/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(421);
	module.exports = __webpack_require__(587);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(35);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(316)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(87)(module)))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(87)(module)))

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/* eslint-disable import/prefer-default-export */
	
	// Redux actions
	var SET_VISITS = exports.SET_VISITS = 'SET_VISITS';
	var SET_LAST_VERIFICATION_DATE = exports.SET_LAST_VERIFICATION_DATE = 'SET_LAST_VERIFICATION_DATE';
	var SET_VERIFICATION_ERROR = exports.SET_VERIFICATION_ERROR = 'SET_VERIFICATION_ERROR';
	
	var SET_ACTIVE_PET = exports.SET_ACTIVE_PET = 'SET_ACTIVE_PET';
	var SET_ACTIVE_PET_TYPE = exports.SET_ACTIVE_PET_TYPE = 'SET_ACTIVE_PET_TYPE';
	var SET_KITTEN = exports.SET_KITTEN = 'SET_KITTEN';
	var SET_SHUFFLE_PETS = exports.SET_SHUFFLE_PETS = 'SET_SHUFFLE_PETS';
	
	var SET_ALL_PETS = exports.SET_ALL_PETS = 'SET_ALL_PETS';
	
	var SET_PURCHASE_LOADING = exports.SET_PURCHASE_LOADING = 'SET_PURCHASE_LOADING';
	var SET_PURCHASE_SUCCESS = exports.SET_PURCHASE_SUCCESS = 'SET_PURCHASE_SUCCESS';
	var SET_PURCHASE_FAIL = exports.SET_PURCHASE_FAIL = 'SET_PURCHASE_FAIL';
	var CLEAR_PURCHASES = exports.CLEAR_PURCHASES = 'CLEAR_PURCHASES';
	
	var SET_ACTIVE_GOODY = exports.SET_ACTIVE_GOODY = 'SET_ACTIVE_GOODY';
	var SET_ACTIVE_GOODIES_WITH_SHUFFLE = exports.SET_ACTIVE_GOODIES_WITH_SHUFFLE = 'SET_ACTIVE_GOODIES_WITH_SHUFFLE';
	var SET_SHUFFLE_GOODIES = exports.SET_SHUFFLE_GOODIES = 'SET_SHUFFLE_GOODIES';
	
	var SET_COLLECTED_GOODIES = exports.SET_COLLECTED_GOODIES = 'SET_COLLECTED_GOODIES';
	var SET_COLLECTED_NEW_GOODIES = exports.SET_COLLECTED_NEW_GOODIES = 'SET_COLLECTED_NEW_GOODIES';
	var SET_NEW_GOODY = exports.SET_NEW_GOODY = 'SET_NEW_GOODY';
	
	var MINS_TO_VERIFY_GOOGLE = exports.MINS_TO_VERIFY_GOOGLE = 0.01;
	var PURCHASES_NOT_SUPPORTED_FOR_COUNTRY = exports.PURCHASES_NOT_SUPPORTED_FOR_COUNTRY = 'PURCHASES_NOT_SUPPORTED_FOR_COUNTRY';
	
	// All options
	var PETS = exports.PETS = [{
		sku: 'cat_tabbycat',
		type: 'cat',
		name: 'Cat',
		displayName: 'Tabby Cat'
	}, {
		sku: 'dog_lildoggo',
		type: 'dog',
		name: 'LilDoggo',
		displayName: 'Lil Doggo'
	}, {
		sku: 'penguin_tuxedobird',
		type: 'penguin',
		name: 'TuxedoBird',
		displayName: 'Tuxedo Birb'
	}, {
		sku: 'wildcat_leopard',
		type: 'wildcat',
		name: 'Leopard',
		displayName: 'Wild Kitty'
	}, {
		sku: 'bear_bear',
		type: 'bear',
		name: 'Bear',
		displayName: 'Bear Cub'
	}, {
		sku: 'turtle_tortoise',
		type: 'turtle',
		name: 'Tortoise',
		displayName: 'Happy Tortoise'
	}, {
		sku: 'dog_classicdoggo',
		type: 'classicdoggo',
		name: 'ClassicDoggo',
		displayName: 'Classic Doggo'
	}, {
		sku: 'chicken_chicken',
		type: 'chicken',
		name: 'Chicken',
		displayName: 'Chicken Birb'
	}, {
		sku: 'seal_seal',
		type: 'seal',
		name: 'Seal',
		displayName: 'Squishy Seal'
	}, {
		sku: 'bunny_bunny',
		type: 'bunny',
		name: 'Bunny',
		displayName: 'Bunny Rabbit'
	}, {
		sku: 'pig_pig',
		type: 'pig',
		name: 'Pig',
		displayName: 'Tubby Piglet'
	}];
	
	var BASE_COLLECTED_PET = exports.BASE_COLLECTED_PET = {
		sku: 'cat_tabbycat',
		displayName: 'Tabby Cat',
		isCollected: true,
		petType: {
			sku: 'cat_tabbycat',
			type: 'cat',
			name: 'Cat'
		}
	};
	
	var ALL_PETS = exports.ALL_PETS = [BASE_COLLECTED_PET].concat(PETS);
	
	var GOODIES = exports.GOODIES = {
		'glasses-Blue': {
			id: 'glasses-Blue',
			type: 'glasses',
			name: 'Blue'
		},
		'glasses-CatEye': {
			id: 'glasses-CatEye',
			type: 'glasses',
			name: 'CatEye'
		},
		'glasses-Kerry': {
			id: 'glasses-Kerry',
			type: 'glasses',
			name: 'Kerry'
		},
		'glasses-OldMan': {
			id: 'glasses-OldMan',
			type: 'glasses',
			name: 'OldMan'
		},
		'glasses-Raybans': {
			id: 'glasses-Raybans',
			type: 'glasses',
			name: 'Raybans'
		},
		'glasses-Scuba': {
			id: 'glasses-Scuba',
			type: 'glasses',
			name: 'Scuba'
		},
		'glasses-Sunglasses': {
			id: 'glasses-Sunglasses',
			type: 'glasses',
			name: 'Sunglasses'
		},
		'glasses-ThreeD': {
			id: 'glasses-ThreeD',
			type: 'glasses',
			name: 'ThreeD'
		},
		'glasses-Aviators': {
			id: 'glasses-Aviators',
			type: 'glasses',
			name: 'Aviators'
		},
		'glasses-Heart': {
			id: 'glasses-Heart',
			type: 'glasses',
			name: 'Heart'
		},
		'glasses-Alien': {
			id: 'glasses-Alien',
			type: 'glasses',
			name: 'Alien'
		},
	
		'hat-Baseball': {
			id: 'hat-Baseball',
			type: 'hat',
			name: 'Baseball'
		},
		'hat-Beanie': {
			id: 'hat-Beanie',
			type: 'hat',
			name: 'Beanie'
		},
		'hat-Bow': {
			id: 'hat-Bow',
			type: 'hat',
			name: 'Bow'
		},
		'hat-Chef': {
			id: 'hat-Chef',
			type: 'hat',
			name: 'Chef'
		},
		'hat-Fedora': {
			id: 'hat-Fedora',
			type: 'hat',
			name: 'Fedora'
		},
		'hat-Fez': {
			id: 'hat-Fez',
			type: 'hat',
			name: 'Fez'
		},
		'hat-King': {
			id: 'hat-King',
			type: 'hat',
			name: 'King'
		},
		'hat-PartyHat': {
			id: 'hat-PartyHat',
			type: 'hat',
			name: 'PartyHat'
		},
		'hat-Princess': {
			id: 'hat-Princess',
			type: 'hat',
			name: 'Princess'
		},
		'hat-Spinner': {
			id: 'hat-Spinner',
			type: 'hat',
			name: 'Spinner'
		},
		'hat-Sweatband': {
			id: 'hat-Sweatband',
			type: 'hat',
			name: 'Sweatband'
		},
		'hat-Unicorn': {
			id: 'hat-Unicorn',
			type: 'hat',
			name: 'Unicorn'
		},
		'hat-Witch': {
			id: 'hat-Witch',
			type: 'hat',
			name: 'Witch'
		},
		'hat-ShrimponBarbie': {
			id: 'hat-ShrimponBarbie',
			type: 'hat',
			name: 'ShrimponBarbie'
		},
		// 'hat-FlowerCrown': {
		// 	id: 'hat-FlowerCrown',
		// 	type: 'hat',
		// 	name: 'FlowerCrown',
		// },
	
	
		'toy-BonsaiTree': {
			id: 'toy-BonsaiTree',
			type: 'toy',
			name: 'BonsaiTree'
		},
		'toy-Campfire': {
			id: 'toy-Campfire',
			type: 'toy',
			name: 'Campfire'
		},
		'toy-Coffee': {
			id: 'toy-Coffee',
			type: 'toy',
			name: 'Coffee'
		},
		'toy-Donut': {
			id: 'toy-Donut',
			type: 'toy',
			name: 'Donut'
		},
		'toy-Fishbones': {
			id: 'toy-Fishbones',
			type: 'toy',
			name: 'Fishbones'
		},
		'toy-Fishbowl': {
			id: 'toy-Fishbowl',
			type: 'toy',
			name: 'Fishbowl'
		},
		'toy-Flamingo': {
			id: 'toy-Flamingo',
			type: 'toy',
			name: 'Flamingo'
		},
		'toy-FoamFinger': {
			id: 'toy-FoamFinger',
			type: 'toy',
			name: 'FoamFinger'
		},
		'toy-IceCream': {
			id: 'toy-IceCream',
			type: 'toy',
			name: 'IceCream'
		},
		'toy-MagicWand': {
			id: 'toy-MagicWand',
			type: 'toy',
			name: 'MagicWand'
		},
		'toy-Martini': {
			id: 'toy-Martini',
			type: 'toy',
			name: 'Martini'
		},
		'toy-MiniGolf': {
			id: 'toy-MiniGolf',
			type: 'toy',
			name: 'MiniGolf'
		},
		'toy-Mouse': {
			id: 'toy-Mouse',
			type: 'toy',
			name: 'Mouse'
		},
		'toy-Pizza': {
			id: 'toy-Pizza',
			type: 'toy',
			name: 'Pizza'
		},
		'toy-Rocketship': {
			id: 'toy-Rocketship',
			type: 'toy',
			name: 'Rocketship'
		},
		'toy-SoccerBall': {
			id: 'toy-SoccerBall',
			type: 'toy',
			name: 'SoccerBall'
		},
		'toy-Synth': {
			id: 'toy-Synth',
			type: 'toy',
			name: 'Synth'
		},
		'toy-Wine': {
			id: 'toy-Wine',
			type: 'toy',
			name: 'Wine'
		},
		'toy-Yarn': {
			id: 'toy-Yarn',
			type: 'toy',
			name: 'Yarn'
		},
		'toy-Flowers': {
			id: 'toy-Flowers',
			type: 'toy',
			name: 'Flowers'
		},
		'toy-Cake': {
			id: 'toy-Cake',
			type: 'toy',
			name: 'Cake'
		},
		'toy-Dough': {
			id: 'toy-Dough',
			type: 'toy',
			name: 'Dough'
		},
		'toy-Burger': {
			id: 'toy-Burger',
			type: 'toy',
			name: 'Burger'
		},
		'toy-Cactus': {
			id: 'toy-Cactus',
			type: 'toy',
			name: 'Cactus'
		},
		'toy-RubberDuck': {
			id: 'toy-RubberDuck',
			type: 'toy',
			name: 'RubberDuck'
		},
		'toy-Egg': {
			id: 'toy-Egg',
			type: 'toy',
			name: 'Egg'
		},
		'toy-Steak': {
			id: 'toy-Steak',
			type: 'toy',
			name: 'Steak'
		},
		'toy-JazzCup': {
			id: 'toy-JazzCup',
			type: 'toy',
			name: 'JazzCup'
		},
		'toy-Gold': {
			id: 'toy-Gold',
			type: 'toy',
			name: 'Gold'
		},
	
		// Lil Doggo
		'toy-Bone': {
			id: 'toy-Bone',
			type: 'toy',
			name: 'Bone'
			// forPetType: 'dog',
		},
	
		// Bear
		'hat-Ranger': {
			id: 'hat-Ranger',
			type: 'hat',
			name: 'Ranger'
			// forPetType: 'bear',
		},
	
		// Penguin
		'toy-Popsicle': {
			id: 'toy-Popsicle',
			type: 'toy',
			name: 'Popsicle'
			// forPetType: 'penguin',
		},
	
		// Wildcat
		'toy-Sushi': {
			id: 'toy-Sushi',
			type: 'toy',
			name: 'Sushi'
			// forPetType: 'wildcat',
		},
	
		// turtle
		'toy-Strawberry': {
			id: 'toy-Strawberry',
			type: 'toy',
			name: 'Strawberry'
			// forPetType: 'turtle',
		},
	
		// Classic Doggo
		'toy-HotDog': {
			id: 'toy-HotDog',
			type: 'toy',
			name: 'HotDog'
			// forPetType: 'classicdoggo',
		},
	
		// Chicken
		'hat-Sombrero': {
			id: 'hat-Sombrero',
			type: 'hat',
			name: 'Sombrero'
			// forPetType: 'chicken',
		},
	
		// Seal
		'hat-BeachBall': {
			id: 'hat-BeachBall',
			type: 'hat',
			name: 'BeachBall'
			// forPetType: 'seal',
		},
	
		// Bunny
		'hat-TopHat': {
			id: 'hat-TopHat',
			type: 'hat',
			name: 'TopHat'
			// forPetType: 'bunny',
		},
	
		// Pig
		'toy-Money': {
			id: 'toy-Money',
			type: 'toy',
			name: 'Money'
			// forPetType: 'pig',
		}
	};
	
	// Redux states
	var INITIAL_STATES = exports.INITIAL_STATES = {
		PET: {
			petType: {
				sku: 'cat_tabbycat',
				type: 'cat',
				name: 'Cat'
			},
			name: {
				first: 'Default',
				last: 'Cat',
				full: 'Default Cat'
			},
			color: 'black',
			body: 0,
			head: 0,
			likesPets: 'likes',
			toy: null,
			glasses: null,
			hat: null,
			kitten: null
		}
	};
	
	// React stuff
	var POSITIONED_GOODY_REFS = exports.POSITIONED_GOODY_REFS = {
		MARKER: 'MARKER',
		GOODY_CONTAINER: 'GOODY_CONTAINER',
		VIEW_BOX: 'VIEW_BOX'
	};
	
	// Initial storage state
	var INITIAL_STATE = exports.INITIAL_STATE = {
		visits: 0,
		lastVerification: {},
	
		activePet: {
			shuffle: false,
			active: {
				petType: BASE_COLLECTED_PET.petType
			}
		},
		allPets: [BASE_COLLECTED_PET],
		activeGoodies: {
			shuffle: true,
			active: {}
		},
		collectedGoodies: {
			newItems: [],
			list: []
		}
	};
	
	var LEGACY_GOODY_MAP = exports.LEGACY_GOODY_MAP = {
		'hat-1': 'hat-PartyHat',
		'hat-2': 'hat-Fedora',
		'hat-3': 'hat-Fez',
		'hat-4': 'hat-Chef',
		'hat-5': 'hat-Baseball',
		'hat-6': 'hat-Beanie',
		'hat-7': 'hat-Princess',
		'hat-8': 'hat-King',
		'hat-9': 'hat-Unicorn',
		'hat-10': 'hat-Sweatband',
		'hat-11': 'hat-Spinner',
		'hat-12': 'hat-Bow',
		'glasses-1': 'glasses-Raybans',
		'glasses-2': 'glasses-CatEye',
		'glasses-3': 'glasses-ThreeD',
		'glasses-4': 'glasses-OldMan',
		'glasses-5': 'glasses-Scuba',
		'glasses-6': 'glasses-Kerry',
		'glasses-7': 'glasses-Blue',
		'glasses-8': 'glasses-Sunglasses',
		'toy-1': 'toy-Yarn',
		'toy-2': 'toy-Mouse',
		'toy-3': 'toy-Pizza',
		'toy-4': 'toy-Fishbones',
		'toy-5': 'toy-SoccerBall',
		'toy-6': 'toy-Donut',
		'toy-7': 'toy-Fishbowl',
		'toy-8': 'toy-Campfire',
		'toy-9': 'toy-MagicWand',
		'toy-10': 'toy-IceCream',
		'toy-11': 'toy-Coffee',
		'toy-12': 'toy-MiniGolf',
		'toy-13': 'toy-Flamingo',
		'toy-14': 'toy-Rocketship',
		'toy-15': 'toy-FoamFinger',
		'toy-16': 'toy-BonsaiTree',
		'toy-17': 'toy-Wine',
		'toy-18': 'toy-Synth',
		'toy-19': 'toy-Martini'
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This is a higher order component to use with a goody that is positioned relative to the animal.
	// ie. Raybans.js
	
	// To use this, simply make sure you have the marker in your SVG.
	// example: <circle ref={POSITIONED_GOODY_REFS.MARKER} cx="YOURCOORDS" cy="YOURCOORDS" r="0"/>.
	// See Test.js for example
	
	
	var PositionedGoodyHOC = function (_React$Component) {
		_inherits(PositionedGoodyHOC, _React$Component);
	
		function PositionedGoodyHOC() {
			_classCallCheck(this, PositionedGoodyHOC);
	
			return _possibleConstructorReturn(this, (PositionedGoodyHOC.__proto__ || Object.getPrototypeOf(PositionedGoodyHOC)).apply(this, arguments));
		}
	
		_createClass(PositionedGoodyHOC, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.props.getMarkerCoords(this.refs[_constants.POSITIONED_GOODY_REFS.MARKER]);
			}
		}]);
	
		return PositionedGoodyHOC;
	}(_react2.default.Component);
	
	PositionedGoodyHOC.PropTypes = {
		getMarkerCoords: _propTypes2.default.func
	};
	
	PositionedGoodyHOC.defaultProps = {
		getMarkerCoords: null
	};
	
	exports.default = PositionedGoodyHOC;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(15);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(329)();
	}


/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 10 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMProperty = __webpack_require__(30);
	var ReactDOMComponentFlags = __webpack_require__(222);
	
	var invariant = __webpack_require__(5);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(4);
	
	var _Hat = __webpack_require__(467);
	
	var _Hat2 = _interopRequireDefault(_Hat);
	
	var _Glasses = __webpack_require__(447);
	
	var _Glasses2 = _interopRequireDefault(_Glasses);
	
	var _setAction2 = __webpack_require__(619);
	
	var _getClassNames2 = __webpack_require__(609);
	
	var _getClassNames3 = _interopRequireDefault(_getClassNames2);
	
	var _getRandom = __webpack_require__(33);
	
	var _getRandom2 = _interopRequireDefault(_getRandom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This is the brains of the animal. This is where we'll later change the potential actions.
	/* eslint-disable react/sort-comp */
	
	var nextId = 0;
	
	var PetHOC = function (_React$Component) {
		_inherits(PetHOC, _React$Component);
	
		function PetHOC(props) {
			_classCallCheck(this, PetHOC);
	
			var _this = _possibleConstructorReturn(this, (PetHOC.__proto__ || Object.getPrototypeOf(PetHOC)).call(this, props));
	
			_this.state = {
				universalActions: {
					isBeingPet: false,
					likesPets: Boolean(props.likesPets === 'likes'),
					hatesPets: Boolean(props.likesPets !== 'likes')
				},
				actions: {
					idle: {},
					pet: {}
				},
				lastActions: {},
				glassesTargetCoords: {},
				hatTargetCoords: {}
			};
	
			_this.id = ++nextId;
	
			_this.timeouts = {
				stopBeingPet: null
			};
	
			_this.direction = 1;
			_this.scale = 0.4;
			_this.offset = 0;
	
			_this.staticClasses = ['pet', _this.props.petType.name, 'fill--' + _this.props.petType.type + '--' + _this.props.color];
			_this.actions = {}; // This gets assigned by the presentation component
	
			_this.startBeingPet = _this.startBeingPet.bind(_this);
			_this.stopBeingPet = _this.stopBeingPet.bind(_this);
			_this.getGlassesTargetCoords = _this.getGlassesTargetCoords.bind(_this);
			_this.getHatTargetCoords = _this.getHatTargetCoords.bind(_this);
			return _this;
		}
	
		_createClass(PetHOC, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.loopAllActions('idle');
			}
		}, {
			key: 'getFrameImagePathname',
			value: function getFrameImagePathname() {
				// if it came from React Router, location will be an object.
				// If not, assume we're in the extension.
				var hasLocation = !!this.props.location;
				return (hasLocation ? '/' : '') + 'extension-assets/frame.png';
			}
		}, {
			key: 'loopAllActions',
			value: function loopAllActions(type) {
				var _this2 = this;
	
				if (type === 'idle') {
					// Idle actions begin after the timeout so that the cat pauses
					this.actions[type].forEach(function (action) {
						_this2.loopAction(action, type);
					});
				} else {
					// Pet actions begin right away
					this.actions[type].forEach(function (action) {
						_this2.setAction(action, type);
					});
				}
			}
		}, {
			key: 'setAction',
			value: function setAction(action, type) {
				this.setState((0, _setAction2.setAction)(action, this.state, type));
				this.loopAction(action, type);
			}
		}, {
			key: 'loopAction',
			value: function loopAction(action, type) {
				var _this3 = this;
	
				var loop = function loop() {
					clearTimeout(_lodash2.default.find(_this3.actions[type], ['name', action.name]).start.timeout);
					if (action.stop) clearTimeout(_lodash2.default.find(_this3.actions[type], ['name', action.name]).stop.timeout);
	
					_lodash2.default.find(_this3.actions[type], ['name', action.name]).start.timeout = setTimeout(function () {
						_this3.setAction(action, type);
					}, action.start.interval());
				};
	
				// If this action has a time limit, run the stop timeout.
				if (action.stop) {
					clearTimeout(_lodash2.default.find(this.actions[type], ['name', action.name]).stop.timeout);
	
					_lodash2.default.find(this.actions[type], ['name', action.name]).stop.timeout = setTimeout(function () {
						// Get the current state.
						var newNextState = _lodash2.default.assign({}, _this3.state);
						// Reset this action
						newNextState.actions[type][action.name] = undefined;
						// Set the new state.
						_this3.setState(newNextState);
	
						loop();
					}, action.stop.interval());
				} else {
					loop();
				}
			}
		}, {
			key: 'stopActions',
			value: function stopActions(type, noSetState) {
				var _this4 = this;
	
				// Clear timeouts to prevent loops.
				this.actions[type].forEach(function (action) {
					clearTimeout(_lodash2.default.find(_this4.actions[type], ['name', action.name]).start.timeout);
					if (action.stop) clearTimeout(_lodash2.default.find(_this4.actions[type], ['name', action.name]).stop.timeout);
				});
	
				if (!noSetState) {
					// Reset pet actions.
					var nextState = _lodash2.default.assign({}, this.state);
					nextState.actions[type] = {};
					this.setState(nextState);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.stopActions('pet', true);
				this.stopActions('idle', true);
				clearTimeout(this.timeouts.stopBeingPet);
			}
		}, {
			key: 'getClassNames',
			value: function getClassNames() {
				return (0, _getClassNames3.default)(this.state, this.staticClasses);
			}
		}, {
			key: 'getName',
			value: function getName() {
				var name = '';
	
				if (_lodash2.default.get(this.props.name, 'full')) {
					name = this.props.name.full;
				} else if (_lodash2.default.isString(this.props.name)) {
					name = this.props.name;
				}
	
				return name;
			}
		}, {
			key: 'startBeingPet',
			value: function startBeingPet() {
				// Return without doing anything if we're
				// not allowed to pet this animal.
				if (this.props.disablePetting) return;
	
				// Prevent a stopBeingPet from completing if petting should resume.
				clearTimeout(this.timeouts.stopBeingPet);
	
				// If isBeingPet is already true, don't run this again.
				if (this.state.universalActions.isBeingPet) {
					return;
				}
	
				// Set petting to true
				var nextState = _lodash2.default.assign({}, this.state);
				nextState.universalActions.isBeingPet = true;
				this.setState(nextState);
	
				// Stop idle actions and Start pet actions.
				this.stopActions('idle');
	
				// Loop pet actions if it likes being pet.
				if (this.state.universalActions.likesPets) {
					this.loopAllActions('pet');
				}
			}
		}, {
			key: 'stopBeingPet',
			value: function stopBeingPet() {
				var _this5 = this;
	
				// Return without doing anything if we're
				// not allowed to pet this animal.
				if (this.props.disablePetting) return;
	
				this.timeouts.stopBeingPet = setTimeout(function () {
					// Set petting to false
					var nextState = _lodash2.default.assign({}, _this5.state);
					nextState.universalActions.isBeingPet = false;
					_this5.setState(nextState);
	
					// Stop pet actions and Start idle actions.
					_this5.stopActions('pet');
					_this5.loopAllActions('idle');
				}, 300);
			}
		}, {
			key: 'getGlassesTargetCoords',
			value: function getGlassesTargetCoords(targetElement) {
				this.setState({ glassesTargetCoords: {
						y: targetElement.cy.baseVal.value,
						x: targetElement.cx.baseVal.value
					} });
			}
		}, {
			key: 'getHatTargetCoords',
			value: function getHatTargetCoords(targetElement) {
				this.setState({ hatTargetCoords: {
						y: targetElement.cy.baseVal.value,
						x: targetElement.cx.baseVal.value
					} });
			}
		}, {
			key: 'shouldRenderGlasses',
			value: function shouldRenderGlasses() {
				if (!this.props.glasses) {
					return null;
				}
				return _react2.default.createElement(_Glasses2.default, {
					petType: this.props.petType,
					goody: this.props.glasses,
					targetCoords: this.state.glassesTargetCoords
				});
			}
		}, {
			key: 'shouldRenderHat',
			value: function shouldRenderHat() {
				if (!this.props.hat) {
					return null;
				}
				return _react2.default.createElement(_Hat2.default, {
					petType: this.props.petType,
					goody: this.props.hat,
					targetCoords: this.state.hatTargetCoords
				});
			}
		}]);
	
		return PetHOC;
	}(_react2.default.Component);
	
	PetHOC.defaultProps = _constants.INITIAL_STATES.PET;
	
	PetHOC.propTypes = {
		petType: _propTypes2.default.shape({
			type: _propTypes2.default.string,
			name: _propTypes2.default.string
		}),
		name: _propTypes2.default.shape({
			first: _propTypes2.default.string,
			last: _propTypes2.default.string,
			full: _propTypes2.default.string.isRequired,
			special: _propTypes2.default.string
		}).isRequired,
		color: _propTypes2.default.string.isRequired,
		likesPets: _propTypes2.default.oneOf(_getRandom2.default.options.likesPetsOptions).isRequired,
		body: _propTypes2.default.node.isRequired,
		head: _propTypes2.default.node.isRequired,
		toy: _propTypes2.default.string,
		glasses: _propTypes2.default.string,
		hat: _propTypes2.default.string,
		kitten: _propTypes2.default.string,
		disablePetting: _propTypes2.default.bool
	};
	
	exports.default = PetHOC;

/***/ },
/* 14 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 15 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.MemoryRouter = undefined;
	
	var _MemoryRouter2 = __webpack_require__(415);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _Prompt2 = __webpack_require__(416);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(417);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(245);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(80);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(418);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(419);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(81);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(420);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Yarn = __webpack_require__(502);
	
	var _Yarn2 = _interopRequireDefault(_Yarn);
	
	var _Mouse = __webpack_require__(491);
	
	var _Mouse2 = _interopRequireDefault(_Mouse);
	
	var _Pizza = __webpack_require__(492);
	
	var _Pizza2 = _interopRequireDefault(_Pizza);
	
	var _Fishbones = __webpack_require__(478);
	
	var _Fishbones2 = _interopRequireDefault(_Fishbones);
	
	var _SoccerBall = __webpack_require__(496);
	
	var _SoccerBall2 = _interopRequireDefault(_SoccerBall);
	
	var _Donut = __webpack_require__(475);
	
	var _Donut2 = _interopRequireDefault(_Donut);
	
	var _Fishbowl = __webpack_require__(479);
	
	var _Fishbowl2 = _interopRequireDefault(_Fishbowl);
	
	var _Campfire = __webpack_require__(473);
	
	var _Campfire2 = _interopRequireDefault(_Campfire);
	
	var _MagicWand = __webpack_require__(487);
	
	var _MagicWand2 = _interopRequireDefault(_MagicWand);
	
	var _IceCream = __webpack_require__(485);
	
	var _IceCream2 = _interopRequireDefault(_IceCream);
	
	var _Coffee = __webpack_require__(474);
	
	var _Coffee2 = _interopRequireDefault(_Coffee);
	
	var _MiniGolf = __webpack_require__(489);
	
	var _MiniGolf2 = _interopRequireDefault(_MiniGolf);
	
	var _Flamingo = __webpack_require__(480);
	
	var _Flamingo2 = _interopRequireDefault(_Flamingo);
	
	var _Rocketship = __webpack_require__(494);
	
	var _Rocketship2 = _interopRequireDefault(_Rocketship);
	
	var _FoamFinger = __webpack_require__(482);
	
	var _FoamFinger2 = _interopRequireDefault(_FoamFinger);
	
	var _BonsaiTree = __webpack_require__(469);
	
	var _BonsaiTree2 = _interopRequireDefault(_BonsaiTree);
	
	var _Wine = __webpack_require__(501);
	
	var _Wine2 = _interopRequireDefault(_Wine);
	
	var _Synth = __webpack_require__(500);
	
	var _Synth2 = _interopRequireDefault(_Synth);
	
	var _Martini = __webpack_require__(488);
	
	var _Martini2 = _interopRequireDefault(_Martini);
	
	var _Bone = __webpack_require__(468);
	
	var _Bone2 = _interopRequireDefault(_Bone);
	
	var _Popsicle = __webpack_require__(493);
	
	var _Popsicle2 = _interopRequireDefault(_Popsicle);
	
	var _Sushi = __webpack_require__(499);
	
	var _Sushi2 = _interopRequireDefault(_Sushi);
	
	var _Strawberry = __webpack_require__(498);
	
	var _Strawberry2 = _interopRequireDefault(_Strawberry);
	
	var _Flowers = __webpack_require__(481);
	
	var _Flowers2 = _interopRequireDefault(_Flowers);
	
	var _Cake = __webpack_require__(472);
	
	var _Cake2 = _interopRequireDefault(_Cake);
	
	var _Dough = __webpack_require__(476);
	
	var _Dough2 = _interopRequireDefault(_Dough);
	
	var _HotDog = __webpack_require__(484);
	
	var _HotDog2 = _interopRequireDefault(_HotDog);
	
	var _Burger = __webpack_require__(470);
	
	var _Burger2 = _interopRequireDefault(_Burger);
	
	var _Cactus = __webpack_require__(471);
	
	var _Cactus2 = _interopRequireDefault(_Cactus);
	
	var _RubberDuck = __webpack_require__(495);
	
	var _RubberDuck2 = _interopRequireDefault(_RubberDuck);
	
	var _Egg = __webpack_require__(477);
	
	var _Egg2 = _interopRequireDefault(_Egg);
	
	var _Steak = __webpack_require__(497);
	
	var _Steak2 = _interopRequireDefault(_Steak);
	
	var _JazzCup = __webpack_require__(486);
	
	var _JazzCup2 = _interopRequireDefault(_JazzCup);
	
	var _Gold = __webpack_require__(483);
	
	var _Gold2 = _interopRequireDefault(_Gold);
	
	var _Money = __webpack_require__(490);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// To add a new toy:
	//
	// 1. Add the svg component in this folder.
	// 2. Import the component here.
	// 3. Add the goody to `toyOptions` here.
	// 4. Add the goody to constants.
	// 5. Add a new story in src/stories/toys.js.
	
	var toyOptions = {
		'toy-Yarn': _Yarn2.default,
		'toy-Mouse': _Mouse2.default,
		'toy-Pizza': _Pizza2.default,
		'toy-Fishbones': _Fishbones2.default,
		'toy-SoccerBall': _SoccerBall2.default,
		'toy-Donut': _Donut2.default,
		'toy-Fishbowl': _Fishbowl2.default,
		'toy-Campfire': _Campfire2.default,
		'toy-MagicWand': _MagicWand2.default,
		'toy-IceCream': _IceCream2.default,
		'toy-Coffee': _Coffee2.default,
		'toy-MiniGolf': _MiniGolf2.default,
		'toy-Flamingo': _Flamingo2.default,
		'toy-Rocketship': _Rocketship2.default,
		'toy-FoamFinger': _FoamFinger2.default,
		'toy-BonsaiTree': _BonsaiTree2.default,
		'toy-Wine': _Wine2.default,
		'toy-Synth': _Synth2.default,
		'toy-Martini': _Martini2.default,
		'toy-Bone': _Bone2.default,
		'toy-Popsicle': _Popsicle2.default,
		'toy-Sushi': _Sushi2.default,
		'toy-Strawberry': _Strawberry2.default,
		'toy-Flowers': _Flowers2.default,
		'toy-Cake': _Cake2.default,
		'toy-Dough': _Dough2.default,
		'toy-HotDog': _HotDog2.default,
		'toy-Burger': _Burger2.default,
		'toy-Cactus': _Cactus2.default,
		'toy-RubberDuck': _RubberDuck2.default,
		'toy-Egg': _Egg2.default,
		'toy-Steak': _Steak2.default,
		'toy-JazzCup': _JazzCup2.default,
		'toy-Gold': _Gold2.default,
		'toy-Money': _Money2.default
	};
	
	function Toy(props) {
	
		var ThisToy = toyOptions[props.toy];
	
		if (!ThisToy) {
			return null;
		}
	
		if (!props.toy || !ThisToy || props.kitten) {
			return null;
		}
	
		return _react2.default.createElement(ThisToy, null);
	}
	
	exports.default = Toy;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(10);
	
	var CallbackQueue = __webpack_require__(220);
	var PooledClass = __webpack_require__(27);
	var ReactFeatureFlags = __webpack_require__(225);
	var ReactReconciler = __webpack_require__(31);
	var Transaction = __webpack_require__(49);
	
	var invariant = __webpack_require__(5);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(39)
	
	var NON_WORD_REGEXP = __webpack_require__(319)
	var CAMEL_CASE_REGEXP = __webpack_require__(317)
	var CAMEL_CASE_UPPER_REGEXP = __webpack_require__(318)
	
	/**
	 * Sentence case a string.
	 *
	 * @param  {string} str
	 * @param  {string} locale
	 * @param  {string} replacement
	 * @return {string}
	 */
	module.exports = function (str, locale, replacement) {
	  if (str == null) {
	    return ''
	  }
	
	  replacement = typeof replacement !== 'string' ? ' ' : replacement
	
	  function replace (match, index, value) {
	    if (index === 0 || index === (value.length - match.length)) {
	      return ''
	    }
	
	    return replacement
	  }
	
	  str = String(str)
	    // Support camel case ("camelCase" -> "camel Case").
	    .replace(CAMEL_CASE_REGEXP, '$1 $2')
	    // Support odd camel case ("CAMELCase" -> "CAMEL Case").
	    .replace(CAMEL_CASE_UPPER_REGEXP, '$1 $2')
	    // Remove all non-word characters and replace with a single space.
	    .replace(NON_WORD_REGEXP, replace)
	
	  // Lower case the entire string.
	  return lowerCase(str, locale)
	}


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var PooledClass = __webpack_require__(27);
	
	var emptyFunction = __webpack_require__(15);
	var warning = __webpack_require__(7);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(394);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(240);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(395);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _InstallButton = __webpack_require__(85);
	
	var _InstallButton2 = _interopRequireDefault(_InstallButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Navigation() {
		return _react2.default.createElement(
			'div',
			{ className: 'navigation' },
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ className: 'site-link', to: '/' },
				'Home'
			),
			_react2.default.createElement(_InstallButton2.default, { classNames: 'site-link', ctaText: 'Learn More' }),
			_react2.default.createElement(
				_reactRouterDom.Link,
				{ className: 'site-link', to: '/shop' },
				'Shop'
			)
		);
	}
	
	exports.default = Navigation;

/***/ },
/* 24 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BasePage = function (_React$Component) {
		_inherits(BasePage, _React$Component);
	
		function BasePage() {
			_classCallCheck(this, BasePage);
	
			return _possibleConstructorReturn(this, (BasePage.__proto__ || Object.getPrototypeOf(BasePage)).apply(this, arguments));
		}
	
		_createClass(BasePage, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
			}
		}]);
	
		return BasePage;
	}(_react2.default.Component);
	
	exports.default = BasePage;

/***/ },
/* 26 */
/***/ function(module, exports) {

	/**
	 * Special language-specific overrides.
	 *
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 *
	 * @type {Object}
	 */
	var LANGUAGES = {
	  tr: {
	    regexp: /[\u0069]/g,
	    map: {
	      '\u0069': '\u0130'
	    }
	  },
	  az: {
	    regexp: /[\u0069]/g,
	    map: {
	      '\u0069': '\u0130'
	    }
	  },
	  lt: {
	    regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
	    map: {
	      '\u0069\u0307': '\u0049',
	      '\u006A\u0307': '\u004A',
	      '\u012F\u0307': '\u012E',
	      '\u0069\u0307\u0300': '\u00CC',
	      '\u0069\u0307\u0301': '\u00CD',
	      '\u0069\u0307\u0303': '\u0128'
	    }
	  }
	}
	
	/**
	 * Upper case a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  var lang = LANGUAGES[locale]
	
	  str = str == null ? '' : String(str)
	
	  if (lang) {
	    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
	  }
	
	  return str.toUpperCase()
	}


/***/ },
/* 27 */
[665, 9],
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(64);
	var setInnerHTML = __webpack_require__(51);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(72);
	var setTextContent = __webpack_require__(238);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(367);
	var ReactInstrumentation = __webpack_require__(18);
	
	var warning = __webpack_require__(7);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(403);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(404);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(244);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(405);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(406);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(407);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(408);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(409);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(410);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(411);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(412);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(413);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(414);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NAMES
	
	var names = {
		first: {
			cat: ['Meowy', 'Purrty'],
			wildcat: ['Meowy', 'Purrty', 'Untamed', 'Primitive', 'Savage', 'Fierce', 'Powerful', 'Wild'],
			penguin: ['Icy', 'Frozen', 'Winter', 'Snowy', 'Cold', 'Chilly', 'Arctic', 'Hypothermic', 'Frigid', 'Cool', 'Shivery', 'Frosty', 'Wobbly', 'Bouncy', 'Peppy'],
			dog: ['Barky', 'Loyal', 'Yappy', 'Yippy', 'Sheddy', 'Drooly', 'Borking', 'Doggest', 'Pupperest', 'Borky', 'Slobbery', 'Fetching'],
			classicdoggo: ['Barky', 'Loyal', 'Yappy', 'Yippy', 'Sheddy', 'Drooly', 'Borking', 'Doggest', 'Pupperest', 'Borky', 'Slobbery', 'Classy', 'Labby', 'Golden', 'Fetching', 'Well-Behaved', 'Trained'],
			turtle: ['Shelly', 'Round', 'Dawdling', 'Sluggish', 'Patient', 'Scaredy', 'Galapagosian', 'Gigantic', 'Enormous'],
			bear: ['Rugged', 'Grisly', 'Tough', 'Stout', 'Vicious', 'Honey Loving', 'Growley', 'Hibernating', 'Winnie'],
			chicken: ['Flappy', 'Clucking', 'Peckish', 'Birby'],
			seal: ['Slippery', 'Chubby', 'Round', 'Slappy', 'Blubbery', 'Blobular', 'Plump', 'Portly', 'Pudgy'],
			bunny: ['Hoppy', 'Jumpy'],
			shared: ['Floppy', 'Rolly Polly', 'Clever', 'Mischievous', 'Ridiculous', 'Gluttonous', 'Sardonic', 'Surly', 'Boopable ', 'Floofy ', 'Smelly', 'Dizzy', 'Gooby', 'Dooby', 'Schmoopy', 'Floopy', 'Sniffly', 'Spinning', 'Cranky', 'Excited', 'Night', 'Tiny', 'Li\'l', 'Magic', 'Lord', 'Master', 'Teeny', 'Froofy', 'Poofy', 'Cuddly', 'Crabby', 'Sleepy', 'Grand', 'Her Majesty, The Empress', 'His Majesty, The Emperor', 'Sparkly', 'Young', 'Old', 'Petit', 'Silent', 'Furry', 'Fluffy', 'Shining', 'Regal', 'Cool', 'Mysterious', 'Notorious', 'Sneaky', 'Professor', 'Doctor', 'Cheeky', 'Grand', 'Crazy', 'Stinky', 'Corpulent', 'Admiral', 'General', 'Tricky', 'Scheming', 'Sir', 'Insane', 'Lumpy', 'Captain', 'Unruly', 'Splendiferous', 'Criminal', 'Swift', 'Crumply', 'Blessed', 'Curmudgeonly', 'Slow', 'Leaping', 'Wobbly', 'Smoochy', 'Jiggly', 'Admirable', 'Impeccable', 'Handsome', 'Radical', 'Sweet', 'Peachy', 'Pretty', 'Trusty', 'Delightful', 'Charming', 'Dreamy', 'Exceptional', 'Infinite', 'Cozy', 'Angelic', 'Chocolate', 'Pinchy', 'Prickly', 'Mr.', 'Mrs.', 'Miss', 'Ms.', 'Dr.', 'Rainy', 'Bumbly', 'Lovey', 'Formidable', 'Lovely', 'Gracious', 'Sassy', 'Swaggy', 'Tipsy', 'Mighty', 'Strong', 'Wise', 'Evil', 'Good', 'Decent', 'Fine', 'Thirsty', 'Hungry', 'Fiery', 'Dancing', 'Loopy', 'Caramel', 'Vanilla', 'Tubby', 'Ferocious', 'Glamorous', 'Scandalous', 'Coy', 'Cunning', 'Littlest', 'Aunt', 'Uncle', 'Old Man', 'Space', 'Flubby', 'Silly', 'Meepy', 'Guilty', 'Innocent', 'Sneaky', 'Scoopy', 'Glittery', 'Scratchy', 'Poofy', 'Doinky', 'Springy', 'Prancy', 'Freepy', 'Creepy', 'Dweeby', 'Baby', 'Teenage', 'Terrible', 'Munchy', 'Snuggly', 'Squeezable', 'Huggable', 'Kissy', 'Dinky', 'Spicy', 'Big']
		},
		last: {
			cat: ['Gato', 'Pouncer', 'Tiger', 'Tigress', 'Purr', 'Kitten', 'Scratcher', 'Lion', 'Meow'],
			wildcat: ['Gato', 'Pouncer', 'Tiger', 'Tigress', 'Purr', 'Kitten', 'Scratcher', 'Lion', 'Meow', 'Wildling'],
			penguin: ['Icicle', 'Freezer', 'Igloo', 'Blizzard', 'Frostbiter', 'Coldbrew', 'Frost', 'Brainfreeze', 'Waddler'],
			dog: ['Poop Bag', 'Pooper Scooper', 'Barker', 'Woofer', 'Doggo', 'Pupper', 'Doggo', 'Bolt', 'Doge', 'Digger', 'Grryffindog', 'Rex', 'Spot ', 'Flufferpupper', 'Borker', 'Pupperino', 'Doggerino', 'Doggerton', 'Beethoven', 'Smeller', 'Sniffer', 'Barkitecht', 'Fuzz Aldrin', 'Pupcake', 'Slobberyn', 'Ravenpaw', 'Huffleruff', 'Barkledore', 'Rufflepuff', 'Barksalot', 'Woofington'],
			classicdoggo: ['Poop Bag', 'Pooper Scooper', 'Barker', 'Woofer', 'Doggo', 'Pupper', 'Doggo', 'Bolt', 'Doge', 'Digger', 'Grryffindog', 'Rex', 'Spot ', 'Flufferpupper', 'Borker', 'Pupperino', 'Doggerino', 'Doggerton', 'Beethoven', 'Smeller', 'Sniffer', 'Barkitecht', 'Fuzz Aldrin', 'Pupcake', 'Slobberyn', 'Ravenpaw', 'Huffleruff', 'Barkledore', 'Rufflepuff', 'Barksalot', 'Woofington', 'Lab', 'Retriever', 'Lassie', 'Fetcher', 'Good Boy', 'Good Girl'],
			turtle: ['Shell', 'Blub', 'Koopa', 'Squirt', 'Squirtle', 'Sheldon', 'Shrimp'],
			bear: ['Yeller', 'Beast', 'Growler', 'Honey Stealer', 'Bee Eater', 'Ranger', 'Camper', 'Cub', 'Bamboo', 'Hibernator', 'Tum Tum', 'Pooh'],
			chicken: ['Birb', 'Clucker', 'Chicklet', 'Chicken', 'Flapper', 'Karen'],
			seal: ['Bowling Ball', 'Flipper', 'Chub', 'Ball', 'Slapper', 'Blubber', 'Plump', 'Pudge'],
			bunny: ['Jumper', 'Hopper', 'Cottontail', 'Thumper', 'Cinnabunny', 'Binky'],
			shared: ['Bop-it', 'Cheerio', 'Chubchub', 'Gooberton', 'Fluffernutter', 'Monster', 'Bug', 'Buddy', 'Pooper', 'McGooberson', 'Nuttypants', 'Goob', 'Nuzzler', 'Stinky', 'Peanut', 'Limabean', 'Monkey', 'Doodoo', 'Beep', 'Gremlin', 'Babe', 'Leader', 'Bingo', 'Skunk', 'Zipper', 'Zingo', 'Dingbat', 'Crumbcatcher', 'Foof', 'Cranberry', 'Hijinx', 'Ploop', 'Wrinkle', 'Whisper', 'Trinket', 'Donker', 'Zap', 'Moose', 'Crab', 'Tripper', 'Cutie', 'Dinker', 'Fluff', 'Cuddlebug', 'Sneaker', 'Snugglebug', 'Snowglobe', 'Honey', 'Show-off', 'Hufflepuff', 'Vape', 'Casper', 'Killer', 'Ratchet', 'Eater', 'Gobbler', 'Beggar', 'Beggar', 'Bonker', 'Biter', 'Burglar', 'Freep', 'Nibbler', 'Lump', 'Bop', 'Rainbow', 'Whizbang', 'Boo', 'Freckles', 'Giggles', 'Meep', 'Mipmop', 'Twinkie', 'Rager', 'Button', 'Leaper', 'Bug', 'Tush', 'Burp', 'Smooch', 'Cupcake', 'Chomper', 'Piglet', 'Treasurechest', 'Doombringer', 'Dinosaur', 'Glitterbug', 'Rhombus', 'Twizzler', 'Bubbles', 'Elf', 'Peaches', 'Sherbert', 'Pocky', 'Cookie', 'Coconut', 'Raccoon', 'Squirrel', 'Sparkles', 'Wobbles', 'Weeble', 'Basket', 'Blip', 'Blob', 'Winky', 'Knight', 'Nightmare', 'Prince', 'Princess', 'Peepers', 'Pinky', 'Pidgeon', 'Mug', 'Teaspoon', 'Bubby', 'Stinker', 'Marshmallow', 'Bob', 'Tubbs', 'River', 'Snowball', 'Booboo', 'Bella', 'Milkshake', 'Wigwam', 'Meeper', 'Slipper', 'Scooper', 'Psychic', 'Goober', 'Pluto', 'Jupiter', 'Weirdo', 'Poofball', 'Doink', 'Skipper', 'Freeper', 'Creeper', 'Stingray', 'Puff', 'Doobie', 'Dweeb', 'Muncher', 'Hugger', 'Smoocher', 'Lovebug', 'Dumbledort', 'Voldemorp', 'Macaroni', 'Spaghetti', 'Chalupa', 'Burrito', 'Taquito', 'Wingding', 'Thunderball', 'Dingbop', 'Stomper', 'Potato', 'Ringpop', 'Smasher']
		}
	};
	
	function name(typeOfPet) {
		var firstNames = names.first[typeOfPet] ? _lodash2.default.concat(names.first.shared, names.first[typeOfPet]) : names.first.shared;
		var lastNames = names.last[typeOfPet] ? _lodash2.default.concat(names.last.shared, names.last[typeOfPet]) : names.last.shared;
	
		var thisName = {
			first: firstNames[_lodash2.default.random(firstNames.length - 1)],
			last: lastNames[_lodash2.default.random(lastNames.length - 1)]
		};
	
		thisName.full = thisName.first + ' ' + thisName.last;
		thisName.special = isSpecial(thisName);
	
		return thisName;
	}
	
	// SPECIAL NAMES
	
	var specialNameOptions = ['Casper', 'Night', 'Pinky', 'Evil', 'Rainbow', 'Space', 'Tiny', 'Lil 404'];
	
	function isSpecial(name) {
		var special = void 0;
	
		specialNameOptions.forEach(function (specialName) {
			if (specialName === name.first || specialName === name.last || specialName === name.full) {
				special = specialName.replace(/\s+/g, '-');
			}
		});
	
		return special;
	}
	
	// CAT COLORS
	
	var colorOptions = {
		cat: ['orange', 'white', 'gray', 'black', 'brown'],
		wildcat: ['orange', 'white', 'gray', 'black', 'gold'],
		dog: ['orange', 'white', 'gray', 'black', 'brown'],
		classicdoggo: ['orange', 'white', 'gray', 'black', 'brown', 'gold', 'orange-spot', 'gray-spot', 'black-spot', 'brown-spot', 'dark-brown-spot', 'gold-spot'],
		penguin: ['orange', 'black', 'gold', 'purple', 'blue', 'red'],
		bear: ['orange', 'white', 'gray', 'black', 'brown', 'panda'],
		turtle: ['green', 'blue', 'purple', 'yellow', 'red'],
		chicken: ['white', 'orange', 'black', 'brown'],
		seal: ['white', 'black', 'gray', 'brown'],
		bunny: ['white', 'gray', 'cream', 'gold', 'brown', 'black'],
		pig: ['white', 'pink', 'pink', 'pink', 'black', 'brown', 'orange'],
		shared: []
	};
	
	function color(typeOfPet) {
		var colorsForThisPet = colorOptions[typeOfPet] ? _lodash2.default.concat(colorOptions.shared, colorOptions[typeOfPet]) : colorOptions.shared;
	
		var thisColor = colorsForThisPet[_lodash2.default.random(colorsForThisPet.length - 1)];
	
		return thisColor;
	}
	
	// LIKES PETS
	
	var likesPetsOptions = ['likes', 'hates'];
	
	function likesPets() {
		var likesPetsValue = Math.random() > 0.45 ? likesPetsOptions[0] : likesPetsOptions[1];
	
		return likesPetsValue;
	}
	
	// BODIES
	
	var numOfBodies = 6;
	
	function body() {
		var body = _lodash2.default.random(0, numOfBodies - 1);
	
		return body;
	}
	
	// HEADS
	
	var numOfHeads = 2;
	
	function head() {
		var head = _lodash2.default.random(0, numOfHeads - 1);
	
		return head;
	}
	
	// GLASSES
	
	var glassesMap = {
		'glasses-1': 'Raybans',
		'glasses-2': 'CatEye',
		'glasses-3': 'ThreeD',
		'glasses-4': 'OldMan',
		'glasses-5': 'Scuba',
		'glasses-6': 'Kerry',
		'glasses-7': 'Blue',
		'glasses-8': 'Sunglasses'
	};
	
	var glassesOptions = ['Raybans', 'CatEye', 'ThreeD', 'OldMan', 'Scuba', 'Kerry', 'Blue', 'Sunglasses'];
	
	function glasses() {
		var glasses = glassesOptions[_lodash2.default.random(glassesOptions.length * 2)];
	
		return glasses;
	}
	
	// HATS
	
	var hatMap = {
		'hat-1': 'PartyHat',
		'hat-2': 'Fedora',
		'hat-3': 'Fez',
		'hat-4': 'Chef',
		'hat-5': 'Baseball',
		'hat-6': 'Beanie',
		'hat-7': 'Princess',
		'hat-8': 'King',
		'hat-9': 'Unicorn',
		'hat-10': 'Sweatband',
		'hat-11': 'Spinner',
		'hat-12': 'Bow'
	};
	
	var hatOptions = ['PartyHat', 'Fedora', 'Fez', 'Chef', 'Baseball', 'Beanie', 'Princess', 'King', 'Unicorn', 'Sweatband', 'Spinner', 'Bow'];
	
	function hat() {
		var hat = hatOptions[_lodash2.default.random(hatOptions.length * 2)];
	
		return hat;
	}
	
	// TOYS
	
	var toyMap = {
		'toy-1': 'Yarn',
		'toy-2': 'Mouse',
		'toy-3': 'Pizza',
		'toy-4': 'Fishbones',
		'toy-5': 'SoccerBall',
		'toy-6': 'Donut',
		'toy-7': 'Fishbowl',
		'toy-8': 'Campfire',
		'toy-9': 'MagicWand',
		'toy-10': 'IceCream',
		'toy-11': 'Coffee',
		'toy-12': 'MiniGolf',
		'toy-13': 'Flamingo',
		'toy-14': 'Rocketship',
		'toy-15': 'FoamFinger',
		'toy-16': 'BonsaiTree',
		'toy-17': 'Wine',
		'toy-18': 'Synth',
		'toy-19': 'Martini'
	};
	
	var toyOptions = ['Yarn', 'Mouse', 'Pizza', 'Fishbones', 'SoccerBall', 'Donut', 'Fishbowl', 'Campfire', 'MagicWand', 'IceCream', 'Coffee', 'MiniGolf', 'Flamingo', 'Rocketship', 'FoamFinger', 'BonsaiTree', 'Wine', 'Synth', 'Martini'];
	
	function toy() {
		var toy = toyOptions[_lodash2.default.random(toyOptions.length * 2)];
	
		return toy;
	}
	
	// BG COLORS
	
	var bgColorOptions = ['light-blue', 'red', 'blue', 'light-purple', 'purple', 'green', 'teal', 'yellow', 'mauve'];
	
	function bgColor() {
		var bgColor = bgColorOptions[_lodash2.default.random(bgColorOptions.length - 1)];
	
		return bgColor;
	}
	
	// GET A PLAIN CAT
	
	function cat() {
		var thisCat = {
			petType: {
				sku: 'cat_tabbycat',
				type: 'cat',
				name: 'Cat'
			},
			name: name('cat'),
			color: color('cat'),
			likesPets: likesPets(),
			body: body(),
			head: head(),
			bgColor: bgColor()
		};
	
		return thisCat;
	}
	
	// Get a random pet of type
	
	function petOfTypeForPetPicker(type) {
		var randomPetOfType = {
			name: name(type),
			color: color(type),
			likesPets: likesPets(),
			body: body(),
			head: head()
		};
	
		// TODO: Make sure we don't need to include `kitten: null` in here.
		return randomPetOfType;
	}
	
	function petOfTypeForInitialize(type) {
		var randomPetOfType = {
			name: name(type),
			color: color(type),
			bgColor: bgColor(),
			likesPets: likesPets(),
			body: body(),
			head: head()
		};
	
		// TODO: Make sure we don't need to include `kitten: null` in here.
		return randomPetOfType;
	}
	
	module.exports = {
		name: name,
		color: color,
		likesPets: likesPets,
		body: body,
		head: head,
		bgColor: bgColor,
		glasses: glasses,
		hat: hat,
		toy: toy,
		cat: cat,
		petOfTypeForPetPicker: petOfTypeForPetPicker,
		petOfTypeForInitialize: petOfTypeForInitialize,
		maps: {
			toyMap: toyMap,
			hatMap: hatMap,
			glassesMap: glassesMap,
			goodyMap: _lodash2.default.merge(toyMap, hatMap, glassesMap)
		},
		options: {
			colorOptions: colorOptions,
			bgColorOptions: bgColorOptions,
			likesPetsOptions: likesPetsOptions,
			toyOptions: toyOptions,
			hatOptions: hatOptions,
			glassesOptions: glassesOptions,
			specialNameOptions: specialNameOptions,
			numOfHeads: numOfHeads,
			numOfBodies: numOfBodies
		}
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.setVisits = setVisits;
	exports.setLastVerification = setLastVerification;
	exports.setAllPets = setAllPets;
	exports.setActivePet = setActivePet;
	exports.setCollectedGoodies = setCollectedGoodies;
	exports.setActiveGoodies = setActiveGoodies;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(4);
	
	var _getStorage = __webpack_require__(616);
	
	var _getStorage2 = _interopRequireDefault(_getStorage);
	
	var _getRandom = __webpack_require__(33);
	
	var _getRandom2 = _interopRequireDefault(_getRandom);
	
	var _getNewGoody = __webpack_require__(612);
	
	var _getNewGoody2 = _interopRequireDefault(_getNewGoody);
	
	var _shuffleActiveGoodies = __webpack_require__(259);
	
	var _shuffleActiveGoodies2 = _interopRequireDefault(_shuffleActiveGoodies);
	
	var _shuffleActivePetType = __webpack_require__(260);
	
	var _shuffleActivePetType2 = _interopRequireDefault(_shuffleActivePetType);
	
	var _saveToStorage = __webpack_require__(257);
	
	var _saveToStorage2 = _interopRequireDefault(_saveToStorage);
	
	var _getCollectedPetTypes = __webpack_require__(254);
	
	var _getCollectedPetTypes2 = _interopRequireDefault(_getCollectedPetTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// --- STEP 1: GET STORAGE --- //
	
	var newState = (0, _getStorage2.default)();
	
	// --- STEP 2: SET VISITS & TIMESTAMP --- //
	
	function setVisits() {
		newState.visits++;
	
		_saveToStorage2.default.visits(newState);
	
		return newState.visits;
	}
	
	function setLastVerification() {
		return newState.lastVerification;
	}
	
	// --- STEP 3: SET PETS --- //
	
	function setAllPets() {
		newState.allPets = _lodash2.default.uniqBy(newState.allPets, 'sku'); // Remove duplicates.
	
		_saveToStorage2.default.allPets(newState);
	
		return newState.allPets;
	}
	
	function setActivePet() {
		var collectedPetTypes = (0, _getCollectedPetTypes2.default)(newState.allPets);
		// Object to check against constants. We only need the sku.
		var findCriteria = { sku: _lodash2.default.get(newState.activePet.active.petType, 'sku') };
		var activePetShouldntBeActive = !_lodash2.default.find(_constants.PETS, findCriteria) || // It doesnt exist
		!_lodash2.default.find(collectedPetTypes, findCriteria); // It isn't collected
	
		var transientPetAttributes = {};
	
		// If shuffle is on or the current pet doesn't exist,
		// shuffle the active pet.
		if (newState.activePet.shuffle || activePetShouldntBeActive) {
			newState.activePet.active.petType = (0, _shuffleActivePetType2.default)(collectedPetTypes);
		}
	
		// If we shuffled the pet because the current one didn't exist,
		// set shuffle to true to explain why the pet changed.
		if (activePetShouldntBeActive && collectedPetTypes.length > 1) {
			newState.activePet.shuffle = true;
		}
	
		_saveToStorage2.default.activePet(newState);
		transientPetAttributes = _getRandom2.default.petOfTypeForInitialize(newState.activePet.active.petType.type);
	
		return Object.assign({}, newState.activePet, {
			active: Object.assign({}, newState.activePet.active, transientPetAttributes, {
				kitten: null // Remove kitten to reset kitten chances on load.
			})
		});
	}
	
	// --- STEP 4: SET GOODIES --- //
	
	function setCollectedGoodies() {
	
		var shouldGetNewGoody = newState.visits === 1 || newState.visits % 200 === 0 || Math.random() < 0.005;
	
		if (shouldGetNewGoody) {
			// get a new goody.
			var newGoody = (0, _getNewGoody2.default)((0, _getCollectedPetTypes2.default)(newState.allPets), newState.collectedGoodies.list);
	
			if (newGoody) {
				// add it to collected goodies, list and new.
				newState.collectedGoodies.list.push(newGoody.id);
				newState.collectedGoodies.newItems.push(newGoody.id);
	
				// set this new goody to active.
				newState.activeGoodies.active[newGoody.type] = newGoody.id;
			}
		}
	
		_saveToStorage2.default.collectedGoodies(newState);
	
		return newState.collectedGoodies;
	}
	
	function setActiveGoodies() {
	
		if (newState.activeGoodies.shuffle) {
			newState.activeGoodies.active = (0, _shuffleActiveGoodies2.default)(newState.collectedGoodies.list);
		}
	
		_saveToStorage2.default.activeGoodies(newState);
	
		return newState.activeGoodies;
	}

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactBaseClasses = __webpack_require__(265);
	var ReactChildren = __webpack_require__(638);
	var ReactDOMFactories = __webpack_require__(639);
	var ReactElement = __webpack_require__(36);
	var ReactPropTypes = __webpack_require__(640);
	var ReactVersion = __webpack_require__(641);
	
	var createReactClass = __webpack_require__(642);
	var onlyChild = __webpack_require__(646);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactCurrentOwner = __webpack_require__(24);
	
	var warning = __webpack_require__(7);
	var canDefineProperty = __webpack_require__(269);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(267);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 37 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 39 */
/***/ function(module, exports) {

	/**
	 * Special language-specific overrides.
	 *
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 *
	 * @type {Object}
	 */
	var LANGUAGES = {
	  tr: {
	    regexp: /\u0130|\u0049|\u0049\u0307/g,
	    map: {
	      '\u0130': '\u0069',
	      '\u0049': '\u0131',
	      '\u0049\u0307': '\u0069'
	    }
	  },
	  az: {
	    regexp: /[\u0130]/g,
	    map: {
	      '\u0130': '\u0069',
	      '\u0049': '\u0131',
	      '\u0049\u0307': '\u0069'
	    }
	  },
	  lt: {
	    regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
	    map: {
	      '\u0049': '\u0069\u0307',
	      '\u004A': '\u006A\u0307',
	      '\u012E': '\u012F\u0307',
	      '\u00CC': '\u0069\u0307\u0300',
	      '\u00CD': '\u0069\u0307\u0301',
	      '\u0128': '\u0069\u0307\u0303'
	    }
	  }
	}
	
	/**
	 * Lowercase a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  var lang = LANGUAGES[locale]
	
	  str = str == null ? '' : String(str)
	
	  if (lang) {
	    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
	  }
	
	  return str.toLowerCase()
	}


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventPluginRegistry = __webpack_require__(65);
	var EventPluginUtils = __webpack_require__(66);
	var ReactErrorUtils = __webpack_require__(70);
	
	var accumulateInto = __webpack_require__(231);
	var forEachAccumulated = __webpack_require__(232);
	var invariant = __webpack_require__(5);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(40);
	var EventPluginUtils = __webpack_require__(66);
	
	var accumulateInto = __webpack_require__(231);
	var forEachAccumulated = __webpack_require__(232);
	var warning = __webpack_require__(7);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(21);
	
	var getEventTarget = __webpack_require__(75);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.X = exports.PriceBadgeSVG = exports.Badge = exports.ShopBox = exports.Camera = exports.House = exports.Bag = exports.ShuffleIcon = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShuffleIcon() {
		return _react2.default.createElement(
			"svg",
			{ version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100" },
			_react2.default.createElement("path", { d: "M95,72.8l-10.5-6.2l-10.1-6.2C73.8,60,73,60.5,73,61.3v5.4c-7-1.1-12.3-5.5-16.9-11.5 c-0.5,0.8-1.1,1.5-1.6,2.3c-1.7,2.6-3.4,5.3-5.4,8C55,72.4,62,77.8,73,78.8v7.2c0,0.8,0.8,1.2,1.4,0.9l10.3-6.2L95,74.5 C95.7,74.1,95.7,73.2,95,72.8z" }),
			_react2.default.createElement("path", { d: "M12.5,19H9.1C7.9,19,7,19.9,7,21.1v7.8C7,30.1,7.9,31,9.1,31h3.4c9.8,0,15.9,5.7,21.7,13.7 c0-0.1,0.1-0.1,0.1-0.2c2.2-3.3,4.5-6.8,7-10.2C34.6,25.8,25.9,19,12.5,19z" }),
			_react2.default.createElement("path", { d: "M95,25.4L84.2,19l-10.7-6.4c-0.7-0.4-1.6,0.1-1.6,0.9v7.8C55.7,23.2,47,36,39.4,47.7 C31.8,59.4,25.2,69,12.5,69H9.1C7.9,69,7,69.9,7,71.1v7.8C7,80.1,7.9,81,9.1,81h3.4c19.2,0,28.6-14,36.9-26.7 C56.1,44,62,35.3,72,33.4v5.8c0,0.8,0.9,1.3,1.6,0.9l10.5-6.4L95,27.2C95.7,26.8,95.7,25.8,95,25.4z" })
		);
	}
	
	function Bag() {
		return _react2.default.createElement(
			"svg",
			{ version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 53 57" },
			_react2.default.createElement("path", { d: "M41.0200882,19.2628937c-0.017395-3.9971924-0.9837646-9.9161987-4.2613525-14.1099854 c-2.5493164-3.262207-6.0966797-4.9863281-10.2587891-4.9863281c-4.1738281,0-7.7285156,1.7387695-10.2802734,5.0288086 c-3.2485962,4.1885381-4.208374,10.1835327-4.2262573,14.1690674L0.4915235,19.4046783l3.3200073,37.4310303h45.3779907 l3.3189697-37.6130371L41.0200882,19.2628937z M22.6688919,9.9390411c1.012207-1.2260742,2.1938477-1.7724609,3.8310547-1.7724609 c1.6484375,0,2.8354492,0.5493164,3.8496094,1.7802734c2.0596313,2.5014648,2.6561279,6.8780518,2.6860962,9.3439331 l-13.0667725,0.0457153C19.9942703,16.8578644,20.5958939,12.449234,22.6688919,9.9390411z" })
		);
	}
	
	function House() {
		var style = {
			fillRule: 'evenodd',
			clipRule: 'evenodd'
		};
		return _react2.default.createElement(
			"svg",
			{ version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 61 57" },
			_react2.default.createElement("path", { style: style, d: "M60.9744568,25.0246086L30.5041218,0.1654159L0.0318311,25.023571 l6.3676362,7.1027603l1.5725493,24.7082138h10.932312l-0.5641479-12.3484497 c0-6.7147217,5.4432373-12.1588745,12.1588745-12.1588745s12.1588726,5.4441528,12.1588726,12.1588745l-0.5197144,12.3484497 h10.895813l1.5645981-24.7002029L60.9744568,25.0246086z" })
		);
	}
	
	function Camera() {
		var style = {
			fillRule: 'evenodd',
			clipRule: 'evenodd'
		};
		return _react2.default.createElement(
			"svg",
			{ version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 63 49" },
			_react2.default.createElement("path", { style: style, d: "M23.7393856,18.3074722c4.8624401,0,8.8047771,3.9423485,8.8047771,8.804781 c0,4.8624401-3.942337,8.8047886-8.8047771,8.8047886s-8.804781-3.9423485-8.804781-8.8047886 C14.9346046,22.2498207,18.8769417,18.3074722,23.7393856,18.3074722" }),
			_react2.default.createElement("path", { style: style, d: "M53.1467819,6.5267105H39.1017838l0.0277214-0.0017486l-3.2673225-4.0041676 c-1.2044563-1.4760207-3.23209-2.3626046-5.4033775-2.3626046H16.6289635c-2.1712847,0-4.1989193,0.8865839-5.4033108,2.3626046 L7.9582648,6.5249619l0.0236397,0.0017486H5.2673607c-2.6465397,0-4.8333044,2.1867647-4.8333044,4.8333044v32.6484261 c0,2.6466026,2.1867647,4.8333702,4.8338871,4.8333702h47.8793526c2.6466064,0,4.8333702-2.1867676,4.8333702-4.8333702 V11.3600149C57.9806671,8.7134752,55.7939034,6.5267105,53.1467819,6.5267105z M23.7393818,42.5024338 c-8.4997168,0-15.3901234-6.8904076-15.3901234-15.3908348c0-8.4990044,6.8904066-15.3894119,15.3901234-15.3894119 s15.3901234,6.8904076,15.3901234,15.3894119C39.1295052,35.6120262,32.2390976,42.5024338,23.7393818,42.5024338z M47.2482033,21.4514885c-2.4386406,0-4.4155655-1.9769859-4.4155655-4.4156265 c0-2.4387045,1.9769249-4.4156275,4.4155655-4.4156275c2.4387054,0,4.4156265,1.976923,4.4156265,4.4156275 C51.6638298,19.4745026,49.6869087,21.4514885,47.2482033,21.4514885z" }),
			_react2.default.createElement(
				"g",
				{ className: "snapshot-flash" },
				_react2.default.createElement("path", { style: style, fill: "#FFFFFF", d: "M48.8290253,3.7666812l2.5763054-1.1934686 C53.297596,1.696642,55.5194092,2.7667944,56.01408,4.7925673l0.6731491,2.7582936 c0.2308235,0.9450812,0.8656769,1.7411942,1.7355728,2.1764894l2.5394173,1.2700605 c1.8648605,0.933136,2.4136391,3.3372889,1.1379585,4.987134l-1.7366257,2.2460556 c-0.5951576,0.769762-0.8214149,1.76227-0.6193962,2.7136745l0.5902367,2.7772675 c0.4331856,2.0401726-1.1042328,3.9679222-3.1893806,3.9995441l-2.8390961,0.042511 c-0.9724846,0.0147533-1.8898087,0.4563751-2.5077972,1.2075214l-1.8033829,2.1930046 c-1.3245125,1.6108475-3.7905006,1.6108475-5.1150131,0l-1.80373-2.1930046 c-0.6176414-0.7511463-1.5349655-1.1927681-2.5077972-1.2075214l-2.8387527-0.042511 c-2.085495-0.0316219-3.6229134-1.9593716-3.189373-3.9995441l0.5902328-2.7772675 c0.2020149-0.9514046-0.0245934-1.9439125-0.6193924-2.7136745l-1.7369766-2.2460556 c-1.2756824-1.6498451-0.7269058-4.053998,1.1383095-4.987134l2.5394135-1.2700605 c0.8702469-0.4352951,1.5047493-1.2314081,1.7352219-2.1764894l0.6735001-2.7582936 c0.4946709-2.0257728,2.7164879-3.0959253,4.6087494-2.2193546l2.5763054,1.1934686 C46.9283295,4.1756325,47.9461288,4.1756325,48.8290253,3.7666812" })
			)
		);
	}
	
	function ShopBox() {
		return _react2.default.createElement(
			"svg",
			{ version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 112.9 114.3" },
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M62,30.7H43.5c-11.6,0-16.9-7.6-16.9-14.7c0-8.1,6.6-14.7,14.7-14.7c7.4,0,13.5,4.5,17.2,12.6 c2.4,5.5,3,11,3,11.2L62,30.7z M41.2,11.4c-2.6,0-4.7,2.1-4.7,4.7c0,4.3,5.3,4.7,6.9,4.7h6.8C48.9,16.5,46.3,11.4,41.2,11.4z" })
			),
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M69.5,30.7H50.9l0.6-5.5c0-0.2,0.6-5.7,3-11.2c3.6-8.2,9.7-12.6,17.2-12.6c8.1,0,14.7,6.6,14.7,14.7 C86.4,23.1,81.1,30.7,69.5,30.7z M62.7,20.7h6.8c1.6,0,6.9-0.3,6.9-4.7c0-2.6-2.1-4.7-4.7-4.7C66.6,11.4,64,16.5,62.7,20.7z" })
			),
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("rect", { x: "7.9", y: "41.2", width: "43.6", height: "21.4" }),
				_react2.default.createElement("rect", { x: "61.5", y: "41.2", width: "43.6", height: "21.4" })
			),
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("polygon", { points: "51.5,72.5 15.4,72.5 18.8,114.3 51.5,114.3 \t" }),
				_react2.default.createElement("polygon", { points: "61.5,72.5 61.5,114.3 94.1,114.3 97.5,72.5 \t" })
			)
		);
	}
	
	function Badge(_ref) {
		var classes = _ref.classes;
	
		var style = {
			fillRule: 'evenodd',
			clipRule: 'evenodd'
		};
		return _react2.default.createElement(
			"svg",
			{ className: classes, version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 60 60" },
			_react2.default.createElement("path", { style: style, d: "M32.7194595,3.5239437l5.0332947-2.331665 c3.6968956-1.7125453,8.0376244,0.3781986,9.0040588,4.3359256l1.3151207,5.388845 c0.4509621,1.8463926,1.6912651,3.4017506,3.39077,4.2521811l4.9612274,2.4813013 c3.6433563,1.8230553,4.7154961,6.5200195,2.2232132,9.7433033l-3.3928223,4.3880901 c-1.1627502,1.5038757-1.6047821,3.4429283-1.2101059,5.3016739l1.1531372,5.4259148 c0.8463135,3.9858589-2.1573257,7.752079-6.2310524,7.813858l-5.546711,0.0830574 c-1.899929,0.02882-3.6920929,0.891613-4.8994484,2.3591156l-3.5232468,4.2844467 c-2.5876846,3.1470947-7.4054546,3.1470947-9.9931412,0l-3.5239277-4.2844467 c-1.2066746-1.4675026-2.9988365-2.3302956-4.8994484-2.3591156l-5.5460329-0.0830574 c-4.0744071-0.061779-7.0780487-3.8279991-6.2310443-7.813858l1.1531348-5.4259148 c0.3946743-1.8587456-0.0480471-3.7977982-1.2101045-5.3016739l-3.3935113-4.3880901 c-2.4922814-3.2232838-1.4201401-7.920248,2.2239027-9.7433033l4.9612255-2.4813013 c1.7001896-0.8504305,2.9398041-2.4057884,3.3900824-4.2521811l1.3158064-5.388845 c0.9664345-3.957727,5.3071661-6.048471,9.0040579-4.3359256l5.0332947,2.331665 C29.0060902,4.322907,30.9945583,4.322907,32.7194595,3.5239437" })
		);
	}
	Badge.defaultProps = {
		classes: ''
	};
	
	function PriceBadgeSVG() {
		var style = {
			fillRule: 'evenodd',
			clipRule: 'evenodd'
		};
		return _react2.default.createElement(
			"svg",
			{ className: "price-badge__svg", version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 60 60" },
			_react2.default.createElement("path", { className: "price-badge__svg__badge", style: style, d: "M32.7194595,3.5239437l5.0332947-2.331665 c3.6968956-1.7125453,8.0376244,0.3781986,9.0040588,4.3359256l1.3151207,5.388845 c0.4509621,1.8463926,1.6912651,3.4017506,3.39077,4.2521811l4.9612274,2.4813013 c3.6433563,1.8230553,4.7154961,6.5200195,2.2232132,9.7433033l-3.3928223,4.3880901 c-1.1627502,1.5038757-1.6047821,3.4429283-1.2101059,5.3016739l1.1531372,5.4259148 c0.8463135,3.9858589-2.1573257,7.752079-6.2310524,7.813858l-5.546711,0.0830574 c-1.899929,0.02882-3.6920929,0.891613-4.8994484,2.3591156l-3.5232468,4.2844467 c-2.5876846,3.1470947-7.4054546,3.1470947-9.9931412,0l-3.5239277-4.2844467 c-1.2066746-1.4675026-2.9988365-2.3302956-4.8994484-2.3591156l-5.5460329-0.0830574 c-4.0744071-0.061779-7.0780487-3.8279991-6.2310443-7.813858l1.1531348-5.4259148 c0.3946743-1.8587456-0.0480471-3.7977982-1.2101045-5.3016739l-3.3935113-4.3880901 c-2.4922814-3.2232838-1.4201401-7.920248,2.2239027-9.7433033l4.9612255-2.4813013 c1.7001896-0.8504305,2.9398041-2.4057884,3.3900824-4.2521811l1.3158064-5.388845 c0.9664345-3.957727,5.3071661-6.048471,9.0040579-4.3359256l5.0332947,2.331665 C29.0060902,4.322907,30.9945583,4.322907,32.7194595,3.5239437" }),
			_react2.default.createElement(
				"g",
				{ className: "price-badge__svg__ellipsis" },
				_react2.default.createElement("circle", { cx: "18.4795742", cy: "30", r: "2.7578125" }),
				_react2.default.createElement("circle", { cx: "30", cy: "30", r: "2.7578125" }),
				_react2.default.createElement("circle", { cx: "41.5204239", cy: "30", r: "2.7578125" })
			),
			_react2.default.createElement(
				"g",
				{ className: "price-badge__svg__checkmark" },
				_react2.default.createElement("polygon", { fill: "#FFFFFF", points: "27.2325401,39.7163086 18.6383018,31.121582 22.1744347,27.5864258 27.2325401,32.6450195 37.8262901,22.0517578 41.3614464,25.5869141 " })
			),
			_react2.default.createElement(
				"g",
				{ className: "price-badge__svg__offline-face" },
				_react2.default.createElement("polygon", { points: "42.7232857,18.2530651 40.279438,18.2530651 42.7232857,14.747694 42.7232857,12.8526745 36.9850044,12.8526745 36.9850044,15.1754284 39.317524,15.1754284 36.958149,18.6837292 36.958149,20.575819 42.7232857,20.575819 " }),
				_react2.default.createElement("polygon", { points: "34.9098091,24.1495495 32.4659615,24.1495495 34.9098091,20.6441784 34.9098091,18.7491589 29.1715279,18.7491589 29.1715279,21.0719128 31.5040474,21.0719128 29.1446724,24.5802135 29.1446724,26.4723034 34.9098091,26.4723034 " }),
				_react2.default.createElement("circle", { cx: "30.0000191", cy: "39.8555412", r: "2.7578125" }),
				_react2.default.createElement("path", { d: "M44.4181099,32.2667351c-1.019043,1.2397461-2.5219727,1.9506836-4.1245117,1.9506836 s-3.105957-0.7109375-4.1245117-1.9511719l-2.3183594,1.9042969c1.5908203,1.9365234,3.9389648,3.046875,6.4428711,3.046875 c2.503418,0,4.8515625-1.1103516,6.4418945-3.0463867L44.4181099,32.2667351z" }),
				_react2.default.createElement("path", { d: "M19.7066841,34.2174187c-1.6025391,0-3.105957-0.7109375-4.1245127-1.9511719l-2.3183594,1.9042969 c1.5908203,1.9365234,3.9389658,3.046875,6.442872,3.046875c2.503418,0,4.8520508-1.1103516,6.4423828-3.0463867 l-2.3173828-1.9042969C22.8126411,33.5064812,21.3092232,34.2174187,19.7066841,34.2174187z" })
			)
		);
	}
	
	function X() {
		return _react2.default.createElement(
			"svg",
			{ version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 60 60" },
			_react2.default.createElement("polygon", { points: "53.8842773,13.1870413 46.8129883,6.1157522 30,22.9287415 13.1870117,6.1157522 6.1157227,13.1870413 22.9287109,30.0000305 6.1157227,46.8130188 13.1870117,53.8843079 30,37.0713196 46.8129883,53.8843079 53.8842773,46.8130188 37.0712891,30.0000305 \t" })
		);
	}
	
	exports.ShuffleIcon = ShuffleIcon;
	exports.Bag = Bag;
	exports.House = House;
	exports.Camera = Camera;
	exports.ShopBox = ShopBox;
	exports.Badge = Badge;
	exports.PriceBadgeSVG = PriceBadgeSVG;
	exports.X = X;

/***/ },
/* 45 */
9,
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var EventPluginRegistry = __webpack_require__(65);
	var ReactEventEmitterMixin = __webpack_require__(359);
	var ViewportMetrics = __webpack_require__(230);
	
	var getVendorPrefixedEventName = __webpack_require__(391);
	var isEventSupported = __webpack_require__(76);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(43);
	var ViewportMetrics = __webpack_require__(230);
	
	var getEventModifierState = __webpack_require__(74);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 50 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	var DOMNamespaces = __webpack_require__(64);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(72);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setActivePet = setActivePet;
	exports.setActivePetAsync = setActivePetAsync;
	exports.setKitten = setKitten;
	exports.setShuffleAsync = setShuffleAsync;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(4);
	
	var _shuffleActivePetType = __webpack_require__(260);
	
	var _shuffleActivePetType2 = _interopRequireDefault(_shuffleActivePetType);
	
	var _getRandom = __webpack_require__(33);
	
	var _getRandom2 = _interopRequireDefault(_getRandom);
	
	var _getCollectedPetTypes = __webpack_require__(254);
	
	var _getCollectedPetTypes2 = _interopRequireDefault(_getCollectedPetTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// --- SET ACTIVE PET --- //
	
	function setActivePet(pet) {
	  return {
	    type: _constants.SET_ACTIVE_PET,
	    payload: {
	      pet: pet
	    }
	  };
	} // Local
	/* eslint-disable import/prefer-default-export */
	function setActivePetAsync(pet) {
	  return function (dispatch, getState) {
	
	    // If shuffle was on, turn it off.
	    if (getState().activePet.shuffle) {
	      dispatch(setShuffle(false));
	    }
	
	    // If the new pet is different, set the new active pet.
	    if (getState().activePet.active.petType.sku !== pet.petType.sku) {
	      dispatch(setActivePet(pet));
	    }
	  };
	}
	
	// --- KITTEN --- //
	
	function setKitten(kitten) {
	  return {
	    type: _constants.SET_KITTEN,
	    payload: {
	      kitten: kitten
	    }
	  };
	}
	
	// --- SHUFFLE --- //
	
	function setShuffle(isShuffle) {
	  return {
	    type: _constants.SET_SHUFFLE_PETS,
	    payload: {
	      isShuffle: isShuffle
	    }
	  };
	}
	
	// Find the last shuffle state, then shuffle goodies if necessary.
	function setShuffleAsync() {
	  return function (dispatch, getState) {
	    var lastShuffleState = getState().activePet.shuffle;
	
	    // Toggle shuffle.
	    dispatch(setShuffle(!lastShuffleState));
	
	    // If shuffle is now true, set a new pet
	    if (lastShuffleState === false) {
	      // Filter out the current active pet.
	      var currentActivePet = getState().activePet.active.petType;
	      var newPetsToPickFrom = _lodash2.default.filter((0, _getCollectedPetTypes2.default)(getState().allPets), function (pet) {
	        return pet.sku !== currentActivePet.sku;
	      });
	      // Construct the new pet
	      var newActivePetType = (0, _shuffleActivePetType2.default)(newPetsToPickFrom);
	      var newActivePet = Object.assign({
	        petType: newActivePetType
	      }, _getRandom2.default.petOfTypeForPetPicker(newActivePetType.type));
	
	      dispatch(setActivePet(newActivePet));
	    }
	  };
	}

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(12);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Icons = __webpack_require__(44);
	
	var Icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ControlButton = function (_React$Component) {
		_inherits(ControlButton, _React$Component);
	
		function ControlButton(props) {
			_classCallCheck(this, ControlButton);
	
			var _this = _possibleConstructorReturn(this, (ControlButton.__proto__ || Object.getPrototypeOf(ControlButton)).call(this, props));
	
			_this.state = {
				isHover: false
			};
	
			_this.getMessage = _this.getMessage.bind(_this);
			_this.setHoverOn = _this.setHoverOn.bind(_this);
			_this.setHoverOff = _this.setHoverOff.bind(_this);
			_this.handleClick = _this.handleClick.bind(_this);
			return _this;
		}
	
		_createClass(ControlButton, [{
			key: 'getMessage',
			value: function getMessage() {
				if (this.props.isActive) {
					return null;
				}
	
				if (this.props.hasNotification && this.props.notificationMessage) {
					return _react2.default.createElement(
						'div',
						{ className: 'control-button__message' },
						this.props.notificationMessage
					);
				}
	
				if (this.props.persistLabel && this.props.label || this.state.isHover && this.props.label) {
					return _react2.default.createElement(
						'div',
						{ className: 'control-button__message' },
						this.props.label
					);
				}
	
				return null;
			}
		}, {
			key: 'setHoverOn',
			value: function setHoverOn() {
				this.setState({ isHover: true });
			}
		}, {
			key: 'setHoverOff',
			value: function setHoverOff() {
				this.setState({ isHover: false });
			}
		}, {
			key: 'handleClick',
			value: function handleClick() {
				if (this.props.callback) {
					this.props.callback();
				}
	
				this.setHoverOff();
			}
		}, {
			key: 'render',
			value: function render() {
				var _classnames;
	
				var thisClassName = this.props.shuffle ? 'shuffle' : this.props.className;
				var Icon = Icons[this.props.iconName];
				var Badge = Icons.Badge;
	
				var classes = (0, _classnames3.default)('control-button', (_classnames = {}, _defineProperty(_classnames, 'control-button--' + thisClassName, Boolean(thisClassName)), _defineProperty(_classnames, 'control-button--is-active', this.props.isActive), _defineProperty(_classnames, 'control-button--has-notification', this.props.hasNotification), _defineProperty(_classnames, 'control-button--no-interaction', !this.props.callback), _defineProperty(_classnames, 'control-button--reverse-flow', this.props.reverseFlow), _classnames));
	
				return _react2.default.createElement(
					'div',
					{
						className: classes,
						onMouseEnter: this.setHoverOn,
						onMouseLeave: this.setHoverOff,
						onClick: this.handleClick
					},
					_react2.default.createElement(
						'div',
						{ className: 'control-button__icon' },
						_react2.default.createElement(Icon, null),
						_react2.default.createElement(Badge, { classes: 'badge' })
					),
					this.getMessage()
				);
			}
		}]);
	
		return ControlButton;
	}(_react2.default.Component);
	
	ControlButton.propTypes = {
		shuffle: _propTypes2.default.bool,
		className: _propTypes2.default.string,
		iconName: _propTypes2.default.string,
		isActive: _propTypes2.default.bool,
		persistLabel: _propTypes2.default.bool,
		hasNotification: _propTypes2.default.bool,
		notificationMessage: _propTypes2.default.node,
		label: _propTypes2.default.node,
		callback: _propTypes2.default.func,
		reverseFlow: _propTypes2.default.bool
	};
	
	ControlButton.defaultProps = {
		shuffle: false,
		className: null,
		iconName: 'ShuffleIcon',
		isActive: false,
		persistLabel: false,
		hasNotification: false,
		notificationMessage: '',
		label: '',
		callback: function callback() {
			return null;
		},
		reverseFlow: false
	};
	
	exports.default = ControlButton;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Cat = __webpack_require__(527);
	
	var _Cat2 = _interopRequireDefault(_Cat);
	
	var _LilDoggo = __webpack_require__(547);
	
	var _LilDoggo2 = _interopRequireDefault(_LilDoggo);
	
	var _ClassicDoggo = __webpack_require__(538);
	
	var _ClassicDoggo2 = _interopRequireDefault(_ClassicDoggo);
	
	var _TuxedoBird = __webpack_require__(575);
	
	var _TuxedoBird2 = _interopRequireDefault(_TuxedoBird);
	
	var _Tiger = __webpack_require__(562);
	
	var _Tiger2 = _interopRequireDefault(_Tiger);
	
	var _Leopard = __webpack_require__(543);
	
	var _Leopard2 = _interopRequireDefault(_Leopard);
	
	var _Bear = __webpack_require__(506);
	
	var _Bear2 = _interopRequireDefault(_Bear);
	
	var _Tortoise = __webpack_require__(569);
	
	var _Tortoise2 = _interopRequireDefault(_Tortoise);
	
	var _Chicken = __webpack_require__(534);
	
	var _Chicken2 = _interopRequireDefault(_Chicken);
	
	var _Seal = __webpack_require__(558);
	
	var _Seal2 = _interopRequireDefault(_Seal);
	
	var _Bunny = __webpack_require__(510);
	
	var _Bunny2 = _interopRequireDefault(_Bunny);
	
	var _Pig = __webpack_require__(553);
	
	var _Pig2 = _interopRequireDefault(_Pig);
	
	var _ComingSoon = __webpack_require__(539);
	
	var _ComingSoon2 = _interopRequireDefault(_ComingSoon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pets = {
	  Cat: _Cat2.default,
	  LilDoggo: _LilDoggo2.default,
	  ClassicDoggo: _ClassicDoggo2.default,
	  TuxedoBird: _TuxedoBird2.default,
	  ComingSoon: _ComingSoon2.default,
	  Tiger: _Tiger2.default,
	  Leopard: _Leopard2.default,
	  Bear: _Bear2.default,
	  Tortoise: _Tortoise2.default,
	  Chicken: _Chicken2.default,
	  Seal: _Seal2.default,
	  Bunny: _Bunny2.default,
	  Pig: _Pig2.default
	};
	
	function Pet(props) {
	  var ThisPet = Pets[props.petType.name];
	  return _react2.default.createElement(ThisPet, props);
	}
	
	Pet.propTypes = {
	  petType: _propTypes2.default.shape({
	    name: _propTypes2.default.string,
	    type: _propTypes2.default.string
	  })
	};
	
	Pet.defaultProps = {
	  petType: {
	    sku: 'cat_tabbycat',
	    type: 'cat',
	    name: 'Cat'
	  }
	};
	
	exports.default = Pet;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShopFooter() {
		return _react2.default.createElement(
			'div',
			{ className: 'shop__footer' },
			_react2.default.createElement(
				'div',
				{ className: 'shop__footer__links' },
				_react2.default.createElement(
					_reactRouterDom.Link,
					{ to: '/shop/terms-of-service', className: 'site-link' },
					'Terms'
				),
				_react2.default.createElement(
					'span',
					{ className: 'divider' },
					'|'
				),
				_react2.default.createElement(
					_reactRouterDom.Link,
					{ to: '/shop/privacy-policy', className: 'site-link' },
					'Privacy'
				)
			),
			_react2.default.createElement(
				'div',
				null,
				'Created by ',
				_react2.default.createElement(
					'a',
					{ className: 'site-link', href: 'https://twitter.com/lslez', target: '_blank' },
					'@lslez'
				),
				'.'
			)
		);
	}
	
	exports.default = ShopFooter;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var useConsoleLog = ("production") === 'development';
	
	function consoleLog() {
		if (arguments.length > 1) {
			var _console;
	
			(_console = console).log.apply(_console, arguments);
		} else {
			console.log(arguments.length <= 0 ? undefined : arguments[0]);
		}
	}
	
	var log = useConsoleLog ? consoleLog : _lodash.noop;
	
	exports.default = log;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(218);
	
	var animateScroll = __webpack_require__(88);
	var scrollSpy = __webpack_require__(262);
	var defaultScroller = __webpack_require__(263);
	var assign = __webpack_require__(10);
	var PropTypes = __webpack_require__(8);
	
	var protoTypes = {
	  to: PropTypes.string.isRequired,
	  containerId: PropTypes.string,
	  container: PropTypes.object,
	  activeClass: PropTypes.string,
	  spy: PropTypes.bool,
	  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	  offset: PropTypes.number,
	  delay: PropTypes.number,
	  isDynamic: PropTypes.bool,
	  onClick: PropTypes.func,
	  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
	  absolute: PropTypes.bool,
	  onSetActive: PropTypes.func,
	  onSetInactive: PropTypes.func,
	  ignoreCancelEvents: PropTypes.bool
	};
	
	var Helpers = {
	
	  Scroll: function Scroll(Component, customScroller) {
	
	    var scroller = customScroller || defaultScroller;
	
	    var _ = function (_React$Component) {
	      _inherits(_, _React$Component);
	
	      function _(props) {
	        _classCallCheck(this, _);
	
	        var _this = _possibleConstructorReturn(this, (_.__proto__ || Object.getPrototypeOf(_)).call(this, props));
	
	        _this.scrollTo = _this.scrollTo.bind(_this);
	        _this.handleClick = _this.handleClick.bind(_this);
	        _this.spyHandler = _this.spyHandler.bind(_this);
	
	        return _this;
	      }
	
	      _createClass(_, [{
	        key: 'scrollTo',
	        value: function scrollTo(to, props) {
	          scroller.scrollTo(to, props);
	        }
	      }, {
	        key: 'handleClick',
	        value: function handleClick(event) {
	
	          /*
	           * give the posibility to override onClick
	           */
	
	          if (this.props.onClick) {
	            this.props.onClick(event);
	          }
	
	          /*
	           * dont bubble the navigation
	           */
	
	          if (event.stopPropagation) event.stopPropagation();
	          if (event.preventDefault) event.preventDefault();
	
	          /*
	           * do the magic!
	           */
	          this.scrollTo(this.props.to, this.props);
	        }
	      }, {
	        key: 'spyHandler',
	        value: function spyHandler(y) {
	          var element = scroller.get(this.props.to);
	          if (!element) return;
	          var cords = element.getBoundingClientRect();
	          var topBound = cords.top + y;
	          var bottomBound = topBound + cords.height;
	          var offsetY = y - this.props.offset;
	          var to = this.props.to;
	          var isInside = offsetY >= topBound && offsetY <= bottomBound;
	          var isOutside = offsetY < topBound || offsetY > bottomBound;
	          var activeLink = scroller.getActiveLink();
	
	          if (isOutside && activeLink === to) {
	            scroller.setActiveLink(void 0);
	            this.setState({ active: false });
	
	            if (this.props.onSetInactive) {
	              this.props.onSetInactive();
	            }
	          } else if (isInside && activeLink != to) {
	            scroller.setActiveLink(to);
	            this.setState({ active: true });
	
	            if (this.props.onSetActive) {
	              this.props.onSetActive(to);
	            }
	
	            scrollSpy.updateStates();
	          }
	        }
	      }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	          var containerId = this.props.containerId;
	          var container = this.props.container;
	
	          var scrollSpyContainer;
	
	          if (containerId) {
	            scrollSpyContainer = document.getElementById(containerId);
	          } else if (container && container.nodeType) {
	            scrollSpyContainer = container;
	          } else {
	            scrollSpyContainer = document;
	          }
	
	          if (!scrollSpy.isMounted(scrollSpyContainer)) {
	            scrollSpy.mount(scrollSpyContainer);
	          }
	
	          if (this.props.spy) {
	            var to = this.props.to;
	            var element = null;
	            var elemTopBound = 0;
	            var elemBottomBound = 0;
	
	            this._stateHandler = function () {
	              if (scroller.getActiveLink() != to) {
	                if (this.state !== null && this.state.active && this.props.onSetInactive) {
	                  this.props.onSetInactive();
	                }
	                this.setState({ active: false });
	              }
	            }.bind(this);
	
	            scrollSpy.addStateHandler(this._stateHandler);
	
	            this._spyHandler = function (y) {
	
	              var containerTop = 0;
	              if (scrollSpyContainer.getBoundingClientRect) {
	                var containerCords = scrollSpyContainer.getBoundingClientRect();
	                containerTop = containerCords.top;
	              }
	
	              if (!element || this.props.isDynamic) {
	                element = scroller.get(to);
	                if (!element) {
	                  return;
	                }
	
	                var cords = element.getBoundingClientRect();
	                elemTopBound = cords.top - containerTop + y;
	                elemBottomBound = elemTopBound + cords.height;
	              }
	
	              var offsetY = y - this.props.offset;
	              var isInside = offsetY >= Math.floor(elemTopBound) && offsetY <= Math.floor(elemBottomBound);
	              var isOutside = offsetY < Math.floor(elemTopBound) || offsetY > Math.floor(elemBottomBound);
	              var activeLink = scroller.getActiveLink();
	
	              if (isOutside && activeLink === to) {
	                scroller.setActiveLink(void 0);
	                this.setState({ active: false });
	
	                if (this.props.onSetInactive) {
	                  this.props.onSetInactive();
	                }
	              } else if (isInside && activeLink != to) {
	                scroller.setActiveLink(to);
	                this.setState({ active: true });
	
	                if (this.props.onSetActive) {
	                  this.props.onSetActive(to);
	                }
	
	                scrollSpy.updateStates();
	              }
	            }.bind(this);
	
	            scrollSpy.addSpyHandler(this._spyHandler, scrollSpyContainer);
	          }
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          scrollSpy.unmount(this._stateHandler, this._spyHandler);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	
	          var className = "";
	          if (this.state && this.state.active) {
	            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
	          } else {
	            className = this.props.className;
	          }
	
	          var props = assign({}, this.props);
	
	          for (var prop in protoTypes) {
	            if (props.hasOwnProperty(prop)) {
	              delete props[prop];
	            }
	          }
	
	          props.className = className;
	          props.onClick = this.handleClick;
	
	          return React.createElement(Component, props);
	        }
	      }]);
	
	      return _;
	    }(React.Component);
	
	    ;
	    _.propTypes = protoTypes;
	    _.defaultProps = { offset: 0 };
	    return _;
	  },
	
	  Element: function Element(Component) {
	    var _ = function (_React$Component2) {
	      _inherits(_, _React$Component2);
	
	      function _(props) {
	        _classCallCheck(this, _);
	
	        var _this2 = _possibleConstructorReturn(this, (_.__proto__ || Object.getPrototypeOf(_)).call(this, props));
	
	        _this2.registerElems = _this2.registerElems.bind(_this2);
	        _this2.childBindings = {
	          domNode: null
	        };
	        return _this2;
	      }
	
	      _createClass(_, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.registerElems(this.props.name);
	        }
	      }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          if (this.props.name !== nextProps.name) {
	            this.registerElems(nextProps.name);
	          }
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          defaultScroller.unregister(this.props.name);
	        }
	      }, {
	        key: 'registerElems',
	        value: function registerElems(name) {
	          defaultScroller.register(name, this.childBindings.domNode);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return React.createElement(Component, Object.assign({}, this.props, { parentBindings: this.childBindings }));
	        }
	      }]);
	
	      return _;
	    }(React.Component);
	
	    ;
	    _.propTypes = {
	      name: PropTypes.string,
	      id: PropTypes.string
	    };
	    return _;
	  }
	};
	
	module.exports = Helpers;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _consolidatedEvents = __webpack_require__(282);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _computeOffsetPixels = __webpack_require__(628);
	
	var _computeOffsetPixels2 = _interopRequireDefault(_computeOffsetPixels);
	
	var _constants = __webpack_require__(264);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _debugLog = __webpack_require__(629);
	
	var _debugLog2 = _interopRequireDefault(_debugLog);
	
	var _ensureChildrenIsSingleDOMElement = __webpack_require__(630);
	
	var _ensureChildrenIsSingleDOMElement2 = _interopRequireDefault(_ensureChildrenIsSingleDOMElement);
	
	var _getCurrentPosition = __webpack_require__(631);
	
	var _getCurrentPosition2 = _interopRequireDefault(_getCurrentPosition);
	
	var _resolveScrollableAncestorProp = __webpack_require__(635);
	
	var _resolveScrollableAncestorProp2 = _interopRequireDefault(_resolveScrollableAncestorProp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultProps = {
	  topOffset: '0px',
	  bottomOffset: '0px',
	  horizontal: false,
	  onEnter: function onEnter() {},
	  onLeave: function onLeave() {},
	  onPositionChange: function onPositionChange() {},
	
	  fireOnRapidScroll: true
	};
	
	/**
	 * Calls a function when you scroll to the element.
	 */
	
	var Waypoint = function (_React$Component) {
	  _inherits(Waypoint, _React$Component);
	
	  function Waypoint(props) {
	    _classCallCheck(this, Waypoint);
	
	    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));
	
	    _this.refElement = function (e) {
	      return _this._ref = e;
	    };
	    return _this;
	  }
	
	  _createClass(Waypoint, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      (0, _ensureChildrenIsSingleDOMElement2.default)(this.props.children);
	
	      if (this.props.scrollableParent) {
	        // eslint-disable-line react/prop-types
	        throw new Error('The `scrollableParent` prop has changed name to `scrollableAncestor`.');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (!Waypoint.getWindow()) {
	        return;
	      }
	
	      this._handleScroll = this._handleScroll.bind(this);
	      this.scrollableAncestor = this._findScrollableAncestor();
	
	      if (false) {
	        (0, _debugLog2.default)('scrollableAncestor', this.scrollableAncestor);
	      }
	
	      this.scrollEventListenerHandle = (0, _consolidatedEvents.addEventListener)(this.scrollableAncestor, 'scroll', this._handleScroll, { passive: true });
	
	      this.resizeEventListenerHandle = (0, _consolidatedEvents.addEventListener)(window, 'resize', this._handleScroll, { passive: true });
	
	      // this._ref may occasionally not be set at this time. To help ensure that
	      // this works smoothly, we want to delay the initial execution until the
	      // next tick.
	      this.initialTimeout = setTimeout(function () {
	        _this2.initialTimeout = null;
	        _this2._handleScroll(null);
	      }, 0);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _ensureChildrenIsSingleDOMElement2.default)(nextProps.children);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!Waypoint.getWindow()) {
	        return;
	      }
	
	      // The element may have moved.
	      this._handleScroll(null);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!Waypoint.getWindow()) {
	        return;
	      }
	
	      (0, _consolidatedEvents.removeEventListener)(this.scrollEventListenerHandle);
	      (0, _consolidatedEvents.removeEventListener)(this.resizeEventListenerHandle);
	
	      if (this.initialTimeout) {
	        clearTimeout(this.initialTimeout);
	      }
	    }
	
	    /**
	     * Traverses up the DOM to find an ancestor container which has an overflow
	     * style that allows for scrolling.
	     *
	     * @return {Object} the closest ancestor element with an overflow style that
	     *   allows for scrolling. If none is found, the `window` object is returned
	     *   as a fallback.
	     */
	
	  }, {
	    key: '_findScrollableAncestor',
	    value: function _findScrollableAncestor() {
	      var _props = this.props,
	          horizontal = _props.horizontal,
	          scrollableAncestor = _props.scrollableAncestor;
	
	
	      if (scrollableAncestor) {
	        return (0, _resolveScrollableAncestorProp2.default)(scrollableAncestor);
	      }
	
	      var node = this._ref;
	
	      while (node.parentNode) {
	        node = node.parentNode;
	
	        if (node === document) {
	          // This particular node does not have a computed style.
	          continue;
	        }
	
	        if (node === document.documentElement) {
	          // This particular node does not have a scroll bar, it uses the window.
	          continue;
	        }
	
	        var style = window.getComputedStyle(node);
	        var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
	        var overflow = overflowDirec || style.getPropertyValue('overflow');
	
	        if (overflow === 'auto' || overflow === 'scroll') {
	          return node;
	        }
	      }
	
	      // A scrollable ancestor element was not found, which means that we need to
	      // do stuff on window.
	      return window;
	    }
	
	    /**
	     * @param {Object} event the native scroll event coming from the scrollable
	     *   ancestor, or resize event coming from the window. Will be undefined if
	     *   called by a React lifecyle method
	     */
	
	  }, {
	    key: '_handleScroll',
	    value: function _handleScroll(event) {
	      if (!this._ref) {
	        // There's a chance we end up here after the component has been unmounted.
	        return;
	      }
	
	      var bounds = this._getBounds();
	      var currentPosition = (0, _getCurrentPosition2.default)(bounds);
	      var previousPosition = this._previousPosition;
	
	      if (false) {
	        (0, _debugLog2.default)('currentPosition', currentPosition);
	        (0, _debugLog2.default)('previousPosition', previousPosition);
	      }
	
	      // Save previous position as early as possible to prevent cycles
	      this._previousPosition = currentPosition;
	
	      if (previousPosition === currentPosition) {
	        // No change since last trigger
	        return;
	      }
	
	      var callbackArg = {
	        currentPosition: currentPosition,
	        previousPosition: previousPosition,
	        event: event,
	        waypointTop: bounds.waypointTop,
	        waypointBottom: bounds.waypointBottom,
	        viewportTop: bounds.viewportTop,
	        viewportBottom: bounds.viewportBottom
	      };
	      this.props.onPositionChange.call(this, callbackArg);
	
	      if (currentPosition === _constants2.default.inside) {
	        this.props.onEnter.call(this, callbackArg);
	      } else if (previousPosition === _constants2.default.inside) {
	        this.props.onLeave.call(this, callbackArg);
	      }
	
	      var isRapidScrollDown = previousPosition === _constants2.default.below && currentPosition === _constants2.default.above;
	      var isRapidScrollUp = previousPosition === _constants2.default.above && currentPosition === _constants2.default.below;
	
	      if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
	        // If the scroll event isn't fired often enough to occur while the
	        // waypoint was visible, we trigger both callbacks anyway.
	        this.props.onEnter.call(this, {
	          currentPosition: _constants2.default.inside,
	          previousPosition: previousPosition,
	          event: event,
	          waypointTop: bounds.waypointTop,
	          waypointBottom: bounds.waypointBottom,
	          viewportTop: bounds.viewportTop,
	          viewportBottom: bounds.viewportBottom
	        });
	        this.props.onLeave.call(this, {
	          currentPosition: currentPosition,
	          previousPosition: _constants2.default.inside,
	          event: event,
	          waypointTop: bounds.waypointTop,
	          waypointBottom: bounds.waypointBottom,
	          viewportTop: bounds.viewportTop,
	          viewportBottom: bounds.viewportBottom
	        });
	      }
	    }
	  }, {
	    key: '_getBounds',
	    value: function _getBounds() {
	      var horizontal = this.props.horizontal;
	
	      var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
	          left = _ref$getBoundingClien.left,
	          top = _ref$getBoundingClien.top,
	          right = _ref$getBoundingClien.right,
	          bottom = _ref$getBoundingClien.bottom;
	
	      var waypointTop = horizontal ? left : top;
	      var waypointBottom = horizontal ? right : bottom;
	
	      var contextHeight = void 0;
	      var contextScrollTop = void 0;
	      if (this.scrollableAncestor === window) {
	        contextHeight = horizontal ? window.innerWidth : window.innerHeight;
	        contextScrollTop = 0;
	      } else {
	        contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
	        contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
	      }
	
	      if (false) {
	        (0, _debugLog2.default)('waypoint top', waypointTop);
	        (0, _debugLog2.default)('waypoint bottom', waypointBottom);
	        (0, _debugLog2.default)('scrollableAncestor height', contextHeight);
	        (0, _debugLog2.default)('scrollableAncestor scrollTop', contextScrollTop);
	      }
	
	      var _props2 = this.props,
	          bottomOffset = _props2.bottomOffset,
	          topOffset = _props2.topOffset;
	
	      var topOffsetPx = (0, _computeOffsetPixels2.default)(topOffset, contextHeight);
	      var bottomOffsetPx = (0, _computeOffsetPixels2.default)(bottomOffset, contextHeight);
	      var contextBottom = contextScrollTop + contextHeight;
	
	      return {
	        waypointTop: waypointTop,
	        waypointBottom: waypointBottom,
	        viewportTop: contextScrollTop + topOffsetPx,
	        viewportBottom: contextBottom - bottomOffsetPx
	      };
	    }
	
	    /**
	     * @return {Object}
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var children = this.props.children;
	
	
	      if (!children) {
	        // We need an element that we can locate in the DOM to determine where it is
	        // rendered relative to the top of its context.
	        return _react2.default.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
	      }
	
	      var ref = function ref(node) {
	        _this3.refElement(node);
	        if (children.ref) {
	          children.ref(node);
	        }
	      };
	
	      return _react2.default.cloneElement(children, { ref: ref });
	    }
	  }]);
	
	  return Waypoint;
	}(_react2.default.Component);
	
	exports.default = Waypoint;
	
	
	Waypoint.propTypes = {
	  children: _propTypes2.default.element,
	  debug: _propTypes2.default.bool,
	  onEnter: _propTypes2.default.func,
	  onLeave: _propTypes2.default.func,
	  onPositionChange: _propTypes2.default.func,
	  fireOnRapidScroll: _propTypes2.default.bool,
	  scrollableAncestor: _propTypes2.default.any,
	  horizontal: _propTypes2.default.bool,
	
	  // `topOffset` can either be a number, in which case its a distance from the
	  // top of the container in pixels, or a string value. Valid string values are
	  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
	  // as a percentage of the height of the containing element.
	  // For instance, if you pass "-20%", and the containing element is 100px tall,
	  // then the waypoint will be triggered when it has been scrolled 20px beyond
	  // the top of the containing element.
	  topOffset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
	  bottomOffset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Waypoint.above = _constants2.default.above;
	Waypoint.below = _constants2.default.below;
	Waypoint.inside = _constants2.default.inside;
	Waypoint.invisible = _constants2.default.invisible;
	Waypoint.getWindow = function () {
	  if (typeof window !== 'undefined') {
	    return window;
	  }
	};
	Waypoint.defaultProps = defaultProps;
	Waypoint.displayName = 'Waypoint';
	module.exports = exports['default'];

/***/ },
/* 59 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(654);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(662);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(28);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(307),
	    getPrototype = __webpack_require__(309),
	    isObjectLike = __webpack_require__(314);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(29);
	var Danger = __webpack_require__(336);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactInstrumentation = __webpack_require__(18);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(72);
	var setInnerHTML = __webpack_require__(51);
	var setTextContent = __webpack_require__(238);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 64 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactErrorUtils = __webpack_require__(70);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 67 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactPropTypesSecret = __webpack_require__(365);
	var propTypesFactory = __webpack_require__(216);
	
	var React = __webpack_require__(35);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactInstanceMap = __webpack_require__(42);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(19);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 72 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 73 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 75 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 77 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var emptyFunction = __webpack_require__(15);
	var warning = __webpack_require__(7);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 79 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(28);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(324);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setActiveGoodyAsync = setActiveGoodyAsync;
	exports.setShuffleAsync = setShuffleAsync;
	
	var _constants = __webpack_require__(4);
	
	var _activePet = __webpack_require__(52);
	
	var _shuffleActiveGoodies = __webpack_require__(259);
	
	var _shuffleActiveGoodies2 = _interopRequireDefault(_shuffleActiveGoodies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// --- SET ONE ACTIVE GOODY --- //
	
	function setActiveGoody(type, id) {
	  return {
	    type: _constants.SET_ACTIVE_GOODY,
	    payload: {
	      type: type,
	      id: id
	    }
	  };
	}
	
	// Set the active goodies, remove kittens and shuffle.
	// Local
	
	/* eslint-disable import/prefer-default-export */
	function setActiveGoodyAsync(type, id) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      leaveShuffleAlone = _ref.leaveShuffleAlone;
	
	  return function (dispatch, getState) {
	    var lastState = getState();
	
	    // If this is a toy and there was a kitten, remove it so that the new toy is shown.
	    if (lastState.activePet.active.kitten && type === 'toy') {
	      dispatch((0, _activePet.setKitten)(null));
	    }
	
	    // If the new goody is different than the last one, set the new goody.
	    if (lastState.activeGoodies.active[type] !== id) {
	      dispatch(setActiveGoody(type, id));
	    }
	
	    // If shuffle was on, turn it off (unless leaveShuffleAlone, like from pet purchase)
	    if (lastState.activeGoodies.shuffle === true && !leaveShuffleAlone) {
	      dispatch(setShuffle(false));
	    }
	  };
	}
	
	// --- SHUFFLE ACTIVE GOODIES --- //
	
	function setActiveGoodiesWithShuffle(activeGoodies, shuffle) {
	  return {
	    type: _constants.SET_ACTIVE_GOODIES_WITH_SHUFFLE,
	    payload: {
	      activeGoodies: activeGoodies,
	      shuffle: shuffle
	    }
	  };
	}
	
	// --- SHUFFLE --- //
	
	function setShuffle(shuffle) {
	  return {
	    type: _constants.SET_SHUFFLE_GOODIES,
	    payload: {
	      shuffle: shuffle
	    }
	  };
	}
	
	// Find the last shuffle state, then shuffle goodies if necessary.
	function setShuffleAsync() {
	  return function (dispatch, getState) {
	    var lastShuffleState = getState().activeGoodies.shuffle;
	
	    // A. Shuffle is false now.
	    if (lastShuffleState === true) {
	      dispatch(setShuffle(false));
	      return;
	    }
	
	    // B. Shuffle is true now.
	    // B1. Remove kittens.
	    if (getState().activePet.active.kitten) {
	      dispatch((0, _activePet.setKitten)(null));
	    }
	    // B2. Shuffle the goodies and set new shuffle state.
	    dispatch(setActiveGoodiesWithShuffle((0, _shuffleActiveGoodies2.default)(getState().collectedGoodies.list), true));
	  };
	}

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.setAllPets = setAllPets;
	exports.setAllPetsAsync = setAllPetsAsync;
	exports.removeNewnessFromPets = removeNewnessFromPets;
	exports.setPetToCollected = setPetToCollected;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(4);
	
	var _getNewPets = __webpack_require__(86);
	
	var _getNewPets2 = _interopRequireDefault(_getNewPets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var basePet = {
		"kind": "chromewebstore#inAppProduct",
		"sku": "tabby_pet",
		"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
		"type": "inapp",
		"state": "ACTIVE",
		"prices": [{
			"valueMicros": "1000000",
			"currencyCode": "USD",
			"regionCode": "US"
		}]
	}; /* eslint-disable import/prefer-default-export, quote-props, quotes, comma-dangle */
	function setAllPets(allPets) {
		return {
			type: _constants.SET_ALL_PETS,
			payload: {
				allPets: allPets
			}
		};
	}
	
	function setAllPetsAsync(skuDetailsResponse, purchasesResponse, dispatch, getState) {
		var inAppProducts = _lodash2.default.get(skuDetailsResponse, 'response.details.inAppProducts', []);
		var successfulPurchases = _lodash2.default.filter(_lodash2.default.get(purchasesResponse, 'response.details', []), function (purchase) {
			return purchase.state === 'ACTIVE';
		});
		var petsForApp = [];
	
		console.log('setAllPetsAsync -- ', [skuDetailsResponse, purchasesResponse]);
	
		if (_lodash2.default.isEmpty(inAppProducts) && _lodash2.default.isEmpty(successfulPurchases)) {
			petsForApp = _lodash2.default.chain(_constants.PETS).map(function (pet) {
				// We add tabby cat at the end.
				if (pet.sku === 'cat_tabbycat') {
					return undefined;
				}
	
				var petInCodeBase = true;
				var isCollected = !!petInCodeBase && !!_lodash2.default.find(successfulPurchases, ['sku', pet.sku]);
				var isComingSoon = pet.state === 'INACTIVE' || !petInCodeBase;
	
				// Newness
				var thisPetFromLastTime = _lodash2.default.find(getState().allPets, { sku: pet.sku, isComingSoon: false });
				var isNewThisTime = !thisPetFromLastTime && !isCollected && !isComingSoon; // It wasn't here last time, it's not collected or coming soon.
				var isNewFromLastTime = _lodash2.default.get(thisPetFromLastTime, 'isNew') && !isCollected; // It was new last time and hasn't been collected since then.
				var isNew = isNewThisTime || isNewFromLastTime;
	
				// Build a fake pet
				return Object.assign({}, basePet, {
					sku: pet.sku,
					petType: pet,
					isCollected: isCollected,
					isComingSoon: isComingSoon,
					isNew: isNew,
					"localeData": [{
						"title": pet.displayName,
						"description": "",
						"languageCode": "en-US"
					}]
				});
			}).filter(function (pet) {
				return pet !== undefined;
			}).value();
		} else {
			petsForApp = _lodash2.default.map(inAppProducts, function (pet) {
				var petInCodeBase = _lodash2.default.find(_constants.PETS, ['sku', pet.sku]);
				var isCollected = !!petInCodeBase && !!_lodash2.default.find(successfulPurchases, ['sku', pet.sku]);
				var isComingSoon = pet.state === 'INACTIVE' || !petInCodeBase;
	
				// Newness
				var thisPetFromLastTime = _lodash2.default.find(getState().allPets, { sku: pet.sku, isComingSoon: false });
				var isNewThisTime = !thisPetFromLastTime && !isCollected && !isComingSoon; // It wasn't here last time, it's not collected or coming soon.
				var isNewFromLastTime = _lodash2.default.get(thisPetFromLastTime, 'isNew') && !isCollected; // It was new last time and hasn't been collected since then.
				var isNew = isNewThisTime || isNewFromLastTime;
	
				return Object.assign({}, pet, {
					petType: petInCodeBase,
					isCollected: isCollected,
					isComingSoon: isComingSoon,
					isNew: isNew
				});
			});
		}
	
		petsForApp.unshift(_constants.BASE_COLLECTED_PET);
	
		dispatch(setAllPets(petsForApp));
	}
	
	function removeNewnessFromPets() {
		return function (dispatch, getState) {
			var petsWithoutNewness = [];
	
			if (_lodash2.default.isEmpty((0, _getNewPets2.default)(getState().allPets))) {
				// Don't do anything if there aren't any new pets to clear.
				return;
			}
	
			petsWithoutNewness = _lodash2.default.map(getState().allPets, function (pet) {
				return Object.assign({}, pet, {
					isNew: false
				});
			});
	
			dispatch(setAllPets(petsWithoutNewness));
		};
	}
	
	function setPetToCollected(sku, isCollected) {
		return function (dispatch, getState) {
			var newPets = _lodash2.default.map(getState().allPets, function (pet) {
				if (pet.sku !== sku) {
					return pet;
				}
				return Object.assign({}, pet, {
					isCollected: isCollected
				});
			});
	
			dispatch(setAllPets(newPets));
		};
	}

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Footer(_ref) {
		var bgColor = _ref.bgColor;
	
		return _react2.default.createElement(
			'div',
			{ className: bgColor },
			_react2.default.createElement(
				'div',
				{ className: 'site-footer alt-color--dark' },
				_react2.default.createElement(
					_reactRouterDom.Link,
					{ className: 'site-link', to: '/terms-of-use-and-privacy-policy' },
					_react2.default.createElement(
						'span',
						{ className: 'link-text--small' },
						'Privacy & Terms'
					),
					_react2.default.createElement(
						'span',
						{ className: 'link-text--medium' },
						'Terms of Use & Privacy Policy'
					)
				),
				_react2.default.createElement(
					'span',
					{ className: 'alt-color--lighter' },
					'Made by ',
					_react2.default.createElement(
						'a',
						{ className: 'site-link', href: 'https://twitter.com/lslez', target: '_blank', rel: 'noopener noreferrer' },
						'@lslez'
					),
					'.'
				)
			)
		);
	}
	
	exports.default = Footer;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isFirefox = (navigator.userAgent || '').indexOf('Firefox') > -1;
	var chromeUrl = 'https://chrome.google.com/webstore/detail/tabby-cat/mefhakmgclhhfbdadeojlkbllmecialg?hl=en';
	var firefoxUrl = 'https://addons.mozilla.org/en-US/firefox/addon/tabby-cat-friend/';
	
	function InstallButton(props) {
		return _react2.default.createElement(
			'a',
			{ className: props.classNames,
				href: isFirefox ? firefoxUrl : chromeUrl,
				onMouseOver: props.hoverOnButton,
				onMouseOut: props.hoverOffButton },
			props.ctaText
		);
	}
	
	// <span className="install-button--extra-text"> for hidden text on mobile
	
	InstallButton.defaultProps = {
		ctaText: _react2.default.createElement(
			'span',
			null,
			'+ Add to ',
			isFirefox ? 'Firefox' : 'Chrome'
		)
	};
	
	exports.default = InstallButton;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getNewPets;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getNewPets(pets) {
		return _lodash2.default.filter(pets, 'isNew');
	}

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var assign = __webpack_require__(10);
	
	var smooth = __webpack_require__(627);
	
	var cancelEvents = __webpack_require__(626);
	
	var events = __webpack_require__(89);
	
	/*
	 * Gets the easing type from the smooth prop within options.
	 */
	var getAnimationType = function getAnimationType(options) {
	  if (_typeof(options.smooth) === Boolean && options.smooth === true) {
	    return smooth.defaultEasing;
	  } else {
	    var animationType = options.smooth;
	    switch (animationType) {
	      case "linear":
	        return smooth.linear;
	      case "easeInQuad":
	        return smooth.easeInQuad;
	      case "easeOutQuad":
	        return smooth.easeOutQuad;
	      case "easeInOutQuad":
	        return smooth.easeInOutQuad;
	      case "easeInCubic":
	        return smooth.easeInCubic;
	      case "easeOutCubic":
	        return smooth.easeOutQuad;
	      case "easeInOutCubic":
	        return smooth.easeInQuad;
	      case "easeInQuart":
	        return smooth.easeInQuart;
	      case "easeOutQuart":
	        return smooth.easeOutQuart;
	      case "easeInOutQuart":
	        return smooth.easeInOutQuart;
	      case "easeInQuint":
	        return smooth.easeInQuint;
	      case "easeOutQuint":
	        return smooth.easeInQuint;
	      case "easeInOutQuint":
	        return smooth.easeInOutQuint;
	      default:
	        return smooth.defaultEasing;
	    }
	  }
	};
	
	/*
	 * Function helper
	 */
	var functionWrapper = function functionWrapper(value) {
	  return typeof value === 'function' ? value : function () {
	    return value;
	  };
	};
	
	/*
	 * Wraps window properties to allow server side rendering
	 */
	var currentWindowProperties = function currentWindowProperties() {
	  if (typeof window !== 'undefined') {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
	  }
	};
	
	/*
	 * Helper function to never extend 60fps on the webpage.
	 */
	var requestAnimationFrameHelper = function () {
	  return currentWindowProperties() || function (callback, element, delay) {
	    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
	  };
	}();
	
	var __currentPositionY = 0;
	var __startPositionY = 0;
	var __targetPositionY = 0;
	var __progress = 0;
	var __duration = 0;
	var __cancel = false;
	
	var __target;
	var __containerElement;
	var __to;
	var __start;
	var __deltaTop;
	var __percent;
	var __delayTimeout;
	
	var currentPositionY = function currentPositionY() {
	  if (__containerElement) {
	    return __containerElement.scrollTop;
	  } else {
	    var supportPageOffset = window.pageXOffset !== undefined;
	    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
	    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
	  }
	};
	
	var scrollContainerHeight = function scrollContainerHeight() {
	  if (__containerElement) {
	    return Math.max(__containerElement.scrollHeight, __containerElement.offsetHeight, __containerElement.clientHeight);
	  } else {
	    var body = document.body;
	    var html = document.documentElement;
	
	    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	  }
	};
	
	var animateTopScroll = function animateTopScroll(easing, timestamp) {
	
	  // Cancel on specific events
	  if (__cancel) {
	    if (events.registered['end']) {
	      events.registered['end'](__to, __target, __currentPositionY);
	    }
	    return;
	  };
	
	  __deltaTop = Math.round(__targetPositionY - __startPositionY);
	
	  if (__start === null) {
	    __start = timestamp;
	  }
	
	  __progress = timestamp - __start;
	
	  __percent = __progress >= __duration ? 1 : easing(__progress / __duration);
	
	  __currentPositionY = __startPositionY + Math.ceil(__deltaTop * __percent);
	
	  if (__containerElement) {
	    __containerElement.scrollTop = __currentPositionY;
	  } else {
	    window.scrollTo(0, __currentPositionY);
	  }
	
	  if (__percent < 1) {
	    var easedAnimate = animateTopScroll.bind(null, easing);
	    requestAnimationFrameHelper.call(window, easedAnimate);
	    return;
	  }
	
	  if (events.registered['end']) {
	    events.registered['end'](__to, __target, __currentPositionY);
	  }
	};
	
	var setContainer = function setContainer(options) {
	  if (!options || !options.containerId && (!options.container || !options.container.nodeType)) {
	    __containerElement = null;
	    return;
	  }
	
	  __containerElement = options.containerId ? document.getElementById(options.containerId) : options.container;
	};
	
	var startAnimateTopScroll = function startAnimateTopScroll(y, options, to, target) {
	
	  window.clearTimeout(__delayTimeout);
	
	  if (!options.ignoreCancelEvents) {
	    /*
	     * Sets the cancel trigger
	     */
	
	    cancelEvents.register(function () {
	      __cancel = true;
	    });
	  }
	
	  setContainer(options);
	
	  __start = null;
	  __cancel = false;
	  __startPositionY = currentPositionY();
	  __targetPositionY = options.absolute ? y : y + __startPositionY;
	  __deltaTop = Math.round(__targetPositionY - __startPositionY);
	
	  __duration = functionWrapper(options.duration)(__deltaTop);
	  __duration = isNaN(parseFloat(__duration)) ? 1000 : parseFloat(__duration);
	  __to = to;
	  __target = target;
	
	  var easing = getAnimationType(options);
	  var easedAnimate = animateTopScroll.bind(null, easing);
	
	  if (options && options.delay > 0) {
	    __delayTimeout = window.setTimeout(function animate() {
	      requestAnimationFrameHelper.call(window, easedAnimate);
	    }, options.delay);
	    return;
	  }
	
	  requestAnimationFrameHelper.call(window, easedAnimate);
	};
	
	var scrollToTop = function scrollToTop(options) {
	  startAnimateTopScroll(0, assign(options || {}, { absolute: true }));
	};
	
	var scrollTo = function scrollTo(toY, options) {
	  startAnimateTopScroll(toY, assign(options || {}, { absolute: true }));
	};
	
	var scrollToBottom = function scrollToBottom(options) {
	  setContainer(options);
	  startAnimateTopScroll(scrollContainerHeight(), assign(options || {}, { absolute: true }));
	};
	
	var scrollMore = function scrollMore(toY, options) {
	  setContainer(options);
	  startAnimateTopScroll(currentPositionY() + toY, assign(options || {}, { absolute: true }));
	};
	
	module.exports = {
	  animateTopScroll: startAnimateTopScroll,
	  getAnimationType: getAnimationType,
	  scrollToTop: scrollToTop,
	  scrollToBottom: scrollToBottom,
	  scrollTo: scrollTo,
	  scrollMore: scrollMore
	};

/***/ },
/* 89 */
/***/ function(module, exports) {

	"use strict";
	
	var Events = {
		registered: {},
		scrollEvent: {
			register: function register(evtName, callback) {
				Events.registered[evtName] = callback;
			},
			remove: function remove(evtName) {
				Events.registered[evtName] = null;
			}
		}
	};
	
	module.exports = Events;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(271);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(653);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(652);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(651);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(270);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(272);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(26)
	
	/**
	 * Upper case the first character of a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  str = String(str)
	
	  return upperCase(str.charAt(0), locale) + str.substr(1)
	}


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(26)
	var noCase = __webpack_require__(20)
	
	/**
	 * Camel case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale, mergeNumbers) {
	  var result = noCase(value, locale)
	
	  // Replace periods between numeric entities with an underscore.
	  if (!mergeNumbers) {
	    result = result.replace(/ (?=\d)/g, '_')
	  }
	
	  // Replace spaces between words with an upper cased character.
	  return result.replace(/ (.)/g, function (m, $1) {
	    return upperCase($1, locale)
	  })
	}


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(15);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 94 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 95 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 96 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(313);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 214 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(274);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(330);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 217 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(344);


/***/ },
/* 219 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(27);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactInstrumentation = __webpack_require__(18);
	
	var quoteAttributeValueForBrowser = __webpack_require__(392);
	var warning = __webpack_require__(7);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 222 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var LinkedValueUtils = __webpack_require__(68);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(19);
	
	var warning = __webpack_require__(7);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 224 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 225 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(352);
	
	var containsNode = __webpack_require__(289);
	var focusNode = __webpack_require__(94);
	var getActiveElement = __webpack_require__(95);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMLazyTree = __webpack_require__(29);
	var DOMProperty = __webpack_require__(30);
	var React = __webpack_require__(35);
	var ReactBrowserEventEmitter = __webpack_require__(47);
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDOMContainerInfo = __webpack_require__(346);
	var ReactDOMFeatureFlags = __webpack_require__(348);
	var ReactFeatureFlags = __webpack_require__(225);
	var ReactInstanceMap = __webpack_require__(42);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactMarkupChecksum = __webpack_require__(362);
	var ReactReconciler = __webpack_require__(31);
	var ReactUpdateQueue = __webpack_require__(71);
	var ReactUpdates = __webpack_require__(19);
	
	var emptyObject = __webpack_require__(46);
	var instantiateReactComponent = __webpack_require__(236);
	var invariant = __webpack_require__(5);
	var setInnerHTML = __webpack_require__(51);
	var shouldUpdateReactComponent = __webpack_require__(77);
	var warning = __webpack_require__(7);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var React = __webpack_require__(35);
	
	var invariant = __webpack_require__(5);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 230 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 232 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(229);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(11);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  delete inst._wrapperState.valueTracker;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(10);
	
	var ReactCompositeComponent = __webpack_require__(343);
	var ReactEmptyComponent = __webpack_require__(224);
	var ReactHostComponent = __webpack_require__(226);
	
	var getNextDebugID = __webpack_require__(644);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 237 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	var escapeTextContentForBrowser = __webpack_require__(50);
	var setInnerHTML = __webpack_require__(51);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(24);
	var REACT_ELEMENT_TYPE = __webpack_require__(358);
	
	var getIteratorFn = __webpack_require__(389);
	var invariant = __webpack_require__(5);
	var KeyEscapeUtils = __webpack_require__(67);
	var warning = __webpack_require__(7);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(97);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(401);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(242);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          if (this.subscription) this.subscription.tryUnsubscribe();
	          this.initSubscription();
	          if (shouldHandleStateChanges) this.subscription.trySubscribe();
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(243);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(62);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(79);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        props = _objectWithoutProperties(_props, ['replace', 'to']); // eslint-disable-line no-unused-vars
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(28);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(81);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, _ref2) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact;
	    var route = _ref2.route;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        component = _props.component,
	        render = _props.render,
	        children = _props.children;
	
	
	    (0, _warning2.default)(!(component && render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(component && children), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(render && children), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props2 = this.props,
	        children = _props2.children,
	        component = _props2.component,
	        render = _props2.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !Array.isArray(children) || children.length ? // Preact defaults to empty children array
	    _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getNewGoodyOnPurchase = getNewGoodyOnPurchase;
	exports.setCollectedGoodies = setCollectedGoodies;
	exports.setCollectedNewGoodiesAsync = setCollectedNewGoodiesAsync;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(4);
	
	var _getNewGoodyOfPetType = __webpack_require__(613);
	
	var _getNewGoodyOfPetType2 = _interopRequireDefault(_getNewGoodyOfPetType);
	
	var _activeGoodies = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// --- GET NEW GOODY --- //
	
	// Sync
	function setNewGoody(id) {
	  return {
	    type: _constants.SET_NEW_GOODY,
	    payload: {
	      id: id
	    }
	  };
	}
	
	// Get a goody for this specific type of pet.
	
	
	/* eslint-disable import/prefer-default-export */
	function getNewGoodyOnPurchase(petSku) {
	  return function (dispatch, getState) {
	    // Find this pet type.
	    var petType = _lodash2.default.find(_constants.PETS, ['sku', petSku]).type;
	    // Get a new goody for this pet type, if one exists.
	    var newGoodyOfPetType = (0, _getNewGoodyOfPetType2.default)(getState().collectedGoodies.list, petType);
	
	    // If there's a new goody for this pet type, save it and put it on the pet.
	    if (newGoodyOfPetType) {
	      // Add the new goody to the 'new' collection.
	      dispatch(setNewGoody(newGoodyOfPetType.id));
	      // Put the new goody on the pet.
	      dispatch((0, _activeGoodies.setActiveGoodyAsync)(newGoodyOfPetType.type, newGoodyOfPetType.id, { leaveShuffleAlone: true }));
	    }
	  };
	}
	
	// --- COLLECTED GOODIES --- //
	
	function setCollectedGoodies(collectedGoodies) {
	  return {
	    type: _constants.SET_COLLECTED_GOODIES,
	    payload: {
	      collectedGoodies: collectedGoodies
	    }
	  };
	}
	
	// --- NEW COLLECTED GOODIES --- //
	
	function setCollectedNewGoodies(collectedNewGoodies) {
	  return {
	    type: _constants.SET_COLLECTED_NEW_GOODIES,
	    payload: {
	      collectedNewGoodies: collectedNewGoodies
	    }
	  };
	}
	
	function setCollectedNewGoodiesAsync(collectedNewGoodies) {
	  return function (dispatch, getState) {
	    // Only dispatch if they're not equal.
	    if (!_lodash2.default.isEqual(getState().collectedGoodies.newItems, collectedNewGoodies)) {
	      dispatch(setCollectedNewGoodies(collectedNewGoodies));
	    }
	  };
	}

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable quote-props */
	
	exports.updateInAppPurchaseData = updateInAppPurchaseData;
	exports.buyPet = buyPet;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _allPets = __webpack_require__(83);
	
	var _lastVerification = __webpack_require__(423);
	
	var _purchases = __webpack_require__(248);
	
	var _constants = __webpack_require__(4);
	
	var _log = __webpack_require__(56);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _fakeGoogle = __webpack_require__(256);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// --------------------------------------------------------
	// Update in-app purchase data from Google.
	// --------------------------------------------------------
	
	function getPurchases() {
		return new Promise(function (resolve, reject) {
			return resolve(_fakeGoogle.getPurchasesResponse);
	
			// window.google.payments.inapp.getPurchases({
			// 	'parameters': { 'env': 'prod' },
			// 	'success': resolve,
			// 	'failure': reject,
			// });
		});
	}
	
	function getSkuDetails() {
		return new Promise(function (resolve, reject) {
			return resolve(_fakeGoogle.getSkuDetailsResponse);
	
			// window.google.payments.inapp.getSkuDetails({
			// 	'parameters': { 'env': 'prod' },
			// 	'success': resolve,
			// 	'failure': reject,
			// });
		});
	}
	
	function updateInAppPurchaseData() {
		return function (dispatch, getState) {
	
			// Reformat the promise so that it reports whether
			// or not it succeeds without having to rely on .catch()
			var skuDetailsPromise = getSkuDetails().then(function (data) {
				return { status: 'success', data: data };
			}, function (data) {
				return { status: 'error', data: data };
			});
	
			// Same format as described above
			var purchasesPromise = getPurchases().then(function (data) {
				return { status: 'success', data: data };
			}, function (data) {
				return { status: 'error', data: data };
			});
	
			// Wait on both promises. Even if one or both fail,
			// we will get to the `then` block and we can check what
			// the `status` of each was to determine what to do next.
			Promise.all([purchasesPromise, skuDetailsPromise]).then(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    purchasesResponse = _ref2[0],
				    skuDetailsResponse = _ref2[1];
	
				// Since this is fake data from a fake API call,
				// we know it succeeded and we can move on.
				(0, _allPets.setAllPetsAsync)(skuDetailsResponse.data, purchasesResponse.data, dispatch, getState);
				dispatch((0, _lastVerification.setLastVerificationDate)());
	
				// Here's the old error handling mechanism
	
				// Whether or not these API calls succeeded, we'll be here.
				// There are three possible scenarios:
				// 	1. the user is logged into chrome and the responses worked
				// 	2. the user is NOT logged in and both calls failed with TOKEN_MISSING_ERROR
				// 	3. an actual error
				// We can look at the `status` and response objects to decide which of
				// these happened.
	
				// log('initialize -> updateInAppPurchaseData: ', { purchasesResponse, skuDetailsResponse });
	
				// if (purchasesResponse.status === 'error' || skuDetailsResponse.status === 'error') {
				// 	// One or both of these errored. First thing we'll check is
				// 	// whether we've reached the LOGGED_THE_HECK_OUT case where
				// 	// both API calls returned TOKEN_MISSING_ERROR.
				// 	if (
				// 		_.get(purchasesResponse, 'data.response.errorType') === 'TOKEN_MISSING_ERROR' &&
				// 		_.get(skuDetailsResponse, 'data.response.errorType') === 'TOKEN_MISSING_ERROR'
				// 	) {
				// 		// The user is not logged into chrome. We can show the cached
				// 		// products here and the rest will be up to them to initiate,
				// 		// if they decide they want to purchase something.
				// 		log('The user is not logged in');
				// 		setAllPetsAsync(null, null, dispatch, getState);
				// 		dispatch(setLastVerificationDate());
	
				// 	} else if (
				// 		_.get(purchasesResponse, 'data.response.errorType') === 'INVALID_RESPONSE_ERROR' &&
				// 		_.get(skuDetailsResponse, 'data.response.errorType') === 'INVALID_RESPONSE_ERROR' &&
				// 		getState().allPets.length === 1 // The user has never reached the API so they only have Tabby Cat
				// 	) {
				// 		// The user is in a country where payments aren't supported.
				// 		// Dispatch this error so that the PetPicker is hidden.
				// 		console.error('Purchases are not supported in this country.');
				// 		dispatch(setVerificationError(PURCHASES_NOT_SUPPORTED_FOR_COUNTRY));
	
				// 	} else {
				// 		// An error occurred! (#3 in the list above)
				// 		// Let's leave a bit of info in the console...
				// 		console.error('One or both API calls failed. Responses:');
				// 		console.error(skuDetailsResponse, purchasesResponse);
				// 		// ...and since we want to know what happened but don't
				// 		// know which error is meaningful...
				// 		const errorTypes = [
				// 			_.get(purchasesResponse, 'data.response.errorType', 'GET_PURCHASES_SUCCEEDED'),
				// 			_.get(skuDetailsResponse, 'data.response.errorType', 'GET_SKU_DETAILS_SUCCEEDED'),
				// 		];
				// 		// ...join them together with a plus sign.
				// 		dispatch(setVerificationError({
				// 			response: {
				// 				errorType: errorTypes.join(' + '),
				// 			},
				// 		}));
				// 	}
				// } else {
				// 	// It all worked! Let's set the data and move on.
				// 	setAllPetsAsync(skuDetailsResponse.data, purchasesResponse.data, dispatch, getState);
				// 	dispatch(setLastVerificationDate());
				// }
			}).catch(function (err) {
				// Now if we hit this catch it's probably the result of a JS error.
				// Logging it to the console as a last resort.
				console.error(err);
			});
		};
	}
	
	// --------------------------------------------------------
	// Buy a pet.
	// --------------------------------------------------------
	
	function buy(sku) {
		return new Promise(function (resolve, reject) {
			(0, _log2.default)('buy promise sku: ', sku);
			window.google.payments.inapp.buy({
				'parameters': { 'env': 'prod' },
				'sku': sku,
				'success': resolve,
				'failure': reject
			});
		});
	}
	
	// DEVELOPMENT ONLY
	// function getPurchasesAfterBuy() {
	// 	log('getting purchases');
	// 	return new Promise((resolve, reject) => {
	// 		window.google.payments.inapp.getPurchasesAfterBuy({
	// 			'parameters': { 'env': 'prod' },
	// 			'success': resolve,
	// 			'failure': reject,
	// 		});
	// 	});
	// }
	
	function buyPet(sku) {
		return function (dispatch) {
			(0, _log2.default)('This should never happen!');
			return;
	
			(0, _log2.default)('buy pet: ' + sku);
			dispatch((0, _purchases.setPurchaseLoading)(sku, true));
	
			buy(sku).then(function (buyResponse) {
				(0, _log2.default)('buy success: ', buyResponse);
				// return getPurchasesAfterBuy() // DEVELOPMENT ONLY
				// return getPurchases() // GET PURCHASES DOESNT WORK
				// 	.then((purchaseResponse) => {
				// 		onPurchase(sku, purchaseResponse, dispatch);
				// 		log('getPurchases success: ', purchaseResponse);
				// 	})
				// 	.catch((purchaseErr) => {
				// 		dispatch(setVerificationError(purchaseErr));
				// 		dispatch(setPurchaseLoading(sku, false));
				// 		console.error('getPurchases error after buy responded successfully: ', purchaseErr);
				// 	});
				(0, _purchases.onPurchase)(sku, buyResponse, dispatch);
			}).catch(function (buyResponse) {
				console.error('buy error with response: ', buyResponse);
				// return getPurchasesAfterBuy() // DEVELOPMENT ONLY
				getPurchases().then(function (purchasesResponse) {
					(0, _log2.default)('after buy -> getPurchases: ', purchasesResponse);
	
					var isGoogleLyingCount = 0;
	
					function isGoogleLying() {
						setTimeout(function () {
							var itemWasPurchasedSuccessfully = (0, _purchases.checkForSkuPurchase)(sku, purchasesResponse);
							isGoogleLyingCount++;
	
							(0, _log2.default)('after buy -> getPurchases -> itemWasPurchasedSuccessfully ' + isGoogleLyingCount + ': ', itemWasPurchasedSuccessfully);
	
							if (itemWasPurchasedSuccessfully) {
								(0, _purchases.onPurchase)(sku, buyResponse, dispatch, { forceSuccess: true });
							} else {
								if (isGoogleLyingCount > 3) {
									(0, _log2.default)('We checked for the purchase 4 times and it didn’t come back :(');
									(0, _purchases.onPurchase)(sku, buyResponse, dispatch);
									return;
								}
								isGoogleLying();
							}
						}, 500);
					}
	
					isGoogleLying();
				}).catch(function (purchaseErr) {
					console.error('getPurchases error after buy responded with an error: ', purchaseErr);
					(0, _purchases.onPurchase)(sku, buyResponse, dispatch);
				});
			});
		};
	}

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.setPurchaseLoading = setPurchaseLoading;
	exports.setPurchaseSuccess = setPurchaseSuccess;
	exports.setPurchaseFail = setPurchaseFail;
	exports.clearPurchases = clearPurchases;
	exports.onPurchase = onPurchase;
	exports.checkForSkuPurchase = checkForSkuPurchase;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(4);
	
	var _allPets = __webpack_require__(83);
	
	var _collectedGoodies = __webpack_require__(246);
	
	var _log = __webpack_require__(56);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setPurchaseLoading(sku, isLoading) {
		return {
			type: _constants.SET_PURCHASE_LOADING,
			payload: {
				sku: sku,
				isLoading: isLoading
			}
		};
	}
	
	function setPurchaseSuccess(sku) {
		return {
			type: _constants.SET_PURCHASE_SUCCESS,
			payload: {
				sku: sku
			}
		};
	}
	
	function setPurchaseFail(sku) {
		return {
			type: _constants.SET_PURCHASE_FAIL,
			payload: {
				sku: sku
			}
		};
	}
	
	function clearPurchases() {
		return {
			type: _constants.CLEAR_PURCHASES
		};
	}
	
	function onPurchase(sku, buyResponse, dispatch) {
		var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
		    forceSuccess = _ref.forceSuccess;
	
		var successResponse = !!_lodash2.default.get(buyResponse, 'checkoutOrderId') || !!_lodash2.default.get(buyResponse, 'response.orderId') || !!_lodash2.default.get(buyResponse, 'orderId');
		var errorResponse = !!_lodash2.default.get(buyResponse, 'response.errorType');
		var purchaseWasSuccessful = successResponse && !errorResponse;
	
		(0, _log2.default)('actions -> onPurchase -> successResponse: ', successResponse);
		(0, _log2.default)('actions -> onPurchase -> errorResponse: ', errorResponse);
		(0, _log2.default)('actions -> onPurchase -> purchaseWasSuccessful: ', purchaseWasSuccessful);
	
		if (purchaseWasSuccessful || forceSuccess) {
			dispatch(setPurchaseSuccess(sku));
			dispatch((0, _allPets.setPetToCollected)(sku, true));
			dispatch((0, _collectedGoodies.getNewGoodyOnPurchase)(sku));
		} else {
			dispatch(setPurchaseFail(sku));
		}
	}
	
	function checkForSkuPurchase(sku, purchasesResponse) {
		var purchases = _lodash2.default.get(purchasesResponse, 'response.details');
		var skuWasPurchased = !!_lodash2.default.find(purchases, { sku: sku, state: 'ACTIVE' });
	
		return skuWasPurchased;
	}
	
	// # User clicks buy
	// - push this pet to `purchases` { sku: { isLoading: true } }
	// - API.buy(sku) _returns order_id or error_
	// 	- *then* API.getPurchases() _returns list of all purchases_
	// 		- *then* (response) => filter by sku, find the latest one.
	// 			- If state = ACTIVE:
	// 				- push this pet to `collectedPets` _saved_
	// 				- push this pet to `purchases` -> { sku: { isLoading: false, success: true } } _not saved_
	// 			- If state != ACTIVE:
	// 				- push this pet to `purchases` -> { sku: { isLoading: false, error: true, errorState: <state> } } _not saved_
	//
	// # SUCCESS: User gets pet
	// Add success class to pet, but keep it in the list of un-purchased items so that
	// it doesn't re-render. Replace "buy" callback with "setActive" one.
	//
	// _pet LIST should store `collectedPets` only once on componentDidMount._
	// _pet ITEM needs to compare `purchases` to each item, as it does with `activePet`,
	// to apply and remove classes accordingly._
	//
	// # FAIL: User sees error
	// Add error element to PetItem
	//
	// # User closes PetPicker
	// Set `purchases` to empty.

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This is the wrapping background that takes the whole "Friend" object
	// and grabs the bg color and special value to add `bg--color` and `specialName`
	
	var Background = function (_React$Component) {
		_inherits(Background, _React$Component);
	
		function Background(props) {
			_classCallCheck(this, Background);
	
			// this.state = {
			// 	bgColor: props.bgColor,
			// 	name: props.name,
			// };
	
			var _this = _possibleConstructorReturn(this, (Background.__proto__ || Object.getPrototypeOf(Background)).call(this, props));
	
			_this.getClassNames = _this.getClassNames.bind(_this);
			return _this;
		}
	
		_createClass(Background, [{
			key: 'getClassNames',
			value: function getClassNames() {
				var classes = ['bg--' + this.props.bgColor, _lodash2.default.get(this.props.name, 'special')];
	
				return (0, _classnames2.default)(classes);
			}
		}, {
			key: 'render',
			value: function render() {
				var styles = {
					height: '100vh',
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					overflow: 'hidden'
				};
	
				return _react2.default.createElement(
					'div',
					{ style: styles, className: this.getClassNames() },
					this.props.children
				);
			}
		}]);
	
		return Background;
	}(_react2.default.Component);
	
	Background.defaultProps = {
		bgColor: 'light-blue'
	};
	
	exports.default = Background;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This is a higher order component to use with goodies that are positioned relative to the animal.
	// ie. _Glasses.js
	
	// --- 1. Import your goodies.
	
	// import Raybans from './Raybans.js';
	// ...
	
	
	// --- 2. Add them to your options object.
	
	// let glassesOptions = {
	// 	Raybans,
	// 	...
	// };
	
	var PositionedGoodyParentHOC = function (_React$Component) {
		_inherits(PositionedGoodyParentHOC, _React$Component);
	
		function PositionedGoodyParentHOC(props) {
			_classCallCheck(this, PositionedGoodyParentHOC);
	
			var _this = _possibleConstructorReturn(this, (PositionedGoodyParentHOC.__proto__ || Object.getPrototypeOf(PositionedGoodyParentHOC)).call(this, props));
	
			_this.state = {
				goodyMarkerCoords: {}
			};
	
			_this.getMarkerCoords = _this.getMarkerCoords.bind(_this);
			return _this;
		}
	
		_createClass(PositionedGoodyParentHOC, [{
			key: 'getMarkerCoords',
			value: function getMarkerCoords(markerElement) {
				if (!markerElement) {
					return;
				}
	
				this.setState({ goodyMarkerCoords: {
						y: markerElement.cy.baseVal.value,
						x: markerElement.cx.baseVal.value
					} });
			}
		}, {
			key: 'getPosition',
			value: function getPosition() {
				if (_lodash2.default.isEmpty(this.props.targetCoords) || _lodash2.default.isEmpty(this.state.goodyMarkerCoords)) {
					return {
						x: 0,
						y: 0
					};
				}
	
				return {
					x: this.props.targetCoords.x - this.state.goodyMarkerCoords.x,
					y: this.props.targetCoords.y - this.state.goodyMarkerCoords.y
				};
			}
	
			// --- 3. Add this to your goody and replace glasses with your type...
	
			// render() {
			// 	let Goody = glassesOptions[this.props.glasses];
			//
			// 	return (
			// 		<svg ref={POSITIONED_GOODY_REFS.GOODY_CONTAINER} {...this.getPosition()}>
			// 			<Glasses getMarkerCoords={this.getMarkerCoords} />
			// 		</svg>
			// 	);
			// }
	
		}]);
	
		return PositionedGoodyParentHOC;
	}(_react2.default.Component);
	
	exports.default = PositionedGoodyParentHOC;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Arrow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Arrow() {
		return _react2.default.createElement(
			"div",
			{ className: "arrow" },
			_react2.default.createElement(
				"svg",
				{ className: "arrow-svg", version: "1.1", x: "0px", y: "0px", viewBox: "0 0 40 40" },
				_react2.default.createElement("polygon", { points: "32.0214844,19.1591797 23,28.1799316 23,0 17,0 17,28.1796875 7.9794922,19.1591797 3.7363281,23.4013672 20,39.6660156 36.2636719,23.4013672 " })
			)
		);
	}

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseSectionBookend = function (_React$Component) {
		_inherits(BaseSectionBookend, _React$Component);
	
		function BaseSectionBookend() {
			_classCallCheck(this, BaseSectionBookend);
	
			var _this = _possibleConstructorReturn(this, (BaseSectionBookend.__proto__ || Object.getPrototypeOf(BaseSectionBookend)).call(this));
	
			_this.state = {
				buttonHover: false,
				textIsHidden: true
			};
	
			_this.hoverOnButton = _this.hoverOnButton.bind(_this);
			_this.hoverOffButton = _this.hoverOffButton.bind(_this);
	
			_this.wayPointEntered = _this.wayPointEntered.bind(_this);
			return _this;
		}
	
		_createClass(BaseSectionBookend, [{
			key: 'hoverOnButton',
			value: function hoverOnButton() {
				this.setState({ buttonHover: true });
			}
		}, {
			key: 'hoverOffButton',
			value: function hoverOffButton() {
				this.setState({ buttonHover: false });
			}
		}, {
			key: 'wayPointEntered',
			value: function wayPointEntered() {
				this.setState({ textIsHidden: false });
			}
		}, {
			key: 'getClassNames',
			value: function getClassNames() {
				var classes = ['contents--centered'];
	
				if (this.state.textIsHidden) {
					classes.push('is-hidden');
				}
	
				return (0, _classnames2.default)(classes);
			}
		}]);
	
		return BaseSectionBookend;
	}(_react2.default.Component);
	
	exports.default = BaseSectionBookend;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-tag-spacing */
	
	var KittenInTab = function (_PetHOC) {
		_inherits(KittenInTab, _PetHOC);
	
		function KittenInTab(props) {
			_classCallCheck(this, KittenInTab);
	
			var _this = _possibleConstructorReturn(this, (KittenInTab.__proto__ || Object.getPrototypeOf(KittenInTab)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(500, 6000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 3000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 199;
						}
					}
				}],
				pet: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(600, 1200);
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(KittenInTab, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.beingPet === nextProps.beingPet) {
					// If this prop is already applied, return.
					return;
				}
	
				if (nextProps.beingPet) {
					this.startBeingPet();
				} else {
					this.stopBeingPet();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var styles = {
					svg: {
						enableBackground: 'new 0 0 110 95'
					}
				};
	
				return _react2.default.createElement(
					'div',
					{
						onMouseEnter: this.startBeingPet,
						onMouseLeave: this.stopBeingPet,
						className: 'cat-wrapper' },
					_react2.default.createElement(
						'svg',
						{ className: this.getClassNames() + ' heart', style: styles.svg, version: '1.1', xmlns: 'http://www.w3.org/2000/svg', x: '0px', y: '0px', viewBox: '0 0 110 95' },
						_react2.default.createElement(
							'g',
							{ className: 'heart-x-wrapper' },
							_react2.default.createElement(
								'g',
								{ className: 'heart-y-wrapper' },
								_react2.default.createElement('path', { fill: '#fc7e7e', d: 'M55,30.5421677c0-2.2242432,3.2366257-5.750782,7.2292061-5.750782 s7.2292061,3.7475796,7.2292061,7.0688534C69.4584122,40.839592,55,49.2948608,55,49.2948608 S40.5415878,40.839592,40.5415878,31.860239c0-3.3212738,3.2366257-7.0688534,7.2292061-7.0688534S55,28.3179245,55,30.5421677z' })
							)
						)
					),
					_react2.default.createElement(
						'svg',
						{ className: this.getClassNames(), style: styles.svg, version: '1.1', xmlns: 'http://www.w3.org/2000/svg', x: '0px', y: '0px', viewBox: '0 0 110 95' },
						_react2.default.createElement('path', { className: 'fill', d: 'M108.0690308,59.8454437c0.4884949-13.741478-2.944664-42.9283447-7.824295-54.7815857 c-1.2200699-3.8865795-6.1605606-6.1623039-9.497673-3.5111153l-0.0000381,0.000037 c-6.3918457,3.6962204-14.2641602,9.6724939-20.5303192,15.4488993 c-4.8372269-1.3831635-9.9633408-2.1468201-15.2732277-2.1468201c-5.2785492,0-10.375473,0.7548504-15.1875801,2.1225491 c-6.2619019-5.768858-14.1213436-11.7336245-20.5041962-15.4246283v-0.000037 c-3.3371105-2.6511884-8.2776012-0.3754642-9.4977121,3.5111153c-4.85532,11.7941914-8.277194,40.7445602-7.8300261,54.5699883 c-0.0044398,0.0956802-0.0100267,0.1913567-0.0136526,0.2870369l0.2430454,5.4813385 c0.1697876,1.2737579,0.4207506,2.5011978,0.7440834,3.685936l1.977181,5.090004 c0.6899538,1.3389511,1.4912009,2.6082687,2.3978572,3.8081818l3.6963687,4.0227356 c9.5384836,8.6259766,25.6744537,12.583519,43.9746323,12.583519c17.9594154,0,33.8327675-3.812767,43.4333-12.1077194 l3.8032913-3.9344177c1.011734-1.2689514,1.9023743-2.6184082,2.664917-4.0482635l2.0485916-5.0656586 c0.3773499-1.3129425,0.6619415-2.6806793,0.8482666-4.1044617L108.0690308,59.8454437z' }),
						_react2.default.createElement('path', { className: 'fill--face', d: 'M55.7324333,62.4954071c-0.9384651-0.0286217-1.5967026-0.3171959-2.0271797-0.8180275 l-3.1361694-3.6441574c-0.4889069-0.5699959-0.5962296-1.2735443-0.2945366-1.9293976 c0.3481979-0.760788,1.1793442-1.2496986,2.1154251-1.2496986h6.2794876c0.9336967,0,1.762455,0.4889107,2.1130409,1.2449265 c0.3028831,0.6534691,0.1991386,1.3546371-0.2826157,1.9198608l-3.1659775,3.6727753 c-0.4316711,0.493679-1.0922928,0.7774849-1.8077698,0.7774849L55.7324333,62.4954071z' }),
						_react2.default.createElement(
							'g',
							{ className: 'eyes' },
							_react2.default.createElement('ellipse', { className: 'fill--face', cx: '75.9827805', cy: '43.2129059', rx: '5.589057', ry: '6.1697845' }),
							_react2.default.createElement('ellipse', { className: 'fill--face', cx: '34.8882446', cy: '43.2129059', rx: '5.5878644', ry: '6.1697845' })
						),
						_react2.default.createElement(
							'g',
							{ className: 'eyes--blink' },
							_react2.default.createElement('path', { className: 'fill--face', d: 'M40.5786324,49.0388565c-0.1149864,0-0.2314301-0.0105515-0.3486023-0.0327492 l-11.3764019-2.1534538c-1.0108643-0.1914024-1.675312-1.1662407-1.4839115-2.1771049 c0.1914024-1.0112267,1.1651497-1.6745834,2.1767426-1.4842758l11.3764038,2.1534538 c1.0108643,0.1914024,1.675312,1.1662407,1.4839096,2.1771049 C42.2379341,48.4158897,41.4563141,49.0388565,40.5786324,49.0388565z' }),
							_react2.default.createElement('path', { className: 'fill--face', d: 'M70.2923965,49.0389061c-0.8776855,0-1.6593018-0.6229668-1.8281479-1.517025 c-0.1913986-1.0108643,0.4730453-1.9857025,1.4839096-2.1771049l11.3764038-2.1534538 c1.0108643-0.1906738,1.9860687,0.4730453,2.1767426,1.4842758c0.1914062,1.0108643-0.4730453,1.9857025-1.4839096,2.1771049 l-11.3764038,2.1534538C70.523819,49.0283508,70.4073792,49.0389061,70.2923965,49.0389061z' })
						),
						_react2.default.createElement(
							'g',
							{ className: 'eyes--is-being-pet--likes' },
							_react2.default.createElement('path', { className: 'fill--face', d: 'M40.3782349,48.9296188c-0.4488602,0-0.8984489-0.161705-1.2552185-0.4894714 c-0.6823616-0.6265221-2.1558495-1.3353462-4.2457085-1.4452057c-2.0884094-0.1058731-3.6293354,0.4412498-4.3733311,0.9934425 c-0.8244858,0.61166-1.9861641,0.4387131-2.5967331-0.3839607c-0.6112938-0.8230362-0.439436-1.9858017,0.3836002-2.5970955 c1.6591244-1.2320175,4.1217079-1.8603516,6.7808037-1.7200394c2.6496696,0.1392288,5.0419121,1.0209999,6.5632591,2.419075 c0.7548714,0.6935997,0.8049088,1.8679657,0.1109467,2.6228371 C41.3796577,48.7276688,40.8800354,48.9296188,40.3782349,48.9296188z' }),
							_react2.default.createElement('path', { className: 'fill--face', d: 'M70.4927902,48.9296188c0.4488602,0,0.8984528-0.161705,1.2552185-0.4894714 c0.6823578-0.6265221,2.1558456-1.3353462,4.2457047-1.4452057c2.0884094-0.1058731,3.6293411,0.4412498,4.3733368,0.9934425 c0.8244858,0.61166,1.9861603,0.4387131,2.5967331-0.3839607c0.61129-0.8230362,0.4394302-1.9858017-0.383606-2.5970955 c-1.6591187-1.2320175-4.1217041-1.8603516-6.7807999-1.7200394c-2.6496658,0.1392288-5.0419159,1.0209999-6.5632629,2.419075 c-0.7548676,0.6935997-0.8049011,1.8679657-0.1109467,2.6228371 C69.4913635,48.7276688,69.9909897,48.9296188,70.4927902,48.9296188z' })
						)
					)
				);
			}
		}]);
	
		return KittenInTab;
	}(_PetHOC3.default);
	
	exports.default = KittenInTab;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getCollectedPetTypes;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCollectedPetTypes(pets) {
		return _lodash2.default.chain(pets).filter('isCollected').map(function (pet) {
			return pet.petType;
		}).value();
	}

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getCollectedPets;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCollectedPets(pets) {
		return _lodash2.default.filter(pets, 'isCollected');
	}

/***/ },
/* 256 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/* eslint-disable quotes, quote-props, comma-dangle */
	
	// mock reponses for the google payments API
	
	var getPurchasesAfterBuyResponse = {
		"response": {
			"details": [
				// {
				// 	"kind": "chromewebstore#payment",
				// 	"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				// 	"sku": "dog_classicdoggo",
				// 	"createdTime": "1387221267247",
				// 	"state": "PAYMENT_REJECTED",
				// },
				// {
				// 	"kind": "chromewebstore#payment",
				// 	"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				// 	"sku": "dog_classicdoggo",
				// 	"createdTime": "1387221267249",
				// 	"state": "ACTIVE"
				// },
				// {
				// 	"kind": "chromewebstore#payment",
				// 	"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				// 	"sku": "dog_classicdoggo",
				// 	"createdTime": "1387221267248",
				// 	"state": "PAYMENT_REJECTED",
				// },
			]
		}
	};
	
	var getPurchasesResponse = exports.getPurchasesResponse = {
		"response": {
			"details": [{
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "dog_lildoggo",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			}, {
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "penguin_tuxedobird",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			}, {
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "wildcat_leopard",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			}, {
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "dog_classicdoggo",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			}, {
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "bear_bear",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			}, {
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "dog_classicdoggo",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			}, {
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "turtle_tortoise",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			}, {
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "chicken_chicken",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			}, {
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "seal_seal",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			}, {
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "bunny_bunny",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			}, {
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "pig_pig",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			}]
		}
	};
	
	var getPurchasesErrorResponse = {
		"request": {},
		"response": {
			"errorType": "TOKEN_MISSING_ERROR"
		}
	};
	
	var getSkuDetailsResponse = exports.getSkuDetailsResponse = {
		"response": {
			"details": {
				"kind": "chromewebstore#inAppProductList",
				"inAppProducts": [{
					"kind": "chromewebstore#inAppProduct",
					"sku": "dog_lildoggo",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [{
						"valueMicros": "1000000",
						"currencyCode": "USD",
						"regionCode": "US"
					}],
					"localeData": [{
						"title": "Lil Doggo",
						"description": "",
						"languageCode": "en-US"
					}]
				}, {
					"kind": "chromewebstore#inAppProduct",
					"sku": "penguin_tuxedobird",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [{
						"valueMicros": "1000000",
						"currencyCode": "USD",
						"regionCode": "US"
					}],
					"localeData": [{
						"title": "Tuxedo Birb",
						"description": "",
						"languageCode": "en-US"
					}]
				}, {
					"kind": "chromewebstore#inAppProduct",
					"sku": "wildcat_leopard",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [{
						"valueMicros": "1000000",
						"currencyCode": "USD",
						"regionCode": "US"
					}],
					"localeData": [{
						"title": "Wild Kitty",
						"description": "",
						"languageCode": "en-US"
					}]
				}, {
					"kind": "chromewebstore#inAppProduct",
					"sku": "bear_bear",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [{
						"valueMicros": "1000000",
						"currencyCode": "USD",
						"regionCode": "US"
					}],
					"localeData": [{
						"title": "Bear Cub",
						"description": "",
						"languageCode": "en-US"
					}]
				}, {
					"kind": "chromewebstore#inAppProduct",
					"sku": "turtle_tortoise",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [{
						"valueMicros": "1000000",
						"currencyCode": "USD",
						"regionCode": "US"
					}],
					"localeData": [{
						"title": "Tortoise",
						"description": "",
						"languageCode": "en-US"
					}]
				}, {
					"kind": "chromewebstore#inAppProduct",
					"sku": "dog_classicdoggo",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [{
						"valueMicros": "1000000",
						"currencyCode": "USD",
						"regionCode": "US"
					}],
					"localeData": [{
						"title": "Classic Doggo",
						"description": "",
						"languageCode": "en-US"
					}]
				}, {
					"kind": "chromewebstore#inAppProduct",
					"sku": "chicken_chicken",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [{
						"valueMicros": "1000000",
						"currencyCode": "USD",
						"regionCode": "US"
					}],
					"localeData": [{
						"title": "Chicken Birb",
						"description": "",
						"languageCode": "en-US"
					}]
				}, {
					"kind": "chromewebstore#inAppProduct",
					"sku": "seal_seal",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [{
						"valueMicros": "1000000",
						"currencyCode": "USD",
						"regionCode": "US"
					}],
					"localeData": [{
						"title": "Squishy Seal",
						"description": "",
						"languageCode": "en-US"
					}]
				}, {
					"kind": "chromewebstore#inAppProduct",
					"sku": "bunny_bunny",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [{
						"valueMicros": "1000000",
						"currencyCode": "USD",
						"regionCode": "US"
					}],
					"localeData": [{
						"title": "Bunny Rabbit",
						"description": "",
						"languageCode": "en-US"
					}]
				}, {
					"kind": "chromewebstore#inAppProduct",
					"sku": "pig_pig",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [{
						"valueMicros": "1000000",
						"currencyCode": "USD",
						"regionCode": "US"
					}],
					"localeData": [{
						"title": "Tubby Piggy",
						"description": "",
						"languageCode": "en-US"
					}]
				}]
			}
		}
	};
	
	var getSkuDetailsErrorResponse = {
		"request": {},
		"response": {
			"errorType": "TOKEN_MISSING_ERROR"
		}
	};
	
	var onPurchase = {
		"jwt": "eyJhb...0oFuU",
		"request": {
			"cartId": "00000000000000000000.0000000000000000000"
		},
		"response": {
			"orderId": "00000000000000000000.0000000000000000000"
		},
		"checkoutOrderId": "10370910874874185126.d82d0d67c1e44407a5a54e855bf58ace"
	};
	
	var onPurchaseFail = {
		"response": {
			"error": 'The API call for buy failed',
			"errorType": 'api_fail'
		}
	};
	
	function getSkuDetails(_ref) {
		var parameters = _ref.parameters,
		    success = _ref.success,
		    failure = _ref.failure;
	
		// success handler
		setTimeout(function () {
			return success(getSkuDetailsResponse);
		}, 1000);
		// error handler
		setTimeout(function () {
			return failure(getSkuDetailsErrorResponse);
		}, 1000);
	}
	
	function getPurchases(_ref2) {
		var parameters = _ref2.parameters,
		    success = _ref2.success,
		    failure = _ref2.failure;
	
		// success handler
		setTimeout(function () {
			return success(getPurchasesResponse);
		}, 1000);
		// error handler
		setTimeout(function () {
			return failure(getPurchasesErrorResponse);
		}, 1000);
	}
	
	// DEVELOPMENT Only
	function getPurchasesAfterBuy(_ref3) {
		var parameters = _ref3.parameters,
		    success = _ref3.success,
		    failure = _ref3.failure;
	
		// success handler
		setTimeout(function () {
			return success(getPurchasesAfterBuyResponse);
		}, 1000);
		// error handler
		setTimeout(function () {
			return failure(getPurchasesErrorResponse);
		}, 1000);
	}
	// DEVELOPMENT Only
	
	function buy(_ref4) {
		var parameters = _ref4.parameters,
		    sku = _ref4.sku,
		    success = _ref4.success,
		    failure = _ref4.failure;
	
		// success handler
		setTimeout(function () {
			return success(onPurchase);
		}, 1000);
		// error handler
		setTimeout(function () {
			return failure(onPurchaseFail);
		}, 1000);
	}
	
	// const google = {
	// 	payments: {
	// 		inapp: {
	// 			getSkuDetails,
	// 			getPurchases,
	// 			getPurchasesAfterBuy,
	// 			buy,
	// 		},
	// 	},
	// };
	
	// window.google = google;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _log = __webpack_require__(56);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Functions for saving extension data to storage.
	var css = 'color: #f08668; font-weight: bold; font-size: 12px';
	
	function visits(newState) {
		// local
		(0, _log2.default)('%csave visits \n', css, newState.visits);
		window.localStorage.setItem('visits', JSON.stringify(newState.visits));
	}
	
	function lastVerification(newState) {
		// local
		(0, _log2.default)('%csave lastVerification \n', css, newState.lastVerification);
		window.localStorage.setItem('lastVerification', JSON.stringify(newState.lastVerification));
	}
	
	function allPets(newState) {
		// local
		(0, _log2.default)('%csave allPets \n', css, newState.allPets);
		window.localStorage.setItem('allPets', JSON.stringify(newState.allPets));
	}
	
	function activePet(newState) {
		// local
		var activePetAttributesToSave = {
			shuffle: newState.activePet.shuffle,
			active: {
				petType: newState.activePet.active.petType
			}
		};
	
		(0, _log2.default)('%csave activePet \n', css, activePetAttributesToSave);
		window.localStorage.setItem('activePet', JSON.stringify(activePetAttributesToSave));
	}
	
	function collectedGoodies(newState) {
		// sync & local
		window.chrome.storage.sync.get('collectedGoodies', function (storageResponse) {
	
			var syncedGoodies = storageResponse.collectedGoodies;
			var reduxGoodies = newState.collectedGoodies.list;
	
			var cumulative = _lodash2.default.union(syncedGoodies, reduxGoodies);
			var cumulativeWhole = { newItems: _lodash2.default.get(newState.collectedGoodies, 'newItems'), list: cumulative };
	
			var newRedux = _lodash2.default.difference(reduxGoodies, syncedGoodies);
			var newSync = _lodash2.default.difference(syncedGoodies, reduxGoodies);
	
			// Case INIT - Sync isn't defined yet. Save storage to sync.
			if (_lodash2.default.isEmpty(storageResponse)) {
				(0, _log2.default)('CASE 0');
				// Save storage to sync.
				window.chrome.storage.sync.set({ 'collectedGoodies': newState.collectedGoodies.list }, function () {
					(0, _log2.default)('CASE 0: sync.set: ', newState.collectedGoodies.list);
				});
				// TRIP OVER
			}
	
			// Case 1 - Sync and Redux are equal. Just update local.
			else if (_lodash2.default.isEqual(syncedGoodies, reduxGoodies)) {
					(0, _log2.default)('CASE 1');
					// TRIP OVER
				}
	
				// Case 2 - Redux has new goodies. Update sync and local with cumulative.
				else if (!_lodash2.default.isEmpty(newRedux) && _lodash2.default.isEmpty(newSync)) {
						(0, _log2.default)('CASE 2');
						// save cumulativeWhole to sync
						window.chrome.storage.sync.set({ 'collectedGoodies': cumulative }, function () {
							(0, _log2.default)('CASE 2: sync.set: ', cumulative);
						});
						// TRIP OVER
					}
	
					// Case 3 - Sync has new goodies. Update Local with cumulative.
					else if (_lodash2.default.isEmpty(newRedux) && !_lodash2.default.isEmpty(newSync)) {
							(0, _log2.default)('CASE 3');
							// 2ND TRIP ON NEXT REFRESH -->
						}
	
						// Case 4 - Both Redux and Sync have new goodies.
						// Update local with cumulative. Sync will get set on second trip.
						else if (!_lodash2.default.isEmpty(newRedux) && !_lodash2.default.isEmpty(newSync)) {
								(0, _log2.default)('CASE 4');
								// 2ND TRIP ON NEXT REFRESH -->
							}
	
			(0, _log2.default)('%csave collectedGoodies \n', css, newState.collectedGoodies);
			// Save to local no matter what.
			window.localStorage.setItem('collectedGoodies', JSON.stringify(cumulativeWhole));
		});
	}
	
	function activeGoodies(newState) {
		// local
		(0, _log2.default)('%csave activeGoodies \n', css, newState.activeGoodies);
		window.localStorage.setItem('activeGoodies', JSON.stringify(newState.activeGoodies));
	}
	
	exports.default = {
		visits: visits,
		lastVerification: lastVerification,
		activePet: activePet,
		allPets: allPets,
		activeGoodies: activeGoodies,
		collectedGoodies: collectedGoodies
	};

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _shopifyBuy = __webpack_require__(656);
	
	var _shopifyBuy2 = _interopRequireDefault(_shopifyBuy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shopClient = _shopifyBuy2.default.buildClient({
		accessToken: '9f0c39c7df29337f1971cf4231b3835a',
		domain: 'tabby-cat.myshopify.com',
		appId: '6'
	});
	
	var getFeaturedStickers = new Promise(function (resolve, reject) {
		shopClient.fetchQueryProducts({ collection_id: 154704937047, sort_by: 'collection-default' }).then(function (productsFromShopify) {
			resolve(productsFromShopify);
		}).catch(function (err) {
			reject('Oops, couldn\'t get stickers. Error: ' + err);
		});
	});
	
	var getCatStickers = new Promise(function (resolve, reject) {
		shopClient.fetchQueryProducts({ collection_id: 154704052311, sort_by: 'collection-default' }).then(function (productsFromShopify) {
			resolve(productsFromShopify);
		}).catch(function (err) {
			reject('Oops, couldn\'t get stickers. Error: ' + err);
		});
	});
	
	var getPetStickers = new Promise(function (resolve, reject) {
		shopClient.fetchQueryProducts({ collection_id: 154704183383, sort_by: 'collection-default' }).then(function (productsFromShopify) {
			resolve(productsFromShopify);
		}).catch(function (err) {
			reject('Oops, couldn\'t get stickers. Error: ' + err);
		});
	});
	
	var getCurrentStock = new Promise(function (resolve, reject) {
		shopClient.fetchQueryProducts({ collection_id: 153771376727, sort_by: 'collection-default' }).then(function (productsFromShopify) {
			resolve(productsFromShopify);
		}).catch(function (err) {
			reject('Oops, couldn\'t get stickers. Error: ' + err);
		});
	});
	
	var getStickers = new Promise(function (resolve, reject) {
		shopClient.fetchQueryProducts({ collection_id: 421045844, sort_by: 'collection-default' }).then(function (productsFromShopify) {
			resolve(productsFromShopify);
		}).catch(function (err) {
			reject('Oops, couldn\'t get stickers. Error: ' + err);
		});
	});
	
	var getMagnets = new Promise(function (resolve, reject) {
		shopClient.fetchQueryProducts({ collection_id: 421045588, sort_by: 'collection-default' }).then(function (productsFromShopify) {
			resolve(productsFromShopify);
		}).catch(function (err) {
			reject('Oops, couldn\'t get magnets. Error: ' + err);
		});
	});
	
	var getCart = new Promise(function (resolve, reject) {
		if (localStorage.getItem('lastCartId')) {
			shopClient.fetchCart(localStorage.getItem('lastCartId')).then(function (remoteCart) {
				resolve(remoteCart);
			}).catch(function (err) {
				reject('Oops, couldn\'t get the remote cart. Error: ' + err);
			});
		} else {
			shopClient.createCart().then(function (newCart) {
				resolve(newCart);
				localStorage.setItem('lastCartId', newCart.id);
			}).catch(function (err) {
				reject('There was a problem creating the cart. ' + err);
			});
		}
	});
	
	function clearLocalCart() {
		localStorage.removeItem('lastCartId');
	}
	
	module.exports = {
		getFeaturedStickers: getFeaturedStickers,
		getCatStickers: getCatStickers,
		getPetStickers: getPetStickers,
		getCurrentStock: getCurrentStock,
		getStickers: getStickers,
		getMagnets: getMagnets,
		getCart: getCart,
		clearLocalCart: clearLocalCart
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _getGoodiesOfType = __webpack_require__(610);
	
	var _getGoodiesOfType2 = _interopRequireDefault(_getGoodiesOfType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shuffleGoodyOfType(collectedGoodies, type) {
		var collectedGoodiesOfType = (0, _getGoodiesOfType2.default)(collectedGoodies, type);
	
		if (_lodash2.default.isEmpty(collectedGoodiesOfType)) {
			return null;
		}
	
		return collectedGoodiesOfType[_lodash2.default.random(collectedGoodiesOfType.length * 2)];
	}
	
	function shuffleActiveGoodies(collectedGoodies) {
		return {
			glasses: shuffleGoodyOfType(collectedGoodies, 'glasses'),
			hat: shuffleGoodyOfType(collectedGoodies, 'hat'),
			toy: shuffleGoodyOfType(collectedGoodies, 'toy')
		};
	}
	
	exports.default = shuffleActiveGoodies;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shuffleActivePetType(collectedPets) {
		if (_lodash2.default.isUndefined(collectedPets) || _lodash2.default.isEmpty(collectedPets)) {
			return null;
		}
	
		var randomPet = collectedPets[_lodash2.default.random(collectedPets.length - 1)];
	
		return randomPet;
	}
	
	exports.default = shuffleActivePetType;

/***/ },
/* 261 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Tell the browser that the event listener won't prevent a scroll.
	 * Allowing the browser to continue scrolling without having to
	 * to wait for the listener to return.
	 */
	var addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
	    var supportsPassiveOption = function () {
	        var supportsPassiveOption = false;
	        try {
	            var opts = Object.defineProperty({}, 'passive', {
	                get: function get() {
	                    supportsPassiveOption = true;
	                }
	            });
	            window.addEventListener('test', null, opts);
	        } catch (e) {}
	        return supportsPassiveOption;
	    }();
	
	    target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
	};
	
	module.exports = addPassiveEventListener;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var addPassiveEventListener = __webpack_require__(261);
	
	var eventThrottler = function eventThrottler(eventHandler) {
	  var eventHandlerTimeout;
	  return function (event) {
	    // ignore events as long as an eventHandler execution is in the queue
	    if (!eventHandlerTimeout) {
	      eventHandlerTimeout = setTimeout(function () {
	        eventHandlerTimeout = null;
	        eventHandler(event);
	        // The eventHandler will execute at a rate of 15fps
	      }, 66);
	    }
	  };
	};
	
	var scrollSpy = {
	
	  spyCallbacks: [],
	  spySetState: [],
	  scrollSpyContainers: [],
	
	  mount: function mount(scrollSpyContainer) {
	    var t = this;
	    if (scrollSpyContainer) {
	      var eventHandler = eventThrottler(function (event) {
	        t.scrollHandler(scrollSpyContainer);
	      });
	      this.scrollSpyContainers.push(scrollSpyContainer);
	      addPassiveEventListener(scrollSpyContainer, 'scroll', eventHandler);
	    }
	  },
	
	  isMounted: function isMounted(scrollSpyContainer) {
	    return this.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
	  },
	
	  currentPositionY: function currentPositionY(scrollSpyContainer) {
	    if (scrollSpyContainer === document) {
	      var supportPageOffset = window.pageXOffset !== undefined;
	      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
	      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
	    } else {
	      return scrollSpyContainer.scrollTop;
	    }
	  },
	
	  scrollHandler: function scrollHandler(scrollSpyContainer) {
	    var callbacks = this.scrollSpyContainers[this.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks;
	    if (callbacks) {
	      for (var i = 0; i < callbacks.length; i++) {
	        var position = this.currentPositionY(scrollSpyContainer);
	        callbacks[i](this.currentPositionY(scrollSpyContainer));
	      }
	    }
	  },
	
	  addStateHandler: function addStateHandler(handler) {
	    this.spySetState.push(handler);
	  },
	
	  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
	    var container = this.scrollSpyContainers[this.scrollSpyContainers.indexOf(scrollSpyContainer)];
	    if (!container.spyCallbacks) {
	      container.spyCallbacks = [];
	    }
	    container.spyCallbacks.push(handler);
	  },
	
	  updateStates: function updateStates() {
	    var length = this.spySetState.length;
	
	    for (var i = 0; i < length; i++) {
	      this.spySetState[i]();
	    }
	  },
	
	  unmount: function unmount(stateHandler, spyHandler) {
	    for (var i = 0; i < this.scrollSpyContainers.length; i++) {
	      var callbacks = this.scrollSpyContainers[i].spyCallbacks;
	      if (callbacks && callbacks.length) {
	        callbacks.splice(callbacks.indexOf(spyHandler), 1);
	      }
	    }
	
	    if (this.spySetState && this.spySetState.length) {
	      this.spySetState.splice(this.spySetState.indexOf(stateHandler), 1);
	    }
	
	    document.removeEventListener('scroll', this.scrollHandler);
	  },
	
	  update: function update() {
	    for (var i = 0; i < this.scrollSpyContainers.length; i++) {
	      this.scrollHandler(this.scrollSpyContainers[i]);
	    }
	  }
	};
	
	module.exports = scrollSpy;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(10);
	
	var animateScroll = __webpack_require__(88);
	var events = __webpack_require__(89);
	
	var __mapped = {};
	var __activeLink;
	
	module.exports = {
	
	  unmount: function unmount() {
	    __mapped = {};
	  },
	
	  register: function register(name, element) {
	    __mapped[name] = element;
	  },
	
	  unregister: function unregister(name) {
	    delete __mapped[name];
	  },
	
	  get: function get(name) {
	    return __mapped[name] || document.getElementById(name);
	  },
	
	  setActiveLink: function setActiveLink(link) {
	    __activeLink = link;
	  },
	
	  getActiveLink: function getActiveLink() {
	    return __activeLink;
	  },
	
	  scrollTo: function scrollTo(to, props) {
	
	    /*
	    * get the mapped DOM element
	    */
	
	    var target = this.get(to);
	
	    if (!target) {
	      console.warn("target Element not found");
	      return;
	    }
	
	    props = assign({}, props, { absolute: false });
	
	    if (events.registered['begin']) {
	      events.registered['begin'](to, target);
	    }
	
	    var containerId = props.containerId;
	    var container = props.container;
	
	    var containerElement;
	
	    if (containerId) {
	      containerElement = document.getElementById(containerId);
	    } else if (container && container.nodeType) {
	      containerElement = container;
	    } else {
	      containerElement = null;
	    }
	
	    var scrollOffset;
	
	    if ((containerId || container) && containerElement) {
	      props.absolute = true;
	      if (containerElement !== target.offsetParent) {
	        if (!containerElement.contains(target)) {
	          throw new Error('Container with ID ' + (containerId || container) + ' is not a parent of target ' + to);
	        } else {
	          throw new Error('Container with ID ' + (containerId || container) + ' is not a positioned element');
	        }
	      }
	
	      scrollOffset = target.offsetTop;
	    } else {
	      var coordinates = target.getBoundingClientRect();
	      scrollOffset = coordinates.top;
	    }
	
	    scrollOffset += props.offset || 0;
	
	    /*
	     * if animate is not provided just scroll into the view
	     */
	    if (!props.smooth) {
	      if ((containerId || container) && containerElement) {
	        containerElement.scrollTop = scrollOffset;
	      } else {
	        // window.scrollTo accepts only absolute values so body rectangle needs to be subtracted
	        var bodyRect = document.body.getBoundingClientRect();
	        window.scrollTo(0, scrollOffset - bodyRect.top);
	      }
	
	      if (events.registered['end']) {
	        events.registered['end'](to, target);
	      }
	
	      return;
	    }
	
	    /*
	     * Animate scrolling
	     */
	
	    animateScroll.animateTopScroll(scrollOffset, props, to, target);
	  }
	};

/***/ },
/* 264 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  above: 'above',
	  inside: 'inside',
	  below: 'below',
	  invisible: 'invisible'
	};
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45),
	    _assign = __webpack_require__(10);
	
	var ReactNoopUpdateQueue = __webpack_require__(268);
	
	var canDefineProperty = __webpack_require__(269);
	var emptyObject = __webpack_require__(46);
	var invariant = __webpack_require__(5);
	var lowPriorityWarning = __webpack_require__(645);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var ReactCurrentOwner = __webpack_require__(24);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 267 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(7);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 270 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(62);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(658);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 272 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(20)
	
	/**
	 * Snake case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '_')
	}


/***/ },
/* 274 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 275 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(275)
	var ieee754 = __webpack_require__(303)
	var isArray = __webpack_require__(306)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	exports.no = exports.noCase = __webpack_require__(20)
	exports.dot = exports.dotCase = __webpack_require__(286)
	exports.swap = exports.swapCase = __webpack_require__(657)
	exports.path = exports.pathCase = __webpack_require__(323)
	exports.upper = exports.upperCase = __webpack_require__(26)
	exports.lower = exports.lowerCase = __webpack_require__(39)
	exports.camel = exports.camelCase = __webpack_require__(92)
	exports.snake = exports.snakeCase = __webpack_require__(273)
	exports.title = exports.titleCase = __webpack_require__(661)
	exports.param = exports.paramCase = __webpack_require__(321)
	exports.header = exports.headerCase = __webpack_require__(299)
	exports.pascal = exports.pascalCase = __webpack_require__(322)
	exports.constant = exports.constantCase = __webpack_require__(284)
	exports.sentence = exports.sentenceCase = __webpack_require__(655)
	exports.isUpper = exports.isUpperCase = __webpack_require__(305)
	exports.isLower = exports.isLowerCase = __webpack_require__(304)
	exports.ucFirst = exports.upperCaseFirst = __webpack_require__(91)
	exports.lcFirst = exports.lowerCaseFirst = __webpack_require__(315)


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventOptionsKey = __webpack_require__(281);
	
	var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TargetEventHandlers = function () {
	  function TargetEventHandlers(target) {
	    _classCallCheck(this, TargetEventHandlers);
	
	    this.target = target;
	    this.events = {};
	  }
	
	  _createClass(TargetEventHandlers, [{
	    key: 'getEventHandlers',
	    value: function () {
	      function getEventHandlers(eventName, options) {
	        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));
	
	        if (!this.events[key]) {
	          this.events[key] = {
	            handlers: [],
	            handleEvent: undefined
	          };
	        }
	
	        return this.events[key];
	      }
	
	      return getEventHandlers;
	    }()
	  }, {
	    key: 'handleEvent',
	    value: function () {
	      function handleEvent(eventName, options, event) {
	        var _getEventHandlers = this.getEventHandlers(eventName, options),
	            handlers = _getEventHandlers.handlers;
	
	        handlers.forEach(function (handler) {
	          if (handler) {
	            // We need to check for presence here because a handler function may
	            // cause later handlers to get removed. This can happen if you for
	            // instance have a waypoint that unmounts another waypoint as part of an
	            // onEnter/onLeave handler.
	            handler(event);
	          }
	        });
	      }
	
	      return handleEvent;
	    }()
	  }, {
	    key: 'add',
	    value: function () {
	      function add(eventName, listener, options) {
	        var _this = this;
	
	        // options has already been normalized at this point.
	        var eventHandlers = this.getEventHandlers(eventName, options);
	
	        if (eventHandlers.handlers.length === 0) {
	          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	        }
	
	        eventHandlers.handlers.push(listener);
	
	        var isSubscribed = true;
	        var unsubscribe = function () {
	          function unsubscribe() {
	            if (!isSubscribed) {
	              return;
	            }
	
	            isSubscribed = false;
	
	            var index = eventHandlers.handlers.indexOf(listener);
	            eventHandlers.handlers.splice(index, 1);
	
	            if (eventHandlers.handlers.length === 0) {
	              // All event handlers have been removed, so we want to remove the event
	              // listener from the target node.
	
	              if (_this.target) {
	                // There can be a race condition where the target may no longer exist
	                // when this function is called, e.g. when a React component is
	                // unmounting. Guarding against this prevents the following error:
	                //
	                //   Cannot read property 'removeEventListener' of undefined
	                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	              }
	
	              eventHandlers.handleEvent = undefined;
	            }
	          }
	
	          return unsubscribe;
	        }();
	        return unsubscribe;
	      }
	
	      return add;
	    }()
	  }]);
	
	  return TargetEventHandlers;
	}();
	
	exports['default'] = TargetEventHandlers;

/***/ },
/* 279 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports['default'] = CAN_USE_DOM;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = canUsePassiveEventListeners;
	
	var _canUseDOM = __webpack_require__(279);
	
	var _canUseDOM2 = _interopRequireDefault(_canUseDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
	function testPassiveEventListeners() {
	  if (!_canUseDOM2['default']) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    window.addEventListener('test', null, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}

/***/ },
/* 281 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = eventOptionsKey;
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EVENT_HANDLERS_KEY = undefined;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	
	var _normalizeEventOptions = __webpack_require__(283);
	
	var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);
	
	var _TargetEventHandlers = __webpack_require__(278);
	
	var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Export to make testing possible.
	var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
	  }
	  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	// Deprecated
	function removeEventListener(unsubscribeFn) {
	  unsubscribeFn();
	}

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = normalizeEventOptions;
	
	var _canUsePassiveEventListeners = __webpack_require__(280);
	
	var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!(0, _canUsePassiveEventListeners2['default'])()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(26)
	var snakeCase = __webpack_require__(273)
	
	/**
	 * Constant case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return upperCase(snakeCase(value, locale), locale)
	}


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var emptyObject = __webpack_require__(46);
	var _invariant = __webpack_require__(5);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(20)
	
	/**
	 * Dot case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '.')
	}


/***/ },
/* 287 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(287);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(297);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var createArrayFromMixed = __webpack_require__(290);
	var getMarkupWrap = __webpack_require__(292);
	var invariant = __webpack_require__(5);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 293 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 294 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(294);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 296 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(296);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 298 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(20)
	var upperCase = __webpack_require__(26)
	
	/**
	 * Header case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '-').replace(/^.|-./g, function (m) {
	    return upperCase(m, locale)
	  })
	}


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(28);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(60);
	
	var _PathUtils = __webpack_require__(37);
	
	var _createTransitionManager = __webpack_require__(61);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(28);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(60);
	
	var _PathUtils = __webpack_require__(37);
	
	var _createTransitionManager = __webpack_require__(61);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(28);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(37);
	
	var _LocationUtils = __webpack_require__(60);
	
	var _createTransitionManager = __webpack_require__(61);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 303 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(39)
	
	/**
	 * Check if a string is lower case.
	 *
	 * @param  {String}  string
	 * @param  {String}  [locale]
	 * @return {Boolean}
	 */
	module.exports = function (string, locale) {
	  return lowerCase(string, locale) === string
	}


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(26)
	
	/**
	 * Check if a string is upper case.
	 *
	 * @param  {String}  string
	 * @param  {String}  [locale]
	 * @return {Boolean}
	 */
	module.exports = function (string, locale) {
	  return upperCase(string, locale) === string
	}


/***/ },
/* 306 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98),
	    getRawTag = __webpack_require__(310),
	    objectToString = __webpack_require__(311);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 308 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(312);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 311 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 312 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(308);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 314 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(39)
	
	/**
	 * Lower case the first character of a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  str = String(str)
	
	  return lowerCase(str.charAt(0), locale) + str.substr(1)
	}


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 99,
		"./af.js": 99,
		"./ar": 106,
		"./ar-dz": 100,
		"./ar-dz.js": 100,
		"./ar-kw": 101,
		"./ar-kw.js": 101,
		"./ar-ly": 102,
		"./ar-ly.js": 102,
		"./ar-ma": 103,
		"./ar-ma.js": 103,
		"./ar-sa": 104,
		"./ar-sa.js": 104,
		"./ar-tn": 105,
		"./ar-tn.js": 105,
		"./ar.js": 106,
		"./az": 107,
		"./az.js": 107,
		"./be": 108,
		"./be.js": 108,
		"./bg": 109,
		"./bg.js": 109,
		"./bn": 110,
		"./bn.js": 110,
		"./bo": 111,
		"./bo.js": 111,
		"./br": 112,
		"./br.js": 112,
		"./bs": 113,
		"./bs.js": 113,
		"./ca": 114,
		"./ca.js": 114,
		"./cs": 115,
		"./cs.js": 115,
		"./cv": 116,
		"./cv.js": 116,
		"./cy": 117,
		"./cy.js": 117,
		"./da": 118,
		"./da.js": 118,
		"./de": 121,
		"./de-at": 119,
		"./de-at.js": 119,
		"./de-ch": 120,
		"./de-ch.js": 120,
		"./de.js": 121,
		"./dv": 122,
		"./dv.js": 122,
		"./el": 123,
		"./el.js": 123,
		"./en-au": 124,
		"./en-au.js": 124,
		"./en-ca": 125,
		"./en-ca.js": 125,
		"./en-gb": 126,
		"./en-gb.js": 126,
		"./en-ie": 127,
		"./en-ie.js": 127,
		"./en-nz": 128,
		"./en-nz.js": 128,
		"./eo": 129,
		"./eo.js": 129,
		"./es": 131,
		"./es-do": 130,
		"./es-do.js": 130,
		"./es.js": 131,
		"./et": 132,
		"./et.js": 132,
		"./eu": 133,
		"./eu.js": 133,
		"./fa": 134,
		"./fa.js": 134,
		"./fi": 135,
		"./fi.js": 135,
		"./fo": 136,
		"./fo.js": 136,
		"./fr": 139,
		"./fr-ca": 137,
		"./fr-ca.js": 137,
		"./fr-ch": 138,
		"./fr-ch.js": 138,
		"./fr.js": 139,
		"./fy": 140,
		"./fy.js": 140,
		"./gd": 141,
		"./gd.js": 141,
		"./gl": 142,
		"./gl.js": 142,
		"./gom-latn": 143,
		"./gom-latn.js": 143,
		"./he": 144,
		"./he.js": 144,
		"./hi": 145,
		"./hi.js": 145,
		"./hr": 146,
		"./hr.js": 146,
		"./hu": 147,
		"./hu.js": 147,
		"./hy-am": 148,
		"./hy-am.js": 148,
		"./id": 149,
		"./id.js": 149,
		"./is": 150,
		"./is.js": 150,
		"./it": 151,
		"./it.js": 151,
		"./ja": 152,
		"./ja.js": 152,
		"./jv": 153,
		"./jv.js": 153,
		"./ka": 154,
		"./ka.js": 154,
		"./kk": 155,
		"./kk.js": 155,
		"./km": 156,
		"./km.js": 156,
		"./kn": 157,
		"./kn.js": 157,
		"./ko": 158,
		"./ko.js": 158,
		"./ky": 159,
		"./ky.js": 159,
		"./lb": 160,
		"./lb.js": 160,
		"./lo": 161,
		"./lo.js": 161,
		"./lt": 162,
		"./lt.js": 162,
		"./lv": 163,
		"./lv.js": 163,
		"./me": 164,
		"./me.js": 164,
		"./mi": 165,
		"./mi.js": 165,
		"./mk": 166,
		"./mk.js": 166,
		"./ml": 167,
		"./ml.js": 167,
		"./mr": 168,
		"./mr.js": 168,
		"./ms": 170,
		"./ms-my": 169,
		"./ms-my.js": 169,
		"./ms.js": 170,
		"./my": 171,
		"./my.js": 171,
		"./nb": 172,
		"./nb.js": 172,
		"./ne": 173,
		"./ne.js": 173,
		"./nl": 175,
		"./nl-be": 174,
		"./nl-be.js": 174,
		"./nl.js": 175,
		"./nn": 176,
		"./nn.js": 176,
		"./pa-in": 177,
		"./pa-in.js": 177,
		"./pl": 178,
		"./pl.js": 178,
		"./pt": 180,
		"./pt-br": 179,
		"./pt-br.js": 179,
		"./pt.js": 180,
		"./ro": 181,
		"./ro.js": 181,
		"./ru": 182,
		"./ru.js": 182,
		"./sd": 183,
		"./sd.js": 183,
		"./se": 184,
		"./se.js": 184,
		"./si": 185,
		"./si.js": 185,
		"./sk": 186,
		"./sk.js": 186,
		"./sl": 187,
		"./sl.js": 187,
		"./sq": 188,
		"./sq.js": 188,
		"./sr": 190,
		"./sr-cyrl": 189,
		"./sr-cyrl.js": 189,
		"./sr.js": 190,
		"./ss": 191,
		"./ss.js": 191,
		"./sv": 192,
		"./sv.js": 192,
		"./sw": 193,
		"./sw.js": 193,
		"./ta": 194,
		"./ta.js": 194,
		"./te": 195,
		"./te.js": 195,
		"./tet": 196,
		"./tet.js": 196,
		"./th": 197,
		"./th.js": 197,
		"./tl-ph": 198,
		"./tl-ph.js": 198,
		"./tlh": 199,
		"./tlh.js": 199,
		"./tr": 200,
		"./tr.js": 200,
		"./tzl": 201,
		"./tzl.js": 201,
		"./tzm": 203,
		"./tzm-latn": 202,
		"./tzm-latn.js": 202,
		"./tzm.js": 203,
		"./uk": 204,
		"./uk.js": 204,
		"./ur": 205,
		"./ur.js": 205,
		"./uz": 207,
		"./uz-latn": 206,
		"./uz-latn.js": 206,
		"./uz.js": 207,
		"./vi": 208,
		"./vi.js": 208,
		"./x-pseudo": 209,
		"./x-pseudo.js": 209,
		"./yo": 210,
		"./yo.js": 210,
		"./zh-cn": 211,
		"./zh-cn.js": 211,
		"./zh-hk": 212,
		"./zh-hk.js": 212,
		"./zh-tw": 213,
		"./zh-tw.js": 213
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 316;


/***/ },
/* 317 */
/***/ function(module, exports) {

	module.exports = /([a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])/g


/***/ },
/* 318 */
/***/ function(module, exports) {

	module.exports = /([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A]+)([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A][a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])/g


/***/ },
/* 319 */
/***/ function(module, exports) {

	module.exports = /[^A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory){
	  'use strict';
	
	  /*istanbul ignore next:cant test*/
	  if (typeof module === 'object' && typeof module.exports === 'object') {
	    module.exports = factory();
	  } else if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Browser globals
	    root.objectPath = factory();
	  }
	})(this, function(){
	  'use strict';
	
	  var toStr = Object.prototype.toString;
	  function hasOwnProperty(obj, prop) {
	    if(obj == null) {
	      return false
	    }
	    //to handle objects with null prototypes (too edge case?)
	    return Object.prototype.hasOwnProperty.call(obj, prop)
	  }
	
	  function isEmpty(value){
	    if (!value) {
	      return true;
	    }
	    if (isArray(value) && value.length === 0) {
	        return true;
	    } else if (typeof value !== 'string') {
	        for (var i in value) {
	            if (hasOwnProperty(value, i)) {
	                return false;
	            }
	        }
	        return true;
	    }
	    return false;
	  }
	
	  function toString(type){
	    return toStr.call(type);
	  }
	
	  function isObject(obj){
	    return typeof obj === 'object' && toString(obj) === "[object Object]";
	  }
	
	  var isArray = Array.isArray || function(obj){
	    /*istanbul ignore next:cant test*/
	    return toStr.call(obj) === '[object Array]';
	  }
	
	  function isBoolean(obj){
	    return typeof obj === 'boolean' || toString(obj) === '[object Boolean]';
	  }
	
	  function getKey(key){
	    var intKey = parseInt(key);
	    if (intKey.toString() === key) {
	      return intKey;
	    }
	    return key;
	  }
	
	  function factory(options) {
	    options = options || {}
	
	    var objectPath = function(obj) {
	      return Object.keys(objectPath).reduce(function(proxy, prop) {
	        if(prop === 'create') {
	          return proxy;
	        }
	
	        /*istanbul ignore else*/
	        if (typeof objectPath[prop] === 'function') {
	          proxy[prop] = objectPath[prop].bind(objectPath, obj);
	        }
	
	        return proxy;
	      }, {});
	    };
	
	    function hasShallowProperty(obj, prop) {
	      return (options.includeInheritedProps || (typeof prop === 'number' && Array.isArray(obj)) || hasOwnProperty(obj, prop))
	    }
	
	    function getShallowProperty(obj, prop) {
	      if (hasShallowProperty(obj, prop)) {
	        return obj[prop];
	      }
	    }
	
	    function set(obj, path, value, doNotReplace){
	      if (typeof path === 'number') {
	        path = [path];
	      }
	      if (!path || path.length === 0) {
	        return obj;
	      }
	      if (typeof path === 'string') {
	        return set(obj, path.split('.').map(getKey), value, doNotReplace);
	      }
	      var currentPath = path[0];
	      var currentValue = getShallowProperty(obj, currentPath);
	      if (path.length === 1) {
	        if (currentValue === void 0 || !doNotReplace) {
	          obj[currentPath] = value;
	        }
	        return currentValue;
	      }
	
	      if (currentValue === void 0) {
	        //check if we assume an array
	        if(typeof path[1] === 'number') {
	          obj[currentPath] = [];
	        } else {
	          obj[currentPath] = {};
	        }
	      }
	
	      return set(obj[currentPath], path.slice(1), value, doNotReplace);
	    }
	
	    objectPath.has = function (obj, path) {
	      if (typeof path === 'number') {
	        path = [path];
	      } else if (typeof path === 'string') {
	        path = path.split('.');
	      }
	
	      if (!path || path.length === 0) {
	        return !!obj;
	      }
	
	      for (var i = 0; i < path.length; i++) {
	        var j = getKey(path[i]);
	
	        if((typeof j === 'number' && isArray(obj) && j < obj.length) ||
	          (options.includeInheritedProps ? (j in Object(obj)) : hasOwnProperty(obj, j))) {
	          obj = obj[j];
	        } else {
	          return false;
	        }
	      }
	
	      return true;
	    };
	
	    objectPath.ensureExists = function (obj, path, value){
	      return set(obj, path, value, true);
	    };
	
	    objectPath.set = function (obj, path, value, doNotReplace){
	      return set(obj, path, value, doNotReplace);
	    };
	
	    objectPath.insert = function (obj, path, value, at){
	      var arr = objectPath.get(obj, path);
	      at = ~~at;
	      if (!isArray(arr)) {
	        arr = [];
	        objectPath.set(obj, path, arr);
	      }
	      arr.splice(at, 0, value);
	    };
	
	    objectPath.empty = function(obj, path) {
	      if (isEmpty(path)) {
	        return void 0;
	      }
	      if (obj == null) {
	        return void 0;
	      }
	
	      var value, i;
	      if (!(value = objectPath.get(obj, path))) {
	        return void 0;
	      }
	
	      if (typeof value === 'string') {
	        return objectPath.set(obj, path, '');
	      } else if (isBoolean(value)) {
	        return objectPath.set(obj, path, false);
	      } else if (typeof value === 'number') {
	        return objectPath.set(obj, path, 0);
	      } else if (isArray(value)) {
	        value.length = 0;
	      } else if (isObject(value)) {
	        for (i in value) {
	          if (hasShallowProperty(value, i)) {
	            delete value[i];
	          }
	        }
	      } else {
	        return objectPath.set(obj, path, null);
	      }
	    };
	
	    objectPath.push = function (obj, path /*, values */){
	      var arr = objectPath.get(obj, path);
	      if (!isArray(arr)) {
	        arr = [];
	        objectPath.set(obj, path, arr);
	      }
	
	      arr.push.apply(arr, Array.prototype.slice.call(arguments, 2));
	    };
	
	    objectPath.coalesce = function (obj, paths, defaultValue) {
	      var value;
	
	      for (var i = 0, len = paths.length; i < len; i++) {
	        if ((value = objectPath.get(obj, paths[i])) !== void 0) {
	          return value;
	        }
	      }
	
	      return defaultValue;
	    };
	
	    objectPath.get = function (obj, path, defaultValue){
	      if (typeof path === 'number') {
	        path = [path];
	      }
	      if (!path || path.length === 0) {
	        return obj;
	      }
	      if (obj == null) {
	        return defaultValue;
	      }
	      if (typeof path === 'string') {
	        return objectPath.get(obj, path.split('.'), defaultValue);
	      }
	
	      var currentPath = getKey(path[0]);
	      var nextObj = getShallowProperty(obj, currentPath)
	      if (nextObj === void 0) {
	        return defaultValue;
	      }
	
	      if (path.length === 1) {
	        return nextObj;
	      }
	
	      return objectPath.get(obj[currentPath], path.slice(1), defaultValue);
	    };
	
	    objectPath.del = function del(obj, path) {
	      if (typeof path === 'number') {
	        path = [path];
	      }
	
	      if (obj == null) {
	        return obj;
	      }
	
	      if (isEmpty(path)) {
	        return obj;
	      }
	      if(typeof path === 'string') {
	        return objectPath.del(obj, path.split('.'));
	      }
	
	      var currentPath = getKey(path[0]);
	      if (!hasShallowProperty(obj, currentPath)) {
	        return obj;
	      }
	
	      if(path.length === 1) {
	        if (isArray(obj)) {
	          obj.splice(currentPath, 1);
	        } else {
	          delete obj[currentPath];
	        }
	      } else {
	        return objectPath.del(obj[currentPath], path.slice(1));
	      }
	
	      return obj;
	    }
	
	    return objectPath;
	  }
	
	  var mod = factory();
	  mod.create = factory;
	  mod.withInheritedProps = factory({includeInheritedProps: true})
	  return mod;
	});


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(20)
	
	/**
	 * Param case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '-')
	}


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var camelCase = __webpack_require__(92)
	var upperCaseFirst = __webpack_require__(91)
	
	/**
	 * Pascal case a string.
	 *
	 * @param  {string}  value
	 * @param  {string}  [locale]
	 * @param  {boolean} [mergeNumbers]
	 * @return {string}
	 */
	module.exports = function (value, locale, mergeNumbers) {
	  return upperCaseFirst(camelCase(value, locale, mergeNumbers), locale)
	}


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(20)
	
	/**
	 * Path case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '/')
	}


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(325)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 325 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(215);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(215);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(15);
	var invariant = __webpack_require__(5);
	var ReactPropTypesSecret = __webpack_require__(217);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(15);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var ReactPropTypesSecret = __webpack_require__(217);
	var checkPropTypes = __webpack_require__(328);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 331 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(11);
	
	var focusNode = __webpack_require__(94);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(41);
	var ExecutionEnvironment = __webpack_require__(14);
	var FallbackCompositionState = __webpack_require__(339);
	var SyntheticCompositionEvent = __webpack_require__(376);
	var SyntheticInputEvent = __webpack_require__(379);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(219);
	var ExecutionEnvironment = __webpack_require__(14);
	var ReactInstrumentation = __webpack_require__(18);
	
	var camelizeStyleName = __webpack_require__(288);
	var dangerousStyleValue = __webpack_require__(385);
	var hyphenateStyleName = __webpack_require__(295);
	var memoizeStringOnly = __webpack_require__(298);
	var warning = __webpack_require__(7);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(40);
	var EventPropagators = __webpack_require__(41);
	var ExecutionEnvironment = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(19);
	var SyntheticEvent = __webpack_require__(21);
	
	var inputValueTracking = __webpack_require__(235);
	var getEventTarget = __webpack_require__(75);
	var isEventSupported = __webpack_require__(76);
	var isTextInputElement = __webpack_require__(237);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMLazyTree = __webpack_require__(29);
	var ExecutionEnvironment = __webpack_require__(14);
	
	var createNodesFromMarkup = __webpack_require__(291);
	var emptyFunction = __webpack_require__(15);
	var invariant = __webpack_require__(5);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 337 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(41);
	var ReactDOMComponentTree = __webpack_require__(11);
	var SyntheticMouseEvent = __webpack_require__(48);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var PooledClass = __webpack_require__(27);
	
	var getTextContentAccessor = __webpack_require__(234);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(30);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(31);
	
	var instantiateReactComponent = __webpack_require__(236);
	var KeyEscapeUtils = __webpack_require__(67);
	var shouldUpdateReactComponent = __webpack_require__(77);
	var traverseAllChildren = __webpack_require__(239);
	var warning = __webpack_require__(7);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(266);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(214)))

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(63);
	var ReactDOMIDOperations = __webpack_require__(349);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(10);
	
	var React = __webpack_require__(35);
	var ReactComponentEnvironment = __webpack_require__(69);
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactErrorUtils = __webpack_require__(70);
	var ReactInstanceMap = __webpack_require__(42);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactNodeTypes = __webpack_require__(229);
	var ReactReconciler = __webpack_require__(31);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(46);
	var invariant = __webpack_require__(5);
	var shallowEqual = __webpack_require__(59);
	var shouldUpdateReactComponent = __webpack_require__(77);
	var warning = __webpack_require__(7);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDefaultInjection = __webpack_require__(357);
	var ReactMount = __webpack_require__(228);
	var ReactReconciler = __webpack_require__(31);
	var ReactUpdates = __webpack_require__(19);
	var ReactVersion = __webpack_require__(370);
	
	var findDOMNode = __webpack_require__(386);
	var getHostComponentFromComposite = __webpack_require__(233);
	var renderSubtreeIntoContainer = __webpack_require__(393);
	var warning = __webpack_require__(7);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(10);
	
	var AutoFocusUtils = __webpack_require__(332);
	var CSSPropertyOperations = __webpack_require__(334);
	var DOMLazyTree = __webpack_require__(29);
	var DOMNamespaces = __webpack_require__(64);
	var DOMProperty = __webpack_require__(30);
	var DOMPropertyOperations = __webpack_require__(221);
	var EventPluginHub = __webpack_require__(40);
	var EventPluginRegistry = __webpack_require__(65);
	var ReactBrowserEventEmitter = __webpack_require__(47);
	var ReactDOMComponentFlags = __webpack_require__(222);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDOMInput = __webpack_require__(350);
	var ReactDOMOption = __webpack_require__(351);
	var ReactDOMSelect = __webpack_require__(223);
	var ReactDOMTextarea = __webpack_require__(354);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactMultiChild = __webpack_require__(363);
	var ReactServerRenderingTransaction = __webpack_require__(368);
	
	var emptyFunction = __webpack_require__(15);
	var escapeTextContentForBrowser = __webpack_require__(50);
	var invariant = __webpack_require__(5);
	var isEventSupported = __webpack_require__(76);
	var shallowEqual = __webpack_require__(59);
	var inputValueTracking = __webpack_require__(235);
	var validateDOMNesting = __webpack_require__(78);
	var warning = __webpack_require__(7);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(78);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var DOMLazyTree = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(11);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 348 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(63);
	var ReactDOMComponentTree = __webpack_require__(11);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(10);
	
	var DOMPropertyOperations = __webpack_require__(221);
	var LinkedValueUtils = __webpack_require__(68);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(19);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var React = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDOMSelect = __webpack_require__(223);
	
	var warning = __webpack_require__(7);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var getNodeForCharacterOffset = __webpack_require__(390);
	var getTextContentAccessor = __webpack_require__(234);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(10);
	
	var DOMChildrenOperations = __webpack_require__(63);
	var DOMLazyTree = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(11);
	
	var escapeTextContentForBrowser = __webpack_require__(50);
	var invariant = __webpack_require__(5);
	var validateDOMNesting = __webpack_require__(78);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(10);
	
	var LinkedValueUtils = __webpack_require__(68);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(19);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactUpdates = __webpack_require__(19);
	var Transaction = __webpack_require__(49);
	
	var emptyFunction = __webpack_require__(15);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(331);
	var BeforeInputEventPlugin = __webpack_require__(333);
	var ChangeEventPlugin = __webpack_require__(335);
	var DefaultEventPluginOrder = __webpack_require__(337);
	var EnterLeaveEventPlugin = __webpack_require__(338);
	var HTMLDOMPropertyConfig = __webpack_require__(340);
	var ReactComponentBrowserEnvironment = __webpack_require__(342);
	var ReactDOMComponent = __webpack_require__(345);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDOMEmptyComponent = __webpack_require__(347);
	var ReactDOMTreeTraversal = __webpack_require__(355);
	var ReactDOMTextComponent = __webpack_require__(353);
	var ReactDefaultBatchingStrategy = __webpack_require__(356);
	var ReactEventListener = __webpack_require__(360);
	var ReactInjection = __webpack_require__(361);
	var ReactReconcileTransaction = __webpack_require__(366);
	var SVGDOMPropertyConfig = __webpack_require__(371);
	var SelectEventPlugin = __webpack_require__(372);
	var SimpleEventPlugin = __webpack_require__(373);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 358 */
267,
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(40);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var EventListener = __webpack_require__(93);
	var ExecutionEnvironment = __webpack_require__(14);
	var PooledClass = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(19);
	
	var getEventTarget = __webpack_require__(75);
	var getUnboundedScrollPosition = __webpack_require__(293);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(30);
	var EventPluginHub = __webpack_require__(40);
	var EventPluginUtils = __webpack_require__(66);
	var ReactComponentEnvironment = __webpack_require__(69);
	var ReactEmptyComponent = __webpack_require__(224);
	var ReactBrowserEventEmitter = __webpack_require__(47);
	var ReactHostComponent = __webpack_require__(226);
	var ReactUpdates = __webpack_require__(19);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(384);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactComponentEnvironment = __webpack_require__(69);
	var ReactInstanceMap = __webpack_require__(42);
	var ReactInstrumentation = __webpack_require__(18);
	
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactReconciler = __webpack_require__(31);
	var ReactChildReconciler = __webpack_require__(341);
	
	var emptyFunction = __webpack_require__(15);
	var flattenChildren = __webpack_require__(387);
	var invariant = __webpack_require__(5);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 365 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var CallbackQueue = __webpack_require__(220);
	var PooledClass = __webpack_require__(27);
	var ReactBrowserEventEmitter = __webpack_require__(47);
	var ReactInputSelection = __webpack_require__(227);
	var ReactInstrumentation = __webpack_require__(18);
	var Transaction = __webpack_require__(49);
	var ReactUpdateQueue = __webpack_require__(71);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(364);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var PooledClass = __webpack_require__(27);
	var Transaction = __webpack_require__(49);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactServerUpdateQueue = __webpack_require__(369);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(71);
	
	var warning = __webpack_require__(7);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 370 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.1';

/***/ },
/* 371 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(41);
	var ExecutionEnvironment = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactInputSelection = __webpack_require__(227);
	var SyntheticEvent = __webpack_require__(21);
	
	var getActiveElement = __webpack_require__(95);
	var isTextInputElement = __webpack_require__(237);
	var shallowEqual = __webpack_require__(59);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventListener = __webpack_require__(93);
	var EventPropagators = __webpack_require__(41);
	var ReactDOMComponentTree = __webpack_require__(11);
	var SyntheticAnimationEvent = __webpack_require__(374);
	var SyntheticClipboardEvent = __webpack_require__(375);
	var SyntheticEvent = __webpack_require__(21);
	var SyntheticFocusEvent = __webpack_require__(378);
	var SyntheticKeyboardEvent = __webpack_require__(380);
	var SyntheticMouseEvent = __webpack_require__(48);
	var SyntheticDragEvent = __webpack_require__(377);
	var SyntheticTouchEvent = __webpack_require__(381);
	var SyntheticTransitionEvent = __webpack_require__(382);
	var SyntheticUIEvent = __webpack_require__(43);
	var SyntheticWheelEvent = __webpack_require__(383);
	
	var emptyFunction = __webpack_require__(15);
	var getEventCharCode = __webpack_require__(73);
	var invariant = __webpack_require__(5);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(21);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(21);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(21);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(48);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(43);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(21);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(43);
	
	var getEventCharCode = __webpack_require__(73);
	var getEventKey = __webpack_require__(388);
	var getEventModifierState = __webpack_require__(74);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(43);
	
	var getEventModifierState = __webpack_require__(74);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(21);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(48);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 384 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(219);
	var warning = __webpack_require__(7);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactInstanceMap = __webpack_require__(42);
	
	var getHostComponentFromComposite = __webpack_require__(233);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(67);
	var traverseAllChildren = __webpack_require__(239);
	var warning = __webpack_require__(7);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(266);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(214)))

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(73);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 389 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 390 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(50);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(228);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(242);
	
	var _warning = __webpack_require__(79);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  Provider.displayName = 'Provider';
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(240);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(402);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(396);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(397);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(398);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(399);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(90);
	
	var _wrapMapToProps = __webpack_require__(241);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(241);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(243);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(400);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(79);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 401 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 402 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(300);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _reactRouter = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(301);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _reactRouter = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(16);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.MemoryRouter;
	  }
	});

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(16);
	
	var _Link = __webpack_require__(244);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive']);
	
	  return _react2.default.createElement(_reactRouter.Route, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [activeClassName, className].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active'
	};
	
	exports.default = NavLink;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(16);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Prompt;
	  }
	});

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(16);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Redirect;
	  }
	});

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(16);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Route;
	  }
	});

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(16);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Router;
	  }
	});

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(16);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.StaticRouter;
	  }
	});

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(16);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Switch;
	  }
	});

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(16);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.matchPath;
	  }
	});

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(16);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.withRouter;
	  }
	});

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(302);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(80);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(38);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(37);
	
	var _Router = __webpack_require__(80);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(28);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _matchPath = __webpack_require__(81);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(97);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(245);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(327).enable();
	  window.Promise = __webpack_require__(326);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(663);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(10);


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	__webpack_require__(621);
	
	var _Extension = __webpack_require__(596);
	
	var _Extension2 = _interopRequireDefault(_Extension);
	
	var _Home = __webpack_require__(598);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _PrivacyPolicy = __webpack_require__(601);
	
	var _PrivacyPolicy2 = _interopRequireDefault(_PrivacyPolicy);
	
	var _CatSnapshot = __webpack_require__(597);
	
	var _CatSnapshot2 = _interopRequireDefault(_CatSnapshot);
	
	var _Shop = __webpack_require__(604);
	
	var _Shop2 = _interopRequireDefault(_Shop);
	
	var _ShopPrivacyPolicy = __webpack_require__(602);
	
	var _ShopPrivacyPolicy2 = _interopRequireDefault(_ShopPrivacyPolicy);
	
	var _ShopTOS = __webpack_require__(603);
	
	var _ShopTOS2 = _interopRequireDefault(_ShopTOS);
	
	var _FAQ = __webpack_require__(600);
	
	var _FAQ2 = _interopRequireDefault(_FAQ);
	
	var _NotFound = __webpack_require__(599);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function App() {
		var developmentMode = ("production") === 'development';
		return _react2.default.createElement(
			_reactRouterDom.BrowserRouter,
			null,
			_react2.default.createElement(
				_reactRouterDom.Switch,
				null,
				_react2.default.createElement(_reactRouterDom.Route, { path: '/', exact: true, component: _Home2.default }),
				developmentMode ? _react2.default.createElement(_reactRouterDom.Route, { path: '/ext', exact: true, component: _Extension2.default }) : null,
				_react2.default.createElement(_reactRouterDom.Route, { path: '/meow', exact: true, component: _CatSnapshot2.default }),
				_react2.default.createElement(_reactRouterDom.Route, { path: '/terms-of-use-and-privacy-policy', component: _PrivacyPolicy2.default }),
				_react2.default.createElement(_reactRouterDom.Route, { path: '/cat/:id', component: _CatSnapshot2.default }),
				_react2.default.createElement(_reactRouterDom.Route, { path: '/cat/:id/screenshot', component: _CatSnapshot2.default }),
				_react2.default.createElement(_reactRouterDom.Route, { path: '/shop', exact: true, component: _Shop2.default }),
				_react2.default.createElement(_reactRouterDom.Route, { path: '/shop/privacy-policy', component: _ShopPrivacyPolicy2.default }),
				_react2.default.createElement(_reactRouterDom.Route, { path: '/shop/terms-of-service', component: _ShopTOS2.default }),
				_react2.default.createElement(_reactRouterDom.Route, { path: '/faq', component: _FAQ2.default }),
				_react2.default.createElement(_reactRouterDom.Route, { component: _NotFound2.default })
			)
		);
	}
	
	exports.default = App;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setLastVerificationDate = setLastVerificationDate;
	exports.setVerificationError = setVerificationError;
	
	var _constants = __webpack_require__(4);
	
	function setLastVerificationDate() {
	  return {
	    type: _constants.SET_LAST_VERIFICATION_DATE,
	    payload: {
	      date: Date.now()
	    }
	  };
	} /* eslint-disable import/prefer-default-export */
	function setVerificationError(error) {
	  return {
	    type: _constants.SET_VERIFICATION_ERROR,
	    payload: {
	      error: error
	    }
	  };
	}

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(22);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icons = __webpack_require__(44);
	
	var _activeGoodies = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/no-static-element-interactions */
	
	function GoodyItem(_ref) {
	  var type = _ref.type,
	      name = _ref.name,
	      id = _ref.id,
	      isActive = _ref.isActive,
	      isNew = _ref.isNew,
	      setActiveGoody = _ref.setActiveGoody;
	
	  var classes = (0, _classnames2.default)('goodies__list__goody', {
	    'goodies__list__goody--is-active': isActive,
	    'goodies__list__goody--is-new': isNew
	  });
	
	  // If this goody is active, remove it on click.
	  var nextActiveGoodyId = isActive ? undefined : id;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes, onClick: function onClick() {
	        return setActiveGoody(type, nextActiveGoodyId);
	      } },
	    _react2.default.createElement('img', {
	      alt: type + ' goody',
	      src: 'extension-assets/' + type + '/' + name + '.svg'
	    }),
	    _react2.default.createElement(_Icons.Badge, { classes: 'badge' })
	  );
	}
	
	GoodyItem.propTypes = {
	  type: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  id: _propTypes2.default.string.isRequired,
	  isActive: _propTypes2.default.bool.isRequired,
	  isNew: _propTypes2.default.bool.isRequired
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setActiveGoody: function setActiveGoody(goodyType, goodyId) {
	      dispatch((0, _activeGoodies.setActiveGoodyAsync)(goodyType, goodyId));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(GoodyItem);

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(22);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _getGoodiesInCodebase = __webpack_require__(607);
	
	var _getGoodiesInCodebase2 = _interopRequireDefault(_getGoodiesInCodebase);
	
	var _GoodyItem = __webpack_require__(424);
	
	var _GoodyItem2 = _interopRequireDefault(_GoodyItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoodyList = function (_React$Component) {
		_inherits(GoodyList, _React$Component);
	
		function GoodyList() {
			_classCallCheck(this, GoodyList);
	
			var _this = _possibleConstructorReturn(this, (GoodyList.__proto__ || Object.getPrototypeOf(GoodyList)).call(this));
	
			_this.state = {
				newGoodies: []
			};
			return _this;
		}
	
		_createClass(GoodyList, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setNewGoodies(this.props.newGoodies);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				// If new goodies have been added since mounting, add them to the state.
				// This happens when you buy a pet and receive a new goody.
				if (!_lodash2.default.isEmpty(nextProps.newGoodies)) {
					this.setNewGoodies(nextProps.newGoodies);
				}
	
				// When the bag was open and then gets closed, clear our state to reflect the updated redux store.
				if (this.props.isOpen && !nextProps.isOpen && !_lodash2.default.isEmpty(this.state.newGoodies)) {
					this.setNewGoodies(); // clear new goodies
				}
			}
		}, {
			key: 'setNewGoodies',
			value: function setNewGoodies(newGoodies) {
				// Save the new goodies to state, so that when they're cleared by the GoodyBag we still can show what's new.
				this.setState({ newGoodies: newGoodies });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'goodies__list' },
					this.props.collectedGoodies.map(function (goody) {
						return _react2.default.createElement(_GoodyItem2.default, {
							key: goody.id,
							type: goody.type,
							name: goody.name,
							id: goody.id,
							isActive: _this2.props.activeGoodies[goody.type] === goody.id,
							isNew: _lodash2.default.includes(_this2.state.newGoodies, goody.id)
						});
					})
				);
			}
		}]);
	
		return GoodyList;
	}(_react2.default.Component);
	
	GoodyList.PropTypes = {
		collectedGoodies: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			type: _propTypes2.default.string,
			name: _propTypes2.default.string
		})).isRequired,
		newGoodies: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
		activeGoodies: _propTypes2.default.shape({
			hat: _propTypes2.default.string,
			glasses: _propTypes2.default.string,
			toy: _propTypes2.default.toy
		}),
		isOpen: _propTypes2.default.bool.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
		return {
			collectedGoodies: (0, _getGoodiesInCodebase2.default)(state.collectedGoodies.list),
			newGoodies: state.collectedGoodies.newItems,
			activeGoodies: state.activeGoodies.active
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(GoodyList);

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(22);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _GoodyList = __webpack_require__(425);
	
	var _GoodyList2 = _interopRequireDefault(_GoodyList);
	
	var _ControlButton = __webpack_require__(53);
	
	var _ControlButton2 = _interopRequireDefault(_ControlButton);
	
	var _collectedGoodies = __webpack_require__(246);
	
	var _activeGoodies = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prefer-stateless-function */
	
	var GoodyBag = function (_React$Component) {
		_inherits(GoodyBag, _React$Component);
	
		function GoodyBag(props) {
			_classCallCheck(this, GoodyBag);
	
			var _this = _possibleConstructorReturn(this, (GoodyBag.__proto__ || Object.getPrototypeOf(GoodyBag)).call(this, props));
	
			_this.state = {
				isOpen: false
			};
	
			_this.getClassNames = _this.getClassNames.bind(_this);
			_this.toggleBag = _this.toggleBag.bind(_this);
			return _this;
		}
	
		_createClass(GoodyBag, [{
			key: 'getClassNames',
			value: function getClassNames() {
				return (0, _classnames2.default)('goody-bag', {
					'goody-bag--is-open': this.state.isOpen
				});
			}
		}, {
			key: 'toggleBag',
			value: function toggleBag() {
				var _this2 = this;
	
				this.props.clearNewGoodies();
	
				// Wait so that the "new" class is removed before we knock the bag over.
				// Otherwise, the bag doesn't transition to fall over.
				setTimeout(function () {
					_this2.setState({ isOpen: !_this2.state.isOpen });
				}, 20);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: this.getClassNames() },
					_react2.default.createElement(_ControlButton2.default, {
						className: 'goody-bag',
						iconName: 'Bag',
						isActive: this.state.isOpen,
						hasNotification: this.props.hasNewGoodies && !this.state.isOpen,
						notificationMessage: 'New goodies!',
						label: 'Goodies',
						callback: this.toggleBag
					}),
					_react2.default.createElement(_GoodyList2.default, { isOpen: this.state.isOpen }),
					_react2.default.createElement(_ControlButton2.default, {
						shuffle: true,
						isActive: this.props.shuffleIsActive,
						callback: this.props.setShuffle
					})
				);
			}
		}]);
	
		return GoodyBag;
	}(_react2.default.Component);
	
	GoodyBag.propTypes = {
		clearNewGoodies: _propTypes2.default.func.isRequired,
		hasNewGoodies: _propTypes2.default.bool.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
		return {
			hasNewGoodies: !_lodash2.default.isEmpty(state.collectedGoodies.newItems),
			shuffleIsActive: state.activeGoodies.shuffle
		};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			clearNewGoodies: function clearNewGoodies() {
				dispatch((0, _collectedGoodies.setCollectedNewGoodiesAsync)([]));
			},
			setShuffle: function setShuffle() {
				dispatch((0, _activeGoodies.setShuffleAsync)());
			}
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GoodyBag);

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ErrorBanner(_ref) {
		var error = _ref.error;
	
		if (!navigator.onLine) {
			return _react2.default.createElement(
				'div',
				{ className: 'pet-picker__list__error-banner pet-picker__list__error-banner--warn' },
				_react2.default.createElement(
					'div',
					{ className: 'pet-picker__list__error-banner__heading' },
					'You\u2019re in offline mode.'
				),
				'Your pets might not be up to date and purchases won\u2019t work until you\u2019re back online.'
			);
		}
	
		if (error) {
			return _react2.default.createElement(
				'div',
				{ className: 'pet-picker__list__error-banner pet-picker__list__error-banner--error' },
				_react2.default.createElement(
					'div',
					{ className: 'pet-picker__list__error-banner__heading' },
					'Sorry, there was a problem getting your pets.'
				),
				'Purchases may not work right now. To fix this issue, try refreshing the page.',
				_react2.default.createElement('br', null),
				'If you keep having this problem, email meow@tabbycats.club',
				error.response && ' with code: ' + error.response.errorType,
				'.'
			);
		}
	
		return null;
	}
	
	ErrorBanner.propTypes = {
		error: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool])
	};
	
	ErrorBanner.defaultProps = {
		error: undefined
	};
	
	exports.default = ErrorBanner;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icons = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NewBadge(_ref) {
		var shouldShow = _ref.shouldShow;
	
		if (!shouldShow) {
			return null;
		}
	
		return _react2.default.createElement(
			'div',
			{ className: 'pet-picker__list__item__new-badge' },
			_react2.default.createElement(_Icons.Badge, null),
			_react2.default.createElement(
				'div',
				{ className: 'new-badge__new' },
				'New'
			)
		);
	}
	
	exports.default = NewBadge;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(22);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Pet = __webpack_require__(54);
	
	var _Pet2 = _interopRequireDefault(_Pet);
	
	var _PriceBadge = __webpack_require__(432);
	
	var _PriceBadge2 = _interopRequireDefault(_PriceBadge);
	
	var _NewBadge = __webpack_require__(428);
	
	var _NewBadge2 = _interopRequireDefault(_NewBadge);
	
	var _activePet = __webpack_require__(52);
	
	var _googleApi = __webpack_require__(247);
	
	var _getRandom = __webpack_require__(33);
	
	var _getRandom2 = _interopRequireDefault(_getRandom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions */
	
	var PetItem = function (_React$Component) {
		_inherits(PetItem, _React$Component);
	
		function PetItem(props) {
			_classCallCheck(this, PetItem);
	
			var _this = _possibleConstructorReturn(this, (PetItem.__proto__ || Object.getPrototypeOf(PetItem)).call(this, props));
	
			_this.state = {
				isActive: _this.props.isActive,
				isHover: false,
				isClick: false,
				petAttrs: _this.getPetAttrs()
			};
	
			_this.errorTimeout = null;
	
			_this.setHover = _this.setHover.bind(_this);
			_this.unsetHover = _this.unsetHover.bind(_this);
			_this.setClick = _this.setClick.bind(_this);
			_this.unsetClick = _this.unsetClick.bind(_this);
			_this.getClassNames = _this.getClassNames.bind(_this);
			_this.onClick = _this.onClick.bind(_this);
			return _this;
		}
	
		_createClass(PetItem, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				// On mount, set the purchase state.
				this.setState({
					unpurchased: !this.props.isCollected
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				// If the new props show that the item has been purchased, trigger our class applier.
				if (nextProps.purchaseSuccess && !this.props.purchaseSuccess) {
					this.applyPurchaseSuccessClasses();
				}
			}
		}, {
			key: 'setHover',
			value: function setHover() {
				this.setState({ isHover: true });
			}
		}, {
			key: 'unsetHover',
			value: function unsetHover() {
				this.setState({ isHover: false });
			}
		}, {
			key: 'setClick',
			value: function setClick() {
				this.setState({ isClick: true });
			}
		}, {
			key: 'unsetClick',
			value: function unsetClick() {
				this.setState({ isClick: false });
			}
		}, {
			key: 'applyPurchaseSuccessClasses',
			value: function applyPurchaseSuccessClasses() {
				var _this2 = this;
	
				this.setState({ purchaseSuccess: true }, function () {
					setTimeout(function () {
						_this2.setNewActivePet(true);
					}, 900);
				});
			}
		}, {
			key: 'getClassNames',
			value: function getClassNames() {
				return (0, _classnames2.default)('pet-picker__list__item', {
					'pet-picker__list__item--is-coming-soon': this.props.isComingSoon,
					'pet-picker__list__item--is-unpurchased': this.state.unpurchased,
					'pet-picker__list__item--purchase-loading': this.props.purchaseLoading,
					'pet-picker__list__item--purchase-success': this.state.purchaseSuccess,
					'pet-picker__list__item--is-active': this.props.moreThanOneCollectedPet ? this.state.isActive : false,
					'pet-picker__list__item--is-offline': this.state.isOffline
				});
			}
		}, {
			key: 'setNewActivePet',
			value: function setNewActivePet(isJustPurchased) {
				var _this3 = this;
	
				var newActivePet = Object.assign({}, this.state.petAttrs, {
					petType: this.props.petType
				});
	
				// If the current cat is special, keep the special name.
				if (this.props.activePetAttrs.name.special) {
					newActivePet.name = this.props.activePetAttrs.name;
				}
	
				this.props.setActivePet(newActivePet);
				setTimeout(function () {
					_this3.props.closePetPicker();
				}, 100);
			}
		}, {
			key: 'buyPet',
			value: function buyPet() {
				var _this4 = this;
	
				clearTimeout(this.errorTimeout);
	
				if (!navigator.onLine) {
					this.setState({ isOffline: true });
	
					this.errorTimeout = setTimeout(function () {
						_this4.setState({ isOffline: false });
					}, 3000);
	
					return;
				}
	
				this.props.buyPet(this.props.sku);
			}
		}, {
			key: 'onClick',
			value: function onClick() {
				if (this.props.isCollected) {
					this.setNewActivePet();
					return;
				}
	
				this.buyPet();
			}
		}, {
			key: 'getPetAttrs',
			value: function getPetAttrs() {
				var petAttrs = _getRandom2.default.petOfTypeForPetPicker(this.props.petType.type);
	
				// If this pet is active it be the same.
				if (this.props.isActive) return this.props.activePetAttrs;
				// Unpurchased pets always like to be pet.
				if (!this.props.isCollected) petAttrs.likesPets = 'likes';
	
				return petAttrs;
			}
		}, {
			key: 'render',
			value: function render() {
				// This item is coming soon, either because it's INACTIVE or it's not in the codebase.
				if (this.props.isComingSoon) {
					return _react2.default.createElement(
						'div',
						{ className: this.getClassNames() },
						_react2.default.createElement(_Pet2.default, {
							petType: { name: 'ComingSoon' },
							name: { full: this.props.name }
						})
					);
				}
	
				return _react2.default.createElement(
					'div',
					{
						className: this.getClassNames(),
						onClick: this.onClick,
						onMouseEnter: this.setHover,
						onMouseLeave: this.unsetHover,
						onMouseDown: this.setClick,
						onMouseUp: this.unsetClick
					},
					_react2.default.createElement(_Pet2.default, Object.assign({
						petType: this.props.petType
					}, this.state.petAttrs, {
						name: { full: this.props.name },
						kitten: null,
						disablePetting: !this.props.isCollected
					})),
					_react2.default.createElement(_NewBadge2.default, {
						shouldShow: this.props.isNew,
						isHover: this.state.isHover,
						isClick: this.state.isClick
					}),
					_react2.default.createElement(_PriceBadge2.default, {
						price: this.props.price,
						isHover: this.state.isHover,
						isClick: this.state.isClick,
						unpurchased: !this.props.isCollected,
						loading: this.props.purchaseLoading,
						success: this.props.purchaseSuccess,
						offline: this.state.isOffline
					})
				);
			}
		}]);
	
		return PetItem;
	}(_react2.default.Component);
	
	PetItem.propTypes = {
		petType: _propTypes2.default.shape({
			sku: _propTypes2.default.string,
			type: _propTypes2.default.string,
			name: _propTypes2.default.string
		}),
		price: _propTypes2.default.number,
		isCollected: _propTypes2.default.bool,
		// isJustPurchased: PropTypes.bool,
		isComingSoon: _propTypes2.default.bool,
		setActivePet: _propTypes2.default.func.isRequired,
		buyPet: _propTypes2.default.func.isRequired
	};
	
	PetItem.defaultProps = {
		petType: {},
		price: null,
		isCollected: true,
		isJustPurchased: false,
		isComingSoon: false
	};
	
	var mapStateToProps = function mapStateToProps(state) {
		return {
			activePetAttrs: state.activePet.active
		};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			setActivePet: function setActivePet(pet) {
				dispatch((0, _activePet.setActivePetAsync)(pet));
			},
			buyPet: function buyPet(sku) {
				dispatch((0, _googleApi.buyPet)(sku));
			}
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PetItem);

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(22);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetItem = __webpack_require__(429);
	
	var _PetItem2 = _interopRequireDefault(_PetItem);
	
	var _ErrorBanner = __webpack_require__(427);
	
	var _ErrorBanner2 = _interopRequireDefault(_ErrorBanner);
	
	var _getAvailablePets = __webpack_require__(605);
	
	var _getAvailablePets2 = _interopRequireDefault(_getAvailablePets);
	
	var _getComingSoonPets = __webpack_require__(606);
	
	var _getComingSoonPets2 = _interopRequireDefault(_getComingSoonPets);
	
	var _getCollectedPets = __webpack_require__(255);
	
	var _getCollectedPets2 = _interopRequireDefault(_getCollectedPets);
	
	var _getNewPets = __webpack_require__(86);
	
	var _getNewPets2 = _interopRequireDefault(_getNewPets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getName(pet) {
		if (pet.localeData) {
			var thisLocale = _lodash2.default.find(pet.localeData, ['languageCode', 'all']) || _lodash2.default.find(pet.localeData, ['languageCode', 'en-US']);
			return _lodash2.default.get(thisLocale, 'title');
		}
		// If there's no locale data, its displayName is defined in constants.
		return pet.displayName;
	}
	
	function getPrice(pet) {
		var priceData = _lodash2.default.find(pet.prices, ['currencyCode', 'USD']);
		var price = 1;
	
		// If there's no USD price, just return 1.
		if (!priceData) {
			return price;
		}
	
		price = priceData.valueMicros * 0.000001; // Turn micros to dollars.
		price = parseInt(price.toFixed(0), 10); // Give it no decimals, turn it to number.
		return price;
	}
	
	function getIsActive(pet, activePet) {
		return activePet.petType.name === pet.petType.name;
	}
	
	var PetList = function (_React$Component) {
		_inherits(PetList, _React$Component);
	
		function PetList() {
			_classCallCheck(this, PetList);
	
			var _this = _possibleConstructorReturn(this, (PetList.__proto__ || Object.getPrototypeOf(PetList)).call(this));
	
			_this.state = {
				newAvailablePets: [],
				isOpen: false
			};
	
			_this.isOpenTimeout = null;
			return _this;
		}
	
		_createClass(PetList, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				// Save the new availablePets to state, so that when they're cleared by the PetPicker we still can show what's new.
				this.setState({ newAvailablePets: this.props.newAvailablePets });
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.isOpen !== this.props.isOpen) {
					this.togglePetList(nextProps.isOpen);
				}
	
				// When the PetPicker was open and then gets closed, clear our state to reflect the updated redux store.
				if (this.props.isOpen && !nextProps.isOpen && !_lodash2.default.isEmpty(this.state.newAvailablePets)) {
					this.setState({ newAvailablePets: [] });
					return;
				}
	
				if (!_lodash2.default.isEmpty(nextProps.newAvailablePets)) {
					this.setState({ newAvailablePets: nextProps.newAvailablePets });
				}
			}
		}, {
			key: 'togglePetList',
			value: function togglePetList(willBeOpen) {
				var _this2 = this;
	
				clearTimeout(this.isOpenTimeout);
	
				if (willBeOpen) {
					this.setState({ isOpen: true });
				} else {
					this.isOpenTimeout = setTimeout(function () {
						_this2.setState({ isOpen: false });
					}, 500);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				if (!this.state.isOpen) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'pet-picker__list' },
					_react2.default.createElement(_ErrorBanner2.default, { error: this.props.error }),
					this.props.availablePets.map(function (pet) {
						return _react2.default.createElement(_PetItem2.default, {
							key: pet.sku,
							petType: pet.petType,
							name: getName(pet),
							price: getPrice(pet),
							sku: pet.sku,
							isActive: getIsActive(pet, _this3.props.activePet),
							moreThanOneCollectedPet: _this3.props.moreThanOneCollectedPet,
							isCollected: pet.isCollected,
							isNew: _lodash2.default.find(_this3.state.newAvailablePets, ['sku', pet.sku]),
							purchaseLoading: _lodash2.default.get(_this3.props.purchases[pet.sku], 'isLoading'),
							purchaseSuccess: _lodash2.default.get(_this3.props.purchases[pet.sku], 'success'),
							closePetPicker: _this3.props.closePetPicker
						});
					}),
					this.props.comingSoonPets.map(function (pet) {
						return _react2.default.createElement(_PetItem2.default, {
							isComingSoon: true,
							key: pet.sku,
							petType: pet.petType,
							name: getName(pet),
							sku: pet.sku
						});
					})
				);
			}
		}]);
	
		return PetList;
	}(_react2.default.Component);
	
	// TODO prop validation
	
	
	PetList.PropTypes = {
		activePet: _propTypes2.default.shape({
			sku: _propTypes2.default.string,
			type: _propTypes2.default.string.isRequired,
			name: _propTypes2.default.string.isRequired
		})
	};
	
	var mapStateToProps = function mapStateToProps(state) {
		return {
			moreThanOneCollectedPet: (0, _getCollectedPets2.default)(state.allPets).length > 1,
			availablePets: (0, _getAvailablePets2.default)(state.allPets),
			newAvailablePets: (0, _getNewPets2.default)(state.allPets),
			comingSoonPets: (0, _getComingSoonPets2.default)(state.allPets),
			activePet: state.activePet.active,
			error: state.lastVerification.error,
			purchases: state.purchases
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PetList);

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = PetPickerFooter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PetPickerFooter() {
		return _react2.default.createElement(
			"div",
			{ className: "pet-picker__footer" },
			_react2.default.createElement(
				"div",
				{ className: "pet-picker__footer__item" },
				"All prices are listed in USD ($)."
			),
			_react2.default.createElement(
				"a",
				{
					className: "pet-picker__footer__item pet-picker__footer__item--link",
					href: "https://tabbycats.club/faq",
					target: "_blank",
					rel: "noopener noreferrer" },
				"Frequently Asked Questions"
			)
		);
	}

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icons = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PriceBadge(_ref) {
		var price = _ref.price,
		    isHover = _ref.isHover,
		    isClick = _ref.isClick,
		    unpurchased = _ref.unpurchased,
		    loading = _ref.loading,
		    offline = _ref.offline,
		    success = _ref.success;
	
		var classes = (0, _classnames2.default)('pet-picker__list__item__price-badge', {
			'pet-picker__list__item__price-badge--is-hover': isHover,
			'pet-picker__list__item__price-badge--is-click': isClick,
			'pet-picker__list__item__price-badge--is-unpurchased': unpurchased,
			'pet-picker__list__item__price-badge--purchase-loading': loading,
			'pet-picker__list__item__price-badge--purchase-success': success,
			'pet-picker__list__item__price-badge--is-offline': offline
		});
	
		return _react2.default.createElement(
			'div',
			{ className: classes },
			_react2.default.createElement(_Icons.PriceBadgeSVG, null),
			_react2.default.createElement(
				'div',
				{ className: 'price-badge__price' },
				_react2.default.createElement(
					'div',
					{ className: 'price-badge__buy-for' },
					'Buy for'
				),
				'$',
				price
			),
			_react2.default.createElement(
				'div',
				{ className: 'price-badge__offline' },
				'You\u2019re Offline'
			)
		);
	}
	
	exports.default = PriceBadge;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ControlButton = __webpack_require__(53);
	
	var _ControlButton2 = _interopRequireDefault(_ControlButton);
	
	var _PetList = __webpack_require__(430);
	
	var _PetList2 = _interopRequireDefault(_PetList);
	
	var _PetPickerFooter = __webpack_require__(431);
	
	var _PetPickerFooter2 = _interopRequireDefault(_PetPickerFooter);
	
	var _allPets = __webpack_require__(83);
	
	var _activePet = __webpack_require__(52);
	
	var _purchases = __webpack_require__(248);
	
	var _getNewPets = __webpack_require__(86);
	
	var _getNewPets2 = _interopRequireDefault(_getNewPets);
	
	var _getCollectedPets = __webpack_require__(255);
	
	var _getCollectedPets2 = _interopRequireDefault(_getCollectedPets);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PetPicker = function (_React$Component) {
		_inherits(PetPicker, _React$Component);
	
		function PetPicker() {
			_classCallCheck(this, PetPicker);
	
			var _this = _possibleConstructorReturn(this, (PetPicker.__proto__ || Object.getPrototypeOf(PetPicker)).call(this));
	
			_this.state = {
				isOpen: false,
				toggleClicks: 0
			};
	
			_this.shuffleClosesPetPickerTimeout = null;
	
			_this.getClassNames = _this.getClassNames.bind(_this);
			_this.togglePetPicker = _this.togglePetPicker.bind(_this);
			_this.closePetPicker = _this.closePetPicker.bind(_this);
			_this.onKeyPress = _this.onKeyPress.bind(_this);
			_this.renderShuffle = _this.renderShuffle.bind(_this);
			_this.setShuffle = _this.setShuffle.bind(_this);
			return _this;
		}
	
		_createClass(PetPicker, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				document.addEventListener("keydown", this.onKeyPress);
			}
		}, {
			key: 'onKeyPress',
			value: function onKeyPress(e) {
				if (e.code === 'Escape' && this.state.isOpen) {
					this.closePetPicker();
				}
			}
		}, {
			key: 'getClassNames',
			value: function getClassNames() {
				return (0, _classnames2.default)('pet-picker', {
					'pet-picker--is-open': this.state.isOpen,
					'pet-picker--has-new-pets': this.props.hasNewPets && !this.state.isOpen
				});
			}
		}, {
			key: 'shouldClearNewPets',
			value: function shouldClearNewPets() {
				if (this.state.toggleClicks === 1) this.props.clearNewPets();
			}
		}, {
			key: 'shouldClearPurchases',
			value: function shouldClearPurchases() {
				if (!_lodash2.default.isEmpty(this.props.purchases)) this.props.clearPurchases();
			}
		}, {
			key: 'closePetPicker',
			value: function closePetPicker() {
				this.setState({ isOpen: false }, this.shouldClearPurchases);
			}
		}, {
			key: 'openPetPicker',
			value: function openPetPicker() {
				this.setState({ isOpen: true });
			}
		}, {
			key: 'togglePetPicker',
			value: function togglePetPicker() {
				var lastToggleClicks = this.state.toggleClicks;
				this.setState({ toggleClicks: lastToggleClicks + 1 }, this.shouldClearNewPets);
	
				if (this.state.isOpen) {
					this.closePetPicker();
				} else {
					this.openPetPicker();
				}
			}
		}, {
			key: 'setShuffle',
			value: function setShuffle() {
				var _this2 = this;
	
				var lastShuffleState = this.props.shuffleIsActive;
	
				clearTimeout(this.shuffleClosesPetPickerTimeout);
	
				this.props.setShuffle();
	
				// Close the petpicker if shuffle is now active
				if (!lastShuffleState) {
					this.shuffleClosesPetPickerTimeout = setTimeout(function () {
						_this2.closePetPicker();
					}, 200);
				}
			}
		}, {
			key: 'renderShuffle',
			value: function renderShuffle() {
				if (!this.props.shouldShowShuffle) {
					return null;
				}
	
				return _react2.default.createElement(_ControlButton2.default, {
					shuffle: true,
					isActive: this.props.shuffleIsActive,
					callback: this.setShuffle
				});
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.props.purchasesNotSupportedForCountry) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: this.getClassNames(), onKeyPress: this.onKeyPress },
					_react2.default.createElement(
						'div',
						{ className: 'pet-picker__controls' },
						_react2.default.createElement(_ControlButton2.default, {
							className: 'pet-picker',
							iconName: 'House',
							isActive: this.state.isOpen,
							hasNotification: this.props.hasNewPets && !this.state.isOpen,
							notificationMessage: 'New Pets!',
							label: 'Pets',
							callback: this.togglePetPicker
						}),
						this.renderShuffle(),
						_react2.default.createElement(_ControlButton2.default, {
							className: 'close-pet-picker',
							iconName: 'X',
							callback: this.togglePetPicker
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'pet-picker__page' },
						_react2.default.createElement(_PetList2.default, {
							isOpen: this.state.isOpen,
							closePetPicker: this.closePetPicker
						})
					)
				);
			}
		}]);
	
		return PetPicker;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
		return {
			hasNewPets: !_lodash2.default.isEmpty((0, _getNewPets2.default)(state.allPets)),
			shouldShowShuffle: (0, _getCollectedPets2.default)(state.allPets).length > 1,
			shuffleIsActive: state.activePet.shuffle,
			purchases: state.purchases,
			purchasesNotSupportedForCountry: state.lastVerification.error === _constants.PURCHASES_NOT_SUPPORTED_FOR_COUNTRY
		};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			clearNewPets: function clearNewPets() {
				dispatch((0, _allPets.removeNewnessFromPets)());
			},
			setShuffle: function setShuffle() {
				dispatch((0, _activePet.setShuffleAsync)());
			},
			clearPurchases: function clearPurchases() {
				dispatch((0, _purchases.clearPurchases)());
			}
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PetPicker);

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ControlButton = __webpack_require__(53);
	
	var _ControlButton2 = _interopRequireDefault(_ControlButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShopBox() {
		return _react2.default.createElement(
			'a',
			{ className: 'shopbox',
				href: 'https://tabbycats.club/shop',
				target: '_blank',
				rel: 'noopener noreferrer' },
			_react2.default.createElement(_ControlButton2.default, {
				className: 'shopbox',
				iconName: 'ShopBox',
				label: 'Gifts',
				reverseFlow: true
			})
		);
	}
	
	exports.default = ShopBox;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ControlButton = __webpack_require__(53);
	
	var _ControlButton2 = _interopRequireDefault(_ControlButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Snapshot = function (_React$Component) {
		_inherits(Snapshot, _React$Component);
	
		function Snapshot(props) {
			_classCallCheck(this, Snapshot);
	
			var _this = _possibleConstructorReturn(this, (Snapshot.__proto__ || Object.getPrototypeOf(Snapshot)).call(this, props));
	
			_this.state = {
				snapshotId: null,
				isLoading: false,
				error: false
			};
	
			_this.getSnapshot = _this.getSnapshot.bind(_this);
			_this.renderSnapshotUrl = _this.renderSnapshotUrl.bind(_this);
			_this.getClassNames = _this.getClassNames.bind(_this);
			return _this;
		}
	
		_createClass(Snapshot, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				// If the pet or its goodies changed, reset the snapshot.
				if (!_lodash2.default.isEqual(this.props.activePet, nextProps.activePet) || !_lodash2.default.isEqual(this.props.activeGoodies, nextProps.activeGoodies)) {
					this.resetSnapshot();
				}
			}
		}, {
			key: 'getClassNames',
			value: function getClassNames() {
				return (0, _classnames2.default)('snapshot', {
					'snapshot--is-loading': this.state.isLoading,
					'snapshot--has-url': this.state.snapshotId
				});
			}
		}, {
			key: 'getSnapshot',
			value: function getSnapshot() {
				// If there's already a snapshot, don't get a new one.
				if (this.state.snapshotId) {
					return;
				}
	
				// Otherwise, set the loading state and call the fetch.
				this.setState({ isLoading: true }, this.saveCatToDatabase);
			}
		}, {
			key: 'resetSnapshot',
			value: function resetSnapshot() {
				this.setState({ snapshotId: null });
			}
		}, {
			key: 'saveCatToDatabase',
			value: function saveCatToDatabase() {
				var _this2 = this;
	
				// Put together the cat to save.
				var thisCat = Object.assign({}, this.props.activePet, this.props.activeGoodies);
	
				// TODO change this to the production URL
				fetch('https://tabbycats.club/save', {
					method: 'POST',
					mode: 'cors',
					cache: 'default',
					body: JSON.stringify(thisCat),
					headers: {
						'Content-Type': 'application/json',
						'Access-Control-Request-Method': 'post',
						'Access-Control-Allow-Credentials': 'true',
						'Access-Control-Allow-Origin': '*'
					}
				}).then(function (response) {
					return response.text();
				}).then(function (text) {
					// Save the snapshot ID and set loading to false.
					_this2.setState({
						snapshotId: text,
						error: false
					});
	
					// This timeout lets the flash animation reach its apex
					setTimeout(function () {
						_this2.setState({ isLoading: false });
					}, 100);
				}).catch(function (err) {
					_this2.setState({ error: true, isLoading: false });
					console.error('Snapshot error: ', err);
				});
			}
		}, {
			key: 'renderSnapshotUrl',
			value: function renderSnapshotUrl() {
				// If there's no snapshotId, don't show a link.
				if (!this.state.snapshotId) {
					return null;
				}
	
				// TODO change this to the production server URL
				return _react2.default.createElement(
					'a',
					{
						className: 'snapshot__url',
						href: 'https://tabbycats.club/cat/' + this.state.snapshotId,
						target: '_blank',
						rel: 'noopener noreferrer' },
					'tabbycats.club/',
					this.state.snapshotId
				);
			}
		}, {
			key: 'render',
			value: function render() {
				// Show the snapshot URL or the "Snapshot!" cta
				var label = this.state.error ? _react2.default.createElement(
					'span',
					null,
					'Oops, it didn\u2019t work.',
					_react2.default.createElement('br', null),
					'Do you have internet?'
				) : this.renderSnapshotUrl() || 'Snapshot';
	
				var persistLabel = !!this.state.snapshotId || !!this.state.error;
	
				// Disable the callback if we already have a snapshotId
				var callback = this.state.snapshotId ? null : this.getSnapshot;
	
				return _react2.default.createElement(
					'div',
					{ className: this.getClassNames() },
					_react2.default.createElement(_ControlButton2.default, {
						className: 'snapshot',
						iconName: 'Camera',
						persistLabel: persistLabel,
						label: label,
						callback: callback,
						reverseFlow: true
					})
				);
			}
		}]);
	
		return Snapshot;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
		return {
			activePet: state.activePet.active,
			activeGoodies: state.activeGoodies.active
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Snapshot);

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC4 = __webpack_require__(6);
	
	var _PositionedGoodyHOC5 = _interopRequireDefault(_PositionedGoodyHOC4);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '55.97804', cy: '5.50389' }),
					_react2.default.createElement(
						'g',
						{ opacity: '0.6' },
						_react2.default.createElement('path', { fill: '#222222', d: 'M111.14455,5.47389c-0.10742-0.42334-0.39258-0.7793-0.7832-0.97461 c-0.53027-0.26562-13.13867-6.47412-26.18945-3.18799C71.12013,4.59694,62.95412,16.03444,62.6133,16.51979 c-0.25195,0.35693-0.33496,0.80566-0.22852,1.229c0.10742,0.42334,0.39258,0.7793,0.7832,0.97461 c0.41992,0.21045,8.40918,4.14502,18.19531,4.14502c2.5752,0,5.27539-0.27246,7.99414-0.95703 c13.05176-3.28564,21.21777-14.72314,21.55859-15.2085C111.16798,6.34596,111.25099,5.89723,111.14455,5.47389z' }),
						_react2.default.createElement('path', { fill: '#222222', d: 'M27.78517,1.31129C14.73048-1.97484,2.12502,4.23365,1.59474,4.49928 c-0.39062,0.19531-0.67578,0.55127-0.7832,0.97461c-0.10645,0.42334-0.02344,0.87207,0.22852,1.229 c0.34082,0.48535,8.50684,11.92285,21.55859,15.2085c2.71973,0.68457,5.41797,0.95703,7.99414,0.95703 c9.78516,0,17.77539-3.93457,18.19531-4.14502c0.39062-0.19531,0.67578-0.55127,0.7832-0.97461 c0.10645-0.42334,0.02344-0.87207-0.22852-1.229C49.00197,16.03444,40.83693,4.59694,27.78517,1.31129z' })
					),
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement('path', { fill: '#222222', d: 'M64.34875,19.26623l-1.13379-0.52051c-0.42578-0.19531-4.24609-1.90771-7.23633-1.90771 c-2.98535,0-6.81152,1.71289-7.2373,1.9082l-1.13281,0.51855l-0.71875-1.01855 C46.81263,18.13635,39.0011,7.22863,27.05286,4.22033C15.10559,1.21252,3.05774,7.12072,2.93762,7.18078L1.84486,7.72637 L0.35865,5.80303C0.16328,5.5502,0.24637,5.18199,0.53138,5.03756l1.06347-0.53891 c0.53125-0.26562,13.14062-6.47217,26.19043-3.1875c10.98731,2.76611,18.5127,11.31055,20.82129,14.23242 c1.65723-0.66406,4.68652-1.70557,7.37207-1.70557c2.68848,0,5.71484,1.04102,7.37207,1.70508 C65.6593,12.62072,73.18469,4.07727,84.172,1.31115c13.05176-3.28564,25.65918,2.92188,26.18945,3.1875l1.04665,0.53327 c0.28721,0.14633,0.3713,0.51732,0.17526,0.77319l-1.47195,1.92124l-1.09274-0.54558 c-0.12109-0.06006-12.16992-5.96924-24.11426-2.96045C72.922,7.23694,65.14368,18.13537,65.06653,18.24524L64.34875,19.26623z' })
					)
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC5.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '40.07384', cy: '5.39768' }),
					_react2.default.createElement(
						'g',
						{ opacity: '0.6' },
						_react2.default.createElement('path', { fill: '#222222', d: 'M78.6904,4.37668c-0.0752-0.29634-0.2748-0.54551-0.54824-0.68223 c-0.37119-0.18594-9.19707-4.53188-18.33262-2.23159C50.67331,3.76281,44.9571,11.76906,44.71852,12.1088 c-0.17637,0.24985-0.23447,0.56396-0.15996,0.8603c0.0752,0.29634,0.2748,0.54551,0.54824,0.68223 c0.29395,0.14731,5.88643,2.90151,12.73672,2.90151c1.80264,0,3.69277-0.19072,5.5959-0.66992 c9.13623-2.29995,14.85244-10.3062,15.09102-10.64595C78.7068,4.98712,78.76491,4.67301,78.6904,4.37668z' }),
						_react2.default.createElement('path', { fill: '#222222', d: 'M20.33884,1.46286C11.20055-0.83744,2.37673,3.50851,2.00554,3.69445 C1.7321,3.83117,1.53249,4.08034,1.45729,4.37668c-0.07451,0.29634-0.01641,0.61045,0.15996,0.8603 c0.23857,0.33975,5.95479,8.346,15.09101,10.64595c1.90381,0.4792,3.79258,0.66992,5.5959,0.66992 c6.84961,0,12.44277-2.7542,12.73672-2.90151c0.27344-0.13672,0.47305-0.38589,0.54824-0.68223 c0.07451-0.29634,0.01641-0.61045-0.15996-0.8603C35.19059,11.76906,29.47507,3.76281,20.33884,1.46286z' })
					),
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement('path', { fill: '#222222', d: 'M45.93335,14.03132l-0.79365-0.36436c-0.29805-0.13672-2.97227-1.3354-5.06543-1.3354 c-2.08974,0-4.76807,1.19902-5.06611,1.33574l-0.79297,0.36299l-0.50312-0.71299c-0.054-0.0769-5.52207-7.7123-13.88584-9.81812 C11.46313,1.39372,3.02964,5.52946,2.94555,5.5715L2.18062,5.95341L1.14027,4.60707 c-0.13676-0.17698-0.0786-0.43473,0.12091-0.53583l0.74443-0.37724c0.37188-0.18594,9.19844-4.53052,18.3333-2.23125 c7.69111,1.93628,12.95889,7.91738,14.5749,9.9627c1.16006-0.46484,3.28057-1.1939,5.16045-1.1939 c1.88194,0,4.00039,0.72871,5.16045,1.19355c1.61602-2.04565,6.88379-8.02607,14.5749-9.96235 c9.13623-2.29995,17.96143,2.04531,18.33262,2.23125l0.73266,0.37329c0.20104,0.10243,0.2599,0.36212,0.12268,0.54123 l-1.03036,1.34487l-0.76492-0.3819c-0.08477-0.04204-8.51894-4.17847-16.87998-2.07231 c-8.3877,2.11162-13.83252,9.74053-13.88652,9.81743L45.93335,14.03132z' })
					)
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC5.default);
	
	var Chicken = function (_PositionedGoodyHOC3) {
		_inherits(Chicken, _PositionedGoodyHOC3);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '45.50642', cy: '7.78016' }),
					_react2.default.createElement(
						'g',
						{ opacity: '0.6' },
						_react2.default.createElement('path', { fill: '#222222', d: 'M88.72694,5.75665c-0.08416-0.33167-0.30757-0.61054-0.61361-0.76356 C87.69788,4.78498,77.81976-0.0791,67.59505,2.49544C57.36958,5.0696,50.97187,14.03037,50.70485,14.41063 c-0.1974,0.27964-0.26243,0.6312-0.17903,0.96287c0.08416,0.33167,0.30757,0.61055,0.61361,0.76356 c0.32899,0.16488,6.58822,3.24744,14.25522,3.24744c2.01755,0,4.13303-0.21346,6.26305-0.74979 C81.88317,16.06055,88.28088,7.09977,88.5479,6.71952C88.7453,6.43988,88.81033,6.08832,88.72694,5.75665z' }),
						_react2.default.createElement('path', { fill: '#222222', d: 'M23.41856,2.49544C13.19079-0.0791,3.31496,4.78498,2.89951,4.99309 c-0.30604,0.15302-0.52944,0.4319-0.6136,0.76356c-0.0834,0.33167-0.01836,0.68323,0.17903,0.96287 c0.26702,0.38025,6.66473,9.34103,16.8902,11.91518c2.13078,0.53633,4.24474,0.74979,6.26306,0.74979 c7.66623,0,13.92623-3.08256,14.25522-3.24744c0.30604-0.15302,0.52945-0.4319,0.61361-0.76356 c0.0834-0.33167,0.01836-0.68323-0.17903-0.96287C40.04098,14.03037,33.64403,5.0696,23.41856,2.49544z' })
					),
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement('path', { fill: '#222222', d: 'M52.06451,16.56234l-0.88828-0.40779c-0.33358-0.15302-3.32663-1.49461-5.66934-1.49461 c-2.33889,0-5.33652,1.34197-5.6701,1.49499l-0.88751,0.40626l-0.56311-0.79799 c-0.06044-0.08607-6.18042-8.63178-15.54134-10.98866C13.48467,2.41806,4.04571,7.04688,3.9516,7.09393L3.09547,7.52137 L1.93109,6.01452C1.77803,5.81644,1.84312,5.52796,2.06642,5.41481L2.8996,4.9926 c0.41621-0.20811,10.2951-5.07066,20.51904-2.49727c8.60806,2.16713,14.50388,8.86131,16.31256,11.15047 c1.29836-0.52026,3.67168-1.33624,5.77569-1.33624c2.1063,0,4.47733,0.81559,5.77569,1.33585 c1.80868-2.28954,7.70449-8.98296,16.31256-11.15009C77.82061-0.07882,87.69797,4.78449,88.11342,4.9926l0.82,0.4178 c0.22501,0.11464,0.2909,0.4053,0.13731,0.60576l-1.15321,1.50521l-0.85612-0.42743 c-0.09487-0.04705-9.53459-4.67663-18.89245-2.31938c-9.3877,2.36337-15.48167,10.90182-15.54211,10.98789L52.06451,16.56234z' })
					)
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC5.default);
	
	function Alien(props) {
		var glasses = {
			Cat: Cat,
			Tortoise: Tortoise,
			Chicken: Chicken
		};
	
		var ThisAlien = glasses[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisAlien)) {
			return null;
		}
	
		return _react2.default.createElement(ThisAlien, props);
	}
	
	exports.default = Alien;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC4 = __webpack_require__(6);
	
	var _PositionedGoodyHOC5 = _interopRequireDefault(_PositionedGoodyHOC4);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '62.20683', cy: '18.69299' }),
					_react2.default.createElement(
						'g',
						{ opacity: '0.2' },
						_react2.default.createElement('path', { fill: '#F2F2F2', d: 'M53.82021,17.4994c-23.60217,0-38.76643,6.58329-46.17512,12.91898 c-1.64551,1.40723-0.95521-11.84636-0.40426-14.13902C9.43356,7.15493,16.89122,2.24953,30.03012,2.24953 S53.82021,4.3605,53.82021,17.4994z' })
					),
					_react2.default.createElement(
						'g',
						{ opacity: '0.2' },
						_react2.default.createElement('path', { fill: '#F2F2F2', d: 'M70.62128,17.4994c23.60217,0,38.76643,6.58329,46.17512,12.91898 c1.64551,1.40723,0.95522-11.84636,0.40426-14.13902c-2.19273-9.12444-9.65038-14.02984-22.78929-14.02984 S70.62128,4.3605,70.62128,17.4994z' })
					),
					_react2.default.createElement('path', { fill: '#FFEAAE', d: 'M124.44001,15.43018c0.00684-0.77832,0.0127-1.51367-0.50195-2.03271 c-0.30176-0.30322-0.7207-0.45703-1.24805-0.45703h-4.18945C115.21882,4.35986,107.14314,0,94.41169,0 c-0.08398,0-0.16699,0.00098-0.25098,0.00122V0H30.28083v0.00122C30.19684,0.00098,30.11383,0,30.02985,0 C17.2984,0,9.22272,4.35986,5.94098,12.94043H1.75153c-0.52734,0-0.94629,0.15381-1.24805,0.45703 c-0.51465,0.51904-0.50879,1.25439-0.50195,2.03271l0.00098,0.26025l-0.00098,0.26025 c-0.00684,0.77832-0.0127,1.51367,0.50195,2.03271c0.30176,0.30322,0.7207,0.45703,1.24805,0.45703H4.5362 c-1.10059,7.31421,0.52539,14.30518,4.62256,19.50244c4.08398,5.18262,10.19629,8.03662,17.21094,8.03662 c18.2749,0,29.3125-13.99268,29.68262-27.76611l0.08398-0.15381c0.02051-0.03613,2.01562-3.59424,6.06934-3.59424 c4.04981,0,6.02246,3.46191,6.1045,3.60938l0.0791,0.14258C68.7613,31.98926,79.7989,45.97949,98.07185,45.97949 c7.01465,0,13.12695-2.854,17.21094-8.03662c4.09717-5.19727,5.72314-12.18823,4.62256-19.50244h2.78467 c0.52734,0,0.94629-0.15381,1.24805-0.45703c0.51465-0.51904,0.50879-1.25439,0.50195-2.03271l-0.00098-0.26025L124.44001,15.43018 z M9.42829,16.80518C11.3902,8.64014,18.32184,4.5,30.02985,4.5c13.64258,0,21.54004,2.12695,21.54004,12.99902 c0,11.7876-9.42578,23.98047-25.2002,23.98047c-5.60645,0-10.46387-2.24512-13.67773-6.32178 C8.95563,30.41553,7.7652,23.72607,9.42829,16.80518z M50.54303,4.5h23.35547c-2.29102,1.75293-3.98779,4.16748-4.86133,7.46558 c-1.65527-1.22607-3.91455-2.27417-6.83155-2.27417c-2.91064,0-5.15869,1.03857-6.80615,2.25781 C54.52497,8.65942,52.83014,6.25,50.54303,4.5z M94.41169,4.5c11.70801,0,18.63965,4.14014,20.60156,12.30518 c1.66309,6.9209,0.47266,13.61035-3.26367,18.35254c-3.21387,4.07666-8.07129,6.32178-13.67773,6.32178 c-15.77441,0-25.2002-12.19287-25.2002-23.98047C72.87165,6.62695,80.76911,4.5,94.41169,4.5z' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC5.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '32.96962', cy: '9.90729' }),
					_react2.default.createElement(
						'g',
						{ opacity: '0.2' },
						_react2.default.createElement('path', { fill: '#F2F2F2', d: 'M28.52471,9.27468c-12.50915,0-20.54621,3.48914-24.47281,6.84706 c-0.87212,0.74583-0.50626-6.27857-0.21426-7.49368c1.16215-4.83595,5.1147-7.43581,12.07832-7.43581 S28.52471,2.31106,28.52471,9.27468z' })
					),
					_react2.default.createElement(
						'g',
						{ opacity: '0.2' },
						_react2.default.createElement('path', { fill: '#F2F2F2', d: 'M37.42928,9.27468c12.50915,0,20.54621,3.48914,24.47282,6.84706 c0.87212,0.74583,0.50626-6.27857,0.21425-7.49368c-1.16214-4.83595-5.1147-7.43581-12.07832-7.43581 S37.42928,2.31106,37.42928,9.27468z' })
					),
					_react2.default.createElement('path', { fill: '#FFEAAE', d: 'M65.9532,8.17799c0.00362-0.41251,0.00673-0.80225-0.26603-1.07734 c-0.15993-0.16071-0.38197-0.24223-0.66147-0.24223h-2.22041C61.06597,2.31073,56.78586,0,50.03819,0 c-0.04451,0-0.0885,0.00052-0.13301,0.00065V0H16.04884v0.00065C16.00433,0.00052,15.96033,0,15.91582,0 C9.16815,0,4.88804,2.31073,3.14872,6.85843H0.92831c-0.27949,0-0.50153,0.08152-0.66146,0.24223 c-0.27276,0.27509-0.26966,0.66483-0.26604,1.07734l0.00052,0.13793L0.00081,8.45386 C-0.00281,8.86637-0.00592,9.25611,0.26685,9.5312c0.15993,0.16071,0.38197,0.24223,0.66146,0.24223h1.47587 c-0.58331,3.87653,0.27846,7.58174,2.44996,10.33629c2.16451,2.74679,5.40403,4.25941,9.1218,4.25941 c9.6857,0,15.53562-7.41612,15.73179-14.71604l0.04451-0.08152c0.01087-0.01915,1.06828-1.90495,3.21675-1.90495 c2.1464,0,3.1919,1.83481,3.23538,1.91297l0.04192,0.07557c0.1972,7.29915,6.04713,14.71397,15.73179,14.71397 c3.71776,0,6.95729-1.51262,9.1218-4.25941c2.1715-2.75455,3.03327-6.45976,2.44996-10.33629h1.47587 c0.2795,0,0.50153-0.08152,0.66147-0.24223c0.27276-0.27509,0.26965-0.66483,0.26603-1.07734l-0.00052-0.13793L65.9532,8.17799z M4.99699,8.90674C6.03681,4.57927,9.71058,2.385,15.91582,2.385c7.23057,0,11.41622,1.12729,11.41622,6.88948 c0,6.24743-4.99566,12.70965-13.3561,12.70965c-2.97142,0-5.54585-1.18991-7.2492-3.35054 C4.74648,16.12023,4.11556,12.57482,4.99699,8.90674z M26.78781,2.385h12.3784c-1.21424,0.92905-2.11353,2.20876-2.5765,3.95676 c-0.8773-0.64982-2.07471-1.20531-3.62072-1.20531c-1.54264,0-2.73411,0.55044-3.60726,1.19664 C28.89823,4.58949,27.99998,3.3125,26.78781,2.385z M50.03819,2.385c6.20525,0,9.87901,2.19427,10.91883,6.52174 c0.88144,3.66808,0.25051,7.21349-1.72975,9.72685c-1.70335,2.16063-4.27778,3.35054-7.2492,3.35054 c-8.36044,0-13.3561-6.46222-13.3561-12.70965C38.62197,3.51229,42.80763,2.385,50.03819,2.385z' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC5.default);
	
	var Chicken = function (_PositionedGoodyHOC3) {
		_inherits(Chicken, _PositionedGoodyHOC3);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '43.54478', cy: '13.08509', r: '0' }),
					_react2.default.createElement(
						'g',
						{ opacity: '0.2' },
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('path', { fill: '#F2F2F2', d: 'M37.67415,12.24958c-16.52152,0-27.1365,4.6083-32.32259,9.04329 c-1.15186,0.98506-0.66865-8.29245-0.28298-9.89731c1.53491-6.3871,6.75527-9.82089,15.9525-9.82089 S37.67415,3.05235,37.67415,12.24958z' })
						)
					),
					_react2.default.createElement(
						'g',
						{ opacity: '0.2' },
						_react2.default.createElement('path', { fill: '#F2F2F2', d: 'M49.43489,12.24958c16.52151,0,27.13651,4.6083,32.32259,9.04329 c1.15186,0.98506,0.66865-8.29245,0.28298-9.89731c-1.53491-6.3871-6.75527-9.82089-15.95251-9.82089 S49.43489,3.05235,49.43489,12.24958z' })
					),
					_react2.default.createElement('path', { fill: '#FFEAAE', d: 'M87.108,10.80112c0.00479-0.54482,0.00889-1.05957-0.35136-1.4229 C86.54541,9.16597,86.25214,9.0583,85.883,9.0583h-2.93262C80.65317,3.0519,75.00019,0,66.08818,0 c-0.05879,0-0.1169,0.00068-0.17568,0.00085V0H21.19658v0.00085C21.13779,0.00068,21.07969,0,21.0209,0 C12.10888,0,6.45591,3.0519,4.15869,9.0583H1.22607c-0.36914,0-0.6624,0.10767-0.87363,0.31992 c-0.36025,0.36333-0.35615,0.87808-0.35137,1.4229l0.00068,0.18218l-0.00068,0.18218 c-0.00479,0.54482-0.00889,1.05957,0.35137,1.4229c0.21123,0.21226,0.50449,0.31992,0.87363,0.31992h1.94927 c-0.77041,5.11995,0.36777,10.01362,3.23579,13.65171c2.85879,3.62783,7.1374,5.62564,12.04766,5.62564 c12.79243,0,20.51875-9.79487,20.77783-19.43628l0.05879-0.10767c0.01435-0.02529,1.41094-2.51597,4.24854-2.51597 c2.83487,0,4.21572,2.42334,4.27314,2.52656l0.05537,0.0998c0.26045,9.64038,7.98677,19.43355,20.77783,19.43355 c4.91026,0,9.18887-1.9978,12.04765-5.62564c2.86802-3.63808,4.0062-8.53176,3.23579-13.65171H85.883 c0.36914,0,0.66241-0.10767,0.87363-0.31992c0.36025-0.36333,0.35616-0.87808,0.35136-1.4229l-0.00068-0.18218L87.108,10.80112z M6.5998,11.76362C7.97314,6.0481,12.82529,3.15,21.0209,3.15c9.5498,0,15.07803,1.48887,15.07803,9.09932 c0,8.25132-6.59805,16.78633-17.64014,16.78633c-3.92451,0-7.32471-1.57158-9.57441-4.42524 C6.26894,21.29087,5.43564,16.60825,6.5998,11.76362z M35.38012,3.15h16.34883c-1.60371,1.22705-2.79145,2.91724-3.40293,5.2259 c-1.15869-0.85825-2.74018-1.59192-4.78208-1.59192c-2.03745,0-3.61108,0.727-4.76431,1.58047 C38.16748,6.0616,36.9811,4.375,35.38012,3.15z M66.08818,3.15c8.1956,0,13.04775,2.8981,14.4211,8.61362 c1.16415,4.84463,0.33086,9.52725-2.28458,12.84678c-2.2497,2.85366-5.6499,4.42524-9.57441,4.42524 c-11.04209,0-17.64014-8.53501-17.64014-16.78633C51.01015,4.63887,56.53838,3.15,66.08818,3.15z' })
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC5.default);
	
	function Aviators(props) {
		var glasses = {
			Cat: Cat,
			Tortoise: Tortoise,
			Chicken: Chicken
		};
	
		var ThisAviators = glasses[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisAviators)) {
			return null;
		}
	
		return _react2.default.createElement(ThisAviators, props);
	}
	
	exports.default = Aviators;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC4 = __webpack_require__(6);
	
	var _PositionedGoodyHOC5 = _interopRequireDefault(_PositionedGoodyHOC4);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
	
			// 7
			value: function render() {
				var style = {
					st146: {
						fill: 'none'
					},
					st3: {
						fill: '#A5C6EF'
					},
					st9: {
						fill: '#EFEFEF'
					}
				};
	
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, style: style.st146, cx: '58.325573', cy: '22.7614727' }),
					_react2.default.createElement('path', { style: style.st3, d: 'M115.2070312,7.3284988c-7.46875-3.2841797-14.0214844-4.9707031-18.6572266-5.8354492 c-1.3532715-0.3239746-2.7919922-0.5524902-4.296875-0.7062988C91.3466797,0.6705399,89.2910156,0.5040359,89.25,0.5040359 c-8.6540527,0-16.2253418,4.7481689-20.3032227,11.7320557c-2.1030273-1.3481445-5.9042969-3.2543335-10.4838867-3.2543335 c-4.5786133,0-8.3789062,1.9377747-10.4816895,3.2859192C43.9035645,5.2837906,36.3327637,0.4141769,27.6787109,0.4141769 c-0.0283203,0-0.1154785,0.0085602-0.126709,0.0088043c-1.0476074,0.0056152-2.0778809,0.1674805-3.0891113,0.3066406 c-1.4199219,0.1552734-2.7802734,0.4202881-4.0634766,0.729126C15.7705078,2.3259354,9.2382812,4.0335159,1.7929688,7.3074417 C0.703125,7.7859573,0,8.8846512,0,10.0745926v2.3564453c0,0.8916016,0.3964844,1.7368164,1.0820312,2.3066406 c1.2373047,1.0292969,2.7382812,3.8598633,3.1103516,7.6430664c0.0068359,0.0715332,0.0283203,0.137207,0.0402832,0.2070312 c-0.0314941,0.4963379-0.0529785,0.9953613-0.0529785,1.4995117c0,12.9570312,10.5419922,23.4985352,23.4990234,23.4985352 h0.0009766c6.2763672,0,12.1767578-2.4443359,16.6142578-6.8823242 c4.4384766-4.4384766,6.8828125-10.3393555,6.8828125-16.6162109c0-2.1318359-0.2905273-4.1960449-0.8249512-6.1608887 c0.8540039-0.6477051,4.1374512-2.923584,8.111084-2.923584c3.9711914,0,7.2568359,2.2749023,8.1132812,2.9233398 c-0.534668,1.9648438-0.8251953,4.0292969-0.8251953,6.1611328c0,12.9570312,10.5419922,23.4985352,23.4990234,23.4985352 s23.4990234-10.5415039,23.4990234-23.4985352c0-0.4589844-0.0166016-0.9140625-0.0427246-1.3666992 c0.0244141-0.112793,0.0546875-0.2231445,0.0661621-0.3408203c0.3691406-3.7597656,1.8886719-6.597168,3.1455078-7.6420898 C116.6035156,14.1678543,117,13.3226395,117,12.4310379v-2.3564453C117,8.8846512,116.296875,7.8070145,115.2070312,7.3284988z M40.0517578,36.4608231c-3.3056641,3.3051758-7.6992188,5.125-12.3730469,5.125 c-9.6494141,0-17.4990234-7.8496094-17.4990234-17.4985352c0-8.359375,5.8955078-15.3591309,13.7451172-17.083252 c2.2109375-0.3278809,3.5527344-0.4035645,3.7832031-0.4143066c9.6347656,0.0161133,17.46875,7.8583984,17.46875,17.4975586 C45.1767578,28.7616043,43.3564453,33.1556473,40.0517578,36.4608231z M89.25,41.5858231 c-9.6494141,0-17.4990234-7.8496094-17.4990234-17.4985352c0-9.6472168,7.8469238-17.4960938,17.4938965-17.4987793 c0.1535645,0.0065918,1.4611816,0.0710449,3.671875,0.3930664c7.8937988,1.6906738,13.8322754,8.7148438,13.8322754,17.1057129 C106.7490234,33.7362137,98.8994141,41.5858231,89.25,41.5858231z' }),
					_react2.default.createElement('path', { style: style.st9, d: 'M112,12.5028152h-3c-0.828125,0-1.5-0.6713867-1.5-1.5s0.671875-1.5,1.5-1.5h3 c0.828125,0,1.5,0.6713867,1.5,1.5S112.828125,12.5028152,112,12.5028152z' }),
					_react2.default.createElement('path', { style: style.st9, d: 'M8,12.5028152H5c-0.828125,0-1.5-0.6713867-1.5-1.5s0.671875-1.5,1.5-1.5h3 c0.828125,0,1.5,0.6713867,1.5,1.5S8.828125,12.5028152,8,12.5028152z' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC5.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
	
			// 7
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '30.9125538', cy: '11.8440666' }),
					_react2.default.createElement('path', { fill: '#A5C6EF', d: 'M61.0597267,3.6645906c-3.9584389-1.7406152-7.431385-2.6344726-9.8883286-3.0927882 c-0.7172356-0.1717065-1.4797592-0.2928198-2.2773438-0.3743384c-0.4803123-0.0615918-1.5698166-0.1498389-1.5915527-0.1498389 c-4.5866508,0-8.5994339,2.5165296-10.7607079,6.2179899c-1.1146049-0.7145166-3.1292801-1.7247968-5.5564613-1.7247968 c-2.4266663,0-4.4408207,1.0270205-5.5552959,1.7415371C23.2688885,2.5808952,19.2563648,0,14.6697168,0 c-0.0150099,0-0.061204,0.0045369-0.0671558,0.0046663c-0.555232,0.0029761-1.1012764,0.0887646-1.637229,0.1625195 c-0.7525587,0.0822949-1.4735451,0.2227527-2.1536427,0.3864368C8.3583689,1.013232,4.8962889,1.9182496,0.9502735,3.6534302 C0.3726563,3.9070437,0,4.4893513,0,5.1200204v1.2489161C0,6.841485,0.2101367,7.2894492,0.5734766,7.5914559 c0.6557715,0.545527,1.4512892,2.0457273,1.6484864,4.0508246c0.003623,0.0379133,0.0150096,0.0727205,0.0213501,0.1097269 c-0.0166919,0.2630596-0.0280788,0.5275412-0.0280788,0.7947416c0,6.8672256,5.587256,12.4542236,12.454483,12.4542236h0.0005178 c3.3264751,0,6.4536819-1.2954979,8.8055573-3.6476326c2.3523922-2.3523922,3.6478901-5.4798584,3.6478901-8.806591 c0-1.1298733-0.1539803-2.2239037-0.4372253-3.2652712c0.4526234-0.3432837,2.1928501-1.5494995,4.2988758-1.5494995 c2.1047325,0,3.8461227,1.205698,4.3000374,1.5493698c-0.283371,1.0413675-0.4373512,2.1355276-0.4373512,3.2654009 c0,6.8672256,5.5872536,12.4542236,12.454483,12.4542236s12.4544792-5.586998,12.4544792-12.4542236 c0-0.2432623-0.0087967-0.4844532-0.022644-0.7243509c0.0129395-0.0597801,0.0289841-0.1182661,0.0350685-0.1806345 c0.1956444-1.9926758,1.0009956-3.4964991,1.6671181-4.0503078c0.3633385-0.3020067,0.5734749-0.7499709,0.5734749-1.2225194 V5.1200204C62.0099983,4.4893513,61.6373444,3.9182038,61.0597267,3.6645906z M21.2274323,19.104723 c-1.7520027,1.7517433-4.0805874,2.7162495-6.5577154,2.7162495c-5.1141891,0-9.2744827-4.1602936-9.2744827-9.2742233 c0-4.4304695,3.124619-8.1403399,7.2849116-9.0541239c1.1717968-0.1737769,1.8829498-0.2138891,2.0050983-0.2195826 c5.1064253,0.0085402,9.2584372,4.1649513,9.2584372,9.2737064 C23.9436817,15.0241365,22.9789162,17.3529797,21.2274323,19.104723z M47.3025017,21.8209724 c-5.114193,0-9.2744827-4.1602936-9.2744827-9.2742233c0-5.1130252,4.1588669-9.2729301,9.2717628-9.274353 c0.0813904,0.0034935,0.7744255,0.0376537,1.9460945,0.2083251c4.183712,0.8960571,7.3311043,4.6188674,7.3311043,9.0660286 C56.5769806,17.6606789,52.4166908,21.8209724,47.3025017,21.8209724z' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M59.3600006,6.4069781h-1.5900002c-0.4389076,0-0.795002-0.355835-0.795002-0.7949996 c0-0.4391651,0.3560944-0.7950001,0.795002-0.7950001h1.5900002c0.4389038,0,0.7949982,0.355835,0.7949982,0.7950001 C60.1549988,6.0511432,59.7989044,6.4069781,59.3600006,6.4069781z' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M4.2399998,6.4069781H2.6500001c-0.4389064,0-0.7950001-0.355835-0.7950001-0.7949996 c0-0.4391651,0.3560936-0.7950001,0.7950001-0.7950001h1.5899997c0.4389067,0,0.7950001,0.355835,0.7950001,0.7950001 C5.0349998,6.0511432,4.6789064,6.4069781,4.2399998,6.4069781z' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC5.default);
	
	var Chicken = function (_PositionedGoodyHOC3) {
		_inherits(Chicken, _PositionedGoodyHOC3);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
	
			// 7
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '40.8279', cy: '15.64311', r: '0' }),
					_react2.default.createElement('path', { fill: '#A5C6EF', d: 'M80.64492,4.84003c-5.22813-2.29893-9.81504-3.47949-13.06006-4.08481 c-0.94729-0.22678-1.95439-0.38674-3.00781-0.49441c-0.63437-0.08135-2.07334-0.1979-2.10205-0.1979 c-6.05783,0-11.35774,3.32372-14.21225,8.21244c-1.47212-0.9437-4.13301-2.27803-7.33872-2.27803 c-3.20503,0-5.86523,1.35644-7.33718,2.30014C30.73249,3.40873,25.43293,0,19.3751,0c-0.01982,0-0.08084,0.00599-0.0887,0.00616 c-0.73333,0.00393-1.45452,0.11724-2.16238,0.21465c-0.99395,0.10869-1.94619,0.2942-2.84443,0.51039 C11.03936,1.33823,6.4668,2.53354,1.25508,4.82529C0.49219,5.16025,0,5.92933,0,6.76229V8.4118 c0,0.62412,0.27754,1.21577,0.75742,1.61465c0.86611,0.72051,1.9168,2.7019,2.17725,5.35015 c0.00479,0.05007,0.01982,0.09605,0.0282,0.14492c-0.02205,0.34744-0.03709,0.69675-0.03709,1.04966 c0,9.06992,7.37939,16.44897,16.44932,16.44897h0.00068c4.39346,0,8.52373-1.71104,11.62998-4.81763 c3.10693-3.10693,4.81797-7.23755,4.81797-11.63135c0-1.49229-0.20337-2.93723-0.57747-4.31262 c0.5978-0.45339,2.89621-2.04651,5.67776-2.04651c2.77983,0,5.07978,1.59243,5.6793,2.04634 c-0.37427,1.37539-0.57764,2.82051-0.57764,4.31279c0,9.06992,7.37939,16.44897,16.44931,16.44897 s16.44932-7.37905,16.44932-16.44897c0-0.32129-0.01162-0.63984-0.02991-0.95669c0.01709-0.07896,0.03828-0.1562,0.04631-0.23857 c0.2584-2.63184,1.32207-4.61802,2.20186-5.34946C81.62246,9.62757,81.9,9.03592,81.9,8.4118V6.76229 C81.9,5.92933,81.40781,5.17499,80.64492,4.84003z M28.03623,25.23265c-2.31396,2.31362-5.38945,3.5875-8.66113,3.5875 c-6.75459,0-12.24932-5.49473-12.24932-12.24897c0-5.85156,4.12686-10.75139,9.62158-11.95828 c1.54766-0.22952,2.48691-0.2825,2.64824-0.29001c6.74434,0.01128,12.22812,5.50088,12.22812,12.24829 C31.62373,19.8432,30.34951,22.91903,28.03623,25.23265z M62.475,28.82015c-6.75459,0-12.24931-5.49473-12.24931-12.24897 c0-6.75305,5.49284-12.24727,12.24573-12.24915c0.10749,0.00461,1.02283,0.04973,2.57031,0.27515 c5.52566,1.18347,9.68259,6.10039,9.68259,11.974C74.72432,23.32543,69.22959,28.82015,62.475,28.82015z' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M78.4,8.46205h-2.1c-0.57969,0-1.05-0.46997-1.05-1.05s0.47031-1.05,1.05-1.05h2.1 c0.57969,0,1.05,0.46997,1.05,1.05S78.97969,8.46205,78.4,8.46205z' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M5.6,8.46205H3.5c-0.57969,0-1.05-0.46997-1.05-1.05s0.47031-1.05,1.05-1.05h2.1 c0.57969,0,1.05,0.46997,1.05,1.05S6.17969,8.46205,5.6,8.46205z' })
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC5.default);
	
	function Blue(props) {
		var glasses = {
			Cat: Cat,
			Tortoise: Tortoise,
			Chicken: Chicken
		};
	
		var ThisBlue = glasses[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisBlue)) {
			return null;
		}
	
		return _react2.default.createElement(ThisBlue, props);
	}
	
	exports.default = Blue;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC4 = __webpack_require__(6);
	
	var _PositionedGoodyHOC5 = _interopRequireDefault(_PositionedGoodyHOC4);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
	
			// 2
			value: function render() {
				var style = {
					st146: {
						fill: 'none'
					},
					st13: {
						fill: '#F2CC7B'
					},
					st2: {
						fill: '#FFFFFF'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '62.118824', cy: '20.3631306' }),
					_react2.default.createElement('path', { style: style.st13, d: 'M31.2946053,41.7856255c-1.3769531,0-2.7675781-0.105957-4.1591797-0.3208008 c-8.3378906-1.2890625-15.2148447-7.5307617-19.8867188-18.0507812C3.7985108,15.6445112,2.7545655,8.355937,2.7125733,8.0492964 l2.9707034-0.4145503c0.0400391,0.2807617,4.1445308,28.1191406,21.9111328,30.8652344 c6.1152344,0.9458008,12.2099609-0.4750977,16.7167969-3.8974609c3.4501953-2.6186523,5.6015625-6.1708984,6.0595703-10.0019531 l0.0361328-0.2104492c0.6328125-5.3203125,5.5507812-9.1767588,11.7119141-9.1767588 c6.1581993,0,11.0732384,3.8515635,11.7109337,9.1665049l0.0234375,0.1279297 c0.4716797,3.9238281,2.6230469,7.4760742,6.0732422,10.0947266c4.5078125,3.4213867,10.5986328,4.8417969,16.7167969,3.8974609 c17.7910156-2.75,21.8720703-30.5839844,21.9111328-30.8647461l2.9707031,0.414062 c-0.0419922,0.3066406-1.0859375,7.5952148-4.5361328,15.364747 c-4.671875,10.5200195-11.5488281,16.7617188-19.8867188,18.0507812 c-6.9189453,1.0688477-13.8369141-0.5610352-18.9902344-4.4726562 c-4.1035156-3.1152344-6.6689453-7.3896484-7.2236328-12.0361328l-0.0332031-0.1831055 c-0.4355469-3.8007812-4.109375-6.5595703-8.7363243-6.5595703s-8.3007812,2.7587891-8.7363281,6.5595703l-0.046875,0.2758789 c-0.5410156,4.5537109-3.1064453,8.828125-7.2099609,11.9433594 C42.009449,40.1166801,36.7643318,41.7851372,31.2946053,41.7856255z' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M51.7975349,24.0424614c-1.9511719,0-3.6591797-1.4287109-3.9521484-3.4160156 c-0.9667969-6.5473642-6.5283203-11.2070322-14.515625-12.1611338 C21.8981209,7.1010547,5.4381595,11.6489058,5.2750735,11.6948042c-2.1308596,0.59375-4.3349609-0.6479492-4.9296875-2.7758789 c-0.5947266-2.1274409,0.6484375-4.3344722,2.7753906-4.9291992c0.7363281-0.2055664,18.1611328-5.0195312,31.1582031-3.4677734 c11.5537109,1.3798828,19.9863281,8.8125,21.4804688,18.9355469c0.3222656,2.1855469-1.1875,4.21875-3.3730469,4.5415039 C52.1891365,24.0283012,51.9918709,24.0424614,51.7975349,24.0424614z' }),
					_react2.default.createElement('path', { style: style.st13, d: 'M4.820972,9.0214643c-0.6835938,0-1.3007815-0.4692383-1.4609377-1.1630855 C3.1744874,7.0507617,3.677417,6.2455859,4.4850345,6.0595508l2.1669922-0.5 c0.8115234-0.1894531,1.6123042,0.3168945,1.7988276,1.1240234c0.1855469,0.8076172-0.3173828,1.6127925-1.1249995,1.7988276 l-2.1669922,0.5C5.0455813,9.008769,4.9323001,9.0214643,4.820972,9.0214643z' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M72.2028046,24.0424614c-0.1943359,0-0.3916016-0.0141602-0.5898438-0.043457 c-2.1855469-0.3227539-3.6953125-2.3564453-3.3720703-4.5419922C69.7369843,9.3344526,78.1686249,1.9018358,89.7223358,0.5219529 c12.9892578-1.550293,30.4199219,3.2617188,31.1572266,3.4677734c2.1269531,0.5947268,3.3691406,2.8007815,2.7753906,4.9277344 c-0.5947266,2.1269531-2.796875,3.3720703-4.9277344,2.7773438c-0.1660156-0.0458984-16.6523438-4.5922847-28.0556641-3.2294922 c-7.9863281,0.9541016-13.5488281,5.6137695-14.5166016,12.161622 C75.8610077,22.6137505,74.1529999,24.0424614,72.2028046,24.0424614z' }),
					_react2.default.createElement('path', { style: style.st13, d: 'M119.1803436,9.0214643c-0.1113281,0-0.2246094-0.0126953-0.3378906-0.0390625l-2.1669922-0.5 c-0.8076172-0.1860352-1.3105469-0.9912105-1.125-1.7988276c0.1865234-0.8061523,0.9912109-1.3134766,1.7988281-1.1240234 l2.1669922,0.5c0.8076172,0.1860352,1.3105469,0.9912109,1.125,1.7988281 C120.4811249,8.5517378,119.8639374,9.0214643,119.1803436,9.0214643z' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC5.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
	
			// 2
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '32.8187103', cy: '10.6788435' }),
					_react2.default.createElement('path', { fill: '#F2CC7B', d: 'M16.4818745,22.0327663c-0.7297859,0-1.4668169-0.0561581-2.2043657-0.1700249 c-4.4190826-0.6832027-8.0638676-3.9913044-10.5399609-9.5669146C1.9089439,8.1779757,1.3556529,4.3150315,1.333397,4.1525121 l1.5744725-0.219712c0.0212207,0.1488035,2.1966016,14.9031448,11.6129007,16.3585739 c3.2410746,0.5012741,6.4712801-0.2518024,8.8599024-2.0656548c1.8286037-1.387886,2.9688282-3.2705755,3.2115726-5.3010349 l0.0191498-0.1115379c0.3353901-2.819766,2.9419136-4.8636818,6.2073154-4.8636818 c3.2638474,0,5.8688164,2.0413284,6.2067947,4.8582468l0.0124245,0.0678034 c0.2499886,2.0796289,1.390213,3.9623184,3.2188187,5.3502045c2.3891373,1.8133354,5.6172752,2.5661526,8.8599014,2.0656548 C60.545887,18.8338737,62.708847,4.0818624,62.7295494,3.9330587l1.5744743,0.2194533 c-0.0222549,0.1625195-0.5755501,4.0254636-2.4041519,8.1433144c-2.4760933,5.5756102-6.1208801,8.8837118-10.5399628,9.5669146 c-3.667038,0.5664883-7.3335609-0.297348-10.0648232-2.3705082c-2.1748619-1.6510735-3.5345421-3.9165134-3.8285255-6.3791504 l-0.0175972-0.0970459c-0.2308388-2.0144138-2.1779671-3.476572-4.6302528-3.476572s-4.3994141,1.4621582-4.6302547,3.476572 l-0.0248432,0.1462164c-0.2867393,2.4134665-1.6464157,4.6789064-3.8212795,6.3299799 C22.1607399,21.1482239,19.3808289,22.0325069,16.4818745,22.0327663z' }),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M27.3484268,12.6288891c-1.0341225,0-1.9393654-0.7572174-2.0946388-1.8104887 c-0.5124035-3.4701023-3.4600105-5.9397264-7.6932812-6.4454002C11.5017366,3.6499436,2.7779574,6.0603046,2.6915221,6.084631 C1.5621666,6.3993187,0.3939927,5.7412181,0.0787876,4.6134152c-0.3152051-1.1275439,0.3436719-2.2972705,1.470957-2.6124756 c0.3902539-0.1089503,9.6254005-2.6603515,16.5138474-1.83792c6.1234665,0.7313379,10.5927525,4.6706252,11.3846474,10.0358391 c0.1708012,1.1583405-0.6293755,2.2359381-1.787714,2.4069977C27.555975,12.6213837,27.4514236,12.6288891,27.3484268,12.6288891 z' }),
					_react2.default.createElement('path', { fill: '#F2CC7B', d: 'M2.4508481,4.6677608c-0.3623047,0-0.689414-0.2486963-0.7742968-0.6164355 C1.5782114,3.6232882,1.8447642,3.1965451,2.2728014,3.0979464l1.1485057-0.2649999 c0.4301076-0.1004102,0.8545218,0.167954,0.9533792,0.5957322c0.0983396,0.4280372-0.1682129,0.8547804-0.5962501,0.9533789 L2.6299303,4.6470575C2.5698912,4.6610322,2.5098522,4.6677608,2.4508481,4.6677608z' }),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M38.1632195,12.6288891c-0.1029968,0-0.2075462-0.0075054-0.3126144-0.0230322 c-1.1583405-0.1710596-1.9585152-1.2489166-1.7871971-2.4072561c0.7929268-5.3649559,5.2616997-9.3042431,11.3851662-10.0355806 c6.884304-0.8216553,16.1225586,1.728711,16.5133286,1.83792c1.127285,0.3152051,1.7856483,1.4844141,1.4709587,2.6116993 c-0.3152084,1.127285-1.4823456,1.7871971-2.611702,1.471992c-0.087986-0.0243263-8.8257408-2.4339111-14.8694992-1.7116308 c-4.2327538,0.5056739-7.1808815,2.9752979-7.6938019,6.4456596 C40.1020699,11.8716717,39.1968231,12.6288891,38.1632195,12.6288891z' }),
					_react2.default.createElement('path', { fill: '#F2CC7B', d: 'M63.0613174,4.6677608c-0.0590057,0-0.1190453-0.0067286-0.179081-0.0207033l-1.1485062-0.2649999 c-0.4280396-0.0985985-0.6945915-0.5253417-0.5962524-0.9533789c0.0988579-0.4272606,0.5253448-0.6961424,0.9533806-0.5957322 l1.1485062,0.2649999c0.4280357,0.0985987,0.6945877,0.5253417,0.5962486,0.9533789 C63.7507324,4.4188056,63.4236221,4.6677608,63.0613174,4.6677608z' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC5.default);
	
	var Chicken = function (_PositionedGoodyHOC3) {
		_inherits(Chicken, _PositionedGoodyHOC3);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
	
			// 2
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, fill: 'none', cx: '43.34547', cy: '14.10413' }),
					_react2.default.createElement('path', { fill: '#F2CC7B', d: 'M21.76851,29.09988c-0.96387,0-1.93731-0.07417-2.91143-0.22456 c-5.83652-0.90234-10.65039-5.27153-13.9207-12.63555C2.52125,10.8011,1.79048,5.6991,1.76109,5.48445l2.07949-0.29019 c0.02803,0.19653,2.90117,19.6834,15.33779,21.60567c4.28066,0.66206,8.54697-0.33257,11.70176-2.72822 c2.41514-1.83306,3.92109-4.31963,4.2417-7.00137l0.02529-0.14732c0.44297-3.72422,3.88555-6.42373,8.19834-6.42373 c4.31074,0,7.75127,2.69609,8.19765,6.41655l0.01641,0.08955c0.33017,2.74668,1.83613,5.23325,4.25127,7.06631 c3.15547,2.39497,7.41904,3.38926,11.70176,2.72822c12.4537-1.925,15.31045-21.40879,15.33779-21.60532l2.07949,0.28984 c-0.0294,0.21465-0.76015,5.31665-3.17529,10.75532c-3.27031,7.36401-8.08418,11.7332-13.9207,12.63555 c-4.84327,0.74819-9.68584-0.39272-13.29317-3.13086c-2.87246-2.18066-4.66826-5.17275-5.05654-8.42529l-0.02324-0.12817 c-0.30488-2.66055-2.87656-4.5917-6.11543-4.5917c-3.23887,0-5.81055,1.93115-6.11543,4.5917l-0.03281,0.19312 c-0.37871,3.1876-2.17451,6.17969-5.04697,8.36035C29.2689,27.93162,25.59732,29.09954,21.76851,29.09988z' }),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M36.12056,16.67966c-1.36582,0-2.56143-1.0001-2.76651-2.39121 C32.6773,9.7053,28.78424,6.44353,23.19312,5.77566C15.19097,4.82068,3.669,8.00418,3.55484,8.03631 c-1.4916,0.41562-3.03447-0.45356-3.45078-1.94312c-0.41631-1.48921,0.45391-3.03413,1.94277-3.45044 c0.51543-0.1439,12.71279-3.51367,21.81074-2.42744C31.94517,1.18123,37.848,6.38406,38.8939,13.47019 c0.22559,1.52988-0.83125,2.95312-2.36113,3.17905C36.39468,16.66975,36.2566,16.67966,36.12056,16.67966z' }),
					_react2.default.createElement('path', { fill: '#F2CC7B', d: 'M3.23697,6.16497c-0.47852,0-0.91055-0.32847-1.02266-0.81416 c-0.12988-0.56533,0.22217-1.12896,0.7875-1.25918l1.51689-0.35c0.56807-0.13262,1.12861,0.22183,1.25918,0.78682 c0.12988,0.56533-0.22217,1.12895-0.7875,1.25918l-1.51689,0.35C3.3942,6.15608,3.3149,6.16497,3.23697,6.16497z' }),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M50.40425,16.67966c-0.13604,0-0.27412-0.00991-0.41289-0.03042 c-1.52988-0.22593-2.58672-1.64951-2.36045-3.17939c1.04727-7.08579,6.94942-12.28862,15.03701-13.25454 c9.09248-1.08521,21.29394,2.2832,21.81005,2.42744c1.48887,0.41631,2.3584,1.96055,1.94278,3.44941 c-0.41631,1.48887-1.95782,2.36045-3.44942,1.94414c-0.11621-0.03213-11.65664-3.2146-19.63897-2.26064 C57.74195,6.44353,53.8482,9.7053,53.17076,14.2888C52.965,15.67957,51.76939,16.67966,50.40425,16.67966z' }),
					_react2.default.createElement('path', { fill: '#F2CC7B', d: 'M83.28853,6.16497c-0.07793,0-0.15723-0.00889-0.23652-0.02734l-1.5169-0.35 c-0.56533-0.13022-0.91738-0.69385-0.7875-1.25918c0.13057-0.56431,0.69385-0.91943,1.25918-0.78682l1.5169,0.35 c0.56533,0.13022,0.91738,0.69385,0.7875,1.25918C84.19908,5.83616,83.76704,6.16497,83.28853,6.16497z' })
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC5.default);
	
	function CatEye(props) {
		var glasses = {
			Cat: Cat,
			Tortoise: Tortoise,
			Chicken: Chicken
		};
	
		var ThisCatEye = glasses[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisCatEye)) {
			return null;
		}
	
		return _react2.default.createElement(ThisCatEye, props);
	}
	
	exports.default = CatEye;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC4 = __webpack_require__(6);
	
	var _PositionedGoodyHOC5 = _interopRequireDefault(_PositionedGoodyHOC4);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '59.15901', cy: '24.02269' }),
					_react2.default.createElement('path', { opacity: '0.4', fill: '#fc5959', d: 'M26.23757,45.05305c0,0-22.34688-8.48164-21.39511-26.79797 c0.3261-6.27568,4.798-10.8621,11.00851-11.82134c6.86674-1.0606,12.14507,4.00397,12.14507,4.00397 s5.85511-4.48605,12.57494-2.71944c6.07763,1.59777,10.05008,6.62299,9.72398,12.89867 C49.34319,38.93327,26.23757,45.05305,26.23757,45.05305z' }),
					_react2.default.createElement('path', { opacity: '0.4', fill: '#fc5959', d: 'M92.08024,45.05186c0,0-23.11103-6.09929-24.07905-24.41477 C67.66952,14.3617,71.63751,9.33297,77.71372,7.7298c6.71826-1.77256,12.49707,2.71253,12.49707,2.71253 s5.35411-5.0735,12.22179-4.01898c6.21136,0.95374,10.68732,5.53618,11.01899,11.81157 C114.41959,36.55041,92.08024,45.05186,92.08024,45.05186z' }),
					_react2.default.createElement('path', { fill: '#f96e6e', d: 'M118.28235,15.82188c-0.41982-8.07487-6.23684-14.35554-14.47632-15.62813 c-6.14431-0.94921-11.23079,1.80199-13.83345,3.64197c-2.79845-1.55458-8.18201-3.76714-14.20457-2.18479 c-6.79716,1.78689-11.49865,6.94156-12.56061,13.35251c-0.5048,0.11177-1.0096,0.20041-1.51464,0.25934 c-0.85473,0.09813-1.70958,0.15341-2.56467,0.14635c-0.85521-0.00122-1.71055-0.05333-2.56625-0.15414 c-0.48301-0.05698-0.96613-0.13758-1.44926-0.23962C54.05451,8.59881,49.35131,3.43903,42.55001,1.65092 c-6.02157-1.58429-11.40709,0.62972-14.20456,2.18479c-2.60266-1.83949-7.68233-4.59021-13.83442-3.64197 C6.27252,1.46634,0.45549,7.74701,0.03568,15.82188C-0.43868,24.9458,3.82473,33.40882,12.3652,40.29681 c6.23197,5.0261,12.54478,7.45294,12.8107,7.55375c0.34092,0.12955,0.70132,0.19481,1.06171,0.19481 c0.25715,0,0.5143-0.03312,0.76658-0.09984c0.01607-0.00438,0.05552-0.01485,0.11616-0.03166 c0.93192-0.25812,7.08402-2.05671,13.40755-6.15356c7.53244-4.87974,12.32343-11.10562,14.07915-18.20352 c0.66503-0.17582,1.33031-0.30293,1.99583-0.38158c0.85448-0.10106,1.70921-0.15293,2.56419-0.15414 c0.85497-0.00731,1.71019,0.04797,2.56577,0.14635c0.65845,0.07671,1.31716,0.20455,1.9761,0.38012 c1.75389,7.10155,6.54537,13.33084,14.08025,18.21277c6.71996,4.35303,13.24999,6.11265,13.52467,6.18521 c0.25228,0.06672,0.50943,0.09984,0.76658,0.09984c0.3604,0,0.72079-0.06526,1.06171-0.19481 c0.26591-0.10081,6.57873-2.52766,12.8107-7.55375C114.49329,33.40882,118.75671,24.9458,118.28235,15.82188z M47.30629,20.46176 c-0.72372,13.93913-16.825,20.07905-20.90602,21.4135c-0.24948-0.11056-0.54741-0.24644-0.88322-0.4052 C20.58154,39.12455,7.15062,31.51235,7.831,18.41041c0.24546-4.7217,3.57281-8.26189,8.47715-9.0197 c0.48702-0.075,0.96528-0.10909,1.4338-0.10909c4.59459,0,8.15279,3.28839,8.18201,3.31518 c1.05782,1.01545,2.70688,1.10457,3.87964,0.22501c0.04773-0.03555,4.83615-3.56599,10.00641-2.20963 C44.60915,11.87405,47.55175,15.74006,47.30629,20.46176z M91.90899,41.87477 c-4.08711-1.3213-20.18036-7.40424-20.91966-21.39548c-0.24935-4.7217,2.69033-8.59063,7.48849-9.85592 c0.83476-0.22062,1.65686-0.31267,2.45071-0.31267c4.10464,0,7.41933,2.47311,7.44855,2.49551 c1.15815,0.89807,2.80721,0.81577,3.88159-0.18215c0.0448-0.04042,4.43777-4.05545,9.72003-3.2431 c4.90434,0.75294,8.23559,4.29069,8.48495,9.0119C111.20004,32.3325,95.82661,40.12149,91.90899,41.87477z' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC5.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '31.35428', cy: '12.73203' }),
					_react2.default.createElement('path', { opacity: '0.4', fill: '#FC5959', d: 'M13.90591,23.87812c0,0-11.84385-4.49527-11.33941-14.20293 c0.17284-3.32611,2.54294-5.75691,5.83451-6.26531c3.63937-0.56212,6.43689,2.1221,6.43689,2.1221s3.10321-2.3776,6.66472-1.44131 c3.22115,0.84682,5.32654,3.51018,5.15371,6.83629C26.15189,20.63463,13.90591,23.87812,13.90591,23.87812z' }),
					_react2.default.createElement('path', { opacity: '0.4', fill: '#FC5959', d: 'M48.79046,23.87812c0,0,11.84385-4.49527,11.33941-14.20293 c-0.17283-3.32611-2.54294-5.75691-5.83451-6.26531c-3.63937-0.56212-6.43689,2.1221-6.43689,2.1221 s-3.10321-2.3776-6.66471-1.44131c-3.22115,0.84682-5.32655,3.51018-5.15371,6.83629 C36.54449,20.63463,48.79046,23.87812,48.79046,23.87812z' }),
					_react2.default.createElement('path', { fill: '#F96E6E', d: 'M62.68964,8.38559c-0.2225-4.27968-3.30552-7.60844-7.67245-8.28291 c-3.25648-0.50308-5.95232,0.95506-7.33173,1.93024C46.20229,1.209,43.349,0.03635,40.15705,0.87499 c-3.60249,0.94705-6.09428,3.67903-6.65712,7.07683c-0.26754,0.05924-0.53509,0.10622-0.80276,0.13745 c-0.45301,0.05201-0.90608,0.08131-1.35928,0.07757c-0.45326-0.00064-0.90659-0.02826-1.36012-0.0817 c-0.25599-0.0302-0.51205-0.07292-0.76811-0.127c-0.56077-3.40077-3.05347-6.13546-6.65816-7.08316 c-3.19143-0.83967-6.04576,0.33375-7.52842,1.15794C13.64368,1.058,10.95146-0.39988,7.69084,0.10268 C3.32443,0.77716,0.24141,4.10591,0.01891,8.38559c-0.25141,4.83568,2.0082,9.32108,6.53464,12.97172 c3.30294,2.66383,6.64873,3.95006,6.78967,4.00349c0.18069,0.06866,0.3717,0.10325,0.56271,0.10325 c0.13629,0,0.27258-0.01755,0.40629-0.05292c0.00852-0.00232,0.02943-0.00787,0.06156-0.01678 c0.49392-0.1368,3.75453-1.09005,7.106-3.26138c3.9922-2.58626,6.53142-5.88598,7.46195-9.64787 c0.35247-0.09318,0.70506-0.16055,1.05779-0.20224c0.45288-0.05356,0.90588-0.08105,1.35902-0.0817 c0.45314-0.00387,0.9064,0.02542,1.35986,0.07757c0.34898,0.04065,0.6981,0.10841,1.04734,0.20146 c0.92957,3.76382,3.46904,7.06534,7.46253,9.65277c3.56158,2.3071,7.0225,3.2397,7.16808,3.27816 c0.13371,0.03536,0.27,0.05292,0.40629,0.05292c0.19101,0,0.38202-0.03459,0.56271-0.10325 c0.14094-0.05343,3.48673-1.33966,6.78967-4.00349C60.68145,17.70668,62.94106,13.22127,62.68964,8.38559z M25.07234,10.84473 c-0.38357,7.38774-8.91725,10.6419-11.08019,11.34915c-0.13222-0.05859-0.29013-0.13061-0.46811-0.21476 c-2.61582-1.24312-9.73421-5.27758-9.37361-12.22161c0.13009-2.5025,1.89359-4.3788,4.49289-4.78044 c0.25812-0.03975,0.5116-0.05782,0.75991-0.05782c2.43513,0,4.32098,1.74285,4.33647,1.75704 c0.56064,0.53819,1.43465,0.58542,2.05621,0.11925c0.0253-0.01884,2.56316-1.88998,5.3034-1.1711 C23.64285,6.29325,25.20243,8.34223,25.07234,10.84473z M48.71177,22.19363c-2.16617-0.70029-10.69559-3.92425-11.08742-11.3396 c-0.13216-2.5025,1.42587-4.55303,3.9689-5.22364c0.44242-0.11693,0.87813-0.16571,1.29887-0.16571 c2.17546,0,3.93225,1.31075,3.94773,1.32262c0.61382,0.47598,1.48782,0.43236,2.05724-0.09654 c0.02375-0.02142,2.35202-2.14939,5.15162-1.71884c2.5993,0.39906,4.36486,2.27406,4.49702,4.77631 C58.93602,17.13622,50.78811,21.26439,48.71177,22.19363z' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC5.default);
	
	var Chicken = function (_PositionedGoodyHOC3) {
		_inherits(Chicken, _PositionedGoodyHOC3);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '41.41131', cy: '16.81588' }),
					_react2.default.createElement('path', { opacity: '0.4', fill: '#FC5959', d: 'M18.3663,31.53714c0,0-15.64282-5.93715-14.97657-18.75858 c0.22827-4.39298,3.3586-7.60347,7.70596-8.27494C15.9024,3.7612,19.59723,7.3064,19.59723,7.3064 s4.09858-3.14023,8.80245-1.90361c4.25434,1.11844,7.03506,4.63609,6.80679,9.02907 C34.54023,27.25329,18.3663,31.53714,18.3663,31.53714z' }),
					_react2.default.createElement('path', { opacity: '0.4', fill: '#FC5959', d: 'M64.44023,31.53714c0,0,15.64282-5.93715,14.97658-18.75858 c-0.22827-4.39298-3.3586-7.60347-7.70596-8.27494C66.90414,3.7612,63.2093,7.3064,63.2093,7.3064 s-4.09858-3.14023-8.80245-1.90361c-4.25434,1.11844-7.03506,4.63609-6.80679,9.02907 C48.2663,27.25329,64.44023,31.53714,64.44023,31.53714z' }),
					_react2.default.createElement('path', { fill: '#F96E6E', d: 'M82.79765,11.07531C82.50378,5.4229,78.43185,1.02644,72.66422,0.13562 C68.3632-0.52883,64.80267,1.39701,62.9808,2.685c-1.95891-1.08821-5.72741-2.637-9.94319-1.52935 c-4.75801,1.25083-8.04906,4.85909-8.79243,9.34676c-0.35336,0.07824-0.70672,0.14029-1.06025,0.18154 c-0.59831,0.06869-1.1967,0.10739-1.79527,0.10245c-0.59865-0.00085-1.19738-0.03733-1.79638-0.1079 c-0.33811-0.03989-0.6763-0.09631-1.01448-0.16773c-0.74065-4.49159-4.03288-8.10343-8.79379-9.35511 c-4.2151-1.109-7.98496,0.44081-9.94319,1.52935c-1.82186-1.28764-5.37763-3.21315-9.6841-2.54938 C4.39076,1.02644,0.31885,5.4229,0.02498,11.07531c-0.33205,6.38674,2.65234,12.31086,8.63066,17.13246 c4.36238,3.51827,8.78135,5.21706,8.96749,5.28763c0.23864,0.09069,0.49092,0.13637,0.7432,0.13637 c0.18,0,0.36001-0.02318,0.5366-0.06989c0.01125-0.00307,0.03886-0.0104,0.08131-0.02216 c0.65234-0.18068,4.95881-1.43969,9.38528-4.30749c5.27271-3.41582,8.6264-7.77394,9.85541-12.74247 c0.46552-0.12307,0.93122-0.21205,1.39708-0.26711c0.59814-0.07074,1.19645-0.10705,1.79493-0.1079 c0.59848-0.00511,1.19713,0.03358,1.79604,0.10245c0.46092,0.0537,0.92201,0.14319,1.38327,0.26609 c1.22773,4.97108,4.58176,9.33159,9.85617,12.74894c4.70398,3.04712,9.27499,4.27885,9.46727,4.32965 c0.17659,0.04671,0.3566,0.06989,0.5366,0.06989c0.25228,0,0.50456-0.04568,0.7432-0.13637 c0.18614-0.07057,4.60511-1.76936,8.96749-5.28763C80.14531,23.38618,83.1297,17.46206,82.79765,11.07531z M33.11441,14.32323 c-0.5066,9.75739-11.7775,14.05534-14.63422,14.98945c-0.17463-0.07739-0.38319-0.1725-0.61825-0.28364 c-3.45485-1.64186-12.8565-6.97039-12.38024-16.14175C5.65352,9.5821,7.98267,7.10397,11.4157,6.5735 c0.34092-0.0525,0.6757-0.07637,1.00366-0.07637c3.21621,0,5.70695,2.30187,5.72741,2.32062 c0.74047,0.71081,1.89482,0.7732,2.71575,0.1575c0.03341-0.02489,3.38531-2.4962,7.00449-1.54674 C31.22641,8.31184,33.28623,11.01804,33.11441,14.32323z M64.33629,29.31234c-2.86097-0.92491-14.12624-5.18296-14.64376-14.97684 c-0.17455-3.30519,1.88322-6.01344,5.24194-6.89914c0.58433-0.15444,1.1598-0.21887,1.7155-0.21887 c2.87325,0,5.19353,1.73118,5.21399,1.74686c0.8107,0.62865,1.96505,0.57104,2.71711-0.1275 c0.03136-0.0283,3.10644-2.83882,6.80402-2.27017c3.43304,0.52706,5.76492,3.00348,5.93946,6.30833 C77.84003,22.63275,67.07863,28.08504,64.33629,29.31234z' })
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC5.default);
	
	function Heart(props) {
		var glasses = {
			Cat: Cat,
			Tortoise: Tortoise,
			Chicken: Chicken
		};
	
		var ThisHeart = glasses[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisHeart)) {
			return null;
		}
	
		return _react2.default.createElement(ThisHeart, props);
	}
	
	exports.default = Heart;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC4 = __webpack_require__(6);
	
	var _PositionedGoodyHOC5 = _interopRequireDefault(_PositionedGoodyHOC4);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
	
			// 6
			value: function render() {
				var style = {
					st146: {
						fill: 'none'
					},
					st119: {
						opacity: 0.5
					},
					st2: {
						fill: '#FFFFFF'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, style: style.st146, cx: '61.3626823', cy: '19.4572811' }),
					_react2.default.createElement(
						'g',
						{ style: style.st119 },
						_react2.default.createElement('path', { style: style.st2, d: 'M121.953125,2.6815338c-0.6191406-0.9355469-1.6503906-1.5166016-2.7714844-1.5634766 L94.0996094,0.0765533c-0.0488281-0.0019531-0.0966797-0.0029297-0.1455078-0.0029297 c-6.1728516,0-10.9902344,0.7036133-14.7021484,1.6772461c-0.0400391,0.0097656-0.0800781,0.0205078-0.1201172,0.0317383 c-5.1025391,1.3552246-8.0871582,3.0380859-9.6259766,4.2619629C67.3393555,4.8192291,64.762207,3.9486237,62,3.9486237h-1 c-2.762207,0-5.3393555,0.8706055-7.5058594,2.0959473c-1.5388184-1.223877-4.5234375-2.9957275-9.6259766-4.3509521 c-0.0400391-0.0112305-0.0800781,0.022522-0.1201172,0.0127563c-3.7119141-0.9736328-8.5302734-1.6549988-14.7021484-1.6549988 c-0.0488281,0-0.0966797,0.0121002-0.1455078,0.0140533L3.8183594,1.1124954 C2.6972656,1.1593704,1.6660156,1.743206,1.046875,2.6787529C0.4267578,3.6142998,0.2929688,4.7919598,0.6865234,5.842741 l2,5.3341913c0.0478516,0.1271973,0.1066895,0.248394,0.1679688,0.3672915 c0.1237793,1.2011719,0.2268066,2.4481716,0.3300781,3.7328396 c0.9335938,11.6308594,2.3457031,29.2076054,25.5673828,29.5039921 c0.2255859,0.0029297,0.4482422,0.0044403,0.6708984,0.0044403c8.421875,0,14.5986328-2.074688,18.8662109-6.3329887 c6.4001465-6.3867188,6.6088867-15.870594,6.5395508-23.7890511l0.0766602-0.6262159 C55.9970703,12.2511082,58.2944336,10.9486237,61,10.9486237h1c2.7055664,0,5.0029297,1.3024902,6.0947266,3.088623 l0.0766602,0.5372314c-0.0673828,7.78125,0.1411133,17.2261353,6.4008789,23.5908813 c4.3535156,4.4262695,10.7685547,6.7832642,19.6103516,6.7832642c0.0888672,0,0.1767578,0,0.265625,0 c22.6425781,0,24.1884766-17.2521973,25.2119141-28.6276855c0.1474609-1.6467285,0.2919922-3.2410889,0.4765625-4.7147217 c0.0649414-0.1252441,0.1264648-0.2734985,0.1767578-0.4077759l2-5.3439026 C122.7070312,4.8037567,122.5732422,3.6170807,121.953125,2.6815338z M43.4545898,33.4974518 c-2.9345703,2.9291992-7.8654785,4.3696289-14.5578613,4.284668 c-15.671875-0.2006836-17.5987549-9.2626953-18.7071533-23.0654297 c-0.1088867-1.3579102-0.2324829-2.6760254-0.3638306-3.9443359c1.1499023-1.2155762,3.2846375-3.0004883,6.0522156-3.1254883 c0.1318359-0.0058594,0.2582855-0.019043,0.3852386-0.0395508l12.8557053-0.5336914 c5.6845703,0.0053711,10.0474815,0.6694336,13.15588,1.5068359c3.708252,1.1955566,4.7623253,4.9990234,5.7623253,6.1918945 v3.6987305C48.0371094,24.2025299,47.0522461,29.9071198,43.4545898,33.4974518z M94.4677734,37.9486237 c-0.0810547,0-0.1621094,0-0.2441406,0c-6.8847656,0-11.7524414-1.6166992-14.7338867-4.6474609 c-3.5214844-3.5810547-4.4526367-9.2783203-4.4526367-14.9086914v-3.6162109 c1-1.2133789,2.0153809-4.9709473,5.6782227-6.1801758c3.1152344-0.8466797,7.4191895-1.5170898,13.1311035-1.5224609 l12.8756104,0.5336914c0.1269531,0.0205078,0.2659302,0.0336914,0.3977661,0.0395508 c2.7663574,0.125,4.9117737,1.9082031,6.0585022,3.1181641c-0.1940918,1.5683594-0.3409882,3.244873-0.4921112,4.9287109 C111.4459686,29.4754791,109.5976562,37.9486237,94.4677734,37.9486237z' })
					),
					_react2.default.createElement('path', { style: style.st2, d: 'M8.4638672,7.1986237h-3c-0.828125,0-1.5-0.6713867-1.5-1.5s0.671875-1.5,1.5-1.5h3 c0.828125,0,1.5,0.6713867,1.5,1.5S9.2919922,7.1986237,8.4638672,7.1986237z' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M117.5361328,7.1986237h-3c-0.828125,0-1.5-0.6713867-1.5-1.5s0.671875-1.5,1.5-1.5h3 c0.828125,0,1.5,0.6713867,1.5,1.5S118.3642578,7.1986237,117.5361328,7.1986237z' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC5.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
	
			// 6
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '32.276268', cy: '10.2851295' }),
					_react2.default.createElement(
						'g',
						{ opacity: '0.5' },
						_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M64.3892059,1.3939835c-0.3281479-0.4958399-0.8747101-0.8037989-1.4688911-0.8286426 L49.6268387,0.0133438c-0.0258789-0.0010352-0.051239-0.0015527-0.0771179-0.0015527 c-3.2716103,0-5.8248253,0.372915-7.792141,0.8889405c-0.0212173,0.0051758-0.0424385,0.0108691-0.0636597,0.0168213 c-2.7043457,0.7182691-4.2861938,1.6101856-5.1017685,2.2588403c-1.1482468-0.649431-2.5141373-1.110852-3.9781036-1.110852 h-0.5300026c-1.4639683,0-2.8298569,0.461421-3.9781036,1.110852c-0.8155746-0.6486547-2.3974228-1.5877355-5.1017685-2.3060045 c-0.0212212-0.0059522-0.0424404,0.0119366-0.0636616,0.0067608C20.973196,0.3611239,18.419466,0,15.1483727,0 c-0.0258789,0-0.05124,0.0064131-0.0771189,0.0074483L1.777777,0.5623931 C1.1835972,0.5872369,0.6370347,0.8966697,0.3088902,1.3925096c-0.3286621,0.4958398-0.3995703,1.1199995-0.1909863,1.6769136 l1.0600001,2.8271213C1.2032652,5.9639592,1.2344493,6.028194,1.2669274,6.0912089 c0.065603,0.636621,0.1202074,1.2975311,0.1749413,1.9784055c0.4948047,6.1643553,1.2432226,15.4800301,13.5507126,15.6371155 c0.1195612,0.0015526,0.2375689,0.0023518,0.3555765,0.0023518c4.4635944,0,7.7372761-1.0995827,9.9990921-3.3564816 c3.3920765-3.3849621,3.5027103-8.4114151,3.4659615-12.6081982l0.0406303-0.3318939 c0.5786514-0.9466505,1.7962551-1.6369672,3.2302036-1.6369672h0.5300026c1.4339485,0,2.6515503,0.6903195,3.2302017,1.63697 l0.0406303,0.2847328c-0.0357132,4.1240621,0.074791,9.1298504,3.3924675,12.5031662 c2.3073616,2.3459225,5.7073326,3.5951309,10.393486,3.5951309c0.0471001,0,0.0936813,0,0.1407814,0 c12.0005646,0,12.8198929-9.1436653,13.3623161-15.1726742c0.0781517-0.872766,0.1547546-1.7177768,0.2525749-2.4988022 c0.03442-0.0663795,0.067028-0.1449542,0.0936813-0.2161212l1.0600052-2.8322685 C64.7887726,2.5187616,64.717865,1.8898233,64.3892059,1.3939835z M22.7849789,17.7264194 c-1.5553226,1.5524769-4.1687031,2.3159046-7.7156668,2.270874c-8.3060932-0.1063614-9.3273392-4.9092283-9.9147911-12.2246771 c-0.0577102-0.7196927-0.1232162-1.4182935-0.1928306-2.090498c0.6094484-0.6442556,1.7408581-1.5902591,3.207674-1.6565089 c0.0698738-0.0031056,0.1368914-0.0100927,0.2041769-0.0209618l6.8135242-0.2828567 c3.0128222,0.0028467,5.3251638,0.3548,6.9726152,0.7986233c1.965374,0.6336446,2.5240326,2.6494823,3.0540333,3.2817039 v1.9603271C25.2137146,12.8001118,24.6917362,15.8235435,22.7849789,17.7264194z M49.8219681,20.0855408 c-0.0429611,0-0.0859184,0-0.1293945,0c-3.6489258,0-6.2287941-0.8568497-7.80896-2.4631538 c-1.8663902-1.8979588-2.3598976-4.91751-2.3598976-7.9016066V7.8041887 c0.5299988-0.6430912,1.0681496-2.6346021,3.0094566-3.2754931c1.6510735-0.4487405,3.9321709-0.8040578,6.9594841-0.8069046 l6.8240738,0.2828567c0.0672836,0.010869,0.1409416,0.0178561,0.2108154,0.0209618 c1.4661713,0.0662498,2.603241,1.0113478,3.2110062,1.652627c-0.1028671,0.8312302-0.1807213,1.7197828-0.2608185,2.6122165 C58.8204117,15.5947742,57.8408051,20.0855408,49.8219681,20.0855408z' })
					),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M4.2398958,3.7880411H2.6498961c-0.4389064,0-0.7950001-0.355835-0.7950001-0.7950001 S2.2109897,2.198041,2.6498961,2.198041h1.5899997c0.4389067,0,0.7950001,0.355835,0.7950001,0.7950001 S4.6788025,3.7880411,4.2398958,3.7880411z' }),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M62.0481987,3.7880411h-1.5900002c-0.4389076,0-0.795002-0.355835-0.795002-0.7950001 s0.3560944-0.7950001,0.795002-0.7950001h1.5900002c0.4389038,0,0.7949982,0.355835,0.7949982,0.7950001 S62.4871025,3.7880411,62.0481987,3.7880411z' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC5.default);
	
	var Chicken = function (_PositionedGoodyHOC3) {
		_inherits(Chicken, _PositionedGoodyHOC3);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
	
			// 6
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, fill: 'none', cx: '42.62904', cy: '13.58413' }),
					_react2.default.createElement(
						'g',
						{ opacity: '0.5' },
						_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M85.04234,1.84111c-0.4334-0.65488-1.15527-1.06162-1.94004-1.09443L65.54488,0.01762 c-0.03418-0.00137-0.06768-0.00205-0.10186-0.00205c-4.32099,0-7.69316,0.49253-10.2915,1.17407 C55.1235,1.19648,55.09547,1.204,55.06744,1.21186c-3.57178,0.94866-5.66101,2.12666-6.73818,2.98337 c-1.51655-0.85774-3.32056-1.46716-5.2541-1.46716h-0.7c-1.93354,0-3.73755,0.60942-5.2541,1.46716 c-1.07718-0.85671-3.16641-2.09701-6.73819-3.04567c-0.02803-0.00786-0.05605,0.01577-0.08408,0.00893 C27.70045,0.47696,24.3276,0,20.00728,0c-0.03418,0-0.06767,0.00847-0.10185,0.00984L2.34801,0.74278 C1.56324,0.7756,0.84137,1.18428,0.40797,1.83916c-0.43408,0.65488-0.52773,1.47924-0.25225,2.21479l1.4,3.73393 c0.0335,0.08904,0.07468,0.17388,0.11758,0.2571c0.08665,0.84082,0.15876,1.71372,0.23105,2.61299 c0.65352,8.1416,1.64199,20.44532,17.89717,20.65279c0.15791,0.00205,0.31377,0.00311,0.46963,0.00311 c5.89531,0,10.21904-1.45228,13.20635-4.43309c4.4801-4.4707,4.62622-11.10942,4.57768-16.65234l0.05367-0.43835 c0.76426-1.25029,2.37241-2.16203,4.26631-2.16203h0.7c1.89389,0,3.50205,0.91174,4.26631,2.16204l0.05366,0.37606 c-0.04717,5.44688,0.09878,12.0583,4.48061,16.51362c3.04746,3.09839,7.53799,4.74829,13.72725,4.74829 c0.0622,0,0.12373,0,0.18594,0c15.84981,0,16.93193-12.07654,17.64834-20.03938c0.10323-1.15271,0.2044-2.26876,0.3336-3.3003 c0.04546-0.08767,0.08852-0.19145,0.12373-0.28544l1.39999-3.74073C85.57008,3.32667,85.47643,2.49599,85.04234,1.84111z M30.09337,23.41225c-2.0542,2.05044-5.50583,3.05874-10.1905,2.99927C8.93255,26.27104,7.58374,19.92763,6.80786,10.26572 C6.73164,9.31518,6.64512,8.3925,6.55318,7.50468c0.80493-0.8509,2.29925-2.10034,4.23655-2.18784 c0.09229-0.0041,0.1808-0.01333,0.26967-0.02769l8.99899-0.37358c3.9792,0.00376,7.03324,0.4686,9.20912,1.05479 c2.59578,0.83689,3.33363,3.49932,4.03363,4.33433v2.58911C33.30113,16.90581,32.61173,20.89902,30.09337,23.41225z M65.8026,26.52807c-0.05674,0-0.11348,0-0.1709,0c-4.81934,0-8.22671-1.13169-10.31372-3.25322 c-2.46504-2.50674-3.11684-6.49483-3.11684-10.43608v-2.53135c0.7-0.84937,1.41077-3.47966,3.97475-4.32612 c2.18066-0.59268,5.19343-1.06196,9.19177-1.06572l9.01292,0.37358c0.08887,0.01436,0.18616,0.02358,0.27844,0.02769 c1.93645,0.0875,3.43824,1.33574,4.24095,2.18271c-0.13586,1.09785-0.23869,2.27141-0.34448,3.4501 C77.68733,20.59687,76.39352,26.52807,65.8026,26.52807z' })
					),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M5.59986,5.00307h-2.1c-0.57969,0-1.05-0.46997-1.05-1.05s0.47031-1.05,1.05-1.05h2.1 c0.57969,0,1.05,0.46997,1.05,1.05S6.17955,5.00307,5.59986,5.00307z' }),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M81.95045,5.00307h-2.1c-0.57969,0-1.05-0.46997-1.05-1.05s0.47031-1.05,1.05-1.05h2.1 c0.57969,0,1.05,0.46997,1.05,1.05S82.53014,5.00307,81.95045,5.00307z' })
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC5.default);
	
	function Kerry(props) {
		var glasses = {
			Cat: Cat,
			Tortoise: Tortoise,
			Chicken: Chicken
		};
	
		var ThisKerry = glasses[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisKerry)) {
			return null;
		}
	
		return _react2.default.createElement(ThisKerry, props);
	}
	
	exports.default = Kerry;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC6 = __webpack_require__(6);
	
	var _PositionedGoodyHOC7 = _interopRequireDefault(_PositionedGoodyHOC6);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
	
			// 4
			value: function render() {
				var style = {
					st1: {
						fill: '#EFEFEF'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '48.5658134', cy: '15.4998684' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M18.165432,30.5141602c-8.2783194,0-15.0136719-6.7353516-15.0136719-15.0141602 S9.8871126,0.4858398,18.165432,0.4858398c8.2792969,0,15.0146484,6.7353516,15.0146484,15.0141602 S26.4447289,30.5141602,18.165432,30.5141602z M18.165432,3.4858398c-6.6240225,0-12.0136719,5.3896484-12.0136719,12.0141602 s5.3896489,12.0141602,12.0136719,12.0141602c6.625,0,12.0146484-5.3896484,12.0146484-12.0141602 S24.790432,3.4858398,18.165432,3.4858398z' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M78.1654358,30.3417969c-8.1835938,0-14.8418007-6.6582031-14.8418007-14.8417969 c0-8.184082,6.6582069-14.8422852,14.8418007-14.8422852c8.1845703,0,14.8427734,6.6582031,14.8427734,14.8422852 C93.0082092,23.6835938,86.3500061,30.3417969,78.1654358,30.3417969z M78.1654358,3.6577148 c-6.5292969,0-11.8417969,5.3125-11.8417969,11.8422852s5.3125,11.8417969,11.8417969,11.8417969 c6.5302734,0,11.8427734-5.3120117,11.8427734-11.8417969S84.6957092,3.6577148,78.1654358,3.6577148z' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M64.8402405,17.9912109h-8.4209023l-0.0351562-1.4643555 c-0.0234375-0.7612305-0.4580078-7.4863281-8.0810547-7.4863281c-7.890625,0-8.9345703,7.3261719-8.9746094,7.6381836 l-0.1699219,1.3066406l-7.3183594,0.0058594v-3h4.7646484c0.9443359-3.6728516,4.1972656-8.9506836,11.6982422-8.9506836 c7.5097656,0,10.3017578,5.2324219,10.9345703,8.9506836h5.6025429V17.9912109z' }),
					_react2.default.createElement('circle', { style: style.st1, cx: '2.3484442', cy: '15.4998684', r: '2.0086577' }),
					_react2.default.createElement('circle', { style: style.st1, cx: '93.6515579', cy: '15.4998684', r: '2.0086577' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M18.165432,30.5141602c-8.2783194,0-15.0136719-6.7353516-15.0136719-15.0141602 S9.8871126,0.4858398,18.165432,0.4858398c8.2792969,0,15.0146484,6.7353516,15.0146484,15.0141602 S26.4447289,30.5141602,18.165432,30.5141602z M18.165432,3.4858398c-6.6240225,0-12.0136719,5.3896484-12.0136719,12.0141602 s5.3896489,12.0141602,12.0136719,12.0141602c6.625,0,12.0146484-5.3896484,12.0146484-12.0141602 S24.790432,3.4858398,18.165432,3.4858398z' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M78.1654358,30.3417969c-8.1835938,0-14.8418007-6.6582031-14.8418007-14.8417969 c0-8.184082,6.6582069-14.8422852,14.8418007-14.8422852c8.1845703,0,14.8427734,6.6582031,14.8427734,14.8422852 C93.0082092,23.6835938,86.3500061,30.3417969,78.1654358,30.3417969z M78.1654358,3.6577148 c-6.5292969,0-11.8417969,5.3125-11.8417969,11.8422852s5.3125,11.8417969,11.8417969,11.8417969 c6.5302734,0,11.8427734-5.3120117,11.8427734-11.8417969S84.6957092,3.6577148,78.1654358,3.6577148z' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M64.8402405,17.9912109h-8.4209023l-0.0351562-1.4643555 c-0.0234375-0.7612305-0.4580078-7.4863281-8.0810547-7.4863281c-7.890625,0-8.9345703,7.3261719-8.9746094,7.6381836 l-0.1699219,1.3066406l-7.3183594,0.0058594v-3h4.7646484c0.9443359-3.6728516,4.1972656-8.9506836,11.6982422-8.9506836 c7.5097656,0,10.3017578,5.2324219,10.9345703,8.9506836h5.6025429V17.9912109z' }),
					_react2.default.createElement('circle', { style: style.st1, cx: '2.3484442', cy: '15.4998684', r: '2.0086577' }),
					_react2.default.createElement('circle', { style: style.st1, cx: '93.6515579', cy: '15.4998684', r: '2.0086577' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC7.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
	
			// 4
			value: function render() {
				var style = {
					st1: {
						fill: '#EFEFEF'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '22.7070141', cy: '8.311657' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M35.7696571,16.6233139c-4.5827789,0-8.311388-3.7286081-8.311388-8.311657S31.1868782,0,35.7696571,0 c4.5833168,0,8.311924,3.7286091,8.311924,8.311657S40.3529739,16.6233139,35.7696571,16.6233139z M35.7696571,1.6607636 c-3.6669807,0-6.6506252,2.983644-6.6506252,6.6508932s2.9836445,6.6508942,6.6506252,6.6508942 c3.6675186,0,6.6511612-2.9836445,6.6511612-6.6508942S39.4371758,1.6607636,35.7696571,1.6607636z' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M9.6341515,16.6233139c-4.5827785,0-8.3113871-3.7286081-8.3113871-8.311657S5.051373,0,9.6341515,0 c4.5833178,0,8.3119278,3.7286091,8.3119278,8.311657S14.2174692,16.6233139,9.6341515,16.6233139z M9.6341515,1.6607636 c-3.6669798,0-6.6506238,2.983644-6.6506238,6.6508932s2.983644,6.6508942,6.6506238,6.6508942 c3.6675196,0,6.6511631-2.9836445,6.6511631-6.6508942S13.301671,1.6607636,9.6341515,1.6607636z' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M26.6025391,7.9223223c-0.3447266-1.4902344-1.5273438-2.9921875-3.9003906-2.9921875 s-3.5556641,1.5019531-3.9003906,2.9921875h-1.9277344v1.6020508h3.4082031l0.0185547-0.7797852 C20.3125,8.374959,20.4814453,6.5326738,22.7021484,6.5326738s2.3896484,1.8422852,2.4013672,2.2099609l0.0185547,0.7817383 h3.4082031V7.9223223H26.6025391z' }),
					_react2.default.createElement('circle', { style: style.st1, cx: '0.8796229', cy: '8.3115997', r: '0.8796229' }),
					_react2.default.createElement('circle', { style: style.st1, cx: '44.5968285', cy: '8.3115997', r: '0.8796229' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC7.default);
	
	var Chicken = function (_PositionedGoodyHOC3) {
		_inherits(Chicken, _PositionedGoodyHOC3);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
	
			// 4
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, fill: 'none', cx: '28.90401', cy: '10.15376' }),
					_react2.default.createElement('circle', { fill: '#EFEFEF', cx: '56.28173', cy: '10.50982', r: '1.40606' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M11.91563,21.01982c-5.79482,0-10.50957-4.71475-10.50957-10.50991S6.12081,0,11.91563,0 c5.79551,0,10.51025,4.71475,10.51025,10.50991S17.71114,21.01982,11.91563,21.01982z M11.91563,2.1 c-4.63682,0-8.40957,3.77275-8.40957,8.40991s3.77275,8.40991,8.40957,8.40991c4.6375,0,8.41025-3.77275,8.41025-8.40991 S16.55313,2.1,11.91563,2.1z' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M45.89178,20.89917c-5.72852,0-10.38926-4.66074-10.38926-10.38926 c0-5.72886,4.66074-10.3896,10.38926-10.3896c5.7292,0,10.38994,4.66074,10.38994,10.3896 C56.28173,16.23843,51.62099,20.89917,45.89178,20.89917z M45.89178,2.22031c-4.57051,0-8.28926,3.71875-8.28926,8.2896 s3.71875,8.28926,8.28926,8.28926c4.57119,0,8.28994-3.71841,8.28994-8.28926S50.46298,2.22031,45.89178,2.22031z' }),
					_react2.default.createElement('circle', { fill: '#EFEFEF', cx: '1.40606', cy: '10.50982', r: '1.40606' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M34.35794,9.21826c-0.44434-2.10986-2.08887-4.27783-5.4541-4.27783 c-3.36621,0-5.00977,2.16797-5.45312,4.27783h-2.72559v1.9834h4.56836l0.02246-0.96582 c0.01172-0.33887,0.20508-3.31201,3.58789-3.31201c3.3916,0,3.57715,2.97266,3.58691,3.30957l0.02344,0.96826h4.56934v-1.9834 H34.35794z' })
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC7.default);
	
	var Bunny = function (_PositionedGoodyHOC4) {
		_inherits(Bunny, _PositionedGoodyHOC4);
	
		function Bunny() {
			_classCallCheck(this, Bunny);
	
			return _possibleConstructorReturn(this, (Bunny.__proto__ || Object.getPrototypeOf(Bunny)).apply(this, arguments));
		}
	
		_createClass(Bunny, [{
			key: 'render',
	
			// 4
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '39.98662', cy: '14.29694' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M63.66008,29.05507c-8.01001,0-14.52707-6.51705-14.52707-14.52754S55.65006,0,63.66008,0 c8.01096,0,14.52801,6.51705,14.52801,14.52754S71.67104,29.05507,63.66008,29.05507z M63.66008,2.90277 c-6.40933,0-11.6243,5.21496-11.6243,11.62477s5.21497,11.62477,11.6243,11.62477c6.41028,0,11.62524-5.21496,11.62524-11.62477 S70.07036,2.90277,63.66008,2.90277z' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M16.52867,29.05507c-8.01001,0-14.52707-6.51705-14.52707-14.52754S8.51865,0,16.52867,0 c8.01096,0,14.52801,6.51705,14.52801,14.52754S24.53962,29.05507,16.52867,29.05507z M16.52867,2.90277 c-6.40933,0-11.6243,5.21496-11.6243,11.62477s5.21496,11.62477,11.6243,11.62477c6.41028,0,11.62524-5.21496,11.62524-11.62477 S22.93894,2.90277,16.52867,2.90277z' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M46.91214,13.84704c-0.60253-2.60471-2.66957-5.2299-6.8173-5.2299s-6.21477,2.62519-6.8173,5.2299 h-3.36939v2.80015h5.95703l0.03243-1.36295c0.02048-0.64606,0.31577-3.8661,4.19723-3.8661s4.17675,3.22004,4.19723,3.86268 l0.03243,1.36636h5.95703v-2.80015H46.91214z' }),
					_react2.default.createElement('circle', { fill: '#EFEFEF', cx: '1.53745', cy: '14.52744', r: '1.53745' }),
					_react2.default.createElement('circle', { fill: '#EFEFEF', cx: '78.65224', cy: '14.52744', r: '1.53745' })
				);
			}
		}]);
	
		return Bunny;
	}(_PositionedGoodyHOC7.default);
	
	var Pig = function (_PositionedGoodyHOC5) {
		_inherits(Pig, _PositionedGoodyHOC5);
	
		function Pig() {
			_classCallCheck(this, Pig);
	
			return _possibleConstructorReturn(this, (Pig.__proto__ || Object.getPrototypeOf(Pig)).apply(this, arguments));
		}
	
		_createClass(Pig, [{
			key: 'render',
			value: function render() {
				var style = {
					st1: {
						fill: '#EFEFEF'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '48.2658134', cy: '15' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M18.165432,30.5141602c-8.2783194,0-15.0136719-6.7353516-15.0136719-15.0141602 S9.8871126,0.4858398,18.165432,0.4858398c8.2792969,0,15.0146484,6.7353516,15.0146484,15.0141602 S26.4447289,30.5141602,18.165432,30.5141602z M18.165432,3.4858398c-6.6240225,0-12.0136719,5.3896484-12.0136719,12.0141602 s5.3896489,12.0141602,12.0136719,12.0141602c6.625,0,12.0146484-5.3896484,12.0146484-12.0141602 S24.790432,3.4858398,18.165432,3.4858398z' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M78.1654358,30.3417969c-8.1835938,0-14.8418007-6.6582031-14.8418007-14.8417969 c0-8.184082,6.6582069-14.8422852,14.8418007-14.8422852c8.1845703,0,14.8427734,6.6582031,14.8427734,14.8422852 C93.0082092,23.6835938,86.3500061,30.3417969,78.1654358,30.3417969z M78.1654358,3.6577148 c-6.5292969,0-11.8417969,5.3125-11.8417969,11.8422852s5.3125,11.8417969,11.8417969,11.8417969 c6.5302734,0,11.8427734-5.3120117,11.8427734-11.8417969S84.6957092,3.6577148,78.1654358,3.6577148z' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M64.8402405,17.9912109h-8.4209023l-0.0351562-1.4643555 c-0.0234375-0.7612305-0.4580078-7.4863281-8.0810547-7.4863281c-7.890625,0-8.9345703,7.3261719-8.9746094,7.6381836 l-0.1699219,1.3066406l-7.3183594,0.0058594v-3h4.7646484c0.9443359-3.6728516,4.1972656-8.9506836,11.6982422-8.9506836 c7.5097656,0,10.3017578,5.2324219,10.9345703,8.9506836h5.6025429V17.9912109z' }),
					_react2.default.createElement('circle', { style: style.st1, cx: '2.3484442', cy: '15.4998684', r: '2.0086577' }),
					_react2.default.createElement('circle', { style: style.st1, cx: '93.6515579', cy: '15.4998684', r: '2.0086577' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M18.165432,30.5141602c-8.2783194,0-15.0136719-6.7353516-15.0136719-15.0141602 S9.8871126,0.4858398,18.165432,0.4858398c8.2792969,0,15.0146484,6.7353516,15.0146484,15.0141602 S26.4447289,30.5141602,18.165432,30.5141602z M18.165432,3.4858398c-6.6240225,0-12.0136719,5.3896484-12.0136719,12.0141602 s5.3896489,12.0141602,12.0136719,12.0141602c6.625,0,12.0146484-5.3896484,12.0146484-12.0141602 S24.790432,3.4858398,18.165432,3.4858398z' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M78.1654358,30.3417969c-8.1835938,0-14.8418007-6.6582031-14.8418007-14.8417969 c0-8.184082,6.6582069-14.8422852,14.8418007-14.8422852c8.1845703,0,14.8427734,6.6582031,14.8427734,14.8422852 C93.0082092,23.6835938,86.3500061,30.3417969,78.1654358,30.3417969z M78.1654358,3.6577148 c-6.5292969,0-11.8417969,5.3125-11.8417969,11.8422852s5.3125,11.8417969,11.8417969,11.8417969 c6.5302734,0,11.8427734-5.3120117,11.8427734-11.8417969S84.6957092,3.6577148,78.1654358,3.6577148z' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M64.8402405,17.9912109h-8.4209023l-0.0351562-1.4643555 c-0.0234375-0.7612305-0.4580078-7.4863281-8.0810547-7.4863281c-7.890625,0-8.9345703,7.3261719-8.9746094,7.6381836 l-0.1699219,1.3066406l-7.3183594,0.0058594v-3h4.7646484c0.9443359-3.6728516,4.1972656-8.9506836,11.6982422-8.9506836 c7.5097656,0,10.3017578,5.2324219,10.9345703,8.9506836h5.6025429V17.9912109z' }),
					_react2.default.createElement('circle', { style: style.st1, cx: '2.3484442', cy: '15.4998684', r: '2.0086577' }),
					_react2.default.createElement('circle', { style: style.st1, cx: '93.6515579', cy: '15.4998684', r: '2.0086577' })
				);
			}
		}]);
	
		return Pig;
	}(_PositionedGoodyHOC7.default);
	
	function OldMan(props) {
		var oldmanglasses = {
			Cat: Cat,
			Tortoise: Tortoise,
			Chicken: Chicken,
			Bunny: Bunny,
			Pig: Pig
		};
	
		var ThisOldMan = oldmanglasses[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisOldMan)) {
			return null;
		}
	
		return _react2.default.createElement(ThisOldMan, props);
	}
	
	exports.default = OldMan;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC4 = __webpack_require__(6);
	
	var _PositionedGoodyHOC5 = _interopRequireDefault(_PositionedGoodyHOC4);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
	
			// 1
			value: function render() {
				var style = {
					st9: {
						fill: '#EFEFEF'
					},
					st52: {
						fill: '#1C1C1C'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '62.0626823', cy: '20.2777004' }),
					_react2.default.createElement('path', { style: style.st9, d: 'M29.9228516,43.605957c-0.2138672,0-0.4287109-0.0014648-0.6455078-0.0039062 C7.8779297,43.3286133,6.6064453,27.4970703,5.6777344,15.9375C5.5625,14.4980469,5.4501953,13.0966797,5.3056641,11.7636719 l2.9824219-0.3232422c0.1474609,1.359375,0.2626953,2.7885742,0.3798828,4.2568359 c0.9287109,11.5620117,1.9814453,24.6665039,20.6484375,24.9047852c7.3212891,0.1074219,12.5625-1.4985352,15.9414062-4.8686523 c4.1171875-4.1088867,4.9355469-10.5332031,5.0595703-16.59375v-4.7602539c0-0.0097656,0-0.0195312,0-0.0292969 l1.3916016-0.0151367l-1.28125-0.5214844C52.0830078,9.7504883,56.4287109,7.125,61.5,7.125h1 c5.0712891,0,9.4169922,2.6254883,11.0722656,6.6884766L72.3125,14.3266602l1.3701172,0.0073242v4.953125 c0.1259766,6.0126953,0.9414062,12.0732422,4.9541016,16.1538086c3.3730469,3.4291992,8.6318359,5.1171875,16.0751953,5.1611328 c0.0791016,0.0004883,0.1601562,0.0009766,0.2392578,0.0009766c18.0722656,0,19.1679688-12.1962891,20.2285156-23.9926758 c0.1640625-1.8183594,0.3183594-3.5356445,0.5361328-5.2026367l2.9746094,0.3886719 c-0.2099609,1.6074219-0.3613281,3.2954102-0.5224609,5.0825195 c-1.0712891,11.9116211-2.4042969,26.7236328-23.2128906,26.7241211c-0.0869141,0-0.1738281-0.0004883-0.2607422-0.0009766 c-8.2822266-0.0488281-14.234375-2.0302734-18.1962891-6.0576172 c-5.9033203-6.0019531-5.8984375-15.2963867-5.8193359-22.8637695C69.4023438,11.9038086,66.2285156,10.125,62.5,10.125h-1 c-3.7285156,0-6.9023438,1.7788086-8.1787109,4.5556641c0.0800781,7.699707,0.0869141,17.1577148-5.9453125,23.1762695 C43.5029297,41.7226562,37.7880859,43.605957,29.9228516,43.605957z' }),
					_react2.default.createElement('path', { style: style.st52, d: 'M51.8349609,19.144043c-1.8417969,0-3.453125-1.2612305-3.8876953-3.0629883 c-0.0048828-0.019043-1.2939453-4.8339844-5.3886719-6.1889648c-3.0664062-0.8305664-7.2792969-1.4916992-12.9306641-1.4980469 L16.8085938,8.9262695c-0.1357422,0.0205078-0.2744141,0.0341797-0.4150391,0.0405273 c-3.8994141,0.1757812-6.5634766,3.9638672-6.5888672,4.0019531c-0.828125,1.2568359-2.2900391,1.9389648-3.7871094,1.7753906 c-1.4960938-0.1679688-2.7705078-1.1611328-3.2988281-2.5708008l-2-5.3334961 C0.2685547,5.6391602,0.4208984,4.2949219,1.1298828,3.2260742c0.7080078-1.0693359,1.8867188-1.7338867,3.1679688-1.7871094 l25.0820312-1.0415039c0.0556641-0.0024414,0.1103516-0.003418,0.1660156-0.003418 c6.1113281,0,10.9179688,0.6899414,14.6494141,1.6538086c0.109375,0.0214844,0.21875,0.0483398,0.328125,0.0795898 c0.0791016,0.0229492,0.15625,0.0458984,0.234375,0.0693359c7.5263672,2.0581055,10.4707031,5.2075195,10.9091797,5.71875 c0.7744141,0.9042969,1.1064453,2.1064453,0.9052734,3.2802734l-0.7939453,4.625 c-0.3212891,1.8706055-1.9121094,3.2578125-3.8095703,3.3208008 C51.9238281,19.1435547,51.8789062,19.144043,51.8349609,19.144043z' }),
					_react2.default.createElement('path', { style: style.st9, d: 'M8.9638672,8.019043h-3c-0.828125,0-1.5-0.6713867-1.5-1.5s0.671875-1.5,1.5-1.5h3 c0.828125,0,1.5,0.6713867,1.5,1.5S9.7919922,8.019043,8.9638672,8.019043z' }),
					_react2.default.createElement('path', { style: style.st52, d: 'M72.1650391,19.144043c-0.0439453,0-0.0888672-0.0004883-0.1337891-0.0024414 c-1.8974609-0.0629883-3.4882812-1.4501953-3.8095703-3.3208008l-0.7939453-4.625 c-0.2011719-1.1738281,0.1308594-2.3759766,0.9052734-3.2802734c0.4384766-0.5112305,3.3828125-3.6606445,10.9091797-5.71875 c0.078125-0.0234375,0.1552734-0.0463867,0.234375-0.0693359c0.109375-0.03125,0.21875-0.0581055,0.328125-0.0795898 c3.7314453-0.9638672,8.5380859-1.6538086,14.6494141-1.6538086c0.0556641,0,0.1103516,0.0009766,0.1660156,0.003418 l25.0820312,1.0415039c1.28125,0.0532227,2.4599609,0.7177734,3.1679688,1.7871094 c0.7089844,1.0688477,0.8613281,2.4130859,0.4111328,3.6137695l-2,5.3334961 c-0.5283203,1.409668-1.8027344,2.402832-3.2988281,2.5708008c-1.4960938,0.1640625-2.9589844-0.5180664-3.7871094-1.7753906 c-0.0087891-0.0126953-2.6513672-3.8242188-6.5888672-4.0019531c-0.140625-0.0063477-0.2792969-0.0200195-0.4150391-0.0405273 L94.3720703,8.394043c-5.6728516,0.0063477-9.90625,0.6787109-12.9785156,1.5141602 c-4.0791016,1.3808594-5.3291016,6.1240234-5.3408203,6.1728516 C75.6191406,17.8823242,74.0068359,19.144043,72.1650391,19.144043z' }),
					_react2.default.createElement('path', { style: style.st9, d: 'M118.0361328,8.019043h-3c-0.828125,0-1.5-0.6713867-1.5-1.5s0.671875-1.5,1.5-1.5h3 c0.828125,0,1.5,0.6713867,1.5,1.5S118.8642578,8.019043,118.0361328,8.019043z' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC5.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
	
			// 1
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '32.6929092', cy: '10.5874405' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M15.6859245,23.0090256c-0.1138783,0-0.2282753-0.0007801-0.3437138-0.0020809 C3.9476767,22.8613472,3.2706501,14.4315348,2.77614,8.2764158C2.714781,7.5099516,2.6549823,6.7637663,2.5780239,6.0539804 l1.5880485-0.1721168C4.2445908,6.605689,4.3059497,7.3666945,4.3683486,8.1484985 c0.4945102,6.1564188,1.055059,13.134161,10.9946613,13.2610378c3.8983631,0.0571995,6.6891479-0.797924,8.4883118-2.5924091 c2.1922779-2.1878567,2.6280289-5.6086082,2.694067-8.8356647V7.4467726c0-0.0051999,0-0.0103998,0-0.0155997l0.7409859-0.00806 l-0.6822262-0.2776742c0.881382-2.1634173,3.1953354-3.5614097,5.8956413-3.5614097h0.5324707 c2.7003059,0,5.0142593,1.3979924,5.8956451,3.5614097l-0.6707878,0.2732544l0.7295456,0.0039001v2.6373882 c0.0670776,3.2015762,0.5012703,6.4286318,2.6379089,8.601409c1.7960434,1.8259449,4.5961876,2.7247467,8.5595474,2.7481461 c0.0421219,0.0002594,0.0852814,0.0005207,0.1273994,0.0005207c9.6229286,0,10.206356-6.4941521,10.7710648-12.7753677 c0.0873604-0.9682212,0.1695175-1.8826227,0.2854767-2.7702456l1.583889,0.2069559 c-0.1117973,0.8559031-0.1923981,1.7547054-0.2781944,2.7062864 c-0.5704308,6.3425751-1.2802162,14.2295179-12.360157,14.2297792c-0.0462799,0-0.092556-0.0002613-0.1388359-0.0005207 c-4.4100342-0.0259991-7.5793724-1.0810585-9.6889687-3.2254963c-3.1433372-3.1958561-3.1407394-8.1448584-3.0986176-12.1742592 c-0.6796265-1.478591-2.3695946-2.4257522-4.3549156-2.4257522h-0.5324707 c-1.9853191,0-3.6752853,0.9471612-4.3549118,2.4257522c0.0426388,4.0998588,0.046278,9.1359596-3.1656971,12.3406563 C22.9169006,22.0062237,19.8739223,23.0090256,15.6859245,23.0090256z' }),
					_react2.default.createElement('path', { fill: '#1C1C1C', d: 'M27.3534527,9.9838028c-0.9806995,0-1.8386822-0.671567-2.0700779-1.6309481 c-0.0025997-0.0101395-0.6889858-2.5739489-2.8693027-3.295435c-1.6327686-0.4422512-3.8760033-0.7942843-6.8851843-0.7976642 L8.7029829,4.5431499C8.6307039,4.55407,8.5568657,4.5613499,8.481987,4.5647297 c-2.0763187,0.0935979-3.4948506,2.1106381-3.5083704,2.130918C4.5326653,7.3648744,3.7542405,7.7280869,2.9570963,7.6409888 c-0.7966242-0.0894384-1.4752108-0.618268-1.7565253-1.3688731L0.1356321,3.4321921 c-0.2397153-0.6393273-0.1585969-1.3550932,0.2189157-1.9242219C0.7315403,0.9385814,1.3591679,0.5847284,2.0413945,0.556389 L15.3968105,0.00182C15.4264498,0.00052,15.4555693,0,15.4852085,0c3.2540951,0,5.8134842,0.3673727,7.8003654,0.8806026 c0.058239,0.0114397,0.116478,0.0257395,0.1747169,0.0423791c0.0421181,0.0122197,0.0831985,0.0244395,0.1247978,0.0369192 c4.0075607,1.0958782,5.5753288,2.7728453,5.8088036,3.0450597c0.4123535,0.4815106,0.5891495,1.1216178,0.4820309,1.7466455 l-0.4227505,2.4626713c-0.1710777,0.9960403-1.0181408,1.7346859-2.0284805,1.7682247 C27.4007721,9.9835424,27.3768539,9.9838028,27.3534527,9.9838028z' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M4.5259051,4.0600796H2.9284968c-0.4409513,0-0.7987041-0.3574929-0.7987041-0.7987041 s0.3577528-0.7987041,0.7987041-0.7987041h1.5974083c0.4409513,0,0.7987041,0.3574929,0.7987041,0.7987041 S4.9668565,4.0600796,4.5259051,4.0600796z' }),
					_react2.default.createElement('path', { fill: '#1C1C1C', d: 'M38.1786003,9.9838028c-0.0233994,0-0.0473213-0.0002604-0.0712395-0.0013008 c-1.0103416-0.0335388-1.8574028-0.7721844-2.0284805-1.7682247L35.6561279,5.751606 c-0.1071167-0.6250277,0.0696793-1.2651348,0.4820328-1.7466455c0.2334747-0.2722144,1.8012428-1.9491813,5.8088036-3.0450597 c0.0415993-0.0124797,0.0826797-0.0246995,0.1247978-0.0369192c0.058239-0.0166396,0.116478-0.0309394,0.1747169-0.0423791 C44.2333603,0.3673727,46.7927475,0,50.0468445,0c0.0296402,0,0.0587578,0.00052,0.088398,0.00182l13.3554153,0.554569 c0.6822243,0.0283394,1.3098564,0.3821924,1.6868477,0.9515812c0.3775101,0.5691286,0.4586334,1.2848946,0.2189178,1.9242219 l-1.0649414,2.8399236c-0.281311,0.7506051-0.9598999,1.2794347-1.7565269,1.3688731 c-0.7966232,0.087358-1.5755692-0.2758546-2.0165176-0.9453411c-0.0046806-0.0067601-1.4117737-2.0362802-3.5083733-2.130918 c-0.0748787-0.0033798-0.148716-0.0106597-0.220993-0.0215797l-6.8259048-0.2833943 c-3.0206223,0.0033798-5.2747765,0.361393-6.9106636,0.8062439c-2.1719971,0.7352657-2.8375854,3.2608562-2.8438225,3.2868552 C40.0178032,9.3119755,39.1593018,9.9838028,38.1786003,9.9838028z' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M62.6035576,4.0600796h-1.5974083c-0.4409523,0-0.7987061-0.3574929-0.7987061-0.7987041 s0.3577538-0.7987041,0.7987061-0.7987041h1.5974083c0.4409485,0,0.7987022,0.3574929,0.7987022,0.7987041 S63.0445061,4.0600796,62.6035576,4.0600796z' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC5.default);
	
	var Chicken = function (_PositionedGoodyHOC3) {
		_inherits(Chicken, _PositionedGoodyHOC3);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
	
			// 1
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, fill: 'none', cx: '42.97906', cy: '13.91856' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M20.62118,30.24834c-0.14971,0-0.3001-0.00103-0.45186-0.00274 C5.18973,30.0542,4.29969,18.97212,3.6496,10.88042C3.56893,9.8728,3.49032,8.89185,3.38915,7.95874l2.0877-0.22627 c0.10322,0.95156,0.18389,1.952,0.26592,2.97978c0.6501,8.09341,1.38701,17.26655,14.45391,17.43335 c5.1249,0.0752,8.79375-1.04897,11.15899-3.40806c2.88203-2.87622,3.45488-7.37324,3.5417-11.61563V9.78975 c0-0.00684,0-0.01367,0-0.02051l0.97412-0.0106L34.97459,9.3936c1.15869-2.84409,4.20068-4.68193,7.75059-4.68193h0.7 c3.5499,0,6.59189,1.83784,7.75058,4.68193l-0.88184,0.35923l0.95908,0.00513v3.46719 c0.08818,4.20889,0.65899,8.45127,3.46787,11.30767c2.36113,2.40044,6.04229,3.58203,11.25264,3.61279 c0.05537,0.00034,0.11211,0.00068,0.16748,0.00068c12.65059,0,13.41758-8.5374,14.15997-16.79487 c0.11485-1.27285,0.22285-2.47495,0.37529-3.64185l2.08223,0.27207c-0.14697,1.1252-0.25293,2.30679-0.36572,3.55776 c-0.7499,8.33813-1.68301,18.70654-16.24902,18.70688c-0.06084,0-0.12168-0.00034-0.18252-0.00068 c-5.79756-0.03418-9.96407-1.42119-12.73741-4.24033c-4.13232-4.20137-4.12891-10.70747-4.07353-16.00464 c-0.89346-1.9438-3.11514-3.18897-5.7251-3.18897h-0.7c-2.60996,0-4.83164,1.24517-5.7251,3.18897 c0.05605,5.38979,0.06084,12.0104-4.16172,16.22339C30.12723,28.93003,26.12684,30.24834,20.62118,30.24834z' }),
					_react2.default.createElement('path', { fill: '#1C1C1C', d: 'M35.95965,13.125c-1.28926,0-2.41719-0.88286-2.72139-2.14409 c-0.00342-0.01333-0.90576-3.38379-3.77207-4.33228C27.31971,6.06724,24.37069,5.60444,20.41473,5.6L11.4412,5.97256 c-0.09502,0.01436-0.19209,0.02393-0.29053,0.02837C8.42108,6.12397,6.55624,8.77563,6.53846,8.80229 c-0.57969,0.87979-1.60303,1.35728-2.65098,1.24277C2.84022,9.92749,1.94813,9.23228,1.57831,8.24551l-1.4-3.73345 c-0.31514-0.84048-0.2085-1.78145,0.28779-2.52964C0.9617,1.23389,1.7868,0.7687,2.68368,0.73145L20.2411,0.00239 C20.28006,0.00068,20.31834,0,20.35731,0c4.27793,0,7.64258,0.48296,10.25459,1.15767 c0.07656,0.01504,0.15312,0.03384,0.22969,0.05571c0.05537,0.01606,0.10938,0.03213,0.16406,0.04854 c5.26846,1.44067,7.32949,3.64526,7.63643,4.00313c0.54209,0.63301,0.77451,1.47451,0.63369,2.29619l-0.55576,3.2375 c-0.2249,1.30942-1.33848,2.28047-2.6667,2.32456C36.02186,13.12466,35.99041,13.125,35.95965,13.125z' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M5.94989,5.3375h-2.1c-0.57969,0-1.05-0.46997-1.05-1.05s0.47031-1.05,1.05-1.05h2.1 c0.57969,0,1.05,0.46997,1.05,1.05S6.52958,5.3375,5.94989,5.3375z' }),
					_react2.default.createElement('path', { fill: '#1C1C1C', d: 'M50.19071,13.125c-0.03076,0-0.06221-0.00034-0.09365-0.00171 c-1.32822-0.04409-2.4418-1.01514-2.6667-2.32456l-0.55576-3.2375c-0.14082-0.82168,0.0916-1.66318,0.63369-2.29619 c0.30693-0.35786,2.36797-2.56245,7.63643-4.00313c0.05469-0.01641,0.10869-0.03247,0.16406-0.04854 c0.07656-0.02188,0.15313-0.04067,0.22969-0.05571C58.15047,0.48296,61.51512,0,65.79305,0 c0.03896,0,0.07725,0.00068,0.11621,0.00239l17.55742,0.72905c0.89688,0.03726,1.72198,0.50244,2.21758,1.25098 c0.49628,0.74819,0.60293,1.68916,0.28779,2.52964l-1.39999,3.73345c-0.36983,0.98677-1.26192,1.68198-2.30918,1.79956 c-1.04726,0.11484-2.07129-0.36265-2.65098-1.24277c-0.00615-0.00889-1.85596-2.67695-4.61221-2.80137 c-0.09844-0.00444-0.19551-0.01401-0.29053-0.02837L65.73563,5.6c-3.971,0.00444-6.93438,0.4751-9.08496,1.05991 c-2.85537,0.9666-3.73037,4.28682-3.73857,4.321C52.60858,12.2418,51.47997,13.125,50.19071,13.125z' }),
					_react2.default.createElement('path', { fill: '#EFEFEF', d: 'M82.30048,5.3375h-2.1c-0.57969,0-1.05-0.46997-1.05-1.05s0.47031-1.05,1.05-1.05h2.1 c0.57969,0,1.05,0.46997,1.05,1.05S82.88017,5.3375,82.30048,5.3375z' })
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC5.default);
	
	function Raybans(props) {
		var glasses = {
			Cat: Cat,
			Tortoise: Tortoise,
			Chicken: Chicken
		};
	
		var ThisRaybans = glasses[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisRaybans)) {
			return null;
		}
	
		return _react2.default.createElement(ThisRaybans, props);
	}
	
	exports.default = Raybans;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC4 = __webpack_require__(6);
	
	var _PositionedGoodyHOC5 = _interopRequireDefault(_PositionedGoodyHOC4);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
	
			// 5
			value: function render() {
				var style = {
					st30: {
						fill: '#5994C9'
					},
					st62: {
						fill: '#F9914B'
					},
					st81: {
						opacity: 0.4,
						fill: '#FFFFFF'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '65.3255768', cy: '122.6258469' }),
					_react2.default.createElement('path', { style: style.st30, d: 'M117.6008301,95.3701172l-7.2515869-0.9775391 c-2.255249-0.302002-4.4946899-0.5734863-6.7631226-0.8300781c-0.6553955-0.0742188-1.2986755-0.1428223-1.9551697-0.2132568 c-1.7168579-0.18396-3.4300079-0.3546143-5.15242-0.5125732c-0.6397705-0.0585938-1.2748795-0.1203613-1.9151993-0.1755371 c-2.2410889-0.1925049-4.4833603-0.3679199-6.7306061-0.5162354c-0.4397049-0.0290527-0.8777618-0.0494385-1.3174591-0.0767822 c-1.8406982-0.1142578-3.6819763-0.2141113-5.5247498-0.2984619c-0.3438721-0.0157471-0.68853-0.0411377-1.0322189-0.0557861 c-0.0869141-0.0036621-0.1724472-0.1390381-0.2593002-0.1416016c-4.7470703-0.1994629-9.496666-0.4550781-14.2365952-0.4550781 h-0.0117188c-4.7381592,0-9.4862671,0.2556152-14.2316895,0.4549561 c-0.088501,0.0025635-0.1758423,0.0661621-0.2644043,0.0699463c-0.3440552,0.0146484-0.68927,0.0759277-1.0335083,0.0917969 c-1.8400879,0.0842285-3.6790771,0.2019043-5.5171509,0.31604c-0.442627,0.0274658-0.8844604,0.0568237-1.3270874,0.0861206 c-2.2455444,0.1481934-4.4876709,0.3279724-6.7271118,0.5203552c-0.6433105,0.0554199-1.284668,0.1196747-1.9274292,0.1787567 c-1.7191162,0.1574707-3.4351807,0.3290024-5.1487427,0.5125961c-0.6585083,0.0705566-1.3164062,0.1399612-1.9738159,0.2144318 c-2.2677612,0.2564621-4.5315552,0.5281067-6.7860718,0.8301086l-7.1582031,0.977684 C5.5336914,96.4178314,0,102.1342773,0,108.9628906v28.434082c0,6.8291016,5.5336914,12.5454102,13.3554688,13.5922852 l7.2299805,0.9780273c5.1801758,0.6938477,10.4157715,1.2744141,15.6330566,1.7250977 c0.644043,0.0556641,1.2662354,0.0834961,1.9019775,0.0834961c7.5551758,0,14.4060669-3.8764648,17.8181763-10.2163086 l9.5223083-18.8486328l9.4533844,18.7114258l0.0706558,0.1376953 c3.4125977,6.3398438,10.2714157,10.2158203,17.8265915,10.2158203c0.6352539,0,1.2755966-0.027832,1.9191513-0.0834961 c5.2167969-0.4506836,10.4881363-1.03125,15.6688004-1.7250977l7.2008591-0.9780273 C125.4226761,149.9423828,131,144.2260742,131,137.3969727v-28.434082 C131,102.1342773,125.4230957,96.4179688,117.6008301,95.3701172z M59.3413086,110.2075195L45.331543,137.9291992 c-1.421875,2.578125-4.668457,4.1025391-8.1152344,3.8081055c-5.03125-0.4350586-10.1152344-0.9946289-15.1098633-1.6635742 l-7.1586914-0.9780273C12.8203125,138.8105469,12,137.6962891,12,137.3969727v-28.434082 c0-0.2993164,0.8203125-1.4140625,2.9482422-1.6992188l7.2299805-0.9775391 c2.1711426-0.2907715,4.3193359-0.5527344,6.5076904-0.8001709c0.6337891-0.0716553,1.2508545-0.1383057,1.8855591-0.2061768 c1.6554565-0.1774902,3.3050537-0.3419189,4.9661865-0.4942627c0.6153564-0.0563965,1.2256165-0.1160889,1.8415833-0.1689453 c2.1672974-0.1864014,4.3347931-0.3555908,6.5048981-0.4989014c0.3999023-0.0263672,0.7994156-0.0449219,1.199501-0.0698242 c1.8065796-0.1125488,3.6117439-0.2102051,5.41576-0.2924805c0.4732056-0.0217285,0.9462547-0.0394287,1.4195786-0.059082 c2.2230873,0.0107422,4.3040009,0.798584,5.7647552,2.199707c0.8076172,0.7744141,1.7694588,2.0766602,1.7679939,3.8828125 C59.4517288,109.918457,59.4145508,110.0625,59.3413086,110.2075195z M119,137.3969727 c0,0.2993164-0.8635254,1.4135742-2.9919434,1.6987305l-7.2515869,0.9780273 c-4.9956055,0.6689453-10.0540161,1.2285156-15.0847778,1.6635742c-3.4389648,0.2958984-6.6808167-1.230957-8.1031799-3.8081055 l-14.0039825-27.7246094c-0.0722656-0.1430664-0.1062393-0.2866211-0.1062393-0.425293 c-0.0014648-1.8061523,0.9625015-3.1088867,1.770607-3.8837891c1.5016479-1.4396973,3.6735764-2.2253418,5.954155-2.1912842 c0.409668,0.0172119,0.8197937,0.0323486,1.2294617,0.0511475c1.807251,0.0822754,3.6165237,0.1801758,5.4263992,0.2929688 c0.3964233,0.0247803,0.7934952,0.0432129,1.1897354,0.0693359c2.1721191,0.1433105,4.3439255,0.3125,6.5133591,0.4992676 c0.6119995,0.0524902,1.2228622,0.1118164,1.8343124,0.1677246c1.6659546,0.152832,3.3294754,0.317749,4.9897537,0.4957275 c0.6311646,0.067627,1.2627029,0.1337891,1.892952,0.2050781c2.1896973,0.2476807,4.3750687,0.5096436,6.5476151,0.8006592 l7.201416,0.9775391C118.1364746,107.5488281,119,108.6635742,119,108.9628906V137.3969727z' }),
					_react2.default.createElement('path', { style: style.st30, d: 'M78.8097305,177.6767578H52.1160088c-5.9370537,0-10.7499886-4.8129272-10.7499886-10.7499847v-3.6191711 c0-5.9370575,4.8129349-10.7499847,10.7499886-10.7499847h26.6937218c5.9370575,0,10.7499924,4.8129272,10.7499924,10.7499847 v3.6191711C89.5597229,172.8638306,84.746788,177.6767578,78.8097305,177.6767578z' }),
					_react2.default.createElement('path', { style: style.st62, d: 'M103.2910156,216.8828125c-26.3725586,0-47.828125-21.4555664-47.828125-47.828125 c0-5.5229492,4.4770508-10,10-10s10,4.4770508,10,10c0,15.3442383,12.4833984,27.828125,27.828125,27.828125 s27.828125-12.4838867,27.828125-27.828125v-164.9375h20v164.9375 C151.1191406,195.4272461,129.6635742,216.8828125,103.2910156,216.8828125z' }),
					_react2.default.createElement('path', { style: style.st81, d: 'M68.5239105,117.875206l11.5428848,22.8408737 c2.537674,4.7156525,8.1107025,7.5037537,13.9465256,6.9989471c5.144989-0.4450684,10.277092-1.009903,15.3893814-1.6945343 l7.301796-0.9778442C121.4979782,144.4007263,125,141.1730804,125,137.3970795v-28.434433 c0-3.776001-3.5020218-7.0036469-8.2955017-7.6455841l-7.301796-0.9778366 c-14.6096039-1.9564896-29.381073-2.9347382-44.1525345-2.9347458 c-14.7714615,0.0000076-29.542923,0.9782562-44.1525345,2.9347458l-7.3017969,0.9778366 c-4.7934818,0.6419373-8.2954998,3.8695831-8.2954998,7.6455841v28.434433c0,3.776001,3.5020185,7.0036469,8.2954998,7.6455688 l7.3017969,0.9778442c5.1122875,0.6846313,10.2443924,1.2494659,15.3893833,1.6945343 c5.8358231,0.5048065,11.4088516-2.2832947,13.9465218-6.9989471l11.5428848-22.8408737h0.0000038 C63.5212517,115.5157852,66.9790878,115.5157852,68.5239105,117.875206L68.5239105,117.875206z' }),
					_react2.default.createElement('path', { style: style.st30, d: 'M151,10.1171875h-20c-2.7612305,0-5-2.2387695-5-5s2.2387695-5,5-5h20c2.7612305,0,5,2.2387695,5,5 S153.7612305,10.1171875,151,10.1171875z' }),
					_react2.default.createElement('path', { style: style.st30, d: 'M151,128.1171875h-20c-2.7612305,0-5-2.2387695-5-5s2.2387695-5,5-5h20c2.7612305,0,5,2.2387695,5,5 S153.7612305,128.1171875,151,128.1171875z' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC5.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
	
			// 5
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '34.6225548', cy: '64.9295883' }),
					_react2.default.createElement('path', { fill: '#5994C9', d: 'M62.3284416,50.4840546l-3.8433418-0.5180969 c-1.195282-0.1600609-2.3821869-0.3039474-3.5844574-0.4399414c-0.3473587-0.0393372-0.6882973-0.075695-1.0362396-0.1130257 c-0.909935-0.0974998-1.8179016-0.1879463-2.7307816-0.2716637c-0.339077-0.0310555-0.6756859-0.0637932-1.0150566-0.0930367 c-1.1877747-0.1020279-2.3761787-0.1949959-3.5672226-0.2736053c-0.2330399-0.0153961-0.46521-0.0261993-0.6982498-0.0406914 c-0.9755707-0.0605583-1.9514503-0.1134796-2.9281197-0.1581879c-0.182251-0.0083466-0.3649178-0.021801-0.5470734-0.0295639 c-0.0460663-0.0019417-0.0913963-0.0736923-0.1374283-0.0750504c-2.5159492-0.1057167-5.0332336-0.2411919-7.5453987-0.2411919 h-0.0062103c-2.5112228,0-5.0277214,0.1354752-7.5427952,0.241127c-0.0469055,0.001358-0.0931969,0.0350647-0.1401348,0.0370712 c-0.1823483,0.0077629-0.3653126,0.0402412-0.5477581,0.0486526c-0.9752464,0.0446396-1.9499111,0.1070099-2.9240913,0.1674995 c-0.2345905,0.0145569-0.4687634,0.030117-0.7033558,0.0456467c-1.1901379,0.0785408-2.3784657,0.1738243-3.5653687,0.2757874 c-0.3409557,0.0293732-0.6808739,0.063427-1.0215378,0.0947418c-0.9111309,0.0834579-1.8206463,0.1743698-2.7288332,0.2716751 c-0.3490095,0.0373955-0.6976957,0.0741806-1.0461226,0.1136475c-1.2019138,0.1359291-2.4017248,0.2798996-3.5966187,0.4399605 l-3.7938476,0.5181694C2.9328566,51.039341,0,54.0690575,0,57.688221v15.0700645 c0,3.6194229,2.9328566,6.6490707,7.0783982,7.2039108l3.8318896,0.5183563 c2.7454929,0.3677368,5.520359,0.6754379,8.2855206,0.914299c0.3413429,0.0295029,0.6711044,0.0442581,1.0080471,0.0442581 c4.0042439,0,7.6352158-2.0545273,9.443634-5.41465l5.0468235-9.989769l5.0102921,9.9170532l0.0374489,0.0729752 c1.8086777,3.3601227,5.4438477,5.4143906,9.4480934,5.4143906c0.3366814,0,0.6760674-0.0147552,1.0171509-0.0442581 c2.7649002-0.2388611,5.558712-0.5465622,8.3044662-0.914299l3.816452-0.5183563 c4.1458054-0.5548401,7.1017838-3.5844879,7.1017838-7.2039108V57.688221 C69.4300003,54.0690575,66.4742432,51.0394135,62.3284416,50.4840546z M31.4508934,58.3478775l-7.4251747,14.6924896 c-0.7535954,1.3664017-2.4742832,2.1743469-4.301075,2.0182953c-2.666563-0.2305832-5.3610744-0.527153-8.0082273-0.881691 l-3.794107-0.5183563c-1.1275439-0.1511383-1.5623093-0.7416916-1.5623093-0.9003296V57.688221 c0-0.1586342,0.4347653-0.7494507,1.5625682-0.9005852l3.8318901-0.5180931 c1.1507053-0.15411,2.2892475-0.2929497,3.4490757-0.4240913c0.3359079-0.0379791,0.6629524-0.0733032,0.9993467-0.1092758 c0.8773918-0.0940704,1.7516785-0.1812172,2.6320782-0.2619591c0.3261395-0.0298882,0.6495762-0.0615273,0.9760399-0.0895386 c1.1486664-0.098793,2.2974396-0.1884651,3.4475956-0.2644196c0.2119484-0.0139732,0.4236908-0.0238075,0.6357346-0.0370064 c0.9574871-0.0596504,1.9142246-0.1114082,2.8703537-0.155014c0.2507992-0.0115166,0.5015144-0.0208969,0.7523766-0.0313148 c1.178236,0.0056953,2.2811203,0.4232521,3.0553188,1.165844c0.4280376,0.4104424,0.9378147,1.1006317,0.9370384,2.0578918 C31.5094166,58.1946716,31.4897118,58.2710152,31.4508934,58.3478775z M63.0699997,72.7582855 c0,0.158638-0.4576683,0.7491913-1.5857315,0.9003296l-3.843338,0.5183563 c-2.6476707,0.354538-5.3286285,0.6511078-7.9949341,0.881691c-1.8226509,0.1568222-3.5408325-0.6524048-4.2946854-2.0182953 l-7.4221115-14.6940422c-0.0382996-0.0758286-0.0563049-0.1519127-0.0563049-0.2254066 c-0.0007782-0.9572601,0.510128-1.6477089,0.9384232-2.0584068c0.7958717-0.7630424,1.9469948-1.1794319,3.1557007-1.1613808 c0.2171249,0.0091209,0.4344902,0.0171432,0.6516113,0.0271072c0.9578438,0.0436058,1.9167633,0.0954933,2.8759956,0.1552734 c0.2101059,0.013134,0.4205513,0.0229034,0.630558,0.036747c1.151226,0.0759544,2.3022804,0.1656265,3.4520798,0.2646141 c0.3243599,0.0278168,0.6481171,0.0592613,0.972187,0.0888939c0.8829536,0.0809975,1.7646217,0.1684036,2.6445694,0.2627335 c0.3345184,0.0358429,0.6692314,0.0709076,1.0032654,0.1086922c1.1605377,0.1312714,2.3187828,0.2701111,3.4702339,0.4243507 l3.8167496,0.5180931c1.1280632,0.1511345,1.5857315,0.741951,1.5857315,0.9005852V72.7582855z' }),
					_react2.default.createElement('path', { fill: '#5994C9', d: 'M41.7691574,94.106575H27.6214848c-3.1466389,0-5.6974945-2.5508575-5.6974945-5.6974945V86.490921 c0-3.146637,2.5508556-5.6974945,5.6974945-5.6974945h14.1476727c3.146637,0,5.6974945,2.5508575,5.6974945,5.6974945v1.9181595 C47.4666519,91.5557175,44.9157944,94.106575,41.7691574,94.106575z' }),
					_react2.default.createElement('path', { fill: '#F9914B', d: 'M54.7442398,114.8857803c-13.977459,0-25.3489075-11.3714523-25.3489075-25.3489075 c0-2.9271622,2.3728371-5.2999954,5.2999992-5.2999954s5.2999992,2.3728333,5.2999992,5.2999954 c0,8.1324463,6.6162033,14.748909,14.748909,14.748909s14.7489014-6.6164627,14.7489014-14.748909V2.1199999h10.6000061 v87.4168701C80.0931473,103.514328,68.7216949,114.8857803,54.7442398,114.8857803z' }),
					_react2.default.createElement('path', { opacity: '0.4', fill: '#FFFFFF', d: 'M36.3176727,62.4117508l6.1177292,12.1056671 c1.3449669,2.4992905,4.2986717,3.9769821,7.3916588,3.7094345c2.7268448-0.235878,5.4468613-0.5352478,8.1563721-0.8981018 l3.8699532-0.5182495C64.3939285,76.4702759,66.25,74.7596207,66.25,72.7583389V57.6880951 c0-2.0012817-1.8560715-3.711937-4.3966141-4.0521584l-3.8699532-0.5182571 c-7.7430916-1.0369377-15.5719681-1.5554085-23.4008446-1.5554123 c-7.8288746,0.0000038-15.6577492,0.5184746-23.4008408,1.5554123l-3.8699522,0.5182571 c-2.5405455,0.3402214-4.396615,2.0508766-4.396615,4.0521584v15.0702438c0,2.0012817,1.8560696,3.711937,4.396615,4.0521622 l3.8699522,0.5182495c2.7095118,0.362854,5.4295282,0.6622238,8.156373,0.8981018 c3.0929871,0.2675476,6.0466919-1.210144,7.3916569-3.7094345l6.1177311-12.1056671V62.411747 c0.8187561-1.2504883,2.6514091-1.2504883,3.4701653,0V62.4117508z' }),
					_react2.default.createElement('path', { fill: '#5994C9', d: 'M80.0299988,5.3000002H69.4300003c-1.4634552,0-2.6500015-1.1865482-2.6500015-2.6500001 S67.9665451,0,69.4300003,0h10.5999985c1.4634552,0,2.6500015,1.1865479,2.6500015,2.6500001 S81.493454,5.3000002,80.0299988,5.3000002z' }),
					_react2.default.createElement('path', { fill: '#5994C9', d: 'M80.0299988,67.8399963H69.4300003c-1.4634552,0-2.6500015-1.1865463-2.6500015-2.6499939 c0-1.4634552,1.1865463-2.6500015,2.6500015-2.6500015h10.5999985c1.4634552,0,2.6500015,1.1865463,2.6500015,2.6500015 C82.6800003,66.65345,81.493454,67.8399963,80.0299988,67.8399963z' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC5.default);
	
	var Chicken = function (_PositionedGoodyHOC3) {
		_inherits(Chicken, _PositionedGoodyHOC3);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
	
			// 5
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, fill: 'none', cx: '45.7279', cy: '85.75606' }),
					_react2.default.createElement('path', { fill: '#5994C9', d: 'M82.32058,66.67705l-5.07611-0.68427c-1.57867-0.2114-3.14628-0.40144-4.73418-0.58105 c-0.45878-0.05196-0.90907-0.09998-1.36862-0.14928c-1.2018-0.12877-2.401-0.24823-3.60669-0.3588 c-0.44784-0.04102-0.89242-0.08426-1.34064-0.12288c-1.56876-0.13475-3.13835-0.25755-4.71142-0.36137 c-0.30779-0.02033-0.61443-0.03461-0.92222-0.05375c-1.28849-0.07998-2.57739-0.14987-3.86733-0.20892 c-0.24071-0.01102-0.48197-0.02879-0.72255-0.03905c-0.06084-0.00256-0.12071-0.09733-0.18151-0.09912 C52.46635,63.87893,49.14163,63.7,45.82368,63.7h-0.0082c-3.31671,0-6.64039,0.17893-9.96218,0.31847 c-0.06195,0.00179-0.12309,0.04631-0.18508,0.04896c-0.24084,0.01025-0.48249,0.05315-0.72346,0.06426 c-1.28806,0.05896-2.57535,0.14133-3.862,0.22123c-0.30984,0.01923-0.61912,0.03977-0.92896,0.06028 c-1.57188,0.10374-3.14137,0.22958-4.70898,0.36425c-0.45032,0.0388-0.89927,0.08377-1.3492,0.12513 c-1.20338,0.11023-2.40463,0.2303-3.60412,0.35882c-0.46095,0.04939-0.92148,0.09798-1.38167,0.1501 c-1.58743,0.17953-3.17209,0.36967-4.75025,0.58108l-5.01074,0.68438C3.87358,67.41045,0,71.41196,0,76.19199v19.90385 c0,4.78037,3.87358,8.78179,9.34883,9.5146l5.06099,0.68462c3.62612,0.48569,7.29104,0.89209,10.94314,1.20757 c0.45083,0.03896,0.88636,0.05844,1.33138,0.05844c5.28862,0,10.08425-2.71352,12.47272-7.15141l6.66562-13.19405l6.61737,13.098 l0.04946,0.09639c2.38882,4.43789,7.18999,7.15107,12.47861,7.15107c0.44468,0,0.89292-0.01948,1.34341-0.05844 c3.65176-0.31548,7.3417-0.72188,10.96816-1.20757l5.0406-0.68462c5.47559-0.73281,9.37971-4.73423,9.37971-9.5146V76.19199 C91.7,71.41196,87.79617,67.41055,82.32058,66.67705z M41.53892,77.06323l-9.80684,19.40517 c-0.99531,1.80469-3.26792,2.87178-5.68066,2.66567c-3.52188-0.30453-7.08066-0.69624-10.5769-1.1645l-5.01108-0.68462 C8.97422,97.08535,8.4,96.30537,8.4,96.09585V76.19199c0-0.20953,0.57422-0.98985,2.06377-1.18945l5.06099-0.68428 c1.5198-0.20354,3.02353-0.38691,4.55538-0.56012c0.44365-0.05016,0.8756-0.09681,1.31989-0.14433 c1.15882-0.12424,2.31354-0.23934,3.47633-0.34598c0.43075-0.03948,0.85793-0.08127,1.28911-0.11826 c1.51711-0.13049,3.03436-0.24892,4.55343-0.34924c0.27993-0.01846,0.55959-0.03144,0.83965-0.04887 c1.26461-0.07878,2.52822-0.14714,3.79103-0.20473c0.33125-0.01521,0.66238-0.0276,0.99371-0.04136 c1.55616,0.00752,3.0128,0.55901,4.03532,1.53979c0.56533,0.54209,1.23862,1.45366,1.2376,2.71797 C41.61621,76.86089,41.59019,76.96172,41.53892,77.06323z M83.3,96.09585c0,0.20953-0.60447,0.9895-2.09436,1.18911 l-5.07611,0.68462c-3.49693,0.46826-7.03781,0.85996-10.55935,1.1645c-2.40727,0.20713-4.67657-0.86166-5.67223-2.66567 l-9.80279-19.40723c-0.05058-0.10014-0.07437-0.20063-0.07437-0.29771c-0.00102-1.26431,0.67376-2.17622,1.23943-2.71865 c1.05115-1.00779,2.5715-1.55774,4.16791-1.5339c0.28677,0.01205,0.57385,0.02264,0.86062,0.0358 c1.26508,0.05759,2.53157,0.12612,3.79848,0.20508c0.2775,0.01734,0.55544,0.03025,0.83281,0.04853 c1.52048,0.10032,3.04074,0.21875,4.55935,0.34949c0.42841,0.03674,0.85601,0.07828,1.28402,0.11741 c1.16617,0.10699,2.33064,0.22243,3.49284,0.34701c0.44181,0.04734,0.88389,0.09366,1.32507,0.14355 c1.53278,0.17338,3.06255,0.35675,4.58333,0.56046l5.04099,0.68428C82.69553,75.20215,83.3,75.98247,83.3,76.19199V96.09585z' }),
					_react2.default.createElement('path', { fill: '#5994C9', d: 'M55.16681,124.2917H36.4812c-4.15594,0-7.52499-3.36906-7.52499-7.52499v-2.53342 c0-4.15594,3.36905-7.52499,7.52499-7.52499h18.68561c4.15594,0,7.52499,3.36906,7.52499,7.52499v2.53342 C62.6918,120.92265,59.32275,124.2917,55.16681,124.2917z' }),
					_react2.default.createElement('path', { fill: '#F9914B', d: 'M72.30371,151.73593c-18.46079,0-33.47969-15.01889-33.47969-33.47968c0-3.86607,3.13393-7,7-7 s7,3.13393,7,7c0,10.74097,8.73838,19.47968,19.47969,19.47968s19.47969-8.73871,19.47969-19.47968V2.8h14v115.45625 C105.7834,136.71704,90.7645,151.73593,72.30371,151.73593z' }),
					_react2.default.createElement('path', { opacity: '0.4', fill: '#FFFFFF', d: 'M47.96674,82.43062l8.08002,15.98861c1.77637,3.30095,5.67749,5.25262,9.76257,4.89925 c3.60149-0.31154,7.19396-0.70692,10.77257-1.18616l5.11126-0.68449C85.04858,100.99847,87.5,98.73912,87.5,96.09592v-19.9041 c0-2.6432-2.45142-4.90255-5.80685-5.35191l-5.11126-0.68449c-10.22673-1.36954-20.56675-2.05431-30.90678-2.05432 c-10.34002,0.00001-20.68005,0.68478-30.90677,2.05432l-5.11126,0.68449c-3.35544,0.44936-5.80685,2.70871-5.80685,5.35191 v19.9041c0,2.6432,2.45141,4.90256,5.80685,5.35191l5.11126,0.68449c3.5786,0.47924,7.17107,0.87463,10.77257,1.18616 c4.08508,0.35337,7.9862-1.5983,9.76257-4.89925l8.08002-15.98861v-0.00001 C44.46488,80.77902,46.88536,80.77902,47.96674,82.43062L47.96674,82.43062z' }),
					_react2.default.createElement('path', { fill: '#5994C9', d: 'M105.7,7h-14c-1.93286,0-3.5-1.56714-3.5-3.5S89.76714,0,91.7,0h14c1.93286,0,3.5,1.56714,3.5,3.5 S107.63286,7,105.7,7z' }),
					_react2.default.createElement('path', { fill: '#5994C9', d: 'M105.7,89.6h-14c-1.93286,0-3.5-1.56714-3.5-3.5s1.56714-3.5,3.5-3.5h14c1.93286,0,3.5,1.56714,3.5,3.5 S107.63286,89.6,105.7,89.6z' })
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC5.default);
	
	function Scuba(props) {
		var glasses = {
			Cat: Cat,
			Tortoise: Tortoise,
			Chicken: Chicken
		};
	
		var ThisScuba = glasses[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisScuba)) {
			return null;
		}
	
		return _react2.default.createElement(ThisScuba, props);
	}
	
	exports.default = Scuba;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC4 = __webpack_require__(6);
	
	var _PositionedGoodyHOC5 = _interopRequireDefault(_PositionedGoodyHOC4);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
	
			// 8
			value: function render() {
				var style = {
					st56: {
						opacity: 0.8
					},
					st18: {
						fill: '#222222'
					},
					st119: {
						opacity: 0.5
					},
					st2: {
						fill: '#FFFFFF'
					},
					st52: {
						fill: '#1C1C1C'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '61.7626823', cy: '19.5277004' }),
					_react2.default.createElement(
						'g',
						{ style: style.st56 },
						_react2.default.createElement('polygon', { style: style.st18, points: '5.7134571,10.706543 9.1328459,30.07477 17.9452572,39.4436226 32.521244,41.3254089 43.98246,37.6245346 50.1730576,28.0594749 51.3322792,14.4047852 45.1533775,6.5879292 24.5371094,5.019043 7.0371094,5.019043' }),
						_react2.default.createElement('polygon', { style: style.st18, points: '117.332283,10.706543 113.9128952,30.07477 105.1004791,39.4436226 90.524498,41.3254089 79.0632782,37.6245346 72.8726807,28.0594749 71.7134552,14.4047852 77.8923569,6.5879292 98.5086288,5.019043 116.0086288,5.019043' })
					),
					_react2.default.createElement(
						'g',
						{ style: style.st119 },
						_react2.default.createElement('rect', { x: '3.9213662', y: '13.5469389', transform: 'matrix(0.7049673 -0.7092398 0.7092398 0.7049673 -6.076673 20.485815)', style: style.st2, width: '35.3271904', height: '7.9998727' }),
						_react2.default.createElement('rect', { x: '9.6167994', y: '20.5192566', transform: 'matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -6.6863627 28.8957787)', style: style.st2, width: '43.8406219', height: '3.9995728' }),
						_react2.default.createElement('rect', { x: '68.9213638', y: '12.5469389', transform: 'matrix(0.7049673 -0.7092398 0.7092398 0.7049673 13.8096933 66.2913742)', style: style.st2, width: '35.3271904', height: '7.9998727' }),
						_react2.default.createElement('rect', { x: '74.6167984', y: '19.5192566', transform: 'matrix(0.7071068 -0.7071068 0.7071068 0.7071068 13.0588036 74.564827)', style: style.st2, width: '43.8406219', height: '3.9995728' })
					),
					_react2.default.createElement('path', { style: style.st18, d: 'M29.4228516,44.855957c-0.2226562,0-0.4453125-0.0014648-0.6708984-0.0043945 C5.5302734,44.5551758,4.1181641,26.9785156,3.1845703,15.3476562 c-0.1142578-1.4204102-0.2246094-2.8032227-0.3671875-4.1186523l6.9589844-0.7539062 c0.1494141,1.3769531,0.2666016,2.824707,0.3857422,4.3120117c1.1083984,13.8027344,3.0078125,22.8647461,18.6796875,23.0654297 c6.7197266,0.0893555,11.5683594-1.355957,14.5029297-4.284668c3.5976562-3.590332,4.3515625-9.2949219,4.4726562-15.0263672 v-4.9121094c0-0.0024414,0-0.0053711,0-0.0083008l3.3916016-0.0361328l-3.1328125-1.2758789 C50.0390625,7.4892578,55.1123047,4.375,61,4.375h1c5.8876953,0,10.9609375,3.1142578,12.9238281,7.934082l-3.0859375,1.2568359 l3.3447266,0.0180664v4.8789062c0.1191406,5.6303711,0.8583984,11.2441406,4.3798828,14.8251953 c2.9814453,3.0307617,7.7763672,4.5234375,14.6611328,4.5639648c0.0820312,0.0004883,0.1630859,0.0009766,0.2441406,0.0009766 c15.1298828,0,16.9804688-8.3901367,18.2207031-22.171875c0.1650391-1.8388672,0.3212891-3.5756836,0.5439453-5.2827148 l6.9414062,0.9072266c-0.2050781,1.5673828-0.3554688,3.2358398-0.5136719,5.0024414 c-1.0234375,11.3754883-2.5693359,28.5439453-25.2119141,28.5444336c-0.0888672,0-0.1767578,0-0.265625-0.0004883 c-8.8417969-0.0522461-15.2568359-2.2290039-19.6103516-6.6552734 c-6.3486328-6.4550781-6.4736328-15.949707-6.3984375-23.7958984C67.1132812,12.5449219,64.765625,11.375,62,11.375h-1 c-2.765625,0-5.1132812,1.1699219-6.1738281,3.0258789c0.0771484,7.9833984-0.0478516,17.6464844-6.5371094,24.1220703 C44.0214844,42.78125,37.8447266,44.855957,29.4228516,44.855957z' }),
					_react2.default.createElement('path', { style: style.st52, d: 'M51.3349609,17.894043c-1.6113281,0-3.0214844-1.1035156-3.4013672-2.6801758 c-0.0078125-0.0292969-1.3652344-5.1430664-5.7695312-6.5629883c-3.1083984-0.8374023-7.3623047-1.5014648-13.046875-1.5068359 L16.2597656,7.6777344c-0.1269531,0.0205078-0.2568359,0.0336914-0.3886719,0.0395508 c-4.1972656,0.1894531-6.9697266,4.2055664-6.9970703,4.2460938c-0.7353516,1.0830078-2.0244141,1.6791992-3.3173828,1.5205078 c-1.2998047-0.1547852-2.4101562-1.0107422-2.8701172-2.2358398l-2-5.3334961 C0.2929688,4.8637695,0.4267578,3.6875,1.046875,2.7519531c0.6191406-0.9355469,1.6503906-1.5166016,2.7714844-1.5634766 l25.0820312-1.0415039c0.0488281-0.0019531,0.0966797-0.0029297,0.1455078-0.0029297 c6.171875,0,10.9902344,0.7036133,14.7021484,1.6772461c0.0400391,0.0097656,0.0800781,0.0205078,0.1201172,0.0317383 c7.5634766,2.0087891,10.4873047,5.1342773,10.9189453,5.6381836c0.6777344,0.7910156,0.96875,1.8432617,0.7919922,2.8701172 l-0.7939453,4.625c-0.2802734,1.6367188-1.6728516,2.8505859-3.3330078,2.9057617 C51.4130859,17.8935547,51.3740234,17.894043,51.3349609,17.894043z' }),
					_react2.default.createElement('path', { style: style.st52, d: 'M71.6669922,17.8813477c-0.046875,0-0.09375-0.0009766-0.140625-0.0029297 c-1.6503906-0.0664062-3.0322266-1.2646484-3.3115234-2.8920898l-0.7939453-4.625 c-0.1767578-1.0268555,0.1142578-2.0791016,0.7919922-2.8701172c0.4316406-0.5039062,3.3554688-3.6293945,10.9189453-5.6381836 c0.0400391-0.0112305,0.0800781-0.0219727,0.1201172-0.0317383C82.9638672,0.8476562,87.78125,0.144043,93.9541016,0.144043 c0.0488281,0,0.0966797,0.0009766,0.1455078,0.0029297l25.0820312,1.0415039 c1.1210938,0.046875,2.1523438,0.6279297,2.7714844,1.5634766c0.6201172,0.9355469,0.7539062,2.1118164,0.3603516,3.1625977 l-2,5.3334961c-0.4628906,1.2329102-1.578125,2.1020508-2.8867188,2.2490234 c-1.3076172,0.1450195-2.5888672-0.453125-3.3134766-1.5532227c-0.0146484-0.0209961-2.7871094-4.0371094-6.984375-4.2265625 c-0.1318359-0.0058594-0.2617188-0.019043-0.3886719-0.0395508L93.8828125,7.144043 c-5.7119141,0.0053711-9.9794922,0.6757812-13.0947266,1.5224609c-4.3662109,1.4414062-5.7138672,6.5185547-5.7275391,6.5708008 C74.6630859,16.7910156,73.2597656,17.8813477,71.6669922,17.8813477z' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC5.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
	
			// 8
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '32.276268', cy: '10.2733383' }),
					_react2.default.createElement(
						'g',
						{ opacity: '0.8' },
						_react2.default.createElement('polygon', { fill: '#222222', points: '2.7821786,5.598125 4.5944548,15.8632851 9.2650328,20.8287773 16.9903049,21.8261242 23.0647507,19.8646603 26.345768,14.7951794 26.9601555,7.5581932 23.6853371,3.4152598 12.7587147,2.58375 3.4837143,2.58375' })
					),
					_react2.default.createElement(
						'g',
						{ opacity: '0.8' },
						_react2.default.createElement('polygon', { fill: '#222222', points: '61.940155,5.598125 60.1278801,15.8632851 55.4573021,20.8287773 47.732029,21.8261242 41.6575851,19.8646603 38.3765678,14.7951794 37.7621803,7.5581932 41.0369987,3.4152598 51.9636192,2.58375 61.2386208,2.58375' })
					),
					_react2.default.createElement(
						'g',
						{ opacity: '0.5' },
						_react2.default.createElement('rect', { x: '1.8323705', y: '7.1035347', transform: 'matrix(0.7049673 -0.7092398 0.7092398 0.7049673 -3.2390556 10.6605186)', fill: '#FFFFFF', width: '18.7234097', height: '4.2399325' })
					),
					_react2.default.createElement(
						'g',
						{ opacity: '0.5' },
						_react2.default.createElement('rect', { x: '4.8509498', y: '10.7988634', transform: 'matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -3.5618277 15.1184874)', fill: '#FFFFFF', width: '23.2355289', height: '2.1197736' })
					),
					_react2.default.createElement(
						'g',
						{ opacity: '0.5' },
						_react2.default.createElement('rect', { x: '36.2823715', y: '6.573535', transform: 'matrix(0.7049673 -0.7092398 0.7092398 0.7049673 7.3007183 34.9374619)', fill: '#FFFFFF', width: '18.7234097', height: '4.2399325' })
					),
					_react2.default.createElement(
						'g',
						{ opacity: '0.5' },
						_react2.default.createElement('rect', { x: '39.3009491', y: '10.2688637', transform: 'matrix(0.7071068 -0.7071068 0.7071068 0.7071068 6.90311 39.323082)', fill: '#FFFFFF', width: '23.2355289', height: '2.1197736' })
					),
					_react2.default.createElement('path', { fill: '#222222', d: 'M15.3481579,23.6973152c-0.1180077,0-0.2360153-0.0007763-0.3555765-0.0023308 C2.6850913,23.5379009,1.9366734,14.222271,1.4418687,8.0579147C1.3813121,7.3050976,1.3228258,6.572207,1.2472594,5.8750291 l3.6882617-0.39957c0.0791893,0.729785,0.1412988,1.4970946,0.2044435,2.2853661 c0.587451,7.3154497,1.5941405,12.1183157,9.9002342,12.2246771c3.5614557,0.0473595,6.1312304-0.7186565,7.686553-2.270874 c1.9067574-1.9028749,2.3063278-4.9263077,2.3705082-7.963974V7.1472363c0-0.0012941,0-0.0028467,0-0.0043993 l1.7975483-0.0191507L25.234417,6.4474707c1.0403328-2.5545068,3.7291508-4.2050633,6.8496284-4.2050633h0.5300026 c3.1204758,0,5.8092957,1.6505566,6.8496284,4.2050633l-1.6355476,0.6661229l1.7727051,0.0095754v2.5858202 c0.0631447,2.9840965,0.4549522,5.9593945,2.3213387,7.8573542c1.5801659,1.6063023,4.1214752,2.3974209,7.770401,2.4189014 c0.0434761,0.0002575,0.0864334,0.0005169,0.1293945,0.0005169c8.018837,0,8.9996452-4.4467726,9.656971-11.7510939 c0.087471-0.9745994,0.1702843-1.895112,0.2882919-2.7998385l3.6789436,0.4808297 c-0.1086922,0.8307133-0.1883965,1.7149954-0.2722435,2.6512938 c-0.5424232,6.0290089-1.3617516,15.1282911-13.3623161,15.1285505c-0.0471001,0-0.0936813,0-0.1407814-0.0002594 c-4.6861534-0.0276909-8.0861244-1.1813717-10.393486-3.5272942c-3.3647766-3.4211922-3.4310265-8.4533453-3.3911705-12.6118259 c-0.5620918-0.9836574-1.8063507-1.6037159-3.2721291-1.6037159h-0.5300026 c-1.4657803,0-2.7100372,0.6200585-3.2721272,1.6037159c0.0408878,4.2312007-0.025362,9.3526363-3.4646683,12.7846966 C23.085434,22.5977192,19.8117523,23.6973152,15.3481579,23.6973152z' }),
					_react2.default.createElement('path', { fill: '#1C1C1C', d: 'M26.9615765,9.4075003c-0.8540039,0-1.601387-0.5848637-1.8027248-1.4204936 c-0.0041409-0.0155272-0.7235756-2.7258248-3.0578518-3.4783835C20.4535484,4.0647998,18.1989784,3.7128468,15.1861563,3.71 L8.3717222,3.9928565c-0.0672855,0.010869-0.1361227,0.0178566-0.2059965,0.0209618 c-2.2245502,0.1004105-3.6939545,2.2289505-3.708447,2.2504296C4.0675426,6.8382421,3.3843393,7.1542234,2.6990659,7.070117 c-0.6888964-0.082036-1.2773827-0.5356932-1.521162-1.1849947L0.1179039,3.0583692 c-0.208584-0.5569141-0.1376758-1.180337,0.1909863-1.6761768c0.3281445-0.4958398,0.874707-0.8037988,1.4688867-0.8286425 l13.2934771-0.5519971C15.0971327,0.0005176,15.1224937,0,15.1483727,0c3.2710934,0,5.8248234,0.372915,7.7921391,0.8889405 c0.0212212,0.0051758,0.0424404,0.0108691,0.0636616,0.0168213c4.0086422,1.0646582,5.5582714,2.7211671,5.7870407,2.9882374 c0.3591995,0.4192381,0.5134373,0.9769287,0.4197559,1.521162l-0.4207897,2.4512501 c-0.1485462,0.8674612-0.8866119,1.5108109-1.7664948,1.5400534 C27.0029812,9.4072409,26.9822788,9.4075003,26.9615765,9.4075003z' }),
					_react2.default.createElement('path', { fill: '#1C1C1C', d: 'M37.7375526,9.4007711c-0.0248451,0-0.0496864-0.0005169-0.0745316-0.0015526 c-0.8747063-0.0351954-1.6070786-0.6702633-1.7551079-1.5328074l-0.4207916-2.4512501 c-0.0936813-0.5442333,0.0605583-1.1019239,0.4197578-1.521162c0.2287674-0.2670703,1.7783966-1.9235792,5.7870407-2.9882374 c0.0212212-0.0059521,0.0424423-0.0116455,0.0636597-0.0168213C43.7248955,0.372915,46.2781105,0,49.5497208,0 c0.0258789,0,0.051239,0.0005176,0.0771179,0.0015527l13.2934761,0.5519971 c0.5941811,0.0248438,1.1407433,0.3328027,1.4688911,0.8286425c0.3286591,0.4958398,0.3995667,1.1192627,0.1909866,1.6761768 l-1.0600052,2.8267531c-0.2453308,0.6534424-0.8364029,1.1140866-1.5299606,1.1919823 c-0.6930351,0.0768604-1.372097-0.2401562-1.7561417-0.8232079c-0.0077629-0.0111279-1.477169-2.139668-3.7017174-2.2400784 c-0.0698738-0.0031052-0.13871-0.0100927-0.2059975-0.0209618L49.5119362,3.71 c-3.0273132,0.0028467-5.2891312,0.3581638-6.9402046,0.8069043c-2.3140907,0.7639451-3.0283508,3.454834-3.0355949,3.4825244 C39.3254814,8.8228951,38.5817223,9.4007711,37.7375526,9.4007711z' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC5.default);
	
	var Chicken = function (_PositionedGoodyHOC3) {
		_inherits(Chicken, _PositionedGoodyHOC3);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
	
			// 8
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, fill: 'none', cx: '42.62904', cy: '13.56856' }),
					_react2.default.createElement(
						'g',
						{ opacity: '0.8' },
						_react2.default.createElement('polygon', { fill: '#222222', points: '3.67458,7.39375 6.06815,20.95151 12.23684,27.50971 22.44003,28.82696 30.46288,26.23634 34.7963,19.5408 35.60775,9.98252 31.28252,4.51072 16.85113,3.4125 4.60113,3.4125 \t\t\t\t' }),
						_react2.default.createElement('polygon', { fill: '#222222', points: '81.80775,7.39375 79.41418,20.95151 73.24549,27.50971 63.0423,28.82696 55.01945,26.23634 50.68603,19.5408 49.87458,9.98252 54.19981,4.51072 68.6312,3.4125 80.8812,3.4125 \t\t\t\t' })
					),
					_react2.default.createElement(
						'g',
						{ opacity: '0.5' },
						_react2.default.createElement('rect', { x: '2.42011', y: '9.38203', transform: 'matrix(0.70497 -0.70924 0.70924 0.70497 -4.278 14.07993)', fill: '#FFFFFF', width: '24.72903', height: '5.59991' }),
						_react2.default.createElement('rect', { x: '6.40692', y: '14.26265', transform: 'matrix(0.70711 -0.70711 0.70711 0.70711 -4.7043 19.96781)', fill: '#FFFFFF', width: '30.68843', height: '2.7997' }),
						_react2.default.createElement('rect', { x: '47.92011', y: '8.68203', transform: 'matrix(0.70497 -0.70924 0.70924 0.70497 9.64246 46.14382)', fill: '#FFFFFF', width: '24.72903', height: '5.59991' }),
						_react2.default.createElement('rect', { x: '51.90691', y: '13.56265', transform: 'matrix(0.70711 -0.70711 0.70711 0.70711 9.11732 51.93615)', fill: '#FFFFFF', width: '30.68843', height: '2.7997' })
					),
					_react2.default.createElement('path', { fill: '#222222', d: 'M20.27115,31.29834c-0.15586,0-0.31172-0.00103-0.46963-0.00308 C3.54635,31.08779,2.55787,18.78413,1.90435,10.64253C1.82437,9.64824,1.74713,8.68027,1.64732,7.75947l4.87129-0.52773 c0.10459,0.96387,0.18662,1.97729,0.27002,3.01841c0.77588,9.66191,2.10547,16.00532,13.07578,16.1458 c4.70381,0.06255,8.09785-0.94917,10.15205-2.99927c2.51836-2.51323,3.04609-6.50644,3.13086-10.51846V9.43975 c0-0.00171,0-0.00376,0-0.00581l2.37412-0.02529l-2.19297-0.89312c1.37402-3.37388,4.92529-5.55386,9.04668-5.55386h0.7 c4.12138,0,7.67265,2.17998,9.04668,5.55386l-2.16016,0.87978l2.34131,0.01265v3.41523 c0.0834,3.94126,0.60088,7.8709,3.06592,10.37764c2.08701,2.12153,5.44346,3.16641,10.26279,3.19477 c0.05742,0.00034,0.11416,0.00068,0.1709,0.00068c10.59092,0,11.88633-5.8731,12.75449-15.52031 c0.11552-1.28721,0.2249-2.50298,0.38076-3.6979l4.85899,0.63506c-0.14355,1.09717-0.24883,2.26509-0.35957,3.50171 c-0.71641,7.96284-1.79853,19.98076-17.64834,19.9811c-0.06221,0-0.12373,0-0.18594-0.00034 c-6.18926-0.03657-10.67979-1.5603-13.72725-4.65869c-4.44404-4.51855-4.53154-11.16479-4.4789-16.65713 c-0.74238-1.29917-2.38574-2.11811-4.32168-2.11811h-0.7c-1.93594,0-3.5793,0.81895-4.32168,2.11811 c0.054,5.58838-0.03349,12.35254-4.57597,16.88545C30.49019,29.84604,26.16646,31.29834,20.27115,31.29834z' }),
					_react2.default.createElement('path', { fill: '#1C1C1C', d: 'M35.60963,12.425c-1.12793,0-2.11504-0.77246-2.38095-1.87612 C33.2232,10.52837,32.27301,6.94873,29.19,5.95479C27.01412,5.3686,24.03639,4.90376,20.05719,4.9l-9.00019,0.37358 c-0.08887,0.01436-0.17978,0.02358-0.27207,0.02769c-2.93809,0.13262-4.87881,2.9439-4.89795,2.97227 C5.37223,9.03164,4.46988,9.44897,3.5648,9.33789C2.65494,9.22954,1.87769,8.63037,1.55572,7.7728l-1.4-3.73345 c-0.27549-0.73555-0.18184-1.55894,0.25225-2.21382c0.4334-0.65488,1.15527-1.06162,1.94004-1.09443l17.55742-0.72905 C19.93961,0.00068,19.9731,0,20.00728,0c4.32031,0,7.69316,0.49253,10.2915,1.17407 c0.02803,0.00684,0.05606,0.01436,0.08408,0.02222c5.29443,1.40615,7.34111,3.59399,7.64326,3.94673 c0.47441,0.55371,0.67813,1.29028,0.5544,2.00908l-0.55576,3.2375c-0.19619,1.1457-1.171,1.99541-2.33311,2.03403 C35.66431,12.42466,35.63697,12.425,35.60963,12.425z' }),
					_react2.default.createElement('path', { fill: '#1C1C1C', d: 'M49.84205,12.41611c-0.03281,0-0.06562-0.00068-0.09843-0.00205 c-1.15527-0.04648-2.12256-0.88525-2.31807-2.02446l-0.55576-3.2375c-0.12373-0.7188,0.07998-1.45537,0.55439-2.00908 c0.30215-0.35273,2.34883-2.54058,7.64326-3.94673c0.02803-0.00786,0.05606-0.01538,0.08408-0.02222 C57.74986,0.49253,61.12203,0,65.44302,0c0.03418,0,0.06768,0.00068,0.10186,0.00205L83.1023,0.7311 c0.78477,0.03281,1.50665,0.43955,1.94004,1.09443c0.43408,0.65488,0.52773,1.47827,0.25224,2.21382L83.89459,7.7728 c-0.32403,0.86304-1.10469,1.47144-2.02071,1.57432c-0.91533,0.10151-1.81221-0.31719-2.31944-1.08726 c-0.01025-0.0147-1.95097-2.82598-4.88906-2.95859c-0.09229-0.0041-0.1832-0.01333-0.27207-0.02769L65.39313,4.9 c-3.99834,0.00376-6.98565,0.47305-9.16631,1.06572c-3.05635,1.00898-3.99971,4.56299-4.00928,4.59956 C51.93932,11.65288,50.95699,12.41611,49.84205,12.41611z' })
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC5.default);
	
	function Sunglasses(props) {
		var glasses = {
			Cat: Cat,
			Tortoise: Tortoise,
			Chicken: Chicken
		};
	
		var ThisSunglasses = glasses[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisSunglasses)) {
			return null;
		}
	
		return _react2.default.createElement(ThisSunglasses, props);
	}
	
	exports.default = Sunglasses;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC4 = __webpack_require__(6);
	
	var _PositionedGoodyHOC5 = _interopRequireDefault(_PositionedGoodyHOC4);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
	
			// 3
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st56: {
						opacity: 0.8
					},
					st30: {
						fill: '#5994C9'
					},
					st25: {
						fill: '#FC5959'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '60.6767426', cy: '17.5086575' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M60,0H0v29h3.8718789c0,3,2.2385252,5,5,5h40.9238281 c2.0810547,0,3.8881836-1.2339554,4.8815918-3.0625687c1.0894775-2.0056152,3.0285378-3.3693504,5.4715309-3.3693504 M60.1488304,27.5702438c2.4429932,0,4.6609612,1.3594093,5.7504387,3.3650246C66.8926773,32.7638817,68.792778,34,70.8738327,34 h40.9980469c2.7614746,0,5-2,5-5H121V0H60 M50,21.2988281C50,25.5520687,46.5520668,29,42.2988281,29H19.7011719 C15.4479322,29,12,25.5520687,12,21.2988281v-8.5976562C12,8.4479322,15.4479322,5,19.7011719,5h22.5976562 C46.5520668,5,50,8.4479322,50,12.7011719V21.2988281z M109,21.2988281C109,25.5520687,105.5520706,29,101.2988281,29H78.7011719 C74.4479294,29,71,25.5520687,71,21.2988281v-8.5976562C71,8.4479322,74.4479294,5,78.7011719,5h22.5976562 C105.5520706,5,109,8.4479322,109,12.7011719V21.2988281z' }),
					_react2.default.createElement(
						'g',
						{ style: style.st56 },
						_react2.default.createElement('rect', { x: '9', y: '3', style: style.st30, width: '42', height: '28' }),
						_react2.default.createElement('rect', { x: '69', y: '3', style: style.st25, width: '42', height: '27' })
					),
					_react2.default.createElement('path', { style: style.st2, d: 'M60,0H0v29h3.8718789c0,3,2.2385252,5,5,5h40.9238281 c2.0810547,0,3.8881836-1.2339554,4.8815918-3.0625687c1.0894775-2.0056152,3.0285378-3.3693504,5.4715309-3.3693504 M60.1488304,27.5702438c2.4429932,0,4.6609612,1.3594093,5.7504387,3.3650246C66.8926773,32.7638817,68.792778,34,70.8738327,34 h40.9980469c2.7614746,0,5-2,5-5H121V0H60 M50,21.2988281C50,25.5520687,46.5520668,29,42.2988281,29H19.7011719 C15.4479322,29,12,25.5520687,12,21.2988281v-8.5976562C12,8.4479322,15.4479322,5,19.7011719,5h22.5976562 C46.5520668,5,50,8.4479322,50,12.7011719V21.2988281z M109,21.2988281C109,25.5520687,105.5520706,29,101.2988281,29H78.7011719 C74.4479294,29,71,25.5520687,71,21.2988281v-8.5976562C71,8.4479322,74.4479294,5,78.7011719,5h22.5976562 C105.5520706,5,109,8.4479322,109,12.7011719V21.2988281z' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC5.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
	
			// 3
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '32.1586761', cy: '9.2795887' }),
					_react2.default.createElement(
						'g',
						{ opacity: '0.8' },
						_react2.default.createElement('rect', { x: '4.77', y: '1.59', fill: '#5994C9', width: '22.2600002', height: '14.8400002' })
					),
					_react2.default.createElement(
						'g',
						{ opacity: '0.8' },
						_react2.default.createElement('rect', { x: '36.5699997', y: '1.59', fill: '#FC5959', width: '22.2600002', height: '14.3100004' })
					),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M31.7999992,0H0v15.3699999h2.0520957c0,1.5899992,1.1864185,2.6500006,2.6500003,2.6500006h21.6896286 c1.1029587,0,2.0607357-0.6539974,2.5872421-1.6231613c0.5774231-1.0629768,1.6051254-1.7857561,2.8999119-1.7857561 M31.8788795,14.6122293c1.2947884,0,2.4703102,0.7204866,3.0477333,1.7834635 c0.5265083,0.9691639,1.5335579,1.6243076,2.6365166,1.6243076h21.7289658c1.4635811,0,2.6500015-1.0600014,2.6500015-2.6500006 h2.1879005V0h-32.329998 M26.5,11.2883787c0,2.2542171-1.827404,4.0816212-4.0816212,4.0816212h-11.976758 c-2.2542171,0-4.0816207-1.827404-4.0816207-4.0816212V6.7316213c0-2.2542171,1.8274035-4.0816212,4.0816207-4.0816212 h11.976758C24.672596,2.6500001,26.5,4.4774041,26.5,6.7316213V11.2883787z M57.7700005,11.2883787 c0,2.2542171-1.827404,4.0816212-4.0816231,4.0816212h-11.976757c-2.2542152,0-4.0816193-1.827404-4.0816193-4.0816212 V6.7316213c0-2.2542171,1.827404-4.0816212,4.0816193-4.0816212h11.976757c2.2542191,0,4.0816231,1.827404,4.0816231,4.0816212 V11.2883787z' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC5.default);
	
	var Chicken = function (_PositionedGoodyHOC3) {
		_inherits(Chicken, _PositionedGoodyHOC3);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
	
			// 3
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, fill: 'none', cx: '42.47372', cy: '12.25606' }),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M42,0H0v20.3h2.71032c0,2.1,1.56697,3.5,3.5,3.5h28.64668c1.45674,0,2.72173-0.86377,3.41711-2.1438 c0.76263-1.40393,2.11998-2.35855,3.83007-2.35855 M42.10418,19.29917c1.7101,0,3.26268,0.95159,4.02531,2.35552 C46.82487,22.93472,48.15495,23.8,49.61168,23.8h28.69864c1.93303,0,3.5-1.4,3.5-3.5H84.7V0H42 M35,14.90918 C35,17.88645,32.58645,20.3,29.60918,20.3H13.79082C10.81355,20.3,8.4,17.88645,8.4,14.90918V8.89082 C8.4,5.91355,10.81355,3.5,13.79082,3.5h15.81836C32.58645,3.5,35,5.91355,35,8.89082V14.90918z M76.3,14.90918 c0,2.97727-2.41356,5.39082-5.39082,5.39082H55.09082C52.11355,20.3,49.7,17.88645,49.7,14.90918V8.89082 C49.7,5.91355,52.11355,3.5,55.09082,3.5h15.81836C73.88644,3.5,76.3,5.91355,76.3,8.89082V14.90918z' }),
					_react2.default.createElement(
						'g',
						{ opacity: '0.8' },
						_react2.default.createElement('rect', { x: '6.3', y: '2.1', fill: '#5994C9', width: '29.4', height: '19.6' })
					),
					_react2.default.createElement(
						'g',
						{ opacity: '0.8' },
						_react2.default.createElement('rect', { x: '48.3', y: '2.1', fill: '#FC5959', width: '29.4', height: '18.9' })
					),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M42,0H0v20.3h2.71032c0,2.1,1.56697,3.5,3.5,3.5h28.64668c1.45674,0,2.72173-0.86377,3.41711-2.1438 c0.76263-1.40393,2.11998-2.35855,3.83007-2.35855 M42.10418,19.29917c1.7101,0,3.26268,0.95159,4.02531,2.35552 C46.82487,22.93472,48.15495,23.8,49.61168,23.8h28.69864c1.93303,0,3.5-1.4,3.5-3.5H84.7V0H42 M35,14.90918 C35,17.88645,32.58645,20.3,29.60918,20.3H13.79082C10.81355,20.3,8.4,17.88645,8.4,14.90918V8.89082 C8.4,5.91355,10.81355,3.5,13.79082,3.5h15.81836C32.58645,3.5,35,5.91355,35,8.89082V14.90918z M76.3,14.90918 c0,2.97727-2.41356,5.39082-5.39082,5.39082H55.09082C52.11355,20.3,49.7,17.88645,49.7,14.90918V8.89082 C49.7,5.91355,52.11355,3.5,55.09082,3.5h15.81836C73.88644,3.5,76.3,5.91355,76.3,8.89082V14.90918z' })
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC5.default);
	
	function ThreeD(props) {
		var glasses = {
			Cat: Cat,
			Tortoise: Tortoise,
			Chicken: Chicken
		};
	
		var ThisThreeD = glasses[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisThreeD)) {
			return null;
		}
	
		return _react2.default.createElement(ThisThreeD, props);
	}
	
	exports.default = ThreeD;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyParentHOC = __webpack_require__(250);
	
	var _PositionedGoodyParentHOC2 = _interopRequireDefault(_PositionedGoodyParentHOC);
	
	var _constants = __webpack_require__(4);
	
	var _Raybans = __webpack_require__(443);
	
	var _Raybans2 = _interopRequireDefault(_Raybans);
	
	var _CatEye = __webpack_require__(439);
	
	var _CatEye2 = _interopRequireDefault(_CatEye);
	
	var _ThreeD = __webpack_require__(446);
	
	var _ThreeD2 = _interopRequireDefault(_ThreeD);
	
	var _OldMan = __webpack_require__(442);
	
	var _OldMan2 = _interopRequireDefault(_OldMan);
	
	var _Scuba = __webpack_require__(444);
	
	var _Scuba2 = _interopRequireDefault(_Scuba);
	
	var _Kerry = __webpack_require__(441);
	
	var _Kerry2 = _interopRequireDefault(_Kerry);
	
	var _Blue = __webpack_require__(438);
	
	var _Blue2 = _interopRequireDefault(_Blue);
	
	var _Sunglasses = __webpack_require__(445);
	
	var _Sunglasses2 = _interopRequireDefault(_Sunglasses);
	
	var _Aviators = __webpack_require__(437);
	
	var _Aviators2 = _interopRequireDefault(_Aviators);
	
	var _Heart = __webpack_require__(440);
	
	var _Heart2 = _interopRequireDefault(_Heart);
	
	var _Alien = __webpack_require__(436);
	
	var _Alien2 = _interopRequireDefault(_Alien);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // To add new glasses:
	//
	// 1. Add the svg component in this folder.
	// 2. Make sure it has the marker ref. (see PositionedGoodyHOC.js for details).
	// 2. Import the component here.
	// 3. Add the goody to `glassesOptions` here.
	// 4. Add the goody to constants.
	// 5. Add a new story in src/stories/glasses.js.
	
	var glassesOptions = {
		'glasses-Raybans': _Raybans2.default,
		'glasses-CatEye': _CatEye2.default,
		'glasses-ThreeD': _ThreeD2.default,
		'glasses-OldMan': _OldMan2.default,
		'glasses-Scuba': _Scuba2.default,
		'glasses-Kerry': _Kerry2.default,
		'glasses-Blue': _Blue2.default,
		'glasses-Sunglasses': _Sunglasses2.default,
		'glasses-Aviators': _Aviators2.default,
		'glasses-Heart': _Heart2.default,
		'glasses-Alien': _Alien2.default
	};
	
	var Glasses = function (_PositionedGoodyParen) {
		_inherits(Glasses, _PositionedGoodyParen);
	
		function Glasses() {
			_classCallCheck(this, Glasses);
	
			return _possibleConstructorReturn(this, (Glasses.__proto__ || Object.getPrototypeOf(Glasses)).apply(this, arguments));
		}
	
		_createClass(Glasses, [{
			key: 'render',
			value: function render() {
				var TheseGlasses = glassesOptions[this.props.goody];
	
				if (!TheseGlasses) {
					return null;
				}
	
				return _react2.default.createElement(
					'svg',
					Object.assign({ ref: _constants.POSITIONED_GOODY_REFS.GOODY_CONTAINER }, this.getPosition()),
					_react2.default.createElement(TheseGlasses, Object.assign({}, this.props, { getMarkerCoords: this.getMarkerCoords }))
				);
			}
		}]);
	
		return Glasses;
	}(_PositionedGoodyParentHOC2.default);
	
	exports.default = Glasses;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Baseball = function (_PositionedGoodyHOC) {
		_inherits(Baseball, _PositionedGoodyHOC);
	
		function Baseball() {
			_classCallCheck(this, Baseball);
	
			return _possibleConstructorReturn(this, (Baseball.__proto__ || Object.getPrototypeOf(Baseball)).apply(this, arguments));
		}
	
		_createClass(Baseball, [{
			key: 'render',
	
			// 5
			value: function render() {
				var style = {
					st49: {
						fill: '#4B9AE2'
					},
					st50: {
						fill: '#238BD8'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '45.4579964', cy: '45.6573067' }),
					_react2.default.createElement('path', { style: style.st49, d: 'M11.2912331,36.7030487c0,3.1619453,15.4767208,5.7252083,34.829792,5.7252083 s33.8297958-2.5632629,33.8297958-5.7252083v-1.2722664c0-18.2690144-14.4767227-33.0789757-33.8297958-33.0789757 S11.1852102,17.161768,11.1852102,35.4307823L11.2912331,36.7030487z' }),
					_react2.default.createElement('path', { style: style.st50, d: 'M72.9352875,40.2391968c1.1573486,0.0527344-5.2211227,2.6881905-17.8550377,6.7348213 c-7.7006836,2.4665527-25.25-2.166748-34.25-2.666748S3.1515326,46.3645973,0.7294871,46.670536 c-0.646527,0.0816689-0.9431157-0.7742996-0.3897915-1.1185379l12.223753-8.8489494 c0,0,12.0964994-2.6598434,23.0167999-2.3957787C49.619606,34.646759,72.9352875,40.2391968,72.9352875,40.2391968z' }),
					_react2.default.createElement('path', { style: style.st50, d: 'M46.1224747,0.3072705h-2.2264709c-0.9983063,0-1.954525,0.4693882-1.9084015,1.5 c0.0462837,1.0340286,0.8384972,1.5000001,1.9084015,1.5000001h2.2264709c0.9983101,0,1.9545288-0.4693882,1.9084015-1.5000001 C47.9845963,0.7732419,47.192379,0.3072705,46.1224747,0.3072705z' }),
					_react2.default.createElement('path', { style: style.st50, d: 'M49.9557381,19.1305122c0.0310059-0.8183594-0.8842773-1.3217773-1.5588379-0.8574219l-4.279541,2.9460449 c-1.6057129-1.5783691-4.1816406-3.5407715-7.1723633-3.6538086c-3.9150391-0.1481934-7.3747559,2.921875-8.7216797,4.2966309 c-0.362793,0.3703613-0.3842773,0.9440918-0.0507812,1.3408203c1.2392578,1.4724121,4.4570312,4.795166,8.3723145,4.9433594 c2.9907227,0.1130371,5.7072754-1.6489258,7.4277344-3.1015625l4.0446777,3.2609863 c0.6376953,0.513916,1.5883789,0.0812988,1.6191406-0.7370605l-1.1142578-4.1376953L49.9557381,19.1305122z' }),
					_react2.default.createElement('polygon', { style: style.st49, points: '36.068531,23.7003365 34.8505135,22.5601997 35.990406,21.3424263 35.2599373,20.6588326 34.1202888,21.8763618 32.9025154,20.7364693 32.2189217,21.466938 33.436451,22.6065865 32.2960701,23.8248482 33.0265388,24.5084419 34.1666756,23.2904243 35.3849373,24.4308052 ' })
				);
			}
		}]);
	
		return Baseball;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = Baseball;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BeachBall = function (_PositionedGoodyHOC) {
		_inherits(BeachBall, _PositionedGoodyHOC);
	
		function BeachBall() {
			_classCallCheck(this, BeachBall);
	
			return _possibleConstructorReturn(this, (BeachBall.__proto__ || Object.getPrototypeOf(BeachBall)).apply(this, arguments));
		}
	
		_createClass(BeachBall, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '66.88209', cy: '123.57816' }),
					_react2.default.createElement('circle', { fill: '#FFFFFF', cx: '66.88209', cy: '66.88209', r: '66.86788' }),
					_react2.default.createElement('path', { fill: '#75C69F', d: 'M7.32357,36.48303C-4.16592,58.99355-1.67568,84.9597,11.58183,104.4912 c19.91488,6.07674,58.84557-7.29811,77.95752-21.1499l0,0C31.34703,53.63963,8.87794,35.497,8.15441,34.90799 C7.87156,35.42799,7.59423,35.95274,7.32357,36.48303z' }),
					_react2.default.createElement('path', { fill: '#FFEAAE', d: 'M75.76816,133.15813c20.99917-2.83449,40.30997-15.57458,50.67249-35.87709 c0,0-9.02534,0.28831-36.90129-13.93974C89.59181,121.84248,76.14036,132.92883,75.76816,133.15813z' }),
					_react2.default.createElement('path', { fill: '#F96E6E', d: 'M59.60795,0.40837L59.60795,0.40837c13.83794,6.10176,29.98386,38.69342,29.9314,82.93293 c29.16844-17.74937,35.98014-45.63178,34.68265-50.86845c-0.00092-0.00163-0.00182-0.00326-0.00289-0.00497 c-6.22633-10.39609-15.34878-19.22909-26.93797-25.14427C85.20886,1.16185,72.14295-0.97526,59.60795,0.40837z' }),
					_react2.default.createElement('circle', { fill: '#987FEF', cx: '89.59181', cy: '83.23866', r: '13.80837' })
				);
			}
		}]);
	
		return BeachBall;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = BeachBall;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Beanie = function (_PositionedGoodyHOC) {
		_inherits(Beanie, _PositionedGoodyHOC);
	
		function Beanie() {
			_classCallCheck(this, Beanie);
	
			return _possibleConstructorReturn(this, (Beanie.__proto__ || Object.getPrototypeOf(Beanie)).apply(this, arguments));
		}
	
		_createClass(Beanie, [{
			key: 'render',
	
			// 6
			value: function render() {
				var style = {
					st36: {
						fill: '#987FEF'
					},
					st9: {
						fill: '#EFEFEF'
					},
					st53: {
						fill: '#836EEA'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, style: style.st144, cx: '38.914917', cy: '83.4989471' }),
					_react2.default.createElement('path', { style: style.st36, d: 'M74.5371704,75.6489105c0-29.8233795-15.6700325-54-35-54s-35,24.1766224-35,54' }),
					_react2.default.createElement('path', { style: style.st9, d: 'M41.7727814,1.477563l0.0000076-0.0000108c1.5273018-2.2293291,5.0192604-1.0947227,4.9445114,1.6065693 v0.0000131c-0.052681,1.9037232,1.8230209,3.2665019,3.6172905,2.6281166l0.0000114-0.0000043 c2.5459824-0.905838,4.7041321,2.0646,3.0558777,4.2060528l-0.0000076,0.0000105 c-1.161602,1.5091801-0.4451447,3.7142019,1.3816833,4.2523823l0.0000114,0.0000038 c2.5921822,0.7636518,2.5921822,4.4353161,0,5.198967l-0.0000114,0.0000038 c-1.826828,0.5381813-2.5432854,2.7432022-1.3816833,4.2523823l0.0000076,0.0000114 c1.6482544,2.1414528-0.5098953,5.1118908-3.0558777,4.2060528l-0.0000114-0.0000057 c-1.7942696-0.6383839-3.6699715,0.7243938-3.6172905,2.6281166v0.0000134 c0.074749,2.7012939-3.4172096,3.8358994-4.9445114,1.6065712l-0.0000076-0.0000114 c-1.0763626-1.5711098-3.3948593-1.5711098-4.4712219,0l-0.0000076,0.0000114 c-1.5273018,2.2293282-5.0192604,1.0947227-4.9445114-1.6065712v-0.0000134 c0.052681-1.9037228-1.8230209-3.2665005-3.6172905-2.6281166l-0.0000134,0.0000057 c-2.5459805,0.905838-4.7041302-2.0646-3.0558758-4.2060528l0.0000076-0.0000114 c1.1616001-1.5091801,0.4451447-3.714201-1.3816814-4.2523823l-0.0000134-0.0000038 c-2.5921803-0.7636509-2.5921803-4.4353151,0-5.198967l0.0000134-0.0000038 c1.8268261-0.5381804,2.5432816-2.7432022,1.3816814-4.2523823l-0.0000076-0.0000105 c-1.6482544-2.1414528,0.5098953-5.1118908,3.0558758-4.2060528l0.0000134,0.0000043 c1.7942696,0.6383853,3.6699715-0.7243934,3.6172905-2.6281166V3.0841215 c-0.074749-2.701292,3.4172096-3.8358984,4.9445114-1.6065693l0.0000076,0.0000108 C38.3779221,3.0486724,40.6964188,3.0486724,41.7727814,1.477563z' }),
					_react2.default.createElement('path', { style: style.st53, d: 'M73.9721985,88.7065277H6.0278015c-3.1982346,0-5.8149719-2.6167374-5.8149719-5.8149719V65.9638824 c0-3.1982384,2.6167374-5.8149757,5.8149719-5.8149757h67.944397c3.1982346,0,5.8149719,2.6167374,5.8149719,5.8149757v16.9276733 C79.7871704,86.0897903,77.170433,88.7065277,73.9721985,88.7065277z' }),
					_react2.default.createElement('path', { style: style.st36, d: 'M36.5371704,23.3989086c-1,0-1,3,0,3C38.5371704,26.3989086,38.5371704,23.3989086,36.5371704,23.3989086z ' }),
					_react2.default.createElement('path', { style: style.st36, d: 'M28.5371704,8.0392542c-1,0-1,2.6534348,0,2.6534348 C30.5371704,10.6926889,30.5371704,8.0392542,28.5371704,8.0392542z' }),
					_react2.default.createElement('path', { style: style.st36, d: 'M31.5371704,16.2206783c-2,0-2,2.6534348,0,2.6534348S33.5371704,16.2206783,31.5371704,16.2206783z' }),
					_react2.default.createElement('path', { style: style.st36, d: 'M40.5371704,6.9336562c-2,0-2,2.6534352,0,2.6534352S42.5371704,6.9336562,40.5371704,6.9336562z' }),
					_react2.default.createElement('path', { style: style.st36, d: 'M49.5371704,14.0094824c-2,0-2,2.6534357,0,2.6534357 C50.5371704,16.6629181,50.5371704,14.0094824,49.5371704,14.0094824z' }),
					_react2.default.createElement('path', { style: style.st36, d: 'M50.5371704,22.1489086c-1.9304199,0-1.9335938,3,0,3 C52.4675903,25.1489086,52.4707642,22.1489086,50.5371704,22.1489086z' }),
					_react2.default.createElement('path', { style: style.st53, d: 'M37.5371704,9.8082104c-1,0-1,2.6534348,0,2.6534348 C39.5371704,12.4616451,39.5371704,9.8082104,37.5371704,9.8082104z' }),
					_react2.default.createElement('path', { style: style.st53, d: 'M35.5371704,2.511265c-1,0-1,2.6534345,0,2.6534345S36.5371704,2.511265,35.5371704,2.511265z' }),
					_react2.default.createElement('path', { style: style.st53, d: 'M26.5371704,22.8989086c-2,0-2,3,0,3S28.5371704,22.8989086,26.5371704,22.8989086z' }),
					_react2.default.createElement('path', { style: style.st53, d: 'M36.5371704,16.2206783c-1,0-1,2.6534348,0,2.6534348 C38.5371704,18.8741131,38.5371704,16.2206783,36.5371704,16.2206783z' }),
					_react2.default.createElement('path', { style: style.st53, d: 'M44.5371704,26.8989086c-1,0-1,3,0,3C46.5371704,29.8989086,46.5371704,26.8989086,44.5371704,26.8989086z ' }),
					_react2.default.createElement('path', { style: style.st53, d: 'M45.5371704,15.5573196c-2,0-2,2.6534348,0,2.6534348S47.5371704,15.5573196,45.5371704,15.5573196z' }),
					_react2.default.createElement('path', { style: style.st53, d: 'M50.5371704,7.3758955c-1,0-1,2.6534348,0,2.6534348S51.5371704,7.3758955,50.5371704,7.3758955z' })
				);
			}
		}]);
	
		return Beanie;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = Beanie;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC6 = __webpack_require__(6);
	
	var _PositionedGoodyHOC7 = _interopRequireDefault(_PositionedGoodyHOC6);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
	
			// 12
			value: function render() {
				var style = {
					st155: {
						fill: '#F96E6E'
					},
					st156: {
						fill: '#F26161'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '0.509522', cy: '35.2435722', r: '0.2505777' }),
					_react2.default.createElement('path', { style: style.st155, d: 'M88.3330154,43.6074257c-2.4673615,7.1922417-6.3909378,13.9099846-9.6233597,15.5329437 c-5.0317459,2.5135956-17.8172874-6.7758522-24.1167564-13.5642891c-1.5094185-1.624836-2.6423721-3.1015892-3.2134666-4.2452202 c-2.9638405-5.9330482-0.5160217-14.7127209,5.9924088-17.9555817c1.2376556-0.6182671,3.020359-1.1892929,5.1256866-1.6526508 c9.0299683-1.9976215,24.0282516-2.0931835,27.2475662,4.351284 C91.6538849,29.8949356,90.6189041,36.9597816,88.3330154,43.6074257z' }),
					_react2.default.createElement('path', { style: style.st155, d: 'M37.7143211,36.6247215c-1.2376518,0.6182671-3.0201111,1.1893768-5.1254349,1.6527328 c-9.0302143,1.9975395-24.0284977,2.0931015-27.247818-4.351368c-1.9087849-3.821022-0.8737249-10.8861141,1.4053502-17.5469799 c2.46769-7.1924057,6.3878207-13.899806,9.6300907-15.519475c5.031744-2.513597,17.8172894,6.7758522,24.1170025,13.5643692 c1.5094185,1.6248369,2.642128,3.1015081,3.2132225,4.2451372C46.6607246,24.5988998,44.2126579,33.3784904,37.7143211,36.6247215 z' }),
					_react2.default.createElement('path', { style: style.st156, d: 'M68.1210556,30.8566761L47.9198875,28.863512L30.5839481,18.2817249 c-0.7329102-0.4436035-1.5981445-0.7492676-2.5083008-0.8369141c-3.2426758-0.3120117-6.1245117,2.0637207-6.4365234,5.3063965 c-0.3120117,3.2429199,2.0634766,6.1247559,5.3061523,6.4367676l20.2172871,1.9460449L64.514122,41.6689301 c0.7197266,0.4328613,1.5678711,0.7324219,2.4594727,0.8205566c3.2124023,0.3168945,6.0732422-2.0302734,6.3901367-5.2426758 C73.6806259,34.0346527,71.3334579,31.1735706,68.1210556,30.8566761z' }),
					_react2.default.createElement('path', { style: style.st156, d: 'M46.08284,39.9521179l-3.3534584-1.1191673 c-4.2619629-1.4223671-6.5639114-6.0304298-5.1415443-10.2923927l1.1191673-3.3534584 c1.4223671-4.2619648,6.0304298-6.5639133,10.2923965-5.1415462l3.3534584,1.1191673 c4.2619629,1.422369,6.5639114,6.0304298,5.1415443,10.2923946l-1.1191673,3.3534584 C54.9528694,39.0725403,50.3448067,41.374485,46.08284,39.9521179z' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC7.default);
	
	var TuxedoBird = function (_PositionedGoodyHOC2) {
		_inherits(TuxedoBird, _PositionedGoodyHOC2);
	
		function TuxedoBird() {
			_classCallCheck(this, TuxedoBird);
	
			return _possibleConstructorReturn(this, (TuxedoBird.__proto__ || Object.getPrototypeOf(TuxedoBird)).apply(this, arguments));
		}
	
		_createClass(TuxedoBird, [{
			key: 'render',
	
			// 12
			value: function render() {
				var style = {
					st155: {
						fill: '#F96E6E'
					},
					st156: {
						fill: '#F26161'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '20.509522', cy: '35.2435722', r: '0.2505777' }),
					_react2.default.createElement('path', { style: style.st155, d: 'M88.3330154,43.6074257c-2.4673615,7.1922417-6.3909378,13.9099846-9.6233597,15.5329437 c-5.0317459,2.5135956-17.8172874-6.7758522-24.1167564-13.5642891c-1.5094185-1.624836-2.6423721-3.1015892-3.2134666-4.2452202 c-2.9638405-5.9330482-0.5160217-14.7127209,5.9924088-17.9555817c1.2376556-0.6182671,3.020359-1.1892929,5.1256866-1.6526508 c9.0299683-1.9976215,24.0282516-2.0931835,27.2475662,4.351284 C91.6538849,29.8949356,90.6189041,36.9597816,88.3330154,43.6074257z' }),
					_react2.default.createElement('path', { style: style.st155, d: 'M37.7143211,36.6247215c-1.2376518,0.6182671-3.0201111,1.1893768-5.1254349,1.6527328 c-9.0302143,1.9975395-24.0284977,2.0931015-27.247818-4.351368c-1.9087849-3.821022-0.8737249-10.8861141,1.4053502-17.5469799 c2.46769-7.1924057,6.3878207-13.899806,9.6300907-15.519475c5.031744-2.513597,17.8172894,6.7758522,24.1170025,13.5643692 c1.5094185,1.6248369,2.642128,3.1015081,3.2132225,4.2451372C46.6607246,24.5988998,44.2126579,33.3784904,37.7143211,36.6247215 z' }),
					_react2.default.createElement('path', { style: style.st156, d: 'M68.1210556,30.8566761L47.9198875,28.863512L30.5839481,18.2817249 c-0.7329102-0.4436035-1.5981445-0.7492676-2.5083008-0.8369141c-3.2426758-0.3120117-6.1245117,2.0637207-6.4365234,5.3063965 c-0.3120117,3.2429199,2.0634766,6.1247559,5.3061523,6.4367676l20.2172871,1.9460449L64.514122,41.6689301 c0.7197266,0.4328613,1.5678711,0.7324219,2.4594727,0.8205566c3.2124023,0.3168945,6.0732422-2.0302734,6.3901367-5.2426758 C73.6806259,34.0346527,71.3334579,31.1735706,68.1210556,30.8566761z' }),
					_react2.default.createElement('path', { style: style.st156, d: 'M46.08284,39.9521179l-3.3534584-1.1191673 c-4.2619629-1.4223671-6.5639114-6.0304298-5.1415443-10.2923927l1.1191673-3.3534584 c1.4223671-4.2619648,6.0304298-6.5639133,10.2923965-5.1415462l3.3534584,1.1191673 c4.2619629,1.422369,6.5639114,6.0304298,5.1415443,10.2923946l-1.1191673,3.3534584 C54.9528694,39.0725403,50.3448067,41.374485,46.08284,39.9521179z' })
				);
			}
		}]);
	
		return TuxedoBird;
	}(_PositionedGoodyHOC7.default);
	
	var Tortoise = function (_PositionedGoodyHOC3) {
		_inherits(Tortoise, _PositionedGoodyHOC3);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
	
			// 12
			value: function render() {
				var style = {
					st155: {
						fill: '#F96E6E'
					},
					st156: {
						fill: '#F26161'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '28.509522', cy: '40.2435722', r: '0.2505777' }),
					_react2.default.createElement('path', { style: style.st155, d: 'M88.3330154,43.6074257c-2.4673615,7.1922417-6.3909378,13.9099846-9.6233597,15.5329437 c-5.0317459,2.5135956-17.8172874-6.7758522-24.1167564-13.5642891c-1.5094185-1.624836-2.6423721-3.1015892-3.2134666-4.2452202 c-2.9638405-5.9330482-0.5160217-14.7127209,5.9924088-17.9555817c1.2376556-0.6182671,3.020359-1.1892929,5.1256866-1.6526508 c9.0299683-1.9976215,24.0282516-2.0931835,27.2475662,4.351284 C91.6538849,29.8949356,90.6189041,36.9597816,88.3330154,43.6074257z' }),
					_react2.default.createElement('path', { style: style.st155, d: 'M37.7143211,36.6247215c-1.2376518,0.6182671-3.0201111,1.1893768-5.1254349,1.6527328 c-9.0302143,1.9975395-24.0284977,2.0931015-27.247818-4.351368c-1.9087849-3.821022-0.8737249-10.8861141,1.4053502-17.5469799 c2.46769-7.1924057,6.3878207-13.899806,9.6300907-15.519475c5.031744-2.513597,17.8172894,6.7758522,24.1170025,13.5643692 c1.5094185,1.6248369,2.642128,3.1015081,3.2132225,4.2451372C46.6607246,24.5988998,44.2126579,33.3784904,37.7143211,36.6247215 z' }),
					_react2.default.createElement('path', { style: style.st156, d: 'M68.1210556,30.8566761L47.9198875,28.863512L30.5839481,18.2817249 c-0.7329102-0.4436035-1.5981445-0.7492676-2.5083008-0.8369141c-3.2426758-0.3120117-6.1245117,2.0637207-6.4365234,5.3063965 c-0.3120117,3.2429199,2.0634766,6.1247559,5.3061523,6.4367676l20.2172871,1.9460449L64.514122,41.6689301 c0.7197266,0.4328613,1.5678711,0.7324219,2.4594727,0.8205566c3.2124023,0.3168945,6.0732422-2.0302734,6.3901367-5.2426758 C73.6806259,34.0346527,71.3334579,31.1735706,68.1210556,30.8566761z' }),
					_react2.default.createElement('path', { style: style.st156, d: 'M46.08284,39.9521179l-3.3534584-1.1191673 c-4.2619629-1.4223671-6.5639114-6.0304298-5.1415443-10.2923927l1.1191673-3.3534584 c1.4223671-4.2619648,6.0304298-6.5639133,10.2923965-5.1415462l3.3534584,1.1191673 c4.2619629,1.422369,6.5639114,6.0304298,5.1415443,10.2923946l-1.1191673,3.3534584 C54.9528694,39.0725403,50.3448067,41.374485,46.08284,39.9521179z' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC7.default);
	
	var Chicken = function (_PositionedGoodyHOC4) {
		_inherits(Chicken, _PositionedGoodyHOC4);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
	
			// 12
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, fill: 'none', cx: '13.58004', cy: '38.01423' }),
					_react2.default.createElement('path', { fill: '#F96E6E', d: 'M68.31544,35.14081c-1.98579,5.78852-5.1436,11.19514-7.74514,12.50134 c-4.04969,2.02301-14.33985-5.45339-19.40984-10.91692c-1.21482-1.30771-2.12666-2.49624-2.58629-3.41667 c-2.38538-4.77508-0.41531-11.84121,4.82286-14.45115c0.9961-0.4976,2.43087-0.95718,4.12529-1.3301 c7.26757-1.60774,19.3386-1.68465,21.9296,3.50203C70.98817,24.10462,70.15518,29.7906,68.31544,35.14081z' }),
					_react2.default.createElement('path', { fill: '#F96E6E', d: 'M27.57611,29.52094c-0.9961,0.4976-2.43067,0.95724-4.1251,1.33016 c-7.26777,1.60768-19.3388,1.68459-21.9298-3.5021c-1.53624-3.07527-0.7032-8.76145,1.13106-14.1223 c1.98607-5.78865,5.1411-11.18695,7.75056-12.4905c4.04969-2.02301,14.33985,5.45339,19.41003,10.91698 c1.21482,1.30771,2.12646,2.49618,2.58609,3.4166C34.77642,19.84222,32.80615,26.90828,27.57611,29.52094z' }),
					_react2.default.createElement('path', { fill: '#F26161', d: 'M52.04829,24.87865L35.78983,23.2745l-13.95244-8.51651c-0.58987-0.35702-1.28623-0.60303-2.01875-0.67357 c-2.60979-0.25112-4.92918,1.66094-5.18029,4.27073c-0.25112,2.60999,1.66074,4.92937,4.27054,5.18049l16.27143,1.56623 l13.96502,8.47879c0.57925,0.34838,1.26186,0.58947,1.97945,0.66041c2.58543,0.25504,4.88791-1.63402,5.14296-4.21945 C56.52279,27.43638,54.63372,25.1337,52.04829,24.87865z' }),
					_react2.default.createElement('path', { fill: '#F26161', d: 'M34.31133,32.19892l-2.69896-0.90074c-3.43015-1.14476-5.28282-4.85346-4.13806-8.28361l0.90074-2.69896 c1.14476-3.43015,4.85346-5.28282,8.2836-4.13806l2.69896,0.90074c3.43015,1.14476,5.28282,4.85346,4.13806,8.28361 l-0.90073,2.69896C41.45017,31.49101,37.74147,33.34368,34.31133,32.19892z' })
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC7.default);
	
	var Bunny = function (_PositionedGoodyHOC5) {
		_inherits(Bunny, _PositionedGoodyHOC5);
	
		function Bunny() {
			_classCallCheck(this, Bunny);
	
			return _possibleConstructorReturn(this, (Bunny.__proto__ || Object.getPrototypeOf(Bunny)).apply(this, arguments));
		}
	
		_createClass(Bunny, [{
			key: 'render',
	
			// 12
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, fill: 'none', cx: '10.58004', cy: '38.01423' }),
					_react2.default.createElement('path', { fill: '#F96E6E', d: 'M68.31544,35.14081c-1.98579,5.78852-5.1436,11.19514-7.74514,12.50134 c-4.04969,2.02301-14.33985-5.45339-19.40984-10.91692c-1.21482-1.30771-2.12666-2.49624-2.58629-3.41667 c-2.38538-4.77508-0.41531-11.84121,4.82286-14.45115c0.9961-0.4976,2.43087-0.95718,4.12529-1.3301 c7.26757-1.60774,19.3386-1.68465,21.9296,3.50203C70.98817,24.10462,70.15518,29.7906,68.31544,35.14081z' }),
					_react2.default.createElement('path', { fill: '#F96E6E', d: 'M27.57611,29.52094c-0.9961,0.4976-2.43067,0.95724-4.1251,1.33016 c-7.26777,1.60768-19.3388,1.68459-21.9298-3.5021c-1.53624-3.07527-0.7032-8.76145,1.13106-14.1223 c1.98607-5.78865,5.1411-11.18695,7.75056-12.4905c4.04969-2.02301,14.33985,5.45339,19.41003,10.91698 c1.21482,1.30771,2.12646,2.49618,2.58609,3.4166C34.77642,19.84222,32.80615,26.90828,27.57611,29.52094z' }),
					_react2.default.createElement('path', { fill: '#F26161', d: 'M52.04829,24.87865L35.78983,23.2745l-13.95244-8.51651c-0.58987-0.35702-1.28623-0.60303-2.01875-0.67357 c-2.60979-0.25112-4.92918,1.66094-5.18029,4.27073c-0.25112,2.60999,1.66074,4.92937,4.27054,5.18049l16.27143,1.56623 l13.96502,8.47879c0.57925,0.34838,1.26186,0.58947,1.97945,0.66041c2.58543,0.25504,4.88791-1.63402,5.14296-4.21945 C56.52279,27.43638,54.63372,25.1337,52.04829,24.87865z' }),
					_react2.default.createElement('path', { fill: '#F26161', d: 'M34.31133,32.19892l-2.69896-0.90074c-3.43015-1.14476-5.28282-4.85346-4.13806-8.28361l0.90074-2.69896 c1.14476-3.43015,4.85346-5.28282,8.2836-4.13806l2.69896,0.90074c3.43015,1.14476,5.28282,4.85346,4.13806,8.28361 l-0.90073,2.69896C41.45017,31.49101,37.74147,33.34368,34.31133,32.19892z' })
				);
			}
		}]);
	
		return Bunny;
	}(_PositionedGoodyHOC7.default);
	
	function Bow(props) {
		var bows = {
			Cat: Cat,
			TuxedoBird: TuxedoBird,
			Tortoise: Tortoise,
			Chicken: Chicken,
			Bunny: Bunny
		};
	
		var ThisBow = bows[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisBow)) {
			return null;
		}
	
		return _react2.default.createElement(ThisBow, props);
	}
	
	exports.default = Bow;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Chef = function (_PositionedGoodyHOC) {
		_inherits(Chef, _PositionedGoodyHOC);
	
		function Chef() {
			_classCallCheck(this, Chef);
	
			return _possibleConstructorReturn(this, (Chef.__proto__ || Object.getPrototypeOf(Chef)).apply(this, arguments));
		}
	
		_createClass(Chef, [{
			key: 'render',
	
			// 4
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st33: {
						fill: '#E5E5E5'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, style: style.st144, cx: '52.2152481', cy: '92.0450745' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M86.4273453,52.695034H19.5726528v36.0097618c0,1.3227463,0.9325886,2.4620743,2.2292576,2.7234344 l2.4605579,0.4959717c19.8100071,3.9930267,40.232933,3.8333817,59.978096-0.4688416l0.0000305-0.0000076 c1.2765045-0.2781296,2.1867523-1.4080734,2.1867523-2.7145233V52.695034z' }),
					_react2.default.createElement('ellipse', { style: style.st2, cx: '53', cy: '32.195034', rx: '52.8375053', ry: '32' }),
					_react2.default.createElement('path', { style: style.st33, d: 'M79.5607529,41.5504265c-2.5407181,5.2112732-0.5708313,14.6979408-0.5708313,14.6979408 s8.6870651-4.290947,11.2277832-9.5022202s0.9158096-7.9347038-2.0270309-9.3694611 C85.2478409,35.941925,82.1014709,36.3391571,79.5607529,41.5504265z' }),
					_react2.default.createElement('path', { style: style.st33, d: 'M63.0960541,46.1276283c-0.773674,4.3453293,2.6466599,10.8805199,2.6466599,10.8805199 s5.4657822-4.9530411,6.2394562-9.2983704s-0.983902-6.0005608-3.4377365-6.437458 C66.0906067,40.8354187,63.8697281,41.782299,63.0960541,46.1276283z' }),
					_react2.default.createElement('path', { style: style.st33, d: 'M48.7336769,48.1896362c0.0348244,4.2971573,4.474659,9.9419861,4.474659,9.9419861 s4.3477707-5.7160416,4.3129463-10.0131989s-2.0124207-5.567852-4.4390526-5.5481873 C50.6556015,42.589901,48.6988525,43.8924751,48.7336769,48.1896362z' }),
					_react2.default.createElement('path', { style: style.st33, d: 'M25.8982258,41.5504265c2.54072,5.2112732,0.5708351,14.6979408,0.5708351,14.6979408 s-8.6870651-4.290947-11.2277832-9.5022202s-0.9158087-7.9347038,2.0270271-9.3694611 C20.2111397,35.941925,23.3575077,36.3391571,25.8982258,41.5504265z' }),
					_react2.default.createElement('path', { style: style.st33, d: 'M42.3629265,46.1276283c0.773674,4.3453293-2.6466599,10.8805199-2.6466599,10.8805199 s-5.4657822-4.9530411-6.2394562-9.2983704s0.983902-6.0005608,3.4377327-6.437458 C39.3683777,40.8354187,41.5892525,41.782299,42.3629265,46.1276283z' })
				);
			}
		}]);
	
		return Chef;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = Chef;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Fedora = function (_PositionedGoodyHOC) {
		_inherits(Fedora, _PositionedGoodyHOC);
	
		function Fedora() {
			_classCallCheck(this, Fedora);
	
			return _possibleConstructorReturn(this, (Fedora.__proto__ || Object.getPrototypeOf(Fedora)).apply(this, arguments));
		}
	
		_createClass(Fedora, [{
			key: 'render',
	
			// 2
			value: function render() {
				var style = {
					st47: {
						fill: '#444444'
					},
					st54: {
						fill: '#808080'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '39.1575317', cy: '47.7731552' }),
					_react2.default.createElement('path', { style: style.st47, d: 'M40.2656517,50.7564507c-15.8204556,0-29.3717995-2.6666298-36.0864105-6.7271271 c-2.4493117-1.2127914-4.017849-3.4524994-4.017849-6.4638138c0-4.1708298,3.0401332-7.8347397,7.8097916-7.8347397l0,0 c0,0,6.3096633-17.7507153,10.2349129-23.8530083c2.3589287-3.6672506,6.4903202-5.7968574,10.8473339-5.6244926 C33.2893753,0.4208441,38.3382988,2.985486,40.5,2.985486s7.2106247-2.564642,11.4465675-2.7322173 c4.3570137-0.1723649,8.4884071,1.957242,10.847332,5.6244926c3.9252548,6.1022935,10.2349167,23.8530083,10.2349167,23.8530083 l0,0c4.7696533,0,7.8097916,3.6639099,7.8097916,7.8347397c0,3.0113144-1.5685425,5.2510223-4.0178528,6.4638138 c-6.7146072,4.0604973-20.2659531,6.7271271-36.0864067,6.7271271H40.2656517z' }),
					_react2.default.createElement('path', { style: style.st54, d: 'M11.6994762,19.8847885c-1.5018187,3.1969509-3.728291,9.8459816-4.0485196,9.8459816 c5.7428441,3.7853127,18.21702,6.4092865,32.6890755,6.4092865c14.4719086,0,26.9459419-2.6239738,32.6887856-6.4092865 c0,0-2.4208603-7.134943-3.9225311-10.3318939c-6.4930305,2.9264259-16.3816223,4.8520279-28.7662544,4.8520279 S18.192358,22.8112144,11.6994762,19.8847885z' })
				);
			}
		}]);
	
		return Fedora;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = Fedora;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Fez = function (_PositionedGoodyHOC) {
		_inherits(Fez, _PositionedGoodyHOC);
	
		function Fez() {
			_classCallCheck(this, Fez);
	
			return _possibleConstructorReturn(this, (Fez.__proto__ || Object.getPrototypeOf(Fez)).apply(this, arguments));
		}
	
		_createClass(Fez, [{
			key: 'render',
	
			// 3
			value: function render() {
				var style = {
					st25: {
						fill: '#FC5959'
					},
					st26: {
						fill: '#EAB049'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '25.414978', cy: '58.7372284' }),
					_react2.default.createElement('path', { style: style.st25, d: 'M47.0372314,3.387193c0-1.8640138-9.1035156-3.375-20.333252-3.375 s-20.3334961,1.5109863-20.3334961,3.375l-6.2038574,49h0.0002441c17.0708008,5.8344727,35.5957031,5.8344727,52.6665039,0 L47.0372314,3.387193z' }),
					_react2.default.createElement('path', { style: style.st26, d: 'M47.5062256,36.6108246l-3.0505371-9.3195782l-0.1833496-0.5595703 c0.7995605-0.7614746,1.3164062-1.8212891,1.3586426-3.0117188c0.0678711-1.9206543-1.1208496-3.5783691-2.8215332-4.2277832 l-1.026123-14.4086924c-0.0507812-0.7099609-0.5927734-1.2866209-1.2988281-1.3803709L26.9014893,1.9003764 c-0.8242188-0.1166992-1.5751953,0.4682618-1.6845703,1.2895509c-0.1083984,0.8212888,0.46875,1.5751951,1.2900391,1.6840818 L38.8780518,6.516099l0.9208984,12.9294443c-1.6450195,0.5827637-2.8525391,2.1152344-2.9179688,3.9648438 c-0.0568848,1.6047363,0.767334,3.0234375,2.0283203,3.8303223l-0.0771484,0.3881836l-1.8745117,9.4194317 c-0.1589355,0.7980957,0.4753418,1.2880859,1.2189941,1.6184082c1.7736816,0.7878418,5.5725098,1.1508789,8.3830566-0.3039551 C47.2589111,38.0007172,47.7513428,37.3591156,47.5062256,36.6108246z' })
				);
			}
		}]);
	
		return Fez;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = Fez;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FlowerCrown = function (_PositionedGoodyHOC) {
		_inherits(FlowerCrown, _PositionedGoodyHOC);
	
		function FlowerCrown() {
			_classCallCheck(this, FlowerCrown);
	
			return _possibleConstructorReturn(this, (FlowerCrown.__proto__ || Object.getPrototypeOf(FlowerCrown)).apply(this, arguments));
		}
	
		_createClass(FlowerCrown, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '61.80107', cy: '45.55338' }),
					_react2.default.createElement('path', { fill: '#75C69F', d: 'M34.61867,15.07672c-0.76818,2.78787-0.95874,5.55765-0.85768,8.06981 c-0.88042-1.20376-1.88113-2.38256-3.04504-3.47123c-6.97097-6.52247-16.70555-7.44553-16.70555-7.44553 s2.49143,8.03803,6.15886,15.99851c-0.77731-0.15698-1.56702-0.29235-2.38212-0.37241C8.28595,26.9233,0,32.11535,0,32.11535 s8.11592,5.74874,16.66604,9.9954c10.43315,5.18172,14.84013,0.48326,16.61896-3.20483 c3.45995-0.63268,5.96995-3.05658,5.96995-3.05658s-0.14787-0.89206-0.54062-2.30434 c4.05603-0.1333,10.76999-2.15966,9.61275-14.40271C47.42897,9.63798,44.97332,0,44.97332,0S37.15487,5.87331,34.61867,15.07672z'
					}),
					_react2.default.createElement('path', { fill: '#75C69F', d: 'M41.36015,36.75166c0,3.42577-4.77095,7.65168-16.24457,7.65168 c-4.83965,0-1.28135-4.22591-1.28135-7.65168s3.92331-6.20291,8.76296-6.20291S41.36015,33.32589,41.36015,36.75166z' }),
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement('path', { fill: '#75C69F', d: 'M83.01997,45.11023c1.63772-2.38332,2.72366-4.93845,3.44976-7.34552 c0.43831,1.42551,0.99846,2.86676,1.74231,4.27622c4.45443,8.44365,13.35178,12.49965,13.35178,12.49965 s0.27444-8.41082-0.58782-17.13296c0.68322,0.40257,1.38523,0.78876,2.12932,1.13101 c8.67369,3.98866,18.20203,1.79208,18.20203,1.79208s-5.78947-8.08693-12.48051-14.89637 c-8.1647-8.30893-13.86597-5.31017-16.75317-2.40668c-3.47659-0.5337-6.6413,0.93601-6.6413,0.93601 s-0.15201,0.89136-0.24274,2.35442c-3.87657-1.20056-10.88403-1.48145-13.79455,10.46679 c-2.25967,9.27537-3.09119,19.18644-3.09119,19.18644S77.61326,52.97805,83.01997,45.11023z' }),
						_react2.default.createElement('path', { fill: '#75C69F', d: 'M105.82243,22.86361c2.76254,3.0715-11.40704,11.41925-17.24308,11.41925 c-5.83604,0-8.56549-3.34889-8.56549-7.47996s4.89334-6.11325,10.56709-7.47996 C94.80563,18.30527,102.86975,19.5807,105.82243,22.86361z' })
					),
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement('path', { fill: '#836EEA', d: 'M26.86303,45.75624c-0.23989,0.0549-0.45061,0.11708-0.60677,0.18347 c-0.93132,0.39466-1.36615,1.46948-0.97157,2.4009c0.39464,0.93145,1.46965,1.36644,2.40092,0.97174 c0.15715-0.06686,0.35379-0.1834,0.56141-0.31864c-0.07294,0.23669-0.13133,0.45812-0.15211,0.62713 c-0.12367,1.00372,0.58957,1.91821,1.5936,2.04189c1.00373,0.12406,1.91793-0.58941,2.0419-1.59351 c0.02051-0.16737,0.01824-0.39403,0.00514-0.63845c0.16928,0.18238,0.33033,0.33542,0.46688,0.43834 c0.8073,0.60941,1.95572,0.44873,2.56511-0.35905c0.60909-0.80739,0.44833-1.9558-0.35902-2.56525 c-0.13529-0.10194-0.32485-0.21343-0.544-0.3251c0.23984-0.05494,0.45057-0.11712,0.60672-0.1835 c0.93127-0.3947,1.36616-1.46949,0.97152-2.40094c-0.39463-0.93145-1.4696-1.3664-2.40092-0.97174 c-0.15714,0.06685-0.35379,0.1834-0.56141,0.31864c0.07294-0.23669,0.13133-0.45812,0.15211-0.62713 c0.12367-1.00372-0.58957-1.91821-1.5936-2.04189c-1.00373-0.12406-1.91792,0.58941-2.0419,1.59351 c-0.02081,0.16776-0.01824,0.39403-0.00514,0.63845c-0.16928-0.18238-0.33033-0.33542-0.46688-0.43834 c-0.8073-0.60941-1.95568-0.44869-2.56511,0.35905c-0.60909,0.80739-0.44828,1.95584,0.35902,2.56525 C26.45423,45.53301,26.64383,45.64454,26.86303,45.75624z' }),
						_react2.default.createElement('path', { fill: '#836EEA', d: 'M13.3848,46.763c0.16523-0.04071,0.37825-0.12527,0.60458-0.22607 c-0.10954,0.22237-0.20182,0.43157-0.24917,0.59533c-0.28045,0.97174,0.27972,1.98724,1.25147,2.26786 c0.97211,0.28027,1.98729-0.27998,2.26779-1.25168c0.04699-0.1628,0.08369-0.37947,0.10967-0.62435 c0.13671,0.20465,0.27043,0.3791,0.3879,0.50119c0.70144,0.7287,1.86074,0.75123,2.58971,0.04985 c0.72892-0.70142,0.75111-1.86059,0.04993-2.58972c-0.11867-0.12303-0.28981-0.26474-0.49119-0.41086 c0.24456-0.01656,0.46949-0.041,0.63335-0.08155c0.98163-0.24261,1.58077-1.23559,1.33793-2.21763 s-1.23587-1.58099-2.21781-1.338c-0.16523,0.04072-0.37825,0.12527-0.60458,0.22607 c0.10954-0.22237,0.20212-0.43195,0.24917-0.59532c0.28075-0.97212-0.27972-1.98724-1.25147-2.26786 c-0.97181-0.28066-1.98699,0.2796-2.26779,1.25168c-0.04699,0.1628-0.08365,0.37951-0.10932,0.624 c-0.13705-0.2043-0.27078-0.37875-0.38825-0.50084c-0.70118-0.72912-1.86074-0.75122-2.58971-0.04984 c-0.72862,0.70103-0.75111,1.86059-0.04993,2.58971c0.11867,0.12303,0.28981,0.26474,0.49119,0.41087 c-0.24426,0.01617-0.46949,0.041-0.63335,0.08155C11.5233,43.45,10.92416,44.44297,11.167,45.42501 C11.41013,46.40666,12.40287,47.006,13.3848,46.763z' }),
						_react2.default.createElement('path', { fill: '#836EEA', d: 'M24.50181,37.5037c0.09869-0.13729,0.20607-0.32912,0.31282-0.55119 c0.06034,0.23856,0.12761,0.44784,0.19707,0.60245c0.41587,0.92202,1.50055,1.33233,2.42246,0.91669 c0.92221-0.41602,1.33262-1.50062,0.91676-2.42264c-0.07018-0.15517-0.19131-0.34952-0.33119-0.55417 c0.23827,0.06775,0.46101,0.12089,0.63048,0.13801c1.00652,0.10085,1.90408-0.63305,2.00509-1.6396 c0.10097-1.00658-0.63331-1.90405-1.63953-2.00528c-0.16812-0.01668-0.39409-0.00915-0.63844,0.00942 c0.17836-0.17295,0.32775-0.33756,0.4276-0.47642c0.59061-0.82121,0.40379-1.96581-0.41741-2.55633 c-0.82125-0.59056-1.96564-0.40381-2.55629,0.41736c-0.099,0.13767-0.20638,0.32951-0.31282,0.55119 c-0.06034-0.23857-0.12761-0.44784-0.19707-0.60245c-0.41587-0.92201-1.50055-1.33233-2.42276-0.91631 c-0.92191,0.41564-1.33232,1.50024-0.91646,2.42226c0.06988,0.15556,0.19136,0.34955,0.33124,0.5542 c-0.23832-0.06779-0.46106-0.12093-0.63053-0.13804c-1.00653-0.10085-1.90438,0.63344-2.0051,1.6396 c-0.10097,1.00658,0.63301,1.90443,1.63954,2.00528c0.16811,0.01667,0.39413,0.00919,0.63849-0.00939 c-0.17862,0.17338-0.32805,0.33795-0.4276,0.47642c-0.59066,0.82117-0.40384,1.96577,0.41736,2.55629 C22.76647,38.512,23.91116,38.32486,24.50181,37.5037z' })
					),
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement('polygon', { fill: '#75C69F', points: '98.53794,37.54509 60.36802,37.43456 60.83744,21.32865 98.88755,26.55077 \t\t\t' })
					),
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('path', { fill: '#FC5959', d: 'M53.26588,16.18153l0.00001-0.00001c3.80442-3.74759,10.17951-0.42141,9.28202,4.84286l0,0.00002 h0.00002c5.32326-0.42539,8.06884,6.22045,3.99751,9.67622l-0.00002,0.00001l0.00002,0.00001 c4.35129,3.09586,2.18266,9.95169-3.15748,9.98196h-0.00002l0,0.00002c1.3433,5.16852-4.72481,9.02642-8.83505,5.61703 l-0.00002-0.00001l-0.00001,0.00002c-2.29323,4.82277-9.42148,3.87759-10.3786-1.37617v-0.00002l-0.00002,0.00001 c-4.85674,2.22039-9.70974-3.08561-7.06589-7.72544l0.00001-0.00002l-0.00002,0 c-5.14772-1.42093-5.4547-8.60501-0.44697-10.4599l0.00002-0.00001l-0.00001-0.00001 c-3.03003-4.39738,1.35265-10.09804,6.3811-8.30005l0.00002,0.00001l0-0.00002 c0.50545-5.31625,7.52708-6.86608,10.22337-2.25652L53.26588,16.18153z' })
						),
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('circle', { fill: '#FFEAAE', cx: '51.20458', cy: '31.72724', r: '5.7076' })
						)
					),
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M87.24824,10.52279c-0.76722,2.97522-5.51828,12.62603-6.68536,12.32507 s-0.65871-11.04583,0.10851-14.02104c0.76723-2.97522,2.68226-4.31254,4.49841-3.84421 C86.98594,5.45093,88.01546,7.54757,87.24824,10.52279z' })
						),
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M76.1131,9.25624c1.32471,2.77231,3.88861,13.21918,2.80112,13.73882 c-1.08749,0.51964-7.60472-8.03819-8.92943-10.81049s-0.71732-5.02772,0.97497-5.83635S74.78839,6.48393,76.1131,9.25624z' })
						),
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M66.76897,15.44353c2.79679,1.27221,11.47597,7.62693,10.97692,8.72402 c-0.49905,1.0971-10.9924-1.26939-13.78919-2.54159c-2.79679-1.27221-3.78125-3.39037-3.00467-5.0976 S63.97218,14.17133,66.76897,15.44353z' })
						),
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M63.58806,26.18957c2.96023-0.82318,13.6936-1.53404,14.01651-0.37284 s-9.23662,6.09337-12.19684,6.91654c-2.96022,0.82318-5.0759-0.16663-5.57838-1.97363 C59.32685,28.95266,60.62783,27.01275,63.58806,26.18957z' })
						),
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M68.05877,36.46616c1.73853-2.53339,9.50384-9.97722,10.4976-9.29525 c0.99377,0.68197-3.15891,10.60497-4.89745,13.13836c-1.73853,2.53339-3.99548,3.13508-5.54192,2.07383 S66.32023,38.99955,68.05877,36.46616z' })
						),
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M78.08919,41.46477c-0.29663-3.0582,0.86713-13.75195,2.06677-13.86831 c1.19963-0.11636,4.39687,10.15439,4.6935,13.21258c0.29663,3.0582-1.04552,4.96985-2.91232,5.15092 S78.38583,44.52296,78.08919,41.46477z' })
						),
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M88.98598,38.8465c-2.193-2.15204-8.17532-11.09199-7.33114-11.95223s9.89532,4.95246,12.08832,7.1045 c2.19301,2.15204,2.39365,4.47917,1.07999,5.81784C93.50949,41.15526,91.17899,40.99854,88.98598,38.8465z' })
						),
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M95.65042,29.83646c-3.06325-0.23892-13.39245-3.24196-13.29873-4.44357 c0.09373-1.20161,10.76363-2.56679,13.82688-2.32786c3.06324,0.23892,4.71279,1.89264,4.56694,3.76252 C100.59967,28.69742,98.71366,30.07538,95.65042,29.83646z' })
						),
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M94.96413,18.65055c-2.50016,1.78599-12.3431,6.12502-13.04369,5.14428 c-0.70058-0.98073,6.59552-8.885,9.09568-10.67099s4.82677-1.57948,5.91699-0.05332 C98.02332,14.59668,97.46429,16.86456,94.96413,18.65055z' })
						),
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('circle', { fill: '#FFEAAE', cx: '79.9096', cy: '25.19523', r: '7.67494' })
						)
					),
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement('path', { fill: '#836EEA', d: 'M105.16225,32.38733c-0.0312-0.2441-0.07249-0.4599-0.12331-0.62179 c-0.30178-0.96542-1.32898-1.50319-2.29449-1.20149c-0.96555,0.30174-1.50349,1.32911-1.20167,2.29449 c0.05119,0.16293,0.14796,0.37002,0.26227,0.58986c-0.22843-0.09572-0.44309-0.17546-0.60927-0.21266 c-0.98684-0.22115-1.96664,0.39934-2.18781,1.38648c-0.22153,0.9868,0.3992,1.96634,1.38639,2.18782 c0.16456,0.03676,0.39036,0.05665,0.63489,0.06749c-0.19804,0.15065-0.36609,0.29598-0.48185,0.42181 c-0.68536,0.7439-0.63766,1.90253,0.10671,2.58792c0.74402,0.68506,1.90265,0.63727,2.58806-0.10667 c0.11467-0.12468,0.24414-0.30244,0.37669-0.50964c0.03123,0.24406,0.07253,0.45985,0.12334,0.62175 c0.30183,0.96538,1.32898,1.50319,2.29453,1.20145s1.50345-1.32907,1.20166-2.29449 c-0.05118-0.16293-0.14796-0.37002-0.26227-0.58985c0.22844,0.09572,0.4431,0.17546,0.60927,0.21266 c0.98684,0.22114,1.96664-0.39934,2.18782-1.38648c0.22153-0.9868-0.3992-1.96634-1.38639-2.18782 c-0.16492-0.0371-0.39037-0.05665-0.6349-0.06749c0.19804-0.15065,0.36609-0.29598,0.48186-0.42181 c0.68536-0.7439,0.63761-1.90248-0.10672-2.58792c-0.74402-0.68506-1.90269-0.63722-2.58805,0.10668 C105.42435,32.00229,105.29484,32.1801,105.16225,32.38733z' }),
						_react2.default.createElement('path', { fill: '#836EEA', d: 'M105.47715,18.87523c0.02438,0.16842,0.08772,0.38868,0.16592,0.62377 c-0.2106-0.13074-0.40978-0.24302-0.56813-0.30614c-0.93968-0.37405-2.00506,0.08422-2.37927,1.02391 c-0.37391,0.94007,0.08448,2.00514,1.02412,2.37923c0.15742,0.06267,0.36948,0.12037,0.61064,0.17015 c-0.21703,0.11606-0.4037,0.2321-0.53668,0.33708c-0.79375,0.62688-0.92944,1.77844-0.30263,2.57244 c0.62685,0.79396,1.77831,0.9293,2.57245,0.30271c0.13403-0.10608,0.29179-0.26256,0.45689-0.4487 c-0.00742,0.24501-0.00507,0.47125,0.01928,0.63829c0.14555,1.00064,1.07523,1.69393,2.0763,1.5482 c1.00106-0.14573,1.69418-1.0755,1.54828-2.07647c-0.02438-0.16842-0.08772-0.38868-0.16592-0.62377 c0.2106,0.13074,0.41014,0.24336,0.56813,0.30614c0.94004,0.37438,2.00506-0.08422,2.37928-1.02391 c0.37426-0.93974-0.08413-2.0048-1.02413-2.37923c-0.15742-0.06267-0.36951-0.12032-0.61033-0.16976 c0.21671-0.11644,0.40339-0.23248,0.53638-0.33746c0.79414-0.62659,0.92943-1.77844,0.30262-2.57245 c-0.62649-0.79362-1.77831-0.9293-2.57245-0.30271c-0.13403,0.10608-0.29179,0.26256-0.45689,0.4487 c0.00777-0.24467,0.00507-0.47125-0.01928-0.63829c-0.14555-1.00064-1.07523-1.69393-2.07629-1.5482 C106.02471,16.94482,105.33125,17.87425,105.47715,18.87523z' }),
						_react2.default.createElement('path', { fill: '#836EEA', d: 'M113.60601,30.8437c0.12698,0.11164,0.30741,0.23724,0.51799,0.36518 c-0.24332,0.03675-0.45817,0.08324-0.61882,0.13726c-0.95824,0.3238-1.47256,1.3632-1.14899,2.32131 c0.32393,0.95845,1.36324,1.47286,2.32148,1.14907c0.16129-0.05468,0.36654-0.15625,0.58388-0.27546 c-0.09071,0.23051-0.16535,0.44699-0.19895,0.61398c-0.1987,0.99186,0.444,1.95682,1.43586,2.15569 c0.9919,0.19883,1.95681-0.44425,2.15587-1.43577c0.03302-0.16568,0.04761-0.39131,0.05299-0.63631 c0.1547,0.1944,0.30392,0.35916,0.43237,0.4721c0.75957,0.66801,1.91695,0.59392,2.58488-0.16566 c0.66797-0.75962,0.59392-1.91678-0.16561-2.58484c-0.12734-0.11197-0.30777-0.23758-0.51799-0.36518 c0.24332-0.03675,0.45816-0.08324,0.61882-0.13726c0.95824-0.3238,1.47256-1.3632,1.14863-2.32164 c-0.32358-0.95811-1.36289-1.47253-2.32113-1.14873c-0.16164,0.05434-0.36658,0.15629-0.58392,0.27551 c0.09075-0.23056,0.1654-0.44704,0.19899-0.61403c0.1987-0.99186-0.44434-1.95716-1.43585-2.15569 c-0.99191-0.19883-1.95717,0.44392-2.15587,1.43577c-0.03302,0.16568-0.04765,0.39135-0.05304,0.63635 c-0.1551-0.1947-0.30428-0.3595-0.43237-0.4721c-0.75954-0.66806-1.91692-0.59396-2.58484,0.16561 C112.77207,29.01814,112.84647,30.17564,113.60601,30.8437z' })
					)
				);
			}
		}]);
	
		return FlowerCrown;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = FlowerCrown;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var King = function (_PositionedGoodyHOC) {
		_inherits(King, _PositionedGoodyHOC);
	
		function King() {
			_classCallCheck(this, King);
	
			return _possibleConstructorReturn(this, (King.__proto__ || Object.getPrototypeOf(King)).apply(this, arguments));
		}
	
		_createClass(King, [{
			key: 'render',
	
			// 8
			value: function render() {
				var style = {
					st36: {
						fill: '#987FEF'
					},
					st72: {
						fill: '#FFEAAE'
					},
					st2: {
						fill: '#FFFFFF'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '32.8059692', cy: '53.3483009' }),
					_react2.default.createElement('path', { style: style.st36, d: 'M51.7131348,41.039669c-0.2718239-10.3747768,18.621727-27.5412445-18.7377701-27.5412445h0.0492706 c-37.3594971,0-18.4659462,17.1664677-18.7377701,27.5412445H51.7131348z' }),
					_react2.default.createElement('path', { style: style.st72, d: 'M60.6269531,39.251194l-5.8085938-1.5058594l4.8359375-18.6577148 c0.7763672-2.9946289-0.7958984-5.2519541-1.8027344-6.3305674c-2.7021484-2.8959961-7.3583984-4.2260742-11.8574219-3.3881836 L33,11.789279L20.0058594,9.3688688c-4.4970703-0.8359375-9.1542969,0.4916992-11.8574219,3.3881836 c-1.0068359,1.0786133-2.5791016,3.3359385-1.8027344,6.3310556l4.8359375,18.6572266L5.3730469,39.251194L0.5371094,20.5934792 c-1.0917969-4.215332,0.0830078-8.5629892,3.2236328-11.9292002c4.1318359-4.4272461,10.7753906-6.4169922,17.3447266-5.1938477 L33,5.6857634l11.8945312-2.215332c6.5693359-1.222168,13.2138672,0.7670898,17.3447266,5.1938477 c3.140625,3.3662109,4.3154297,7.7138681,3.2236328,11.9287119L60.6269531,39.251194z' }),
					_react2.default.createElement('path', { style: style.st72, d: 'M57.2851181,35.3537331C41.1239853,37.3151588,24.86129,37.3195534,8.6903915,35.3664284 l-3.3388672-0.4116211v3.3769531l0.9365234,9.0039062l2.3491211,0.3183594 c7.7207031,1.0039062,15.9714355,1.5053711,24.2595215,1.5053711c8.3261719,0,16.6400146-0.5068359,24.3948975-1.5200195 l2.2965698-0.3007812l1.0398865-8.4736328l0.0204315-3.9194336L57.2851181,35.3537331z' }),
					_react2.default.createElement('rect', { x: '30', y: '7.9982634', style: style.st72, width: '6', height: '30' }),
					_react2.default.createElement('circle', { style: style.st36, cx: '47.8118134', cy: '42.6655006', r: '2.5159504' }),
					_react2.default.createElement('circle', { style: style.st36, cx: '18.7640133', cy: '42.6655006', r: '2.5159504' }),
					_react2.default.createElement('circle', { style: style.st2, cx: '6.4971576', cy: '41.6232643', r: '2.5159504' }),
					_react2.default.createElement('circle', { style: style.st2, cx: '33.1627464', cy: '43.1726456', r: '2.5159504' }),
					_react2.default.createElement('circle', { style: style.st2, cx: '59.5028419', cy: '41.6232643', r: '2.5159504' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M38.2957001,5.6968212c0-2.9247339-2.3709679-5.2956991-5.2957001-5.2956991 s-5.2956982,2.370965-5.2956982,5.2956991H38.2957001z' }),
					_react2.default.createElement('path', { style: style.st72, d: 'M50.293457,39.0851784l-5.8847656-1.1738281l3.7578125-18.8139648 c0.8740234-3.4213877-0.2597656-4.677247-0.6328125-5.0898447c-2.6425781-2.9257812-10.5595703-2.8144531-13.9804688-2.3032227 l-0.8857422,0.0332031l-0.2207031-0.0332031c-2.7246094-0.4008789-11.1484375-0.840332-13.9833984,2.3066406 c-0.3720703,0.4125977-1.5039062,1.6679688-0.6298828,5.0864267l0.0361328,0.15625l3.7216797,18.6577148l-5.8847656,1.1738281 l-3.7060547-18.5825195c-1.3447266-5.3583994,0.3496094-8.6752939,2.0126953-10.5166025 C19.2016602,4.238986,30.5649414,5.3991423,33.0004883,5.723361c2.4287109-0.3237305,13.7958984-1.4829102,18.9863281,4.2626953 c1.6630859,1.8413086,3.3574219,5.1582031,2.0126953,10.5166025L50.293457,39.0851784z' })
				);
			}
		}]);
	
		return King;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = King;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartyHat = function (_PositionedGoodyHOC) {
		_inherits(PartyHat, _PositionedGoodyHOC);
	
		function PartyHat() {
			_classCallCheck(this, PartyHat);
	
			return _possibleConstructorReturn(this, (PartyHat.__proto__ || Object.getPrototypeOf(PartyHat)).apply(this, arguments));
		}
	
		_createClass(PartyHat, [{
			key: 'render',
	
			// 1
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st30: {
						fill: '#C8B8F2'
					},
					st1: {
						fill: '#A2D8C0'
					},
					st13: {
						fill: '#F2CC7B'
					},
					st11: {
						fill: '#FC7E7E'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '31.8727417', cy: '91.439743' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M66.7650146,86.2496185c-21.6400146,6.920166-44.9000244,6.920166-66.5300293,0L13.164917,52.8497162 l2.6101074-6.7299805l1.0899658-2.8300781L33.4949951,0.3096782l16.6400146,42.9699707l0.8299561,2.1401367l2.5,6.4799805 L66.7650146,86.2496185z' }),
					_react2.default.createElement('ellipse', { transform: 'matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -3.9746635 0.6556352)', style: style.st30, cx: '10.7373371', cy: '77.4687042', rx: '3.6241295', ry: '3.6241295' }),
					_react2.default.createElement('ellipse', { transform: 'matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -3.326685 1.2937791)', style: style.st1, cx: '23.4465237', cy: '65.2117081', rx: '3.6241295', ry: '3.6241295' }),
					_react2.default.createElement('ellipse', { transform: 'matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -4.0717745 1.8501824)', style: style.st13, cx: '33.8727417', cy: '79.9507217', rx: '3.6241295', ry: '3.6241295' }),
					_react2.default.createElement('path', { style: style.st11, d: 'M18.2850342,49.3697357c0.0999756,2-1.4300537,3.6999512-3.4300537,3.8100586 c-0.5999756,0.0300293-1.1800537-0.0900879-1.6900635-0.3300781l2.6101074-6.7299805 C17.164917,46.5596771,18.2049561,47.8196869,18.2850342,49.3697357z' }),
					_react2.default.createElement('ellipse', { transform: 'matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -1.7507921 1.3185166)', style: style.st30, cx: '24.7145786', cy: '34.6389046', rx: '3.6241295', ry: '3.6241295' }),
					_react2.default.createElement('ellipse', { transform: 'matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -2.5427375 1.8304178)', style: style.st13, cx: '34.2536621', cy: '50.2650528', rx: '3.6241295', ry: '3.6241295' }),
					_react2.default.createElement('ellipse', { transform: 'matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -3.2864468 2.3973894)', style: style.st11, cx: '44.8856812', cy: '64.9825668', rx: '3.6241295', ry: '3.6241295' }),
					_react2.default.createElement('path', { style: style.st1, d: 'M53.4649658,51.899765c-0.0400391,0.0100098-0.0799561,0.0100098-0.1199951,0.0100098 c-2,0.0998535-3.6999512-1.4299316-3.8099365-3.4299316c-0.0600586-1.2402344,0.5100098-2.3701172,1.4299316-3.0600586 L53.4649658,51.899765z' }),
					_react2.default.createElement('ellipse', { transform: 'matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -3.8894804 3.0455716)', style: style.st30, cx: '57.1641846', cy: '77.0104218', rx: '3.6241295', ry: '3.6241295' }),
					_react2.default.createElement('ellipse', { transform: 'matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -1.7152613 2.2394111)', style: style.st11, cx: '42.6052055', cy: '34.4097633', rx: '3.6241295', ry: '3.6241295' }),
					_react2.default.createElement('ellipse', { transform: 'matrix(0.9986735 -0.0514906 0.0514906 0.9986735 -0.9181879 1.7705231)', style: style.st1, cx: '33.903492', cy: '18.705595', rx: '3.6241295', ry: '3.6241295' })
				);
			}
		}]);
	
		return PartyHat;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = PartyHat;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Princess = function (_PositionedGoodyHOC) {
		_inherits(Princess, _PositionedGoodyHOC);
	
		function Princess() {
			_classCallCheck(this, Princess);
	
			return _possibleConstructorReturn(this, (Princess.__proto__ || Object.getPrototypeOf(Princess)).apply(this, arguments));
		}
	
		_createClass(Princess, [{
			key: 'render',
	
			// 7
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st72: {
						fill: '#FFEAAE'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '27.1190453', cy: '29.5497303' }),
					_react2.default.createElement('path', { style: style.st72, d: 'M0.2587006,13.3136253c14.7030487,0,27.7795486-13.1139326,27.7795486-13.1139326h0.2204514 c0,0,13.4825974,13.1972656,27.4825974,13.1972656l-1.8376045,10.1430674l-1.259449,0.3007812 c-7.7548828,1.0131836-16.0501671,1.5200195-24.376339,1.5200195c-8.2880859,0-16.5295391-0.5014648-24.2502422-1.5053711 L2.673183,23.537096L0.2587006,13.3136253z' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M30.2737331,12.0654554l-0.0000038,0.0000048c-1.2203884,1.2203865-3.1990261,1.2203865-4.4194145,0 l-0.0000038-0.0000048c-1.2203865-1.2203875-1.2203865-3.1990261,0-4.4194131l0.0000038-0.0000043 c1.2203884-1.2203875,3.1990261-1.2203875,4.4194145,0l0.0000038,0.0000043 C31.4941196,8.8664293,31.4941196,10.845068,30.2737331,12.0654554z' })
				);
			}
		}]);
	
		return Princess;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = Princess;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ranger = function (_PositionedGoodyHOC) {
		_inherits(Ranger, _PositionedGoodyHOC);
	
		function Ranger() {
			_classCallCheck(this, Ranger);
	
			return _possibleConstructorReturn(this, (Ranger.__proto__ || Object.getPrototypeOf(Ranger)).apply(this, arguments));
		}
	
		_createClass(Ranger, [{
			key: 'render',
			value: function render() {
				var style = {
					st40: {
						fill: '#D1AF79'
					},
					st157: {
						fill: '#CEA365'
					},
					st24: {
						fill: '#5E5E5E'
					}
				};
	
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '71.0000153', cy: '56.2328835' }),
					_react2.default.createElement('path', { style: style.st40, d: 'M108.6850586,37.5460205v-6.7702637c0-3.8115234-1.7114258-7.4216309-4.6618652-9.8347168 L82.4348145,3.2872314c-2.2692871-1.8557129-5.1105957-2.8693848-8.0422363-2.8693848H71h-3.3925781 c-2.9316406,0-5.7729492,1.013916-8.0422363,2.8693848L37.9769287,20.94104 c-2.9505615,2.4130859-4.6619873,6.0231934-4.6619873,9.8347168v6.7702637 c-20.2653809,2.2805176-33.0983887,6.3823242-33.0983887,11.064209v1.0007324 c0,7.1638184,30.0327148,12.9711914,70.7834473,12.9711914s70.7834473-5.807373,70.7834473-12.9711914v-1.0007324 C141.7834473,43.9283447,128.9504395,39.8267822,108.6850586,37.5460205z' }),
					_react2.default.createElement('circle', { style: style.st157, cx: '71.0000153', cy: '28.0129185', r: '2' }),
					_react2.default.createElement('circle', { style: style.st157, cx: '66.9968109', cy: '34.6384544', r: '2' }),
					_react2.default.createElement('circle', { style: style.st157, cx: '75.003212', cy: '34.6384544', r: '2' }),
					_react2.default.createElement('path', { style: style.st157, d: 'M55.4376221,21.4908447c5.2414551-4.3552246,7.4835205-11.7021484,7.6231689-20.2216797 c-1.2556152,0.4814453-2.439209,1.1542969-3.4956055,2.0180664L47.0039062,13.5592041 c-3.1057129,2.5637207-6.1898193,5.0942383-9.2636719,7.5986328c-1.4025879,1.2075195-2.5109863,2.6865234-3.2651367,4.3337402 C37.335083,27.0640869,45.2526855,29.9537354,55.4376221,21.4908447z' }),
					_react2.default.createElement('path', { style: style.st157, d: 'M104.2596436,21.1578369c-3.0726318-2.503418-6.1555176-5.0332031-9.2601318-7.5957031 L82.4348145,3.2872314c-1.0563965-0.8637695-2.2398682-1.536377-3.4954834-2.0180664 c0.1395264,8.5195312,2.3817139,15.8664551,7.6231689,20.2216797c10.1848145,8.4628906,18.1025391,5.5732422,20.9624023,4.0007324 C106.770874,23.8443604,105.6623535,22.3653564,104.2596436,21.1578369z' }),
					_react2.default.createElement('path', { style: style.st24, d: 'M33.9196777,41.7418213l-0.6047363-0.1062012v7.0993652 c2.8123779,0.4389648,15.3067627,2.1674805,37.6848145,2.1674805c22.3778076,0,34.8723145-1.7282715,37.6853027-2.1674805 v-7.0986328l-0.6022949,0.1049805c-0.1240234,0.0214844-12.6953125,2.1611328-37.0830078,2.1611328 C46.7155762,43.9024658,34.1481934,41.7808838,33.9196777,41.7418213z' })
				);
			}
		}]);
	
		return Ranger;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = Ranger;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC3 = __webpack_require__(6);
	
	var _PositionedGoodyHOC4 = _interopRequireDefault(_PositionedGoodyHOC3);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '54.34491', cy: '70.13715' }),
						_react2.default.createElement('circle', { fill: '#D1AF79', cx: '55.45789', cy: '8.15383', r: '7.21167' }),
						_react2.default.createElement('path', { fill: '#D1AF79', d: 'M55.53143,46.93857c30.58903,0,46.57311,8.47895,54.56702,24.87725 c0.46561,0.95515,0.09139,2.15963-0.81834,2.5372c-3.48103,1.44474-44.50916,9.20248-52.47595,10.70139 c-0.8861,0.16672-1.78472,0.16689-2.67088,0.0005C46.1673,83.55922,5.14824,75.81929,1.65135,74.37982 c-0.91846-0.37807-1.30094-1.59112-0.83702-2.55795C8.68041,55.42865,24.93669,46.93857,55.53143,46.93857' }),
						_react2.default.createElement('path', { fill: '#D1AF79', d: 'M98.25116,57.63715H12.66461l3.22204-20.48726c1.13537-6.86683,7.58776-29.3209,39.54546-29.3209 s38.46094,22.44992,39.597,29.3209L98.25116,57.63715z' }),
						_react2.default.createElement('path', { fill: '#75C69F', d: 'M85.63464,50.79567c-0.68115-2.61401-0.80676-4.83521-0.80261-6.96436 c0.03418-2.10791,0.2644-4.07715,0.68213-5.91382c0.82275-3.68213,2.30664-6.89624,4.26831-9.7727 c1.96118-2.87646,4.45764-5.37427,7.64233-7.38501c1.59412-1.00415,3.36829-1.88086,5.36877-2.59741 c1.02112-0.34351,2.0636-0.67212,3.21643-0.92236c1.12524-0.26978,2.37561-0.45117,3.75305-0.54248 c0.37207,1.32935,0.61707,2.56885,0.73694,3.71973c0.14746,1.17041,0.18457,2.2627,0.20044,3.34009 c-0.01025,2.12476-0.24683,4.0896-0.66345,5.927c-0.83667,3.67236-2.36169,6.85742-4.42175,9.66406 c-2.05994,2.80664-4.59729,5.27539-7.7959,7.27637c-1.59314,1.00488-3.37354,1.8772-5.3501,2.61084 C90.46276,49.94777,88.32641,50.56837,85.63464,50.79567z' }),
						_react2.default.createElement('path', { fill: '#66AA88', d: 'M109.76305,16.69752c0.37207,1.32935,0.61707,2.56885,0.73694,3.71973 c0.14746,1.17041,0.18457,2.2627,0.20044,3.34009c-0.01025,2.12476-0.24683,4.0896-0.66345,5.927 c-0.83667,3.67236-2.36169,6.85742-4.42175,9.66406c-2.05994,2.80664-4.59729,5.27539-7.7959,7.27637 c-1.59314,1.00488-3.37354,1.8772-5.3501,2.61084c-2.00647,0.71216-4.14282,1.33276-6.83459,1.56006' }),
						_react2.default.createElement('path', { fill: '#75C69F', d: 'M110.19787,28.87257c0.24731-1.2749,0.40796-2.61133,0.46802-4.01855l-7.91322,3.87428 c-0.38662,0.18929-0.22589,0.77333,0.20314,0.73815L110.19787,28.87257z' }),
						_react2.default.createElement('path', { fill: '#75C69F', d: 'M108.0061,35.4048c0.55676-1.12891,1.03625-2.31226,1.43225-3.55493l-0.01074-0.06299l-8.6692,0.81651 c-0.43028,0.04053-0.48436,0.64713-0.06802,0.76312L108.0061,35.4048z' }),
						_react2.default.createElement('polygon', { fill: '#AD6636', points: '12.71546,57.31354 98.20032,57.31354 96.62756,47.31354 14.28821,47.31354 \t' })
					)
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC4.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					{ transform: 'scale(0.75) translate(18.5 28)' },
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '57.34491', cy: '78.13715' }),
					_react2.default.createElement('circle', { fill: '#D1AF79', cx: '55.45789', cy: '8.15383', r: '7.21167' }),
					_react2.default.createElement('path', { fill: '#D1AF79', d: 'M55.53143,46.93857c30.58903,0,46.57311,8.47895,54.56702,24.87725 c0.46561,0.95515,0.09139,2.15963-0.81834,2.5372c-3.48103,1.44474-44.50916,9.20248-52.47595,10.70139 c-0.8861,0.16672-1.78472,0.16689-2.67088,0.0005C46.1673,83.55922,5.14824,75.81929,1.65135,74.37982 c-0.91846-0.37807-1.30094-1.59112-0.83702-2.55795C8.68041,55.42865,24.93669,46.93857,55.53143,46.93857' }),
					_react2.default.createElement('path', { fill: '#D1AF79', d: 'M98.25116,57.63715H12.66461l3.22204-20.48726c1.13537-6.86683,7.58776-29.3209,39.54546-29.3209 s38.46094,22.44992,39.597,29.3209L98.25116,57.63715z' }),
					_react2.default.createElement('path', { fill: '#75C69F', d: 'M85.63464,50.79567c-0.68115-2.61401-0.80676-4.83521-0.80261-6.96436 c0.03418-2.10791,0.2644-4.07715,0.68213-5.91382c0.82275-3.68213,2.30664-6.89624,4.26831-9.7727 c1.96118-2.87646,4.45764-5.37427,7.64233-7.38501c1.59412-1.00415,3.36829-1.88086,5.36877-2.59741 c1.02112-0.34351,2.0636-0.67212,3.21643-0.92236c1.12524-0.26978,2.37561-0.45117,3.75305-0.54248 c0.37207,1.32935,0.61707,2.56885,0.73694,3.71973c0.14746,1.17041,0.18457,2.2627,0.20044,3.34009 c-0.01025,2.12476-0.24683,4.0896-0.66345,5.927c-0.83667,3.67236-2.36169,6.85742-4.42175,9.66406 c-2.05994,2.80664-4.59729,5.27539-7.7959,7.27637c-1.59314,1.00488-3.37354,1.8772-5.3501,2.61084 C90.46276,49.94777,88.32641,50.56837,85.63464,50.79567z' }),
					_react2.default.createElement('path', { fill: '#66AA88', d: 'M109.76305,16.69752c0.37207,1.32935,0.61707,2.56885,0.73694,3.71973 c0.14746,1.17041,0.18457,2.2627,0.20044,3.34009c-0.01025,2.12476-0.24683,4.0896-0.66345,5.927 c-0.83667,3.67236-2.36169,6.85742-4.42175,9.66406c-2.05994,2.80664-4.59729,5.27539-7.7959,7.27637 c-1.59314,1.00488-3.37354,1.8772-5.3501,2.61084c-2.00647,0.71216-4.14282,1.33276-6.83459,1.56006' }),
					_react2.default.createElement('path', { fill: '#75C69F', d: 'M110.19787,28.87257c0.24731-1.2749,0.40796-2.61133,0.46802-4.01855l-7.91322,3.87428 c-0.38662,0.18929-0.22589,0.77333,0.20314,0.73815L110.19787,28.87257z' }),
					_react2.default.createElement('path', { fill: '#75C69F', d: 'M108.0061,35.4048c0.55676-1.12891,1.03625-2.31226,1.43225-3.55493l-0.01074-0.06299l-8.6692,0.81651 c-0.43028,0.04053-0.48436,0.64713-0.06802,0.76312L108.0061,35.4048z' }),
					_react2.default.createElement('polygon', { fill: '#AD6636', points: '12.71546,57.31354 98.20032,57.31354 96.62756,47.31354 14.28821,47.31354 \t' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC4.default);
	
	function ShrimponBarbie(props) {
		var shrimponBarbies = {
			Cat: Cat,
			Tortoise: Tortoise
		};
	
		var ThisShrimponBarbie = shrimponBarbies[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisShrimponBarbie)) {
			return null;
		}
	
		return _react2.default.createElement(ThisShrimponBarbie, props);
	}
	
	exports.default = ShrimponBarbie;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sombrero = function (_PositionedGoodyHOC) {
		_inherits(Sombrero, _PositionedGoodyHOC);
	
		function Sombrero() {
			_classCallCheck(this, Sombrero);
	
			return _possibleConstructorReturn(this, (Sombrero.__proto__ || Object.getPrototypeOf(Sombrero)).apply(this, arguments));
		}
	
		_createClass(Sombrero, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '95.62737', cy: '54.79403' }),
					_react2.default.createElement('path', { fill: '#FF9D5A', d: 'M96.62782,40.91937c-26.72363,0-49.50966-0.81818-65.89526-2.36634 C6.17045,36.2323,4.92638,33.09066,4.92638,32.48447s1.24407-3.74783,25.80619-6.06825 c16.3856-1.54847,39.17252-2.36665,65.89526-2.36665s49.50876,0.81818,65.89435,2.36665 c24.56212,2.32042,25.8062,5.46206,25.8062,6.06825s-1.24408,3.74783-25.8062,6.06856 C146.13748,40.10119,123.35146,40.91937,96.62782,40.91937z' }),
					_react2.default.createElement('path', { fill: '#FC5959', d: 'M31.15308,30.86395c16.24463-1.53519,38.8855-2.34668,65.47478-2.34668 c26.58846,0,49.22906,0.81149,65.47395,2.34668c5.58394,0.52764,9.82793,1.08717,13.0461,1.62053h13.18051 c0-0.60617-1.24423-3.74798-25.80641-6.06821c-16.38559-1.54855-39.17153-2.36659-65.89415-2.36659 c-26.72289,0-49.50965,0.81804-65.89525,2.36659C6.17043,28.73651,4.92646,31.87832,4.92646,32.48449h13.18025 C21.32488,31.95113,25.56887,31.39159,31.15308,30.86395z' }),
					_react2.default.createElement('path', { fill: '#FFCE8D', d: 'M130.78563,46.09406c0-18.32381-15.82668-45.52703-34.15049-45.52703H96.6196 c-18.32381,0-34.15048,27.20323-34.15048,45.52703H130.78563z' }),
					_react2.default.createElement('path', { fill: '#FFCE8D', d: 'M162.52203,38.02269c-16.38451,1.41298-39.17043,2.15953-65.89412,2.15953 s-49.50961-0.74656-65.8952-2.15953C6.17056,35.90472,4.92632,33.0377,4.92632,32.4845 c0,18.03426,10.74112,31.23459,91.70106,31.23459s91.70104-13.20033,91.70104-31.23459 C188.32841,33.0377,187.08418,35.90472,162.52203,38.02269z' }),
					_react2.default.createElement('circle', { fill: '#FFFFFF', cx: '47.98237', cy: '46.88966', r: '3.56067' }),
					_react2.default.createElement('circle', { fill: '#FFFFFF', cx: '72.30487', cy: '47.83371', r: '3.56067' }),
					_react2.default.createElement('circle', { fill: '#FFFFFF', cx: '24.77766', cy: '45.14322', r: '3.56067' }),
					_react2.default.createElement('circle', { fill: '#FFFFFF', cx: '3.80853', cy: '41.63413', r: '3.56068' }),
					_react2.default.createElement('circle', { fill: '#FFFFFF', cx: '96.62737', cy: '48.20508', r: '3.56067' }),
					_react2.default.createElement('circle', { fill: '#FFFFFF', cx: '145.27237', cy: '46.88966', r: '3.56067' }),
					_react2.default.createElement('circle', { fill: '#FFFFFF', cx: '120.94987', cy: '47.83371', r: '3.56067' }),
					_react2.default.createElement('circle', { fill: '#FFFFFF', cx: '168.47708', cy: '45.14322', r: '3.56067' }),
					_react2.default.createElement('circle', { fill: '#FFFFFF', cx: '189.44621', cy: '41.63413', r: '3.56068' }),
					_react2.default.createElement('path', { fill: '#FC5959', d: 'M162.10181,34.1053c-16.24489,1.53491-38.8855,2.34641-65.47395,2.34641 c-26.58819,0-49.22906-0.8115-65.47505-2.34641c-5.58394-0.52764-9.82792-1.08745-13.04609-1.62081H4.92646 c0,0.60617,1.24397,3.74771,25.80614,6.06849c16.3856,1.54827,39.17154,2.36631,65.89525,2.36631 c26.72343,0,49.50964-0.81804,65.89415-2.36631c24.56218-2.32078,25.80641-5.46232,25.80641-6.06849H175.1479 C171.92973,33.01785,167.68575,33.57766,162.10181,34.1053z' })
				);
			}
		}]);
	
		return Sombrero;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = Sombrero;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = function (_PositionedGoodyHOC) {
		_inherits(Spinner, _PositionedGoodyHOC);
	
		function Spinner() {
			_classCallCheck(this, Spinner);
	
			return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
		}
	
		_createClass(Spinner, [{
			key: 'render',
	
			// 11
			value: function render() {
				var style = {
					st72: {
						fill: '#FFEAAE'
					},
					st20: {
						fill: '#75C69F'
					},
					st25: {
						fill: '#FC5959'
					},
					st50: {
						fill: '#238BD8'
					},
					st115: {
						fill: '#F2F2F2'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '45.6753731', cy: '60.6846466' }),
					_react2.default.createElement('path', { style: style.st72, d: 'M12.8749523,51.7303886c0,3.1619453,14.859787,5.7252083,33.4414062,5.7252083 s32.4812698-2.5632629,32.4812698-5.7252083v-1.2722664c0-18.2690125-13.8996506-33.0789719-32.4812698-33.0789719 S12.7731562,32.1891098,12.7731562,50.4581223L12.8749523,51.7303886z' }),
					_react2.default.createElement('path', { style: style.st20, d: 'M47.0884018,17.3790455c-19.3530293,0-34.9358139,14.8100643-34.9358139,33.0790787l0.1060219,1.2722664 c0,2.1499062,1.9470673,3.3087311,12.6106405,4.287735C25.245472,34.0264244,31.6117287,20.7818718,47.0884018,17.3790455z' }),
					_react2.default.createElement('path', { style: style.st25, d: 'M45.7976303,17.3790455c19.875-0.1694336,34.9358063,14.8100643,34.9358063,33.0790787 l-0.1060181,1.2722664c0,2.1499062-10.791214,4.0229225-21.4547882,5.0019264 C58.7964096,34.7406158,55.67556,23.444231,45.7976303,17.3790455z' }),
					_react2.default.createElement('path', { style: style.st50, d: 'M71.8672943,55.0700951c1.1573486,0.0527344-3.9357529,2.8846321-16.569664,6.931263 c-7.7006836,2.4665527-25.2500019-2.166748-34.25-2.666748S3.3689106,61.3919373,0.9468651,61.6978798 c-0.6465269,0.081665-0.9431157-0.7743034-0.3897915-1.1185417l11.7015371-8.8489494 c0,0,12.6187162-2.6598434,23.5390205-2.3957787C49.8369865,49.674099,71.8672943,55.0700951,71.8672943,55.0700951z' }),
					_react2.default.createElement('path', { style: style.st50, d: 'M46.2263412,18.8346119c-0.828125,0-1.5-0.6713867-1.5-1.5v-10c0-0.8286133,0.671875-1.5,1.5-1.5 s1.5,0.6713867,1.5,1.5v10C47.7263412,18.1632252,47.0544662,18.8346119,46.2263412,18.8346119z' }),
					_react2.default.createElement('path', { style: style.st115, d: 'M73.7155533,7.3346114c0-3.8961933-3.5611725-7.0546818-11.5550842-7.0546818 S44.7670288,7.3346114,44.7670288,7.3346114s9.3995247,7.0546813,17.3934402,7.0546813 S73.7155533,11.2308044,73.7155533,7.3346114z' }),
					_react2.default.createElement('path', { style: style.st115, d: 'M18.7376862,7.3346114c0,3.896193,3.5611687,7.0546813,11.5550823,7.0546813 s17.3934383-7.0546813,17.3934383-7.0546813s-9.3995247-7.0546818-17.3934383-7.0546818 S18.7376862,3.4384181,18.7376862,7.3346114z' }),
					_react2.default.createElement('circle', { style: style.st50, cx: '46.2266197', cy: '7.3346114', r: '3.5319245' })
				);
			}
		}]);
	
		return Spinner;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = Spinner;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC10 = __webpack_require__(6);
	
	var _PositionedGoodyHOC11 = _interopRequireDefault(_PositionedGoodyHOC10);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
	
			// 10
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st3: {
						fill: '#A5C6EF'
					},
					st11: {
						fill: '#FC7E7E'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '92.5170654', cy: '4.8880091' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M185.7677765,38.6758385c-0.1119385-1.435009-0.2337799-2.8881111-0.3652344-4.3551292 c-0.3523102-3.9318104-0.7736664-7.9635563-1.2588348-12.0147591c-0.1005707-0.8397865-0.2038727-1.6804104-0.3098755-2.5211544 c-0.5310364-4.2116737-3.5700684-7.6716328-7.6672363-8.7822161 C163.1239624,7.4672256,132.2688293,0.4344695,93.2000732,0.4344695c-39.1307144,0-70.210907,7.0583935-83.2998581,10.5857763 c-4.0888166,1.1019077-7.1133413,4.5726652-7.6438208,8.7740011c-0.6461701,5.1175919-1.446764,13.1722374-2.0156126,18.9069748 c-0.3170349,3.1961288,2.7701993,5.6533089,5.8141241,4.6284866l7.1912231-2.4211273 c0.320797-0.1077385,32.5995941-10.7906799,79.9539413-10.7906799c46.9620514,0,79.3055878,10.678112,79.6022339,10.7776375 c0,0,3.6892395,1.2011604,7.1979065,2.3298683C182.9946747,44.188694,186.0124359,41.8118973,185.7677765,38.6758385z' }),
					_react2.default.createElement('path', { style: style.st3, d: 'M1.9424427,22.4024754c-0.2307129,1.9890137-0.4714355,4.2119141-0.7087402,6.479248l1.3132324-0.4428711 c0.3779297-0.1274414,38.3486328-12.7324228,90.6533203-12.7324228s90.2753906,12.6049814,90.6533203,12.7324228 l1.0102539,0.3408203c-0.22229-2.1455078-0.4604492-4.3049316-0.7200928-6.4736328v-0.0002441 c-7.810791-2.3962402-43.6652832-12.5358896-90.9434814-12.5358896C45.2651978,9.769906,9.067687,20.1947117,1.9424427,22.4024754 z' }),
					_react2.default.createElement('path', { style: style.st11, d: 'M1.3313587,27.9530125c-0.2280273,2.159668-0.4539795,4.3762188-0.6652832,6.4809551l1.8818359-0.6362305 c0.3769531-0.1274414,38.2792969-12.73242,90.6523438-12.73242c52.3046875,0,90.2753906,12.6054668,90.6533203,12.7329082 l1.5489502,0.5224609c-0.1907959-2.128418-0.4053955-4.2885723-0.6357422-6.4628887 c-6.3265381-1.9816895-42.8981934-12.7290049-91.5665283-12.7290049 C43.6712036,15.1287928,6.6746202,26.2581882,1.3313587,27.9530125z' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC11.default);
	
	var LilDoggo = function (_PositionedGoodyHOC2) {
		_inherits(LilDoggo, _PositionedGoodyHOC2);
	
		function LilDoggo() {
			_classCallCheck(this, LilDoggo);
	
			return _possibleConstructorReturn(this, (LilDoggo.__proto__ || Object.getPrototypeOf(LilDoggo)).apply(this, arguments));
		}
	
		_createClass(LilDoggo, [{
			key: 'render',
	
			// 10
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st3: {
						fill: '#A5C6EF'
					},
					st11: {
						fill: '#FC7E7E'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '79.5', cy: '4.8880091' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M158.5153046,38.6758385c-0.0953522-1.435009-0.1991425-2.8881111-0.3111115-4.3551292 c-0.3000946-3.9318104-0.6590118-7.9635563-1.0722656-12.0147591c-0.0856628-0.8397865-0.1736603-1.6804104-0.2639618-2.5211544 c-0.4523315-4.2116737-3.0409393-7.6716328-6.5308838-8.7822161 c-11.1096344-3.5353541-37.3918076-10.5681105-70.670311-10.5681105c-33.3312683,0-59.8051605,7.0583935-70.9542389,10.5857763 c-3.4828262,1.1019077-6.0590954,4.5726652-6.5109539,8.7740011c-0.5504034,5.1175919-1.2323437,13.1722374-1.7168849,18.9069748 c-0.2700481,3.1961288,2.3596365,5.6533089,4.9524302,4.6284866l6.1254334-2.4211273 c0.2732534-0.1077385,27.7681084-10.7906799,68.1042099-10.7906799c40.0019455,0,67.5519485,10.678112,67.8046188,10.7776375 c0,0,3.1424866,1.2011604,6.131134,2.3298683C156.153183,44.188694,158.7236938,41.8118973,158.5153046,38.6758385z' }),
					_react2.default.createElement('path', { style: style.st3, d: 'M1.9341582,22.4024754c-0.1965196,1.9890137-0.4015656,4.2119141-0.6037,6.479248l1.1186023-0.4428711 c0.3219178-0.1274414,32.6651001-12.7324228,77.2178726-12.7324228s76.8959503,12.6049814,77.217865,12.7324228 l0.8605194,0.3408203c-0.1893311-2.1455078-0.3921967-4.3049316-0.6133575-6.4736328v-0.0002441 C150.478775,19.9095554,119.9381714,9.769906,79.6669312,9.769906C38.8361778,9.769906,8.0033913,20.1947117,1.9341582,22.4024754 z' }),
					_react2.default.createElement('path', { style: style.st11, d: 'M1.4136411,27.9530125c-0.1942321,2.159668-0.3866966,4.3762188-0.5666836,6.4809551l1.6029348-0.6362305 c0.3210859-0.1274414,32.6060371-12.73242,77.217041-12.73242c44.5527649,0,76.8959503,12.6054668,77.217865,12.7329082 l1.3193817,0.5224609c-0.1625214-2.128418-0.3453064-4.2885723-0.5415192-6.4628887 c-5.3889008-1.9816895-36.5403824-12.7290049-77.9957275-12.7290049 C37.4784241,15.1287928,5.9649944,26.2581882,1.4136411,27.9530125z' })
				);
			}
		}]);
	
		return LilDoggo;
	}(_PositionedGoodyHOC11.default);
	
	var TuxedoBird = function (_PositionedGoodyHOC3) {
		_inherits(TuxedoBird, _PositionedGoodyHOC3);
	
		function TuxedoBird() {
			_classCallCheck(this, TuxedoBird);
	
			return _possibleConstructorReturn(this, (TuxedoBird.__proto__ || Object.getPrototypeOf(TuxedoBird)).apply(this, arguments));
		}
	
		_createClass(TuxedoBird, [{
			key: 'render',
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st3: {
						fill: '#A5C6EF'
					},
					st11: {
						fill: '#FC7E7E'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '56.0041687', cy: '8.1188641' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M114.5945511,27.6726074c-0.2905884-2.0812988-0.6337891-3.2333984-0.6337891-3.2333984l-0.7873535-0.3125 c-0.2321777-0.0922852-23.5791016-9.2075195-55.8395958-9.2075195c-0.0099487,0-0.0196533,0.0002441-0.0296021,0.0002441 s-0.0196533-0.0002441-0.0296021-0.0002441c-32.260498,0-55.6074219,9.1152344-55.8395996,9.2075195l-0.7873535,0.3125 c0,0-0.3432007,1.1520996-0.6337891,3.2333984c-0.1953125,2.3112793,1.7063599,4.0883789,3.5813599,3.347168l4.4296269-1.7509766 c0.1975708-0.0778809,20.0805054-7.8032227,49.2496338-7.8032227c0.0100098,0,0.0197144,0.0002441,0.0297241,0.0002441 s0.0197144-0.0002441,0.0297241-0.0002441c29.1691246,0,49.0520592,7.7253418,49.24963,7.8032227l4.4296265,1.7509766 C112.8881912,31.7609863,114.7898636,29.9838867,114.5945511,27.6726074z' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M108.1357498,11.732666c-2.5525513-3.6206055-6.3862305-6.1191406-10.7012329-7.1220703 C87.5692215,2.3181152,73.5776443,0,57.3339348,0c-0.0099487,0-0.0197754,0.0002441-0.0297241,0.0002441 S57.2844353,0,57.2744865,0C41.0307732,0,27.039196,2.3181152,17.1739006,4.6105957 C12.8588982,5.6135254,9.025219,8.1120605,6.4726672,11.732666c-0.7529297,1.0678711-2.0202637,3.1784668-1.8945312,2.9619141 c8.3117065-2.65625,27.9640503-7.9436035,52.6964722-7.9436035c0.0099487,0,0.0196533,0.0002441,0.0296021,0.0002441 s0.0196533-0.0002441,0.0296021-0.0002441c24.7324181,0,44.3847618,5.2873535,52.6964684,7.9436035 C110.1560135,14.9111328,108.8886795,12.8005371,108.1357498,11.732666z' }),
					_react2.default.createElement('path', { style: style.st3, d: 'M111.5015335,17.5119629c-0.0650635-0.1369629-0.1283569-0.2773438-0.194397-0.4121094 c-0.1558838-0.3208008-0.3151245-0.6328125-0.475647-0.9406738c-0.1416016-0.2697754-0.2846069-0.5339355-0.428894-0.7939453 c-0.1239624-0.2241211-0.246582-0.4541016-0.3723145-0.6706543c-8.3117065-2.65625-27.9640503-7.9436035-52.6964684-7.9436035 c-0.0099487,0-0.0196533,0.0002441-0.0296021,0.0002441s-0.0196533-0.0002441-0.0296021-0.0002441 c-24.7324219,0-44.3847656,5.2873535-52.6964722,7.9436035c-0.1257324,0.2165527-0.2483521,0.4465332-0.3723145,0.6706543 c-0.1442871,0.2600098-0.2872925,0.5241699-0.428894,0.7939453c-0.1605225,0.3078613-0.3197632,0.619873-0.475647,0.9406738 c-0.06604,0.1347656-0.1293335,0.2751465-0.194397,0.4121094c-0.2745972,0.5825195-0.538147,1.1870117-0.7926636,1.8078613 c6.4344487-2.2160645,27.5838623-8.6936035,54.9603882-8.6936035c0.0099487,0,0.0196533,0.0002441,0.0296021,0.0002441 s0.0196533-0.0002441,0.0296021-0.0002441c27.3765221,0,48.5259361,6.4775391,54.9603844,8.6936035 C112.0396805,18.6989746,111.7761307,18.0944824,111.5015335,17.5119629z' }),
					_react2.default.createElement('path', { style: style.st11, d: 'M113.2225418,21.8344727c-0.010498-0.0319824-0.0210571-0.0639648-0.0315552-0.0959473 c-0.194458-0.5930176-0.4143066-1.1542969-0.6323242-1.7177734c-0.069519-0.1796875-0.1298218-0.3708496-0.2014771-0.5473633 c-0.020813-0.0515137-0.0419922-0.1025391-0.0629883-0.1535645c-6.4344482-2.2160645-27.5838623-8.6936035-54.9603844-8.6936035 c-0.0099487,0-0.0196533,0.0002441-0.0296021,0.0002441s-0.0196533-0.0002441-0.0296021-0.0002441 c-27.3765259,0-48.5259399,6.4775391-54.9603882,8.6936035c-0.0209961,0.0510254-0.0421753,0.1020508-0.0629883,0.1535645 c-0.0716553,0.1765137-0.131958,0.3676758-0.2014771,0.5473633c-0.2180176,0.5634766-0.4378662,1.1247559-0.6323242,1.7177734 c-0.010498,0.0319824-0.0210571,0.0639648-0.0315552,0.0959473c-0.2727661,0.8395996-0.5214233,1.7070312-0.7382202,2.6047363 l0.7873535-0.3125c0.2321777-0.0922852,23.5791016-9.2075195,55.8395996-9.2075195 c0.0099487,0,0.0196533,0.0002441,0.0296021,0.0002441s0.0196533-0.0002441,0.0296021-0.0002441 c32.2604942,0,55.6074181,9.1152344,55.8395958,9.2075195l0.7873535,0.3125 C113.7439651,23.5415039,113.4953079,22.6740723,113.2225418,21.8344727z' })
				);
			}
		}]);
	
		return TuxedoBird;
	}(_PositionedGoodyHOC11.default);
	
	var Tortoise = function (_PositionedGoodyHOC4) {
		_inherits(Tortoise, _PositionedGoodyHOC4);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st3: {
						fill: '#A5C6EF'
					},
					st11: {
						fill: '#FC7E7E'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '30.0382576', cy: '13.0568066' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M50.8361206,0.659043c-3.147686,0.5238518-6.4787979,1.1161793-10.0095253,1.5138811 C29.9493179,3.39851,20.505518,3.0843146,13.5244579,2.4003196c-2.7943077-0.2737825-5.5940394,0.7394123-7.497828,2.8030744 C4.5429235,6.8116965,3.2142484,8.646533,2.0455906,10.7100334c-0.5690253,1.0045242-1.0968118,2.0596428-1.5849936,3.1652393 c-0.9109621,2.063076,0.3581067,4.4352665,2.5788655,4.8281593c7.6437669,1.3523216,24.9448395,2.3591213,39.727562,0.6938572 c7.1283875-0.803091,15.6455116-2.4009781,20.6940727-3.8030882c2.1795044-0.6053009,3.3574371-2.9666605,1.5785141-5.5859938 c-1.6478043-2.4262781-3.7933388-5.0259571-5.887455-7.1638966C57.0660973,0.7146722,53.7715874,0.1705091,50.8361206,0.659043z' }),
					_react2.default.createElement('path', { style: style.st3, d: 'M60.2345543,4.0015373c-5.5842285,1.4033203-11.9116211,2.6464844-18.8162842,3.4243164 C26.0287457,9.1597404,12.8599215,8.0186272,4.6785254,6.7998772C3.9096043,7.7739983,3.1891453,8.8184319,2.5170262,9.9326897 c8.1445312,1.3398438,22.4140625,2.8391113,39.2893066,0.9379883c7.7641602-0.8745117,14.8220215-2.329834,20.9328613-3.9482422 C61.9331627,5.9148674,61.0928307,4.9346428,60.2345543,4.0015373z' }),
					_react2.default.createElement('path', { style: style.st11, d: 'M1.0031102,12.7217522c7.7030029,1.3947754,22.9091797,3.3137207,41.1535645,1.2585449 c8.4698486-0.9541016,16.1052246-2.5983887,22.5811806-4.3930664c-0.6855469-0.9838867-1.4390907-1.984375-2.2401161-2.9714355 c-6.0351562,1.6049805-13.0266113,3.052002-20.729126,3.9196777c-16.9122295,1.9052734-31.1424561,0.3388672-39.0184326-0.9870605 c-0.2380371,0.3825684-0.4782715,0.762207-0.7045898,1.1616211c-0.3560791,0.628418-0.6899414,1.284668-1.0144043,1.9521484 C1.0216649,12.6817131,1.0126317,12.7022209,1.0031102,12.7217522z' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC11.default);
	
	var Bear = function (_PositionedGoodyHOC5) {
		_inherits(Bear, _PositionedGoodyHOC5);
	
		function Bear() {
			_classCallCheck(this, Bear);
	
			return _possibleConstructorReturn(this, (Bear.__proto__ || Object.getPrototypeOf(Bear)).apply(this, arguments));
		}
	
		_createClass(Bear, [{
			key: 'render',
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st3: {
						fill: '#A5C6EF'
					},
					st11: {
						fill: '#FC7E7E'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '80.0711517', cy: '0.5424188' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M160.1302643,45.7799339c-0.0966034-1.2384224-0.2017517-2.4924583-0.3152008-3.7584991 c-0.3040466-3.393177-0.6676788-6.8725967-1.08638-10.3688068c-0.086792-0.7247429-0.1759491-1.4502048-0.2674255-2.1757717 c-0.4582977-3.6346989-3.0809937-6.6206608-6.6168671-7.5791016 c-11.2558746-3.0510311-37.8840179-9.1203384-71.6005783-9.1203384c-33.7700272,0-60.5924072,6.0914326-71.8882446,9.1355839 c-3.5286727,0.9509525-6.1388545,3.9462357-6.5966611,7.5720119c-0.5576485,4.4165115-1.2485654,11.3677139-1.739485,16.3168259 c-0.2736029,2.7582779,2.3906975,4.8788376,5.017622,3.9944115l6.2060661-2.089447 c0.2768497-0.0929794,28.1336327-9.3124199,69.0007019-9.3124199c40.528511,0,68.4411697,9.215271,68.6971664,9.3011627 c0,0,3.1838531,1.0366096,6.2118378,2.0106888C157.7370605,50.5375595,160.3414001,48.4863701,160.1302643,45.7799339z' }),
					_react2.default.createElement('path', { style: style.st3, d: 'M1.4879638,31.7359276c-0.1991066,1.7165298-0.4068515,3.6349068-0.6116468,5.591629l1.133327-0.3822021 c0.3261554-0.1099815,33.0950851-10.9881516,78.2343292-10.9881516s77.9081726,10.87817,78.2343292,10.9881516 l0.8718567,0.2941322c-0.1918488-1.8515854-0.3973846-3.7151833-0.6214447-5.5867825v-0.0002117 C151.9879456,29.5845242,121.0453186,20.83395,80.2439728,20.83395 C38.8757439,20.83395,7.6370897,29.830616,1.4879638,31.7359276z' }),
					_react2.default.createElement('path', { style: style.st11, d: 'M0.9605948,36.5260735C0.763806,38.3898773,0.568808,40.3027763,0.3864517,42.119175l1.6240349-0.5490685 c0.3253129-0.1099854,33.0352478-10.9881535,78.23349-10.9881535c45.1392365,0,77.9081726,10.8785915,78.2343292,10.9885731 l1.3367462,0.4508858c-0.1646576-1.836834-0.3498535-3.7010612-0.548645-5.5775108 c-5.4598389-1.7102089-37.0213852-10.9852009-79.0224304-10.9852009 C37.5001183,25.4587002,5.5718598,35.0634308,0.9605948,36.5260735z' })
				);
			}
		}]);
	
		return Bear;
	}(_PositionedGoodyHOC11.default);
	
	var Leopard = function (_PositionedGoodyHOC6) {
		_inherits(Leopard, _PositionedGoodyHOC6);
	
		function Leopard() {
			_classCallCheck(this, Leopard);
	
			return _possibleConstructorReturn(this, (Leopard.__proto__ || Object.getPrototypeOf(Leopard)).apply(this, arguments));
		}
	
		_createClass(Leopard, [{
			key: 'render',
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st3: {
						fill: '#A5C6EF'
					},
					st11: {
						fill: '#FC7E7E'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '73.5470901', cy: '0.2718361' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M149.0843201,37.5954666c-0.0899506-1.1529922-0.187851-2.3205261-0.293457-3.4992332 c-0.2830811-3.159111-0.6216278-6.3985176-1.0114441-9.6535549c-0.0808105-0.6747494-0.1638184-1.3501682-0.2489929-2.0256844 c-0.4266663-3.3839741-2.868454-6.1639614-6.1604156-7.0562878c-10.4794312-2.8405676-35.2707443-8.491209-66.661499-8.491209 c-31.4405327,0-56.4126816,5.6712403-66.9293213,8.5054016c-3.2852607,0.8853559-5.7153897,3.6740217-6.1416163,7.0496874 C1.1183941,26.5364418,0.4751374,33.0081444,0.018082,37.6158638c-0.2547295,2.5680046,2.225785,4.5422859,4.6715012,3.7188683 l5.7779651-1.9453125c0.2577524-0.0865631,26.1929474-8.6700382,64.2409668-8.6700382 c37.732811,0,63.7200317,8.5795918,63.958374,8.6595554c0,0,2.9642181,0.965107,5.7833405,1.8719902 C146.8561859,42.0249062,149.2808838,40.1152115,149.0843201,37.5954666z' }),
					_react2.default.createElement('path', { style: style.st3, d: 'M1.3853225,24.5202332c-0.1853719,1.5981216-0.3787864,3.3841648-0.5694547,5.2059097l1.0551488-0.355835 c0.3036569-0.102396,30.8121529-10.2301769,72.8376389-10.2301769s72.533989,10.1277809,72.8376389,10.2301769l0.8117218,0.27384 c-0.1786041-1.7238598-0.3699646-3.4589024-0.5785828-5.2013988v-0.0001965 c-6.2757721-1.9253178-35.0839462-10.0722685-73.0707779-10.0722685 C36.1940536,14.3702841,7.1102753,22.7463493,1.3853225,24.5202332z' }),
					_react2.default.createElement('path', { style: style.st11, d: 'M0.894332,28.979948c-0.1832142,1.735239-0.364761,3.5161839-0.5345381,5.2072849l1.5120075-0.5111961 c0.3028723-0.1023941,30.7564449-10.2301769,72.836853-10.2301769c42.0254898,0,72.533989,10.1281757,72.8376389,10.2305698 l1.2445526,0.4197845c-0.1533051-1.7101288-0.3257294-3.4457607-0.5108032-5.1927681 c-5.0832214-1.5922375-34.4676132-10.2274323-73.5713882-10.2274323 C34.9133224,18.6760139,5.1875072,27.6182003,0.894332,28.979948z' })
				);
			}
		}]);
	
		return Leopard;
	}(_PositionedGoodyHOC11.default);
	
	var Chicken = function (_PositionedGoodyHOC7) {
		_inherits(Chicken, _PositionedGoodyHOC7);
	
		function Chicken() {
			_classCallCheck(this, Chicken);
	
			return _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).apply(this, arguments));
		}
	
		_createClass(Chicken, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '34.79963', cy: '5.29766' }),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M71.50744,15.72634c-1.55711-3.66364-3.0271-7.32556-4.79568-10.72734 c-0.7247-1.39392-2.05299-2.37018-3.60104-2.63807C55.82561,1.10024,46.40663,0,35.69302,0 C25.20889,0,15.92813,1.05405,8.67596,2.28081C6.99987,2.56433,5.5765,3.63927,4.80485,5.15393 c-1.69139,3.31999-3.16964,6.85548-4.65473,10.42539c-0.61038,1.46726,0.74042,2.83262,2.25078,2.46842 c6.36888-1.53577,18.24541-3.77869,33.29211-3.77869c15.24835,0,27.28948,2.34164,33.5434,3.87641 C70.80785,18.5311,72.19926,17.35407,71.50744,15.72634z' }),
					_react2.default.createElement('path', { fill: '#A5C6EF', d: 'M3.57095,7.66504c-0.50049,1.05713-0.98706,2.13013-1.46167,3.21533 c7.7981-1.67188,19.62573-3.53906,33.58374-3.53906c14.09619,0,26.02441,1.90454,33.81885,3.58887 c-0.47437-1.08594-0.96118-2.15918-1.46167-3.2168c-7.92432-1.59692-19.21948-3.22583-32.35718-3.22583 C22.68887,4.48755,11.48354,6.08374,3.57095,7.66504z' }),
					_react2.default.createElement('path', { fill: '#FC7E7E', d: 'M2.27554,10.50708c-0.46729,1.05908-0.92261,2.12988-1.36816,3.21021 c7.75-1.73218,20.07642-3.7998,34.78564-3.7998c14.84302,0,27.28076,2.11133,35.021,3.85425 c-0.4458-1.08228-0.90161-2.15552-1.36914-3.2168c-7.96436-1.67651-19.78638-3.49121-33.65186-3.49121 C21.95791,7.06372,10.23598,8.84399,2.27554,10.50708z' })
				);
			}
		}]);
	
		return Chicken;
	}(_PositionedGoodyHOC11.default);
	
	var Bunny = function (_PositionedGoodyHOC8) {
		_inherits(Bunny, _PositionedGoodyHOC8);
	
		function Bunny() {
			_classCallCheck(this, Bunny);
	
			return _possibleConstructorReturn(this, (Bunny.__proto__ || Object.getPrototypeOf(Bunny)).apply(this, arguments));
		}
	
		_createClass(Bunny, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '50.16353', cy: '14.63047' }),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M50.27055,19.1013c25.10522,0,42.39575,6.6687,42.55444,6.73096c0,0,1.97217,0.75,3.8479,1.45483 c1.60083,0.60181,3.21411-0.88257,3.08325-2.84131c-0.00684-0.10254-0.01538-0.2085-0.02246-0.31128 c-1.64433-5.83488-3.43052-10.93522-5.42618-15.37104c-0.56764-1.26171-1.648-2.20852-2.97896-2.58624 c-8.16262-2.31655-22.95615-5.61377-41.058-5.61377c-18.07284,0-32.92776,3.28905-41.14816,5.60466 C7.79145,6.54303,6.70994,7.48708,6.13883,8.74637c-2.04025,4.49879-3.86854,9.68102-5.55529,15.62129 c-0.00269,0.03027-0.00562,0.06421-0.00806,0.09424c-0.16943,1.99585,1.48096,3.53052,3.10815,2.89062l3.84448-1.51221 C7.69951,25.77293,24.95537,19.1013,50.27055,19.1013z' }),
					_react2.default.createElement('path', { fill: '#A5C6EF', d: 'M50.27075,6.26043c-21.729,0-38.9375,4.67871-45.99365,6.94312 c-0.56396,1.45483-1.11279,2.96631-1.646,4.5459c4.04395-1.448,22.81494-7.64844,47.63965-7.64844 c24.50684,0,43.12452,6.04639,47.4878,7.59399c-0.52686-1.57544-1.06982-3.08276-1.62842-4.53418 C88.99536,10.88176,71.8689,6.26043,50.27075,6.26043z' }),
					_react2.default.createElement('path', { fill: '#FC7E7E', d: 'M50.27055,9.74022c-23.39551,0-41.55103,5.42407-47.43359,7.41748 c-0.48535,1.41431-0.95947,2.87842-1.42188,4.39722l0.3938-0.15552c0.20142-0.07959,20.46362-7.95166,48.46167-7.95166 c27.96167,0,48.26025,7.87256,48.46216,7.95215l0.22681,0.08936c-0.45605-1.51416-0.9248-2.97168-1.40454-4.38159 C91.51836,15.07445,73.47099,9.74022,50.27055,9.74022z' })
				);
			}
		}]);
	
		return Bunny;
	}(_PositionedGoodyHOC11.default);
	
	var Pig = function (_PositionedGoodyHOC9) {
		_inherits(Pig, _PositionedGoodyHOC9);
	
		function Pig() {
			_classCallCheck(this, Pig);
	
			return _possibleConstructorReturn(this, (Pig.__proto__ || Object.getPrototypeOf(Pig)).apply(this, arguments));
		}
	
		_createClass(Pig, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('ellipse', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '60', cy: '7' }),
					_react2.default.createElement('path', { fill: '#FFFFFF', d: 'M123.64806,21.79376c-1.58815-3.28899-4.60526-5.66306-8.17167-6.45069 c-0.02039-0.0045-0.04062-0.00896-0.06069-0.01338c-14.12878-3.11115-35.93191-6.66418-61.82241-6.66418 c-14.72554,0-28.1592,1.14991-39.62077,2.71408c-0.01823,0.00249-0.03662,0.005-0.05518,0.00754 c-3.36823,0.46144-6.26985,2.60338-7.70163,5.68687c-1.20245,2.58961-2.61784,5.90319-3.67817,9.1882 c-1.20134,3.72187-1.99692,7.41011-2.48827,10.13201c-0.37718,2.08941,1.46967,3.89668,3.55523,3.49875 c0.0152-0.0029,0.03027-0.00577,0.04521-0.00861c12.32544-2.34521,29.55042-4.62445,49.94358-4.62445 c41.44378,0,69.98679,9.56688,70.24857,9.65605l0.00001,0c3.47356,1.07295,6.80466-2.01957,5.98218-5.56081 c-0.5938-2.55665-1.37199-5.48416-2.35315-8.38378C126.34996,27.65868,124.89671,24.37967,123.64806,21.79376z' }),
					_react2.default.createElement('path', { fill: '#A5C6EF', d: 'M4.43425,21.14037c-0.67529,1.64209-1.33594,3.38452-1.89673,5.12183 c-0.06763,0.20996-0.12964,0.4187-0.19482,0.62817c13.58765-2.41626,31.22559-4.54224,51.25073-4.54224 c34.99975,0,62.71045,6.48975,74.21631,9.67871c-0.11304-0.35205-0.21973-0.70361-0.33887-1.05542 c-0.5835-1.72461-1.25732-3.43726-1.94531-5.05054c-13.4187-3.45557-39.65234-8.89136-71.93213-8.89136 C34.67595,17.02953,17.8405,18.89843,4.43425,21.14037z' }),
					_react2.default.createElement('path', { fill: '#FC7E7E', d: 'M2.5363,26.26586c-0.62744,1.94482-1.14209,3.87671-1.5625,5.66968 c13.75488-2.51489,31.89624-4.78613,52.61963-4.78613c36.63501,0,65.28149,7.10938,75.71777,10.10229 c-0.48633-1.91406-1.06885-3.95679-1.74854-5.99438c-12.67505-3.39551-39.96973-9.42676-73.96924-9.42676 C33.77044,21.83055,16.23577,23.8828,2.5363,26.26586z' })
				);
			}
		}]);
	
		return Pig;
	}(_PositionedGoodyHOC11.default);
	
	function Sweatband(props) {
		var sweatbands = {
			Cat: Cat,
			LilDoggo: LilDoggo,
			TuxedoBird: TuxedoBird,
			Tortoise: Tortoise,
			Bear: Bear,
			Leopard: Leopard,
			Chicken: Chicken,
			Bunny: Bunny,
			Pig: Pig
		};
	
		var ThisSweatband = sweatbands[props.petType.name];
	
		if (_lodash2.default.isUndefined(ThisSweatband)) {
			return null;
		}
	
		return _react2.default.createElement(ThisSweatband, props);
	}
	
	exports.default = Sweatband;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopHat = function (_PositionedGoodyHOC) {
		_inherits(TopHat, _PositionedGoodyHOC);
	
		function TopHat() {
			_classCallCheck(this, TopHat);
	
			return _possibleConstructorReturn(this, (TopHat.__proto__ || Object.getPrototypeOf(TopHat)).apply(this, arguments));
		}
	
		_createClass(TopHat, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '32.7272', cy: '60.7006' }),
					_react2.default.createElement('path', { fill: '#444444', d: 'M32.72672,0C21.76777,0,14.1874,1.17435,10.53195,1.90492C9.10499,2.19011,8.13991,3.5127,8.29139,4.95997 l2.64323,25.25459l43.5843-0.00002l2.64339-25.25455c0.15149-1.44728-0.81359-2.76988-2.24055-3.05507 C51.26627,1.17435,43.68585,0,32.72672,0z' }),
					_react2.default.createElement('path', { fill: '#ffffff', d: 'M54.519,30.21455c-14.52808-0.00024-29.0564-0.00024-43.58423,0l1.75049,16.7251l20.0415,3.51147 l20.0415-3.51147L54.519,30.21455z' }),
					_react2.default.createElement('path', { fill: '#444444', d: 'M32.72702,55.57523c17.60231,0,26.90208-2.3328,31.333-6.35959 c2.94451-2.67595,0.86792-8.04698-2.89868-7.47179c-19.06079,2.9104-38.01611,2.90771-56.86841,0 c-3.76563-0.58081-5.84328,4.79579-2.8988,7.47176C5.82498,53.24241,15.12468,55.57523,32.72702,55.57523z' })
				);
			}
		}]);
	
		return TopHat;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = TopHat;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PositionedGoodyHOC4 = __webpack_require__(6);
	
	var _PositionedGoodyHOC5 = _interopRequireDefault(_PositionedGoodyHOC4);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PositionedGoodyHOC) {
		_inherits(Cat, _PositionedGoodyHOC);
	
		function Cat() {
			_classCallCheck(this, Cat);
	
			return _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).apply(this, arguments));
		}
	
		_createClass(Cat, [{
			key: 'render',
	
			// 9
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st82: {
						fill: '#EBEFFF'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '12.036643', cy: '84.0755081' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M17.1588974,8.9754705c0.541687,2.625,0.8620644,8.4152346,0.8620644,8.4152346l1.1979485,3.4234982 c1.2046223,3.4425716,1.6372013,7.1079922,1.2670708,10.7364101l-0.3622875,3.5515289l1.6860237,5.2146721 c0.9740334,3.0125694,1.3637867,6.1834335,1.1483173,9.3422127l-0.4036255,5.9171638l2.0243626,6.6664734 c0.8333969,2.7444725,1.1856918,5.6124458,1.0413017,8.4770317l-0.3778477,7.4961319 c0,0,3.0833378,13.4636917-11.3654051,13.4636917c-14.5512571,0-14.7179241-15.4540482-12.4716015-23.7567749l1.3895756-4.1880684 l-0.4142787-4.1677628c-0.3281109-3.3008881,0.0075343-6.6340599,0.9871721-9.8032608l1.7628253-5.7028656l-0.3290553-2.5133247 c-0.4740615-3.6208763-0.1447968-7.3017273,0.9643955-10.7809772l1.5025201-4.7130184l-0.000001-0.0000057 c-0.7923408-4.3564873-0.4070277-8.8455276,1.1161237-13.0032654l0.6326847-1.7270355l0.2892637-2.4364853 c0.2297735-1.9353929,1.1488333-8.5661983,3.7506428-8.5661983S16.6172104,6.3504705,17.1588974,8.9754705z' }),
					_react2.default.createElement('path', { style: style.st82, d: 'M20.928978,79.6029129c1.2446289,0,2.5566406-0.125,3.9345703-0.3964844l0.5263672-0.1035156 c-0.0720215-0.5567627-0.147644-0.887085-0.147644-0.887085l0.0571289-1.1334229l-0.8225708,0.1621094 c-6.4433594,1.2666016-12.015625-0.8017578-16.5683594-6.1523438c-3.4741211-4.0834961-5.0244141-8.6381836-5.0400391-8.6835938 l-0.2921753-0.8724365l0.2185669,2.1986084l-0.6663818,2.0083008 C4.4201274,70.4376297,10.2614365,79.6043777,20.928978,79.6029129z' }),
					_react2.default.createElement('path', { style: style.st82, d: 'M22.5544052,55.5761795l0.0799561-1.1719971l-0.9075317,0.1787109 c-4.9360352,0.9731445-9.2143555-0.6147461-12.7084961-4.7167969c-2.6870122-3.1538086-3.8881841-6.6772461-3.8999028-6.7128906 l-0.1749878-0.5211182l0.1870728,1.4287109l-0.7345581,2.3763428c1.9710083,3.8208008,6.5421147,10.4224854,14.5994263,10.4221191 c0.9863281,0,2.0253906-0.0991211,3.1181641-0.3144531l0.6936035-0.1363525L22.5544052,55.5761795z' }),
					_react2.default.createElement('path', { style: style.st82, d: 'M19.8635483,36.049202l0.5324707-0.1047363l-0.2723389-0.8422852l0.1188965-1.1657715 l-0.7657471,0.1508789C10.859642,35.780159,7.5066142,26.1346493,7.3684306,25.7235165l-0.2651978-0.7888184 c0.0504761,0.3734131,0.0975342,0.7470703,0.1651611,1.1187744L6.4672465,28.566534 c1.551209,2.927002,5.0082402,7.7238789,11.0130005,7.7229023C18.2336655,36.2894363,19.0285873,36.2137527,19.8635483,36.049202z ' }),
					_react2.default.createElement('path', { style: style.st82, d: 'M18.3619614,18.3653622l-0.3410034-0.9746094c0,0-0.0218506-0.3922119-0.0629883-1.012085 c-6.0838623,0.4388428-8.4960938-6.4726553-8.6008301-6.7835684L9.2574692,9.2994452l-0.2402954,2.0236816l-0.47052,1.2844238 c1.5922852,2.7766113,4.5301514,5.8057852,8.8641968,5.805419C17.720726,18.4129696,18.0378036,18.3974667,18.3619614,18.3653622z ' })
				);
			}
		}]);
	
		return Cat;
	}(_PositionedGoodyHOC5.default);
	
	var Tortoise = function (_PositionedGoodyHOC2) {
		_inherits(Tortoise, _PositionedGoodyHOC2);
	
		function Tortoise() {
			_classCallCheck(this, Tortoise);
	
			return _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).apply(this, arguments));
		}
	
		_createClass(Tortoise, [{
			key: 'render',
	
			// 9
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st82: {
						fill: '#EBEFFF'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '15.036643', cy: '87.0755081' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M17.1588974,8.9754705c0.541687,2.625,0.8620644,8.4152346,0.8620644,8.4152346l1.1979485,3.4234982 c1.2046223,3.4425716,1.6372013,7.1079922,1.2670708,10.7364101l-0.3622875,3.5515289l1.6860237,5.2146721 c0.9740334,3.0125694,1.3637867,6.1834335,1.1483173,9.3422127l-0.4036255,5.9171638l2.0243626,6.6664734 c0.8333969,2.7444725,1.1856918,5.6124458,1.0413017,8.4770317l-0.3778477,7.4961319 c0,0,3.0833378,13.4636917-11.3654051,13.4636917c-14.5512571,0-14.7179241-15.4540482-12.4716015-23.7567749l1.3895756-4.1880684 l-0.4142787-4.1677628c-0.3281109-3.3008881,0.0075343-6.6340599,0.9871721-9.8032608l1.7628253-5.7028656l-0.3290553-2.5133247 c-0.4740615-3.6208763-0.1447968-7.3017273,0.9643955-10.7809772l1.5025201-4.7130184l-0.000001-0.0000057 c-0.7923408-4.3564873-0.4070277-8.8455276,1.1161237-13.0032654l0.6326847-1.7270355l0.2892637-2.4364853 c0.2297735-1.9353929,1.1488333-8.5661983,3.7506428-8.5661983S16.6172104,6.3504705,17.1588974,8.9754705z' }),
					_react2.default.createElement('path', { style: style.st82, d: 'M20.928978,79.6029129c1.2446289,0,2.5566406-0.125,3.9345703-0.3964844l0.5263672-0.1035156 c-0.0720215-0.5567627-0.147644-0.887085-0.147644-0.887085l0.0571289-1.1334229l-0.8225708,0.1621094 c-6.4433594,1.2666016-12.015625-0.8017578-16.5683594-6.1523438c-3.4741211-4.0834961-5.0244141-8.6381836-5.0400391-8.6835938 l-0.2921753-0.8724365l0.2185669,2.1986084l-0.6663818,2.0083008 C4.4201274,70.4376297,10.2614365,79.6043777,20.928978,79.6029129z' }),
					_react2.default.createElement('path', { style: style.st82, d: 'M22.5544052,55.5761795l0.0799561-1.1719971l-0.9075317,0.1787109 c-4.9360352,0.9731445-9.2143555-0.6147461-12.7084961-4.7167969c-2.6870122-3.1538086-3.8881841-6.6772461-3.8999028-6.7128906 l-0.1749878-0.5211182l0.1870728,1.4287109l-0.7345581,2.3763428c1.9710083,3.8208008,6.5421147,10.4224854,14.5994263,10.4221191 c0.9863281,0,2.0253906-0.0991211,3.1181641-0.3144531l0.6936035-0.1363525L22.5544052,55.5761795z' }),
					_react2.default.createElement('path', { style: style.st82, d: 'M19.8635483,36.049202l0.5324707-0.1047363l-0.2723389-0.8422852l0.1188965-1.1657715 l-0.7657471,0.1508789C10.859642,35.780159,7.5066142,26.1346493,7.3684306,25.7235165l-0.2651978-0.7888184 c0.0504761,0.3734131,0.0975342,0.7470703,0.1651611,1.1187744L6.4672465,28.566534 c1.551209,2.927002,5.0082402,7.7238789,11.0130005,7.7229023C18.2336655,36.2894363,19.0285873,36.2137527,19.8635483,36.049202z ' }),
					_react2.default.createElement('path', { style: style.st82, d: 'M18.3619614,18.3653622l-0.3410034-0.9746094c0,0-0.0218506-0.3922119-0.0629883-1.012085 c-6.0838623,0.4388428-8.4960938-6.4726553-8.6008301-6.7835684L9.2574692,9.2994452l-0.2402954,2.0236816l-0.47052,1.2844238 c1.5922852,2.7766113,4.5301514,5.8057852,8.8641968,5.805419C17.720726,18.4129696,18.0378036,18.3974667,18.3619614,18.3653622z ' })
				);
			}
		}]);
	
		return Tortoise;
	}(_PositionedGoodyHOC5.default);
	
	var Pig = function (_PositionedGoodyHOC3) {
		_inherits(Pig, _PositionedGoodyHOC3);
	
		function Pig() {
			_classCallCheck(this, Pig);
	
			return _possibleConstructorReturn(this, (Pig.__proto__ || Object.getPrototypeOf(Pig)).apply(this, arguments));
		}
	
		_createClass(Pig, [{
			key: 'render',
	
			// 9
			value: function render() {
				var style = {
					st2: {
						fill: '#FFFFFF'
					},
					st82: {
						fill: '#EBEFFF'
					}
				};
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '18.036643', cy: '84.0755081' }),
					_react2.default.createElement('path', { style: style.st2, d: 'M17.1588974,8.9754705c0.541687,2.625,0.8620644,8.4152346,0.8620644,8.4152346l1.1979485,3.4234982 c1.2046223,3.4425716,1.6372013,7.1079922,1.2670708,10.7364101l-0.3622875,3.5515289l1.6860237,5.2146721 c0.9740334,3.0125694,1.3637867,6.1834335,1.1483173,9.3422127l-0.4036255,5.9171638l2.0243626,6.6664734 c0.8333969,2.7444725,1.1856918,5.6124458,1.0413017,8.4770317l-0.3778477,7.4961319 c0,0,3.0833378,13.4636917-11.3654051,13.4636917c-14.5512571,0-14.7179241-15.4540482-12.4716015-23.7567749l1.3895756-4.1880684 l-0.4142787-4.1677628c-0.3281109-3.3008881,0.0075343-6.6340599,0.9871721-9.8032608l1.7628253-5.7028656l-0.3290553-2.5133247 c-0.4740615-3.6208763-0.1447968-7.3017273,0.9643955-10.7809772l1.5025201-4.7130184l-0.000001-0.0000057 c-0.7923408-4.3564873-0.4070277-8.8455276,1.1161237-13.0032654l0.6326847-1.7270355l0.2892637-2.4364853 c0.2297735-1.9353929,1.1488333-8.5661983,3.7506428-8.5661983S16.6172104,6.3504705,17.1588974,8.9754705z' }),
					_react2.default.createElement('path', { style: style.st82, d: 'M20.928978,79.6029129c1.2446289,0,2.5566406-0.125,3.9345703-0.3964844l0.5263672-0.1035156 c-0.0720215-0.5567627-0.147644-0.887085-0.147644-0.887085l0.0571289-1.1334229l-0.8225708,0.1621094 c-6.4433594,1.2666016-12.015625-0.8017578-16.5683594-6.1523438c-3.4741211-4.0834961-5.0244141-8.6381836-5.0400391-8.6835938 l-0.2921753-0.8724365l0.2185669,2.1986084l-0.6663818,2.0083008 C4.4201274,70.4376297,10.2614365,79.6043777,20.928978,79.6029129z' }),
					_react2.default.createElement('path', { style: style.st82, d: 'M22.5544052,55.5761795l0.0799561-1.1719971l-0.9075317,0.1787109 c-4.9360352,0.9731445-9.2143555-0.6147461-12.7084961-4.7167969c-2.6870122-3.1538086-3.8881841-6.6772461-3.8999028-6.7128906 l-0.1749878-0.5211182l0.1870728,1.4287109l-0.7345581,2.3763428c1.9710083,3.8208008,6.5421147,10.4224854,14.5994263,10.4221191 c0.9863281,0,2.0253906-0.0991211,3.1181641-0.3144531l0.6936035-0.1363525L22.5544052,55.5761795z' }),
					_react2.default.createElement('path', { style: style.st82, d: 'M19.8635483,36.049202l0.5324707-0.1047363l-0.2723389-0.8422852l0.1188965-1.1657715 l-0.7657471,0.1508789C10.859642,35.780159,7.5066142,26.1346493,7.3684306,25.7235165l-0.2651978-0.7888184 c0.0504761,0.3734131,0.0975342,0.7470703,0.1651611,1.1187744L6.4672465,28.566534 c1.551209,2.927002,5.0082402,7.7238789,11.0130005,7.7229023C18.2336655,36.2894363,19.0285873,36.2137527,19.8635483,36.049202z ' }),
					_react2.default.createElement('path', { style: style.st82, d: 'M18.3619614,18.3653622l-0.3410034-0.9746094c0,0-0.0218506-0.3922119-0.0629883-1.012085 c-6.0838623,0.4388428-8.4960938-6.4726553-8.6008301-6.7835684L9.2574692,9.2994452l-0.2402954,2.0236816l-0.47052,1.2844238 c1.5922852,2.7766113,4.5301514,5.8057852,8.8641968,5.805419C17.720726,18.4129696,18.0378036,18.3974667,18.3619614,18.3653622z ' })
				);
			}
		}]);
	
		return Pig;
	}(_PositionedGoodyHOC5.default);
	
	function Unicorn(props) {
		var unicorns = {
			Cat: Cat,
			Tortoise: Tortoise,
			Pig: Pig
		};
	
		var ThisUnicorn = unicorns[props.petType.name] || Cat;
	
		if (_lodash2.default.isUndefined(ThisUnicorn)) {
			return null;
		}
	
		return _react2.default.createElement(ThisUnicorn, props);
	}
	
	exports.default = Unicorn;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyHOC2 = __webpack_require__(6);
	
	var _PositionedGoodyHOC3 = _interopRequireDefault(_PositionedGoodyHOC2);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Witch = function (_PositionedGoodyHOC) {
		_inherits(Witch, _PositionedGoodyHOC);
	
		function Witch() {
			_classCallCheck(this, Witch);
	
			return _possibleConstructorReturn(this, (Witch.__proto__ || Object.getPrototypeOf(Witch)).apply(this, arguments));
		}
	
		_createClass(Witch, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('circle', { ref: _constants.POSITIONED_GOODY_REFS.MARKER, cx: '60.609', cy: '115.32874' }),
					_react2.default.createElement('ellipse', { fill: '#4C4C4C', cx: '60.609', cy: '109.32769', rx: '60.2445', ry: '14.21944' }),
					_react2.default.createElement('path', { fill: '#515151', d: 'M60.609,109.57452c27.10395,0,33.88211-5.43649,33.88211-5.43649L64.7455,3.31687 c-1.30478-4.42249-6.96821-4.42249-8.27299,0L26.72689,104.13803C26.72689,104.13803,33.50505,109.57452,60.609,109.57452z' })
				);
			}
		}]);
	
		return Witch;
	}(_PositionedGoodyHOC3.default);
	
	exports.default = Witch;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionedGoodyParentHOC = __webpack_require__(250);
	
	var _PositionedGoodyParentHOC2 = _interopRequireDefault(_PositionedGoodyParentHOC);
	
	var _constants = __webpack_require__(4);
	
	var _PartyHat = __webpack_require__(457);
	
	var _PartyHat2 = _interopRequireDefault(_PartyHat);
	
	var _Fedora = __webpack_require__(453);
	
	var _Fedora2 = _interopRequireDefault(_Fedora);
	
	var _Fez = __webpack_require__(454);
	
	var _Fez2 = _interopRequireDefault(_Fez);
	
	var _Chef = __webpack_require__(452);
	
	var _Chef2 = _interopRequireDefault(_Chef);
	
	var _Baseball = __webpack_require__(448);
	
	var _Baseball2 = _interopRequireDefault(_Baseball);
	
	var _Beanie = __webpack_require__(450);
	
	var _Beanie2 = _interopRequireDefault(_Beanie);
	
	var _Princess = __webpack_require__(458);
	
	var _Princess2 = _interopRequireDefault(_Princess);
	
	var _King = __webpack_require__(456);
	
	var _King2 = _interopRequireDefault(_King);
	
	var _Unicorn = __webpack_require__(465);
	
	var _Unicorn2 = _interopRequireDefault(_Unicorn);
	
	var _Sweatband = __webpack_require__(463);
	
	var _Sweatband2 = _interopRequireDefault(_Sweatband);
	
	var _Spinner = __webpack_require__(462);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _Bow = __webpack_require__(451);
	
	var _Bow2 = _interopRequireDefault(_Bow);
	
	var _Ranger = __webpack_require__(459);
	
	var _Ranger2 = _interopRequireDefault(_Ranger);
	
	var _Sombrero = __webpack_require__(461);
	
	var _Sombrero2 = _interopRequireDefault(_Sombrero);
	
	var _BeachBall = __webpack_require__(449);
	
	var _BeachBall2 = _interopRequireDefault(_BeachBall);
	
	var _Witch = __webpack_require__(466);
	
	var _Witch2 = _interopRequireDefault(_Witch);
	
	var _TopHat = __webpack_require__(464);
	
	var _TopHat2 = _interopRequireDefault(_TopHat);
	
	var _ShrimponBarbie = __webpack_require__(460);
	
	var _ShrimponBarbie2 = _interopRequireDefault(_ShrimponBarbie);
	
	var _FlowerCrown = __webpack_require__(455);
	
	var _FlowerCrown2 = _interopRequireDefault(_FlowerCrown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // To add a new hat:
	//
	// 1. Add the svg component in this folder.
	// 2. Make sure it has the marker ref. (see PositionedGoodyHOC.js for details).
	// 2. Import the component here.
	// 3. Add the goody to `hatOptions` here.
	// 4. Add the goody to constants.
	// 5. Add a new story in src/stories/hat.js.
	
	// WIP
	
	
	var hatOptions = {
		'hat-PartyHat': _PartyHat2.default,
		'hat-Fedora': _Fedora2.default,
		'hat-Fez': _Fez2.default,
		'hat-Chef': _Chef2.default,
		'hat-Baseball': _Baseball2.default,
		'hat-Beanie': _Beanie2.default,
		'hat-Princess': _Princess2.default,
		'hat-King': _King2.default,
		'hat-Unicorn': _Unicorn2.default,
		'hat-Sweatband': _Sweatband2.default,
		'hat-Spinner': _Spinner2.default,
		'hat-Bow': _Bow2.default,
		'hat-Ranger': _Ranger2.default,
		'hat-Sombrero': _Sombrero2.default,
		'hat-BeachBall': _BeachBall2.default,
		'hat-Witch': _Witch2.default,
		'hat-TopHat': _TopHat2.default,
		'hat-ShrimponBarbie': _ShrimponBarbie2.default,
		// WIP
		'hat-FlowerCrown': _FlowerCrown2.default
	};
	
	var Hat = function (_PositionedGoodyParen) {
		_inherits(Hat, _PositionedGoodyParen);
	
		function Hat() {
			_classCallCheck(this, Hat);
	
			return _possibleConstructorReturn(this, (Hat.__proto__ || Object.getPrototypeOf(Hat)).apply(this, arguments));
		}
	
		_createClass(Hat, [{
			key: 'render',
			value: function render() {
				var ThisHat = hatOptions[this.props.goody];
	
				if (!ThisHat) {
					return null;
				}
	
				return _react2.default.createElement(
					'svg',
					Object.assign({ ref: _constants.POSITIONED_GOODY_REFS.GOODY_CONTAINER }, this.getPosition()),
					_react2.default.createElement(ThisHat, Object.assign({}, this.props, { getMarkerCoords: this.getMarkerCoords }))
				);
			}
		}]);
	
		return Hat;
	}(_PositionedGoodyParentHOC2.default);
	
	exports.default = Hat;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Bone;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Bone() {
		var style = {
			st2: {
				fill: "#FFFFFF"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st2, d: "M139.3103485,378.6974792c2.6002197-2.0913696,4.2680511-5.2949219,4.2680511-8.89151 c0-6.3017273-5.1092834-11.4110107-11.411026-11.4110107c-5.1377182,0-9.3689728,3.8449402-11.7977676,8.3145142H85.3362808 c-2.4287949-4.469574-6.6600494-8.3145142-11.7977676-8.3145142c-6.3017349,0-11.4110222,5.1092834-11.4110222,11.4110107 c0,3.5965881,1.6678352,6.8001404,4.268055,8.89151c-2.6002197,2.0913696-4.268055,5.2949219-4.268055,8.89151 C62.127491,393.8907166,67.2367783,399,73.5385132,399c5.1377182,0,9.3689728-3.8449402,11.7977676-8.3145142h35.0329056 C122.7984009,395.1550598,127.0292358,399,132.1673737,399c6.3017426,0,11.411026-5.1092834,11.411026-11.4110107 C143.5783997,383.9924011,141.9105682,380.7888489,139.3103485,378.6974792z" })
		);
	}

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = BonsaiTree;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BonsaiTree() {
		// 16
		var style = {
			st131: {
				fill: "#C48357"
			},
			st3: {
				fill: "#66AA88"
			},
			st132: {
				fill: "#999999"
			},
			st19: {
				fill: "#75C69F"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st131, d: "M65.2380447,311.9967346c0.037674,0.0485535,0.0288849,0.5664062,0.0632095,0.8841553 c0.0343323,0.3713379,0.0745239,0.7476807,0.1377335,1.1244507c0.1247559,0.7518616,0.2909546,1.4991455,0.53125,2.2078857 c0.4768295,1.418335,1.1282272,2.7156982,1.9889374,3.8079224c1.6929703,2.1999207,4.0791931,3.7166443,6.9711304,4.7234802 c2.8852463,1.0101624,6.2431259,1.4526672,9.7190628,1.5393066c1.7373352,0.0489807,3.5223999-0.0112915,5.3208618-0.1343689 l0.6706543-0.0385132l0.9369125-0.0133972l1.9127502-0.0100403c1.3124237,0.0878906,2.604332,0.1096802,3.9628067,0.3361511 c5.2865372,0.6610107,11.3990479,2.8797913,16.1840591,7.8314209c2.3619461,2.4486084,4.2499924,5.5322876,5.365242,8.842865 c1.1278,3.3101501,1.5095978,6.8070068,1.2525558,10.1297302c-0.5119934,6.6872864-3.3691864,12.6402893-7.2352905,17.2787781 c-1.9366074,2.3339233-4.1311035,4.3718262-6.4729538,6.1322021c-2.3544083,1.7251892-4.8440399,3.1644592-7.4002304,4.3776855 l-0.4035645,0.1917114c-6.2033539,2.9447021-13.6194916,0.3026733-16.5641785-5.9006653s-0.303093-13.6194763,5.9006805-16.5641785 c0.5869217-0.2788086,1.2525558-0.5253906,1.8566513-0.7058105c1.1901779-0.3462219,2.3225937-0.7590027,3.3666687-1.2550964 c1.0147781-0.519104,1.9395447-1.1123047,2.7449951-1.7678833c1.6264038-1.3015442,2.696022-2.9002991,3.154007-4.3019104 c0.4337082-1.430481,0.4353867-2.467865-0.163269-3.6408691c-0.6145554-1.1541748-2.2744446-2.5683289-4.9357147-3.3189697 c-0.6204224-0.2365112-1.361824-0.3378296-2.0584412-0.5203552l-1.1261292-0.1636963l-0.5827408-0.0891418l-0.8489914-0.0975647 c-2.2560349-0.2444763-4.5246201-0.5689087-6.8099594-1.0432434c-4.5543442-0.945282-9.2083206-2.3552246-13.6454468-4.8842163 c-4.4036331-2.4783325-8.5786896-6.3184814-10.9619865-11.1809387c-1.2132072-2.3983765-1.9387054-4.9801025-2.279892-7.5287476 c-0.173317-1.2776794-0.2231331-2.5545349-0.193409-3.827179c0.0142326-0.636322,0.0611191-1.2751465,0.1260071-1.9173584 c0.0828896-0.6949158,0.1448479-1.1905823,0.3395157-2.1446533c0.4165421-2.040863,2.4088326-3.3583069,4.4496841-2.9417725 c0.9134636,0.1863098,1.6820793,0.6882324,2.215004,1.3689575L65.2380447,311.9967346z" }),
			_react2.default.createElement("path", { style: style.st131, d: "M130.4544373,324.8907166l-11.1206436,18.7088623 c-2.2589645,3.7999573-7.1704025,5.0495911-10.9703598,2.7906189c-3.7999649-2.2585449-5.0495911-7.1704102-2.7906342-10.9703674 c0.414032-0.6970215,0.9465408-1.331665,1.516304-1.8511963l16.1539154-14.5852966 c1.9324265-1.744873,4.9131088-1.5928955,6.6579819,0.3395081 C131.318924,320.8935852,131.4796906,323.1613464,130.4544373,324.8907166z" }),
			_react2.default.createElement("path", { style: style.st131, d: "M89.5315018,311.1820679c-0.2026215,0.862793-0.4638519,2.0818787-0.6133041,3.1401672 c-0.1624298,1.0951538-0.2716904,2.1886292-0.3173218,3.2540588c-0.1004791,2.1271057,0.0883331,4.1683655,0.5835724,5.7512512 c0.4801788,1.628479,1.2768478,2.5386047,2.0278778,2.9865417c0.7489395,0.4516907,1.8068314,0.7095947,3.3210373,0.8200989 c4.1231537,0.3014221,7.2214737,3.8883057,6.9200592,8.0114441s-3.8878708,7.2214661-8.0114441,6.9200439 c-0.4897995-0.0355835-0.9649506-0.118042-1.4221039-0.2419434l-0.4751511-0.1335449 c-3.3855133-0.9423523-7.1750031-2.7408142-9.9576797-5.9454956c-2.7902145-3.1694946-4.0678864-7.1218262-4.3345566-10.4642334 c-0.3056107-3.4022522,0.1021423-6.4637146,0.763588-9.313385c0.3344879-1.427124,0.7409897-2.8048706,1.2069321-4.1511841 c0.4818497-1.3819275,0.9557419-2.5792236,1.6448212-4.0750122c1.0763092-2.3359985,3.842659-3.3574524,6.1786499-2.2815857 c2.0467148,0.9427795,3.0840912,3.1820679,2.5867538,5.2932434L89.5315018,311.1820679z" }),
			_react2.default.createElement("path", { style: style.st3, d: "M56.662693,371.0365295c6.7742271-7.3579102,21.599369-12.127655,38.7980919-12.127655 c17.195488,0,32.0182877,4.7679443,38.7943726,12.1237183" }),
			_react2.default.createElement("path", { style: style.st132, d: "M52.7371254,377.519165c0.0003662,8.2972107,7.5389099,15.0232849,16.838459,15.0232849h51.7708282 c9.2995529,0,16.8380966-6.7260742,16.8380966-15.0226135c0-3.3398743-2.218277-9.1668091-2.218277-9.1668091H54.9553986 C54.9553986,368.3530273,52.7371254,374.1796265,52.7371254,377.519165z" }),
			_react2.default.createElement("path", { style: style.st3, d: "M147.2046204,305.2776489c-1.6767578-1.3899231-4.003418-2.2984009-6.9733887-2.3726501 c-0.8308105-0.5428162-1.7875977-0.98172-2.8701172-1.2856445c-1.767334-1.6360779-4.3366699-2.7178955-7.7280273-2.7178955 c-0.5095215,0-0.9956055,0.0306396-1.4682617,0.0775757c-1.7446289-1.4145508-4.1721191-2.3215637-7.2856445-2.3215637 c-4.6455078,0-7.7546387,2.0280762-9.348877,4.7489014c-0.0952148-0.0016785-0.184082-0.0116882-0.2805176-0.0116882 c-3.5446777,0-6.2028809,1.1790466-7.9741211,2.9459229c-11.5290527,1.9963379-10.8937988,18.1736145,1.9482422,18.5754089 c1.7685547,1.6611023,4.3547363,2.7615051,7.7766113,2.7615051c3.2561035,0,5.7548828-1.0013123,7.5146484-2.5328979 c0.1987305-0.0114746,0.4064941-0.011261,0.5998535-0.0296021c1.619873,0.96875,3.6748047,1.5653687,6.1835938,1.5653687 c1.1687012,0,2.2316895-0.1387329,3.2077637-0.3738403c0.9770508,0.2348938,2.0412598,0.3738403,3.2119141,0.3738403 c2.5322266,0,4.604248-0.6087036,6.2316895-1.5966797c0.9487305,0.2192688,1.9770508,0.3500366,3.1057129,0.3500366 C155.6565247,323.4337463,157.0491028,308.5502319,147.2046204,305.2776489z" }),
			_react2.default.createElement("path", { style: style.st19, d: "M118.367218,293.8049316c-1.3956451-3.2937622-4.7856903-5.8806763-10.1282501-5.7468872 c-0.2892227,0.0072632-0.5633087,0.0335083-0.83992,0.0563049c-0.804985-2.4980774-2.6969757-4.6938782-5.6556168-5.7841797 c-1.7254105-2.4677124-4.8069763-4.2147217-9.2208786-4.104187c-0.868866,0.021759-1.6697388,0.1257019-2.4216309,0.2837219 c-1.7894745-2.1395569-4.7101746-3.5968018-8.7506561-3.4956055c-3.321228,0.0831604-5.8245544,1.1908875-7.548233,2.819519 c-1.7154388-1.1138916-3.9548187-1.7831421-6.7266541-1.7137451c-4.923996,0.1233215-8.067337,2.4823914-9.4908447,5.4872131 c-3.0596161,0.1340027-5.4167938,1.1387329-7.0810318,2.6250305c-1.6107864-0.8650818-3.612133-1.3717041-6.0251961-1.3112793 c-7.5249825,0.188446-10.9215813,5.5900269-10.3220177,10.5540771c-3.2000961,0.7948303-5.352581,2.7079773-6.4730625,5.0186768 c-7.1774502,4.7917786-4.7527752,17.2385254,6.809515,16.9489746c1.6891708-0.0422974,3.1640205-0.3534241,4.4386673-0.8573608 c1.6222153,0.8825378,3.6407623,1.4031067,6.0814018,1.34198c2.5123978-0.0629272,4.5553207-0.7144165,6.1524849-1.7293396 c0.1022568,0.0070496,0.1974144,0.0230408,0.3013306,0.0279541c1.8106689,1.630249,4.4333687,2.6757507,7.871254,2.5896606 c0.6728859-0.0168457,1.3066978-0.0823975,1.9136086-0.1785583c0.5999031,0.0625916,1.2192001,0.1000977,1.8784142,0.0835876 c0.3956299-0.0099182,0.7776451-0.0368042,1.1500969-0.0749207c1.6374054,0.9138794,3.6924896,1.4500122,6.1802368,1.3877258 c2.7615814-0.0691833,4.9603806-0.8449707,6.6135712-2.0409546c1.7001495,1.3323364,4.0273743,2.1740723,6.9657822,2.1835327 c1.3117676,0.4514771,2.8219681,0.6936646,4.5374908,0.6507263c2.6829987-0.0671997,4.8371964-0.8001709,6.4762497-1.9367371 c0.7301483-0.051239,1.4041672-0.1691284,2.0513229-0.3159485c0.3427734,0.0151978,0.6883926,0.0267944,1.0488739,0.0177612 c0.4456635-0.0111694,0.8721695-0.0458374,1.2886124-0.0925903c0.431488,0.0275879,0.876236,0.0383606,1.3367844,0.026825 c3.7502899-0.0939026,6.4647522-1.4888306,8.180748-3.473053c0.1653824,0.001709,0.3196411,0.0178833,0.4895096,0.0136108 c1.8675766-0.0467529,3.4719467-0.4229126,4.8327789-1.0253906c1.2345505,0.3816223,2.6295853,0.5891418,4.203804,0.5497437 C132.51651,312.2394409,132.1886597,293.7745056,118.367218,293.8049316z" }),
			_react2.default.createElement("path", { style: style.st19, d: "M67.9876022,331.0114746c-0.7990723,0-1.546875,0.0675964-2.2558594,0.1806641 c-1.7707481-1.7541504-4.4221153-2.9231873-7.9572716-2.9231873c-1.7158203,0-3.2194824,0.2807922-4.5200195,0.7660217 c-1.3012695-0.4852295-2.8068848-0.7660217-4.5256348-0.7660217c-3.7419434,0-6.4863281,1.3200684-8.2519531,3.2525635 c-11.3779297,2.2377014-10.4987793,18.5370178,2.7077637,18.5370178c2.3461914,0,4.2995605-0.5191956,5.8662109-1.3826294 c1.6870117,1.156311,3.9086914,1.8814087,6.6811523,1.8814087c2.8105469,0,5.0544434-0.7486877,6.7502441-1.9362488 c1.5041504,0.7449036,3.3366661,1.1882019,5.5053673,1.1882019 C82.1436081,349.8092651,82.1670456,331.0114746,67.9876022,331.0114746z" }),
			_react2.default.createElement("rect", { x: "70.2379608", y: "390.8883667", style: style.st132, width: "50.4457092", height: "6.6203127" })
		);
	}

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Burger;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Burger() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { fill: "#FFCE8D", d: "M84.13434,361.64685c-23.73875,0-42.98285,3.76978-42.98285,8.41995 c0,15.16107,13.49446,23.88892,42.98285,23.88892s42.98284-8.72784,42.98284-23.88892 C127.11718,365.41663,107.87323,361.64685,84.13434,361.64685z" }),
			_react2.default.createElement("path", { fill: "#AD6636", d: "M127.11726,362.00894c0-3.41483-1.84582-6.52722-4.73934-7.89487 c-5.62027-2.65646-17.02717-6.13162-38.24351-6.13162s-32.62323,3.47516-38.24351,6.13162 c-2.89352,1.36765-4.73934,4.48004-4.73935,7.89487c0,3.41483,1.84582,6.52722,4.73934,7.89487 c5.62027,2.65649,17.02717,6.13165,38.24351,6.13165s32.62324-3.47516,38.24351-6.13165 C125.27142,368.53616,127.11725,365.42377,127.11726,362.00894z" }),
			_react2.default.createElement("path", { fill: "#FFCE61", d: "M39.57019,355.39557c9.56087,2.13794,19.06597,6.41434,28.549,11.5275 c12.56584-3.71191,41.57589-9.84686,62.34962-8.31848c0,0-2.99178-7.16156-19.27512-8.87753 c-8.15985-0.85989-50.03115,0.07019-50.03115,0.07019S45.24285,348.67633,39.57019,355.39557z" }),
			_react2.default.createElement("path", { fill: "#FFBB10", d: "M130.46881,358.60458c-20.77374-1.52838-49.78378,3.32489-62.34962,7.0368 c-9.48302-5.11316-18.98812-8.10788-28.549-10.24582v2.41299c9.56087,2.13791,19.06597,5.27158,28.549,10.38474 c12.56584-3.71191,41.57589-8.70413,62.34962-7.17572V358.60458z" }),
			_react2.default.createElement("path", { fill: "#75C69F", d: "M129.65887,347.91803c0,2.0264-0.93916,1.9747-6.03466,3.54242 c-2.72267,0.83768-5.2101,4.26025-9.01715,4.89087c-3.05296,0.50571-6.88684-1.81223-10.48766-1.47034 c-3.18277,0.30215-6.29965,3.30652-9.81253,3.46057c-3.25426,0.14273-6.71087-2.56192-10.17248-2.56192 c-3.4611,0-6.9172,2.70465-10.17101,2.56198c-3.51431-0.15408-6.63251-3.15854-9.81643-3.46088 c-3.60055-0.34189-7.43422,1.97601-10.48693,1.47031c-3.80747-0.63077-6.29504-4.05347-9.01776-4.89133 c-5.09402-1.56754-6.03234-1.51562-6.03234-3.54169c0-2.0264,0.93916-1.9747,6.03466-3.54242 c2.72267-0.83768,5.2101-5.51312,9.01715-6.14374c3.05296-0.50571,6.88684,3.06509,10.48766,2.72321 c3.18277-0.30219,6.29965-4.55939,9.81253-4.71344c3.25426-0.14273,6.71087,3.81476,10.17248,3.81476 c3.4611,0,6.9172-3.95749,10.17101-3.81482c3.51431,0.15408,6.63251,4.41141,9.81643,4.71375 c3.60055,0.34189,7.43422-3.22888,10.48693-2.72318c3.80747,0.63077,6.29504,5.30634,9.01776,6.14417 C128.72055,345.94388,129.65887,345.89197,129.65887,347.91803z" }),
			_react2.default.createElement("path", { fill: "#FFCE8D", d: "M41.15154,341.17172c0,4.65027,19.24408,8.42007,42.98286,8.42007s42.98286-3.76981,42.98286-8.42007 c0-23.73877-19.24409-38.19781-42.98286-38.19781S41.15154,317.43295,41.15154,341.17172z" }),
			_react2.default.createElement("path", { fill: "#F8FAFF", d: "M89.70567,322.57483c0.39602,0.2558,0.39602,0.83029,0,1.08609 c-0.57935,0.37424-1.33677,0.80444-1.75725,0.80444c-0.74419,0-1.34748-0.6033-1.34748-1.34747 c0-0.7442,0.60329-1.3475,1.34748-1.3475C88.3689,321.77039,89.12631,322.20059,89.70567,322.57483z" }),
			_react2.default.createElement("path", { fill: "#F8FAFF", d: "M72.43877,314.17578c-0.09914-0.46094,0.30707-0.86716,0.76799-0.76801 c0.67429,0.14505,1.51405,0.3764,1.81138,0.67374c0.52622,0.52625,0.52622,1.37939,0,1.90564 c-0.52622,0.52621-1.3794,0.52621-1.90562,0C72.81519,315.68982,72.58381,314.85007,72.43877,314.17578z" }),
			_react2.default.createElement("path", { fill: "#F8FAFF", d: "M58.39066,319.68686c-0.09914-0.46091,0.30707-0.86713,0.768-0.76797 c0.67429,0.14502,1.51405,0.3764,1.81137,0.67374c0.52622,0.52621,0.52622,1.37939,0,1.90561 c-0.52622,0.52625-1.3794,0.52625-1.90562,0C58.76708,321.20093,58.5357,320.36115,58.39066,319.68686z" }),
			_react2.default.createElement("path", { fill: "#F8FAFF", d: "M88.46361,311.70828c-0.46092,0.09915-0.86714-0.30707-0.768-0.76797 c0.14503-0.67429,0.37642-1.51407,0.67375-1.81137c0.52622-0.52625,1.37939-0.52625,1.90562,0 c0.52623,0.52621,0.52623,1.37939,0,1.90561C89.97765,311.33188,89.1379,311.56326,88.46361,311.70828z" }),
			_react2.default.createElement("path", { fill: "#F8FAFF", d: "M101.31787,317.88849c-0.25582,0.39603-0.83029,0.39603-1.08611,0 c-0.37424-0.57935-0.80443-1.33676-0.80443-1.75723c0-0.7442,0.60329-1.3475,1.34748-1.3475 c0.74419,0,1.34747,0.6033,1.34747,1.3475C102.12229,316.55173,101.69211,317.30914,101.31787,317.88849z" }),
			_react2.default.createElement("path", { fill: "#F8FAFF", d: "M111.51496,314.79657c-0.25581,0.39603-0.83029,0.39603-1.08611,0 c-0.37424-0.57935-0.80443-1.33676-0.80443-1.75723c0-0.7442,0.60329-1.34747,1.34748-1.34747s1.34748,0.60327,1.34748,1.34747 C112.31939,313.45981,111.88921,314.21722,111.51496,314.79657z" }),
			_react2.default.createElement("path", { fill: "#F8FAFF", d: "M79.54465,306.07864c-0.25581,0.39603-0.83029,0.39603-1.08611,0 c-0.37424-0.57935-0.80443-1.33676-0.80443-1.75723c0-0.7442,0.60329-1.3475,1.34748-1.3475s1.34748,0.6033,1.34748,1.3475 C80.34908,304.74188,79.91889,305.4993,79.54465,306.07864z" }),
			_react2.default.createElement("path", { fill: "#F8FAFF", d: "M99.29466,307.77951c-0.25581,0.39603-0.83029,0.39603-1.08611,0 c-0.37424-0.57935-0.80443-1.33676-0.80443-1.75723c0-0.7442,0.60329-1.34747,1.34748-1.34747s1.34748,0.60327,1.34748,1.34747 C100.09909,306.44275,99.66891,307.20016,99.29466,307.77951z" }),
			_react2.default.createElement("path", { fill: "#F8FAFF", d: "M64.10948,311.40256c-0.25582,0.39603-0.8303,0.39603-1.08611,0 c-0.37424-0.57935-0.80442-1.33676-0.80442-1.75723c0-0.7442,0.60329-1.34747,1.34748-1.34747 c0.74419,0,1.34748,0.60327,1.34748,1.34747C64.9139,310.0658,64.48372,310.82321,64.10948,311.40256z" })
		);
	}

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Cactus;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Cactus() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { fill: "#75C69F", d: "M95.82006,292.11142c-4.41797,0-8,3.58154-8,8v6.03125c0,4.19385-1.00977,7.23389-3.08691,9.29395 c-1.38525,1.37384-3.12183,2.21136-4.73828,2.72797v-42.40912c0-5.79883-4.70117-10.5-10.5-10.5s-10.5,4.70117-10.5,10.5v29.10162 c-1.59521-0.51007-3.30908-1.32874-4.67383-2.65631c-2.12012-2.06201-3.15039-5.12207-3.15039-9.35645v-6.03076 c0-4.41846-3.58203-8-8-8s-8,3.58154-8,8v6.03076c0,10.78613,4.34766,17.27832,7.99414,20.82568 c5.14209,5.00116,11.4397,6.88812,15.83008,7.59747v34.07489c0,5.79883,4.70117,10.5,10.5,10.5s10.5-4.70117,10.5-10.5v-20.77673 c4.39062-0.70923,10.68872-2.59601,15.83105-7.59729c3.64648-3.54736,7.99414-10.03955,7.99414-20.82568v-6.03125 C103.82006,295.69296,100.23803,292.11142,95.82006,292.11142z" }),
			_react2.default.createElement("polygon", { fill: "#D1AF79", points: "96.50246,345.14954 93.84914,345.14954 93.84914,345.14771 45.14065,345.14771 45.14065,345.14954 42.34182,345.14954 43.67385,360.37219 46.47268,360.37219 48.74465,386.33661 69.49465,386.33661 90.24563,386.33661 92.51711,360.37219 95.1719,360.37219 \t" }),
			_react2.default.createElement("polygon", { fill: "#CEA365", points: "92.51717,360.37219 46.47284,360.37219 46.80064,364.12 92.18935,364.12 \t\t" })
		);
	}

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Cake;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Cake() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { fill: "#FFEAAE", d: "M31.0144,366.55817c-3.23416-13.16168-3.1056-25.93146,0.21358-39.08136l72.21318,13.05627 c0,0-0.10125,39.09985-0.57729,39.01431L31.0144,366.55817z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M30.03949,327.13174c8.83332-9.3699,26.00292-15.04514,39.38206-14.8898l35.06902,28.29114 L30.03949,327.13174z" }),
			_react2.default.createElement("path", { fill: "#F8FAFF", d: "M28.96184,332.00317l75.83931,13.82837c0.49878-1.76868,0.241-3.69891-0.31051-5.29846l-74.45117-13.40131 C29.62957,328.75549,29.27166,330.37927,28.96184,332.00317z" }),
			_react2.default.createElement("path", { fill: "#F8FAFF", d: "M28.69353,353.59875l0.01953-0.22705c0.18359-2.14844,0.38623-3.61523,0.60156-5.16846 c0.15039-1.08545,0.30908-2.23193,0.47607-3.7124l0.03027-0.26562l74.88623,13.4585l0.02979,0.17236 c-0.32788,2.89172-0.32837,5.94293-0.00049,9.1543l-0.04346,0.24707L28.69353,353.59875z" }),
			_react2.default.createElement("path", { fill: "#F8FAFF", d: "M34.94548,328.01331c-0.60107-0.10797-4.90601-0.88153-4.90601-0.88153 c-3.36084,13.31488-3.35791,26.63593,0,39.96295l5.41455,0.97296l-0.53467-1.94989 c-3.18018-12.62158-3.18018-25.40918-0.01562-37.94922L34.94548,328.01331z" }),
			_react2.default.createElement("path", { fill: "#FFEAAE", d: "M34.91936,366.1178l0.53467,1.94989l68.15854,12.3118c0.43311,0.07782,0.85276-0.2178,0.91466-0.65347 c0.56614-3.98511,0.99074-8.07504,0.41356-12.29294c-0.03223-0.23547-0.21498-0.42578-0.44892-0.46783L32.85711,354.0932 C33.22673,358.10925,33.91253,362.12189,34.91936,366.1178z" }),
			_react2.default.createElement("path", { fill: "#FFEAAE", d: "M33.86492,332.88422c-0.7561,4.01398-1.1875,8.04791-1.2998,12.08826l71.76747,12.89584 c0.30229,0.05432,0.59546-0.1521,0.6423-0.45566c0.5731-3.71353,0.56909-7.44281,0.00223-11.18747 c-0.05234-0.34573-0.32418-0.62112-0.66834-0.68298L33.86492,332.88422z" }),
			_react2.default.createElement("path", { fill: "#A2D8C0", d: "M52.32873,338.13672c-0.96387,0-1.74805,0.78369-1.74805,1.74707s0.78418,1.74756,1.74805,1.74756 c0.96289,0,1.74707-0.78418,1.74707-1.74756S53.29162,338.13672,52.32873,338.13672z" }),
			_react2.default.createElement("path", { fill: "#A2D8C0", d: "M84.36388,343.85107c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74707,1.74707,1.74707 c0.96387,0,1.74805-0.78369,1.74805-1.74707S85.32775,343.85107,84.36388,343.85107z" }),
			_react2.default.createElement("path", { fill: "#A2D8C0", d: "M95.34924,368.47998c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74707,1.74707,1.74707 c0.96387,0,1.74805-0.78369,1.74805-1.74707S96.3131,368.47998,95.34924,368.47998z" }),
			_react2.default.createElement("path", { fill: "#A2D8C0", d: "M67.48888,367.479c-0.96387,0-1.74805,0.78418-1.74805,1.74756s0.78418,1.74707,1.74805,1.74707 c0.96289,0,1.74707-0.78369,1.74707-1.74707S68.45177,367.479,67.48888,367.479z" }),
			_react2.default.createElement("circle", { fill: "#A2D8C0", cx: "61.60412", cy: "363.30859", r: "1.74707" }),
			_react2.default.createElement("circle", { fill: "#A2D8C0", cx: "45.29357", cy: "360.89502", r: "1.74707" }),
			_react2.default.createElement("circle", { fill: "#FC7E7E", cx: "45.41759", cy: "342.51709", r: "1.74707" }),
			_react2.default.createElement("path", { fill: "#FC7E7E", d: "M72.27795,341.77051c-0.96289,0-1.74707,0.78418-1.74707,1.74756s0.78418,1.74707,1.74707,1.74707 s1.74707-0.78369,1.74707-1.74707S73.24084,341.77051,72.27795,341.77051z" }),
			_react2.default.createElement("path", { fill: "#FC7E7E", d: "M92.47131,350.10205c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756 s1.74707-0.78418,1.74707-1.74756S93.4342,350.10205,92.47131,350.10205z" }),
			_react2.default.createElement("path", { fill: "#FC7E7E", d: "M87.4381,370.1123c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74707,1.74707,1.74707 c0.96387,0,1.74805-0.78369,1.74805-1.74707S88.40197,370.1123,87.4381,370.1123z" }),
			_react2.default.createElement("path", { fill: "#FC7E7E", d: "M55.40197,365.39893c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756 c0.96387,0,1.74805-0.78418,1.74805-1.74756S56.36584,365.39893,55.40197,365.39893z" }),
			_react2.default.createElement("path", { fill: "#C8B8F2", d: "M38.25549,335.88867c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756 s1.74707-0.78418,1.74707-1.74756S39.21838,335.88867,38.25549,335.88867z" }),
			_react2.default.createElement("path", { fill: "#C8B8F2", d: "M60.4508,343.52588c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756 s1.74707-0.78418,1.74707-1.74756S61.41369,343.52588,60.4508,343.52588z" }),
			_react2.default.createElement("circle", { fill: "#C8B8F2", cx: "78.16271", cy: "349.43555", r: "1.74707" }),
			_react2.default.createElement("circle", { fill: "#C8B8F2", cx: "101.51134", cy: "349.29053", r: "1.74707" }),
			_react2.default.createElement("path", { fill: "#C8B8F2", d: "M101.51134,373.36084c-0.96289,0-1.74707,0.78418-1.74707,1.74756s0.78418,1.74707,1.74707,1.74707 s1.74707-0.78369,1.74707-1.74707S102.47424,373.36084,101.51134,373.36084z" }),
			_react2.default.createElement("circle", { fill: "#C8B8F2", cx: "79.31603", cy: "367.47119", r: "1.74707" }),
			_react2.default.createElement("path", { fill: "#C8B8F2", d: "M38.25549,361.70654c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756 s1.74707-0.78418,1.74707-1.74756S39.21838,361.70654,38.25549,361.70654z" }),
			_react2.default.createElement("path", { fill: "#b4edd2", d: "M53.57673,295.68884h-0.01314v26.36365c0,0.00226,0,0.00916,0,0.01025 c0,0.00305,0.0025,0.00586,0.0025,0.00885c0.01439,0.73932,1.80632,1.3374,4.01807,1.3374 c1.90017,0,3.48375-0.44305,3.90295-1.03668c0.0025-0.00348,0.00688-0.00659,0.00938-0.01007 c0.0657-0.09662,0.10762-0.19623,0.10762-0.2995v-26.3739H53.57673z" }),
			_react2.default.createElement("ellipse", { fill: "#b4edd2", cx: "57.58385", cy: "295.68884", rx: "4.02027", ry: "1.34625" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M58.74142,295.66122c0,0,0.00083,0.20026-1.15734,0.20026c-1.15817,0-1.15817-0.20026-1.15817-0.20026 v-4.18814c0,0,0-0.39059,1.15776-0.39059s1.15776,0.39059,1.15776,0.39059V295.66122z" })
		);
	}

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Campfire;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Campfire() {
		// 8
		var style = {
			st25: {
				fill: "#EAB049"
			},
			st78: {
				fill: "#AD6636"
			},
			st79: {
				fill: "#E2935D"
			},
			st11: {
				fill: "#FCB47E"
			},
			st80: {
				fill: "#E57B4C"
			},
			st81: {
				fill: "#FFD180"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st25, d: "M47.3127594,328.740387C45.3333321,356.6666565,66.9141006,363.7528381,66.5,363.4296875 c-2.0155411-4.0787659-19.1872406-34.6893005,0-66.096344c6.5,26.333313,36.7392654,43.333313,36.7392654,72.096344 c0,18.4279175-16.5847015,33.5917969-36.7392654,33.5917969s-36.7392654-15.1638794-36.7392654-33.5917969 C29.7607327,357.0037842,35.3333321,337.3333435,47.3127594,328.740387" }),
			_react2.default.createElement("path", { style: style.st78, d: "M24.2272949,353.2215576c-0.0014648-0.0006104-0.0026855-0.0014648-0.0039062-0.0020752 c-0.0031738-0.0014648-0.0063477-0.0021973-0.0095215-0.0036621c-0.4082031-0.1899414-0.8237305-0.348877-1.2424316-0.4914551 c-0.076416-0.026123-0.1523438-0.0539551-0.229248-0.0786133c-0.4060059-0.1296387-0.815918-0.2368164-1.2290039-0.3236084 c-0.0820312-0.0172119-0.1638184-0.0317383-0.2458496-0.0472412c-0.4255371-0.0805664-0.8530273-0.1452637-1.2832031-0.1818848 c-0.0285645-0.0024414-0.057373-0.0024414-0.0856934-0.0046387c-0.4189453-0.032959-0.8393555-0.0419922-1.2600098-0.0344238 c-0.0698242,0.0012207-0.1394043,0-0.2092285,0.0024414c-0.4240723,0.0141602-0.8481445,0.0505371-1.2719727,0.1046143 c-0.0842285,0.0107422-0.1679688,0.0230713-0.2521973,0.0352783c-0.4289551,0.0626221-0.8566895,0.1408691-1.2819824,0.243042 c-0.0454102,0.0108643-0.0905762,0.0247803-0.1357422,0.0361328c-0.4104004,0.1026611-0.8178711,0.2242432-1.2226562,0.3626709 c-0.0568848,0.0195312-0.1140137,0.036377-0.1708984,0.0566406c-0.4162598,0.1477051-0.8278809,0.3171387-1.2358398,0.5018311 c-0.0795898,0.0360107-0.1586914,0.0726318-0.237793,0.1099854c-0.40625,0.1917725-0.8078613,0.3985596-1.2028809,0.6259766 c-0.0537109,0.0308838-0.1064453,0.0646973-0.1599121,0.0964355c-0.1782227,0.1051025-0.3569336,0.2084961-0.5322266,0.3206787 l0.0075684,0.0164795c-2.300293,1.4716797-4.3535156,3.5454102-5.9262695,6.1184082l-0.0041504-0.0020752 c-0.020752,0.0338135-0.0395508,0.069458-0.0600586,0.1033936c-0.1325684,0.2199707-0.262207,0.4416504-0.3876953,0.6685791 c-0.2294922,0.4080811-0.4511719,0.8233643-0.652832,1.2562256c-4.0319824,8.6464844-1.3815918,18.4162598,5.9199219,21.8212891 l99.1555176,46.2368164l14.6013184-31.3125L24.2272949,353.2215576z" }),
			_react2.default.createElement("polygon", { style: style.st79, points: "14.7849979,421.2447815 15.6047935,414.9579773 6.2583299,425.2208252 \t\t" }),
			_react2.default.createElement("path", { style: style.st78, d: "M129.2991333,362.7172546c-0.2002716-0.4294739-0.4198608-0.8412781-0.6472473-1.2464294 c-0.1292419-0.2343445-0.2633209-0.4636841-0.4005585-0.6906433c-0.0179901-0.0297546-0.0346069-0.0610962-0.0528107-0.0911255 l-0.0038147,0.0016479c-1.5727615-2.5729065-3.6262665-4.6467285-5.9265518-6.1184387l0.0072784-0.0160217l0,0 c-0.0896759-0.0576172-0.1846924-0.1004639-0.275177-0.1559448c-0.3180389-0.1954346-0.6405945-0.3756104-0.9665756-0.5474854 c-0.1813126-0.0957642-0.3605957-0.1950073-0.5439224-0.2831116c-0.3770981-0.1815186-0.7592163-0.3406677-1.1438599-0.4904785 c-0.1364136-0.0528564-0.2700653-0.116272-0.4071884-0.1652527c-0.5229111-0.1871643-1.0508041-0.3453674-1.583107-0.4728088 c-0.1162033-0.0275574-0.2333984-0.0409851-0.3500595-0.0661621c-0.4175568-0.0887146-0.8357391-0.1647644-1.2557678-0.2154846 c-0.1889343-0.022644-0.3774719-0.0315552-0.5666962-0.0466309c-0.3521805-0.0278625-0.7034912-0.0461121-1.0551605-0.0462341 c-0.2047577-0.0000305-0.4079437,0.0071716-0.6119461,0.0167847c-0.3421631,0.0158997-0.682106,0.046936-1.0219879,0.0899963 c-0.1999969,0.0253906-0.3987885,0.0496521-0.5978088,0.0849304c-0.3608932,0.0632629-0.7174377,0.1497192-1.073822,0.2454834 c-0.1688995,0.0452576-0.3376083,0.0800171-0.5051956,0.1327209c-0.5193634,0.163147-1.0304413,0.2391968-1.533905,0.4740601 L108.7797546,353h-0.0019913L9.6222658,399.3500366l14.6012278,31.3688354l99.1554337-46.2088623 C130.6804962,381.1053467,133.3310242,371.3637695,129.2991333,362.7172546z" }),
			_react2.default.createElement("path", { style: style.st11, d: "M15.59233,415.1017761l-8.4853773,9.50177c-0.905365-1.1388855-1.7089648-2.4068298-2.3614302-3.8060303 c-3.7572303-8.0574036-1.3515511-17.1595154,5.3634634-20.290802c6.7150154-3.1312561,15.2339764,0.8766174,18.9912071,8.934021 s1.3515511,17.1595154-5.3634644,20.2907715c-3.3287125,1.5522156-7.0995693,1.3459167-10.5150309-0.2341309L15.59233,415.1017761 z" }),
			_react2.default.createElement("path", { style: style.st78, d: "M30.160593,408.9909058c-4.0081234-8.6576843-13.1840611-12.9326477-20.495039-9.5479431 c-7.3110166,3.3844604-9.9884109,13.1470032-5.9803486,21.8046875c0.6966441,1.5046692,1.5574725,2.8673401,2.5294988,4.0900269 l3.0725169-2.6615295c-0.7577572-0.9728394-1.403574-2.0150146-1.9115882-3.10495 c-3.0813799-6.6071777-1.3050895-13.9799194,3.959168-16.4347534c5.2623978-2.4559631,12.0543137,0.92276,15.1356087,7.5309143 c3.0804062,6.6070862,1.3041172,13.9798584-3.9600983,16.4341736c-2.5059834,1.169342-5.4528484,1.0473022-8.22754-0.3031921 l-0.4933329-0.2695923l-0.3463678,1.8111877c-0.0116348-0.0056763-0.0237226-0.0096741-0.0353565-0.0153503l-0.4503717,2.3206482 c3.640686,1.6183777,7.6527424,1.8029785,11.2227402,0.1500854 C31.4911613,427.4108582,34.1686172,417.6483154,30.160593,408.9909058z" }),
			_react2.default.createElement("path", { style: style.st11, d: "M109.2638931,429.7250061c-6.7150116-3.1312866-9.120697-12.2333679-5.3634644-20.290802 c3.7572327-8.0574036,12.2761917-12.0652466,18.9912109-8.9339905s9.1206894,12.2333679,5.3634567,20.2907715 C124.4978714,428.8483887,115.9789124,432.8562622,109.2638931,429.7250061z" }),
			_react2.default.createElement("path", { style: style.st78, d: "M123.3782883,399.4563904c-7.3015671-3.4046631-16.4892502,0.844635-20.5211411,9.4911499 c-4.0319901,8.646759-1.3816147,18.4163208,5.9199753,21.821228c7.3016968,3.4046326,16.4893799-0.8446655,20.5213852-9.4911804 C133.3303833,412.6308289,130.6798859,402.8612671,123.3782883,399.4563904z M125.5361938,419.5231323 c-2.157074,4.6255188-6.3185577,7.8564758-10.6019974,8.2312317c-1.5631256,0.1367493-3.0443115-0.1149902-4.4024048-0.7483215 c-5.2153244-2.4318848-6.9704285-9.7459717-3.9124451-16.3040466c2.1569443-4.6255188,6.3184357-7.8564453,10.6017532-8.2312012 c1.5632401-0.1367798,3.0444336,0.1149902,4.4026718,0.7485352c2.426445,1.1314392,4.1937866,3.3849182,4.9762878,6.3455505 C127.4351196,412.7243347,127.0573425,416.2609558,125.5361938,419.5231323z" }),
			_react2.default.createElement("polygon", { style: style.st79, points: "115.8529739,414.5727844 114.374649,403.1390381 98.3333359,396.5 \t" }),
			_react2.default.createElement("path", { style: style.st80, d: "M47.3127594,328.740387C45.3333321,356.6666565,66.9141006,363.7528381,66.5,363.4296875 c-2.0155411-4.0787659-19.1872406-34.6893005,0-66.096344c6.5,26.333313,36.7392654,43.333313,36.7392654,72.096344 c0,18.4279175-16.5847015,33.5917969-36.7392654,33.5917969s-36.7392654-15.1638794-36.7392654-33.5917969 C29.7607327,357.0037842,35.3333321,337.3333435,47.3127594,328.740387" }),
			_react2.default.createElement("path", { style: style.st81, d: "M52.7858887,352.2927246c-5.3242188,6.4748535-8.0266113,13.1838379-8.0266113,19.9611816 c0,7.5947266,9.6972656,16.7675781,21.7392578,16.7675781c6.4257812,0,12.8847656-2.6782227,17.2753906-7.1640625 c2.9033203-2.965332,4.5302734-6.4345703,4.4648438-9.5180664c-0.2373047-11.0908203-8.4492188-18.2519531-17.9580078-26.5439453 c-4.338623-3.7834473-8.786499-7.6669922-12.5891113-12.1130371c0.9409523,12.9323425,5.5307884,23.1647339,7.7665482,27.6852722 c0.369278,0.7466431-0.4172745,1.5385132-1.1632538,1.1678772 C61.5106201,361.1520996,56.6252289,358.0449829,52.7858887,352.2927246z" }),
			_react2.default.createElement("polygon", { style: style.st81, points: "50.668335,348.5983887 50.6679688,348.5976562 50.6677246,348.5979004 \t\t" })
		);
	}

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Coffee;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Coffee() {
		// 11
		var style = {
			st0: {
				fill: "#FFFFFF"
			},
			st16: {
				fill: "#E6E6E6"
			},
			st14: {
				fill: "#5E4C3E"
			},
			st31: {
				opacity: 0.3
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st0, d: "M90.2728348,329.9684143c-16.4505234-5.8594055-34.1504707-5.8594055-50.6009903,0 C36.7090263,331.0235291,35,333.8284912,35,336.9735413v23.5109558v23.5107117 c0,3.1450806,1.8161507,5.9500122,4.778965,7.0053406l0,0c16.4505196,5.8592224,34.1245689,5.8592224,50.5750923,0l0,0 C93.3168716,389.9452209,95,387.1402893,95,383.9952087v-23.5107117v-23.5109558 C95,333.8284912,93.2356491,331.0235291,90.2728348,329.9684143z" }),
			_react2.default.createElement("path", { style: style.st16, d: "M42.5571785,336.2410889c14.6497879,4.5523071,30.3394432,4.5523071,44.9892387,0 c0.9566803-0.2973022,0.9566803-1.6630859,0-1.9603577c-14.6497955-4.5523071-30.3394508-4.5523071-44.9892387,0 C41.6004944,334.5780334,41.6004944,335.9438171,42.5571785,336.2410889z" }),
			_react2.default.createElement("path", { style: style.st14, d: "M46.5190544,337.3415222c12.1649818,3.0676575,24.9005013,3.0676575,37.0654869,0 C71.4195557,334.2738647,58.6840363,334.2738647,46.5190544,337.3415222z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M98.9023438,381.0688477h-6.9707031c-3.0371094,0-5.5-2.4624023-5.5-5.5s2.4628906-5.5,5.5-5.5h6.9707031 c2.9902344,0,5.4228516-2.4326172,5.4228516-5.4223633v-7.4916992c0-2.9897461-2.4326172-5.4223633-5.4228516-5.4223633 h-6.9707031c-3.0371094,0-5.5-2.4624023-5.5-5.5s2.4628906-5.5,5.5-5.5h6.9707031 c9.0556641,0,16.4228516,7.3671875,16.4228516,16.4223633v7.4916992 C115.3251953,373.7016602,107.9580078,381.0688477,98.9023438,381.0688477z" }),
			_react2.default.createElement(
				"g",
				{ style: style.st31 },
				_react2.default.createElement("path", { style: style.st16, d: "M60.2207031,334.7641602c-0.4902344,0-0.9824219-0.1791992-1.3681641-0.5410156 c-0.8056641-0.7553711-0.8466797-2.0209961-0.0908203-2.8266602c0.0302734-0.0327148,3.4003906-3.7177734,3.1435547-7.6953125 c-0.125-1.949707-1.0947266-3.6547852-2.9648438-5.2128906c-2.7294922-2.2749023-4.2089844-4.9863281-4.3984375-8.0595703 c-0.3515625-5.7119141,4.0332031-10.4580078,4.2197266-10.6572266c0.7548828-0.8061523,2.0214844-0.847168,2.8271484-0.0913086 c0.8037109,0.7539062,0.8457031,2.0166016,0.0947266,2.8227539l0,0 c-0.0341797,0.0366211-3.4042969,3.7216797-3.1474609,7.6992188c0.125,1.949707,1.0947266,3.6547852,2.9648438,5.2128906 c2.7294922,2.2749023,4.2089844,4.9863281,4.3984375,8.0595703c0.3515625,5.7119141-4.0332031,10.4580078-4.2197266,10.6572266 C61.2861328,334.5517578,60.7539062,334.7641602,60.2207031,334.7641602z" })
			),
			_react2.default.createElement(
				"g",
				{ style: style.st31 },
				_react2.default.createElement("path", { style: style.st16, d: "M67.6181641,312.125c-0.4902344,0-0.9824219-0.1791992-1.3681641-0.5410156 c-0.8056641-0.7553711-0.8466797-2.0209961-0.0908203-2.8266602c0.0302734-0.0327148,3.4003906-3.7177734,3.1435547-7.6953125 c-0.125-1.949707-1.0947266-3.6547852-2.9648438-5.2128906c-2.7294922-2.2744141-4.2089844-4.9858398-4.3984375-8.059082 c-0.3515625-5.7119141,4.0332031-10.4584961,4.2197266-10.6577148c0.7548828-0.8066406,2.0214844-0.8466797,2.8271484-0.0913086 c0.8046875,0.7543945,0.8466797,2.0170898,0.0947266,2.8232422c-0.0507812,0.0546875-3.4033203,3.7314453-3.1474609,7.6992188 c0.125,1.9492188,1.0947266,3.6542969,2.9648438,5.2124023c2.7294922,2.2749023,4.2089844,4.9863281,4.3984375,8.0595703 c0.3515625,5.7119141-4.0332031,10.4580078-4.2197266,10.6572266C68.6835938,311.9125977,68.1513672,312.125,67.6181641,312.125z " })
			)
		);
	}

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Donut;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Donut() {
		// 6
		var style = {
			st71: {
				fill: "#F7D9A4"
			},
			st72: {
				fill: "#F79AC0"
			},
			st73: {
				fill: "#F26DAA"
			},
			st0: {
				fill: "#FFFFFF"
			},
			st74: {
				fill: "#F77272"
			},
			st75: {
				fill: "#6AB0E5"
			},
			st76: {
				fill: "#FFE35A"
			},
			st77: {
				fill: "#BDED9D"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st71, d: "M131.9003906,384.1782532c0-14.5200806-20.5725403-25.8941956-46.1197205-25.8941956 s-46.1197166,11.374115-46.1197166,25.8941956v7.0634766c0,14.5203552,20.5725365,25.8944397,46.1197166,25.8944397 s45.8395844-11.3740845,45.8395844-25.8944397L131.9003906,384.1782532z" }),
			_react2.default.createElement("path", { style: style.st72, d: "M86.5531158,402.9390869c-26.8147354,0-39.6403008-8.0298462-44.899353-12.8163147 c-1.6682854-1.5189819-2.624588-3.6851501-2.624588-5.9444885c0-14.8745422,20.5352211-26.526001,46.7514954-26.526001 c26.1286697,0,46.5960236,11.6514587,46.5960236,26.526001l0.001236,0.3023071 c0.0074005,2.858429-1.2438202,5.5533447-3.4352875,7.393158 C124.0216827,396.0061951,111.9698029,402.9390869,86.5531158,402.9390869z" }),
			_react2.default.createElement("path", { style: style.st73, d: "M86.3408813,380.0377808c-4.5483017,0-7.4727402-1.2129517-8.5178833-1.7348938 c-0.9377975-0.4670715-1.3178482-1.6053772-0.8514175-2.5419312c0.467659-0.9378052,1.6090546-1.3172302,2.5419083-0.8501892 c0.6293106,0.3134155,2.9799652,1.3363647,6.8273926,1.3363647c3.8474197,0,6.1980743-1.0229492,6.8273849-1.3363647 c0.9365616-0.4689026,2.0754852-0.0863647,2.5419159,0.8501892s0.0863724,2.0748596-0.8514175,2.5419312 C93.8136139,378.8248291,90.889183,380.0377808,86.3408813,380.0377808z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M67.7750244,392.9589844c-0.3306961,0-0.6613922-0.1289368-0.9094086-0.3862305 c-0.4849396-0.5015869-0.4701309-1.3017883,0.0320816-1.7867432l4.2126694-4.0664368 c0.5034485-0.4830933,1.3030396-0.4707336,1.7867432,0.032074c0.4849396,0.5016174,0.4701309,1.3018188-0.0320816,1.7867432 l-4.2126694,4.0664673C68.4068069,392.841156,68.0909119,392.9589844,67.7750244,392.9589844z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M51.4549446,385.6608582c-0.3788185,0-0.7527008-0.1690674-1.0007248-0.4911194l-3.5796585-4.6328125 c-0.4269409-0.5521851-0.3257599-1.3456116,0.227047-1.7725525c0.552803-0.4275818,1.3474617-0.3233032,1.7719345,0.2276611 l3.5796585,4.6328125c0.4269447,0.5521851,0.3257599,1.3456116-0.2270432,1.7725525 C51.9966431,385.5751038,51.7239456,385.6608582,51.4549446,385.6608582z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M53.7278595,371.5637207c-0.1221581,0-0.2455521-0.0179138-0.3689461-0.055542l-5.6008492-1.708374 c-0.6675644-0.2036133-1.0426788-0.9100342-0.8390808-1.5776062c0.2023659-0.6669312,0.9081802-1.0451355,1.5769768-0.8396912 l5.6008492,1.7084045c0.6675606,0.2035828,1.0426788,0.9100037,0.839077,1.5775757 C54.7705383,371.2126465,54.2695618,371.5637207,53.7278595,371.5637207z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M65.6390762,376.1286621c-0.0641632,0-0.1307983-0.0049133-0.1961975-0.0154114 c-0.6897659-0.1073608-1.1611328-0.7539368-1.0537796-1.4430847l0.9044724-5.784729 c0.1073532-0.6885376,0.758873-1.1598816,1.4437103-1.0531616c0.6897736,0.1073608,1.1611404,0.7539368,1.0537872,1.4430847 l-0.90448,5.784729C66.7891083,375.6838379,66.2511139,376.1286621,65.6390762,376.1286621z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M78.2746201,364.2378235c-0.2566605,0-0.5145569-0.0777588-0.7378998-0.2393799 c-0.5663757-0.4084473-0.6934738-1.1981812-0.2850418-1.763916l3.427887-4.7469788 c0.407196-0.5657654,1.1981583-0.6940918,1.763298-0.2844238c0.5663757,0.4084473,0.6934738,1.1981506,0.2850418,1.763916 l-3.427887,4.7469788C79.0532303,364.0558167,78.6670074,364.2378235,78.2746201,364.2378235z" }),
			_react2.default.createElement("path", { style: style.st74, d: "M100.9433136,367.3405457c-0.1221542,0-0.2455521-0.0178833-0.3689423-0.0555115 c-0.6675644-0.2036133-1.0426788-0.9100342-0.8390808-1.5776062l1.7090073-5.6002197 c0.2023621-0.6663208,0.9057083-1.0439148,1.576973-0.8396912c0.6675644,0.2035828,1.0426788,0.9100342,0.8390808,1.5775757 l-1.7090073,5.6002502C101.9859924,366.989502,101.4850159,367.3405457,100.9433136,367.3405457z" }),
			_react2.default.createElement("path", { style: style.st74, d: "M85.9151688,390.8137817c-0.2455521,0-0.494812-0.0715637-0.7132187-0.2214966 c-0.5750122-0.3942261-0.7218552-1.1802673-0.3282242-1.7565002l3.3094254-4.8302612 c0.3960953-0.5750122,1.1808777-0.7236938,1.7571259-0.3276062c0.5750198,0.3942261,0.7218552,1.1802673,0.3282318,1.7565002 l-3.3094254,4.8302612C86.7135315,390.6219177,86.3174362,390.8137817,85.9151688,390.8137817z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M118.9711685,376.8067322c-0.2011261,0-0.4059601-0.0481262-0.595993-0.1499329l-5.1590958-2.7689514 c-0.6157379-0.3300781-0.8464813-1.0963745-0.5157852-1.7114868c0.3294601-0.6138916,1.0932693-0.8458557,1.7102356-0.5157776 l5.1591034,2.7689514c0.6157379,0.3300781,0.8464813,1.096344,0.5157852,1.7114868 C119.8583755,376.5654907,119.4215622,376.8067322,118.9711685,376.8067322z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M99.9388885,375.5857239c-0.4429855,0-0.8736267-0.2332153-1.1043701-0.6477966 c-0.3405685-0.6089478-0.1221619-1.3789368,0.4874039-1.7188721l5.1122131-2.854126 c0.6083298-0.3405457,1.3795395-0.1221619,1.7188721,0.4874268c0.3405685,0.6089478,0.1221619,1.3789062-0.4874039,1.7188721 l-5.1122131,2.8540955C100.358429,375.5345154,100.1474228,375.5857239,99.9388885,375.5857239z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M105.6828766,394.0757141c-0.0394821,0-0.0802078-0.0018616-0.1209259-0.0055542 c-0.6947098-0.0666504-1.2043228-0.6836243-1.1376877-1.3783264l0.5565033-5.8284912 c0.0653992-0.6934814,0.6799011-1.1975403,1.3770752-1.1376953c0.6947098,0.0666199,1.2043304,0.6835938,1.1376953,1.3782959 l-0.5565109,5.8285217C106.8773346,393.5858154,106.3269958,394.0757141,105.6828766,394.0757141z" }),
			_react2.default.createElement("path", { style: style.st75, d: "M60.2998238,370.4981995c-0.3788223,0-0.7527046-0.1690369-1.0007248-0.4910889l-3.5796585-4.632843 c-0.4269447-0.5521851-0.3257599-1.3456116,0.2270432-1.7725525c0.5528069-0.4275513,1.3486977-0.3226624,1.7719383,0.2276611 l3.5796585,4.632843c0.4269409,0.5521851,0.3257599,1.3456116-0.227047,1.7725525 C60.8415222,370.4124451,60.568821,370.4981995,60.2998238,370.4981995z" }),
			_react2.default.createElement("path", { style: style.st75, d: "M108.3272095,368.8570557c-0.3788147,0-0.7527008-0.1690369-1.0007248-0.4910889 c-0.4269409-0.5521851-0.3257599-1.3456116,0.2270432-1.7725525l4.6334457-3.5796814 c0.554039-0.4281616,1.3474579-0.3232727,1.7719345,0.2276611c0.4269485,0.5522156,0.3257599,1.3456116-0.2270432,1.772583 l-4.6334457,3.5796509C108.8689117,368.7713013,108.5962067,368.8570557,108.3272095,368.8570557z" }),
			_react2.default.createElement("path", { style: style.st75, d: "M86.9035568,372.0899963c-0.4244766,0-0.8403168-0.2141113-1.0784683-0.6033936l-3.0601654-4.9913025 c-0.3652496-0.5947571-0.1776886-1.3727417,0.4170685-1.7373657c0.5935287-0.3658752,1.3733749-0.1783142,1.7373886,0.4170532 l3.060173,4.9913025c0.365242,0.5947571,0.177681,1.3727417-0.4170761,1.7373657 C87.3564072,372.0301514,87.1281357,372.0899963,86.9035568,372.0899963z" }),
			_react2.default.createElement("path", { style: style.st74, d: "M125.1741867,381c-0.6848373,0-1.2475128-0.2287598-1.2635574-0.916687 c-0.016037-0.6977844,0.5367661-1.1169434,1.2339401-1.1329956l5.8538132-0.0556641 c0.6959381-0.0512085,1.2758942,0.5752869,1.2931671,1.2736816c0.016037,0.6977844-0.5367737,0.9782104-1.2339478,0.9942322 L125.2037964,381C125.1939316,381,125.1840591,381,125.1741867,381z" }),
			_react2.default.createElement("path", { style: style.st75, d: "M58.4945679,389h-0.0061684c-0.6971741,0-1.2610855-0.0404663-1.2573853-0.7382507l0.0283813-5.429718 C57.2630959,382.1361084,57.8282433,382,58.5229492,382c0.0024681,0,0.0037041,0,0.0037041,0 c0.6996422,0,1.2635536,0.412323,1.2598495,1.1101074l-0.0283813,5.2437744C59.7544212,389.0498352,59.1892776,389,58.4945679,389 z" }),
			_react2.default.createElement("path", { style: style.st75, d: "M99.4132309,388.8962402c-0.4664307,0-0.9143448-0.2585144-1.1339874-0.703949l-2.5925064-5.2498169 c-0.3097229-0.6256104-0.0518265-1.3832397,0.5737839-1.6923523c0.6231384-0.3096924,1.3832397-0.0512085,1.6917267,0.5731812 l2.5925064,5.2497864c0.3097229,0.6256104,0.0518265,1.3832397-0.5737839,1.6923523 C99.7920532,388.8542786,99.6007919,388.8962402,99.4132309,388.8962402z" }),
			_react2.default.createElement("path", { style: style.st74, d: "M54.7507973,379.8206177c-0.4244766,0-0.840313-0.2140808-1.0784645-0.6033936 c-0.3652458-0.5947571-0.1776848-1.3727722,0.4170723-1.7373962l4.9912834-3.0601501 c0.5947609-0.3658752,1.3721428-0.1783142,1.7373886,0.4170532c0.3652458,0.5947571,0.1776886,1.3727722-0.4170723,1.7373962 l-4.9912834,3.0601807C55.2036514,379.7607727,54.9753723,379.8206177,54.7507973,379.8206177z" }),
			_react2.default.createElement("path", { style: style.st74, d: "M108.1088028,381.5006409c-0.0974808,0-0.1974335-0.0111084-0.2961426-0.0351868l-5.6933975-1.3659668 c-0.6786652-0.162262-1.0969696-0.844635-0.9340897-1.5232849c0.1628799-0.6780701,0.8464813-1.1006775,1.5239105-0.9335022 l5.6933975,1.3659973c0.6786652,0.162262,1.0969696,0.844635,0.9340897,1.5232849 C109.1971359,381.1113281,108.6788864,381.5006409,108.1088028,381.5006409z" }),
			_react2.default.createElement("path", { style: style.st76, d: "M80.2624969,385.4627991c-0.1221619,0-0.2455597-0.0178833-0.3689499-0.0555115l-5.600853-1.7084045 c-0.6675568-0.2035828-1.0426788-0.9100342-0.8390808-1.5775757c0.2023697-0.6669617,0.9069519-1.0433044,1.5769806-0.8396912 l5.6008453,1.708374c0.6675644,0.2036133,1.0426788,0.9100342,0.8390808,1.5776062 C81.3051758,385.1117554,80.8041916,385.4627991,80.2624969,385.4627991z" }),
			_react2.default.createElement("path", { style: style.st76, d: "M78.1573944,370.0465698c-0.0641632,0-0.1307983-0.0049133-0.1961975-0.0154114l-5.7847061-0.90448 c-0.6897736-0.1073608-1.1611404-0.7539368-1.0537872-1.4430847c0.1073532-0.6885376,0.7564087-1.1605225,1.4437103-1.0531616 l5.7847061,0.90448c0.6897736,0.1073303,1.1611404,0.7539368,1.0537872,1.4430847 C79.3074265,369.6017456,78.7694244,370.0465698,78.1573944,370.0465698z" }),
			_react2.default.createElement("path", { style: style.st76, d: "M123.3183365,389.5810852c-0.2430801,0-0.4886398-0.0697327-0.7058105-0.2159424l-4.8530807-3.2748718 c-0.5787201-0.390564-0.7304916-1.1759644-0.3405685-1.7546692c0.3899231-0.5774841,1.1747131-0.7311096,1.7546616-0.3405762 l4.8530807,3.2748718c0.5787201,0.390564,0.7304916,1.1759644,0.3405685,1.7546692 C124.1228714,389.3861084,123.7243042,389.5810852,123.3183365,389.5810852z" }),
			_react2.default.createElement("path", { style: style.st76, d: "M89.1172409,362.5072021c-0.4997406,0-0.9723434-0.2986145-1.1710052-0.7903137 c-0.2615967-0.6472168,0.0505905-1.3832703,0.6971741-1.6454773l5.4281006-2.1958008 c0.6478195-0.2591248,1.3832474,0.0505981,1.6448364,0.6978149c0.2615967,0.6471863-0.0505905,1.3832397-0.6971741,1.6454468 l-5.4281006,2.1958008C89.4356003,362.4769897,89.2751846,362.5072021,89.1172409,362.5072021z" }),
			_react2.default.createElement("path", { style: style.st76, d: "M91.0458908,396.4720154c-0.4651947,0-0.9131165-0.2579041-1.1339951-0.7033386 c-0.3097153-0.625-0.0530548-1.3832703,0.5725479-1.6929626l5.2479477-2.5968323 c0.6256104-0.3097229,1.3820114-0.0530701,1.6929626,0.5725403c0.3097229,0.625,0.0530624,1.3832397-0.5725479,1.6929626 l-5.2479401,2.5968323C91.4247055,396.4300537,91.2334518,396.4720154,91.0458908,396.4720154z" }),
			_react2.default.createElement("path", { style: style.st77, d: "M124.2043076,374.6183167c-0.4738312,0-0.9266891-0.26651-1.1426239-0.7224731l-2.506134-5.291748 c-0.2998505-0.631134-0.0296173-1.3844604,0.6009293-1.683075c0.6268387-0.2992249,1.3832474-0.0296326,1.6818619,0.6009216 l2.5061264,5.291748c0.2998505,0.6311646,0.0296173,1.384491-0.6009293,1.6831055 C124.5695572,374.5794678,124.3856964,374.6183167,124.2043076,374.6183167z" }),
			_react2.default.createElement("path", { style: style.st77, d: "M65.6390762,384.4546814c-0.2566605,0-0.5145493-0.0777283-0.7378922-0.2393799 c-0.5663834-0.4084473-0.6934738-1.1981506-0.2850418-1.763916l3.427887-4.7469788 c0.408432-0.5657654,1.1969147-0.6934814,1.763298-0.2844238c0.5663757,0.4084473,0.6934738,1.1981506,0.2850342,1.763916 l-3.4278793,4.7469788C66.4176941,384.2726746,66.0314713,384.4546814,65.6390762,384.4546814z" }),
			_react2.default.createElement("path", { style: style.st74, d: "M70.1540604,363.9823914c-0.1221619,0-0.2455521-0.0178833-0.3689423-0.055542l-5.600853-1.708374 c-0.6675644-0.2036133-1.0426788-0.9100342-0.8390808-1.5776062c0.2023659-0.6663208,0.9069443-1.0445251,1.576973-0.8396912 l5.600853,1.7084045c0.6675644,0.2035828,1.0426788,0.9100342,0.8390808,1.5775757 C71.1967392,363.6313477,70.6957626,363.9823914,70.1540604,363.9823914z" }),
			_react2.default.createElement("path", { style: style.st77, d: "M96.4665833,369.9034424c-0.1147537,0-0.2307434-0.0160217-0.3454971-0.0487366l-5.6329346-1.5967102 c-0.6712646-0.190033-1.0611877-0.8884277-0.8711624-1.5603333c0.1912613-0.671875,0.8933716-1.0617981,1.5597-0.8705444 l5.6329346,1.5967407c0.671257,0.1900024,1.0611877,0.8884277,0.8711548,1.5603027 C97.5228348,369.5400391,97.016922,369.9034424,96.4665833,369.9034424z" }),
			_react2.default.createElement("path", { style: style.st77, d: "M112.1425476,385.6546936c-0.1764526,0-0.3578415-0.0370178-0.5293579-0.1166077 c-0.6330109-0.2930603-0.9094086-1.0439148-0.6157379-1.6769409l2.4567795-5.3145752 c0.2912064-0.6329956,1.0426788-0.9118652,1.676918-0.6169739c0.6330109,0.2930603,0.9094162,1.0439148,0.6157379,1.6769409 l-2.4567719,5.3145752C113.0778809,385.3832092,112.6200867,385.6546936,112.1425476,385.6546936z" }),
			_react2.default.createElement("path", { style: style.st77, d: "M41.6907845,379.441803c-0.2455559,0-0.494812-0.0715637-0.7132187-0.2214966 c-0.575016-0.3942566-0.7218552-1.1802673-0.328228-1.7565002l3.3094254-4.8302612 c0.3948593-0.5750122,1.1821136-0.7230835,1.7571297-0.3276062c0.575016,0.3942261,0.7218552,1.1802368,0.328228,1.7565002 l-3.3094254,4.8302612C42.4891434,379.2499084,42.0930481,379.441803,41.6907845,379.441803z" }),
			_react2.default.createElement("path", { style: style.st77, d: "M81.1928864,396.1228027c-0.4824753,0-0.9427338-0.2776184-1.1537323-0.7453003l-2.404953-5.3380127 c-0.2862701-0.6361084-0.0024643-1.384491,0.6330109-1.6707458c0.640419-0.288147,1.3844833-0.0024719,1.6719894,0.6329956 l2.4049454,5.3380127c0.2862778,0.6361084,0.0024719,1.384491-0.6330109,1.6707764 C81.5420914,396.0863953,81.3656387,396.1228027,81.1928864,396.1228027z" })
		);
	}

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Dough;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Dough() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				{ opacity: "0.3" },
				_react2.default.createElement("path", { d: "M38.59256,415.45814a2.00481,2.00481,0,1,0-2.32245-1.97949A2.17334,2.17334,0,0,0,38.59256,415.45814Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M155.48806,405.20131a2.03046,2.03046,0,0,0-1.07352-1.27979,2.5551,2.5551,0,0,0-3.15752.63721,1.72957,1.72957,0,0,0-.30777,1.48,2.02593,2.02593,0,0,0,1.07352,1.27783,2.60765,2.60765,0,0,0,1.1859.27881,2.45471,2.45471,0,0,0,1.97057-.915A1.728,1.728,0,0,0,155.48806,405.20131Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M60.64584,415.77992a2.584,2.584,0,0,0-3.15647.63623,1.7277,1.7277,0,0,0-.30882,1.479,2.02837,2.02837,0,0,0,1.07351,1.2793,2.64435,2.64435,0,0,0,1.20272.28662,2.42949,2.42949,0,0,0,1.9548-.92285v-.00049a1.72957,1.72957,0,0,0,.30777-1.48A2.02594,2.02594,0,0,0,60.64584,415.77992Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M113.68609,424.01625a2.58413,2.58413,0,0,0-3.15647.63672,1.7296,1.7296,0,0,0-.30777,1.48,2.02921,2.02921,0,0,0,1.07352,1.27832,2.60779,2.60779,0,0,0,1.18591.27881,2.45369,2.45369,0,0,0,1.97056-.91553,1.73061,1.73061,0,0,0,.30777-1.48047A2.026,2.026,0,0,0,113.68609,424.01625Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M101.452,414.33265a2.5212,2.5212,0,0,0-.67278-.22076,2.3749,2.3749,0,0,0-2.09084-1.13324,2.17435,2.17435,0,0,0-2.32244,1.97949,2.07942,2.07942,0,0,0,1.80144,1.925,2.13473,2.13473,0,0,0,.89285.84448,2.60766,2.60766,0,0,0,1.18591.27881,2.45429,2.45429,0,0,0,1.97161-.91552,1.73062,1.73062,0,0,0,.30777-1.48047A2.026,2.026,0,0,0,101.452,414.33265Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M111.39516,421.32387a1.7336,1.7336,0,0,0,.30882-1.48,2.03355,2.03355,0,0,0-1.07352-1.27833,2.64655,2.64655,0,0,0-2.88021.33564,1.71947,1.71947,0,0,0,.21008-.8122,2.35154,2.35154,0,1,0-2.32245,1.97949,2.5019,2.5019,0,0,0,1.70376-.6452,1.70613,1.70613,0,0,0-.17647,1.25946,2.02591,2.02591,0,0,0,1.07352,1.27783,2.60766,2.60766,0,0,0,1.18591.27881A2.45369,2.45369,0,0,0,111.39516,421.32387Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M126.6229,418.56556a2.55256,2.55256,0,0,0-3.15753.63672,1.73062,1.73062,0,0,0-.30776,1.48047,2.0259,2.0259,0,0,0,1.07351,1.27783,2.60766,2.60766,0,0,0,1.18591.27881,2.45469,2.45469,0,0,0,1.97056-.915v-.00048a1.727,1.727,0,0,0,.30882-1.47852A2.03044,2.03044,0,0,0,126.6229,418.56556Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M42.16079,420.06849a2.005,2.005,0,1,0-2.32245-1.97949,1.71919,1.71919,0,0,0,.208.80927,2.64593,2.64593,0,0,0-2.87706-.33271,2.0292,2.0292,0,0,0-1.07352,1.27833,1.72962,1.72962,0,0,0,.30777,1.48v.00048a2.42965,2.42965,0,0,0,1.95586.92237,2.64893,2.64893,0,0,0,1.20166-.28614,2.02873,2.02873,0,0,0,1.07352-1.2788,1.70182,1.70182,0,0,0-.177-1.25776A2.503,2.503,0,0,0,42.16079,420.06849Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M79.57836,414.62953A2.005,2.005,0,1,0,81.9008,416.609,2.17334,2.17334,0,0,0,79.57836,414.62953Z", fill: "#fff" }),
				_react2.default.createElement("ellipse", { cx: "33.51408", cy: "408.36945", rx: "2.32245", ry: "1.97949", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M51.43272,414.95814a2.35154,2.35154,0,1,0-2.32244,1.9795A2.17435,2.17435,0,0,0,51.43272,414.95814Z", fill: "#fff" }),
				_react2.default.createElement("ellipse", { cx: "65.12477", cy: "424.63978", rx: "2.32245", ry: "1.97949", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M31.7187,415.62953a2.00467,2.00467,0,1,0,0-3.959,2.25168,2.25168,0,0,0-2.28095,1.62823,2.20477,2.20477,0,0,0-2.30092-1.79962,2.00467,2.00467,0,1,0,0,3.959,2.25168,2.25168,0,0,0,2.281-1.62823A2.20476,2.20476,0,0,0,31.7187,415.62953Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M50.80563,418.28383a2.00467,2.00467,0,1,0,2.3214,1.97949A2.17436,2.17436,0,0,0,50.80563,418.28383Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M124.65128,407.59877a2.50942,2.50942,0,0,0,1.68013-.62128c-.00263.04089-.01418.07977-.01418.12128a2.35215,2.35215,0,1,0,2.32244-1.97949,2.5135,2.5135,0,0,0-1.6817.62188c.00316-.04107.01471-.08014.01471-.12188a2.35154,2.35154,0,0,0-4.64385,0c0,.04174.01156.08081.01471.12188a2.51348,2.51348,0,0,0-1.6817-.62188,2.00481,2.00481,0,1,0,2.32245,1.97949c0-.04175-.01156-.08081-.01471-.12189A2.5135,2.5135,0,0,0,124.65128,407.59877Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M91.14543,416.109a2.63974,2.63974,0,0,0-.95272.17877,2.56855,2.56855,0,0,0-3.03988-.50787,2.02839,2.02839,0,0,0-1.07351,1.2793,1.727,1.727,0,0,0,.30882,1.47851,2.45407,2.45407,0,0,0,1.97056.916,2.63373,2.63373,0,0,0,.93119-.18671,2.4619,2.4619,0,0,0,1.85554.80145,2.00488,2.00488,0,1,0,0-3.95947Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M147.14363,413.41957a1.8934,1.8934,0,0,0-.85293,1.373,1.78772,1.78772,0,0,0,.55041,1.45263,2.49334,2.49334,0,0,0,1.76153.69678,2.58,2.58,0,0,0,1.46427-.44531,1.89158,1.89158,0,0,0,.85188-1.374,1.78293,1.78293,0,0,0-.54936-1.45263A2.595,2.595,0,0,0,147.14363,413.41957Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M134.86228,397.2599a2.00467,2.00467,0,1,0,2.3214,1.97949A2.17436,2.17436,0,0,0,134.86228,397.2599Z", fill: "#fff" }),
				_react2.default.createElement("ellipse", { cx: "120.66184", cy: "413.47865", rx: "2.32245", ry: "1.97949", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M109.20716,415.45814a2.53734,2.53734,0,0,0,1.5441-.51214,2.23356,2.23356,0,0,0,.54411.4013,2.60817,2.60817,0,0,0,1.18591.2793,2.45407,2.45407,0,0,0,1.97056-.916,1.72957,1.72957,0,0,0,.30777-1.48,2.026,2.026,0,0,0-1.07352-1.27783,2.65425,2.65425,0,0,0-2.73788.23,2.4894,2.4894,0,0,0-1.74105-.68359,2.00481,2.00481,0,1,0,0,3.959Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M125.65967,413.26088a2.0259,2.0259,0,0,0-1.07351,1.27783,1.72957,1.72957,0,0,0,.30777,1.48v.00049a2.43008,2.43008,0,0,0,1.95585.92285,2.6458,2.6458,0,0,0,1.20167-.28613,2.02879,2.02879,0,0,0,1.07351-1.27881,1.72872,1.72872,0,0,0-.30882-1.47949A2.58387,2.58387,0,0,0,125.65967,413.26088Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M72.34631,416.39125a2.02594,2.02594,0,0,0-1.07351,1.27783,1.72167,1.72167,0,0,0,.26995,1.41718,2.48238,2.48238,0,0,0-2.16174.90069,1.72807,1.72807,0,0,0-.30882,1.479,2.03045,2.03045,0,0,0,1.07352,1.27978,2.63951,2.63951,0,0,0,1.20166.28613,2.43008,2.43008,0,0,0,1.95586-.92285v-.00049a1.72957,1.72957,0,0,0,.30777-1.48,1.81047,1.81047,0,0,0-.27678-.57769c.06775.00512.13392.02154.2022.02154a2.64891,2.64891,0,0,0,1.20166-.28613,2.02878,2.02878,0,0,0,1.07352-1.27881,1.72872,1.72872,0,0,0-.30882-1.47949A2.58607,2.58607,0,0,0,72.34631,416.39125Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M95.70839,425.49623a2.02594,2.02594,0,0,0-1.07351,1.27783,1.72957,1.72957,0,0,0,.30777,1.48v.00049a2.42615,2.42615,0,0,0,1.9548.92236,2.64379,2.64379,0,0,0,1.20272-.28613,2.02839,2.02839,0,0,0,1.07351-1.2793,1.72633,1.72633,0,0,0-.30882-1.47851A2.5835,2.5835,0,0,0,95.70839,425.49623Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M43.38976,420.46986a2.02916,2.02916,0,0,0-1.07351,1.27832,1.72957,1.72957,0,0,0,.30777,1.48,2.45426,2.45426,0,0,0,1.97161.91553,2.60766,2.60766,0,0,0,1.18591-.27881,2.03144,2.03144,0,0,0,1.07351-1.27783,1.73325,1.73325,0,0,0-.30881-1.48A2.58492,2.58492,0,0,0,43.38976,420.46986Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M21.17683,418.56556a2.02917,2.02917,0,0,0-1.07352,1.27833,1.72958,1.72958,0,0,0,.30777,1.48,2.45429,2.45429,0,0,0,1.97161.91552,2.60766,2.60766,0,0,0,1.18591-.27881,2.02859,2.02859,0,0,0,1.07247-1.27783,1.73066,1.73066,0,0,0-.30777-1.48047A2.58509,2.58509,0,0,0,21.17683,418.56556Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M15.04561,408.81947a2.02911,2.02911,0,0,0,1.07351-1.27832,1.73094,1.73094,0,0,0-.30777-1.48047,2.55272,2.55272,0,0,0-3.15752-.63623,2.02714,2.02714,0,0,0-1.07351,1.27783,1.72735,1.72735,0,0,0,.30882,1.48047v.00049a2.45428,2.45428,0,0,0,1.97056.91455A2.61351,2.61351,0,0,0,15.04561,408.81947Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M32.32794,416.39125a2.02713,2.02713,0,0,0-1.07352,1.27783,1.72735,1.72735,0,0,0,.30882,1.48047V419.15a2.45432,2.45432,0,0,0,1.97056.91455,2.60727,2.60727,0,0,0,1.18591-.27832,2.026,2.026,0,0,0,1.07352-1.27783,1.732,1.732,0,0,0-.30777-1.481A2.55274,2.55274,0,0,0,32.32794,416.39125Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M70.54276,416.609a2.35206,2.35206,0,1,0-2.32245,1.98A2.17435,2.17435,0,0,0,70.54276,416.609Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M116.081,414.62953a2.2754,2.2754,0,0,0-2.25522,1.527,2.3506,2.3506,0,0,0-1.51154.8714,1.73064,1.73064,0,0,0-.30777,1.48047,2.02984,2.02984,0,0,0,1.07247,1.27783,2.60779,2.60779,0,0,0,1.18591.27881,2.45429,2.45429,0,0,0,1.97161-.91553,1.82855,1.82855,0,0,0,.28834-.59876,2.09412,2.09412,0,0,0,1.8776-1.94177A2.17334,2.17334,0,0,0,116.081,414.62953Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M116.081,411.34974a2.00481,2.00481,0,1,0-2.32245-1.97949A2.17334,2.17334,0,0,0,116.081,411.34974Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M15.63383,413.15a2.00467,2.00467,0,1,0,0,3.959,2.00481,2.00481,0,1,0,0-3.959Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M84.16758,419.76332A2.00481,2.00481,0,1,0,86.49,421.74281,2.17334,2.17334,0,0,0,84.16758,419.76332Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M133.94948,410.01918a2.17439,2.17439,0,0,0-2.32245,1.98,1.77793,1.77793,0,0,0,.44852,1.15857,2.00845,2.00845,0,1,0,2.41174,1.9718,1.77789,1.77789,0,0,0-.44853-1.15857,1.99635,1.99635,0,1,0-.08928-3.95178Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M96.99409,418.28383a2.00467,2.00467,0,1,0,2.3214,1.97949A2.17435,2.17435,0,0,0,96.99409,418.28383Z", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M56.65429,418.70814a2.00488,2.00488,0,1,0,2.3214,1.98A2.17439,2.17439,0,0,0,56.65429,418.70814Z", fill: "#fff" }),
				_react2.default.createElement("ellipse", { cx: "122.44648", cy: "400.71889", rx: "2.32245", ry: "1.97949", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M143.05545,407.39076a2.00481,2.00481,0,1,0,2.32245,1.97949A2.17334,2.17334,0,0,0,143.05545,407.39076Z", fill: "#fff" }),
				_react2.default.createElement("ellipse", { cx: "28.16003", cy: "402.19838", rx: "2.32245", ry: "1.97949", fill: "#fff" }),
				_react2.default.createElement("path", { d: "M22.81383,408.09957a2.17334,2.17334,0,0,0,2.3214,1.97949,2.00481,2.00481,0,1,0,0-3.959A2.17334,2.17334,0,0,0,22.81383,408.09957Z", fill: "#fff" })
			),
			_react2.default.createElement("path", { d: "M109.10045,414.34733c.72271,0,1.227-.44565,1.227-.8455s-.50426-.8455-1.227-.8455c-.72379,0-1.22806.44565-1.22806.8455S108.37666,414.34733,109.10045,414.34733Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M115.9754,424.02913a1.55585,1.55585,0,0,0,.70641-.16464.91081.91081,0,0,0,.5097-.58121.5726.5726,0,0,0-.1239-.4667,1.3661,1.3661,0,0,0-1.09547-.47907,1.568,1.568,0,0,0-.70749.164.91191.91191,0,0,0-.50861.58121.57335.57335,0,0,0,.12389.46731A1.368,1.368,0,0,0,115.9754,424.02913Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M88.24412,418.34582a1.568,1.568,0,0,0,.70749-.164.91191.91191,0,0,0,.50861-.58121.57335.57335,0,0,0-.12389-.46731,1.37027,1.37027,0,0,0-1.09656-.47908,1.55924,1.55924,0,0,0-.7064.16464.91382.91382,0,0,0-.5097.58121.58121.58121,0,0,0,.12389.46732A1.36989,1.36989,0,0,0,88.24412,418.34582Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M76.3526,421.91723a1.55129,1.55129,0,0,0,.70532-.16464.91078.91078,0,0,0,.5097-.58121.57256.57256,0,0,0-.12389-.46669,1.36611,1.36611,0,0,0-1.09547-.47908,1.56785,1.56785,0,0,0-.70749.164.91192.91192,0,0,0-.50862.5812.57338.57338,0,0,0,.1239.46732A1.37028,1.37028,0,0,0,76.3526,421.91723Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M38.26,421.13239a1.55594,1.55594,0,0,0,.7064-.16464.91078.91078,0,0,0,.5097-.58121.57258.57258,0,0,0-.12389-.4667,1.3688,1.3688,0,0,0-1.09656-.47969,1.55588,1.55588,0,0,0-.70641.16464.91383.91383,0,0,0-.50969.58121.58118.58118,0,0,0,.12389.46731A1.37027,1.37027,0,0,0,38.26,421.13239Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M33.4184,418.958a1.55581,1.55581,0,0,0,.7064-.16465.91077.91077,0,0,0,.5097-.5812.57257.57257,0,0,0-.12389-.4667,1.36808,1.36808,0,0,0-1.09547-.4797,1.55586,1.55586,0,0,0-.70641.16465.91079.91079,0,0,0-.5097.5812.57261.57261,0,0,0,.12389.4667A1.3681,1.3681,0,0,0,33.4184,418.958Z", fill: "#fff" }),
			_react2.default.createElement("ellipse", { cx: "105.53148", cy: "418.11186", rx: "1.22806", ry: "0.8455", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M68.11375,417.478c.72379,0,1.22806-.44565,1.22806-.8455,0-.40047-.50427-.84612-1.22806-.84612s-1.22806.44565-1.22806.84612C66.88569,417.03239,67.39,417.478,68.11375,417.478Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M137.87336,407.09874c.72379,0,1.22806-.44565,1.22806-.8455,0-.40047-.50427-.84612-1.22806-.84612-.72271,0-1.227.44565-1.227.84612C136.64639,406.65309,137.15065,407.09874,137.87336,407.09874Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M116.08,410.23866c.72379,0,1.22806-.44565,1.22806-.8455s-.50427-.8455-1.22806-.8455c-.72271,0-1.227.44565-1.227.8455S115.35724,410.23866,116.08,410.23866Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M98.58154,415.82727c.72379,0,1.22806-.44565,1.22806-.84612,0-.39985-.50427-.84551-1.22806-.84551s-1.22806.44566-1.22806.84551C97.35348,415.38162,97.85775,415.82727,98.58154,415.82727Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M82.56788,425.50845c.72271,0,1.227-.44565,1.227-.8455,0-.40047-.50426-.84612-1.227-.84612-.72379,0-1.22806.44565-1.22806.84612C81.33982,425.0628,81.84409,425.50845,82.56788,425.50845Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M115.97323,414.51878c.72379,0,1.22806-.44565,1.22806-.8455,0-.40047-.50427-.84612-1.22806-.84612-.72271,0-1.227.44565-1.227.84612C114.74626,414.07313,115.25052,414.51878,115.97323,414.51878Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M126.855,415.80388c.7238,0,1.22806-.44565,1.22806-.8455,0-.40047-.50426-.84612-1.22806-.84612-.7227,0-1.227.44565-1.227.84612C125.628,415.35823,126.13229,415.80388,126.855,415.80388Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M141.271,413.01636c.72379,0,1.22806-.44566,1.22806-.84551,0-.40046-.50427-.84612-1.22806-.84612-.72271,0-1.227.44566-1.227.84612C140.04407,412.5707,140.54833,413.01636,141.271,413.01636Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M96.88725,421.13177c.72271,0,1.227-.44565,1.227-.8455s-.50427-.8455-1.227-.8455c-.72379,0-1.228.44565-1.228.8455S96.16346,421.13177,96.88725,421.13177Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M128.53311,407.96769c.72379,0,1.22806-.44565,1.22806-.84612,0-.39985-.50427-.8455-1.22806-.8455s-1.22806.44565-1.22806.8455C127.30505,407.522,127.80932,407.96769,128.53311,407.96769Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M27.03032,414.34733c.72379,0,1.22806-.44565,1.22806-.8455,0-.40047-.50427-.84612-1.22806-.84612s-1.22806.44565-1.22806.84612C25.80226,413.90168,26.30653,414.34733,27.03032,414.34733Z", fill: "#fff" }),
			_react2.default.createElement("ellipse", { cx: "38.48495", cy: "413.50183", rx: "1.22806", ry: "0.8455", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M59.34129,418.34582a1.36613,1.36613,0,0,0,1.09547-.47907.57258.57258,0,0,0,.12389-.4667.91078.91078,0,0,0-.5097-.58121,1.55594,1.55594,0,0,0-.7064-.16464,1.368,1.368,0,0,0-1.09548.47908.57338.57338,0,0,0-.12389.46731.91081.91081,0,0,0,.5097.58121A1.55211,1.55211,0,0,0,59.34129,418.34582Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M74.14753,418.958a1.36881,1.36881,0,0,0,1.09656-.4797.57257.57257,0,0,0,.12389-.4667.91075.91075,0,0,0-.50969-.5812,1.55589,1.55589,0,0,0-.70641-.16465,1.36808,1.36808,0,0,0-1.09547.4797.57257.57257,0,0,0-.12389.4667.91077.91077,0,0,0,.5097.5812A1.55126,1.55126,0,0,0,74.14753,418.958Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M50.78618,428.06229a1.36614,1.36614,0,0,0,1.09547-.47908.57258.57258,0,0,0,.12389-.4667.91077.91077,0,0,0-.5097-.5812,1.55915,1.55915,0,0,0-.7064-.16465,1.36612,1.36612,0,0,0-1.09547.47908.57394.57394,0,0,0-.1239.46732.911.911,0,0,0,.50862.58058,1.567,1.567,0,0,0,.70749.16465Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M103.10579,423.03632a1.36612,1.36612,0,0,0,1.09547-.47908.57562.57562,0,0,0,.12281-.4667.91193.91193,0,0,0-.50861-.5812,1.56042,1.56042,0,0,0-.7075-.16465,1.36614,1.36614,0,0,0-1.09547.47908.5739.5739,0,0,0-.12389.46732.911.911,0,0,0,.50861.58058,1.56707,1.56707,0,0,0,.70749.16465Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M109.32542,421.13239a1.36805,1.36805,0,0,0,1.09547-.4797.57256.57256,0,0,0,.12389-.46669.91078.91078,0,0,0-.5097-.58121,1.55581,1.55581,0,0,0-.7064-.16464,1.3681,1.3681,0,0,0-1.09548.47969.57262.57262,0,0,0-.12389.4667.91081.91081,0,0,0,.5097.58121A1.556,1.556,0,0,0,109.32542,421.13239Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M125.31734,421.13239a1.36879,1.36879,0,0,0,1.09656-.4797.57259.57259,0,0,0,.12389-.46669.91081.91081,0,0,0-.5097-.58121,1.55582,1.55582,0,0,0-.70641-.16464,1.36809,1.36809,0,0,0-1.09547.47969.57258.57258,0,0,0-.12389.4667.91081.91081,0,0,0,.5097.58121A1.55142,1.55142,0,0,0,125.31734,421.13239Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M114.16592,418.958a1.36881,1.36881,0,0,0,1.09656-.4797.57257.57257,0,0,0,.12389-.4667.91077.91077,0,0,0-.5097-.5812,1.55581,1.55581,0,0,0-.7064-.16465,1.368,1.368,0,0,0-1.09547.47908.57444.57444,0,0,0-.1239.46732.91193.91193,0,0,0,.50861.5812A1.55589,1.55589,0,0,0,114.16592,418.958Z", fill: "#fff" }),
			_react2.default.createElement("ellipse", { cx: "42.05393", cy: "418.11186", rx: "1.22806", ry: "0.8455", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M79.47165,417.478c.7238,0,1.22806-.44565,1.22806-.8455,0-.40047-.50426-.84612-1.22806-.84612s-1.228.44565-1.228.84612C78.2436,417.03239,78.74786,417.478,79.47165,417.478Z", fill: "#fff" }),
			_react2.default.createElement("ellipse", { cx: "33.51389", cy: "408.39236", rx: "1.22806", ry: "0.8455", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M49.00386,415.82727c.7238,0,1.22806-.44565,1.22806-.84612,0-.39985-.50426-.84551-1.22806-.84551s-1.22805.44566-1.22805.84551C47.77581,415.38162,48.28007,415.82727,49.00386,415.82727Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M132.05753,415.99872c.72379,0,1.22806-.44565,1.22806-.84612,0-.39985-.50427-.8455-1.22806-.8455-.72271,0-1.227.44565-1.227.8455C130.83056,415.55307,131.33482,415.99872,132.05753,415.99872Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M63.52429,422.61171c.72379,0,1.22806-.44565,1.22806-.84612,0-.39985-.50427-.8455-1.22806-.8455s-1.22806.44565-1.22806.8455C62.29623,422.16606,62.8005,422.61171,63.52429,422.61171Z", fill: "#fff" }),
			_react2.default.createElement("ellipse", { cx: "50.69815", cy: "420.28627", rx: "1.22806", ry: "0.8455", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M91.03822,421.557c.72379,0,1.22806-.44566,1.22806-.84612,0-.39985-.50427-.84551-1.22806-.84551s-1.22806.44566-1.22806.84551C89.81016,421.11134,90.31443,421.557,91.03822,421.557Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M19.58688,411.21675c.7238,0,1.22806-.44565,1.22806-.84612,0-.39985-.50426-.8455-1.22806-.8455s-1.228.44565-1.228.8455C18.35883,410.7711,18.86309,411.21675,19.58688,411.21675Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M25.13556,408.94535c.7238,0,1.22806-.44565,1.22806-.84612,0-.39985-.50426-.8455-1.22806-.8455s-1.22805.44565-1.22805.8455C23.90751,408.4997,24.41177,408.94535,25.13556,408.94535Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M122.44594,401.58805c.72379,0,1.22805-.44565,1.22805-.8455,0-.40047-.50426-.84612-1.22805-.84612-.72271,0-1.227.44565-1.227.84612C121.219,401.1424,121.72323,401.58805,122.44594,401.58805Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M120.55508,407.96769c.72379,0,1.22806-.44565,1.22806-.84612,0-.39985-.50427-.8455-1.22806-.8455s-1.22806.44565-1.22806.8455C119.327,407.522,119.83129,407.96769,120.55508,407.96769Z", fill: "#fff" }),
			_react2.default.createElement("path", { d: "M120.55508,414.34733c.72379,0,1.22806-.44565,1.22806-.8455,0-.40047-.50427-.84612-1.22806-.84612s-1.22806.44565-1.22806.84612C119.327,413.90168,119.83129,414.34733,120.55508,414.34733Z", fill: "#fff" }),
			_react2.default.createElement("ellipse", { cx: "82.37026", cy: "359.6197", rx: "7.32803", ry: "5.17683", transform: "translate(-286.25342 374.71188) rotate(-79.44353)", fill: "#f49453" }),
			_react2.default.createElement("polygon", { points: "83.713 352.416 59.343 345.574 55.83 364.428 81.028 366.824 83.713 352.416", fill: "#f49453" }),
			_react2.default.createElement("circle", { cx: "57.58668", cy: "355.00107", r: "9.58895", fill: "#f49453" }),
			_react2.default.createElement("rect", { x: "81.34966", y: "349.57388", width: "120.60131", height: "42.18635", transform: "translate(70.30533 -19.67737) rotate(10.55647)", fill: "#f7a46b" }),
			_react2.default.createElement("ellipse", { cx: "82.37026", cy: "359.6197", rx: "21.09318", ry: "14.90111", transform: "translate(-286.25342 374.71188) rotate(-79.44353)", fill: "#f7a46b" }),
			_react2.default.createElement("ellipse", { cx: "200.93037", cy: "381.7144", rx: "21.09318", ry: "14.90111", transform: "translate(-211.1348 509.31219) rotate(-79.44353)", fill: "#f49453" }),
			_react2.default.createElement("ellipse", { cx: "200.93037", cy: "381.7144", rx: "7.32803", ry: "5.17683", transform: "translate(-211.1348 509.31219) rotate(-79.44353)", fill: "#f7a46b" }),
			_react2.default.createElement("polygon", { points: "202.273 374.51 227.471 376.906 223.957 395.76 199.588 388.918 202.273 374.51", fill: "#f7a46b" }),
			_react2.default.createElement("circle", { cx: "225.71394", cy: "386.33304", r: "9.58895", fill: "#f7a46b" }),
			_react2.default.createElement("path", { d: "M117.80652,392.54141c0,18.00166-19.05,19.78375-42.54936,19.78375s-42.54935-1.78209-42.54935-19.78375,19.05-32.59487,42.54935-32.59487S117.80652,374.53976,117.80652,392.54141Z", fill: "#ffeaae" })
		);
	}

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Egg;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Egg() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M136.57094,386.00687c-9.07789-3.84058-22.32984-6.50665-39.02149-6.50665 c-54.58496,0-65.10107,12.24689-67.20752,18.30127c-2.61865,7.19336,12.34448,7.30969,14.10889,10.47095 c1.76465,3.16119,4.42017,7.74213,9.19434,9.50336c21.09985,7.78363,53.11108-4.88306,64.43018-4.31781 c26.27076,1.31195,32.0398-4.32208,33.5442-9.46393C154.20766,397.01859,146.17299,390.06931,136.57094,386.00687z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M68.60095,410.03833c18.31055,4.42285,39.78943-4.7666,50.40247-4.21484 c15.24854,0.79272,26.32446-0.47607,32.88892-2.74756c0.59981-2.4982-0.1138-4.97687-1.72424-7.30417 c-2.68408-3.87885-7.85938-7.33725-13.59729-9.76492c-9.07764-3.84058-22.32983-6.50659-39.02124-6.50659 c-19.96701,0-34.03668,1.63882-43.95537,4.01379c-1.59065,0.38089-3.07455,0.7807-4.45889,1.19571 c-1.06628,0.31964-4.23214,5.29114-2.88215,9.46393C48.54278,401.25085,56.0083,406.99658,68.60095,410.03833z" }),
			_react2.default.createElement("path", { fill: "#FFBB10", d: "M97.35204,397.98923c-12.46178,0-22.56405-4.32852-22.56405-9.55365 c0-12.46176,10.10227-20.56244,22.56405-20.56244s22.56406,8.10068,22.56406,20.56244 C119.9161,393.66071,109.81383,397.98923,97.35204,397.98923z" })
		);
	}

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Fishbones;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Fishbones() {
		// 4
		var style = {
			st0: {
				fill: "#FFFFFF"
			},
			st33: {
				fill: "#E5E5E5"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st0, d: "M168.5691986,421.5116882c0,2.3858032-2.2182465,4.2285461-4.5334778,3.6524963 c-7.4983368-1.8655701-17.4802551-7.5722351-17.4802551-14.3227234c0-6.7504578,9.9819183-12.4571533,17.4802551-14.3227234 c2.3152313-0.5760193,4.5334778,1.2666931,4.5334778,3.6525269V421.5116882z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M177.2470856,424.9614258c-0.9755707,0-1.7649994-0.7894287-1.7649994-1.7650146v-24.7098999 c0-0.9755859,0.7894287-1.7649841,1.7649994-1.7649841s1.7649841,0.7893982,1.7649841,1.7649841v24.7098999 C179.0120697,424.1719971,178.2226562,424.9614258,177.2470856,424.9614258z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M187.8370514,424.9614258c-0.9755859,0-1.7649994-0.7894287-1.7649994-1.7650146v-24.7098999 c0-0.9755859,0.7894135-1.7649841,1.7649994-1.7649841c0.9755707,0,1.7649841,0.7893982,1.7649841,1.7649841v24.7098999 C189.6020355,424.1719971,188.8126221,424.9614258,187.8370514,424.9614258z" }),
			_react2.default.createElement("rect", { x: "166", y: "409", style: style.st0, width: "49", height: "4" }),
			_react2.default.createElement("path", { style: style.st0, d: "M217.6361847,397.6447449l-12.347229,13.1118774l12.2341919,13.7634583 c1.2478485,1.4038391,3.5484161,0.2449951,3.163147-1.5933228l-2.4394989-11.6400146l2.5169983-12.0098267 C221.1433716,397.4657593,218.9048157,396.2975464,217.6361847,397.6447449z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M198.427002,421.431427c-0.9755707,0-1.7649841-0.7894287-1.7649841-1.7649841V402.01651 c0-0.9755859,0.7894135-1.7650146,1.7649841-1.7650146s1.7649994,0.7894287,1.7649994,1.7650146v17.6499329 C200.1920013,420.6419983,199.4025726,421.431427,198.427002,421.431427z" }),
			_react2.default.createElement("path", { style: style.st33, d: "M161.5351562,415.5512695c-0.3779297,0-0.7558594-0.1416016-1.046875-0.4257812l-6.5849609-6.4194336 c-0.59375-0.5786133-0.6054688-1.5283203-0.0273438-2.1210938c0.5771484-0.59375,1.5283203-0.605957,2.1210938-0.0273438 l6.5849609,6.4194336c0.59375,0.5786133,0.6054688,1.5283203,0.0273438,2.1210938 C162.3154297,415.3999023,161.9257812,415.5512695,161.5351562,415.5512695z" }),
			_react2.default.createElement("path", { style: style.st33, d: "M155.0322266,415.6342773c-0.3779297,0-0.7558594-0.1416016-1.046875-0.4257812 c-0.59375-0.5786133-0.6054688-1.5283203-0.0273438-2.1210938l6.4199219-6.5854492 c0.5771484-0.5942383,1.5283203-0.605957,2.1210938-0.0273438c0.59375,0.5786133,0.6054688,1.5283203,0.0273438,2.1210938 l-6.4199219,6.5854492C155.8125,415.4829102,155.4228516,415.6342773,155.0322266,415.6342773z" })
		);
	}

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Fishbowl;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Fishbowl() {
		// 7
		var style = {
			st66: {
				opacity: 0.5,
				fill: "#5994C9"
			},
			st67: {
				fill: "#F9914B"
			},
			st0: {
				fill: "#FFFFFF"
			},
			st68: {
				fill: "#555555"
			},
			st69: {
				opacity: 0.3,
				fill: "#FFFFFF"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st66, d: "M83.5136719,385.0002441c3.7431641,7.6689453,10.0224609,13.8703613,17.6806641,17.6125488 c15.9580078,7.7973633,33.1171875,7.2277832,47.0810547-1.4890137 c13.5556641-8.4638672,21.6484375-22.8986816,21.6484375-38.8581543c0-6.8554688-1.5588379-13.7131348-4.442627-19.8356934 c-5.9592285-2.2416992-6.123291-3.6081543-12.9769287-3.6081543c-7.1300049,0-7.1300049,4-14.2598877,4 c-7.1325684,0-7.1325684-4-14.2648926-4c-7.130249,0-7.130249,4-14.260498,4c-7.1350098,0-7.1350098-4-14.2700195-4 c-6.8990479,0-6.9050293,1.4040527-12.9753418,3.6538086C76.371582,355.2243652,76.5168457,370.6643066,83.5136719,385.0002441z" }),
			_react2.default.createElement("path", { style: style.st67, d: "M141.2979889,368.9460144c0.6156616,0.6939087,0.603714,1.7212219-0.0278931,2.4006653 c-2.3450775,2.5226135-8.3907928,8.1771851-15.401825,8.0957031c-9.0197601-0.1048279-16.221611-9.6637268-16.221611-9.6637268 s7.4220581-9.3889465,16.4418182-9.2841187C133.0995026,360.5760193,139.0121765,366.3695679,141.2979889,368.9460144z" }),
			_react2.default.createElement("path", { style: style.st67, d: "M105.5564423,360.7468567l10.0445709,7.6731262 c0.9468307,0.7232666,0.9301987,2.1542969-0.0331802,2.8553772l-10.2201843,7.4375916 c-1.1848373,0.8622742-2.845932,0.0045166-2.8289032-1.4607544l2.3633881-7.7606201l-2.1877747-7.3500977 C102.7113876,360.6762085,104.3919678,359.8572998,105.5564423,360.7468567z" }),
			_react2.default.createElement("circle", { style: style.st0, cx: "128.8622131", cy: "369.7176208", r: "4.4635382" }),
			_react2.default.createElement("circle", { style: style.st68, cx: "128.8622131", cy: "369.7176208", r: "1.949445" }),
			_react2.default.createElement("path", { style: style.st0, d: "M173.9191895,362.078125c0-13.9956055-5.9326172-27.2741699-16.2773438-36.7214355L157.0686035,325 H90.8752441l-0.5732422,0.3566895c-16.9560547,15.4863281-20.9424438,39.5030518-10.296936,61.3145752 C83.7018433,394.2454834,90,400.5063477,97,404.71875V408c0,3.3137207,3.0620117,6,7.0629883,6h39.8444824 C147.9084473,414,151,411.3137207,151,408v-4l-0.0646973,0.0581055 C165.2862549,394.8039551,173.9191895,379.1757812,173.9191895,362.078125z M148.270752,401.0820312 c-13.9638672,8.7167969-31.1230469,9.2446289-47.0810547,1.4472656c-7.6582031-3.7421875-13.9375-9.8601074-17.6806641-17.5290527 C73.7805176,365.067627,77.2971191,343,92.435791,329h63.0722656c9.1679688,8,14.4111328,20.6262207,14.4111328,33.244873 C169.9191895,378.2043457,161.826416,392.6181641,148.270752,401.0820312z" }),
			_react2.default.createElement("circle", { style: style.st69, cx: "137.1647034", cy: "355.0555725", r: "2.7896991" }),
			_react2.default.createElement("circle", { style: style.st69, cx: "145.8713837", cy: "350.9161987", r: "3.5551238" }),
			_react2.default.createElement("circle", { style: style.st69, cx: "143.5653076", cy: "360.9291992", r: "1.8513534" })
		);
	}

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Flamingo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Flamingo() {
		// 13
		var style = {
			st16: {
				fill: "#E6E6E6"
			},
			st72: {
				fill: "#F79AC0"
			},
			st11: {
				fill: "#FCB47E"
			},
			st92: {
				fill: "#4D4D4D"
			},
			st0: {
				fill: "#FFFFFF"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st16, d: "M94.4697266,317h-3.7587891l-30.1699219,85c0,0.4892578,1.1873779,0.8858643,2.6520996,0.8858643 S65.6843262,402.4529419,65.8452148,402l26.7338867-75.4741211L119.1135254,402h-0.0043945 c0,0.4892578,1.1873779,0.8858643,2.6520996,0.8858643s2.4912109-0.4329224,2.6520996-0.8858643L94.4697266,317z" }),
			_react2.default.createElement("path", { style: style.st72, d: "M98.2805176,297.7094727c-14.5054932,0-27.2381592,4.8192139-34.5026855,12.0799561 c0.2424316-1.7472534,0.9230957-3.9546509,1.9088135-6.2649536c1.2149658-2.7724609,2.8181152-5.7300415,4.5479736-8.769043 c1.7111816-3.0608521,3.6419678-6.1472778,5.6251221-9.3361206c1.9758301-3.2053223,4.088623-6.4439087,5.8814697-10.3455811 c0.8883057-1.9550171,1.6849365-4.1037598,2.1738281-6.550415c0.1235352-0.633667,0.2421875-1.5952148,0.3032227-2.1421509 l0.0672607-0.5961914l0.0168457-0.1484985l0.0083008-0.0742188l0.0042725-0.0370483l0.0089111-0.3678589l0.0224609-0.3826904 c0.0682373-1.0106812,0.0789795-2.0561523,0.0762939-3.1102905c-0.0252686-2.1248169-0.2293701-4.3518066-0.7927246-6.699585 c-0.5714111-2.336731-1.5384521-4.8060303-3.0776367-7.0773315c-1.5220947-2.2659912-3.5761719-4.2490234-5.7229004-5.635376 c-2.1466064-1.4089355-4.31604-2.2921143-6.2619629-2.8299561c-3.9182129-1.1003418-6.9923096-1.0782471-9.3900146-0.9262695 c-0.4006348,0.0372314-0.7750244,0.0889893-1.1376953,0.1464844c-6.7547607,0.5197754-12.0771484,6.1533203-12.0771484,13.0414429 c0,7.230896,5.8616943,13.0927124,13.0926514,13.0927124c2.5100098,0,4.8466797-0.718811,6.8388672-1.9434814 c0.0646973,0.1795654,0.1279297,0.3640747,0.1855469,0.5631714c0.1268311,0.480896,0.236084,0.9956055,0.3074951,1.5664062 l0.0313721,0.2109985c0.0036621-0.1339111-0.0025635,0.3371582,0.0091553-0.2935181l0.0014648,0.0372925l0.0029297,0.074585 l0.0058594,0.149292l0.0234375,0.5994873c0.0053711,0.1391602,0.0041504,0.1130981,0.0064697,0.1258545l0.010498,0.0285645 c0.0042725,0.0367432,0.0372314,0.0028076,0.0336914,0.1027222c0.0096436,0.7556763-0.1369629,1.7960205-0.4637451,2.9730835 c-0.6529541,2.3704224-2.0212402,5.1851807-3.7711182,7.9677734c-1.7575684,2.7996216-3.8709717,5.6384277-6.0997314,8.5700073 c-2.2073975,2.953064-4.4627686,6.0525513-6.5540771,9.520813c-2.0975342,3.4634399-4.1464844,7.2816772-5.3341064,12.0498047 c-0.5737305,2.3739014-0.9296875,4.9903564-0.8258057,7.7250366c0.0968018,2.7267456,0.6878662,5.5411987,1.6911621,8.0528564 c0.9957275,2.5217285,2.3438721,4.7219849,3.7398682,6.5702515c1.4053955,1.8432007,2.8817139,3.4005127,4.3132324,4.6986694 c2.8843994,2.6035767,5.5441895,4.4031372,7.8936768,5.8674316c2.3574219,1.4473877,4.3635254,2.5170288,6.0367432,3.3847656 c1.6601562,0.8258667,5.2386475,2.381958,5.2386475,2.381958l0,0c5.4729004,2.6133423,12.3459473,4.1355591,20.4851074,4.1355591 c22.5944824,0,33.5958252-25.8887329,51.748291-31.5119019C162.7626953,312.7608032,120.875,297.7094727,98.2805176,297.7094727z"
			}),
			_react2.default.createElement("path", { style: style.st11, d: "M46.1955338,254.1526031c-1.3502197,0.9560242-10.6007614,10.998642-1.1788139,17.6878815 l9.4721756-7.883606L46.1955338,254.1526031z" }),
			_react2.default.createElement("circle", { style: style.st0, cx: "59.0552216", cy: "251.6837616", r: "6.1673884" }),
			_react2.default.createElement("circle", { style: style.st92, cx: "59.0552216", cy: "251.6837616", r: "2.9245703" })
		);
	}

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Flowers;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Flowers() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("rect", { x: "78.85351", y: "314.59412", transform: "matrix(0.9834 -0.18143 0.18143 0.9834 -63.03912 20.74194)", fill: "#75C69F", width: "6.00002", height: "80.68285" }),
			_react2.default.createElement("rect", { x: "58.72816", y: "346.02158", transform: "matrix(0.22519 -0.97432 0.97432 0.22519 -258.32373 373.20502)", fill: "#75C69F", width: "93.51927", height: "5.9998" }),
			_react2.default.createElement("path", { fill: "#FC5959", d: "M78.09647,295.44958l0.00002-0.00003c5.57093-5.4877,14.90618-0.61707,13.59196,7.09155l-0.00001,0.00003 h0.00003c7.79501-0.62289,11.81544,9.1088,5.85368,14.16919l-0.00002,0.00003h0.00002 c6.37172,4.53336,3.19613,14.57257-4.6236,14.61691h-0.00002l0,0c1.96704,7.56842-6.91868,13.21768-12.93745,8.22522 l-0.00002-0.00003l-0.00001,0.00003c-3.35806,7.06213-13.79617,5.67807-15.19772-2.01517l-0.00001-0.00003l-0.00002,0.00003 c-7.11187,3.25137-14.21828-4.51837-10.3468-11.31262l0.00001-0.00003h-0.00002 c-7.53796-2.08072-7.9875-12.60059-0.65451-15.31674l0.00002-0.00003h-0.00001 c-4.43696-6.43924,1.98073-14.7869,9.34404-12.15402h0.00002v-0.00003c0.74015-7.78476,11.02215-10.05423,14.97041-3.30429 L78.09647,295.44958z" }),
			_react2.default.createElement("circle", { fill: "#FFEAAE", cx: "75.07803", cy: "318.21362", r: "8.35782" }),
			_react2.default.createElement("path", { fill: "#F9914B", d: "M112.40389,322.33905l0.00001-0.00003c4.40293-4.33716,11.78096-0.4877,10.74227,5.60477l0,0h0.00002 c6.16071-0.49231,9.33822,7.19907,4.6264,11.19849l-0.00002,0.00003h0.00002c5.03582,3.58289,2.52602,11.51727-3.65422,11.55234 h-0.00002h0.00001c1.55463,5.98163-5.46812,10.44647-10.22499,6.5007h-0.00002h-0.00001 c-2.65401,5.58151-10.90367,4.48764-12.01137-1.59265v-0.00003l-0.00002,0.00003c-5.6208,2.5697-11.23727-3.57104-8.1775-8.94083 h0.00002l-0.00002-0.00003c-5.95756-1.64444-6.31284-9.95874-0.51728-12.10544h0.00002l-0.00001-0.00003 c-3.50671-5.08917,1.56544-11.68665,7.38497-9.6058h0.00002v-0.00003c0.58497-6.15259,8.71125-7.94623,11.83172-2.61151 L112.40389,322.33905z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M123.84809,289.37616c-0.88943,3.44916-6.39732,14.63733-7.75033,14.28842 c-1.353-0.34891-0.76363-12.80539,0.1258-16.25455c0.88944-3.44916,3.10954-4.99951,5.21499-4.45657 C123.54401,283.49637,124.73753,285.927,123.84809,289.37616z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M110.93916,287.90787c1.53573,3.21393,4.50805,15.32495,3.24732,15.92737 c-1.26072,0.60242-8.81612-9.31863-10.35185-12.53256c-1.53573-3.21396-0.83159-5.82864,1.13027-6.76608 S109.40343,284.69394,110.93916,287.90787z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M100.10653,295.08078c3.24231,1.47485,13.30405,8.84186,12.72551,10.11374 c-0.57854,1.27185-12.74345-1.47162-15.98576-2.94647s-4.3836-3.93045-3.4833-5.90964 C94.26327,294.35922,96.86422,293.6059,100.10653,295.08078z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M96.41891,307.53864c3.43178-0.95432,15.87495-1.77841,16.24929-0.43225 c0.37434,1.34619-10.70798,7.06403-14.13976,8.01834s-5.88447-0.19318-6.467-2.28802S92.98714,308.49292,96.41891,307.53864z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M101.60179,319.45224c2.01548-2.93695,11.01778-11.56656,12.16985-10.77594 c1.15208,0.79059-3.66212,12.29431-5.6776,15.23123c-2.01548,2.93695-4.63194,3.63449-6.42472,2.40421 C99.87653,325.08142,99.58631,322.38919,101.60179,319.45224z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M113.23003,325.2471c-0.34389-3.54535,1.00526-15.94257,2.396-16.07748 c1.39073-0.13489,5.09728,11.77197,5.44117,15.31732c0.34388,3.54535-1.21207,5.76154-3.37624,5.97144 C115.52678,330.6683,113.57391,328.79248,113.23003,325.2471z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M125.86265,322.21176c-2.54234-2.49487-9.47762-12.85892-8.49896-13.8562 s11.47161,5.74139,14.01395,8.23624s2.77493,5.19269,1.25201,6.7446S128.405,324.7066,125.86265,322.21176z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M133.58871,311.76645c-3.55121-0.27698-15.52583-3.75839-15.41718-5.15143 s12.47824-2.97568,16.02945-2.69867c3.55121,0.27698,5.46353,2.19412,5.29445,4.36188 C139.32637,310.44595,137.13992,312.04343,133.58871,311.76645z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M132.79309,298.79865c-2.89842,2.0705-14.30931,7.10071-15.12151,5.96378 c-0.81219-1.13696,7.64617-10.30038,10.5446-12.37085c2.89842-2.0705,5.59566-1.83109,6.85954-0.06183 C136.33961,294.09903,135.69153,296.72818,132.79309,298.79865z" }),
			_react2.default.createElement("circle", { fill: "#FFEAAE", cx: "115.34043", cy: "306.38589", r: "8.89753" }),
			_react2.default.createElement("circle", { fill: "#FFEAAE", cx: "110.0183", cy: "340.33041", r: "8.35782" }),
			_react2.default.createElement("path", { fill: "#75C69F", d: "M86.61914,379.83838l-0.43066-1.43701C81.5,362.76172,69.34961,353.77002,69.22754,353.68115 l-1.21191-0.88232l1.76172-2.42529l1.21289,0.88037c0.53223,0.38574,13.08301,9.64258,18.07129,26.28613l0.43066,1.43701 L86.61914,379.83838z" }),
			_react2.default.createElement("path", { fill: "#75C69F", d: "M105.25098,367.03381c-2.21191,1.86273-3.9375,4.03766-5.27686,6.16541 c-0.04395-1.49072-0.20117-3.02899-0.54395-4.58539c-2.05176-9.32349-9.55225-15.59698-9.55225-15.59698 s-2.49854,8.03583-3.98389,16.67371c-0.55176-0.56958-1.12598-1.12836-1.75244-1.65594 c-7.30273-6.14917-17.07227-6.56226-17.07227-6.56226s3.43359,9.33417,8.07568,17.67621 c5.66455,10.17908,11.95752,8.80231,15.51221,6.76996c3.20996,1.43793,6.65137,0.86157,6.65137,0.86157 s0.3833-0.81897,0.85938-2.20538c3.41846,2.18707,10.09961,4.31909,16.0791-6.42694 c4.64209-8.34204,8.07617-17.67627,8.07617-17.67627S112.55322,360.88464,105.25098,367.03381z" }),
			_react2.default.createElement("path", { fill: "#75C69F", d: "M86.9541,378.28174l-0.28711-0.95801c-3.08887-10.30469-11.06348-16.18408-11.14355-16.24219 l-0.80957-0.5874l1.1748-1.61865l0.80859,0.58691c0.35059,0.25391,8.60449,6.3418,11.88574,17.28711l0.28711,0.95801 L86.9541,378.28174z" }),
			_react2.default.createElement("path", { fill: "#836EEA", d: "M84.771,354.27917c0.19092,0.15527,0.36963,0.28308,0.51807,0.3653 c0.88428,0.49109,1.99902,0.17224,2.49023-0.71204c0.49121-0.88434,0.17236-1.99933-0.71191-2.49036 c-0.14941-0.0827-0.3623-0.16595-0.59668-0.24634c0.23145-0.0882,0.44189-0.17847,0.58789-0.26611 c0.86719-0.52032,1.14893-1.64532,0.62842-2.51276c-0.52002-0.86743-1.64502-1.1488-2.5127-0.62848 c-0.14453,0.08685-0.32178,0.22815-0.50635,0.38892c0.03955-0.24567,0.06104-0.4668,0.05811-0.63776 c-0.0166-1.01135-0.8501-1.81757-1.86182-1.80066c-1.01123,0.01691-1.81738,0.85046-1.80078,1.86188 c0.00293,0.16937,0.03174,0.38739,0.07861,0.62885c-0.19092-0.15521-0.36963-0.28302-0.51807-0.36523 c-0.88428-0.49103-1.99902-0.17224-2.49023,0.7121s-0.17236,1.99927,0.71191,2.49036 c0.14941,0.0827,0.3623,0.16595,0.59668,0.24634c-0.23145,0.0882-0.44189,0.17847-0.58789,0.26611 c-0.86719,0.52032-1.14893,1.64532-0.62842,2.51276c0.52002,0.86743,1.64502,1.1488,2.5127,0.62848 c0.14502-0.08685,0.32178-0.22815,0.50635-0.38892c-0.03955,0.24567-0.06104,0.4668-0.05811,0.63776 c0.0166,1.01135,0.8501,1.8175,1.86182,1.80066c1.01123-0.01691,1.81738-0.85052,1.80078-1.86188 C84.84668,354.73877,84.81787,354.52069,84.771,354.27917z" }),
			_react2.default.createElement("path", { fill: "#836EEA", d: "M71.07031,355.04327c0.16309,0.18256,0.32129,0.34479,0.4541,0.44897 c0.7959,0.62433,1.94678,0.48535,2.57129-0.31049s0.48535-1.94714-0.31055-2.57147 c-0.13379-0.10516-0.33154-0.22107-0.55029-0.3374c0.24268-0.05054,0.46436-0.10651,0.62256-0.17004 c0.93896-0.37701,1.39404-1.44354,1.01709-2.3822c-0.37695-0.9386-1.44385-1.39386-2.38232-1.01685 c-0.15723,0.06311-0.35059,0.16754-0.55957,0.29779c0.07715-0.2337,0.13232-0.44647,0.15625-0.61414 c0.14307-1.0014-0.55322-1.92896-1.55469-2.07172c-1.00098-0.14282-1.92871,0.55322-2.07129,1.55463 c-0.02441,0.16925-0.03076,0.39136-0.02197,0.64001c-0.16309-0.18256-0.32129-0.34479-0.4541-0.44897 c-0.79541-0.62439-1.94678-0.48535-2.57129,0.31049s-0.48535,1.94708,0.31055,2.57147 c0.13379,0.10516,0.33154,0.22101,0.55029,0.33734c-0.24268,0.05054-0.46484,0.10657-0.62256,0.17004 c-0.93896,0.37701-1.39404,1.4436-1.01709,2.3822c0.37695,0.93866,1.44385,1.39392,2.38232,1.01685 c0.15723-0.06311,0.35059-0.1676,0.55957-0.29785c-0.07715,0.23376-0.13232,0.44653-0.15625,0.61426 c-0.14307,1.00134,0.55322,1.92889,1.55469,2.07172c1.00146,0.14276,1.92871-0.55328,2.07178-1.55463 C71.07275,355.51404,71.0791,355.29193,71.07031,355.04327z" }),
			_react2.default.createElement("path", { fill: "#836EEA", d: "M93.86035,364.28217c-0.13379-0.10516-0.33154-0.22101-0.55029-0.33734 c0.24268-0.05054,0.46436-0.10657,0.62256-0.17004c0.93848-0.37708,1.39404-1.4436,1.01709-2.3822 c-0.37744-0.93866-1.44385-1.39392-2.38232-1.01691c-0.15723,0.06317-0.35059,0.1676-0.55957,0.29785 c0.07715-0.2337,0.13232-0.44647,0.15625-0.6142c0.14258-1.00134-0.55322-1.92889-1.55469-2.07172 c-1.00146-0.14276-1.92871,0.55322-2.07178,1.55463c-0.02393,0.16925-0.03027,0.39136-0.02148,0.64001 c-0.16357-0.18256-0.32129-0.34479-0.4541-0.44897c-0.79541-0.62433-1.94678-0.48535-2.57129,0.31049 s-0.48535,1.94714,0.31055,2.57147c0.13379,0.10516,0.33154,0.22101,0.55029,0.33734 c-0.24268,0.05054-0.46484,0.10657-0.62256,0.17004c-0.93896,0.37708-1.39404,1.4436-1.01709,2.3822 c0.37695,0.93866,1.44336,1.39392,2.38232,1.01691c0.15723-0.06317,0.35059-0.16766,0.55908-0.29791 c-0.07666,0.23376-0.13184,0.44653-0.15576,0.61426c-0.14307,1.0014,0.55322,1.92889,1.55469,2.07172 c1.00098,0.14276,1.92871-0.55322,2.07178-1.55463c0.02393-0.16925,0.03027-0.39136,0.02148-0.64001 c0.16309,0.18256,0.32129,0.34479,0.4541,0.44897c0.79541,0.62433,1.94678,0.48535,2.57129-0.31049 C94.79492,366.0578,94.65625,364.90649,93.86035,364.28217z" }),
			_react2.default.createElement("path", { fill: "#836EEA", d: "M79.72021,361.2196c-0.16895,0.00671-0.38623,0.04016-0.62695,0.09271 c0.15088-0.1944,0.27441-0.37622,0.35352-0.52612c0.4707-0.89526,0.12646-2.00269-0.76855-2.47345 c-0.89551-0.47076-2.00293-0.12665-2.47363,0.76862c-0.0791,0.15082-0.15771,0.36591-0.23291,0.60211 c-0.09326-0.22949-0.18848-0.43774-0.2793-0.58185c-0.54004-0.85535-1.6709-1.11102-2.52637-0.57111 c-0.85547,0.53998-1.11084,1.67108-0.57129,2.52643c0.09033,0.14276,0.23535,0.31622,0.40039,0.49738 c-0.24609-0.03412-0.46777-0.05054-0.63867-0.04376c-1.01074,0.03998-1.79785,0.89172-1.75781,1.9024 c0.04004,1.01074,0.8916,1.79773,1.90234,1.75781c0.16943-0.00671,0.38672-0.04016,0.62695-0.09271 c-0.15088,0.1944-0.27441,0.37622-0.35352,0.52612c-0.4707,0.89526-0.12646,2.00269,0.76904,2.47345 c0.89502,0.47076,2.00244,0.12665,2.47314-0.76862c0.07959-0.15082,0.15771-0.36597,0.23291-0.60217 c0.09326,0.22955,0.18848,0.43781,0.2793,0.58191c0.54004,0.85535,1.67139,1.11102,2.52637,0.57111 c0.85547-0.53998,1.11133-1.67108,0.57129-2.52643c-0.09033-0.14276-0.23535-0.31628-0.40039-0.49744 c0.24658,0.03406,0.46826,0.05054,0.63867,0.04376c1.01074-0.03992,1.79785-0.89166,1.75781-1.90234 C81.58301,361.96667,80.73096,361.17969,79.72021,361.2196z" }),
			_react2.default.createElement("polygon", { fill: "#AD6636", points: "121.6416,371.06464 118.98828,371.06464 118.98828,371.06281 70.27979,371.06281 70.27979,371.06464 67.48096,371.06464 68.81299,386.28729 71.61182,386.28729 73.88379,412.25171 94.63379,412.25171 115.38477,412.25171 117.65625,386.28729 120.31104,386.28729 \t" }),
			_react2.default.createElement("polygon", { fill: "#9B5C32", points: "117.65631,386.28729 71.61198,386.28729 71.93977,390.03513 117.32848,390.03513 \t\t" })
		);
	}

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = FoamFinger;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FoamFinger() {
		// 15
		var style = {
			st19: {
				fill: "#75C69F"
			},
			st120: {
				fill: "#F2F2F2"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st19, d: "M6.4200001,392.7200012l-1.8299999-6.9200134c-2.6400175-13.6289062-3.9793715-27.4777527-4-41.3599854 c-0.0340934-7.3316345,1.166-14.6166992,3.5500002-21.5499878c0.1066852-0.3018799,0.1608033-0.619812,0.1599998-0.9400024 v-66.6100159c0-7.7599945,5.6400003-17,12.670001-20.3099976c17.6200027-8.1999969,34.9199982,4.5399933,34.9199982,21.2399902 v13.9100037c-0.0000038,0.0718079,0.058197,0.1300049,0.1299934,0.1300049h0.0000076h5.5499992 c4.806778-0.0153198,9.4996414,1.4627686,13.4300003,4.230011c0.6940536,0.4912109,1.5757904,0.6351013,2.3899994,0.3900146 c2.2210312-0.6715393,4.529686-1.0085754,6.8499985-1h1c5.4941406,0.015564,10.806366,1.970459,15,5.519989 c0.6407547,0.5440369,1.5016174,0.7518311,2.3199997,0.5599976c1.7468338-0.4114075,3.5353775-0.6194763,5.3300018-0.6199951 h2.6699982c11.9293518,0,21.6000061,9.6706543,21.6000061,21.6000061l0,0v14.3399963 c0.0098724,3.631134-0.8327255,7.2138977-2.4599991,10.4599915c-0.343895,0.6665955-0.4190521,1.4396667-0.2099991,2.1600037 c1.7759094,5.9683533,2.6753082,12.1630554,2.6699982,18.3900146c0.0371857,13.3737793-1.3574219,26.7131042-4.1600037,39.789978 l-2,6.5899963c0,0-11.8099976,3.6600037-55.8000031,3.6600037S6.4200001,392.7200012,6.4200001,392.7200012z" }),
			_react2.default.createElement("path", { style: style.st120, d: "M116.9000015,325.5c2.5367432-2.9724731,3.9302139-6.7522278,3.9300003-10.6600037v-11.6699829 c0.0216522-9.1016235-7.3391266-16.4974976-16.4407501-16.519165c-3.3528137-0.0079651-6.6282959,1.006897-9.3892517,2.9091492 c-4.4744339-7.9068604-14.5114441-10.6893616-22.4182892-6.2149353c-0.6989288,0.3955078-1.3679504,0.8417053-2.001709,1.3349304 c-5.1863785-7.4592285-15.4376717-9.3017578-22.8969116-4.115387c-1.1495361,0.7992554-2.1923256,1.7420044-3.1030884,2.8053894 V256.269989c0-9.1127014-7.3873024-16.5-16.5-16.5s-16.5,7.3872986-16.5,16.5v67.5100098 c-2.5141916,6.6022949-3.7757344,13.615387-3.7200003,20.6799927c0.0604692,13.210022,1.3189554,26.3873291,3.7600002,39.3699951 c0.2236748,1.082489,1.2825203,1.7786865,2.3649988,1.5549927c1.0824785-0.2236633,1.778676-1.2825012,1.5550013-2.3649902 c-2.3887653-12.7158203-3.620471-25.6218872-3.6800003-38.5599976c0-9.3699951,2.3499994-31.9200134,24-38.8200073 c7.0499992-2.1000061,12.4799995-2.1300049,16.1299973-0.0700073c2.6300011,1.480011,4.3899994,4,5.3699989,7.8099976 c1.9399986,7.4700012-2.2900009,13.9200134-10.5099983,16.0599976l-5.4599991,1.3900146 c-1.071434,0.2761536-1.7161446,1.3685608-1.4400024,2.4400024s1.3685684,1.716156,2.4400024,1.4400024l5.4700012-1.3900146 c3.750351-0.8994751,7.1585236-2.8693237,9.8100014-5.6700134c3.6599998,1,8.0600014,2.8999939,10.3599968,6.6499939 c0.5799026,0.9416504,1.8133621,1.2348938,2.7550049,0.6549988s1.2349014-1.8133545,0.6549988-2.7550049l0,0 c-2.2300034-3.6199951-6.1299973-6.3599854-11.3400002-8c0.4022141-0.7833557,0.7367668-1.5996704,1-2.4400024 c2.1981392-0.5514526,4.2581291-1.5525208,6.0499992-2.9400024C72.3231125,326.256897,82.5290756,328.1239014,90,323 c2.9456635,5.1433411,8.4128952,8.3230286,14.3399963,8.3399963c3.3635864-0.0133972,6.6417084-1.06073,9.3899994-3 c2.0616379,5.7563782,3.1137619,11.8255615,3.1100006,17.9400024c0.0206528,12.3330688-1.2123489,24.6362915-3.6799927,36.7200012 c-0.2485275,1.0769653,0.4230499,2.1514587,1.5000076,2.3999939c1.0769501,0.2485352,2.1514664-0.4230347,2.3999939-1.5 c2.5519104-12.3526001,3.8153458-24.936615,3.7699966-37.5499878 C120.8343201,339.2154846,119.5013046,332.1433716,116.9000015,325.5z M34.7299995,301.8200073 c-7.855423,2.3769226-14.6307049,7.4291992-19.1499996,14.2799988V256.269989c0-6.9035645,5.5964413-12.5,12.5000019-12.5 s12.5,5.5964355,12.5,12.5v44.1900024C38.6022148,300.7841797,36.6479721,301.2385254,34.7299995,301.8200073z M54,302.0899963 c-2.8974762-1.5170898-6.1560669-2.2089233-9.4199982-2v-6c0-6.9035645,5.5964394-12.5,12.5-12.5s12.5,5.5964355,12.5,12.5 v11.6700134c0.0108795,5.0604858-3.0399857,9.6249084-7.7200012,11.5499878 c0.0369835-1.6656189-0.158226-3.3282471-0.5800018-4.9400024C60,307.5599976,57.5800018,304.1000061,54,302.0899963z M70.0599976,315.9499817c2.2782593-2.9038391,3.5144424-6.4891052,3.5100021-10.1799927v-11.6699829 c-0.0037918-1.9894714-0.3697586-3.9616394-1.0800018-5.8200073c2.2681122-1.9880371,5.18396-3.0796814,8.1999969-3.0700073 c6.8989944,0.0110168,12.4889908,5.6010132,12.5,12.5v11.6700134c0.0018082,6.9035645-5.5931702,12.5014648-12.496727,12.5032654 c-4.3312607,0.0011292-8.3544312-2.2399597-10.6332703-5.9232788V315.9499817z M93.0599976,320.2599792 c2.6618729-3.0029297,4.1311493-6.8771362,4.1299973-10.8900146v-11.6599731 c-0.0033188-1.4736633-0.2051315-2.9401855-0.5999985-4.3599854c5.4252548-4.269165,13.2841339-3.3319702,17.5532913,2.0932922 c1.7353821,2.2053223,2.6782074,4.9304504,2.6767044,7.7366943v11.6700134 c-0.0017853,3.1151428-1.1722488,6.1162109-3.2799988,8.4100037c-0.3092651,0.1793518-0.5647964,0.4383545-0.7399979,0.75 c-5.0401993,4.6932983-12.9307556,4.4120789-17.624054-0.6281128c-0.8578339-0.9212341-1.5712357-1.9670715-2.1159439-3.1018982 V320.2599792z" }),
			_react2.default.createElement("path", { style: style.st120, d: "M37.0900002,369.1900024v-4.480011h5.1500015l1.1699982-5.0599976H39v-4.519989h5.3100014 l1.7999992-8.1099854h5l-1.8400002,8.1099854h4.5999985l1.7999992-8.1099854h4.8899994l-1.8800011,8.1099854h3.8100014v4.519989 h-4.5999985l-1.0900002,5.0599976h4.2999992v4.480011h-5.4799995l-1.5099983,6.9400024h-4.8400002l1.5099983-6.9400024h-4.6899986 l-1.4599991,6.9400024h-4.9000015l1.4599991-6.9400024H37.0900002z M47.0900002,364.7600098h4.7299995L53,359.6900024h-4.7799988 L47.0900002,364.7600098z" }),
			_react2.default.createElement("path", { style: style.st120, d: "M68.3799973,376.1300049v-6.3999939h6.3600006v-13.3800049h-6.3600006v-4.8099976 c3.2256927-0.3202515,6.3472519-1.3187561,9.159996-2.9299927c0.9466629-0.5266724,1.8099976-1.0566711,2.5899963-1.5899963 h2.8000031v22.7099915H89v6.3999939H68.3799973z" }),
			_react2.default.createElement("path", { style: style.st19, d: "M6.4200516,392.7219849l-1.8280954-6.9202576 c-0.167016-0.6304016-4.0791764-19.6881409-4.0265303-41.3602295c0-5.4101868,0.6421819-13.3742065,3.5534275-21.5531311 c0.1069951-0.3005981,0.1644831-0.6186523,0.1644831-0.9377136l-0.0000033-66.6111755 c-0.0000005-7.7587585,5.6360784-17.0364227,12.6702328-20.3103943c17.6209087-8.2014618,34.920166,4.537262,34.920166,21.240387 v13.9075317c0,0.0734253,0.0595627,0.1329346,0.1329842,0.132843l4.5979156-0.0046997h0.9512634 c4.936264,0,9.5862198,1.5189514,13.4281082,4.2315369c0.6943054,0.4902344,1.5794144,0.6392517,2.3921509,0.3905945 c2.1877823-0.6694031,4.488945-1.0158691,6.84758-1.0158691h0.9512634c5.6102142,0,10.9074097,2.0424194,15.0313721,5.5246277 c0.6398392,0.5402832,1.5002365,0.7485046,2.3154602,0.5569458c1.7314835-0.4068909,3.5175781-0.616333,5.3273621-0.616333 h2.6732101c11.9280319,0,21.5976105,9.6695557,21.5976105,21.5975952v14.3406982 c0,3.6933899-0.8522339,7.2532349-2.4642487,10.4573059c-0.3382263,0.6722717-0.4238358,1.438324-0.2091446,2.1596069 c1.7759628,5.9664612,2.6733932,12.1282349,2.6733932,18.3908386c0.0535583,21.8214111-3.9493713,39.2461853-4.1191101,39.8071594 l-2.0032806,6.5921326c0,0-11.8128128,3.6582947-55.7986526,3.6582947S6.4200516,392.7219849,6.4200516,392.7219849z" }),
			_react2.default.createElement("path", { style: style.st120, d: "M116.8958588,325.5014038c2.4453125-2.8786011,3.9291992-6.5979004,3.9291992-10.6620483v-11.6669922 c0-9.0986328-7.4023438-16.5004883-16.5-16.5004883c-3.3588867,0-6.5737305,1.019043-9.2973633,2.8840942 c-2.8439941-4.9790039-8.1955566-8.3494263-14.3286133-8.3494263c-3.7143555,0-7.2177734,1.2289429-10.0952148,3.468811 c-2.9853516-4.2705688-7.930172-7.0752563-13.523922-7.0752563c-4.996582,0-9.4724121,2.2409058-12.5009766,5.7606812V256.269043 c0-9.0981445-7.4023438-16.5-16.5-16.5c-9.0986328,0-16.5009766,7.4018555-16.5009766,16.5v67.5059814 c-3.0258789,7.6069946-3.7177739,15.282959-3.7177739,20.6834717c-0.0498047,20.6708984,3.7216802,39.1879883,3.7597661,39.3725586 c0.1953125,0.9453125,1.0283203,1.5961914,1.9570312,1.5961914c0.1337891,0,0.2695312-0.0136719,0.40625-0.0419922 c1.0810547-0.2231445,1.7773438-1.2807617,1.5546875-2.3623047c-0.0371094-0.1811523-3.7265625-18.3134766-3.6777344-38.5595703 c0-9.3730469,2.3466797-31.9199219,24.046875-38.8232422c7.0527344-2.1049805,12.4785156-2.1274414,16.1298828-0.0693359 c2.6337891,1.484375,4.390625,4.0380859,5.3710938,7.8071289c1.9414062,7.4667969-2.2890625,13.9228516-10.5146484,16.0620117 l-5.4580078,1.3852539c-1.0703125,0.2714844-1.7177734,1.3598633-1.4462891,2.4306641 c0.2714844,1.0693359,1.3583984,1.7216797,2.4306641,1.4462891l5.46875-1.3881836 c4.0981445-1.0656738,7.4213867-3.0613403,9.8078613-5.6665649c3.6611328,0.9818115,8.0556602,2.9033813,10.3630333,6.6538696 c0.3769531,0.6142578,1.0332031,0.9526367,1.7050781,0.9526367c0.3574219,0,0.71875-0.0961914,1.0458984-0.296875 c0.9404297-0.5786133,1.234375-1.8105469,0.6552734-2.7514648c-2.2285156-3.6229248-6.1259766-6.3555298-11.3413048-8.0075073 c0.4038086-0.7803345,0.7290039-1.5966797,0.9956055-2.4368896c2.2524414-0.5639648,4.2958946-1.5817871,6.053463-2.9393921 c3.0446777,4.3659668,8.0522461,7.0527344,13.5256348,7.0527344c3.4431152,0,6.6411133-1.0630493,9.2890625-2.8739014 c2.901123,5.0752563,8.3693848,8.3392334,14.3369141,8.3392334c3.4897461,0,6.7246094-1.0961914,9.3933105-2.9523926 c2.060791,5.7680054,3.107666,11.7877197,3.107666,17.9396973c0.0488281,20.2119141-3.6308594,36.4902344-3.6679688,36.6523438 c-0.2470703,1.0761719,0.4257812,2.1494141,1.5019531,2.3964844c0.1503906,0.034668,0.3007812,0.0512695,0.4492188,0.0512695 c0.9111328,0,1.734375-0.6269531,1.9472656-1.5527344c0.15625-0.6787109,3.8193359-16.862793,3.7695312-37.5522461 C120.8260345,339.1622314,119.493515,332.1680908,116.8958588,325.5014038z M34.7283821,301.8178711 c-8.1577148,2.5947876-14.5754395,7.3932495-19.1503906,14.2766113V256.269043c0-6.8925781,5.6074219-12.5,12.5009766-12.5 c6.8925781,0,12.5,5.6074219,12.5,12.5v37.831543v6.3574219C38.7377815,300.7509155,36.78722,301.2034912,34.7283821,301.8178711z M54.000843,302.0859375c-2.5786133-1.4533691-5.7285156-2.1243896-9.421875-2.0157471v-5.9696045 c0-6.8925781,5.6083984-12.5004883,12.5009766-12.5004883s12.4999962,5.6079102,12.4999962,12.5004883v11.6669922 c0,5.1657104-3.1240234,9.6567993-7.7194786,11.546875c0.0368652-1.5999756-0.1420898-3.2543335-0.5812988-4.9433594 C60.0291634,307.5634766,57.5799446,304.1030273,54.000843,302.0859375z M70.0655365,315.9493408 c2.2080078-2.8192139,3.5144043-6.3581543,3.5144043-10.1817627v-11.6669922c0-2.050354-0.3930664-4.0063477-1.0795898-5.8190918 c2.2741699-1.9854126,5.1445312-3.0749512,8.1987305-3.0749512c6.8925781,0,12.5009766,5.6079102,12.5009766,12.5004883v11.6669922 c0,6.8925781-5.6083984,12.5004883-12.5009766,12.5004883C76.3138275,321.8745117,72.3201752,319.5999756,70.0655365,315.9493408z M93.0657806,320.2614136c2.5644531-2.9088745,4.1342773-6.7139282,4.1342773-10.8873901v-11.6669922 c0-1.5115967-0.2214355-2.9694214-0.6040039-4.3612061c2.1965332-1.7321777,4.8996582-2.6739502,7.7290039-2.6739502 c6.8925781,0,12.5,5.6079102,12.5,12.5004883v11.6669922c0,3.2382812-1.248291,6.1832886-3.2753906,8.4060669 c-0.3195801,0.1838379-0.5710449,0.4433594-0.7426758,0.7495728c-2.230957,2.0686035-5.2067871,3.3448486-8.4819336,3.3448486 C99.5128021,327.3398438,95.1312103,324.5373535,93.0657806,320.2614136z" }),
			_react2.default.createElement("path", { style: style.st120, d: "M37.0936165,369.1865234v-4.4750977h5.1455078l1.1708984-5.0610352H38.976429v-4.5175781h5.3115234 l1.7988281-8.1142578h4.9775391l-1.8408203,8.1142578h4.6015625l1.7978516-8.1142578h4.8935547l-1.8818359,8.1142578h3.8066406 v4.5175781h-4.6015625l-1.0869141,5.0610352h4.3496094v4.4750977h-5.4794922l-1.5058594,6.9433594h-4.8515625l1.5058594-6.9433594 h-4.6845703l-1.4638672,6.9433594h-4.8935547l1.4638672-6.9433594H37.0936165z M47.0906868,364.7529297h4.7265625 l1.1708984-5.0610352H48.219593L47.0906868,364.7529297z" }),
			_react2.default.createElement("path", { style: style.st120, d: "M68.3797455,376.1298828v-6.3994141h6.3574219v-13.3847656h-6.3574219v-4.8100586 c2.7324219-0.1669922,5.7851562-1.1425781,9.1591797-2.9277344c0.9482422-0.5292969,1.8125-1.059082,2.59375-1.5893555h2.8027344 v22.7119141h6.1064453v6.3994141H68.3797455z" })
		);
	}

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Gold;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Gold() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { fill: "#FFDB80", d: "M143.50821,377.37881l-38.77338-29.11682c-0.71062-0.53366-1.60537-0.76047-2.48439-0.62976 l-33.84924,5.03256c-1.24831,0.18561-2.28378,1.06223-2.67282,2.26282l-7.73633,23.87454 c-0.43334,1.33728,0.02158,2.80258,1.13608,3.65933l39.92744,30.69324c0.70879,0.54489,1.60722,0.78119,2.49237,0.65561 l47.06801-6.67871c1.98788-0.28207,3.27362-2.2489,2.73442-4.18292l-6.63649-23.80487 C144.51732,378.43878,144.09349,377.81833,143.50821,377.37881z" }),
			_react2.default.createElement("path", { fill: "#FFEAAE", d: "M144.71382,379.14389c-0.19653-0.70499-0.62054-1.32565-1.20561-1.76498l-38.77336-29.11676 c-0.71083-0.53369-1.60551-0.76083-2.48428-0.62979l-33.84933,5.03256c-0.02683,0.00372-0.04993,0.01801-0.07679,0.0228 l36.02736,26.97775c3.8691,2.89587,8.735,4.12558,13.51544,3.41461l26.85093-3.92126L144.71382,379.14389z" }),
			_react2.default.createElement("path", { fill: "#F9C764", d: "M97.37881,379.10468L65.50455,355.6185l-7.51266,23.18356 c-0.43329,1.33734,0.02172,2.80264,1.13636,3.65942l39.92731,30.69333c0.66545,0.51132,1.49833,0.73846,2.32993,0.66232 l4.12333-17.35672C108.08715,385.65253,103.61358,383.80185,97.37881,379.10468z" }),
			_react2.default.createElement("path", { fill: "#FFDB80", d: "M88.07377,385.32605L49.30039,356.2092c-0.71062-0.53363-1.60537-0.76044-2.48439-0.62976L12.96676,360.612 c-1.24831,0.18561-2.28379,1.06223-2.67282,2.26282l-7.73633,23.87454c-0.43334,1.33731,0.02158,2.80258,1.13608,3.65933 l39.92744,30.69327c0.70879,0.54486,1.60722,0.78119,2.49238,0.65558l47.068-6.67871 c1.98788-0.28204,3.27361-2.24887,2.73443-4.18292l-6.6365-23.80484C89.08288,386.38602,88.65906,385.76556,88.07377,385.32605z" }),
			_react2.default.createElement("path", { fill: "#FFEAAE", d: "M89.27938,387.09109c-0.19653-0.70499-0.62054-1.32562-1.20561-1.76495l-38.77336-29.11679 c-0.71083-0.53369-1.60551-0.76083-2.48429-0.62976l-33.84933,5.03253c-0.02683,0.00372-0.04993,0.01801-0.07679,0.0228 l36.02736,26.97775c3.8691,2.89587,8.735,4.12558,13.51544,3.41461l26.85093-3.92126L89.27938,387.09109z" }),
			_react2.default.createElement("path", { fill: "#F9C764", d: "M41.94438,387.05188L10.07011,363.5657l-7.51266,23.18356 c-0.43329,1.33734,0.02172,2.80264,1.13636,3.65942l39.92732,30.69333c0.66545,0.51132,1.49833,0.73846,2.32993,0.66235 l4.12333-17.35675C52.65271,393.59973,48.17914,391.74905,41.94438,387.05188z" }),
			_react2.default.createElement("path", { fill: "#FFDB80", d: "M113.15673,348.82916l-34.14889-25.53934c-0.71062-0.53363-1.60537-0.76044-2.4844-0.62976 l-33.84923,5.03259c-1.24831,0.18558-2.28379,1.06223-2.67282,2.26279l-7.73633,23.87457 c-0.43334,1.33728,0.02158,2.80258,1.13608,3.6593l35.30294,27.11575c0.70879,0.54486,1.60722,0.78119,2.49238,0.65558 l47.068-6.67868c1.98788-0.28207,3.27362-2.2489,2.73443-4.18295l-6.6365-23.80484 C114.16583,349.88913,113.74201,349.26868,113.15673,348.82916z" }),
			_react2.default.createElement("path", { fill: "#F9C764", d: "M67.02734,350.55502l-27.24979-19.90881l-7.51266,23.18353 c-0.43329,1.33734,0.02172,2.80264,1.13636,3.65942l35.30284,27.11597c0.66545,0.51132,1.49832,0.73846,2.32993,0.66235 l4.12333-17.35675C77.73566,357.10287,73.2621,355.25217,67.02734,350.55502z" }),
			_react2.default.createElement("path", { fill: "#FFEAAE", d: "M114.36234,350.59424c-0.19653-0.70502-0.62054-1.32565-1.20561-1.76498l-34.14888-25.53943 c-0.71083-0.53369-1.60551-0.7608-2.48428-0.62976l-33.84933,5.03253c-0.02683,0.00372,31.3261,23.42322,31.3261,23.42322 c3.86909,2.89587,8.73499,4.12555,13.51544,3.41458l26.85092-3.92126L114.36234,350.59424z" }),
			_react2.default.createElement("path", { fill: "#FFF3D7", d: "M68.01085,346.64139c3.53385,2.64017,5.98946,4.47461,5.98946,4.47461 c1.19722,0.89594,2.49728,1.61172,3.85281,2.1806l0.70252-30.28055c-0.62093-0.32706-1.32911-0.46094-2.032-0.3558 l-7.98396,1.18674L68.01085,346.64139z" }),
			_react2.default.createElement("path", { fill: "#FFF3D7", d: "M81.77532,354.44876c1.63864,0.28305,3.31666,0.33356,4.99493,0.15491l0.58171-25.07343l-4.91327-3.67438 L81.77532,354.44876z" })
		);
	}

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = HotDog;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HotDog() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { fill: "#FFCE8D", d: "M105.34041,353.72766v0.05786c-0.37891-0.0332-0.76074-0.05811-1.14844-0.05811H38.02401 c-0.38745,0-0.76904,0.0249-1.14795,0.05811v-0.05786c-8.83691,0-16.00073,10.35474-16.00073,23.12793 s7.16382,23.12793,16.00073,23.12793h68.46436c8.83716,0,16.00098-10.35474,16.00098-23.12793 S114.17757,353.72766,105.34041,353.72766z" }),
			_react2.default.createElement("path", { fill: "#f96e6e", d: "M71.10799,382.10388c-25.54687,0-43.70019-4.08105-44.45996-4.25488 c-5.38379-1.22998-8.75195-6.59229-7.52148-11.97607c1.23047-5.3833,6.5918-8.75098,11.97656-7.521 c0.15527,0.03516,16.85742,3.75195,40.00488,3.75195s39.85059-3.71729,40.0166-3.75439 c5.37891-1.21631,10.73926,2.1543,11.96289,7.53564c1.22266,5.38086-2.13867,10.73486-7.51855,11.96387 C114.80916,378.02283,96.65486,382.10388,71.10799,382.10388z" }),
			_react2.default.createElement("path", { fill: "#ffeaae", d: "M71.10896,370.60046c-3.19434,0-6.21875-1.38965-8.29882-3.81348 c-1.09375-1.27393-2.59668-2.00684-4.24805-2.08252c-1.65723-0.06836-3.19238,0.5083-4.37695,1.64209l-0.03613,0.03564 c-2.29492,2.2251-5.44238,3.32959-8.61816,3.03857c-3.18262-0.29443-6.06836-1.9585-7.91699-4.56592l-0.08594-0.12256 c-0.94238-1.33008-2.35547-2.19678-3.97363-2.43555c-1.62109-0.23828-3.22266,0.18359-4.5127,1.18896 c-1.0918,0.84961-2.66113,0.65186-3.50879-0.43701c-0.84863-1.08936-0.65234-2.66016,0.43652-3.5083 c2.37988-1.85156,5.33594-2.62988,8.31348-2.18994c2.98242,0.43945,5.58496,2.03613,7.32812,4.49512l0.08594,0.12256 c1,1.41064,2.56641,2.31396,4.29395,2.47363c1.71387,0.16309,3.4082-0.43262,4.65039-1.62256l0.03613-0.03613 c2.15527-2.09033,5.10547-3.2124,8.11328-3.07324c3,0.1377,5.84179,1.52344,7.79785,3.80225 c1.14551,1.33398,2.78711,2.08838,4.52051,2.08838s3.375-0.75439,4.50391-2.06982c1.96875-2.29492,4.8125-3.68115,7.81348-3.81787 c2.9873-0.14893,5.95703,0.98389,8.11426,3.07617c1.24512,1.2085,2.95215,1.80957,4.67773,1.65039 c1.72852-0.15918,3.29492-1.06299,4.29785-2.479l0.08789-0.12354c1.73633-2.4502,4.33789-4.04688,7.31836-4.4873 c2.98633-0.44141,5.93457,0.33594,8.3125,2.18652c1.08984,0.84766,1.28613,2.41846,0.43848,3.5083 c-0.84766,1.08887-2.41895,1.28613-3.50879,0.43799c-1.29102-1.00439-2.89453-1.42822-4.51074-1.18652 c-1.61816,0.23926-3.03027,1.10547-3.97559,2.44043l-0.08789,0.12354c-1.84277,2.6001-4.72852,4.26514-7.91309,4.55859 c-3.1875,0.29443-6.32422-0.81445-8.61914-3.0415c-1.1875-1.15137-2.75-1.74854-4.4043-1.66943 c-1.65234,0.0752-3.15625,0.80859-4.2334,2.06396C77.32771,369.21033,74.30232,370.60046,71.10896,370.60046z" }),
			_react2.default.createElement("path", { fill: "#FFCE8D", d: "M104.19244,373.98352c7.17969,0,15.0016,3.81873,15.0016,10.99841s-7.82191,15.00159-15.0016,15.00159 H38.02428c-7.17969,0-15.0016-7.8219-15.0016-15.00159s7.82191-10.99841,15.0016-10.99841H104.19244z" }),
			_react2.default.createElement("path", { fill: "#FFCE8D", d: "M104.19244,373.98352c7.17969,0,15.0016,3.81873,15.0016,10.99841s-7.82191,15.00159-15.0016,15.00159 H38.02428c-7.17969,0-15.0016-7.8219-15.0016-15.00159s7.82191-10.99841,15.0016-10.99841H104.19244z" }),
			_react2.default.createElement("path", { fill: "#FFCE8D", d: "M104.19244,373.98352c7.17969,0,15.0016,3.81873,15.0016,10.99841s-7.82191,15.00159-15.0016,15.00159 H38.02428c-7.17969,0-15.0016-7.8219-15.0016-15.00159s7.82191-10.99841,15.0016-10.99841H104.19244z" })
		);
	}

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = IceCream;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IceCream() {
		// 10
		var style = {
			st15: {
				fill: "#FCDAC9"
			},
			st116: {
				fill: "#F9C9B4"
			},
			st0: {
				fill: "#FFFFFF"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st15, d: "M97.7784424,343.6196594l-36.8149567,21.9043274L44.3048096,299.152832 c-0.4536781-1.8075256,1.7190514-3.1002502,3.0911522-1.8391724L97.7784424,343.6196594z" }),
			_react2.default.createElement("path", { style: style.st116, d: "M44.3046875,299.152832l0.1025391,0.4084473l-0.0952148-1.3798828 C44.2290039,298.4765625,44.2172852,298.8046875,44.3046875,299.152832z" }),
			_react2.default.createElement("path", { style: style.st116, d: "M85.4443359,343.2739258l9.1201172-0.6298828l0.1914062,2.7739258l3.0224609-1.7983398 l-4.7617188-4.3764648l-7.8134766,0.5395508l-0.5693359-8.2441406l-4.4418945-4.0825195l-8.4726562,0.5852051 l-0.7946777-8.9396973L67,315.657959v0.012207l-8.9421387,0.6298828l-0.5408936-9.1213379l0.531311-0.0336914l-4.2467957-3.923584 l0.0599518,0.7075195l-8.2210007,0.5678711l0.8685036,3.447998l7.6034431-0.5249023l0.6305771,9.1213379l-5.9708443,0.4123535 l0.8658943,3.4477539l5.3467674-0.3691406l0.6299286,9.1213379l-3.715313,0.2565918l0.8652458,3.4477539l3.0913162-0.2133789 l0.6298828,9.1213379l-1.4599571,0.1008301l0.8652344,3.4482422l0.8359375-0.0578613l0.3227539,4.6740723l3.9135742,15.5927734 l0.6455078-0.3840332l-0.5185547-7.5114746l9.1201172-0.6296387l0.2006836,2.9040527l3.3701172-2.0053711l-0.0786133-1.1398926 l2.2568359-0.1557617l9.9946289-5.9467773L85.4443359,343.2739258z M58.4770508,319.7910156l9.1201172-0.6296387 l0.6298828,9.1210938l-9.1201172,0.6298828L58.4770508,319.7910156z M59.3481445,332.4033203l9.1201172-0.6296387 l0.6298828,9.1213379l-9.1201172,0.6298828L59.3481445,332.4033203z M60.8491211,354.1374512l-0.6298828-9.121582 l9.1201172-0.6296387l0.6298828,9.1213379L60.8491211,354.1374512z M71.9604492,331.5324707l9.1206055-0.6298828 l0.6298828,9.1213379l-9.1206055,0.6298828L71.9604492,331.5324707z M73.4614258,353.2663574l-0.6298828-9.1213379 l9.1206055-0.6298828l0.6298828,9.1213379L73.4614258,353.2663574z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M111.2392578,388.3376465c-3.4277344,0-4.5058594,1.8022461-4.5058594,2.7919922 c0,0.989502,2.0175781,1.791748,4.5058594,1.791748s4.5053711-0.8022461,4.5053711-1.791748 C115.7446289,390.1398926,114.6665039,388.3376465,111.2392578,388.3376465z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M127.4794922,382.885498c0-1.5998535-1.7421875-4.5134277-7.2836914-4.5134277l0,0 c-1.0859375-2.8686523-3.949707-5.0373535-8.262207-6.5651855c1.1865234-6.0119629,0.2529297-12.4643555-3.1274414-18.145752 c-1.8139648-3.0488281-4.1665039-5.5742188-6.8540039-7.5541992c-0.0458984-4.0048828-4.8427734-7.480957-8.0527344-3.9875488 c-0.0761719,0.0825195-0.1533203,0.1604004-0.2270508,0.2509766c-4.8735352,5.9558105-11.9912109,2.8269043-18.0166016,6.472168 c-5.5600586,3.3637695-4.6513672,11.621582-12.65625,10.817627c-0.3793945-0.0380859-0.7338867-0.0361328-1.0678711-0.0036621 c-4.6318359,0.451416-4.9140625,7.2897949-0.9248047,9.4106445c0.1728516,1.9821777,0.6000977,3.9558105,1.2446289,5.8903809 c-1.8691406,1.2797852-2.9179688,2.6630859-2.9179688,4.0424805c0,4.9707031,13.5805664,8,30.3330078,8 c5.7324219,0,11.3212891-0.4663086,16.1245117-1.265625c8.0834961-0.8903809,9.1445312,0.0478516,14.4047852,0.0478516 c0.222168,0,0.4248047-0.0048828,0.6181641-0.012207C124.546875,385.6447754,127.4794922,384.4023438,127.4794922,382.885498z" })
		);
	}

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = JazzCup;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function JazzCup() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("ellipse", { fill: "#ebefff", cx: "98.55396", cy: "313.54935", rx: "37.61078", ry: "9.44258" }),
			_react2.default.createElement("ellipse", { fill: "#fb9f59", cx: "98.55396", cy: "320.43338", rx: "35.77922", ry: "8.98275" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M98.55383,322.99191c-20.60988,0-37.33862-4.16248-37.59834-9.32135h-0.01234l9.17892,76.41412 c0,3.25748,8.68463,9.75937,28.43177,9.75937c19.74691,0,28.43201-6.44443,28.43201-9.70193l9.17891-76.47156h-0.0121 C135.89293,318.82944,119.16395,322.99191,98.55383,322.99191z" }),
			_react2.default.createElement(
				"g",
				{ opacity: "0.6" },
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M119.7729,280.51514c0.08665-0.66141-1.88027-1.46387-4.39301-1.79221 c-2.47118-0.32309-4.55396-0.06693-4.704,0.5705c0,0-4.81226,37.27051-4.81226,37.33911 c0,0.54913,2.09655,0.99451,4.68264,0.99451c2.58632,0,4.68288-0.44537,4.68288-0.99451 c0-0.00024-0.00024-0.00024-0.00024-0.00024C115.22986,316.62589,119.74702,280.71338,119.7729,280.51514z" })
			),
			_react2.default.createElement("path", { fill: "#f8faff", d: "M98.55407,301.18954c-15.05287,0-40.52821,2.60318-40.52821,12.35971c0,0,0.70065,5.32193,0.72878,5.54385 c1.14868,9.06424,25.35516,11.50989,39.79943,11.50989c14.50479,0,38.85357-2.46619,39.81242-11.62421 c0.01938-0.18506,0.71555-5.42953,0.71555-5.42953C139.08203,303.79272,113.60693,301.18954,98.55407,301.18954z M98.55407,322.01871c-20.77204,0-35.52506-3.2562-35.66453-8.46945c-0.1148-4.29138,14.89249-8.46924,35.66453-8.46924 c20.7718,0,35.77912,4.17786,35.66428,8.46924C134.07884,318.76251,119.32587,322.01871,98.55407,322.01871z" }),
			_react2.default.createElement("path", { fill: "#00DBD5", d: "M131.36719,353.63913l-16.97949-17.32996c-2.21094-2.25684-5.64941-2.7749-8.42383-1.27246 c-2.77832,1.50195-4.22461,4.66211-3.54688,7.74658l3.29297,14.98438l-19.92773-21.33594 c-2.18457-2.33936-5.66699-2.92334-8.49414-1.42041c-2.82715,1.50098-4.29492,4.7124-3.58008,7.83203l3.39746,14.84277 l-12.4624-13.21338l2.84058,23.64795l17.18042,18.21582c2.19141,2.32324,5.66602,2.89307,8.48633,1.38672 c2.81738-1.50488,4.27734-4.70996,3.56543-7.82373l-3.3418-14.59619l19.62109,21.00781 c2.17578,2.33008,5.64355,2.91699,8.4668,1.43506c2.82324-1.48389,4.30566-4.67188,3.62109-7.78662l-3.54199-16.11816 l7.66309,7.82098L131.36719,353.63913z" }),
			_react2.default.createElement("path", { fill: "#987FEF", d: "M130.71802,359.0488l-17.63208-4.27234c-0.61133-0.14648-1.25293,0.12207-1.57422,0.66797 c-0.32031,0.54492-0.24512,1.23535,0.18457,1.69971l8.03516,8.68018L76.2832,354.78036 c-0.625-0.15771-1.27051,0.11572-1.59277,0.66943c-0.32227,0.5542-0.2373,1.25439,0.20703,1.71533l8.32031,8.62891 l-16.5127-4.15649l0.36621,3.04858l20.30957,5.1123c0.62012,0.15625,1.26855-0.11768,1.58984-0.67139 s0.23633-1.25293-0.20801-1.71387l-8.30566-8.61328l43.2666,10.99805c0.62305,0.1582,1.26172-0.11084,1.58594-0.65674 c0.32422-0.54639,0.25098-1.24072-0.18066-1.70703l-8.10156-8.75195l13.34644,3.23395L130.71802,359.0488z" })
		);
	}

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = MagicWand;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MagicWand() {
		// 9
		var style = {
			st89: {
				opacity: 0.2,
				fill: "#FFEAAE"
			},
			st19: {
				fill: "#75C69F"
			},
			st36: {
				fill: "#987FEF"
			},
			st29: {
				fill: "#5994C9"
			},
			st67: {
				fill: "#F9914B"
			},
			st70: {
				fill: "#FFEAAE"
			},
			st72: {
				fill: "#F79AC0"
			},
			st0: {
				fill: "#FFFFFF"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("circle", { style: style.st89, cx: "62.5", cy: "284.8648071", r: "58.9804611" }),
			_react2.default.createElement("polygon", { style: style.st19, points: "69.3496246,308.1174927 68.0444336,305.6479492 76.8852539,300.9750977 82.3833466,311.3780212 " }),
			_react2.default.createElement("polygon", { style: style.st36, points: "101.3212128,368.6108093 97.0195618,360.4716492 110.0566711,363.7385559 114.3559952,371.873291 " }),
			_react2.default.createElement("line", { style: style.st29, x1: "106.2882309", y1: "356.6083069", x2: "110.0566711", y2: "363.7385559" }),
			_react2.default.createElement("polygon", { style: style.st19, points: "93.2526474,353.3442688 89.2551346,345.7806091 102.2740173,349.013031 106.2882309,356.6083069 " }),
			_react2.default.createElement("line", { style: style.st29, x1: "98.5195999", y1: "341.9093323", x2: "102.2740173", y2: "349.013031" }),
			_react2.default.createElement("polygon", { style: style.st67, points: "94.221817,333.7774963 98.5195999,341.9093323 85.4901047,338.6568298 81.1843948,330.5100098 \t" }),
			_react2.default.createElement("line", { style: style.st29, x1: "90.4523773", y1: "326.6453857", x2: "94.221817", y2: "333.7774963" }),
			_react2.default.createElement("polygon", { style: style.st36, points: "73.1164856,315.244751 77.4168396,323.3814392 90.4523773,326.6453857 86.1519089,318.5084839 \t" }),
			_react2.default.createElement("line", { style: style.st29, x1: "82.3833466", y1: "311.3780212", x2: "86.1519089", y2: "318.5084839" }),
			_react2.default.createElement("polygon", { style: style.st29, points: "73.1171265,315.2459717 86.151062,318.5068359 82.3843384,311.3798828 69.3504028,308.1188965 \t" }),
			_react2.default.createElement("path", { style: style.st70, d: "M65.3790817,264.8403015l18.1977386-6.5726624c3.0600739-1.1052246,6.0591507,1.7781982,5.075058,4.879364 l-5.8522644,18.4420166l11.8743668,15.2760315c1.9967575,2.5687561,0.181221,6.3120728-3.0722504,6.3344421l-19.3478622,0.1330872 l-10.8589745,16.0137329c-1.8260078,2.6928101-5.947155,2.1228943-6.9738121-0.9644165l-6.1053734-18.3598022 l-18.5855827-5.3789673c-3.1252899-0.9045105-3.8567638-5.0000916-1.2378025-6.9305115l15.5745296-11.4800415 l-0.6275444-19.3381348c-0.105526-3.2518463,3.5635452-5.2131195,6.2088089-3.3188782L65.3790817,264.8403015z" }),
			_react2.default.createElement("polygon", { style: style.st72, points: "90.4534302,326.6473389 77.4194946,323.3864746 81.1862183,330.5134277 94.2201538,333.774292 \t" }),
			_react2.default.createElement("polygon", { style: style.st70, points: "98.522522,341.9147949 85.4885864,338.6539307 89.2553101,345.7808838 102.2685547,349.0366211 102.274292,349.0136719 \t" }),
			_react2.default.createElement("polygon", { style: style.st29, points: "106.2868652,356.6057129 93.2529297,353.3447266 97.0195923,360.4716797 110.0535278,363.732666 " }),
			_react2.default.createElement("path", { style: style.st72, d: "M115.9458008,374.8813477l-1.5899048-3.0081787l-13.0338745-3.2608643l3.3010178,6.2459106 c0,0,1.7102966,2.0106506,6.2098389,2.0106506C114.5833359,376.868866,115.9458008,374.8813477,115.9458008,374.8813477z" }),
			_react2.default.createElement("path", { style: style.st70, d: "M65.3790817,264.8403015l18.1977386-6.5726624c3.0600739-1.1052246,6.0591507,1.7781982,5.075058,4.879364 l-5.8522644,18.4420166l11.8743668,15.2760315c1.9967575,2.5687561,0.181221,6.3120728-3.0722504,6.3344421l-19.3478622,0.1330872 l-10.8589745,16.0137329c-1.8260078,2.6928101-5.947155,2.1228943-6.9738121-0.9644165l-6.1053734-18.3598022 l-18.5855827-5.3789673c-3.1252899-0.9045105-3.8567638-5.0000916-1.2378025-6.9305115l15.5745296-11.4800415 l-0.6275444-19.3381348c-0.105526-3.2518463,3.5635452-5.2131195,6.2088089-3.3188782L65.3790817,264.8403015z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M56.1459961,291.8779297l-8.2877388-2.3987732c-1.4418488-0.4172974-1.7793121-2.3067932-0.571064-3.1974182 l6.9447403-5.1191406l-0.2795372-8.6228638c-0.0486374-1.5002747,1.6441574-2.4050598,2.8645439-1.5310974l7.0141144,5.0231018 l8.1151047-2.9311523c1.4117737-0.5099182,2.7954483,0.820343,2.3414612,2.2510986l-2.6093979,8.2235107l5.2948532,6.8121033 c0.9211884,1.1851807,0.0834961,2.9121704-1.4175339,2.9224243l-8.6273193,0.0589294l-4.8423576,7.1410522 c-0.8424416,1.2423706-2.7437744,0.9794312-3.2174301-0.4449463L56.1459961,291.8779297z" })
		);
	}

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Martini;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Martini() {
		// 19
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				{ style: { "opacity": "0.4" } },
				_react2.default.createElement("path", { style: { "fill": "#FFFFFF" }, d: "M86.3356857,319.8651428c0-1.6376953,14.3574905-8.9121094,32.0683594-8.9121094 s32.0683517,7.2744141,32.0683517,8.9121094s-14.3574829,8.9121094-32.0683517,8.9121094 S86.3356857,321.5028381,86.3356857,319.8651428z" })
			),
			_react2.default.createElement(
				"g",
				{ style: { "opacity": "0.4" } },
				_react2.default.createElement("path", { style: { "fill": "#FFFFFF" }, d: "M150.4723969,319.8650513c0-1.6376953-14.3574219-8.9121094-32.0683517-8.9121094 s-32.0683594,7.2744141-32.0683594,8.9121094c0,0.2124023,0.2460938,0.520752,0.7045898,0.8945312l31.3637695,39.8120117 l31.3637619-39.8120117C150.2263031,320.3858032,150.4723969,320.0774536,150.4723969,319.8650513z" })
			),
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { style: { "fill": "#FFFFFF" }, d: "M118.4043198,390.5316467c-1.6572266,0-3-1.3432617-3-3v-28.9599609c0-1.6567383,1.3427734-3,3-3 s3,1.3432617,3,3v28.9599609C121.4043198,389.188385,120.0615463,390.5316467,118.4043198,390.5316467z" })
			),
			_react2.default.createElement("path", { style: { "fill": "#FFFFFF" }, d: "M118.5136948,382.7284241c-1.6054688,0-15.6855469,0.1625977-15.6855469,5.8032227 s14.0800781,5.8037109,15.6855469,5.8037109s15.6855545-0.1630859,15.6855545-5.8037109 S120.1191635,382.7284241,118.5136948,382.7284241z" }),
			_react2.default.createElement("path", { style: { "fill": "#FFFFFF" }, d: "M157.4892883,312.1012268c-0.0053711-0.0537109-0.0058594-0.1039429-0.0161133-0.1611938 c-0.0473633-0.3026733-0.15625-0.5840454-0.3227539-0.8258057c-0.8696289-1.496521-3.6875-3.7755127-11.8613281-6.625061 c-4.8828125-1.7026367-14.8720703-4.559082-26.9082108-4.559082c-12.0351562,0-22.0244141,2.8564453-26.9082031,4.559082 c-8.1738281,2.8495483-10.9919434,5.12854-11.8613281,6.625061c-0.1665039,0.2417603-0.2756348,0.5231323-0.3225098,0.8258057 c-0.0192871,0.1090088-0.0310059,0.2127686-0.0310059,0.3069458c0,0.0903931,0.0119629,0.1903687,0.0297852,0.2945557 c0.0183105,0.4028931,0.1538086,0.8039551,0.4223633,1.1448975l37.1230469,47.1230469 c0.3798828,0.4814453,0.9580078,0.762207,1.5712891,0.762207s1.1914062-0.2807617,1.5712891-0.762207l37.1230545-47.1230469 C157.4658508,313.2203064,157.5849915,312.6430359,157.4892883,312.1012268z M118.3808823,303.9300842 c16.939949,0,30.5537186,5.7688599,34.3784256,8.3168945c-3.824707,2.5480347-17.4384766,8.3168945-34.3784256,8.3168945 s-30.5537109-5.7688599-34.3793945-8.3168945C87.8271713,309.6989441,101.4409409,303.9300842,118.3808823,303.9300842z M118.4043198,356.3397522l-29.3125-37.2089844c0.7419434,0.2854614,1.5256348,0.5758667,2.3808594,0.8740234 c4.8837891,1.7026367,14.8730469,4.559082,26.9082031,4.559082c12.0361404,0,22.0253983-2.8564453,26.9082108-4.559082 c0.8806152-0.3070068,1.6872559-0.605957,2.4477539-0.8994751L118.4043198,356.3397522z" }),
			_react2.default.createElement("circle", { style: { "fill": "#75C69F" }, cx: "118.4040451", cy: "338.9004211", r: "7.3903885" }),
			_react2.default.createElement("circle", { style: { "fill": "#FC7E7E" }, cx: "120.7840118", cy: "336.9004211", r: "2.9862974" })
		);
	}

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = MiniGolf;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MiniGolf() {
		// 12
		var style = {
			st24: {
				fill: "#FC5959"
			},
			st19: {
				fill: "#75C69F"
			},
			st3: {
				fill: "#66AA88"
			},
			st92: {
				fill: "#4D4D4D"
			},
			st0: {
				fill: "#FFFFFF"
			},
			st16: {
				fill: "#E6E6E6"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("polygon", { style: style.st24, points: "76.9270248,310.4536133 24.18787,285.7267151 76.8113022,261.3862 \t" }),
			_react2.default.createElement("path", { style: style.st19, d: "M27.2711525,406.002594c0,0,0.4094181-8.2949829,1.755415-9.1663513 c1.0367985-0.6711731,3.3351002,0.6379089,4.6362514,0.0041809c1.1029434-0.5372009,1.4021645-4.7505798,2.6834297-5.2579041 c1.1385155-0.4508057,3.0941658,2.8613281,4.3655243,2.4361572c1.160656-0.3881226,1.7321739-4.5519714,2.9975777-4.9172363 c1.1757431-0.3393555,2.9561462,3.1423645,4.2175789,2.8239746c1.1866951-0.29953,1.9167557-4.4176025,3.1753654-4.6975708 c1.1923485-0.2652283,2.8529243,3.3193665,4.1064911,3.0725403c1.1993065-0.236145,2.0383759-4.3142395,3.2908211-4.5327759 c1.2050438-0.2102966,2.7777176,3.4460449,4.029377,3.2527161c1.2098923-0.1868896,2.1369247-4.2301636,3.3880539-4.4006042 c1.2140656-0.1654053,2.7146759,3.5464783,3.9654617,3.3970947c1.2177124-0.1454773,2.2184982-4.1567078,3.4690628-4.2864685 c1.2197342-0.1265869,2.656723,3.6311951,3.9059067,3.519989c1.2212448-0.1087341,2.284111-4.0895081,3.5318298-4.183136 c1.2232361-0.0917664,2.6021347,3.7054749,3.8492203,3.6286316c1.2242126-0.0754395,2.3437958-4.0269165,3.5894928-4.0875854 c1.2281494-0.0597839,2.5553894,3.7723389,3.8029861,3.7272644c1.2285309-0.0443726,2.4031525-3.9671326,3.6491776-3.9968872 c1.2310333-0.0293884,2.507782,3.8346558,3.7545776,3.8198853c1.2320099-0.0146179,2.4589539-3.9085083,3.7050781-3.9085083 c1.243187,0,2.4672546,3.8938599,3.6963959,3.9083862c1.2436218,0.0147095,2.5171585-3.8494568,3.7451172-3.8201904 c1.2440109,0.0296326,2.4168015,3.95224,3.6433868,3.99646c1.2450638,0.0448608,2.5696259-3.7874756,3.7953339-3.7279358 c1.2462616,0.0605469,2.3666229,4.0119629,3.5914001,4.0872803c1.2474289,0.0767212,2.6264572-3.7206116,3.8500443-3.6289368 c1.2485886,0.0935364,2.3125305,4.0742493,3.5346298,4.1829529c1.2496948,0.1111145,2.6869812-3.646759,3.9072266-3.5202332 c1.2507477,0.1296692,2.2519226,4.1408081,3.4698181,4.2861633c1.251709,0.1493835,2.7530212-3.562561,3.9679871-3.3971558 c1.2525635,0.1705322,2.1812134,4.2138977,3.3924866,4.4009094c1.2532959,0.1934509,2.8274078-3.462738,4.0339966-3.2522583 c1.2538757,0.218689,2.0944519,4.2969971,3.2950897,4.5333557c1.2561646,0.2472534,2.9191742-3.336853,4.1138916-3.071106 c1.2592926,0.2801208,1.9899902,4.3983459,3.1772919,4.6980286c1.2617798,0.318512,3.0425415-3.1631165,4.2185822-2.8236389 c1.2661591,0.3654785,1.8382874,4.5295715,2.9995575,4.9179993c1.2714691,0.4252625,3.227356-2.8866882,4.365921-2.4357605 c1.2853241,0.5090332,1.5874786,4.723999,2.6932526,5.2631226c1.3022156,0.6348572,3.6025085-0.6836243,4.6394653-0.0112 c1.3427734,0.8707581,1.7380829,7.5657043,1.7380829,9.1663513" }),
			_react2.default.createElement("ellipse", { style: style.st19, cx: "103.1399689", cy: "406.002594", rx: "75.8688126", ry: "19.6074219" }),
			_react2.default.createElement("path", { style: style.st3, d: "M175.8318634,408.002594c-0.9623108,0.8867188-1.0114899,4.5030823-2.4411926,5.3554382 c-1.1113129,0.6625366-3.331131-2.3276062-4.7079773-1.7053833c-1.1736603,0.530365-1.6669769,4.7740479-3.0211029,5.2718811 c-1.2071533,0.4438171-3.1284485-2.903595-4.4703674-2.4878845c-1.2282867,0.3805237-1.9601593,4.5561523-3.2948303,4.9114075 c-1.2428284,0.3308411-3.0080719-3.1768494-4.3379364-2.8692322c-1.2499542,0.289093-2.1199341,4.4089966-3.4424591,4.6764832 c-1.2587585,0.2545776-2.9152985-3.3527222-4.2360992-3.1187134c-1.2658539,0.2242737-2.2386017,4.2987976-3.5581818,4.5033264 c-1.2717285,0.1971436-2.8480225-3.4812622-4.166748-3.3032227c-1.2766724,0.1723938-2.3311615,4.2068481-3.6492615,4.3606873 c-1.2792511,0.149292-2.7868958-3.5855103-4.1027679-3.4543457c-1.2814484,0.1277771-2.4020233,4.1251831-3.716011,4.2352295 c-1.284111,0.1075134-2.7308426-3.6744995-4.0439682-3.5844421c-1.2870865,0.0882874-2.4687347,4.0509338-3.7817688,4.1219177 c-1.2898483,0.0697021-2.6829987-3.753418-3.996048-3.7008362c-1.290451,0.0516663-2.5272064,3.9804382-3.8383255,4.0150757 c-1.2934952,0.0341797-2.6349716-3.8261719-3.9469147-3.8089905c-1.2947311,0.0169678-2.5853271,3.9120483-3.8964157,3.9120483 c-1.3081207,0-2.5958023-3.89505-3.8876266-3.9119263c-1.3094788-0.0171204-2.6484375,3.8433533-3.939537,3.8092957 c-1.3108139-0.0345764-2.5473862-3.9632263-3.8375473-4.014801c-1.3121414-0.0524597-2.7042847,3.7707825-3.9932709,3.7012024 c-1.3134537-0.0709229-2.4956741-4.0335083-3.7831879-4.1217041c-1.314743-0.0900879-2.7629395,3.6918945-4.0486069,3.5843201 c-1.315979-0.1101379-2.4385986-4.107666-3.7219543-4.2355957c-1.3171539-0.1312561-2.826004,3.6034546-4.1064606,3.4540405 c-1.3182526-0.1538086-2.3729324-4.1882935-3.6497498-4.3606567c-1.3192368-0.1781006-2.8959961,3.5002747-4.1681976,3.3031006 c-1.3200989-0.2046204-2.2933617-4.2792053-3.5596886-4.5035706c-1.3230782-0.2344055-2.9818306,3.372467-4.2426643,3.1174316 c-1.3265572-0.2683411-2.2001991-4.3891602-3.4537315-4.6792603c-1.329525-0.3077087-3.0947304,3.1997986-4.3372078,2.868866 c-1.3348808-0.3555603-2.0666237-4.5313721-3.2949944-4.9121399c-1.3413582-0.4158325-3.2625847,2.9313354-4.4691391,2.4874268 c-1.3568535-0.4992065-1.8518753-4.743988-3.027317-5.2758789c-1.3769569-0.6230774-3.5983963,2.3653564-4.7091599,1.7018738 c-1.4249859-0.8511353-1.2632065-5.0989075-2.2151222-6.0075073c-1.5787907-1.5069275-2.8999119,3.1349487-3.4671707-1.3349609 l-0.008007,9.0110168c0,5.4053345,12.2572899,10.5926819,21.1973572,12.9016724 c14.6661034,3.7880859,34.0673447,5.9004211,54.6754608,5.9004211s40.0093613-2.1123352,54.6754684-5.9004211 c8.9400635-2.3089905,21.1973572-6.3394775,21.1973572-14.9241028l-0.0080109-6.8427124 C178.6024628,409.1848145,177.5551758,406.4147034,175.8318634,408.002594z" }),
			_react2.default.createElement("ellipse", { style: style.st92, cx: "79.0696793", cy: "404.2949219", rx: "17.9303246", ry: "4.371747" }),
			_react2.default.createElement("circle", { style: style.st0, cx: "134.2957306", cy: "399.4878235", r: "10.222209" }),
			_react2.default.createElement("circle", { style: style.st16, cx: "127.6634598", cy: "398.818512", r: "1.2777761" }),
			_react2.default.createElement("circle", { style: style.st16, cx: "133.565567", cy: "406.3026428", r: "1.2777761" }),
			_react2.default.createElement("circle", { style: style.st16, cx: "133.2004852", cy: "400.6439209", r: "1.2777761" }),
			_react2.default.createElement("circle", { style: style.st16, cx: "128.9412384", cy: "403.7470703", r: "1.2777761" }),
			_react2.default.createElement("circle", { style: style.st16, cx: "138.5", cy: "404", r: "1.2777761" }),
			_react2.default.createElement("circle", { style: style.st16, cx: "130.644928", cy: "394.4578552", r: "1.2777761" }),
			_react2.default.createElement("path", { style: style.st3, d: "M61.1394043,404.2949219c0.0002441,0.8098145,0.9191895,1.5656738,2.4931641,2.2158203 c3.1213379-1.2856445,8.8586426-2.1491699,15.4309082-2.1491699c6.5766602,0,12.3171387,0.8647461,15.4370117,2.1518555 C96.078125,405.8625488,96.9997559,405.105957,97,404.2949219c-0.0002441-0.7543945-0.7841797-1.4643555-2.1640625-2.0837402 c-0.276123-0.1240234-0.5759277-0.2443848-0.8981934-0.3605957c-1.9963379-0.720459-4.8566895-1.2851562-8.2114258-1.612793 c-2.0598145-0.2009277-4.302002-0.3144531-6.65625-0.3144531c-4.9516602,0-9.4343262,0.4892578-12.6789551,1.2802734 c-0.4057617,0.098877-0.7919922,0.2026367-1.1572266,0.3105469c-0.8537598,0.2521973-1.5771484,0.5302734-2.184082,0.8254395 C61.8378906,402.9284668,61.1396484,403.5913086,61.1394043,404.2949219z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M81.6666641,408.6211548c0,0-1.0934067,0.0455017-2.465332,0.0455017 c-1.3719177,0-2.465332-0.0366821-2.465332-0.0366821V261.2319336h4.9306641V408.6211548z" })
		);
	}

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Money;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Money() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("polygon", { fill: "#66AA88", points: "151.44595,368.28943 151.44595,400.67505 64.84555,413.52036 34.79037,394.89786 34.78257,362.99457 64.83562,381.02542" }),
			_react2.default.createElement("path", { fill: "#5F9B7B", d: "M64.84555,391.2417l12.36633-1.79156c0.36752-0.09317,3.84599-0.47253,3.7525-0.84006 c-0.08172-0.32156-3.63493-0.526-3.95404-0.5108l-12.16479-0.76062V391.2417z" }),
			_react2.default.createElement("path", { fill: "#5F9B7B", d: "M83.14124,394.42902l-18.29569,1.05804v4.61221l18.49722-4.31943 c0.36891-0.08319,3.85659-0.85547,3.77306-1.22433C87.04027,394.22034,83.474,394.40393,83.14124,394.42902z" }),
			_react2.default.createElement("path", { fill: "#5F9B7B", d: "M139.17935,377.43527l12.2666-3.12384v3.88879l-12.06506,0.58588 c-0.31911,0.01553-4.6835,0.32272-4.76523,0.00079C134.52219,378.41974,138.81184,377.52875,139.17935,377.43527z" }),
			_react2.default.createElement("path", { fill: "#5F9B7B", d: "M133.54004,386.05991l17.90591-4.05905v4.08752l-17.70436,1.32269 c-0.33276,0.02509-3.18181,0.1442-3.25739-0.19131C130.40067,386.85086,133.17114,386.14343,133.54004,386.05991z" }),
			_react2.default.createElement("polygon", { fill: "#71BC96", points: "151.44595,368.28943 64.84555,381.22189 34.78427,362.99557 121.38467,350.06311 \t\t" }),
			_react2.default.createElement("polygon", { fill: "#91CEAC", points: "46.60955,365.37283 120.52516,354.33432 139.62099,365.91238 65.70403,376.95093 \t\t" }),
			_react2.default.createElement("path", { fill: "#71BC96", d: "M82.24339,355.90826c10.4115-1.55478,19.73953,3.0842,23.69209,6.19632 c3.95255,3.11212,10.055,11.47958,0.32608,12.93246c-9.72892,1.45285-20.26849-4.07117-24.76002-7.84406 S74.89825,357.00516,82.24339,355.90826z" }),
			_react2.default.createElement("path", { fill: "#71BC96", d: "M65.53941,365.7453c3.44715-0.51477,6.53558,1.02115,7.84423,2.05154 c1.30865,1.0304,3.32912,3.80078,0.10796,4.2818c-3.22115,0.48105-6.71071-1.3479-8.19781-2.59708 C63.80668,368.23239,63.10749,366.10846,65.53941,365.7453z" }),
			_react2.default.createElement("path", { fill: "#71BC96", d: "M113.87035,358.51193c3.44714-0.51477,6.53558,1.02115,7.84422,2.05154 c1.30865,1.0304,3.32912,3.80078,0.10796,4.2818c-3.22115,0.48105-6.71071-1.3479-8.19781-2.59708 C112.13763,360.99902,111.43844,358.87509,113.87035,358.51193z" }),
			_react2.default.createElement("path", { fill: "#91CEAC", d: "M86.73431,359.09061c6.55703-1.20206,12.93575,3.01398,12.93575,3.01398l-2.16915,0.89099 c0,0,5.78441,3.24649,2.16915,3.96954s8.09585,3.70441,8.09585,3.70441l-11.18786,1.59796l-2.12424-3.13312 C89.02762,369.168,78.20032,360.65509,86.73431,359.09061z" }),
			_react2.default.createElement("polygon", { fill: "#5F9B7B", points: "64.84555,381.22189 64.84555,413.65945 34.79037,395.03696 34.78427,362.99557 \t\t" }),
			_react2.default.createElement("path", { fill: "#EBEFFF", d: "M110.18053,380.86002c-9.24514,0-16.73971,3.26328-16.73971,7.28928v7.289v7.289v15.29541 c0,4.02573,7.49457,7.289,16.73971,7.289s16.73971-3.26328,16.73971-7.289v-15.29541v-7.289v-7.289 C126.92024,384.12329,119.42567,380.86002,110.18053,380.86002z" }),
			_react2.default.createElement("rect", { x: "93.44084", y: "388.14911", fill: "#DCE4FF", width: "10.62132", height: "29.31278" }),
			_react2.default.createElement("ellipse", { fill: "#F8FAFF", cx: "110.18053", cy: "388.3652", rx: "16.73972", ry: "7.28908" }),
			_react2.default.createElement("path", { fill: "#EBEFFF", d: "M132.59955,415.09827c-9.24514,0-16.73971,3.26358-16.73971,7.289v7.28931 c0,4.0257,7.49457,7.289,16.73971,7.289s16.7397-3.26331,16.7397-7.289v-7.28931 C149.33925,418.36185,141.84468,415.09827,132.59955,415.09827z" }),
			_react2.default.createElement("path", { fill: "#DCE4FF", d: "M115.85979,422.38715v7.28955c0,3.08423,4.40601,5.71484,10.62122,6.7793v-20.35693h-2.31812 C119.20158,417.3642,115.85979,419.70306,115.85979,422.38715z" }),
			_react2.default.createElement("ellipse", { fill: "#F8FAFF", cx: "132.59953", cy: "422.38742", rx: "16.73972", ry: "7.28908" }),
			_react2.default.createElement("path", { fill: "#EBEFFF", d: "M137.60355,405.80737c-9.24515,0-16.73971,3.26358-16.73971,7.289v7.28928 c0,4.02573,7.49456,7.289,16.73971,7.289c9.24513,0,16.7397-3.26328,16.7397-7.289v-7.28928 C154.34325,409.07095,146.84868,405.80737,137.60355,405.80737z" }),
			_react2.default.createElement("path", { fill: "#DCE4FF", d: "M120.86378,413.09625v7.28955c0,3.08423,4.40601,5.71484,10.62122,6.7793v-20.35693h-2.31812 C124.20558,408.0733,120.86378,410.41217,120.86378,413.09625z" }),
			_react2.default.createElement("ellipse", { fill: "#F8FAFF", cx: "137.60353", cy: "413.09653", rx: "16.73972", ry: "7.28908" }),
			_react2.default.createElement("ellipse", { fill: "#F8FAFF", cx: "94.11608", cy: "422.38742", rx: "16.73972", ry: "7.28908" }),
			_react2.default.createElement("ellipse", { fill: "#F8FAFF", cx: "94.11608", cy: "415.09811", rx: "16.73972", ry: "7.28908" }),
			_react2.default.createElement("path", { fill: "#EBEFFF", d: "M94.11587,400.52023c-9.24512,0-16.73926,3.26361-16.73926,7.289v21.86731 c0,4.0257,7.49414,7.289,16.73926,7.289s16.73975-3.26331,16.73975-7.289v-21.86731 C110.85561,403.78384,103.36098,400.52023,94.11587,400.52023z" }),
			_react2.default.createElement("path", { fill: "#DCE4FF", d: "M85.67934,401.52103c-4.96143,1.26514-8.30322,3.604-8.30322,6.28809v21.86755 c0,3.08423,4.40625,5.71484,10.62158,6.7793v-34.93494H85.67934z" }),
			_react2.default.createElement("ellipse", { fill: "#F8FAFF", cx: "94.11607", cy: "407.80942", rx: "16.73972", ry: "7.28908" })
		);
	}

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Mouse;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Mouse() {
		// 2
		var style = {
			st24: {
				fill: "#FC5959"
			},
			st36: {
				fill: "#987FEF"
			},
			st38: {
				fill: "#353535"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st24, d: "M95.603653,413.375946c11.2272034-0.1366272,22.4543991-0.2733154,33.6817474-0.4099426 c3.8037109-0.0462952,3.8060303,5.8628235,0,5.9091492c-11.2273483,0.1365967-22.4545441,0.2733154-33.6817474,0.4099121 C91.7999344,419.3313904,91.7976303,413.4222412,95.603653,413.375946z" }),
			_react2.default.createElement("path", { style: style.st24, d: "M162.9366302,397.3920898c1.8909302-1.7072144,4.1417084-2.9072266,6.7154388-3.0761414 c2.5509033-0.1673889,5.1995697,0.9503784,6.5992432,3.1391602c2.2511597,3.5202026,1.0830994,9.71521-3.6716766,10.4454956 c-2.1125336,0.3244934-4.5161591-0.5332336-5.0473022-2.8658447c-0.0743256-0.3257751-0.0923615-0.6753845-0.0853577-1.0298157 c-1.5062561,0.6325073-3.3284607,0.4774475-4.5103455-0.8100281 C161.4960938,401.6257629,161.2352295,398.9281921,162.9366302,397.3920898z" }),
			_react2.default.createElement("path", { style: style.st36, d: "M179.3167572,415.3426514c0,0-6.2044678-19.2520752-21.9993134-19.2520752 s-28.5991211,10.4623108-28.5991211,18.9946594c0,8.5323792,12.8042603,11.9037476,28.5991211,11.9037476 S179.3167572,415.3426514,179.3167572,415.3426514z" }),
			_react2.default.createElement("path", { style: style.st24, d: "M149.8225555,397.4550781c1.4503632-2.1554565,4.0482941-3.3065186,6.5993042-3.1391602 c2.5737152,0.1689453,4.8244019,1.368988,6.7154999,3.0761414l0.0395966,0.0362854 c1.5887909,1.4562378,0.5493774,4.1047974-1.6057739,4.0917664l-0.3800201-0.0023193 c-3.4464569,0-5.5392456,2.091095-6.2872162,4.6378174c-0.4185333,1.4251099-2.2041321,2.0195312-3.3579407,1.0842285 C149.2863159,405.4081116,147.1723785,401.3937378,149.8225555,397.4550781z" }),
			_react2.default.createElement("path", { style: style.st38, d: "M165.7392578,413.0517578c-0.1972656,0-0.3964844-0.0581055-0.5703125-0.1791992 c-0.453125-0.3154297-0.5654297-0.9389648-0.2490234-1.3920898l3.9775391-5.7148438 c0.3154297-0.4536133,0.9384766-0.5649414,1.3916016-0.2495117s0.5654297,0.9389648,0.2490234,1.3920898l-3.9775391,5.7148438 C166.3662109,412.9023438,166.0556641,413.0517578,165.7392578,413.0517578z" }),
			_react2.default.createElement("path", { style: style.st38, d: "M170.5849609,412.1835938c-0.1972656,0-0.3964844-0.0581055-0.5703125-0.1791992l-5.7148438-3.9780273 c-0.453125-0.3154297-0.5654297-0.9389648-0.2490234-1.3920898c0.3154297-0.453125,0.9384766-0.5654297,1.3916016-0.2495117 l5.7148438,3.9780273c0.453125,0.3154297,0.5654297,0.9389648,0.2490234,1.3920898 C171.2119141,412.0341797,170.9013672,412.1835938,170.5849609,412.1835938z" }),
			_react2.default.createElement("path", { style: style.st24, d: "M178.5570526,411.8014526c2.9827118,0,2.9827118,4.9711609,0,4.9711609 C174.5801239,416.7726135,174.5801239,411.8014526,178.5570526,411.8014526z" })
		);
	}

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Pizza;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Pizza() {
		// 3
		var style = {
			st25: {
				fill: "#EAB049"
			},
			st26: {
				fill: "#C64A4A"
			},
			st27: {
				fill: "#FFEBCC"
			},
			st24: {
				fill: "#FC5959"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st25, d: "M93.449585,360.7979431c-32.8293724-0.0900879-65.2832489,15.8638306-74.3684998,44.7933655 c-3.5913601,11.4353943,16.6695995,16.3152771,20.2570515,4.8922729 c6.6102524-21.0485535,30.6053238-31.3465881,54.1114502-31.282196 C106.9686584,379.2386169,106.9873428,360.8351746,93.449585,360.7979431z" }),
			_react2.default.createElement("path", { style: style.st25, d: "M122.630867,430.7028503l-93.8735809-13.6578064l1.2475014-8.9124146l94.9430237,14.1077881 l-1.0529938,7.5282593C123.809433,430.3790588,123.2394485,430.8003235,122.630867,430.7028503z" }),
			_react2.default.createElement("path", { style: style.st26, d: "M43.0656281,410.9189453l81.2091217,11.9504089 c0.4657364,0.0685425,0.8183975-0.4118652,0.6134491-0.8356628l-22.5928192-46.7185669 c-1.6992035-3.5184631-12.4565887-2.2776489-16.7198257-1.4729919 c-26.0542336,4.9170227-36.3756218,13.256897-46.816227,30.3744812c-0.0099258,0.0162659-0.0200539,0.0343018-0.0287971,0.051239 C35.7809753,409.9778137,39.5554504,410.3791809,43.0656281,410.9189453z" }),
			_react2.default.createElement("path", { style: style.st27, d: "M124.8883209,422.0336914l-19.8499298-41.0464783 c-0.0238647,0.0016174-0.0482788,0.0049438-0.0721436,0.0066223c-0.9145737-1.5110474-2.8769531-0.5892944-5.2914047-0.327179 c-6.3521042,0.6896057-12.6339035-0.9416809-18.8935242,0.3615723c-5.8088455,1.2093201-9.8267822,4.6444092-13.8734741,8.7596436 c-7.2775269,7.4005432-22.3308296,10.6604004-18.4959679,24.221283 c1.8608818,6.5802002,11.0437698,4.9924316,11.9656677-0.5426636l13.2895241,1.9555969 c0.6501236,2.3100281,2.525383,4.222168,5.639595,4.222168c2.3686142,0,4.0195618-1.1122131,4.962616-2.6619263 l40.0055313,5.8870239C124.7405014,422.9378967,125.0930939,422.457489,124.8883209,422.0336914z" }),
			_react2.default.createElement("path", { style: style.st24, d: "M102.6781158,393.940918c2.9031754,0,5.5504532-0.8057251,7.5847321-2.1281433l-7.3689117-15.2581787 c-0.0725937-0.0010681-0.1429825-0.0083313-0.2158203-0.0083313c-6.4044495,0-11.596344,3.8939819-11.596344,8.6973267 S96.2736664,393.940918,102.6781158,393.940918z" }),
			_react2.default.createElement("ellipse", { style: style.st24, cx: "66.6375046", cy: "398.3991089", rx: "11.596426", ry: "8.6972599" }),
			_react2.default.createElement("path", { style: style.st24, d: "M99.6747208,406.3655701c-6.4044418,0-11.596344,3.8937988-11.596344,8.6973267 c0,0.8928528,0.1974945,1.7480774,0.5328293,2.5583191l20.0125885,2.9449463 c1.6444321-1.4999695,2.647522-3.4096069,2.647522-5.5032654 C111.2713165,410.2593689,106.0794144,406.3655701,99.6747208,406.3655701z" })
		);
	}

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Popsicle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Popsicle() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { fill: "#FD9797", d: "M125.2073669,385.0257568c0.0602798,1.5744629,0.3826218,5.8757935-13.2877655,7.8314514 c-22.9886169,3.2887573-44.6419983-1.0307312-44.8177948-5.6208496 c-0.2936249-7.6669922,17.5902405-7.3414001,41.2650757-9.9037476 C121.9426727,375.8633118,125.0872345,381.888092,125.2073669,385.0257568z" }),
			_react2.default.createElement("path", { fill: "#FCDAC9", d: "M37.1227455,307.5670166l0.0000076-0.0000305c2.9785652-2.9785461,7.807766-2.9785461,10.7863312,0 l17.7245293,17.7245483L54.847271,336.0778809l-17.7245255-17.7245483 C34.1441803,315.3747864,34.1441803,310.5455627,37.1227455,307.5670166z" }),
			_react2.default.createElement("path", { fill: "#FD9797", d: "M72.2578354,313.7215271c2.2909851-3.2400818,6.9475937-3.6366882,9.75354-0.8307495l33.372261,33.3722839 c13.2153015,13.215271,10.9589157,26.9373474,1.3860626,37.686676c-0.9527588,1.0698547-2.2241058,1.8113403-3.6251526,2.1102905 l-0.9466934,0.2020264c-10.9300156,2.3322754-22.222496,2.3955688-33.1779785,0.1860046l-1.1999588-0.2420044 c-1.2911911-0.2604065-2.4767914-0.8961792-3.4081879-1.8275757l-32.183876-32.1838684 c-2.6767006-2.6766968-2.2891273-7.1209412,0.8104973-9.2939148l1.7704926-1.2411804 c3.1578636-2.2137756,5.8709526-5.0020447,7.9976463-8.2192078l0.5543976-0.8386536 c2.3148994-3.5018921,5.3225288-6.4925232,8.8374748-8.7875366l0.5214386-0.3404541 c3.2432747-2.1176453,6.0571022-4.8291626,8.293354-7.9918213L72.2578354,313.7215271z" }),
			_react2.default.createElement("path", { fill: "#FC8B8B", d: "M76.059288,372.7965698c2.1382904,2.1383057,5.6050873,2.1383057,7.7433777,0 c2.1382828-2.1382751,2.1382828-5.605072,0-7.7433472c-1.686264-1.6862793-22.5051537-22.5106201-31.2417221-31.2471924 c-2.0885315,3.0625-4.7154045,5.7246094-7.7524948,7.8540344l-0.0366631,0.0257263 C53.4756737,350.3377686,74.3700714,371.1073608,76.059288,372.7965698z" }),
			_react2.default.createElement("path", { fill: "#FC8B8B", d: "M94.7293625,354.1264954c2.1382904,2.1383057,5.6050873,2.1383057,7.7433701,0 c2.1382904-2.1382751,2.1382904-5.605072,0-7.7433472c-1.69207-1.6920776-22.5797424-22.5797424-31.2282944-31.228302 l-0.231369,0.3269958c-2.0731583,2.9321289-4.6397171,5.4740906-7.5875435,7.5169678 C72.2231216,331.7435608,93.0460587,352.4432068,94.7293625,354.1264954z" }),
			_react2.default.createElement("path", { fill: "#FD9797", d: "M54.7944717,383.5910034c3.4476967,0,5.2781525,2.7640991,5.2781525,4.3650513 c0,1.6009216-1.8304558,2.5126953-5.2781525,2.5126953c-3.4477005,0-5.2781563-0.9117737-5.2781563-2.5126953 C49.5163155,386.3551025,51.3467712,383.5910034,54.7944717,383.5910034z" })
		);
	}

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Rocketship;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Rocketship() {
		// 14
		var style = {
			st24: {
				fill: "#FC5959"
			},
			st0: {
				fill: "#FFFFFF"
			},
			st2: {
				fill: "#A5C6EF"
			},
			st137: {
				opacity: 0.4,
				fill: "#FFFFFF",
				enableBackground: "new"
			},
			st120: {
				fill: "#F2F2F2"
			},
			st87: {
				opacity: 0.4,
				fill: "#FFFFFF"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st24, d: "M43,347.4899902c-17.6399994,0-25.0799999,16.4100037-15.8199997,41 c0.2672596,0.7373047,1.0816154,1.1183472,1.8189163,0.8510742c0.3958416-0.1434631,0.7075977-0.4552307,0.8510838-0.8510742 c2-5.6300049,8.3000011-13.1199951,16.1399975-13.1199951" }),
			_react2.default.createElement("path", { style: style.st24, d: "M92.2799988,347.4899902c17.6399994,0,25.0800018,16.4100037,15.8199997,41 c-0.2672577,0.7373047-1.0816193,1.1183472-1.8189163,0.8510742c-0.3958435-0.1434937-0.7075958-0.4552307-0.8510818-0.8510742 c-2-5.6300049-8.3000031-13.1199951-16.1399994-13.1199951" }),
			_react2.default.createElement("path", { style: style.st0, d: "M86.3300018,386.3999939c22.75-58.7099915-14.8000031-88.4299927-18.6699982-89.7399902 C63.7999992,298,26.25,327.7000122,49,386.3999939l0,0C61.1180496,390.4237366,74.2119522,390.4237366,86.3300018,386.3999939 L86.3300018,386.3999939z" }),
			_react2.default.createElement("path", { style: style.st24, d: "M86.0599976,317.4899902c-7-13.2900085-16.5500031-20.2200012-18.4000015-20.8200073 c-1.8499985,0.6099854-11.4199982,7.5299988-18.4000015,20.8200073 C61.2341728,321.2783203,74.0858231,321.2783203,86.0599976,317.4899902z" }),
			_react2.default.createElement("circle", { style: style.st2, cx: "67.6699982", cy: "336.9400024", r: "9.8299942" }),
			_react2.default.createElement("path", { style: style.st137, d: "M63.6599998,336.9400024c-1.1763611-0.0032959-2.1273308-0.9595642-2.1240463-2.1359253 c0.0009575-0.3428955,0.0846786-0.680481,0.2440453-0.9840698c1.7286415-3.2529602,5.7670288-4.4886475,9.0199814-2.7600098 c1.1746368,0.6242065,2.1358109,1.5853882,2.7600174,2.7600098c0.5467606,1.0415649,0.1456375,2.3291931-0.8959427,2.875946 c-0.3035965,0.1593628-0.6411743,0.243103-0.9840546,0.2440491h-8H63.6599998z" }),
			_react2.default.createElement("path", { style: style.st120, d: "M45.3199997,375.3699951c1,3.5599976,2.2099991,7.2399902,3.6800003,11l0,0 c12.1180496,4.0237427,25.2119522,4.0237427,37.3300018,0l0,0c1.4700012-3.7999878,2.6900024-7.480011,3.6800003-11 c-7.3248901,2.070282-14.9085846,3.0805359-22.5199966,3C54.1699982,378.3699951,45.3199997,375.3699951,45.3199997,375.3699951z"
			}),
			_react2.default.createElement("path", { style: style.st24, d: "M72,359l-3,36c-0.0958176,0.8284302-0.8450623,1.4223328-1.6734924,1.3265076 C66.6299896,396.2459412,66.0805588,395.6965332,66,395l-3-36c-0.0973434-2.4944153,1.8458786-4.595459,4.3403091-4.6928101 C69.6804199,354.2158508,71.7027359,355.927063,72,358.25C72.0192795,358.4996338,72.0192795,358.7503662,72,359z" }),
			_react2.default.createElement("path", { style: style.st24, d: "M43.0493889,347.4873962c-17.64258,0-25.0793438,16.4143066-15.8189526,41.0304871 c0.4644699,1.2346802,2.2206478,1.1945496,2.6657066-0.0472412c2.0177746-5.6299744,8.3022366-13.1209717,16.1350689-13.1209717" }),
			_react2.default.createElement("path", { style: style.st24, d: "M92.2839355,347.4873962c17.6425781,0,25.0793457,16.4143066,15.8189545,41.0304871 c-0.4644699,1.2346802-2.2206497,1.1945496-2.6657104-0.0472412c-2.0177689-5.6299744-8.3022385-13.1209717-16.1350708-13.1209717"
			}),
			_react2.default.createElement("path", { style: style.st0, d: "M86.3332748,386.4048157c22.75-58.7080078-14.7984161-88.4311218-18.6666641-89.7380981 c-3.8681641,1.3069763-41.4165802,31.0300903-18.6665802,89.7380981h0.0000191 c12.1385765,4.0245056,25.1946297,4.0245056,37.3332024,0H86.3332748z" }),
			_react2.default.createElement("path", { style: style.st24, d: "M86.0639648,317.4892578c-6.9785156-13.2922363-16.5456543-20.2160645-18.3974609-20.8225098 c-1.8515625,0.6064453-11.4187012,7.5305176-18.3972168,20.8225098 C61.2424316,321.2768555,74.0908203,321.2768555,86.0639648,317.4892578z" }),
			_react2.default.createElement("circle", { style: style.st2, cx: "67.6666641", cy: "336.9379578", r: "9.8333378" }),
			_react2.default.createElement("path", { style: style.st87, d: "M63.6602135,336.9379578c-1.6021118,0-2.6362877-1.709198-1.8844757-3.1239624 c1.1199722-2.1075745,3.3378487-3.5426941,5.8909264-3.5426941c2.5530701,0,4.7709503,1.4351196,5.8909225,3.5426941 c0.7518082,1.4147644-0.2823639,3.1239624-1.8844757,3.1239624H63.6602135z" }),
			_react2.default.createElement("path", { style: style.st120, d: "M45.3151207,375.3701172c0.9927177,3.5569153,2.2125282,7.2351074,3.6849098,11.0346985h0.0000191 c12.1385765,4.0245056,25.1946297,4.0245056,37.3332024,0h0.0000229c1.47229-3.7993774,2.6920471-7.4773254,3.6847305-11.0340576 c0,0-9.1953278,2.9996643-22.5233307,2.9996643S45.3151207,375.3701172,45.3151207,375.3701172z" }),
			_react2.default.createElement("path", { style: style.st24, d: "M72,359l-3,36c-0.0690918,0.8284302-0.7966309,1.4440308-1.625,1.375 c-0.7436523-0.0619507-1.3156738-0.6550903-1.375-1.375l-3-36c-0.2070312-2.4852905,1.6396484-4.6679077,4.125-4.875 s4.6679688,1.6397095,4.875,4.125C72.0205078,358.4950562,72.0180664,358.7623901,72,359z" })
		);
	}

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = RubberDuck;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RubberDuck() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { fill: "#FFEAAE", d: "M115.00616,359.79486c0,15.13559-11.99403,25.25409-27.40541,27.4054 c-50.94308,7.11133-57.04457-26.47464-57.46495-47.85425c-0.11552-5.87512,5.35025-10.36383,11.05526-8.95547 c16.26221,4.01459,34.11201,1.9989,46.40968,1.9989C102.73634,332.38943,115.00616,344.65927,115.00616,359.79486z" }),
			_react2.default.createElement("circle", { fill: "#FFEAAE", cx: "84.66972", cy: "329.22141", r: "23.23638" }),
			_react2.default.createElement("path", { fill: "#FFE094", d: "M74.18383,354.63217c0,5.46689-4.40257,8.72278-9.89864,9.89865 c-13.43827,2.87512-20.60411-9.56247-20.75595-17.28464c-0.04173-2.12204,2.13426-2.93829,3.99308-3.23465 C47.52232,344.01154,74.18383,341.28516,74.18383,354.63217z" }),
			_react2.default.createElement("path", { fill: "#FF8431", d: "M101.94353,334.76239c-6.76274,1.17841-11.70834,3.1116-15.45768,2.52982 c-0.16694,0.69669-0.00581,1.46689,0.5565,2.0354c2.2618,2.28601,6.45184,5.19696,11.78114,4.37485 c3.48058-0.53696,8.28038-4.86716,8.60065-8.18665C107.42414,335.51581,108.70628,333.58401,101.94353,334.76239z" }),
			_react2.default.createElement("path", { fill: "#FF9D5A", d: "M107.26012,334.01218l-6.56575-2.80801c-1.18841-0.50824-2.53876-0.4758-3.70122,0.08868l-9.34268,4.53577 c-0.49675,0.24112-0.85049,0.6369-1.04945,1.09244c-0.05218,0.11948-0.10122,0.27518-0.11517,0.37115 c3.91158,1.43954,19.19784,1.90671,23.42075-0.81982C111.0969,335.70383,109.62919,334.88672,107.26012,334.01218z" }),
			_react2.default.createElement("path", { fill: "#515151", d: "M87.87776,325.92957c-1.25005,0-2.26762,1.15381-2.26762,2.57202 c0,1.41873,1.01756,2.57254,2.26762,2.57254c1.25113,0,2.26869-1.15381,2.26869-2.57254 C90.14645,327.08337,89.12889,325.92957,87.87776,325.92957z" }),
			_react2.default.createElement("path", { fill: "#515151", d: "M103.65696,324.63031c-1.25114,0-2.26869,1.15381-2.26869,2.57254 c0,1.41821,1.01756,2.57202,2.26869,2.57202c1.25005,0,2.26761-1.15381,2.26761-2.57202 C105.92457,325.78412,104.90701,324.63031,103.65696,324.63031z" })
		);
	}

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = SoccerBall;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SoccerBall() {
		// 5
		var style = {
			st0: {
				fill: "#FFFFFF"
			},
			st46: {
				fill: "#444444"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st0, d: "M247,368.0300293c0,5.2299805-0.9599609,10.2399902-2.6999512,14.8599854 c-2.7900391,7.3599854-7.5800781,13.7399902-13.7099609,18.4599609c-7.0900879,5.4700928-15.9699707,8.710083-25.6201172,8.710083 c-23.2099609,0-42.0300293-18.8200684-42.0300293-42.0300293c0-4.8800049,0.8300781-9.5700684,2.3701172-13.9300537 c2.6699219-7.6300049,7.4899902-14.25,13.7299805-19.1600342C186.1899414,329.3400879,195.1799316,326,204.9699707,326 C228.1799316,326,247,344.8200684,247,368.0300293z" }),
			_react2.default.createElement("path", { style: style.st46, d: "M187.6098633,345.4000244l-4.2897949,10.4300537 c-0.5800781,1.4099121-1.9899902,2.2799072-3.5100098,2.1699219l-11.2700195-0.8499756 c-1.5100098-0.1199951-2.7800293-1.2000732-3.1401367-2.6700439l-0.0898438-0.3800049 c2.6699219-7.6300049,7.4899902-14.25,13.7299805-19.1600342l7.6000977,6.4500732 C187.8000488,342.3699951,188.1899414,343.9899902,187.6098633,345.4000244z" }),
			_react2.default.createElement("path", { style: style.st46, d: "M211.1881714,359.0812073l-1.4020996-11.1932678 c-0.1891174-1.5097351,0.6160126-2.9693909,1.9938812-3.6148071l10.2270355-4.7904663 c1.3758545-0.6444702,3.0101318-0.3305664,4.0493469,0.7777405l7.7227783,8.2363281 c1.0408478,1.1100769,1.2478638,2.7643433,0.5126495,4.0966797l-5.4518738,9.8796387 c-0.7345276,1.3311157-2.2425079,2.0379944-3.7355042,1.7510681l-11.0958405-2.1322632 C212.5156403,361.8049622,211.377121,360.5896301,211.1881714,359.0812073z" }),
			_react2.default.createElement("path", { style: style.st46, d: "M244.3000488,382.8900146c-2.7900391,7.3599854-7.5800781,13.7399902-13.7099609,18.4599609 l-4.6999512-7.1600342c-0.8300781-1.2700195-0.75-2.9399414,0.1999512-4.119873l7.079834-8.8000488 c0.9501953-1.1899414,2.5500488-1.6300049,3.9799805-1.0900879L244.3000488,382.8900146z" }),
			_react2.default.createElement("path", { style: style.st46, d: "M204.7424927,390.5474243l-9.8085327,5.572052 c-1.3229675,0.7515564-2.9795074,0.5651245-4.102356-0.4616394l-8.3342285-7.6211243 c-1.1212158-1.0252686-1.4555054-2.6554871-0.8282776-4.0392761l4.6611481-10.2835999 c0.6282043-1.3859863,2.0779266-2.2093201,3.5900421-2.0388794l11.213089,1.2638855 c1.5107422,0.1702881,2.7401276,1.2938232,3.0453644,2.7831726l2.2685394,11.0687866 C206.7525024,388.2800598,206.0643158,389.7965393,204.7424927,390.5474243z" })
		);
	}

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Steak;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Steak() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { fill: "#FCDAC9", d: "M111.36121,412.26398c-21.60423-6.65387-33.21066,8.11615-53.48628,4.79791 c-14.46355-2.36707-19.65802-11.46265-20.05922-21.48553c-0.11988-2.995,0.12861-17.94119,1.00339-20.94699 c1.3478-4.63113,95.14935,0.39929,96.655,9.6474c0.60736,3.73053,0.73875,10.84598,0.73842,17.31342 c-0.0002,3.57187-0.89211,6.43344-3.02869,8.27155C126.84409,415.31583,116.60106,413.87778,111.36121,412.26398z" }),
			_react2.default.createElement("path", { fill: "#F96E6E", d: "M64.70508,400.58896c-1.90918,0-3.7627-0.15137-5.66797-0.46387 c-12.00488-1.96387-16.66895-8.47119-18.4668-13.58447c-2.92383-8.3125-0.26367-19.04102,6.61914-26.69727 c8.43652-9.38623,20.69531-14.76953,33.63281-14.76953c8.49609,0,16.83008,2.31543,24.10254,6.69531 c20.86719,12.56982,29.04102,25.79883,29.73145,33.9873c0.28027,3.31982-0.60156,5.96045-2.55078,7.63672 c-3.35645,2.88818-8.21875,3.49463-11.70703,3.49463c-3.17676,0-6.73535-0.5127-9.51953-1.37012 c-3.7793-1.16357-7.42969-1.72949-11.15918-1.72949c-6.47559,0-12.18945,1.74414-17.71582,3.43164 c-5.42285,1.65625-11.03125,3.36816-17.2959,3.36914C64.70703,400.58896,64.70605,400.58896,64.70508,400.58896z" }),
			_react2.default.createElement("path", { fill: "#FCF1ED", d: "M80.82568,344.07388v2.43857v2.56143h0.00049c7.76636,0,15.3855,2.11679,22.03394,6.12158 c19.59937,11.80606,27.23096,24.02319,27.81079,30.89801c0.11694,1.38586,0.00806,3.25128-1.17334,4.26779 c-2.34741,2.01941-6.1355,2.44327-8.89966,2.44327c-3.89819,0-7.40967-0.81485-8.73853-1.16519 c-3.37109-0.88885-6.71606-1.32104-10.22559-1.32129c-0.00122,0-0.00171,0-0.00293,0c-6.80835,0-12.96777,1.65918-18.92334,3.26364 c-5.82935,1.5704-11.33545,3.05371-17.36646,3.05371c-1.92749,0-3.77832-0.14954-5.65771-0.45712 c-7.97119-1.30457-13.27539-5.0961-15.3396-10.96472c-2.45264-6.97403-0.11377-16.09479,5.81982-22.69586 c7.6792-8.54294,18.85425-13.44302,30.65942-13.44382L80.82568,344.07388 M80.82275,344.07385 c-12.82715,0.00089-25.44971,5.16925-34.37769,15.10129c-12.36377,13.75436-12.16821,37.91168,12.43066,41.93747 c2.2312,0.36517,4.38013,0.5228,6.46533,0.5228c13.19922,0,23.82056-6.31821,36.29224-6.31735 c2.86743,0.00018,5.83496,0.33435,8.95142,1.15607c2.41846,0.63766,6.12671,1.33041,10.01318,1.33041 c4.34985,0,8.92334-0.86804,12.1604-3.65283c7.46289-6.42044,1.60059-25.81946-27.31836-43.23923 C97.80664,346.31436,89.27124,344.07327,80.82275,344.07385L80.82275,344.07385z" }),
			_react2.default.createElement("path", { fill: "#FCF1ED", d: "M91.88825,371.09552c-1.80331-1.04956-3.52293-1.94815-5.33472-2.82779 c-1.82592-0.88248-3.71305-1.64325-5.59232-2.45798c-2.54025-1.10132,2.65073-2.78131,5.1755-3.86929l0.12392-0.05319 c0.75134-0.32938,1.31895-1.05048,1.38834-1.97174c0.08915-1.18347-0.81598-2.19513-1.97217-2.46301 c-3.15079-0.72995-6.47181-0.62982-9.67706,0.07523c-3.27209,0.73239-6.44224,2.11026-9.24186,4.0506 c-1.41521,0.94791-2.71927,2.06494-3.90768,3.28702c-0.60479,0.60126-1.14661,1.26306-1.68639,1.91971 c-0.54087,0.69818-1.11825,1.48865-1.55053,2.28809c-0.91195,1.5994-1.55176,3.31088-1.89623,5.0813 c-0.33253,1.76715-0.40148,3.61249,0.03461,5.40842c0.1879,0.7612,0.76173,1.43842,1.62519,1.68741 c1.05913,0.30545,2.18368-0.25449,2.72134-1.21677l0.09021-0.16147c1.27881-2.28998,2.73475-4.26614,4.33658-5.90408 c0.41274-0.4137,0.78083-0.76385,1.24026-1.15231c0.00439-0.00394,0.00877-0.0079,0.01315-0.01184 c0.85564-0.76953,1.9997-1.13086,3.14875-1.06793c0.8153,0.04468,1.63589,0.10971,2.46245,0.2095 c1.81262,0.20767,3.64329,0.48346,5.46976,0.85886c1.82755,0.36649,3.65727,0.79889,5.47396,1.30054 c1.80013,0.49704,3.65687,1.08148,5.34055,1.68896l0.10614,0.03882c1.28634,0.46518,2.78196-0.14713,3.31393-1.52859 C93.55461,373.10767,92.99619,371.74039,91.88825,371.09552z" })
		);
	}

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Strawberry;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Strawberry() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { fill: "#75C69F", d: "M49.8368645,348.226532c-3.0364723-0.4523621-7.7070885,1.6367493-7.7070885,1.6367493 s2.1502686,4.6427612,4.7372246,6.2957764c-2.8258514,1.3049622-5.0172462,7.0444641-5.0172462,7.0444641 s5.7906227,2.1256409,8.6245728,0.8356323c2.83395-1.289978,5.0338287-7.0527954,5.0338287-7.0527954l1.3885345-3.7088013 c0,0,2.1256256-5.7906189,0.8356514-8.6246033c-1.2899857-2.8339539-7.0528259-5.033783-7.0528259-5.033783 S48.5627937,345.3866577,49.8368645,348.226532z" }),
			_react2.default.createElement("path", { fill: "#FC5959", d: "M55.5711441,354.3948975c-0.9426765-14.5606995,9.5989838-16.5250244,16.4352341-13.9655762 c8.3516769,3.12677,17.6198578,19.7576599,15.3351593,25.8601074c-2.2846909,6.102417-20.1960602,12.5575562-28.5477333,9.4307556 C51.9575539,373.1607666,45.2978249,364.7564087,55.5711441,354.3948975z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M77.1074219,370.7612305c0.0429688,0.2529297,0.1855469,0.4663086,0.4130859,0.6171875 c0.3046875,0.2021484,0.7177734,0.2612305,1.1328125,0.1630859c0.7568359-0.1796875,1.2880859-0.8266602,1.1835938-1.4423828 c-0.0429688-0.2529297-0.1865234-0.4663086-0.4150391-0.6171875c-0.2080078-0.1376953-0.4658203-0.2089844-0.7412109-0.2089844 c-0.1279297,0-0.2587891,0.0151367-0.3896484,0.0463867h-0.0009766 C77.5332031,369.4985352,77.0029297,370.1455078,77.1074219,370.7612305z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M73.9921875,364.9165039c-0.0839844,0.2421875-0.0615234,0.4975586,0.0654297,0.7392578 c0.1699219,0.3237305,0.5029297,0.5742188,0.9140625,0.6875c0.7490234,0.2075195,1.5283203-0.1044922,1.7314453-0.6953125 c0.0839844-0.2426758,0.0605469-0.4985352-0.0664062-0.7407227c-0.1699219-0.3227539-0.5029297-0.5727539-0.9130859-0.6860352 c-0.1572266-0.043457-0.3164062-0.0639648-0.4697266-0.0639648 C74.671875,364.1572266,74.1533203,364.449707,73.9921875,364.9165039z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M82.6210938,364.7885742c0.1132812-0.2304688,0.1210938-0.4873047,0.0244141-0.7426758 c-0.1289062-0.3413086-0.4287109-0.6303711-0.8232422-0.7924805c-0.2197266-0.0908203-0.4472656-0.1337891-0.6650391-0.1337891 c-0.4980469,0-0.9462891,0.2231445-1.1376953,0.6132812c-0.1132812,0.2299805-0.1210938,0.4868164-0.0244141,0.7426758 c0.1289062,0.3413086,0.4296875,0.6303711,0.8232422,0.7924805 C81.5361328,365.5654297,82.3457031,365.3500977,82.6210938,364.7885742z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M68.1064453,369.2089844c0.0078125,0.2958984,0.1591797,0.5727539,0.4277344,0.7792969 c0.5683594,0.4384766,1.4707031,0.4213867,2.0126953-0.0390625c0.2509766-0.2133789,0.3857422-0.4912109,0.3789062-0.7822266 c-0.0068359-0.2958984-0.1591797-0.5732422-0.4277344-0.7807617c-0.2753906-0.2124023-0.6289062-0.3173828-0.9814453-0.3173828 c-0.3759766,0-0.7519531,0.1196289-1.03125,0.3569336C68.234375,368.6396484,68.0996094,368.9179688,68.1064453,369.2089844z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M60.8867188,368.0087891c-0.1201172,0-0.2402344,0.0146484-0.3564453,0.0449219 c-0.3193359,0.0830078-0.5615234,0.2749023-0.6816406,0.5405273c-0.1220703,0.2695312-0.1054688,0.5844727,0.0458984,0.8876953 c0.3212891,0.6420898,1.1396484,1.0195312,1.8300781,0.8393555c0.3193359-0.0830078,0.5615234-0.2749023,0.6816406-0.5400391 c0.1220703-0.2695312,0.1054688-0.5849609-0.0458984-0.8881836 C62.0927734,368.3588867,61.4804688,368.0087891,60.8867188,368.0087891z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M65.0878906,361.9282227c-0.0712891,0.2871094,0.0029297,0.5942383,0.2070312,0.8652344 c0.4345703,0.5737305,1.3125,0.7944336,1.9521484,0.4926758c0.2988281-0.1396484,0.5019531-0.3725586,0.5722656-0.6552734 c0.0712891-0.2871094-0.0029297-0.5942383-0.2070312-0.8647461c-0.3017578-0.3989258-0.8183594-0.6274414-1.3222656-0.6274414 c-0.21875,0-0.4345703,0.0429688-0.6298828,0.1342773C65.3613281,361.4130859,65.1582031,361.6459961,65.0878906,361.9282227z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M56.4326172,363.5107422c0.3388672,0.0258789,0.6210938-0.0751953,0.8212891-0.2851562 c0.2041016-0.2143555,0.2929688-0.5175781,0.25-0.8540039c-0.0917969-0.7124023-0.7431641-1.3383789-1.4511719-1.3959961 c-0.0341797-0.0024414-0.0683594-0.0039062-0.1015625-0.0039062c-0.2871094,0-0.5410156,0.1010742-0.7207031,0.2900391 c-0.2041016,0.2143555-0.2929688,0.5175781-0.2490234,0.8535156 C55.0732422,362.8276367,55.7246094,363.4536133,56.4326172,363.5107422z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M68.1015625,344.5019531c-0.0615234,0.284668,0.0195312,0.5830078,0.2265625,0.8398438 c0.4423828,0.5532227,1.3261719,0.7387695,1.96875,0.4155273c0.3027344-0.1533203,0.5039062-0.3974609,0.5664062-0.6865234 c0.0615234-0.284668-0.0195312-0.5830078-0.2265625-0.8398438c-0.296875-0.3691406-0.7880859-0.574707-1.2734375-0.574707 c-0.2421875,0-0.4824219,0.0512695-0.6962891,0.159668C68.3642578,343.9692383,68.1640625,344.2128906,68.1015625,344.5019531z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M66.5146484,351.894043c-0.0605469,0.284668,0.0195312,0.5830078,0.2265625,0.8398438 c0.4443359,0.5527344,1.3271484,0.7387695,1.9697266,0.4150391c0.3027344-0.1533203,0.5039062-0.3974609,0.5664062-0.6865234 c0.0605469-0.284668-0.0195312-0.5830078-0.2265625-0.8398438c-0.296875-0.3686523-0.7880859-0.574707-1.2734375-0.574707 c-0.2421875,0-0.4824219,0.0517578-0.6962891,0.159668C66.7783203,351.3608398,66.5771484,351.6049805,66.5146484,351.894043z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M75.1142578,350.2363281c-0.015625-0.0004883-0.0302734-0.0009766-0.0449219-0.0009766 c-0.3203125,0-0.5966797,0.1166992-0.78125,0.3305664c-0.1904297,0.2197266-0.2636719,0.5200195-0.2060547,0.8447266 c0.125,0.6992188,0.8095703,1.2875977,1.5273438,1.3115234c0.3476562,0.0175781,0.6337891-0.105957,0.8271484-0.3295898 c0.1904297-0.2202148,0.2626953-0.5205078,0.2050781-0.8452148 C76.5175781,350.8476562,75.8320312,350.2597656,75.1142578,350.2363281z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M80.765625,359.25c0.3427734,0.0180664,0.6328125-0.105957,0.8271484-0.3295898 c0.1904297-0.2202148,0.2626953-0.5200195,0.2050781-0.8447266c-0.1240234-0.6992188-0.8085938-1.2875977-1.5273438-1.3115234 c-0.3349609-0.019043-0.6328125,0.105957-0.8261719,0.3300781c-0.1904297,0.2202148-0.2636719,0.5200195-0.2060547,0.8447266 C79.3632812,358.6381836,80.0478516,359.2265625,80.765625,359.25z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M73.3300781,357.7807617c-0.0986328,0-0.1972656,0.0097656-0.2949219,0.0302734 c-0.3320312,0.0693359-0.5888672,0.2529297-0.7236328,0.5161133c-0.1328125,0.2592773-0.1328125,0.5678711,0.0009766,0.8696289 c0.2871094,0.6503906,1.09375,1.0615234,1.7958984,0.9106445c0.3310547-0.0693359,0.5888672-0.2529297,0.7236328-0.5166016 c0.1328125-0.2592773,0.1328125-0.5678711-0.0009766-0.8691406 C74.5830078,358.1616211,73.9501953,357.7807617,73.3300781,357.7807617z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M60.2392578,355.0239258c-0.1103516,0.269043-0.0849609,0.5766602,0.0732422,0.8657227 c0.3417969,0.6240234,1.1787109,0.9638672,1.8642578,0.7587891c0.3261719-0.097168,0.5673828-0.3012695,0.6796875-0.5751953 c0.1103516-0.269043,0.0849609-0.5766602-0.0732422-0.8662109c-0.2734375-0.5004883-0.8652344-0.8183594-1.4443359-0.8183594 c-0.1425781,0-0.2841797,0.019043-0.4199219,0.0595703C60.5927734,354.5454102,60.3515625,354.75,60.2392578,355.0239258z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M60.3505859,348.6445312c0.6220703,0.3447266,1.5117188,0.1806641,1.9804688-0.3613281 c0.2216797-0.2568359,0.3154297-0.5585938,0.2636719-0.8500977c-0.0517578-0.2866211-0.2382812-0.5322266-0.5273438-0.6914062 c-0.2207031-0.1220703-0.4746094-0.1801758-0.7324219-0.1801758c-0.4667969,0-0.9443359,0.1914062-1.2470703,0.5415039 c-0.2226562,0.2563477-0.3164062,0.5581055-0.2646484,0.8496094 C59.8740234,348.2392578,60.0615234,348.4848633,60.3505859,348.6445312z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M85.8681641,356.6636353c-0.2456055-0.0552368-0.480957-0.02771-0.6855469,0.0946655 c-0.5341797,0.3237305-0.6757812,1.1484375-0.3173828,1.8388672c0.1972656,0.3779297,0.5126953,0.6513672,0.8642578,0.7495117 c0.265625,0.0742188,0.5185547,0.0415039,0.7373047-0.0908203c0.1118164-0.0678101,0.1958008-0.1678467,0.2724609-0.2736206 C86.4916992,358.2259521,86.1987305,357.4500732,85.8681641,356.6636353z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M86.8603516,362.2133789c-0.0527344,0-0.1054688,0.0043945-0.1582031,0.0136719 c-0.2861328,0.0512695-0.5322266,0.2382812-0.6914062,0.5273438c-0.34375,0.6220703-0.1816406,1.5102539,0.3613281,1.9799805 v0.0004883c0.2558594,0.222168,0.5546875,0.3168945,0.8496094,0.2641602 c0.1630859-0.0290527,0.3061523-0.1116333,0.434082-0.2219238c0.0595703-0.6835938,0.0327148-1.437439-0.0742188-2.2477417 c-0.0117188-0.0109253-0.0175781-0.0270996-0.0297852-0.0376587 C87.3417969,362.309082,87.1005859,362.2133789,86.8603516,362.2133789z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M85.40625,368.1015625c-0.2148438-0.2045898-0.5195312-0.2910156-0.8554688-0.2495117 c-0.7109375,0.0922852-1.3369141,0.7431641-1.3945312,1.4511719c-0.0273438,0.3286133,0.0742188,0.6206055,0.2851562,0.8212891 c0.0908203,0.086853,0.2045898,0.1409302,0.3227539,0.1846313c0.7231445-0.5213013,1.3608398-1.0576782,1.9013672-1.6020508 C85.6411133,368.4712524,85.5668945,368.255127,85.40625,368.1015625z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M74.1064453,374.0932617c-0.0654297-0.2885742-0.2695312-0.5297852-0.5732422-0.6791992 c-0.2089844-0.1025391-0.4423828-0.1513672-0.6777344-0.1513672c-0.4921875,0-0.9912109,0.2124023-1.2871094,0.590332 c-0.2041016,0.2597656-0.28125,0.559082-0.2167969,0.8427734c0.0664062,0.2885742,0.2695312,0.5297852,0.5742188,0.6791992 c0.0585938,0.0286865,0.1259766,0.0316772,0.1879883,0.052002c0.5966797-0.1520996,1.190918-0.3199463,1.7807617-0.4983521 C74.0942383,374.6704712,74.1704102,374.3743896,74.1064453,374.0932617z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M64.0654297,374.8364258c-0.2753906-0.2124023-0.6298828-0.3178711-0.9824219-0.3178711 c-0.3769531,0-0.7519531,0.1196289-1.03125,0.3569336c-0.2509766,0.2138672-0.3857422,0.4921875-0.3789062,0.7832031 c0.0078125,0.2954712,0.1591797,0.5724487,0.4267578,0.7788086c0.5756836,0.0567017,1.171875,0.0856934,1.784668,0.0911865 c0.0766602-0.043396,0.1621094-0.0727539,0.2290039-0.1297607c0.2519531-0.2138672,0.3857422-0.4916992,0.3789062-0.7822266 C64.4853516,375.3203125,64.3339844,375.043457,64.0654297,374.8364258z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M53.890625,372.6965942c0.3237305,0.020813,0.6074219-0.0772705,0.8037109-0.2839966 c0.2041016-0.2143555,0.2929688-0.5175781,0.2490234-0.8535156c-0.0917969-0.7124023-0.7431641-1.3383789-1.4511719-1.3955078 c-0.0351562-0.0029297-0.0693359-0.0039062-0.1025391-0.0039062c-0.2871094,0-0.5400391,0.1010742-0.7197266,0.2895508 c-0.1591797,0.1670532-0.2246094,0.3967285-0.2353516,0.6453857 C52.8725586,371.6688843,53.3618164,372.2037354,53.890625,372.6965942z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M64.8740234,340.5541992c-0.0332031-0.2895508-0.2050781-0.5463867-0.4833984-0.7231445 c-0.0644531-0.0410156-0.1391602-0.0617065-0.2094727-0.0914307c-0.6679688,0.137085-1.3237305,0.3305054-1.9570312,0.5870361 c-0.1044922,0.1835327-0.1708984,0.376709-0.1479492,0.5756836c0.0332031,0.2890625,0.2050781,0.5458984,0.484375,0.7226562 c0.5947266,0.3798828,1.4931641,0.2729492,1.9990234-0.2387695 C64.7958984,341.144043,64.9082031,340.8481445,64.8740234,340.5541992z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M76.2275391,343.036377c-0.2084961,0.0465088-0.3974609,0.1292114-0.5302734,0.2819824 c-0.1904297,0.2202148-0.2626953,0.5205078-0.2050781,0.8452148c0.1240234,0.699707,0.8095703,1.2875977,1.5273438,1.3110352 c0.3476562,0.0048828,0.6328125-0.105957,0.8261719-0.3295898c0.1025391-0.1185913,0.1645508-0.2629395,0.1967773-0.4196777 C77.4472656,344.1165771,76.8408203,343.5516357,76.2275391,343.036377z" }),
			_react2.default.createElement("path", { fill: "#5E5E5E", d: "M82.2099609,349.9189453c-0.1835938,0.0006714-0.3588867,0.0332031-0.5078125,0.1289062 c-0.2451172,0.1572266-0.4003906,0.4243164-0.4375,0.7524414c-0.078125,0.7050781,0.4111328,1.4638672,1.0917969,1.690918 c0.3203125,0.1069336,0.6367188,0.0786133,0.8867188-0.0810547c0.1333008-0.0855713,0.2333984-0.208313,0.309082-0.3511353 C83.128418,351.335022,82.6791992,350.6201172,82.2099609,349.9189453z" })
		);
	}

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Sushi;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Sushi() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("polygon", { fill: "#FAD59E", points: "83.6585541,363.9838867 0,397.5761108 77.2566986,417.9328918 156.5118713,384.3406372 \t" }),
			_react2.default.createElement("path", { fill: "#57756C", d: "M99.537468,354.3636169c0.9025497,4.3707886-0.3415604,12.5780334,0.0460739,15.9753113 c0.7186737,6.2986145-5.7504807,6.0394592-14.5449829,6.0394592s-13.8067856-2.776886-14.5449905-6.0394592 c-0.7544785-3.3350525-0.8564758-11.6045227,0.0460739-15.9753113H99.537468z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M98.1838531,354.6044922c-0.3807983-2.1391907-5.1174088-4.4126892-13.1453171-4.4126892 c-8.5881042,0-12.8542252,2.5644226-13.1404953,4.3853455c-0.0639114,0.4050293,0.1095734,0.8511047,0.5156097,1.3258057 c1.4898911,1.7424011,6.0761185,3.6177368,12.6248856,3.6177368c6.6083755,0,11.1999741-1.8879395,12.6694565-3.6420288 C98.0925522,355.4197083,98.2526016,354.9910583,98.1838531,354.6044922z" }),
			_react2.default.createElement("path", { fill: "#57756C", d: "M85.03862,350.191803c8.027916,0,12.7645264,2.2734985,13.1453247,4.4126892 c0.0687485,0.3865662-0.091301,0.8152161-0.4758606,1.2741699c-1.4694824,1.7540894-6.0610809,3.6420288-12.6694641,3.6420288 c-6.5487595,0-11.1349869-1.8753357-12.6248779-3.6177368c-0.406044-0.4747009-0.5795212-0.9207764-0.5156097-1.3258057 C72.1844025,352.7562256,76.4505234,350.191803,85.03862,350.191803 M85.03862,348.8168335 c-8.7943344,0-14.0395737,2.6261902-14.4987869,5.5467529c-0.5182953,3.2950745,5.7044525,6.5320435,14.4987869,6.5320435 s15.0831528-3.2481079,14.4987946-6.5320435C99.0030136,351.3599243,93.832962,348.8168335,85.03862,348.8168335 L85.03862,348.8168335z" }),
			_react2.default.createElement("path", { fill: "#F96E6E", d: "M90.3240662,355.8276672l-3.1946487,1.3264771c-1.3318787,0.553009-2.8498459,0.553009-4.1817245,0 l-3.1946487-1.3264771c-0.9000168-0.3736877-0.9000168-1.574646,0-1.9483337l3.3615799-1.3957825 c1.2255478-0.5088806,2.6223145-0.5088806,3.8478622,0l3.3615799,1.3957825 C91.2240829,354.2530212,91.2240829,355.4539795,90.3240662,355.8276672z" }),
			_react2.default.createElement("path", { fill: "#57756C", d: "M75.9523239,364.5700378c0.9025497,4.3707886-0.341568,12.5780334,0.0460663,15.9753113 c0.7186813,6.2986145-5.750473,6.0394592-14.5449829,6.0394592s-13.8067856-2.776886-14.5449829-6.0394592 c-0.7544785-3.3350525-0.8564758-11.6045227,0.0460739-15.9753113H75.9523239z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M74.1229401,366.085022c0.3845596-0.4588623,0.5446167-0.8876038,0.4758682-1.2741089 c-0.3807983-2.1391602-5.1174164-4.4126587-13.1453247-4.4126587c-8.5886345,0-12.8547554,2.5643921-13.1410255,4.3853455 c-0.0639153,0.4049072,0.1101036,0.8510132,0.5161438,1.3258667c1.4898949,1.7423401,6.0761223,3.6175842,12.6248817,3.6175842 C68.0618591,369.7270508,72.6534576,367.8391724,74.1229401,366.085022z" }),
			_react2.default.createElement("path", { fill: "#57756C", d: "M61.4535751,360.3982544c8.0279083,0,12.7645264,2.2734985,13.1453247,4.4126587 c0.0687408,0.3865051-0.0913086,0.8152466-0.4758682,1.2741089c-1.4694824,1.7541504-6.0610809,3.6420288-12.6694565,3.6420288 c-6.5487633,0-11.1349907-1.8752441-12.6248817-3.6175842c-0.4060402-0.4748535-0.5800591-0.9209595-0.5161438-1.3258667 C48.5988197,362.9626465,52.8649368,360.3982544,61.4535751,360.3982544 M61.4535751,359.0232849 c-8.7948799,0-14.0401192,2.6260986-14.4993324,5.5467529c-0.5177574,3.2949829,5.7044525,6.5319824,14.4993324,6.5319824 c8.794342,0,15.0831451-3.2480774,14.4987946-6.5319824C75.4179611,361.5663452,70.2479172,359.0232849,61.4535751,359.0232849 L61.4535751,359.0232849z" }),
			_react2.default.createElement("path", { fill: "#F96E6E", d: "M66.7389221,366.0340881l-3.1946487,1.3264771c-1.3318825,0.553009-2.8498459,0.553009-4.1817284,0 l-3.1946449-1.3264771c-0.9000206-0.3736877-0.9000206-1.574646,0-1.9483337l3.3615799-1.3957825 c1.225544-0.5088806,2.6223145-0.5088806,3.8478584,0l3.3615837,1.3957825 C67.6389389,364.4594421,67.6389389,365.6604004,66.7389221,366.0340881z" }),
			_react2.default.createElement("path", { fill: "#57756C", d: "M52.3671722,374.7764893c0.9025497,4.3707886-0.3415604,12.5780334,0.0460739,15.9753418 c0.7186775,6.298584-5.7504768,6.0394287-14.5449829,6.0394287s-13.8067875-2.776886-14.5449867-6.0394287 c-0.7544785-3.335083-0.8564758-11.6045532,0.0460739-15.9753418H52.3671722z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M50.5378609,376.2915039c0.3845558-0.4588623,0.5446091-0.8875427,0.4758644-1.2741089 c-0.3807983-2.1392517-5.1174126-4.4127502-13.1453247-4.4127502c-8.5886345,0-12.8547554,2.5644836-13.1410255,4.385437 c-0.0639133,0.4048767,0.1101055,0.8510132,0.5161457,1.3258667c1.489893,1.7423096,6.0761204,3.6175842,12.6248798,3.6175842 C44.4767799,379.9335327,49.0683784,378.0456543,50.5378609,376.2915039z" }),
			_react2.default.createElement("path", { fill: "#57756C", d: "M37.8684921,370.6046448c8.0279121,0,12.7645226,2.2734985,13.1453209,4.4127502 c0.0687485,0.3865662-0.0913048,0.8152466-0.4758606,1.2741089c-1.4694862,1.7541504-6.0610809,3.6420288-12.6694603,3.6420288 c-6.5487614,0-11.1349869-1.8752747-12.6248798-3.6175842c-0.4060421-0.4748535-0.5800591-0.92099-0.5161457-1.3258667 C25.0137367,373.1691284,29.2798576,370.6046448,37.8684921,370.6046448 M37.8684921,369.2296753 c-8.794878,0-14.0401173,2.6261902-14.4993305,5.5468445c-0.5177574,3.2949829,5.7044525,6.5319519,14.4993305,6.5319519 c8.794342,0,15.083149-3.2480469,14.4987946-6.5319519C51.8328781,371.7728271,46.6628342,369.2296753,37.8684921,369.2296753 L37.8684921,369.2296753z" }),
			_react2.default.createElement("path", { fill: "#F96E6E", d: "M43.1537704,376.2405396l-3.1946449,1.3264771c-1.3318825,0.5530396-2.8498459,0.5530396-4.1817284,0 l-3.1946449-1.3264771c-0.9000187-0.3736877-0.9000187-1.574646,0-1.9483337l3.3615799-1.3957825 c1.225544-0.5088806,2.6223145-0.5088806,3.8478584,0l3.3615799,1.3957825 C44.053791,374.6658936,44.053791,375.8668518,43.1537704,376.2405396z" }),
			_react2.default.createElement("polygon", { fill: "#F9C37D", points: "77.2566757,417.9329834 0.0000622,397.5761414 0.0000622,406.4263306 77.2566757,426.7832031 156.5118408,393.1910706 156.5118408,384.3405762 \t" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M129.6807098,362.3928833c7.5402985,0.6686401,12.4571228,2.5776367,13.1865234,10.6481323 c0.7889099,8.7288513-3.329483,14.6738892-12.7398834,16.4631958c-6.6332855,1.261261-22.0635681-3.8387451-27.8768311-6.2549133 c-6.0626678-2.5198669-5.6606979-11.78479-4.6234436-14.945282c2.5103455-7.6489563,9.1834259-10.3302917,16.723732-9.6616821 L129.6807098,362.3928833z" }),
			_react2.default.createElement("path", { fill: "#FC5959", d: "M98.2819519,369.1638184c10.2965546,1.5280457,20.4771423,4.5916748,30.541748,9.1913757 c0.1966858,0.0899048,0.4143066,0.098877,0.6172943,0.0240173l13.3917542-4.939209 c0.4075317-0.1503296,0.6364746-0.548645,0.6782074-0.9682922c0.0477142-0.4797668,0.4616699-6.0953064,0.4616699-6.0953064 c-8.9449921-3.8732605-19.0467224-1.6263733-28.1742783-3.0818481c-3.6287155-0.5786133-7.1335068-2.7759705-10.6502914-1.4788818 l-7.2246933,0.1858826c0,0-0.4617996,5.5825806-0.466835,6.0346375 C97.4506912,368.5596924,97.7353973,369.0827026,98.2819519,369.1638184z" }),
			_react2.default.createElement("path", { fill: "#F96E6E", d: "M98.7408142,363.1003418c10.2965469,1.5280457,20.4771423,4.5916748,30.541748,9.1914062 c0.1966858,0.0898743,0.4143066,0.0988464,0.6172943,0.0239868l13.3917542-4.939209 c0.8734131-0.3221436,0.9265594-1.7835083,0.0744324-2.1524963c-8.9449921-3.8732605-17.9812775-6.5374451-27.1088333-7.9929199 c-3.6287155-0.5786438-7.3330231-0.1395264-10.8498077,1.1575317l-6.8084564,2.5111389 C97.6131134,361.2633972,97.7222748,362.9491882,98.7408142,363.1003418z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M106.8326416,371.7898865c7.5403137,0.6686096,12.4571304,2.5776062,13.1865311,10.6481018 c0.7889023,8.7288513-3.329483,14.6738892-12.7398834,16.4631958c-6.6332932,1.261261-22.0635681-3.8387451-27.8768387-6.2549133 c-6.0626678-2.5198669-5.6606979-11.78479-4.623436-14.945282c2.5103455-7.6489563,9.1834259-10.3302917,16.723732-9.6616821 L106.8326416,371.7898865z" }),
			_react2.default.createElement("path", { fill: "#D9E2FF", d: "M75.3487091,378.7486877c10.2965469,1.5280151,20.4771423,4.5916748,30.5417404,9.1913757 c0.196701,0.0899048,0.4143143,0.098877,0.6173019,0.0240173l13.3917542-4.9392395 c0.4075241-0.1502991,0.636467-0.5486145,0.6782074-0.9682617c0.0477142-0.4797668,0.4616623-6.0953064,0.4616623-6.0953064 c-8.9449844-3.8732605-19.0467148-1.6263733-28.1742783-3.0818481c-3.6287079-0.5786438-7.1334991-2.7759705-10.6502838-1.4788818 l-7.2247009,0.1858521c0,0-0.461792,5.5826111-0.4668274,6.034668 C74.5174484,378.1445618,74.8021545,378.667572,75.3487091,378.7486877z" }),
			_react2.default.createElement("path", { fill: "#EBEFFF", d: "M75.8075714,372.6852112c10.2965469,1.5280457,20.4771423,4.5916748,30.5417404,9.1913757 c0.196701,0.0899048,0.4143143,0.098877,0.6173019,0.0240173l13.3917542-4.939209 c0.8734131-0.3221436,0.9265518-1.7835388,0.0744247-2.1524963c-8.9449844-3.8732605-17.9812698-6.5374756-27.1088333-7.9929504 c-3.6287079-0.5786133-7.3330231-0.1394958-10.8498077,1.1575623l-6.8084488,2.5111389 C74.6798706,370.8482361,74.789032,372.5340576,75.8075714,372.6852112z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M83.8748932,381.0150146c7.5495605,0.5354004,12.4950562,2.3573914,13.3484116,10.4139099 c0.9229584,8.7137451-3.1034851,14.7306824-12.4851151,16.6858521c-6.612999,1.3781738-22.1195793-3.448761-27.9691925-5.7619934 c-6.1005745-2.4124756-5.8410683-11.6832581-4.8525276-14.8616333c2.3924408-7.6922607,9.0233955-10.4910278,16.5729561-9.9555969 L83.8748932,381.0150146z" }),
			_react2.default.createElement("path", { fill: "#F9A369", d: "M52.3972702,388.760376c10.3186684,1.3259277,20.5426559,4.1891174,30.671936,8.5901489 c0.1979599,0.0859985,0.4157181,0.0907288,0.6176834,0.0119019l13.3245163-5.1996155 c0.4054718-0.1582031,0.6289215-0.5608826,0.6648483-0.9812012c0.0410614-0.4804993,0.3772125-6.1021118,0.3772125-6.1021118 c-8.9994888-3.6967468-19.0709991-1.2528992-28.2195663-2.5291443c-3.6370621-0.5073853-7.1726341-2.6353149-10.6717606-1.2698669 l-7.2227783,0.32724c0,0-0.3844528,5.5896301-0.3832245,6.041626 C51.55756,388.17276,51.8495369,388.6900024,52.3972702,388.760376z" }),
			_react2.default.createElement("path", { fill: "#FCB47E", d: "M52.7721252,382.6901245c10.3186684,1.3259277,20.5426559,4.1891174,30.671936,8.5901489 c0.1979599,0.0859985,0.4157181,0.0907288,0.6176834,0.0119019l13.3245087-5.1996155 c0.8690338-0.3391113,0.9019165-1.8009949,0.0446014-2.1531677c-8.9994965-3.6967163-18.0735321-6.1830444-27.2220993-7.4593201 c-3.6370621-0.5073547-7.3356285,0.0041199-10.8347511,1.3695679l-6.7742653,2.6434937 C51.6188545,380.8759155,51.7513962,382.5589905,52.7721252,382.6901245z" }),
			_react2.default.createElement("path", { fill: "#D7EDAF", d: "M54.7408676,401.4301453c0,2.2819214-5.1188927,4.1317444-11.4333687,4.1317444 s-11.4333706-1.849823-11.4333706-4.1317444c0-2.2818909,0.5071468-9.5160522,11.4333706-9.5160522 S54.7408676,399.1482544,54.7408676,401.4301453z" })
		);
	}

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Synth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Synth() {
		// 18
		var style = {
			st29: {
				fill: "#5994C9"
			},
			st143: {
				fill: "#4A88BA"
			},
			st120: {
				fill: "#F2F2F2"
			},
			st0: {
				fill: "#FFFFFF"
			},
			st19: {
				fill: "#75C69F"
			},
			st1: {
				fill: "#A2D8C0"
			},
			st145: {
				fill: "#494949"
			},
			st24: {
				fill: "#FC5959"
			},
			st10: {
				fill: "#FC7E7E"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st29, d: "M200.3323517,379.683136v40.2079773v0.0103149H20.3206825v-0.0103149V379.683136 c0-2.9573975,2.3974209-5.3547974,5.3547897-5.3547974h13.9203415c1.3096237,0,2.3657799,1.0667114,2.3657799,2.3657837v0.1268616 h136.7264862c0.0350342,0,0.0634308-0.0284119,0.0634308-0.063446l0,0c0-1.3360596,1.0931396-2.4291992,2.4292145-2.4291992 h13.8074036C197.934845,374.3283386,200.3323517,376.7258301,200.3323517,379.683136z" }),
			_react2.default.createElement("path", { style: style.st143, d: "M185.0765991,410.6286011h-1.8436432H37.4200668h-7.5650883h-9.534296v13.4871521c0,0,0,0,0,0.0103149 c0,1.3098755,0.5280781,2.5137939,1.3941994,3.3693237c0.8661213,0.8661194,2.0594559,1.404541,3.379652,1.404541h170.4639587 c2.6403961,0,4.7738647-2.1437988,4.7738647-4.7738647c0-0.0103149,0-0.0103149,0-0.0103149v-13.4871521H185.0765991z" }),
			_react2.default.createElement("path", { style: style.st120, d: "M175.0097809,419.3462524H45.6399002c-2.0314713,0-3.6783066-1.6468201-3.6783066-3.6782837v-7.9827881 h136.7264862v7.9827881C178.6880798,417.6994324,177.0412445,419.3462524,175.0097809,419.3462524z" }),
			_react2.default.createElement("path", { style: style.st0, d: "M178.6879883,400.0236816V376.694397c0-1.3050537-1.0578613-2.3629761-2.362793-2.3629761H44.3244629 c-1.3049316,0-2.362793,1.0579224-2.362793,2.3629761v23.3292847l0,0v10.6049194h2.362793h14.8066406h4.7255859h14.8066406 h4.7258301h14.8066406h4.7258301h14.8063965h4.7258301h14.8066406h4.7258301h14.8066406h4.7258301h14.8063965h2.362793V400.0236816 L178.6879883,400.0236816z" }),
			_react2.default.createElement("path", { style: style.st19, d: "M34.0975266,400.2272644h-5.9127789c-0.9886894,0-1.7901821-0.8014832-1.7901821-1.7901917V380.633667 c0-0.9887085,0.8014927-1.7901917,1.7901821-1.7901917h5.9127789c0.9886932,0,1.790184,0.8014832,1.790184,1.7901917v17.8034058 C35.8877106,399.4257812,35.0862198,400.2272644,34.0975266,400.2272644z" }),
			_react2.default.createElement("path", { style: style.st1, d: "M31.9852123,390.4361877h-1.6881485c-0.9886913,0-1.790184-0.8014832-1.790184-1.7901917v-5.9000244 c0-0.988678,0.8014927-1.7901917,1.790184-1.7901917h1.6881485c0.9886913,0,1.7901859,0.8015137,1.7901859,1.7901917v5.9000244 C33.7753983,389.6347046,32.9739037,390.4361877,31.9852123,390.4361877z" }),
			_react2.default.createElement("rect", { x: "60.4375", y: "395.4804688", style: style.st120, width: "2.1132812", height: "18.1582031" }),
			_react2.default.createElement("rect", { x: "79.9697266", y: "395.4804688", style: style.st120, width: "2.1132812", height: "18.1582031" }),
			_react2.default.createElement("rect", { x: "99.5019531", y: "374.331543", style: style.st120, width: "2.1132812", height: "39.3071289" }),
			_react2.default.createElement("rect", { x: "119.0341797", y: "395.4804688", style: style.st120, width: "2.1132812", height: "18.1582031" }),
			_react2.default.createElement("rect", { x: "138.5664062", y: "395.4804688", style: style.st120, width: "2.1132812", height: "18.1582031" }),
			_react2.default.createElement("rect", { x: "158.0996094", y: "395.4804688", style: style.st120, width: "2.1132812", height: "18.1582031" }),
			_react2.default.createElement("path", { style: style.st145, d: "M65.0377502,395.4806824h-7.0875816c-1.2509651,0-2.2650719-1.0140991-2.2650719-2.2650757v-18.8872681 c0-1.2509766,2.0702629-4.8869019,3.321228-4.8869019h4.9752693c1.2509651,0,3.3212318,3.6359253,3.3212318,4.8869019v18.8872681 C67.3028259,394.4665833,66.2887192,395.4806824,65.0377502,395.4806824z" }),
			_react2.default.createElement("path", { style: style.st145, d: "M84.5701599,395.4806824h-7.0875854c-1.2509613,0-2.2650757-1.0140991-2.2650757-2.2650757v-18.8872681 c0-1.2509766,2.0702667-4.8869019,3.3212357-4.8869019h4.9752655c1.2509689,0,3.3212357,3.6359253,3.3212357,4.8869019v18.8872681 C86.8352356,394.4665833,85.8211212,395.4806824,84.5701599,395.4806824z" }),
			_react2.default.createElement("path", { style: style.st145, d: "M123.6348495,395.4806824h-7.0875854c-1.2509613,0-2.2650681-1.0140991-2.2650681-2.2650757v-18.8872681 c0-1.2509766,2.0702667-4.8869019,3.321228-4.8869019h4.9752731c1.2509613,0,3.321228,3.6359253,3.321228,4.8869019v18.8872681 C125.8999252,394.4665833,124.8858185,395.4806824,123.6348495,395.4806824z" }),
			_react2.default.createElement("path", { style: style.st145, d: "M143.1672211,395.4806824h-7.0875854c-1.2509613,0-2.2650757-1.0140991-2.2650757-2.2650757v-18.8872681 c0-1.2509766,2.0702667-4.8869019,3.321228-4.8869019h4.9752655c1.2509766,0,3.3212433,3.6359253,3.3212433,4.8869019v18.8872681 C145.4322968,394.4665833,144.4181824,395.4806824,143.1672211,395.4806824z" }),
			_react2.default.createElement("path", { style: style.st145, d: "M162.699585,395.4806824h-7.0875854c-1.2509613,0-2.2650757-1.0140991-2.2650757-2.2650757v-18.8872681 c0-1.2509766,2.0702667-4.8869019,3.321228-4.8869019h4.9752808c1.2509613,0,3.321228,3.6359253,3.321228,4.8869019v18.8872681 C164.9646606,394.4665833,163.9505463,395.4806824,162.699585,395.4806824z" }),
			_react2.default.createElement("path", { style: style.st24, d: "M189.5102234,388.3366394h-0.0000153c-2.610611,0-4.7465668-2.1359558-4.7465668-4.746582l0,0 c0-2.6106262,2.1359558-4.746582,4.7465668-4.746582h0.0000153c2.610611,0,4.7465668,2.1359558,4.7465668,4.746582l0,0 C194.2567902,386.2006836,192.1208344,388.3366394,189.5102234,388.3366394z" }),
			_react2.default.createElement("path", { style: style.st24, d: "M189.5102234,400.2272644h-0.0000153c-2.610611,0-4.7465668-2.1359558-4.7465668-4.7465515v-0.0000305 c0-2.6105957,2.1359558-4.7465515,4.7465668-4.7465515h0.0000153c2.610611,0,4.7465668,2.1359558,4.7465668,4.7465515v0.0000305 C194.2567902,398.0913086,192.1208344,400.2272644,189.5102234,400.2272644z" }),
			_react2.default.createElement("path", { style: style.st10, d: "M189.5102081,386.2243042L189.5102081,386.2243042c-1.4488373,0-2.6342468-1.1854248-2.6342468-2.6342468 l0,0c0-1.4488525,1.1854095-2.6342773,2.6342468-2.6342773l0,0c1.4488525,0,2.6342621,1.1854248,2.6342621,2.6342773l0,0 C192.1444702,385.0388794,190.9590607,386.2243042,189.5102081,386.2243042z" }),
			_react2.default.createElement("path", { style: style.st10, d: "M189.5102081,398.1149597L189.5102081,398.1149597c-1.4488373,0-2.6342468-1.1854248-2.6342468-2.6342773 l0,0c0-1.448822,1.1854095-2.6342468,2.6342468-2.6342468l0,0c1.4488525,0,2.6342621,1.1854248,2.6342621,2.6342468l0,0 C192.1444702,396.9295349,190.9590607,398.1149597,189.5102081,398.1149597z" })
		);
	}

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Wine;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Wine() {
		// 17
		var style = {
			st0: {
				fill: "#FFFFFF"
			},
			st138: {
				fill: "#BC669B"
			},
			st139: {
				fill: "#DB79BA"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st138, d: "M102.8184052,338.5260315c0,16.8907776,13.6924438,30.4938049,30.5832214,30.4938049 s30.5832062-13.5583496,30.5832062-30.4490967L102.8184052,338.5260315z" }),
			_react2.default.createElement("ellipse", { style: style.st139, cx: "133.4016266", cy: "338.1160583", rx: "29.3139057", ry: "5.2039328" }),
			_react2.default.createElement("path", { style: style.st0, d: "M165.984375,338.347168c0-14.3007812-8.4716797-29.8227539-8.8330078-30.4765625 c-0.0117188-0.0211182-0.027832-0.0377197-0.0402832-0.0582275c-0.0073242-0.0123901-0.0095215-0.0266724-0.017334-0.0389404 c-0.0288086-0.0456543-0.0715332-0.0888672-0.1022949-0.1341553c-0.0324707-0.0429688-0.0622559-0.0878906-0.0974121-0.1276245 c-2.5722656-3.5097656-11.7392578-5.8704224-23.1782227-5.9428101c-0.0283203-0.0014648-0.0556641-0.0019531-0.0839844-0.0019531 h-0.4609375c-0.0283203,0-0.0556641,0.0004883-0.0839844,0.0019531 c-11.4370117,0.0723877-20.6035156,2.4325562-23.1767578,5.9418945c-0.0356445,0.0404053-0.0661621,0.0861816-0.0991211,0.1300049 c-0.0302734,0.0447998-0.0727539,0.0875244-0.1010742,0.1326904c-0.0078125,0.0122681-0.0100098,0.0264282-0.017334,0.0388184 c-0.0124512,0.0205688-0.0285645,0.0371704-0.0402832,0.0583496c-0.3613281,0.6538086-8.8339844,16.1757812-8.8339844,30.4765625 c0,16.954895,13.0180664,30.9198608,29.5830078,32.4398804v15.1208496 c-5.7675781,0.265686-17.3408203,1.4494019-17.3408203,6.6775513c0,6.5644531,18.2587891,6.7539062,20.3408203,6.7539062 s20.3417969-0.1894531,20.3417969-6.7539062c0-5.2282104-11.5742188-6.4118652-17.3417969-6.6775513v-15.1208496 C152.9663086,369.2670288,165.984375,355.302063,165.984375,338.347168z M133.4013672,305.5673828 c9.8681641,0.0268555,16.2607422,1.7915039,18.9550781,3.2695312c-2.6943359,1.4785156-9.0869141,3.2431641-18.9550781,3.2700195 c-9.8681641-0.0268555-16.2597656-1.7915039-18.9541016-3.2700195 C117.1416016,307.3588867,123.5332031,305.5942383,133.4013672,305.5673828z M104.8183594,338.347168 c0-10.2595215,4.9401855-21.6384277,7.2143555-26.3327026c3.9846191,2.4642944,11.7700195,4.0322266,21.0541992,4.0910034 c0.0283203,0.0014648,0.0556641,0.0019531,0.0839844,0.0019531h0.4609375c0.0283203,0,0.0556641-0.0004883,0.0839844-0.0019531 c9.2858887-0.0587769,17.0717773-1.6269531,21.0561523-4.0916748c2.2739258,4.6893921,7.2124023,16.0564575,7.2124023,26.333374 c0,15.7612305-12.8222656,28.5834961-28.5830078,28.5834961S104.8183594,354.1083984,104.8183594,338.347168z" })
		);
	}

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Yarn;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Yarn() {
		// 1
		var style = {
			st19: {
				fill: "#75C69F"
			},
			st29: {
				fill: "#5994C9"
			}
		};
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { style: style.st19, d: "M198.8992615,408.2594299c-7.1264343,0.9279785-12.9576111-5.3042908-20.3323212-3.5843506 c-4.0927887,0.9546509-7.5837555,3.5115356-11.8623505,3.7886047c-4.4606781,0.2887268-8.4091949-1.2428284-12.0259857-3.8696289 c-2.9459381-2.1396179-5.5736694-3.7112122-9.1942902-4.1049194c-4.267395-0.4640503-8.721344-0.0812378-12.9656372,0.4487915 c-8.6987152,1.0863953-17.101799,3.4974365-25.1091614,7.1930847c-3.1505508,1.4541321-1.6549835,6.9232178,1.5448608,5.4464111 c7.9640884-3.6757507,16.3886719-6.2035217,25.0709076-7.125885c3.9769745-0.4223633,8.75-1.1399841,12.6653748-0.0547485 c3.8762817,1.074585,6.7878876,4.6035461,10.5434265,6.1326599c7.3202515,2.9807129,13.4897308,1.0099792,20.4773254-1.6455383 c7.5247498-2.8597107,13.7100525,4.0379639,21.2909088,3.0508728 C202.4385376,413.4874573,202.3730469,407.8072815,198.8992615,408.2594299z" }),
			_react2.default.createElement("path", { style: style.st29, d: "M199.0023193,413.9347839c0.7330933-0.0954895,1.2969666-0.4369812,1.7122192-0.8983459 c-0.2531586-0.3020325-0.5960999-0.5603333-1.0657501-0.7346497c-2.5011902-0.9284973-4.42276-2.6476135-6.22258-4.541748 c-4.7833405-1.3076782-9.288208-4.2349854-14.5740356-3.1424255c0.240921,0.0304871,0.4800415,0.0615845,0.7231293,0.0914307 c5.0232697,0.6158447,7.8967133,4.4508057,11.1436005,7.8686523 C193.3774567,413.5270691,196.0865631,414.3144531,199.0023193,413.9347839z" }),
			_react2.default.createElement("path", { style: style.st29, d: "M178.9086304,410.5110168c-0.122345-0.0041199-0.238678-0.0223999-0.3627472-0.0227051 c-4.1951904-0.0085754-8.140564,1.6834412-12.3743134,0.9714661c-4.3426056-0.7304688-7.8272705-3.0708923-10.7727661-6.3764648 c-0.2401886-0.1626587-0.4829712-0.3169556-0.7201996-0.4892578c-2.9459381-2.1396179-5.5736694-3.7112122-9.1942902-4.1049194 c-4.267395-0.4640503-8.721344-0.0812378-12.9656372,0.4487915c-1.2667542,0.1582336-2.5251617,0.3529663-3.7790375,0.5671997 c1.9908295,0.0848389,3.9806519,0.2399597,5.9657593,0.4905396c3.9700165,0.5010376,8.7789154,0.8970337,12.371109,2.8540344 c1.9281158,1.0506592,3.4273224,2.7399292,4.928833,4.4412537c1.682663,1.2082825,3.3501282,2.4736328,5.2287445,3.2384949 c7.3202515,2.9807129,13.4897308,1.0099792,20.4773254-1.6455383 C178.1145172,410.7307739,178.5129089,410.6108704,178.9086304,410.5110168z" }),
			_react2.default.createElement("path", { style: style.st29, d: "M127.8400879,392.9000244c-0.3000488,1.8199463-0.8100586,3.5999756-1.4801025,5.2999268 c-0.4300537,1.0900879-0.9200439,2.1401367-1.5,3.1600342c-0.8299561,1.5300293-1.8199463,2.9801025-2.9599609,4.3199463 c-0.4901123,0.6000977-1.0200195,1.1800537-1.5799561,1.7299805c-1.3100586,1.3100586-2.7600098,2.4801025-4.3400879,3.5 c-1.2600098,0.8200684-2.6099854,1.5400391-4.0400391,2.1501465c-1.8099365,0.7600098-3.7399902,1.3498535-5.7800293,1.7199707 c-2.6799316,0.4899902-5.539917,0.6199951-8.5698242,0.3199463c-0.0400391,0.0100098-0.0800781,0.0100098-0.1201172,0.0200195 c-1.7800293,0.289917-3.5999756,0.3399658-5.4199219,0.1600342c-1.7399902-0.1700439-3.4899902-0.5500488-5.1900635-1.1400146 c-2.039917-0.710083-4.0100098-1.7200928-5.8499756-3.0300293H81c-1.1500244-0.8299561-2.25-1.7698975-3.2800293-2.8299561 c-2.4799805-2.5500488-4.5300293-5.7900391-5.8898926-9.7099609c-0.9300537-2.6601562-1.5400391-5.6401367-1.75-8.9200439 c-0.4400635-6.8699951,1.329834-12.710083,4.2600098-17.3000488c2.0299072-3.2099609,4.619873-5.8199463,7.3999023-7.7199707 c0.8200684-0.5699463,1.6500244-1.0699463,2.4799805-1.5100098c2.0500488-1.0799561,4.1300049-1.7999268,6.1201172-2.1199951 c1.0998535-0.1899414,2.1699219-0.2399902,3.1799316-0.1699219c0.1899414,0,0.3699951,0.0198975,0.5600586,0.039917 C98.9199219,358.9199219,104.5,359.25,109.7199707,361.1400146c2.0300293,0.7299805,4,1.7000732,5.8601074,2.8699951 c2.6298828,1.6400146,5.0100098,3.6799316,6.9799805,5.9899902c0.8798828,1.0400391,1.6799316,2.1400146,2.369873,3.2800293 c1.1201172,1.8299561,1.9700928,3.7800293,2.4700928,5.7900391c0.1700439,0.6599121,0.2999268,1.3299561,0.3900146,2.0100098 c0.1298828,0.9699707,0.1799316,1.9599609,0.1398926,2.9599609c0.1101074,0.7199707,0.2000732,1.4499512,0.25,2.1699219 C128.3499756,388.4699707,128.2299805,390.7199707,127.8400879,392.9000244z" }),
			_react2.default.createElement("path", { style: style.st19, d: "M119.3900146,385.5700684c2.6300049,2.6599121,5.4500732,5.119873,8.4500732,7.3299561 c-0.3000488,1.8199463-0.8100586,3.5999756-1.4801025,5.2999268c-5.0999756-3.619873-9.7099609-7.7900391-13.8800049-12.5100098 c-1.9299316,0.0500488-3.8499756,0.130127-5.7800293,0.2399902c5.8500977,5.4500732,11.2199707,11.5400391,18.1600342,15.4300537 c-0.8299561,1.5300293-1.8199463,2.9801025-2.9599609,4.3199463 c-8.5500488-4.9099121-14.8199463-12.9499512-22.4700928-19.2299805c-1.4399414,0.1201172-2.8798828,0.25-4.3199463,0.380127 c0.1099854,0.0898438,0.2200928,0.1799316,0.3199463,0.2999268c7.2299805,8.1300049,15.5700684,14.9400635,24.8901367,20.2799072 c-1.3100586,1.3100586-2.7600098,2.4801025-4.3400879,3.5c-8.2199707-4.9199219-15.7099609-10.9799805-22.2900391-18.039917 c0.0400391,1.460083,0.130127,2.9200439,0.25,4.3800049c0.5900879-0.0400391,1.210083,0.1500244,1.7700195,0.6799316 c5.4100342,5.0500488,10.8200684,10.0800781,16.2299805,15.130127c-1.8099365,0.7600098-3.7399902,1.3498535-5.7800293,1.7199707 c-3.7698975-3.5200195-7.539917-7.0300293-11.3099365-10.5500488c0.6300049,3.6700439,1.5,7.3100586,2.6199951,10.8900146 c-1.7800293,0.289917-3.5999756,0.3399658-5.4199219,0.1600342c-5.0900879-17.0200195-4.880127-35.3500977,0.7600098-52.3900146 c0.119873-0.3399658,0.289917-0.6300049,0.4899902-0.8800049c-0.0100098-0.2299805,0-0.4599609,0.0699463-0.6999512 c0.0499268-0.1600342,0.0999756-0.3200684,0.1500244-0.4799805c0.1899414,0,0.3699951,0.0198975,0.5600586,0.039917 C98.9199219,358.9199219,104.5,359.25,109.7199707,361.1400146c-3.1699219,0.1700439-6.3299561,0.4000244-9.4899902,0.6700439 C99.6400146,361.8599854,99.1500244,361.7399902,98.75,361.5c-0.0900879,0.2900391-0.1999512,0.5800781-0.2900391,0.8699951 c-0.0999756,0.3199463-0.25,0.6300049-0.4299316,0.8900146c-0.0100098,0.2199707-0.0400391,0.4499512-0.1300049,0.6899414 c-0.0699463,0.2099609-0.1300049,0.4300537-0.2000732,0.6401367c5.7399902-0.2301025,11.8901367-0.8200684,17.880127-0.5800781 c2.6298828,1.6400146,5.0100098,3.6799316,6.9799805,5.9899902c-8.4001465-1.8699951-18.1000977-0.3699951-26.3200684-0.1599121 h-0.0300293c-0.3399658,1.3198242-0.6398926,2.6499023-0.9099121,3.9799805 c9.8798828-1.1700439,19.8598633-2.1401367,29.6298828-0.5400391c1.1201172,1.8299561,1.9700928,3.7800293,2.4700928,5.7900391 c-10.6199951-2.4300537-21.4901123-1.2900391-32.3099365,0c-0.2401123,0.0299072-0.460083,0.0299072-0.670166,0 c-0.119873,0.8798828-0.2299805,1.75-0.3199463,2.6298828c8.7401123-0.7900391,17.5200195-1.5400391,26.3099365-1.1398926 c2.4001465,0.0998535,4.920166,0.1999512,7.380127,0.5200195c0.1298828,0.9699707,0.1799316,1.9599609,0.1398926,2.9599609 c0.1101074,0.7199707,0.2000732,1.4499512,0.25,2.1699219 C125.3400879,385.6400146,122.2600098,385.5600586,119.3900146,385.5700684z" }),
			_react2.default.createElement("path", { style: style.st19, d: "M86.8599854,414.1400146c-2.039917-0.710083-4.0100098-1.7200928-5.8499756-3.0300293H81 c-2.6899414-15.9899902-1.5900879-32.3900146,3.2199707-47.9899902c2.0500488-1.0799561,4.1300049-1.7999268,6.1201172-2.1199951 C84.2800293,378.1199951,83.1400146,396.5,86.8599854,414.1400146z" }),
			_react2.default.createElement("path", { style: style.st19, d: "M77.7199707,408.2800293c-2.4799805-2.5500488-4.5300293-5.7900391-5.8898926-9.7099609 c-0.25-8.8100586,0.5898438-17.6000977,2.5100098-26.2200928c2.0299072-3.2099609,4.619873-5.8199463,7.3999023-7.7199707 C77.2299805,378.7299805,75.8499756,393.6199951,77.7199707,408.2800293z" })
		);
	}

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Bodies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function Bodies() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				{ className: "tail" },
				_react2.default.createElement("path", { className: "fill panda--black", d: "M359.0868835,333.0495911c0,0,5.8746643,4.0974426,13.4881287,4.7285767 c7.6134644,0.6311646,14.2970276-5.0291138,14.9281921-12.6425781 c0.631134-7.6134644-5.0291443-14.2970276-12.6426086-14.9281921c-7.6134338-0.631134-14.0826416,2.4429932-14.0826416,2.4429932 L359.0868835,333.0495911z" })
			),
			_react2.default.createElement("path", { className: "fill panda--white", d: "M347.1164856,368.0533142 c-13.3091736,6.5107117-63.9416504-18.6937866-63.9416504-18.6937866 c-37.2061157,0-122.2788086-27.7246399-122.2788086-69.7499695c0-69.567276,30.1615143-76.0936279,67.36763-76.0936279 c10.4207916,0,27.381073,4.8546295,37.4191742,18.754776c18.0921631,25.052887,69.3887634,32.668808,93.1766052,62.6470795 C379.9905396,311.5479431,370.0073853,356.8553467,347.1164856,368.0533142z" }),
			_react2.default.createElement("path", { className: "fill panda--black", d: "M365.8136902,296.7249451c-5.1389771-2.4512024-12.6520386-3.8838196-23.3447876-3.8838196 c-23.7250366,0-42.3563843,13.5067139-40.6023254,47.1098022c-13.4412842-2.2948303-29.7199097,3.9304199-31.9029541,21.7950745 c-0.5586853,4.571991,0.5942688,16.8989563,17.0591736,16.8989563l41.706665-0.5673218 c25.1195374,0,31.0707703-14.7467651,37.8486633-34.5522461l0.0012817,0.000824 c5.0942688-14.2868042,5.5318298-31.8944397-0.7636414-46.803009L365.8136902,296.7249451z" }),
			_react2.default.createElement("path", { className: "fill panda--black", d: "M162.8386688,252.5019531l-13.8438721,96.4331055 c-0.0010986,0.0068359-0.001709,0.0136719-0.0028076,0.0205078c-2.4355469,2.6074219-4.3206787,5.5935059-5.3826904,8.9516602 c-1.3800049,4.3630371-0.9547119,8.0231934,0.2579346,10.9812012c2.3696289,5.7807617,8.2302246,9.3615723,14.4777832,9.3615723 h17.6540527l0.0075684-0.1071777c11.2038574-0.9570312,20.7698975-9.3823242,22.6894531-20.9848633l9.7092285-58.6855469 C210.6760712,284.7480469,165.1095428,238.7773438,162.8386688,252.5019531z" }),
			_react2.default.createElement("path", { className: "fill panda--black", d: "M249.6851044,269.510498c-13.7192383-2.2719727-26.6916504,7.0144043-28.9624023,20.7390137 l-9.7092285,58.6855469c-0.0009766,0.0068359-0.001709,0.0136719-0.0028076,0.0205078 c-2.4356689,2.6074219-4.3206787,5.5935059-5.3826904,8.9516602c-1.3800049,4.3630371-0.9547119,8.0231934,0.2578125,10.9812012 c2.369751,5.7807617,8.2302246,9.3615723,14.4777832,9.3615723h17.6541748l0.0076904-0.1071777 c11.2038574-0.9570312,20.7697601-9.3823242,22.6894379-20.9848633l9.7092285-58.6855469 C272.6948547,284.7480469,263.4096985,271.78125,249.6851044,269.510498z" }),
			_react2.default.createElement("path", { className: "fill panda--black", d: "M265.6828918,222.270752 c-10.0381927-13.9001465-26.9985199-18.7548828-37.4191742-18.7548828c-0.0002441,0-0.0002441,0-0.0003662,0 c-0.5402832,0-1.0787354,0.001709-1.6160889,0.0046387c-0.1751709,0.0009766-0.3494873,0.0029297-0.5244141,0.0041504 c-0.3623047,0.0026855-0.7241211,0.0056152-1.0849609,0.0100098c-0.2087402,0.0024414-0.4169922,0.0053711-0.6252441,0.0083008 c-0.3261719,0.0048828-0.6518555,0.0100098-0.9769287,0.0161133c-0.2230225,0.0039062-0.4456787,0.0085449-0.6680908,0.0131836 c-0.3132324,0.0068359-0.6256104,0.0146484-0.9376221,0.0229492c-0.2235107,0.0058594-0.4471436,0.0114746-0.6699219,0.0180664 c-0.3184814,0.0095215-0.6356201,0.0205078-0.9526367,0.0317383c-0.2126465,0.0073242-0.4259033,0.0141602-0.6380615,0.0222168 c-0.4995117,0.0192871-0.9974365,0.0405273-1.4934082,0.064209c-0.2044678,0.0097656-0.4074707,0.0214844-0.6112061,0.0322266 c-0.3082275,0.0158691-0.6166992,0.0317383-0.923584,0.0495605c-0.2479248,0.0144043-0.4943848,0.0305176-0.741333,0.0461426 c-0.2624512,0.0166016-0.5247803,0.0332031-0.7861328,0.0515137c-0.2600098,0.0178223-0.5192871,0.0371094-0.7783203,0.0566406 c-0.243042,0.0183105-0.4855957,0.0373535-0.7275391,0.0568848c-0.2678223,0.0217285-0.5351562,0.0439453-0.8017578,0.0673828 c-0.2290039,0.0202637-0.4571533,0.041748-0.6853027,0.0632324c-0.2766113,0.0258789-0.5534668,0.0517578-0.8288574,0.079834 c-0.1998291,0.0200195-0.3981934,0.0424805-0.5974121,0.0637207c-1.0688477,0.1147461-2.1271973,0.2446289-3.1743164,0.3918457 c-0.1585693,0.0222168-0.3178711,0.0437012-0.4758301,0.0666504c-0.3065186,0.0446777-0.6113281,0.0922852-0.9157715,0.1398926 c-0.1680908,0.0263672-0.3363037,0.0527344-0.5039062,0.0800781c-0.3068848,0.0500488-0.6125488,0.1020508-0.9174805,0.1552734 c-0.1564941,0.0273438-0.3127441,0.0554199-0.46875,0.0837402c-0.3145752,0.0568848-0.628418,0.1149902-0.9406738,0.1755371 c-0.1303711,0.0253906-0.2597656,0.052002-0.3896484,0.0778809c-0.3376465,0.0673828-0.6749268,0.1352539-1.0097656,0.2072754 c-0.0152588,0.0031738-0.0302734,0.0068359-0.0456543,0.0100098c-1.2104492,0.260498-2.4019775,0.552002-3.574707,0.8745117 c-0.0739746,0.0202637-0.1485596,0.0400391-0.2224121,0.0605469c-0.3383789,0.0944824-0.6744385,0.192627-1.0095215,0.2927246 c-0.0966797,0.0288086-0.1934814,0.0576172-0.289917,0.0869141c-0.3319092,0.1010742-0.6621094,0.204834-0.9906006,0.3115234 c-0.0875244,0.0283203-0.1746826,0.0571289-0.2619629,0.0859375c-0.3432617,0.1135254-0.6854248,0.2287598-1.0250244,0.3486328 c-0.0355225,0.0124512-0.0706787,0.0256348-0.1063232,0.0380859c-1.5461426,0.5490723-3.0532227,1.1657715-4.5177002,1.8579102 c-0.0250244,0.0117188-0.0501709,0.0231934-0.0753174,0.0351562c-0.3448486,0.1635742-0.6870117,0.3322754-1.0270996,0.5046387 c-0.0449219,0.0227051-0.0898438,0.0454102-0.1346436,0.0683594c-0.3397217,0.173584-0.6773682,0.3508301-1.0123291,0.5332031 c-0.02771,0.0151367-0.0551758,0.0305176-0.0827637,0.0456543c-1.8061523,0.9882812-3.5407715,2.1052246-5.1966553,3.3681641 c-0.0010986,0.0007324-0.0023193,0.0014648-0.00354,0.0024414c-0.3272705,0.2497559-0.6513672,0.5053711-0.9726562,0.7666016 c-0.0136719,0.0112305-0.0274658,0.0224609-0.0412598,0.0336914 c-8.8476562,7.2150879-15.3261719,18.8466797-18.3696289,37.5004883 c-0.6286621,3.8522949-1.111084,8.003418-1.4382324,12.4755859c-0.0092773,0.1271973-0.0170898,0.2578125-0.026123,0.3857422 c-0.0649414,0.9162598-0.1229248,1.8469238-0.1748047,2.7905273c-0.0159912,0.2919922-0.0305176,0.5869141-0.0452881,0.8813477 c-0.0401611,0.8012695-0.0751953,1.6137695-0.105957,2.4345703c-0.0133057,0.3557129-0.0268555,0.7106934-0.0384521,1.0700684 c-0.026001,0.8122559-0.0457764,1.6374512-0.0627441,2.46875c-0.006958,0.3474121-0.0163574,0.6896973-0.0217285,1.0402832 c-0.0178223,1.1411133-0.0283203,2.2971191-0.0286865,3.4741211c0,0.0292969-0.0006104,0.057373-0.0006104,0.0866699 c0,0.0061035,0.0006104,0.012207,0.0006104,0.0185547c0.0003662,0.7270508,0.0316162,1.4487305,0.0826416,2.1672363 c0.0153809,0.2189941,0.0418701,0.4362793,0.0618896,0.654541c0.0476074,0.5161133,0.1033936,1.0307617,0.1763916,1.5422363 c0.0328369,0.2307129,0.0708008,0.4602051,0.1086426,0.6896973c0.0859375,0.5197754,0.1838379,1.0368652,0.2954102,1.5515137 c0.041626,0.1933594,0.0822754,0.3867188,0.1274414,0.5791016c0.1472168,0.6240234,0.3112793,1.244873,0.4951172,1.8615723 c0.0216064,0.072998,0.0397949,0.1467285,0.0620117,0.2194824c0.6763916,2.2148438,1.5847168,4.3820801,2.7021484,6.4997559 c0.0147705,0.027832,0.0297852,0.0554199,0.0444336,0.083252c0.3710938,0.6994629,0.7633057,1.3935547,1.1789551,2.0820312l0,0 c14.6367188,9.6533203,46.4459229,14.8242188,59.3820801,14.8242188c34.7233734,0,52.7236176-12.3271484,72.7031097-34.652832 c5.0002441-5.5874023,11.6656494-17.4633789,14.7055664-24.5739746 C293.9455872,243.8220215,275.2099915,235.4633789,265.6828918,222.270752z" })
		);
	}

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make group for face '.fill--face'
	// Make glasses target 'ref="glassesTarget"'
	// Make groups for each eye group
	// - '.fill-eyes eyes'
	// - '.fill-face eyes--blink'
	// - '.fill-face eyes--is-being-pet--likes'
	// - '.fill-eyes eyes--is-being-pet--hates'
	
	var Eyes = function (_React$Component) {
		_inherits(Eyes, _React$Component);
	
		function Eyes() {
			_classCallCheck(this, Eyes);
	
			return _possibleConstructorReturn(this, (Eyes.__proto__ || Object.getPrototypeOf(Eyes)).apply(this, arguments));
		}
	
		_createClass(Eyes, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getGlassesTargetCoords(this.refs.glassesTarget);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					{ className: "fill--face" },
					_react2.default.createElement("circle", { ref: "glassesTarget", cx: "214.2627563", cy: "199.0496063", r: "0" }),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes" },
						_react2.default.createElement("ellipse", { cx: "184.2627563", cy: "199.0496063", rx: "7.6592607", ry: "8.5102901" }),
						_react2.default.createElement("ellipse", { cx: "244.2627563", cy: "199.0496063", rx: "7.6592607", ry: "8.5102901" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--blink" },
						_react2.default.createElement("path", { d: "M191.8984985,205.0343018c-0.1542969,0-0.3105469-0.0141602-0.4677734-0.0439453l-15.265625-2.8896484 c-1.3564453-0.2568359-2.2480469-1.5649414-1.9912109-2.9213867c0.2568359-1.3569336,1.5634766-2.2470703,2.9208984-1.9916992 l15.265625,2.8896484c1.3564453,0.2568359,2.2480469,1.5649414,1.9912109,2.9213867 C194.125061,204.1983643,193.0762329,205.0343018,191.8984985,205.0343018z" }),
						_react2.default.createElement("path", { d: "M236.6270142,205.0343018c0.1542969,0,0.3105469-0.0141602,0.4677734-0.0439453l15.265625-2.8896484 c1.3564453-0.2568359,2.2480469-1.5649414,1.9912109-2.9213867c-0.2568359-1.3569336-1.5634766-2.2470703-2.9208984-1.9916992 l-15.265625,2.8896484c-1.3564453,0.2568359-2.2480469,1.5649414-1.9912109,2.9213867 C234.4004517,204.1983643,235.4492798,205.0343018,236.6270142,205.0343018z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--is-being-pet--likes" },
						_react2.default.createElement("path", { d: "M191.6562347,204.9013824c-0.6044922,0-1.2099609-0.2177734-1.6904297-0.6591797 c-0.9189453-0.84375-2.9033203-1.7983398-5.7177734-1.9462891c-2.8125-0.1425781-4.8876953,0.5942383-5.8896484,1.3378906 c-1.1103516,0.8237305-2.6748047,0.5908203-3.4970703-0.5170898c-0.8232422-1.1083984-0.5917969-2.6743164,0.5166016-3.4975586 c2.234375-1.6591797,5.5507812-2.5053711,9.1318359-2.3164062c3.5683594,0.1875,6.7900391,1.375,8.8388672,3.2578125 c1.0166016,0.934082,1.0839844,2.515625,0.1494141,3.5322266 C193.0048676,204.6294098,192.332016,204.9013824,191.6562347,204.9013824z" }),
						_react2.default.createElement("path", { d: "M236.869278,204.9013824c0.6044922,0,1.2099609-0.2177734,1.6904297-0.6591797 c0.9189453-0.84375,2.9033203-1.7983398,5.7177734-1.9462891c2.8125-0.1425781,4.8876953,0.5942383,5.8896484,1.3378906 c1.1103516,0.8237305,2.6748047,0.5908203,3.4970703-0.5170898c0.8232422-1.1083984,0.5917969-2.6743164-0.5166016-3.4975586 c-2.234375-1.6591797-5.5507812-2.5053711-9.1318359-2.3164062c-3.5683594,0.1875-6.7900391,1.375-8.8388672,3.2578125 c-1.0166016,0.934082-1.0839844,2.515625-0.1494141,3.5322266 C235.5206451,204.6294098,236.1934967,204.9013824,236.869278,204.9013824z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes--is-being-pet--hates" },
						_react2.default.createElement("path", { d: "M191.9220123,199.0496063c0,4.7001038-3.4291687,8.5102844-7.659256,8.5102844 c-4.2301025,0-7.6592712-3.8101807-7.6592712-8.5102844c0-3.0506439,3.4291687-3.0506439,7.6592712-3.0506439 C188.4928436,195.9989624,191.9220123,195.9989624,191.9220123,199.0496063z" }),
						_react2.default.createElement("path", { d: "M251.9220123,199.0496063c0,4.7001038-3.4291687,8.5102844-7.659256,8.5102844 c-4.2301025,0-7.6592712-3.8101807-7.6592712-8.5102844c0-3.0506439,3.4291687-3.0506439,7.6592712-3.0506439 C248.4928436,195.9989624,251.9220123,195.9989624,251.9220123,199.0496063z" })
					)
				);
			}
		}]);
	
		return Eyes;
	}(_react2.default.Component);
	
	exports.default = Eyes;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make hatTarget 'ref="hatTarget"'
	// Add '.fill' to all body elements
	// Add '.fill--face' to nose
	
	var HeadHOC = function (_React$Component) {
		_inherits(HeadHOC, _React$Component);
	
		function HeadHOC() {
			_classCallCheck(this, HeadHOC);
	
			return _possibleConstructorReturn(this, (HeadHOC.__proto__ || Object.getPrototypeOf(HeadHOC)).apply(this, arguments));
		}
	
		_createClass(HeadHOC, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getHatTargetCoords(this.refs.hatTarget);
			}
		}]);
	
		return HeadHOC;
	}(_react2.default.Component);
	
	var Heads = function (_HeadHOC) {
		_inherits(Heads, _HeadHOC);
	
		function Heads() {
			_classCallCheck(this, Heads);
	
			return _possibleConstructorReturn(this, (Heads.__proto__ || Object.getPrototypeOf(Heads)).apply(this, arguments));
		}
	
		_createClass(Heads, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "214.2627563", cy: "142.0613708", r: "0" }),
					_react2.default.createElement(
						"g",
						{ className: "ear ear--right" },
						_react2.default.createElement("path", { className: "fill fill--light panda--black", d: "M274.3649292,166.2736206c0,0,11.2728271-1.6379089,20.791687-9.1886444 c9.5188599-7.5507507,11.1143494-21.3884125,3.5635986-30.90728s-21.3883972-11.1143494-30.9072571-3.5635986 c-9.5188904,7.5507431-13.6791992,18.1550217-13.6791992,18.1550217L274.3649292,166.2736206z" }),
						_react2.default.createElement("path", { className: "fill panda--black", d: "M275.508728,174.1457977l-2.2871399-15.7447357l1.1435852,7.8723602l-1.1782837-7.8677063 c0.0932312-0.0139771,9.4059448-1.5086975,17.0255432-7.5533295c6.0674438-4.8125,7.087738-13.6637421,2.275238-19.7306366 c-4.8125-6.067421-13.6647949-7.0882416-19.7306519-2.2752228 c-7.6268616,6.0493011-11.1839294,14.7420502-11.2175903,14.8280182l-14.8114624-5.8110504 c0.2019806-0.5142822,5.0704193-12.7004089,16.1409607-21.4822388 c12.9417419-10.264122,31.8193665-8.0883408,42.0840149,4.8523788 c10.2646484,12.9402084,8.0878296,31.8188705-4.8523865,42.0840378 C289.0295105,172.0995026,276.0556335,174.0665588,275.508728,174.1457977z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "ear ear--left" },
						_react2.default.createElement("path", { className: "fill fill--light panda--black", d: "M154.1605835,166.2736206c0,0-11.2728119-1.6379089-20.7916718-9.1886444 c-9.5188751-7.5507507-11.114357-21.3884125-3.5636139-30.90728 c7.5507507-9.5188675,21.3884125-11.1143494,30.9072723-3.5635986 c9.5188751,7.5507431,13.6791992,18.1550217,13.6791992,18.1550217L154.1605835,166.2736206z" }),
						_react2.default.createElement("path", { className: "fill panda--black", d: "M153.016983,174.1457977c-0.5469208-0.0792389-13.5213165-2.0462952-24.5923462-10.828125 c-12.9402084-10.2646484-15.1165085-29.1433105-4.8518677-42.0840378 c10.265152-12.9396896,29.1427765-15.1180573,42.0840302-4.8523788 c11.0705109,8.7818298,15.9389496,20.9679565,16.1409454,21.4822388l-14.8114471,5.8110504 c-0.0222778-0.0549011-3.5974731-8.783905-11.2176056-14.8280182 c-6.0658722-4.8119812-14.9176331-3.7932358-19.7306519,2.2752228 c-4.8130188,6.0668945-3.7922058,14.9181366,2.274704,19.7306366c7.626358,6.0498199,16.8996887,7.535202,16.9913635,7.5486755 L153.016983,174.1457977z" })
					),
					_react2.default.createElement("path", { className: "fill panda--white", d: "M138.7770081,193.9500885c0,44.6381989,37.6783752,64.7990875,75.4857483,64.7990875 s75.4857483-20.1608887,75.4857483-64.7990875c0-50.0987549-31.1744385-73.2291946-75.4857483-73.2291946 S138.7770081,143.8513336,138.7770081,193.9500885z" }),
					_react2.default.createElement(
						"g",
						{ className: "muzzle" },
						_react2.default.createElement("circle", { className: "fill fill--light panda--white", cx: "214.2627563", cy: "228.2754974", r: "23.522028" }),
						_react2.default.createElement("path", { className: "fill--face nose", d: "M223.8284149,222.4874268c0-0.0444031-0.0094452-0.0870972-0.0111847-0.1310425 c-0.0017242-0.0214233-0.0031433-0.0425262-0.0054321-0.0639496c-0.1752319-3.0310211-4.3772888-5.4581604-9.5490417-5.4581604 c-5.1785278,0-9.3853149,2.4334412-9.5500641,5.470459c-0.0022125,0.0211029-0.0037842,0.0423584-0.0054474,0.0636292 c-0.0014038,0.0400085-0.0101471,0.0787506-0.0101471,0.1190643h0.0090485 c-0.0200806,0.6416779,0.190033,1.30336,0.6997986,1.8957367l5.906189,5.5724335 c1.4494476,1.6843567,4.4051819,1.6931763,5.8684692,0.0173187l5.9537659-5.6070862 c0.4991302-0.5884399,0.7046051-1.2431793,0.6848297-1.8784027H223.8284149z" })
					)
				);
			}
		}]);
	
		return Heads;
	}(HeadHOC);
	
	exports.default = Heads;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	var _Bodies = __webpack_require__(503);
	
	var _Bodies2 = _interopRequireDefault(_Bodies);
	
	var _Heads = __webpack_require__(505);
	
	var _Heads2 = _interopRequireDefault(_Heads);
	
	var _Eyes = __webpack_require__(504);
	
	var _Eyes2 = _interopRequireDefault(_Eyes);
	
	var _Toy = __webpack_require__(17);
	
	var _Toy2 = _interopRequireDefault(_Toy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bear = function (_PetHOC) {
		_inherits(Bear, _PetHOC);
	
		function Bear(props) {
			_classCallCheck(this, Bear);
	
			var _this = _possibleConstructorReturn(this, (Bear.__proto__ || Object.getPrototypeOf(Bear)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(500, 4000);
						}
					}
				}, {
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 3000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 199;
						}
					}
				}, {
					name: 'wag',
					actions: ['isWaggingUp', 'isWaggingDown'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}, {
					name: 'sniff',
					actions: ['isSniffing'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(1000, 10000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 150;
						}
					}
				}, {
					name: 'flapEar',
					actions: ['isFlappingEarRight', 'isFlappingEarLeft'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 8000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}],
				pet: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(600, 1200);
						}
					}
				}, {
					name: 'wag',
					actions: ['isWaggingUp', 'isWaggingDown'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return 100;
						}
					}
				}, {
					name: 'flapEars',
					actions: ['isFlappingEars'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 800);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 800);
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(Bear, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Bodies2.default, { body: this.props.body })
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Heads2.default, { getHatTargetCoords: this.getHatTargetCoords, head: this.props.head }),
									_react2.default.createElement(_Eyes2.default, { getGlassesTargetCoords: this.getGlassesTargetCoords }),
									this.shouldRenderHat(),
									this.shouldRenderGlasses()
								)
							)
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-toy', viewBox: '0 0 480 480' },
							_react2.default.createElement(_Toy2.default, { toy: this.props.toy })
						)
					)
				);
			}
		}]);
	
		return Bear;
	}(_PetHOC3.default);
	
	exports.default = Bear;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Bodies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function Bodies() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill fill--alt leg leg--left", fill: "#F9CA8C", d: "M295.65915,322.78326 c-2.06384-16.52185-11.40875-32.41916-30.38394-35.14792c-18.9749-2.72906-35.93547,13.94757-38.66423,32.92273 c-0.44888,3.12186-0.61162,6.33524-0.49562,9.51727l-6.49878,0.70261c-9.27345,1.00223-15.67355,9.66104-14.67134,18.93451 c1.00223,9.27344,10.76855,13.90826,20.04201,12.90631l25.54213-2.76038 C280.31625,356.63898,298.98688,349.42218,295.65915,322.78326z" }),
			_react2.default.createElement(
				"g",
				{ className: "tail" },
				_react2.default.createElement("circle", { className: "fill fill--white", fill: "#FFFFFF", cx: "343.8403", cy: "332.86063", r: "24.02028" })
			),
			_react2.default.createElement("path", { className: "fill belly", fill: "#FAD59E", d: "M342.37531,336.51498c-6.95691,31.88583-28.17328,33.68982-62.52521,33.63113 c-27.80345-0.04745-86.24832-24.34467-86.24832-58.33105s7.07106-45.30084,69.52274-59.92542 C318.52808,238.91556,351.33084,295.46881,342.37531,336.51498z" }),
			_react2.default.createElement("path", { className: "fill fill--alt arm arm--right", fill: "#F9CA8C", d: "M223.75703,382.52258c-9.32733,0-16.88881-5.30783-16.88881-14.63516 v-25.69113c0-9.32733,7.56148-16.88882,16.88881-16.88882s16.88882,7.56149,16.88882,16.88882v25.69113 C240.64586,377.21475,233.08437,382.52258,223.75703,382.52258z" }),
			_react2.default.createElement("path", { className: "fill fill--alt arm arm--left", fill: "#F9CA8C", d: "M184.18922,382.52258c-9.32733,0-16.88882-5.30783-16.88882-14.63516 v-25.69113c0-9.32733,7.56149-16.88882,16.88882-16.88882s16.88881,7.56149,16.88881,16.88882v25.69113 C201.07803,377.21475,193.51656,382.52258,184.18922,382.52258z" }),
			_react2.default.createElement("path", { className: "fill torso", fill: "#FAD59E", d: "M250.82784,316.36142c-0.64923,24.89731-21.77948,41.16284-47.19939,40.49997 c-25.41989-0.66284-45.50343-18.00308-44.8542-42.90036c0.64923-24.89731,21.78244-46.79688,47.20233-46.134 C231.39647,268.48987,251.47707,291.46411,250.82784,316.36142z" }),
			_react2.default.createElement("path", { className: "fill fill--alt leg leg--right", fill: "#F9CA8C", d: "M345.27444,340.06955 c-2.06384-16.52185-11.40875-32.41916-30.38394-35.14792s-35.93546,13.94785-38.66449,32.92276 c-0.44888,3.12183-0.61163,6.33521-0.49536,9.51755l-6.49905,0.70233c-9.27319,1.0022-15.67328,9.66132-14.67134,18.93448 c1.00223,9.27347,10.76854,13.90854,20.04201,12.90631l25.54242-2.76038 C329.93155,373.92554,348.60217,366.70874,345.27444,340.06955z" })
		);
	}

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make group for face '.fill--face'
	// Make glasses target 'ref="glassesTarget"'
	// Make groups for each eye group
	// - '.fill-eyes eyes'
	// - '.fill-face eyes--blink'
	// - '.fill-face eyes--is-being-pet--likes'
	// - '.fill-eyes eyes--is-being-pet--hates'
	
	var Eyes = function (_React$Component) {
		_inherits(Eyes, _React$Component);
	
		function Eyes() {
			_classCallCheck(this, Eyes);
	
			return _possibleConstructorReturn(this, (Eyes.__proto__ || Object.getPrototypeOf(Eyes)).apply(this, arguments));
		}
	
		_createClass(Eyes, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getGlassesTargetCoords(this.refs.glassesTarget);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					{ className: "fill--face" },
					_react2.default.createElement("circle", { ref: "glassesTarget", cx: "202.28545", cy: "273.28705" }),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes" },
						_react2.default.createElement("ellipse", { transform: "matrix(0.08134 -0.99669 0.99669 0.08134 -107.40938 430.50348)", cx: "179.82877", cy: "273.51767", rx: "7.43675", ry: "6.85861" }),
						_react2.default.createElement("ellipse", { transform: "matrix(0.99669 -0.08134 0.08134 0.99669 -21.50175 19.20372)", cx: "224.95857", cy: "273.51767", rx: "6.85861", ry: "7.43675" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--blink" },
						_react2.default.createElement("path", { d: "M185.90509,277.65744c-0.11784,0-0.23717-0.0108-0.35724-0.03357l-11.65846-2.20682 c-1.03592-0.19617-1.71684-1.19516-1.52069-2.23108c0.19614-1.03632,1.19403-1.71613,2.2307-1.52109l11.65846,2.20685 c1.03592,0.19614,1.71684,1.19516,1.52071,2.23108C187.60553,277.01904,186.80453,277.65744,185.90509,277.65744z" }),
						_react2.default.createElement("path", { d: "M218.88225,277.65744c0.11783,0,0.23717-0.0108,0.35724-0.03357l11.65845-2.20682 c1.03593-0.19617,1.71686-1.19516,1.52071-2.23108c-0.19615-1.03632-1.19403-1.71613-2.23071-1.52109l-11.65845,2.20685 c-1.03593,0.19614-1.71686,1.19516-1.52071,2.23108C217.18181,277.01904,217.9828,277.65744,218.88225,277.65744z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--is-being-pet--likes" },
						_react2.default.createElement("path", { d: "M185.85614,277.65744c-0.47278,0-0.94632-0.17032-1.3221-0.51553c-0.71872-0.65991-2.27072-1.40652-4.47194-1.52222 c-2.19969-0.11151-3.82272,0.46475-4.60635,1.04636c-0.86842,0.64426-2.092,0.4621-2.73509-0.40442 c-0.64388-0.86688-0.46286-2.09161,0.40404-2.73547c1.74753-1.29767,4.34132-1.95947,7.14211-1.81168 c2.79085,0.14664,5.31056,1.07541,6.91296,2.54797c0.7951,0.73056,0.84779,1.9675,0.11687,2.76257 C186.91092,277.44473,186.38467,277.65744,185.85614,277.65744z" }),
						_react2.default.createElement("path", { d: "M218.92694,277.65744c0.47174,0,0.94426-0.16995,1.31923-0.51443c0.71715-0.65845,2.26578-1.40344,4.4622-1.51889 c2.1949-0.11127,3.81439,0.46375,4.59633,1.0441c0.86653,0.64285,2.08745,0.46109,2.72914-0.40353 c0.64247-0.86502,0.46185-2.08707-0.40315-2.72952c-1.74373-1.29486-4.33188-1.95523-7.12657-1.80774 c-2.78477,0.1463-5.29901,1.07306-6.89793,2.54242c-0.79337,0.72897-0.84595,1.9632-0.11661,2.75656 C217.87445,277.44519,218.39955,277.65744,218.92694,277.65744z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes--is-being-pet--hates" },
						_react2.default.createElement("path", { d: "M218.12268,274.07553c0.37856,4.63864,3.66542,7.16235,7.44078,6.85425c3.77534-0.30811,6.60954-3.3313,6.231-7.96997 c-0.19713-2.02863-1.23912-3.21503-6.83589-2.69183C218.81996,270.84183,218.08875,271.91293,218.12268,274.07553z" }),
						_react2.default.createElement("path", { d: "M186.66464,274.07553c-0.37854,4.63864-3.66541,7.16235-7.44077,6.85425s-6.60956-3.3313-6.231-7.96997 c0.19713-2.02863,1.23911-3.21503,6.83589-2.69183C185.96736,270.84183,186.69858,271.91293,186.66464,274.07553z" })
					)
				);
			}
		}]);
	
		return Eyes;
	}(_react2.default.Component);
	
	exports.default = Eyes;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make hatTarget 'ref="hatTarget"'
	// Add '.fill' to all body elements
	// Add '.fill--face' to nose
	
	var HeadHOC = function (_React$Component) {
		_inherits(HeadHOC, _React$Component);
	
		function HeadHOC() {
			_classCallCheck(this, HeadHOC);
	
			return _possibleConstructorReturn(this, (HeadHOC.__proto__ || Object.getPrototypeOf(HeadHOC)).apply(this, arguments));
		}
	
		_createClass(HeadHOC, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getHatTargetCoords(this.refs.hatTarget);
			}
		}]);
	
		return HeadHOC;
	}(_react2.default.Component);
	
	var Heads = function (_HeadHOC) {
		_inherits(Heads, _HeadHOC);
	
		function Heads() {
			_classCallCheck(this, Heads);
	
			return _possibleConstructorReturn(this, (Heads.__proto__ || Object.getPrototypeOf(Heads)).apply(this, arguments));
		}
	
		_createClass(Heads, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "201.66981", cy: "252.25842" }),
					_react2.default.createElement(
						"g",
						{ className: "ear ear--right" },
						_react2.default.createElement("path", { className: "fill fill--alt", fill: "#F9CA8C", d: "M207.12628,250.49135c0,0-4.68541-29.08371,5.70441-53.77675 c7.47893-17.77489,26.79756-26.57507,37.0354-30.1109c3.71422-1.28279,7.75418,0.63651,9.0762,4.33693 c2.37631,6.6514,3.04181,21.60115,2.41016,30.69572c-1.56705,22.56326-21.50287,46.37608-21.50287,46.37608" })
					),
					_react2.default.createElement(
						"g",
						{ className: "ear ear--left" },
						_react2.default.createElement("path", { className: "fill fill--alt", fill: "#F9CA8C", d: "M197.61336,250.49135c0,0,4.68541-29.08371-5.70441-53.77675 c-7.47893-17.77489-26.79758-26.57507-37.0354-30.1109c-3.71423-1.28279-7.75418,0.63651-9.07622,4.33693 c-2.3763,6.6514-3.04179,21.60115-2.41016,30.69572c1.56706,22.56326,21.50288,46.37608,21.50288,46.37608" })
					),
					_react2.default.createElement("path", { className: "fill fill--alt", fill: "#F9CA8C", d: "M202.42819,223.74702c27.71442,0,40.42635,9.24236,49.70348,53.73799 c3.55681,21.93875-12.68216,38.52969-30.85414,38.63864c-4.60289,0.02762-33.29839,0.0271-37.81541,0 c-18.172-0.10895-34.41096-16.69989-30.85416-38.63864C162.05992,232.98938,174.71378,223.74702,202.42819,223.74702z" }),
					_react2.default.createElement("path", { className: "fill--face nose", fill: "#FC7E7E", d: "M196.39325,288.02222l3.80586,4.64508 c1.12845,1.37732,3.23416,1.38,4.36613,0.00558l3.82126-4.63968c0.54681-0.66394,0.02766-1.66891-0.82869-1.58844 c-3.44424,0.32364-6.88844,0.32065-10.33269-0.00897C196.36932,286.35388,195.84837,287.35721,196.39325,288.02222z" })
				);
			}
		}]);
	
		return Heads;
	}(HeadHOC);
	
	exports.default = Heads;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	var _Bodies = __webpack_require__(507);
	
	var _Bodies2 = _interopRequireDefault(_Bodies);
	
	var _Heads = __webpack_require__(509);
	
	var _Heads2 = _interopRequireDefault(_Heads);
	
	var _Eyes = __webpack_require__(508);
	
	var _Eyes2 = _interopRequireDefault(_Eyes);
	
	var _Toy = __webpack_require__(17);
	
	var _Toy2 = _interopRequireDefault(_Toy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bunny = function (_PetHOC) {
		_inherits(Bunny, _PetHOC);
	
		function Bunny(props) {
			_classCallCheck(this, Bunny);
	
			var _this = _possibleConstructorReturn(this, (Bunny.__proto__ || Object.getPrototypeOf(Bunny)).call(this, props));
	
			_this.stompSpeed = _lodash2.default.random(50, 300);
	
			_this.actions = {
				idle: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(500, 4000);
						}
					}
				}, {
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 2500);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 199;
						}
					}
				}, {
					name: 'ruffleTail',
					actions: ['isRufflingTail'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(1000, 6000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 400;
						}
					}
				}, {
					name: 'sniff',
					actions: ['isSniffing'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(1000, 10000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 150;
						}
					}
				}, {
					name: 'alert',
					actions: ['isAlert'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 4000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(1000, 2000);
						}
					}
				}],
				pet: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(600, 1200);
						}
					}
				}, {
					name: 'stomp',
					actions: ['isStompingRight', 'isStompingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _this.stompSpeed;
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 150;
						}
					}
				}, {
					name: 'alert',
					actions: ['isAlert'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 1000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 1000);
						}
					}
				}, {
					name: 'ruffleTail',
					actions: ['isRufflingTail'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(1000, 6000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 400;
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(Bunny, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Bodies2.default, { body: this.props.body })
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Heads2.default, { getHatTargetCoords: this.getHatTargetCoords, head: this.props.head }),
									_react2.default.createElement(_Eyes2.default, { getGlassesTargetCoords: this.getGlassesTargetCoords }),
									this.shouldRenderHat(),
									this.shouldRenderGlasses()
								)
							)
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-toy', viewBox: '0 0 480 480' },
							_react2.default.createElement(_Toy2.default, { toy: this.props.toy })
						)
					)
				);
			}
		}]);
	
		return Bunny;
	}(_PetHOC3.default);
	
	exports.default = Bunny;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Bodies(props) {
		var bodies = {
			Body0: Body0,
			Body1: Body1,
			Body2: Body2,
			Body3: Body3,
			Body4: Body4,
			Body5: Body5
		};
	
		var propBody = 'Body' + props.body;
	
		var Body = bodies[propBody];
	
		return _react2.default.createElement(Body, null);
	}
	
	function Body0() {
		return _react2.default.createElement('path', { className: 'fill', d: 'M378.5,322.5c0.1-0.9,0.2-1.8,0.3-2.7c0.7-11,2.7-54.1-36.1-88.5c-22.4-19.9-43.8-27-73.5-28 c-2.2-3.3-4.5-7.4-5.5-11.2c-2.7-10.3-14.1-16.6-24.3-13.8c-4.4,1.2-7.9,3.9-10.4,7.3c-12.6-12.5-31.8-16.6-46.9-5.2 c-2.1-1.7-4.5-3-7-3.7c-11-3-19.6,4.2-24.3,13.8c-11,22.2-11,56.8-11,59.3c0,0,1.3,99.5,1.3,111.5c0,25.4,39.7,25.5,39.6,0 c0-12,0-24,0-36.1l0-10.3c0-0.1,0-0.1,0-0.2c0.3-0.3,0.7-0.5,1-0.8c2.3-1.1,12.7,5.7,12.7,8c0,12.8,0,25.5,0,38.3 c0,25.4,39.5,25.5,39.5,0c0-5.8,0-11.5,0-17.3c2,0.5,4.3,0.7,6.9,0.5c5.2-0.5,9.3-0.2,13.1,0.6c-10.4,9.8-5.8,33.5,13.5,35.5 c28.4,2.9,67.3-1.2,90.8-20.2c5.1,10.5,1.2,23.6-14.3,27.2c-24.7,5.8-53.7,4.2-78.9,3.7c-25.4-0.5-25.4,39,0,39.5 c26.2,0.5,52.4-0.4,78.3-3.6c19.9-2.5,37.5-9.6,48.4-27.5C408.3,371.4,399.7,341.1,378.5,322.5z' });
	}
	
	function Body1() {
		return _react2.default.createElement('path', { className: 'fill', d: 'M378,323.5c0.1-0.9,0.2-1.8,0.3-2.7c0.7-11,2.7-54.1-36.1-88.5c-22.4-19.9-43.8-27-73.5-28 c-2.2-3.3-4.5-7.4-5.5-11.2c-2.7-10.3-14.1-16.6-24.3-13.8c-4.4,1.2-7.9,3.9-10.4,7.3c-12.6-12.5-31.8-16.6-46.9-5.2 c-2.1-1.7-4.5-3-7-3.7c-11-3-19.6,4.2-24.3,13.8c-4.7,9.5-7.4,21.3-8.9,31.9c-12.2,17.6-12.1,42-1.6,60.4 c0.4,30.1,0.9,71.1,0.9,78.5c0,25.4,39.6,25.5,39.5,0c0-12-0.1-24-0.1-36.1v-0.5c3-1.3,6.8-1.4,10.2,0.4c1.2,0.6,2.4,1,3.7,1.2 c0,11.2,0,22.5,0,33.7c0,25.4,39.5,25.5,39.5,0c0-5.8,0-11.5,0-17.3c2,0.5,4.3,0.7,6.9,0.5c5.2-0.5,9.3-0.2,13.1,0.6 c-10.4,9.8-5.8,33.5,13.5,35.5c28.4,2.9,67.3-1.2,90.8-20.2c5.1,10.5,1.2,23.6-14.3,27.2c-24.7,5.8-53.7,4.2-78.9,3.7 c-25.4-0.5-25.4,39,0,39.5c26.2,0.5,52.4-0.4,78.3-3.6c19.9-2.5,37.5-9.6,48.4-27.5C407.8,372.4,399.2,342.1,378,323.5z' });
	}
	
	function Body2() {
		return _react2.default.createElement('path', { className: 'fill', d: 'M379,322.5c0.1-0.9,0.2-1.8,0.3-2.7c0.7-11,2.7-54.1-36.1-88.5c-22.4-19.9-43.8-27-73.5-28 c-2.2-3.3-4.5-7.4-5.5-11.2c-2.7-10.3-14.1-16.6-24.3-13.8c-4.4,1.2-7.9,3.9-10.4,7.3c-12.6-12.5-31.8-16.6-46.9-5.2 c-2.1-1.7-4.5-3-7-3.7c-11-3-19.6,4.2-24.3,13.8c-3.6,7.4-6.1,16.1-7.7,24.6c-18.4,10.4-27.6,32.6-25.2,53.2 c2,17.5,10.6,32.3,22.7,44.2c0.3,22.5,0.5,43.7,0.5,48.8c0,25.4,39.5,25.5,39.4,0c0-9-0.1-18-0.2-27c1.6-2.6,4.2-2.8,7.7-2.2 c2.2,0.4,4.3,1.2,6.4,1.9c0,8.7,0,17.4,0,26.1c0,25.4,39.5,25.5,39.6,0c0-5.8,0-11.5,0-17.3c2,0.5,4.3,0.7,6.9,0.5 c5.2-0.5,9.4-0.2,13.1,0.6c-10.4,9.8-5.8,33.5,13.5,35.5c28.4,2.9,67.3-1.2,90.8-20.2c5.1,10.5,1.2,23.6-14.3,27.2 c-24.7,5.8-53.7,4.2-78.9,3.7c-25.4-0.5-25.4,39,0,39.5c26.2,0.5,52.4-0.4,78.3-3.6c19.9-2.5,37.5-9.6,48.4-27.5 C408.8,371.4,400.2,341.1,379,322.5z' });
	}
	
	function Body3() {
		return _react2.default.createElement('path', { className: 'fill', d: 'M416,353.9c-6.2-17.7-19.6-36.3-37.6-43.9c-0.5-17.9-5.7-50.6-36.4-77.8c-22.4-19.9-43.8-27-73.5-28 c-2.2-3.3-4.5-7.4-5.5-11.2c-2.7-10.3-14.1-16.6-24.3-13.8c-4.4,1.2-7.9,3.9-10.4,7.3c-12.6-12.5-31.8-16.6-46.9-5.2 c-2.1-1.7-4.5-3-7-3.7c-11-3-19.6,4.2-24.3,13.8c-1.9,3.9-3.5,8.1-4.8,12.4c-2.5-4-20.8,21.1-20.8,21.1c-9.5,11-15.4,25.4-16.3,39.2 c-0.2,0.9-0.3,1.9-0.3,2.9c1,35.2,19.9,67.7,34.8,97.7c6.8,18.4,37.1,21.6,37.1-2.6c0-4,0-8.1-0.1-12.1c4.6,1,9.2,1.9,13.9,2.6 c0,2.8,0,5.6,0,8.4c0,25.4,28.4,27.8,38.1,7.8c0.8-1.6,12.1-12.9,16.2-13c-1.3,10.6,4.9,23.1,18.7,24.5c28.4,2.9,67.3-1.2,90.8-20.2 c5.1,10.5,1.2,23.6-14.3,27.2c-24.7,5.8-53.7,4.2-78.9,3.7c-13.7-0.3-20,11-19,21.6c-0.1,0.5-0.1,1-0.1,1.6 c-0.1,10.2,6.1,19.5,15,24.3c8.9,4.8,19.5,5.2,29.4,5.3c21.3,0.3,42.9-2.5,63.5-8c18.8-5.1,38.6-12.8,51.5-28.1 C417.7,392.6,422.7,373,416,353.9z' });
	}
	
	function Body4() {
		return _react2.default.createElement('path', { className: 'fill', d: 'M417,352.9c-6.2-17.7-19.6-36.3-37.6-43.9c-0.5-17.9-5.7-50.6-36.4-77.8c-22.4-19.9-43.8-27-73.5-28 c-2.2-3.3-4.5-7.4-5.5-11.2c-2.7-10.3-14.1-16.6-24.3-13.8c-4.4,1.2-7.9,3.9-10.4,7.3c-12.6-12.5-31.8-16.6-46.9-5.2 c-2.1-1.7-4.5-3-7-3.7c-8.3-2.3-9.6,14.1-11.8,26.3c-38.1,10.9-56.6,35.9-56.6,74.1c0,28.7,9.6,54.3,30.2,71.5 c1.9,5.2,4.1,10.3,6.6,15.3c6,16.3,30.5,20.7,36,4.6c5.4,1.2,11.1,2,17.2,2.6c6.4,13.6,25,13.6,34,0.1c7.1-0.5,14.1-1.2,20.8-2.2 c3,5.4,8.3,9.6,16,10.4c28.4,2.9,67.3-1.2,90.8-20.2c5.1,10.5,1.2,23.6-14.3,27.2c-24.7,5.8-53.7,4.2-78.9,3.7 c-13.7-0.3-20,11-19,21.6c-0.1,0.5-0.1,1-0.1,1.6c-0.1,10.2,6.1,19.5,15,24.3c8.9,4.8,19.5,5.2,29.4,5.3c21.3,0.3,42.9-2.5,63.5-8 c18.8-5.1,38.6-12.8,51.5-28.1C418.7,391.6,423.7,372,417,352.9z' });
	}
	
	function Body5() {
		return _react2.default.createElement('path', { className: 'fill', d: 'M379,323c0.1-0.9,0.2-1.8,0.3-2.7c0.7-11,2.7-54.1-36.1-88.5c-22.4-19.9-43.8-27-73.5-28 c-2.2-3.3-4.5-7.4-5.5-11.2c-2.2-8.5-10.4-14.3-19-14.5c-1.9-0.1-3.9,0.1-5.8,0.6c-4.2,1.2-7.7,3.7-10.2,7 c-7.5-7.3-17.3-11.7-27.1-11.6c-6.8-0.1-13.6,2-19.7,6.5c-2-1.6-4.3-2.9-6.7-3.5c-11-3-19.6,4.2-24.3,13.8c-2.9,6-5.1,12.8-6.7,19.7 c-25.5,13.1-38,35.5-38,66.9c0,28.7,9.6,54.3,30.2,71.5c1.4,3.8,3,7.6,4.7,11.4c0,0.5,0,0.9,0,1.3c0,22.7,31.5,25.2,38.2,7.2 c5.3,1.1,10.9,2,16.8,2.5c5.6,11.9,20.5,13.4,30.2,4.5c1.7-1.2,3.2-2.7,4.4-4.4c6.9-0.5,13.6-1.2,20.2-2.1c3,5.4,8.3,9.6,16,10.4 c5.4,0.5,11.2,0.8,17.1,0.8c25.6,0,55-5.6,74.2-21c5.1,10.5,1.2,23.6-14.3,27.2c-24.7,5.8-53.7,4.2-78.9,3.7 c-25.4-0.5-25.4,39,0,39.5c26.2,0.5,52.4-0.4,78.3-3.6c19.9-2.5,37.5-9.6,48.4-27.5C408.8,371.9,400.2,341.6,379,323z' });
	}
	
	exports.default = Bodies;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Eyes = function (_React$Component) {
		_inherits(Eyes, _React$Component);
	
		function Eyes() {
			_classCallCheck(this, Eyes);
	
			return _possibleConstructorReturn(this, (Eyes.__proto__ || Object.getPrototypeOf(Eyes)).apply(this, arguments));
		}
	
		_createClass(Eyes, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getGlassesTargetCoords(this.refs.glassesTarget);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					{ className: "fill--face" },
					_react2.default.createElement("circle", { ref: "glassesTarget", cx: "199.3255768", cy: "159.5086517", r: "0" }),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes" },
						_react2.default.createElement("ellipse", { cx: "229.3255768", cy: "159.5086517", rx: "7.6592607", ry: "8.5102901" }),
						_react2.default.createElement("ellipse", { cx: "169.3255768", cy: "159.5086517", rx: "7.6592607", ry: "8.5102901" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--blink" },
						_react2.default.createElement("path", { d: "M176.1699219,168.2983398c-0.1542969,0-0.3105469-0.0141602-0.4677734-0.0439453l-15.265625-2.8896484 c-1.3564453-0.2568359-2.2480469-1.5649414-1.9912109-2.9213867c0.2568359-1.3569336,1.5634766-2.2470703,2.9208984-1.9916992 l15.265625,2.8896484c1.3564453,0.2568359,2.2480469,1.5649414,1.9912109,2.9213867 C178.3964844,167.4624023,177.3476562,168.2983398,176.1699219,168.2983398z" }),
						_react2.default.createElement("path", { d: "M221.8984375,168.2983398c-1.1777344,0-2.2265625-0.8359375-2.453125-2.0356445 c-0.2568359-1.3564453,0.6347656-2.6645508,1.9912109-2.9213867l15.265625-2.8896484 c1.3564453-0.2558594,2.6650391,0.6347656,2.9208984,1.9916992c0.2568359,1.3564453-0.6347656,2.6645508-1.9912109,2.9213867 l-15.265625,2.8896484C222.2089844,168.2841797,222.0527344,168.2983398,221.8984375,168.2983398z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--is-being-pet--likes" },
						_react2.default.createElement("path", { d: "M176.4052734,168.6992188c-0.6044922,0-1.2099609-0.2177734-1.6904297-0.6591797 c-0.9189453-0.84375-2.9033203-1.7983398-5.7177734-1.9462891c-2.8125-0.1425781-4.8876953,0.5942383-5.8896484,1.3378906 c-1.1103516,0.8237305-2.6748047,0.5908203-3.4970703-0.5170898c-0.8232422-1.1083984-0.5917969-2.6743164,0.5166016-3.4975586 c2.234375-1.6591797,5.5507812-2.5053711,9.1318359-2.3164062c3.5683594,0.1875,6.7900391,1.375,8.8388672,3.2578125 c1.0166016,0.934082,1.0839844,2.515625,0.1494141,3.5322266 C177.7539062,168.4272461,177.0810547,168.6992188,176.4052734,168.6992188z" }),
						_react2.default.createElement("path", { d: "M222.5205078,168.6992188c-0.6757812,0-1.3486328-0.2719727-1.8417969-0.8085938 c-0.9345703-1.0166016-0.8671875-2.5981445,0.1494141-3.5322266c2.0488281-1.8828125,5.2705078-3.0703125,8.8388672-3.2578125 c3.5712891-0.1894531,6.8974609,0.6572266,9.1318359,2.3164062c1.1083984,0.8232422,1.3398438,2.3891602,0.5166016,3.4975586 c-0.8242188,1.1088867-2.3896484,1.3383789-3.4970703,0.5170898c-1.0009766-0.7436523-3.0634766-1.480957-5.8896484-1.3378906 c-2.8144531,0.1479492-4.7988281,1.1025391-5.7177734,1.9462891 C223.7304688,168.4814453,223.125,168.6992188,222.5205078,168.6992188z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes--is-being-pet--hates" },
						_react2.default.createElement("path", { d: "M164.0014191,156.512207c-1.1442413-0.0243225-2.146286,0.8135376-2.2757721,1.9506989 c-0.0390015,0.342453-0.0593262,0.6913605-0.0593262,1.0457916c0,4.7000732,3.4291382,8.5102539,7.6592407,8.5102539 s7.6593018-3.8101807,7.6593018-8.5102539c0-0.2648621-0.0113831-0.5266418-0.0334015-0.7849426 c-0.0950928-1.115799-1.0602112-1.958786-2.1797943-1.9825897L164.0014191,156.512207z" }),
						_react2.default.createElement("path", { d: "M223.8821106,156.7286377c-1.1194611,0.0231934-2.0842438,0.8654327-2.1811371,1.9809265 c-0.0228424,0.2629089-0.0346527,0.5294189-0.0346527,0.7991333c0,4.7000732,3.4291382,8.5102539,7.6592407,8.5102539 s7.6593018-3.8101807,7.6593018-8.5102539c0-0.3568726-0.0206146-0.7081451-0.0601196-1.052887 c-0.1302338-1.1364288-1.1309662-1.9739532-2.2746124-1.9502563L223.8821106,156.7286377z" })
					)
				);
			}
		}]);
	
		return Eyes;
	}(_react2.default.Component);
	
	exports.default = Eyes;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeadHOC = function (_React$Component) {
		_inherits(HeadHOC, _React$Component);
	
		function HeadHOC() {
			_classCallCheck(this, HeadHOC);
	
			return _possibleConstructorReturn(this, (HeadHOC.__proto__ || Object.getPrototypeOf(HeadHOC)).apply(this, arguments));
		}
	
		_createClass(HeadHOC, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getHatTargetCoords(this.refs.hatTarget);
			}
		}]);
	
		return HeadHOC;
	}(_react2.default.Component);
	
	var Head0 = function (_HeadHOC) {
		_inherits(Head0, _HeadHOC);
	
		function Head0() {
			_classCallCheck(this, Head0);
	
			return _possibleConstructorReturn(this, (Head0.__proto__ || Object.getPrototypeOf(Head0)).apply(this, arguments));
		}
	
		_createClass(Head0, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "198.3777466", cy: "115.3500366" }),
					_react2.default.createElement("path", { className: "fill", d: "M297.5195312,174.7324219l-11.168396,0.6960449 c0.8058472-22.6686401-4.857666-70.8167725-12.9073486-90.3704834c-2.0126953-6.411499-10.1627808-10.1656494-15.6678467-5.7921143 l-0.000061,0.000061c-10.5443115,6.0974731-23.5308838,15.9562378-33.8678589,25.4852905 c-7.9797363-2.2817383-16.4360352-3.5415039-25.1954956-3.5415039c-8.7077637,0-17.1159058,1.2452393-25.0541992,3.5014648 c-10.3299561-9.5166016-23.2952881-19.3563843-33.8247681-25.4452515v-0.000061 c-5.5050659-4.3735352-13.6551514-0.6193848-15.6679077,5.7921143c-8.0095825,19.4562988-13.65448,67.2142944-12.9168091,90.0214233 c-0.0073242,0.1578369-0.0165405,0.3156738-0.022522,0.4735107l-13.1647949-0.8204956 c-2.5009766-0.1567383-4.6171875,1.7314453-4.7714844,4.2114258c-0.1542969,2.4804688,1.7304688,4.6166992,4.2109375,4.7709961 l14.1262817,0.8803711c0.2800903,2.1012573,0.6940918,4.1260986,1.227478,6.0805054l-10.6750488,3.6392212 c-2.3525391,0.8017578-3.609375,3.3588867-2.8076172,5.7114258c0.6386719,1.8710938,2.3867188,3.0493164,4.2597656,3.0493164 c0.4814453,0,0.9707031-0.078125,1.4521484-0.2421875l11.0324097-3.7610474 c1.1381836,2.2088013,2.4599609,4.3027344,3.9556274,6.2821655l-7.3161621,6.0423584 c-1.9169922,1.5825195-2.1875,4.4189453-0.6044922,6.3354492c0.8896484,1.0771484,2.1757812,1.6342773,3.4726562,1.6342773 c1.0087891,0,2.0244141-0.3378906,2.8623047-1.0302734l7.6834106-6.3457031 c15.7351685,14.2298584,42.3538818,20.7584229,72.5427856,20.7584229c29.62677,0,55.8122559-6.2897339,71.6497803-19.9735107 l6.7333984,5.560791c0.8388672,0.6928711,1.8535156,1.0302734,2.8623047,1.0302734 c1.296875,0,2.5830078-0.5571289,3.4726562-1.6347656c1.5830078-1.9160156,1.3125-4.7524414-0.6044922-6.3349609 l-6.1897583-5.1117554c1.6690063-2.0933228,3.1382446-4.319458,4.3961792-6.6782227l9.4644775,3.2265015 c0.4814453,0.1640625,0.9707031,0.2421875,1.4521484,0.2421875c1.8730469,0,3.6210938-1.1782227,4.2597656-3.0493164 c0.8017578-2.3525391-0.4550781-4.909668-2.8076172-5.7114258l-8.9893188-3.0645142 c0.6224976-2.1658936,1.09198-4.4221802,1.399353-6.7709351l12.2686768-0.7646484 c2.4804688-0.1542969,4.3652344-2.2905273,4.2109375-4.7709961 C302.1357422,176.4638672,300.0263672,174.5727539,297.5195312,174.7324219z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M204.0471954,180.5730591c2.3025818,0,3.6375275,2.2151337,2.2914124,3.8022461l-4.6143188,5.3463898 c-1.1341095,1.2987366-3.424881,1.2919159-4.5482483-0.0135498l-4.5774536-5.3194733 c-1.3641815-1.5853271-0.0314941-3.8156128,2.2799988-3.8156128H204.0471954z" })
				);
			}
		}]);
	
		return Head0;
	}(HeadHOC);
	
	var Head1 = function (_HeadHOC2) {
		_inherits(Head1, _HeadHOC2);
	
		function Head1() {
			_classCallCheck(this, Head1);
	
			return _possibleConstructorReturn(this, (Head1.__proto__ || Object.getPrototypeOf(Head1)).apply(this, arguments));
		}
	
		_createClass(Head1, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "198.3777466", cy: "115.3500366" }),
					_react2.default.createElement("path", { className: "fill", d: "M306.0224609,194.3149414l-10.5822754-3.607666c-0.0405273-2.0932617-0.2005005-4.2236328-0.4882812-6.3847656 l9.7492676-0.607666c2.4804688-0.1542969,4.3652344-2.2905273,4.2109375-4.7709961s-2.2724609-4.3725586-4.7714844-4.2114258 l-11.0126343,0.6862793c-1.5087891-5.5307617-3.7248535-11.1491699-6.5653076-16.6948242 c-1.3328857-24.520752-6.2202759-58.1230469-12.6188965-73.6657715 c-2.0126953-6.4116211-10.1627808-10.1657715-15.6678467-5.7922363h-0.000061 c-10.6514282,6.1594238-23.7930298,16.1567383-34.1798706,25.7751465 c-7.9381104-2.4560547-16.2775879-3.8312988-24.8834839-3.8312988c-8.5559692,0-16.848877,1.3588867-24.7456055,3.7883301 c-10.3796387-9.6054688-23.4979248-19.5820312-34.1333618-25.7321777l0,0 c-5.5050659-4.3735352-13.6551514-0.6193848-15.6679077,5.7922363 c-6.3637695,15.458252-11.2327271,48.7800293-12.5968018,73.2648926c-2.968689,5.7312012-5.2705688,11.5449219-6.8161621,17.2626953 l-13.6911621-0.8532715c-2.5117188-0.1591797-4.6181641,1.7314453-4.7714844,4.2114258 c-0.1542969,2.4804688,1.7304688,4.6166992,4.2109375,4.7709961l12.4507446,0.7758789 c-0.2322998,1.7822266-0.3815918,3.5444336-0.4459839,5.28125l-13.3260498,4.5429688 c-2.3525391,0.8017578-3.609375,3.3588867-2.8076172,5.7114258c0.6386719,1.8710938,2.3867188,3.0493164,4.2597656,3.0493164 c0.4814453,0,0.9707031-0.078125,1.4521484-0.2421875l10.9870605-3.7456055 c0.3132324,1.8291016,0.7437134,3.5622559,1.2938232,5.1989746l-8.6090088,7.1101074 c-1.9169922,1.5825195-2.1875,4.4189453-0.6044922,6.3354492c0.8896484,1.0771484,2.1757812,1.6342773,3.4726562,1.6342773 c1.0087891,0,2.0244141-0.3378906,2.8623047-1.0302734l7.107666-5.8701172 c13.6983032,18.6286621,48.8760376,20.2828369,90.1185303,20.2828369c40.2109375,0,74.6560669-1.572876,89.0502319-18.9168701 l5.4540405,4.5041504c0.8388672,0.6928711,1.8535156,1.0302734,2.8623047,1.0302734 c1.296875,0,2.5830078-0.5571289,3.4726562-1.6347656c1.5830078-1.9160156,1.3125-4.7524414-0.6044922-6.3349609 l-6.5224609-5.3864746c0.7577515-1.8815918,1.3534546-3.8933105,1.7750244-6.046875l8.418335,2.869873 c0.4814453,0.1640625,0.9707031,0.2421875,1.4521484,0.2421875c1.8730469,0,3.6210938-1.1782227,4.2597656-3.0493164 C309.6318359,197.6738281,308.375,195.1166992,306.0224609,194.3149414z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M204.0471954,180.5730591c2.3025818,0,3.6375275,2.2151337,2.2914124,3.8022461l-4.6143188,5.3463898 c-1.1341095,1.2987366-3.424881,1.2919159-4.5482483-0.0135498l-4.5774536-5.3194733 c-1.3641815-1.5853271-0.0314941-3.8156128,2.2799988-3.8156128H204.0471954z" }),
					"  "
				);
			}
		}]);
	
		return Head1;
	}(HeadHOC);
	
	function Heads(props) {
		var heads = {
			Head0: Head0,
			Head1: Head1
		};
	
		var propHead = 'Head' + props.head;
	
		var Head = heads[propHead];
	
		return _react2.default.createElement(Head, props);
	}
	
	exports.default = Heads;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Athlete() {
		return _react2.default.createElement(
			"g",
			{ className: "whole-kitten" },
			_react2.default.createElement("path", { className: "fill", d: "M86.37976,312.95044l-0.17279-0.19922c-3.35883-3.87476-6.70862-7.61133-9.89288-11.40942 c-3.19226-3.78418-6.23688-7.60327-9.02557-11.46582c-2.79706-3.85864-5.24622-7.79932-7.55267-11.58081 c-2.34674-3.7959-4.34619-7.43359-6.55792-11.14941l-0.98932-1.66333c-1.58508-2.62061-4.38647-4.44678-7.67474-4.65186 c-5.32825-0.33228-9.91705,3.71777-10.24927,9.04614c-0.10577,1.69629-0.1568,3.47046-0.02307,5.15894 c0.07556,0.83887,0.18115,1.67676,0.28687,2.51978l0.18176,1.26099l0.25769,1.21118 c0.36792,1.60742,0.74146,3.25537,1.28992,4.76343l0.80396,2.30298c0.2807,0.76562,0.61896,1.47144,0.92914,2.21094 c2.5849,5.85083,6.13336,10.95166,9.96106,15.61646c3.84698,4.65967,8.08356,8.85181,12.62701,12.60352 c4.55652,3.73413,9.40808,7.05786,14.65399,9.71265c3.24536,1.63794,7.3009,1.26709,10.21777-1.26147 C89.30414,322.63574,89.72009,316.80396,86.37976,312.95044z" }),
			_react2.default.createElement("path", { className: "fill", d: "M95.125,305.4502c-6.70898-3.8418-15.26367-1.521-19.10645,5.18896 c-15.58203,27.19971-13.30371,54.44482-13.19922,55.59131c0.66406,7.27002,6.77539,12.76709,13.9375,12.76709 c0.42285,0,0.85059-0.01953,1.28027-0.05859c7.7002-0.70264,13.37598-7.47559,12.67383-15.17529 c-0.01562-0.19727-1.44336-19.92383,9.60254-39.20654C104.15723,317.84814,101.83398,309.29395,95.125,305.4502z" }),
			_react2.default.createElement("circle", { fill: "#FFFFFF", cx: "129.79105", cy: "368.02069", r: "42.02801" }),
			_react2.default.createElement("path", { fill: "#444444", d: "M90.18262,353.98975l8.25092,2.24316c1.46826,0.39941,3.02649-0.19287,3.85895-1.46655l6.17859-9.45337 c0.83124-1.27173,0.74988-2.93408-0.2016-4.11841l-4.78375-5.95532C97.34723,340.16699,92.77222,346.69653,90.18262,353.98975z" }),
			_react2.default.createElement("path", { fill: "#444444", d: "M160.80127,377.20044c-1.29529-0.79858-2.95764-0.67163-4.11658,0.3147l-8.59381,7.31274 c-1.15784,0.98535-1.54974,2.604-0.97083,4.00977l4.30249,10.44751c0.57886,1.40576,1.99683,2.27905,3.51263,2.16333 l0.36908-0.02808c6.4314-4.91309,11.23639-11.5481,13.96094-19.00244L160.80127,377.20044z" }),
			_react2.default.createElement("path", { fill: "#444444", d: "M108.45042,375.21481l-2.25952,11.05212c-0.30476,1.49069,0.38563,3.00803,1.70972,3.75757l9.82795,5.56345 c1.32216,0.74847,2.97576,0.56131,4.09719-0.46371l8.33385-7.61746c1.1232-1.02664,1.45694-2.6601,0.82646-4.04504 l-4.67522-10.26999c-0.6299-1.3837-2.07899-2.20456-3.58965-2.03342l-11.22704,1.27185 C109.98362,372.60132,108.75493,373.7254,108.45042,375.21481z" }),
			_react2.default.createElement("path", { className: "fill", d: "M175.02155,322.90942c-5.35455-15.41016-21.60034-28.6958-45.11115-32.26245 c-28.92615-4.38818-53.79346,2.18701-58.45129,31.92725c-3.30493,21.10205,7.64349,41.68408,17.75177,35.19043 c23.48816-15.08887,37.19098-2.5708,38.84821,2.38965c0.03284,0.09839,0.08759,0.19385,0.15271,0.28735 c0.34705,1.19409,0.6673,2.44604,0.95032,3.76636c1.80664,8.43262,1.60938,16.16357,1.6084,16.20459 c-0.26172,7.72754,5.79102,14.2041,13.51855,14.46582c0.16113,0.00537,0.32227,0.00781,0.48242,0.00781 c7.5127,0,13.72754-5.96045,13.9834-13.52637c0.06897-2.04443,0.21838-11.32007-2.01526-22.1438 c3.05389-1.1106,6.01385-2.53613,8.68665-4.32153c0.83649,2.15137,1.55951,4.60327,2.14014,7.31201 c1.80664,8.43262,1.60938,16.16357,1.6084,16.20459c-0.26172,7.72754,5.79102,14.2041,13.51855,14.46582 c0.16113,0.00537,0.32227,0.00781,0.48242,0.00781c7.5127,0,13.72754-5.96045,13.9834-13.52637 C197.30566,375.01611,197.83411,338.09668,175.02155,322.90942z" }),
			_react2.default.createElement(
				"g",
				{ className: "kitten-head" },
				_react2.default.createElement("path", { className: "fill", d: "M168.68333,337.54971c-18.85588,0-32.76048-4.00308-42.84023-12.7121l-4.28545,3.53915 c-0.5339,0.44098-1.17966,0.6557-1.82171,0.6557c-0.82539,0-1.64394-0.35458-2.21016-1.04044 c-1.0075-1.21945-0.83533-3.02466,0.38473-4.03186l3.93945-3.25336c-1.06223-1.33231-1.99733-2.74911-2.79794-4.25034 l-6.02364,2.0535c-0.30641,0.1044-0.6178,0.15414-0.92421,0.15414c-1.1921,0-2.30464-0.74988-2.71112-1.94073 c-0.51028-1.49728,0.28963-3.12476,1.7869-3.63504l5.72122-1.95038c-0.39619-1.37848-0.69498-2.81448-0.89061-4.30936 l-7.80836-0.48666c-1.57869-0.09818-2.77824-1.45779-2.68004-3.03647c0.09882-1.57837,1.44133-2.78198,3.0368-2.68036 l7.10809,0.44299l0.00502-0.00055c0.45473-15.71692,3.75923-40.26196,8.20982-51.073 c1.28098-4.08058,6.46808-6.46991,9.97176-3.68639l0.00005,0.00005c6.71089,3.88072,14.97615,10.1553,21.5551,16.22003 c5.07867-1.45221,7.6996-2.25397,13.27454-2.25397s8.19586,0.80176,13.27454,2.25397 c6.57893-6.06473,14.84421-12.33931,21.5551-16.22003l0.00005-0.00005c3.50368-2.78352,8.69078-0.3942,9.97176,3.68639 c4.45059,10.81104,7.7551,35.35608,8.20982,51.073l0.00502,0.00055l7.10809-0.44299 c1.59547-0.10162,2.93797,1.10199,3.03679,2.68036c0.09821,1.57867-1.10135,2.93829-2.68004,3.03647l-7.80836,0.48666 c-0.19562,1.49487-0.49442,2.93088-0.89061,4.30936l5.72122,1.95038c1.49727,0.51028,2.29718,2.13776,1.78691,3.63504 c-0.40648,1.19086-1.51903,1.94073-2.71112,1.94073c-0.30641,0-0.6178-0.04974-0.92421-0.15414l-6.02365-2.0535 c-0.8006,1.50122-1.73569,2.91803-2.79793,4.25034l3.93945,3.25336c1.22006,1.0072,1.39223,2.81241,0.38472,4.03186 c-0.56621,0.68585-1.38477,1.04044-2.21016,1.04044c-0.64204,0-1.28781-0.21472-1.8217-0.6557l-4.28545-3.53915 C201.44382,333.54663,187.5392,337.54971,168.68333,337.54971z" }),
				_react2.default.createElement("path", { className: "fill--face", d: "M168.66982,312.67004h2.6465c1.32248,0,2.0892,1.27228,1.31607,2.18381l-1.05519,1.24414l-1.59502,1.82654 c-0.65138,0.74594-1.96707,0.742-2.61227-0.00778l-1.60745-1.86801l-1.02159-1.18719 c-0.78351-0.91052-0.01808-2.1915,1.30951-2.1915H168.66982z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M224.91731,293.22098c-0.06631-0.87-0.13861-1.75095-0.21671-2.64038 c-0.20934-2.38373-0.46042-4.82812-0.75015-7.28439c-0.06006-0.50916-0.12178-1.01883-0.18513-1.52859 c-0.31737-2.55359-2.15582-4.65421-4.63823-5.33182c-7.90233-2.15707-26.59837-6.45334-50.28088-6.49539 c-23.72006-0.04208-42.5677,4.20309-50.5057,6.32721c-2.47972,0.66354-4.31685,2.76419-4.64294,5.31036 c-0.39719,3.10147-0.89116,7.98312-1.24216,11.45877c-0.19562,1.93707,1.67315,3.42987,3.5194,2.81192l4.36175-1.45987 c0.19457-0.06497,19.77267-6.50598,48.47771-6.45502c28.46722,0.05051,48.06158,6.55814,48.2413,6.61877 c0,0,2.23503,0.73209,4.36069,1.42004C223.23039,296.55975,225.06224,295.12222,224.91731,293.22098z" }),
				_react2.default.createElement("path", { fill: "#A5C6EF", d: "M223.95667,283.40454c-2.95366-0.87698-9.25761-2.6145-17.8262-4.22183 c-9.9236-1.86151-22.89537-3.55814-37.29051-3.58426c-28.03358-0.05161-50.13645,6.04477-55.34642,7.62051l-0.02987,0.26688 l-0.15609,1.42383l-0.52802,4.96671c2.92638-0.91428,26.59881-8.16934,56.23537-8.10971 c29.51776,0.04749,52.62669,7.14728,55.62238,8.12296L223.95667,283.40454z" }),
				_react2.default.createElement(
					"g",
					{ className: "kitten-eyes" },
					_react2.default.createElement("ellipse", { className: "fill--eyes", transform: "matrix(0.98481 -0.17365 0.17365 0.98481 -49.47593 37.28986)", cx: "188.37454", cy: "301.40118", rx: "5.28059", ry: "5.86732" }),
					_react2.default.createElement("ellipse", { className: "fill--eyes", transform: "matrix(0.17365 -0.98481 0.98481 0.17365 -173.7023 395.79202)", cx: "148.99213", cy: "301.40118", rx: "5.86732", ry: "5.28059" })
				),
				_react2.default.createElement(
					"g",
					{ className: "kitten-eyes--blink" },
					_react2.default.createElement("path", { className: "fill--face", d: "M152.99779,305.17029c-0.09863,0-0.19824-0.00977-0.29883-0.03027l-8.625-1.74072 c-0.81152-0.16357-1.33691-0.95508-1.17383-1.76709c0.16406-0.8125,0.9541-1.33838,1.76758-1.17334l8.625,1.74072 c0.81152,0.16357,1.33691,0.95508,1.17383,1.76709C154.32298,304.67859,153.69701,305.17029,152.99779,305.17029z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M184.36888,305.17029c-0.69922,0-1.3252-0.4917-1.46875-1.20361c-0.16309-0.81201,0.3623-1.60352,1.17383-1.76709 l8.625-1.74072c0.81152-0.16455,1.60352,0.36084,1.76758,1.17334c0.16309,0.81201-0.3623,1.60352-1.17383,1.76709l-8.625,1.74072 C184.56712,305.16052,184.46751,305.17029,184.36888,305.17029z" })
				)
			)
		);
	}
	
	exports.default = Athlete;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Birthday() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill", d: "M142.42114,312.61017c-0.87799-11.53955-5.45447-21.00293-15.22125-27.44092 c-8.62164-5.68359-19.56061-6.81152-29.50745-5.02979c-5.71912,1.0249-10.78162,3.24805-15.09271,6.34277 c-12.18713,1.11865-25.92798,8.09473-37.10339,19.99414c-11.51434,12.26025-17.2074,24.17822-17.55133,36.90088 c-0.01562,0.57812-0.00568,1.13135,0.00043,1.68848c-0.03101,0.00635-0.06152,0.00977-0.09259,0.01611 c-4.10327,0.64551-8.37146,2.13184-12.33771,4.68506c-3.94476,2.55225-7.52991,6.23193-9.94647,10.75244 c-1.24146,2.23682-2.11365,4.70312-2.72864,7.22949c-0.51196,2.54736-0.82684,5.17188-0.64026,7.7832 c0.25824,5.22217,1.97174,10.35693,4.77057,14.58154c2.79041,4.24463,6.56683,7.56982,10.57574,9.83154 c4.02716,2.26758,8.25568,3.52246,12.32355,4.07373c4.07001,0.49365,7.9798,0.271,11.66309-0.50293 c3.17053-0.67578,5.94934-2.92529,7.13416-6.19824c1.82599-5.04297-0.78217-10.61182-5.82538-12.4375l-1.30878-0.47412 c-2.43604-0.88184-4.64984-1.61182-6.56244-2.46191c-1.88092-0.87646-3.44714-1.80664-4.63684-2.74854 c-1.20172-0.93213-2.02875-1.8501-2.62024-2.71484c-0.63745-0.8501-0.90387-1.729-1.06903-2.60352 c-0.09888-0.44385-0.07086-0.88574-0.09052-1.35352c0.09674-0.4458,0.09998-0.9375,0.2934-1.41162 c0.31409-0.96045,0.8728-2.0166,1.88708-3.04932c0.99353-1.05225,2.4574-2.02686,4.2829-2.86865 c0.54266-0.23828,1.12292-0.45947,1.72137-0.67188c7.1319,7.94434,17.81757,9.47217,21.64972,9.47217 c0,0,7.35437,0.01416,10.10431,0.01416c5.81836,0,16.46539,0.75098,20.27429-6.375c0.4527,0.66113,0.95374,1.28662,1.51013,1.85938 c2.56122,2.63672,6.15015,4.2666,10.11627,4.24658c7.73157-0.04004,13.96692-6.34082,13.927-14.07227l-0.05206-10.03467 c1.00726-0.49512,1.78455-0.98242,2.24506-1.45459v11.31641c0,7.73193,6.26758,14,14,14s14-6.26807,14-14v-42.7793 C142.51312,316.22589,142.48792,313.4881,142.42114,312.61017z" }),
			_react2.default.createElement(
				"g",
				{ className: "birthday-head-blowing" },
				_react2.default.createElement("path", { className: "fill", d: "M115.93775,300.74515c-18.85587,0-32.76049-4.00308-42.84023-12.7121l-4.28545,3.53915 c-0.5339,0.44098-1.17966,0.65573-1.82171,0.65573c-0.82539,0-1.64394-0.35458-2.21016-1.04044 c-1.0075-1.21945-0.83534-3.02469,0.38473-4.03189l3.93945-3.25336c-1.06223-1.33228-1.99733-2.74911-2.79794-4.25034 l-6.02364,2.0535c-0.30642,0.10443-0.6178,0.15414-0.92422,0.15414c-1.19209,0-2.30463-0.74988-2.71111-1.94073 c-0.51028-1.49725,0.28963-3.12473,1.7869-3.63501l5.72122-1.95041c-0.39618-1.37848-0.69498-2.81448-0.89061-4.30933 l-7.80836-0.48666c-1.57869-0.09821-2.77824-1.45779-2.68004-3.0365c0.09882-1.57837,1.44133-2.78195,3.0368-2.68036 l7.10809,0.44302l0.00502-0.00055c0.45473-15.71693,3.75923-40.26196,8.20982-51.07303 c1.28098-4.08058,6.46807-6.46989,9.97176-3.68637l0.00004,0.00005c6.7109,3.88071,14.97617,10.15529,21.5551,16.22003 c5.07868-1.45221,7.69961-2.25398,13.27454-2.25398s8.19586,0.80177,13.27454,2.25398 c6.57893-6.06474,14.84419-12.33932,21.5551-16.22003l0.00003-0.00005c3.50369-2.78352,8.69078-0.39421,9.97176,3.68637 c4.45059,10.81107,7.7551,35.35609,8.20982,51.07303l0.00502,0.00055l7.10809-0.44302 c1.59547-0.10159,2.93799,1.10199,3.0368,2.68036c0.09821,1.5787-1.10135,2.93829-2.68004,3.0365l-7.80836,0.48666 c-0.19563,1.49484-0.49443,2.93085-0.89061,4.30933l5.72122,1.95041c1.49727,0.51028,2.29718,2.13776,1.7869,3.63501 c-0.40648,1.19086-1.51901,1.94073-2.71111,1.94073c-0.30643,0-0.61781-0.04971-0.92422-0.15414l-6.02364-2.0535 c-0.80061,1.50122-1.7357,2.91806-2.79794,4.25034l3.93947,3.25336c1.22006,1.0072,1.39223,2.81244,0.38472,4.03189 c-0.56621,0.68585-1.38477,1.04044-2.21016,1.04044c-0.64204,0-1.28781-0.21475-1.8217-0.65573l-4.28546-3.53915 C148.69824,296.74207,134.79362,300.74515,115.93775,300.74515z" }),
				_react2.default.createElement("path", { className: "fill--face", d: "M118.95367,277.86551h-2.64651c-1.32247,0-2.0892,1.27225-1.31606,2.18381l1.0552,1.24411l1.59502,1.82657 c0.65137,0.74591,1.96707,0.742,2.61227-0.00778l1.60746-1.86804l1.02158-1.18719c0.78352-0.91052,0.01809-2.19147-1.30951-2.19147 H118.95367z" }),
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("path", { fill: "#FFFFFF", d: "M140.34941,236.45993c-15.58227,4.98299-32.33105,4.98299-47.90611,0l9.31042-24.05019l1.87946-4.84604 l0.78485-2.03786l11.97472-30.94849l11.98194,30.94128l0.59763,1.54105l1.80016,4.66602L140.34941,236.45993z" }),
					_react2.default.createElement("circle", { fill: "#C8B8F2", cx: "100.0057", cy: "230.13707", r: "2.60962" }),
					_react2.default.createElement("circle", { fill: "#A2D8C0", cx: "109.15717", cy: "221.3112", r: "2.60962" }),
					_react2.default.createElement("circle", { fill: "#F2CC7B", cx: "116.66476", cy: "231.9243", r: "2.60962" }),
					_react2.default.createElement("path", { fill: "#FC7E7E", d: "M105.44055,209.90392c0.07199,1.44014-1.02973,2.66422-2.46987,2.7435 c-0.43202,0.02162-0.84972-0.06487-1.21696-0.23767l1.87946-4.84604C104.634,207.88049,105.38289,208.78778,105.44055,209.90392z"
					}),
					_react2.default.createElement("circle", { fill: "#C8B8F2", cx: "110.07026", cy: "199.29672", r: "2.60962" }),
					_react2.default.createElement("circle", { fill: "#F2CC7B", cx: "116.93905", cy: "210.54861", r: "2.60962" }),
					_react2.default.createElement("circle", { fill: "#FC7E7E", cx: "124.59482", cy: "221.14621", r: "2.60962" }),
					_react2.default.createElement("path", { fill: "#A2D8C0", d: "M130.77248,211.72571c-0.02882,0.00722-0.05757,0.00722-0.0864,0.00722 c-1.44014,0.0719-2.66422-1.02965-2.74342-2.46979c-0.04324-0.89305,0.36724-1.70665,1.02966-2.20345L130.77248,211.72571z" }),
					_react2.default.createElement("circle", { fill: "#C8B8F2", cx: "133.43617", cy: "229.80708", r: "2.60962" }),
					_react2.default.createElement("circle", { fill: "#FC7E7E", cx: "122.95272", cy: "199.13173", r: "2.60962" }),
					_react2.default.createElement("circle", { fill: "#A2D8C0", cx: "116.6869", cy: "187.82367", r: "2.60962" })
				),
				_react2.default.createElement(
					"g",
					{ className: "birthday-eyes--blow" },
					_react2.default.createElement("path", { className: "fill--face", d: "M103.40948,269.96829c-0.09863,0-0.19824-0.00977-0.29883-0.03027l-8.625-1.74072 c-0.81152-0.16357-1.33691-0.95508-1.17383-1.76709c0.16406-0.8125,0.9541-1.33838,1.76758-1.17334l8.625,1.74072 c0.81152,0.16357,1.33691,0.95508,1.17383,1.76709C104.73467,269.47659,104.1087,269.96829,103.40948,269.96829z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M134.31689,269.96829c-0.69922,0-1.3252-0.4917-1.46875-1.20361c-0.16309-0.81201,0.3623-1.60352,1.17383-1.76709 l8.625-1.74072c0.81152-0.16455,1.60352,0.36084,1.76758,1.17334c0.16309,0.81201-0.3623,1.60352-1.17383,1.76709l-8.625,1.74072 C134.51514,269.95853,134.41553,269.96829,134.31689,269.96829z" })
				),
				_react2.default.createElement(
					"g",
					{ className: "birthday-eyes" },
					_react2.default.createElement(
						"g",
						{ className: "kitten-eyes" },
						_react2.default.createElement("ellipse", { className: "fill--eyes", transform: "matrix(0.17365 -0.98481 0.98481 0.17365 -180.53188 318.04373)", cx: "99.24895", cy: "266.59662", rx: "5.86732", ry: "5.28059" }),
						_react2.default.createElement("ellipse", { className: "fill--eyes", transform: "matrix(0.98481 -0.17365 0.17365 0.98481 -44.1879 28.12328)", cx: "138.63135", cy: "266.59662", rx: "5.28059", ry: "5.86732" })
					),
					_react2.default.createElement(
						"g",
						{ className: "kitten-eyes--blink" },
						_react2.default.createElement("path", { className: "fill--face", d: "M103.40948,269.96829c-0.09863,0-0.19824-0.00977-0.29883-0.03027l-8.625-1.74072 c-0.81152-0.16357-1.33691-0.95508-1.17383-1.76709c0.16406-0.8125,0.9541-1.33838,1.76758-1.17334l8.625,1.74072 c0.81152,0.16357,1.33691,0.95508,1.17383,1.76709C104.73467,269.47659,104.1087,269.96829,103.40948,269.96829z" }),
						_react2.default.createElement("path", { className: "fill--face", d: "M134.31689,269.96829c-0.69922,0-1.3252-0.4917-1.46875-1.20361c-0.16309-0.81201,0.3623-1.60352,1.17383-1.76709 l8.625-1.74072c0.81152-0.16455,1.60352,0.36084,1.76758,1.17334c0.16309,0.81201-0.3623,1.60352-1.17383,1.76709l-8.625,1.74072 C134.51514,269.95853,134.41553,269.96829,134.31689,269.96829z" })
					)
				)
			),
			_react2.default.createElement(
				"g",
				{ className: "candle-blow" },
				_react2.default.createElement("circle", { className: "candle-glow-1", opacity: "0.2", fill: "#FFEAAE", cx: "187.70528", cy: "285.67859", r: "30.39661" }),
				_react2.default.createElement("circle", { className: "candle-glow-2", opacity: "0.2", fill: "#FFEAAE", cx: "187.70528", cy: "285.67859", r: "30.39661" })
			),
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { fill: "#FFEAAE", d: "M161.0144,366.55817c-3.23416-13.16168-3.10561-25.93146,0.21358-39.08136l72.2132,13.05627 c0,0-0.10126,39.09985-0.5773,39.01431L161.0144,366.55817z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M160.03949,327.13174c8.83333-9.3699,26.00291-15.04514,39.38206-14.8898l35.06902,28.29114 L160.03949,327.13174z" }),
				_react2.default.createElement("path", { fill: "#F8FAFF", d: "M158.96184,332.00317l75.83931,13.82837c0.49878-1.76868,0.24101-3.69891-0.3105-5.29846 l-74.45117-13.40131C159.62956,328.75549,159.27165,330.37927,158.96184,332.00317z" }),
				_react2.default.createElement("path", { fill: "#F8FAFF", d: "M158.69353,353.59875l0.01953-0.22705c0.18359-2.14844,0.38623-3.61523,0.60156-5.16846 c0.15039-1.08545,0.30908-2.23193,0.47607-3.7124l0.03027-0.26562l74.88623,13.4585l0.02979,0.17236 c-0.32788,2.89172-0.32837,5.94293-0.00049,9.1543l-0.04346,0.24707L158.69353,353.59875z" }),
				_react2.default.createElement("path", { fill: "#F8FAFF", d: "M164.94548,328.01331c-0.60107-0.10797-4.90601-0.88153-4.90601-0.88153 c-3.36084,13.31488-3.35791,26.63593,0,39.96295l5.41455,0.97296l-0.53467-1.94989 c-3.18018-12.62158-3.18018-25.40918-0.01562-37.94922L164.94548,328.01331z" }),
				_react2.default.createElement("path", { fill: "#FFEAAE", d: "M164.91936,366.1178l0.53467,1.94989l68.15854,12.3118c0.43312,0.07782,0.85277-0.2178,0.91466-0.65347 c0.56615-3.98511,0.99075-8.07504,0.41356-12.29294c-0.03221-0.23547-0.21497-0.42578-0.44891-0.46783L162.8571,354.0932 C163.22673,358.10925,163.91252,362.12189,164.91936,366.1178z" }),
				_react2.default.createElement("path", { fill: "#FFEAAE", d: "M163.86491,332.88422c-0.7561,4.01398-1.1875,8.04791-1.2998,12.08826l71.76749,12.89584 c0.30229,0.05432,0.59544-0.1521,0.64229-0.45566c0.5731-3.71353,0.56911-7.44281,0.00224-11.18747 c-0.05234-0.34573-0.32419-0.62112-0.66835-0.68298L163.86491,332.88422z" }),
				_react2.default.createElement("path", { fill: "#A2D8C0", d: "M182.32872,338.13672c-0.96387,0-1.74805,0.78369-1.74805,1.74707s0.78418,1.74756,1.74805,1.74756 c0.96289,0,1.74707-0.78418,1.74707-1.74756S183.29161,338.13672,182.32872,338.13672z" }),
				_react2.default.createElement("path", { fill: "#A2D8C0", d: "M214.36388,343.85107c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74707,1.74707,1.74707 c0.96387,0,1.74805-0.78369,1.74805-1.74707S215.32774,343.85107,214.36388,343.85107z" }),
				_react2.default.createElement("path", { fill: "#A2D8C0", d: "M225.34923,368.47998c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74707,1.74707,1.74707 c0.96387,0,1.74805-0.78369,1.74805-1.74707S226.3131,368.47998,225.34923,368.47998z" }),
				_react2.default.createElement("path", { fill: "#A2D8C0", d: "M197.48888,367.479c-0.96387,0-1.74805,0.78418-1.74805,1.74756s0.78418,1.74707,1.74805,1.74707 c0.96289,0,1.74707-0.78369,1.74707-1.74707S198.45177,367.479,197.48888,367.479z" }),
				_react2.default.createElement("circle", { fill: "#A2D8C0", cx: "191.60411", cy: "363.30859", r: "1.74707" }),
				_react2.default.createElement("circle", { fill: "#A2D8C0", cx: "175.29356", cy: "360.89502", r: "1.74707" }),
				_react2.default.createElement("circle", { fill: "#FC7E7E", cx: "175.41759", cy: "342.51709", r: "1.74707" }),
				_react2.default.createElement("path", { fill: "#FC7E7E", d: "M202.27794,341.77051c-0.96289,0-1.74707,0.78418-1.74707,1.74756s0.78418,1.74707,1.74707,1.74707 s1.74707-0.78369,1.74707-1.74707S203.24083,341.77051,202.27794,341.77051z" }),
				_react2.default.createElement("path", { fill: "#FC7E7E", d: "M222.4713,350.10205c-0.96289,0-1.74707,0.78369-1.74707,1.74707 c0,0.96341,0.78418,1.74756,1.74707,1.74756s1.74707-0.78415,1.74707-1.74756 C224.21837,350.88574,223.43419,350.10205,222.4713,350.10205z" }),
				_react2.default.createElement("path", { fill: "#FC7E7E", d: "M217.4381,370.1123c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74707,1.74707,1.74707 c0.96387,0,1.74805-0.78369,1.74805-1.74707S218.40196,370.1123,217.4381,370.1123z" }),
				_react2.default.createElement("path", { fill: "#FC7E7E", d: "M185.40196,365.39893c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756 c0.96387,0,1.74805-0.78418,1.74805-1.74756S186.36583,365.39893,185.40196,365.39893z" }),
				_react2.default.createElement("path", { fill: "#C8B8F2", d: "M168.25548,335.88867c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756 s1.74707-0.78418,1.74707-1.74756S169.21837,335.88867,168.25548,335.88867z" }),
				_react2.default.createElement("path", { fill: "#C8B8F2", d: "M190.45079,343.52588c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756 s1.74707-0.78418,1.74707-1.74756S191.41368,343.52588,190.45079,343.52588z" }),
				_react2.default.createElement("circle", { fill: "#C8B8F2", cx: "208.1627", cy: "349.43555", r: "1.74707" }),
				_react2.default.createElement("circle", { fill: "#C8B8F2", cx: "231.51134", cy: "349.29053", r: "1.74707" }),
				_react2.default.createElement("path", { fill: "#C8B8F2", d: "M231.51134,373.36084c-0.96289,0-1.74707,0.78418-1.74707,1.74756s0.78418,1.74707,1.74707,1.74707 s1.74707-0.78369,1.74707-1.74707S232.47423,373.36084,231.51134,373.36084z" }),
				_react2.default.createElement("circle", { fill: "#C8B8F2", cx: "209.31602", cy: "367.47119", r: "1.74707" }),
				_react2.default.createElement("path", { fill: "#C8B8F2", d: "M168.25548,361.70654c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756 s1.74707-0.78418,1.74707-1.74756S169.21837,361.70654,168.25548,361.70654z" }),
				_react2.default.createElement("path", { fill: "none", d: "M184.49968,317.18042c0.00195,0.00854,0.00562,0.0177,0.00781,0.02625 C184.50529,317.19812,184.50163,317.1889,184.49968,317.18042z" }),
				_react2.default.createElement("path", { fill: "none", d: "M184.65251,317.64905c0.00366,0.00879,0.0083,0.01782,0.01196,0.02655 C184.66081,317.66687,184.65617,317.65778,184.65251,317.64905z" }),
				_react2.default.createElement("path", { fill: "#B4EDD2", d: "M184.44621,316.75659v0.01074c0,0.12915,0.02051,0.26843,0.05347,0.41309 C184.46501,317.03143,184.44621,316.88934,184.44621,316.75659z" }),
				_react2.default.createElement("path", { fill: "#B4EDD2", d: "M184.50749,317.20667c0.03369,0.14166,0.08325,0.28961,0.14502,0.44238 C184.59001,317.49615,184.54192,317.34851,184.50749,317.20667z" }),
				_react2.default.createElement("path", { fill: "#B4EDD2", d: "M183.57674,295.68884h-0.01315v26.36365c0,0.00226,0,0.00916,0,0.01025 c0,0.00305,0.0025,0.00586,0.0025,0.00885c0.0144,0.73932,1.80632,1.3374,4.01808,1.3374 c1.90016,0,3.48375-0.44305,3.90295-1.03668c0.0025-0.00348,0.00688-0.00659,0.00938-0.01007 c0.06569-0.09662,0.1076-0.19623,0.1076-0.2995v-26.3739H183.57674z" }),
				_react2.default.createElement("ellipse", { fill: "#B4EDD2", cx: "187.58385", cy: "295.68884", rx: "4.02027", ry: "1.34625" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M188.74142,295.66122c0,0,0.00082,0.20026-1.15735,0.20026s-1.15817-0.20026-1.15817-0.20026v-4.18814 c0,0,0-0.39059,1.15776-0.39059s1.15776,0.39059,1.15776,0.39059V295.66122z" })
			),
			_react2.default.createElement(
				"g",
				{ className: "candle-blow" },
				_react2.default.createElement(
					"g",
					{ className: "candle" },
					_react2.default.createElement(
						"g",
						{ className: "candle-flip" },
						_react2.default.createElement("path", { fill: "#FFEAAE", d: "M192.05537,287.45261c1.08923,3.66379-2.01562,5.83093-4.47171,5.83093s-4.36938-1.99228-4.44713-4.44714 c-0.20647-6.51965,5.44794-11.45248,5.44794-11.45248C188.02881,282.25012,191.04654,284.05927,192.05537,287.45261z" }),
						_react2.default.createElement("path", { fill: "#FFFFFF", d: "M189.55602,288.21582c0.81915,1.52847-0.36235,2.77548-1.45378,3.00015 c-1.09142,0.22464-2.12387-0.48569-2.38297-1.56946c-0.39775-1.66382,0.12328-3.27118,0.63377-4.33136 c0.21216-0.44058,0.85645-0.43362,1.05045,0.01523C187.93323,286.55603,188.96869,287.1199,189.55602,288.21582z" })
					)
				)
			),
			_react2.default.createElement(
				"g",
				{ className: "candle-smoke-1" },
				_react2.default.createElement("path", { opacity: "0.4", fill: "#EFEFEF", d: "M187.58366,289.29276c0.39908,0,0.79973-0.14587,1.11374-0.4404 c0.65584-0.61493,0.68922-1.64517,0.07393-2.30103c-0.02464-0.02661-2.76804-3.0264-2.55896-6.26425 c0.10175-1.58716,0.89114-2.97513,2.41348-4.2435c2.22191-1.85184,3.42627-4.05905,3.58049-6.56079 c0.28619-4.64969-3.28317-8.51318-3.43501-8.67535c-0.6145-0.65625-1.64555-0.68964-2.30141-0.07434 c-0.65425,0.61371-0.68843,1.6416-0.0771,2.29782l0,0c0.02782,0.02982,2.77122,3.0296,2.56215,6.26746 c-0.10176,1.58713-0.89114,2.97513-2.4135,4.24347c-2.22191,1.85187-3.42627,4.05905-3.58049,6.56079 c-0.28618,4.64972,3.28317,8.51321,3.43501,8.67538C186.71637,289.11984,187.14963,289.29276,187.58366,289.29276z" })
			),
			_react2.default.createElement(
				"g",
				{ className: "candle-smoke-2" },
				_react2.default.createElement("path", { opacity: "0.4", fill: "#EFEFEF", d: "M187.60092,289.29276c-0.39908,0-0.79973-0.14587-1.11374-0.44043 c-0.65584-0.6149-0.68922-1.64514-0.07393-2.30099c0.02464-0.02664,2.76804-3.0264,2.55896-6.26428 c-0.10175-1.58713-0.89114-2.97513-2.41348-4.24347c-2.22191-1.85147-3.42627-4.05865-3.58049-6.56039 c-0.28619-4.64972,3.28317-8.51361,3.43501-8.67578c0.6145-0.65662,1.64555-0.68921,2.30141-0.07431 c0.65504,0.61411,0.68922,1.64197,0.0771,2.29822c-0.04134,0.04453-2.77043,3.03754-2.56215,6.26746 c0.10176,1.58673,0.89114,2.97473,2.4135,4.24307c2.22191,1.85187,3.42627,4.05905,3.58049,6.56079 c0.28618,4.64972-3.28319,8.51321-3.43501,8.67538C188.46822,289.11984,188.03496,289.29276,187.60092,289.29276z" })
			)
		);
	}
	
	exports.default = Birthday;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Bonsai() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill", d: "M123.59,327.57c-.06-27.07-9.09-37.25-28.76-37.21s-40.56,20.17-40.5,47.24,8.34,50.73,38.44,50.8c21.36,0,33-8,35.26-25.83S123.59,327.57,123.59,327.57Z", fill: "#f1f1f1" }),
			_react2.default.createElement("path", { className: "fill", d: "M98.8,310.45c-18.86,0-32.76-4-42.84-12.71l-4.29,3.54A2.86,2.86,0,1,1,48,296.86L52,293.61a27.77,27.77,0,0,1-2.8-4.25l-6,2.05A2.86,2.86,0,1,1,41.3,286L47,284a29.38,29.38,0,0,1-.89-4.31l-7.81-.49a2.86,2.86,0,0,1,.36-5.72l7.11.44h0c.45-15.72,3.76-40.26,8.21-51.07,1.28-4.08,6.47-6.47,10-3.69h0a133.15,133.15,0,0,1,21.56,16.22c5.08-1.45,7.7-2.25,13.27-2.25s8.2.8,13.27,2.25a133.15,133.15,0,0,1,21.56-16.22h0c3.5-2.78,8.69-.39,10,3.69,4.45,10.81,7.76,35.36,8.21,51.07h0l7.11-.44a2.86,2.86,0,0,1,.36,5.72l-7.81.49a29.38,29.38,0,0,1-.89,4.31l5.72,2a2.86,2.86,0,1,1-1.85,5.42l-6-2.05a27.77,27.77,0,0,1-2.8,4.25l3.94,3.25a2.86,2.86,0,1,1-3.65,4.42l-4.29-3.54C131.56,306.45,117.66,310.45,98.8,310.45Z", fill: "#f1f1f1" }),
			_react2.default.createElement("path", { className: "fill", d: "M71.16,370.35l-.25-.09c-4.8-1.79-9.53-3.47-14.15-5.28s-9.12-3.69-13.41-5.75S35,354.9,31.18,352.68s-7.37-4.45-11.1-6.65l-1.67-1A9.67,9.67,0,0,0,4.78,357.49,37.07,37.07,0,0,0,7.23,362c.47.7,1,1.39,1.46,2.07l.76,1,.81.94a40.59,40.59,0,0,0,3.41,3.56l1.81,1.64c.61.54,1.25,1,1.87,1.5a68.16,68.16,0,0,0,16.22,8.94,93.71,93.71,0,0,0,17.12,5,80.7,80.7,0,0,0,17.52,1.51,9.23,9.23,0,0,0,2.95-17.88Z", fill: "#f1f1f1" }),
			_react2.default.createElement("circle", { cx: "69.56", cy: "276.3", fill: "#efefef", r: "1.9" }),
			_react2.default.createElement("circle", { cx: "136.82", cy: "276.3", fill: "#efefef", r: "1.9" }),
			_react2.default.createElement("path", { d: "M83.5,290.09A13.79,13.79,0,1,1,97.29,276.3,13.8,13.8,0,0,1,83.5,290.09Zm0-24.58A10.79,10.79,0,1,0,94.29,276.3,10.8,10.8,0,0,0,83.5,265.51Z", fill: "#efefef" }),
			_react2.default.createElement("path", { d: "M122.88,290.09a13.79,13.79,0,1,1,13.79-13.79A13.8,13.8,0,0,1,122.88,290.09Zm0-24.58a10.79,10.79,0,1,0,10.79,10.79A10.8,10.8,0,0,0,122.88,265.51Z", fill: "#efefef" }),
			_react2.default.createElement("path", { className: "fill", d: "M126,369.88l-17-4a14,14,0,0,0-16.26,8.61l-15.36-4.43A14,14,0,1,0,69.63,397l17,4.9a14,14,0,0,0,17-8.49l16,3.76A14,14,0,1,0,126,369.88Z", fill: "#f1f1f1" }),
			_react2.default.createElement(
				"g",
				{ className: "kitten-arms" },
				_react2.default.createElement("path", { className: "kitten-arm-left fill", d: "M86.19,357.28a14,14,0,0,0,23.4-15.37L89.4,311.15A14,14,0,0,0,66,326.52Z", fill: "#f1f1f1" }),
				_react2.default.createElement("path", { className: "kitten-arm-right fill", d: "M141.16,334.7,121,303.95a14,14,0,0,0-23.4,15.37l20.2,30.75a14,14,0,0,0,23.4-15.37Z", fill: "#f1f1f1" }),
				_react2.default.createElement("path", { className: "scissors-left", d: "M138.79,379.16l-15.66-21-7.24,1.59L112.41,357a9.46,9.46,0,1,0-3.28,8.16l.4-.36a9.41,9.41,0,0,0,2.27-3.38l24.47,20.23a1.78,1.78,0,0,0,2.52-2.52ZM109,358.46a6,6,0,1,1-10.1-4.81l.25-.23a6,6,0,0,1,9.85,5Z", fill: "#efefef" }),
				_react2.default.createElement("path", { className: "scissors-right", d: "M142,347.48a9.47,9.47,0,0,0-17.48,7.09l-2.13,3.93-7.29,1.33-6.33,25.39a1.78,1.78,0,0,0,3.3,1.35l14.74-28.12a9.42,9.42,0,0,0,3.4,2.24l.51.18A9.47,9.47,0,0,0,142,347.48Zm-2.67,6.18a6,6,0,1,1-3.91-7.57l.32.11a6,6,0,0,1,3.59,7.45Z", fill: "#efefef" })
			),
			_react2.default.createElement(
				"g",
				{ className: "leaf-1-wrapper" },
				_react2.default.createElement("path", { className: "leaf-1", d: "M174,342.09s-1.37-3.41-4.41-3.41-4.41,3.41-4.41,3.41,1.37,3.41,4.41,3.41S174,342.09,174,342.09Z", fill: "#66AA88" })
			),
			_react2.default.createElement(
				"g",
				{ className: "leaf-2-wrapper" },
				_react2.default.createElement("path", { className: "leaf-2", d: "M181.59,342.09s-1.37-3.41-4.41-3.41-4.41,3.41-4.41,3.41,1.37,3.41,4.41,3.41S181.59,342.09,181.59,342.09Z", fill: "#66AA88" })
			),
			_react2.default.createElement("path", { d: "M109.93,277.8H105.8l-.38-.94a2.33,2.33,0,0,0-2.23-1.69,2.27,2.27,0,0,0-2.24,1.69l-.38.93H96.45v-3h2.19a5.26,5.26,0,0,1,9.1,0h2.19Z", fill: "#efefef" }),
			_react2.default.createElement("path", { d: "M195.24,312s0,.57.06.88.07.75.14,1.12a14.06,14.06,0,0,0,.53,2.21,12.61,12.61,0,0,0,2,3.81,14.54,14.54,0,0,0,7,4.72,32.28,32.28,0,0,0,9.72,1.54c1.74,0,3.52,0,5.32-.13l.67,0h2.85a39.31,39.31,0,0,1,4,.34,27.08,27.08,0,0,1,16.18,7.83A23.85,23.85,0,0,1,249,343.1a25.49,25.49,0,0,1,1.25,10.13A30.82,30.82,0,0,1,243,370.51a38.26,38.26,0,0,1-6.47,6.13,45.45,45.45,0,0,1-7.4,4.38l-.4.19a12.43,12.43,0,1,1-10.66-22.46,13.43,13.43,0,0,1,1.86-.71,22.5,22.5,0,0,0,3.37-1.26A15.61,15.61,0,0,0,226,355a9.59,9.59,0,0,0,3.15-4.3,4.43,4.43,0,0,0-.16-3.64,8,8,0,0,0-4.94-3.32,21.16,21.16,0,0,0-2.06-.52l-1.13-.16-.58-.09-.85-.1c-2.26-.24-4.52-.57-6.81-1A46,46,0,0,1,199,337a26.84,26.84,0,0,1-11-11.18,23.65,23.65,0,0,1-2.28-7.53,24.21,24.21,0,0,1-.19-3.83c0-.64.06-1.28.13-1.92s.14-1.19.34-2.14a3.77,3.77,0,0,1,6.66-1.57Z", fill: "#c48357" }),
			_react2.default.createElement("path", { d: "M260.45,324.89,249.33,343.6a8,8,0,0,1-13.76-8.18,8.24,8.24,0,0,1,1.52-1.85L253.24,319a4.71,4.71,0,0,1,7.21,5.91Z", fill: "#c48357" }),
			_react2.default.createElement("path", { d: "M219.53,311.18c-.2.86-.46,2.08-.61,3.14a31.45,31.45,0,0,0-.32,3.25,17.26,17.26,0,0,0,.58,5.75,4.93,4.93,0,0,0,2,3,7.52,7.52,0,0,0,3.32.82A7.49,7.49,0,1,1,222,341.82l-.48-.13a20.3,20.3,0,0,1-10-5.95,18.24,18.24,0,0,1-4.33-10.46A29,29,0,0,1,208,316a41.9,41.9,0,0,1,1.21-4.15,43,43,0,0,1,1.64-4.08,4.66,4.66,0,0,1,8.77,3Z", fill: "#c48357" }),
			_react2.default.createElement("path", { d: "M186.66,371c6.77-7.36,21.6-12.13,38.8-12.13s32,4.77,38.79,12.12", fill: "#6a8" }),
			_react2.default.createElement("path", { d: "M182.74,377.52c0,8.3,7.54,15,16.84,15h51.77c9.3,0,16.84-6.73,16.84-15,0-3.34-2.22-9.17-2.22-9.17H185S182.74,374.18,182.74,377.52Z", fill: "#999" }),
			_react2.default.createElement("path", { d: "M277.2,305.28a11.12,11.12,0,0,0-7-2.37,10.32,10.32,0,0,0-2.87-1.29,11.05,11.05,0,0,0-7.73-2.72c-.51,0-1,0-1.47.08a11.31,11.31,0,0,0-7.29-2.32c-4.65,0-7.75,2-9.35,4.75h-.28a10.94,10.94,0,0,0-8,2.95c-11.53,2-10.89,18.17,1.95,18.58a11,11,0,0,0,7.78,2.76,11.15,11.15,0,0,0,7.51-2.53l.6,0a11.88,11.88,0,0,0,6.18,1.57,13.62,13.62,0,0,0,3.21-.37,13.66,13.66,0,0,0,3.21.37,11.84,11.84,0,0,0,6.23-1.6,13.71,13.71,0,0,0,3.11.35C285.66,323.43,287,308.55,277.2,305.28Z", fill: "#6a8" }),
			_react2.default.createElement("path", { d: "M248.37,293.8c-1.4-3.29-4.79-5.88-10.13-5.75-.29,0-.56,0-.84.06a9.1,9.1,0,0,0-5.66-5.78c-1.73-2.47-4.81-4.21-9.22-4.1a13.32,13.32,0,0,0-2.42.28c-1.79-2.14-4.71-3.6-8.75-3.5a11.08,11.08,0,0,0-7.55,2.82,11.61,11.61,0,0,0-6.73-1.71c-4.92.12-8.07,2.48-9.49,5.49a11.1,11.1,0,0,0-7.08,2.63,11.93,11.93,0,0,0-6-1.31c-7.52.19-10.92,5.59-10.32,10.55a9.47,9.47,0,0,0-6.47,5c-7.18,4.79-4.75,17.24,6.81,16.95a12.87,12.87,0,0,0,4.44-.86,13,13,0,0,0,12.23-.39l.3,0a11,11,0,0,0,7.87,2.59,14.48,14.48,0,0,0,1.91-.18,14.44,14.44,0,0,0,1.88.08c.4,0,.78,0,1.15-.07a11.9,11.9,0,0,0,6.18,1.39,11.57,11.57,0,0,0,6.61-2,11.12,11.12,0,0,0,7,2.18,12.88,12.88,0,0,0,4.54.65,11.69,11.69,0,0,0,6.48-1.94,13.42,13.42,0,0,0,2.05-.32c.34,0,.69,0,1,0s.87,0,1.29-.09.88,0,1.34,0a10.77,10.77,0,0,0,8.18-3.47h.49a12.62,12.62,0,0,0,4.83-1,13,13,0,0,0,4.2.55C262.52,312.24,262.19,293.77,248.37,293.8Z", fill: "#75c69f" }),
			_react2.default.createElement("path", { d: "M198,331a14.25,14.25,0,0,0-2.26.18,11,11,0,0,0-8-2.92,12.86,12.86,0,0,0-4.52.77,12.88,12.88,0,0,0-4.53-.77,10.78,10.78,0,0,0-8.25,3.25c-11.38,2.24-10.5,18.54,2.71,18.54a12,12,0,0,0,5.87-1.38,12.77,12.77,0,0,0,13.43-.05,12.29,12.29,0,0,0,5.51,1.19C212.14,349.81,212.17,331,198,331Z", fill: "#75c69f" }),
			_react2.default.createElement("rect", { height: "6.62", width: "50.45", fill: "#999", x: "200.24", y: "390.89" }),
			_react2.default.createElement("path", { className: "fill--face", d: "M103.79,287.57h-2.65c-1.32,0-2.09,1.27-1.32,2.18l1.06,1.24,1.6,1.83a1.8,1.8,0,0,0,2.61,0l1.61-1.87,1-1.19c.78-.91,0-2.19-1.31-2.19Z" }),
			_react2.default.createElement(
				"g",
				{ className: "kitten-eyes" },
				_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "84.5", cy: "278.7", rx: "5.87", ry: "5.28", transform: "matrix(0.17, -0.98, 0.98, 0.17, -203.26, 312.36)" }),
				_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "123.88", cy: "277.3", rx: "5.28", ry: "5.87", transform: "translate(-46.27 25.72) rotate(-10)" })
			),
			_react2.default.createElement(
				"g",
				{ className: "kitten-eyes--blink" },
				_react2.default.createElement("path", { className: "fill--face", d: "M88.5,281a1.49,1.49,0,0,1-.3,0l-8.62-1.74a1.5,1.5,0,1,1,.59-2.94L88.8,278a1.5,1.5,0,0,1-.29,3Z" }),
				_react2.default.createElement("path", { className: "fill--face", d: "M119.87,281a1.5,1.5,0,0,1-.29-3l8.63-1.74a1.5,1.5,0,1,1,.59,2.94l-8.63,1.74A1.49,1.49,0,0,1,119.87,281Z" })
			)
		);
	}
	
	exports.default = Bonsai;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Camper() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill", d: "M92.9,305.7c-18.9,0-32.8-4-42.8-12.7l-4.3,3.5c-0.5,0.4-1.2,0.7-1.8,0.7c-0.8,0-1.6-0.4-2.2-1 c-1-1.2-0.8-3,0.4-4l3.9-3.3c-1.1-1.3-2-2.7-2.8-4.3l-6,2.1c-0.3,0.1-0.6,0.2-0.9,0.2c-1.2,0-2.3-0.7-2.7-1.9 c-0.5-1.5,0.3-3.1,1.8-3.6l5.7-2c-0.4-1.4-0.7-2.8-0.9-4.3l-7.8-0.5c-1.6-0.1-2.8-1.5-2.7-3c0.1-1.6,1.4-2.8,3-2.7l7.1,0.4l0,0 c0.5-15.7,3.8-40.3,8.2-51.1c1.3-4.1,6.5-6.5,10-3.7l0,0c6.7,3.9,15,10.2,21.6,16.2c5.1-1.5,7.7-2.3,13.3-2.3 c5.6,0,8.2,0.8,13.3,2.3c6.6-6.1,14.8-12.3,21.6-16.2l0,0c3.5-2.8,8.7-0.4,10,3.7c4.5,10.8,7.8,35.4,8.2,51.1l0,0l7.1-0.4 c1.6-0.1,2.9,1.1,3,2.7c0.1,1.6-1.1,2.9-2.7,3l-7.8,0.5c-0.2,1.5-0.5,2.9-0.9,4.3l5.7,2c1.5,0.5,2.3,2.1,1.8,3.6 c-0.4,1.2-1.5,1.9-2.7,1.9c-0.3,0-0.6,0-0.9-0.2l-6-2.1c-0.8,1.5-1.7,2.9-2.8,4.3l3.9,3.3c1.2,1,1.4,2.8,0.4,4 c-0.6,0.7-1.4,1-2.2,1c-0.6,0-1.3-0.2-1.8-0.7l-4.3-3.5C125.6,301.7,111.7,305.7,92.9,305.7z", fill: "#F1F1F1" }),
			_react2.default.createElement("path", { className: "fill", d: "M127.2,319.6c-0.9-11.5-5.7-21-15.5-27.4c-8.6-5.7-19.6-6.8-29.5-5c-5.7,1-10.8,3.2-15.1,6.3 c-12.2,1.1-25.9,8.1-37.1,20c-11.5,12.3-17.6,27-17.6,39.5c-1.5,0.7-2.9,1.8-3.8,3.4l0,0c0,0-0.8,1.2-2,3.3 c-0.3,0.6-0.7,1.5-1.1,2.3c-0.4,0.9-0.9,1.8-1.3,2.8c-0.4,1-0.8,2.1-1.2,3.2c-0.3,1.2-0.7,2.5-1,3.9c-0.1,0.7-0.2,1.5-0.3,2.2 c-0.1,0.8-0.2,1.5-0.3,2.3c0,1.7-0.2,3.4,0.1,5.3c0.1,0.5,0.1,0.9,0.2,1.4l0.1,0.7l0.2,0.7c0.2,1,0.5,1.9,0.7,2.9 c0.3,1,0.7,1.9,1.1,2.9c0.4,1,1,1.9,1.5,2.8c2.2,3.7,5.3,6.8,8.5,9.1c3.3,2.4,6.7,4,10,5.2c1.7,0.7,3.3,1.1,5,1.6 c1.6,0.4,3.3,0.8,4.9,1.1c3.2,0.6,6.3,0.9,9.3,1.1c0.7,0,1.5,0.1,2.2,0.1c0.7,0,1.4,0,2.2,0c1.4,0,2.8-0.1,4.1-0.2 c2.7-0.2,5.2-0.5,7.5-0.9c1.1-0.2,2.2-0.4,3.3-0.6c1-0.2,2-0.5,2.9-0.7c1.8-0.5,3.4-1,4.7-1.5c1.3-0.4,2.3-0.9,3-1.1 c0.7-0.3,1-0.4,1-0.4c2.5-1.2,4.3-3.6,4.6-6.6c0.4-4.5-2.9-8.5-7.3-8.9l-0.6-0.1c0,0-0.3,0-0.9,0c-0.6,0-1.5,0-2.7-0.1 c-1.1,0-2.5-0.1-4.1-0.1c-1.6-0.1-3.3-0.1-5.3-0.2c-1,0-1.9-0.1-3-0.2c-1-0.1-2.1-0.1-3.2-0.2c-2.1-0.2-4.4-0.3-6.7-0.6 c-1.1-0.1-2.3-0.3-3.4-0.4c-1.1-0.2-2.3-0.3-3.4-0.6c-2.2-0.4-4.4-1-6.3-1.7c-1.9-0.7-3.6-1.5-4.9-2.3c-1.3-0.8-2.1-1.7-2.7-2.4 c-0.1-0.2-0.3-0.4-0.4-0.6c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1-0.5-0.4-0.9-0.5-1.5c-0.2-0.5-0.2-1.2-0.3-1.7c0-0.6,0-1.3,0-2 c0,0,0,0,0,0c5,3.6,12.5,6,18.5,6c0,0,2.1,0,4.9,0c7.2,0,12-1.2,15.3-3.2c2.3,1.3,5.2,1.9,8.3,1.9c8,0,14.6-5.1,14.6-11.4v-4 c7-2.3,12-6,15-9.1v11.3c0,7.7,6.3,14,14,14s14-6.3,14-14v-42.8c0-0.5,0.2-1,0.2-1.4C127.2,321.4,127.2,320.5,127.2,319.6z", fill: "#F1F1F1" }),
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M176.8,328.7c-2,27.9,19.6,35,19.2,34.7c-2-4.1-19.2-34.7,0-66.1c6.5,26.3,36.7,43.3,36.7,72.1 c0,18.4-16.6,33.6-36.7,33.6s-36.7-15.2-36.7-33.6C159.3,357,164.8,337.3,176.8,328.7", fill: "#EAB049" }),
				_react2.default.createElement("path", { d: "M153.7,353.2C153.7,353.2,153.7,353.2,153.7,353.2C153.7,353.2,153.7,353.2,153.7,353.2 c-0.4-0.2-0.8-0.4-1.3-0.5c-0.1,0-0.2-0.1-0.2-0.1c-0.4-0.1-0.8-0.2-1.2-0.3c-0.1,0-0.2,0-0.2,0c-0.4-0.1-0.9-0.1-1.3-0.2 c0,0-0.1,0-0.1,0c-0.4,0-0.8,0-1.3,0c-0.1,0-0.1,0-0.2,0c-0.4,0-0.8,0.1-1.3,0.1c-0.1,0-0.2,0-0.3,0c-0.4,0.1-0.9,0.1-1.3,0.2 c0,0-0.1,0-0.1,0c-0.4,0.1-0.8,0.2-1.2,0.4c-0.1,0-0.1,0-0.2,0.1c-0.4,0.1-0.8,0.3-1.2,0.5c-0.1,0-0.2,0.1-0.2,0.1 c-0.4,0.2-0.8,0.4-1.2,0.6c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.4,0.2-0.5,0.3l0,0c-2.3,1.5-4.4,3.5-5.9,6.1l0,0c0,0,0,0.1-0.1,0.1 c-0.1,0.2-0.3,0.4-0.4,0.7c-0.2,0.4-0.5,0.8-0.7,1.3c-4,8.6-1.4,18.4,5.9,21.8l99.2,46.2l14.6-31.3L153.7,353.2z", fill: "#AD6636" }),
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("polygon", { fill: "#E2935D", points: "144.3,421.2 145.1,415 135.8,425.2 \t\t\t" }),
					_react2.default.createElement("path", { d: "M258.8,362.7c-0.2-0.4-0.4-0.8-0.6-1.2c-0.1-0.2-0.3-0.5-0.4-0.7c0,0,0-0.1-0.1-0.1l0,0 c-1.6-2.6-3.6-4.6-5.9-6.1l0,0l0,0c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3-0.2-0.6-0.4-1-0.5c-0.2-0.1-0.4-0.2-0.5-0.3 c-0.4-0.2-0.8-0.3-1.1-0.5c-0.1-0.1-0.3-0.1-0.4-0.2c-0.5-0.2-1.1-0.3-1.6-0.5c-0.1,0-0.2,0-0.4-0.1c-0.4-0.1-0.8-0.2-1.3-0.2 c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0-1.1,0c-0.2,0-0.4,0-0.6,0c-0.3,0-0.7,0-1,0.1c-0.2,0-0.4,0-0.6,0.1c-0.4,0.1-0.7,0.1-1.1,0.2 c-0.2,0-0.3,0.1-0.5,0.1c-0.5,0.2-1,0.2-1.5,0.5l0-0.1h0l-99.2,46.4l14.6,31.4l99.2-46.2C260.2,381.1,262.8,371.4,258.8,362.7z", fill: "#AD6636" }),
					_react2.default.createElement("path", { d: "M145.1,415.1l-8.5,9.5c-0.9-1.1-1.7-2.4-2.4-3.8c-3.8-8.1-1.4-17.2,5.4-20.3c6.7-3.1,15.2,0.9,19,8.9 s1.4,17.2-5.4,20.3c-3.3,1.6-7.1,1.3-10.5-0.2L145.1,415.1z", fill: "#FCB47E" }),
					_react2.default.createElement("path", { d: "M159.7,409c-4-8.7-13.2-12.9-20.5-9.5c-7.3,3.4-10,13.1-6,21.8c0.7,1.5,1.6,2.9,2.5,4.1l3.1-2.7 c-0.8-1-1.4-2-1.9-3.1c-3.1-6.6-1.3-14,4-16.4c5.3-2.5,12.1,0.9,15.1,7.5c3.1,6.6,1.3,14-4,16.4c-2.5,1.2-5.5,1-8.2-0.3l-0.5-0.3 l-0.3,1.8c0,0,0,0,0,0l-0.5,2.3c3.6,1.6,7.7,1.8,11.2,0.2C161,427.4,163.7,417.6,159.7,409z", fill: "#AD6636" })
				),
				_react2.default.createElement("path", { d: "M238.8,429.7c-6.7-3.1-9.1-12.2-5.4-20.3c3.8-8.1,12.3-12.1,19-8.9c6.7,3.1,9.1,12.2,5.4,20.3 S245.5,432.9,238.8,429.7z", fill: "#FCB47E" }),
				_react2.default.createElement("path", { d: "M252.9,399.5c-7.3-3.4-16.5,0.8-20.5,9.5c-4,8.6-1.4,18.4,5.9,21.8c7.3,3.4,16.5-0.8,20.5-9.5 C262.8,412.6,260.2,402.9,252.9,399.5z M255,419.5c-2.2,4.6-6.3,7.9-10.6,8.2c-1.6,0.1-3-0.1-4.4-0.7c-5.2-2.4-7-9.7-3.9-16.3 c2.2-4.6,6.3-7.9,10.6-8.2c1.6-0.1,3,0.1,4.4,0.7c2.4,1.1,4.2,3.4,5,6.3C256.9,412.7,256.6,416.3,255,419.5z", fill: "#AD6636" }),
				_react2.default.createElement("polygon", { fill: "#E2935D", points: "245.4,414.6 243.9,403.1 227.8,396.5 \t\t" }),
				_react2.default.createElement("path", { d: "M176.8,328.7c-2,27.9,19.6,35,19.2,34.7c-2-4.1-19.2-34.7,0-66.1c6.5,26.3,36.7,43.3,36.7,72.1 c0,18.4-16.6,33.6-36.7,33.6s-36.7-15.2-36.7-33.6C159.3,357,164.8,337.3,176.8,328.7", fill: "#E57B4C" }),
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("path", { d: "M182.3,352.3c-5.3,6.5-8,13.2-8,20c0,7.6,9.7,16.8,21.7,16.8c6.4,0,12.9-2.7,17.3-7.2 c2.9-3,4.5-6.4,4.5-9.5c-0.2-11.1-8.4-18.3-18-26.5c-4.3-3.8-8.8-7.7-12.6-12.1c0.9,12.9,5.5,23.2,7.8,27.7 c0.4,0.7-0.4,1.5-1.2,1.2C191,361.2,186.1,358,182.3,352.3z", fill: "#FFD180" }),
					_react2.default.createElement("polygon", { fill: "#FFD180", points: "180.2,348.6 180.2,348.6 180.2,348.6 \t\t\t" })
				)
			),
			_react2.default.createElement(
				"g",
				{ className: "arm" },
				_react2.default.createElement("path", { d: "M217.3,266.3c-0.8-1.1-2.4-1.4-3.5-0.6L173.5,295l3.8-23.9c0.2-1.3-0.6-2.5-1.9-2.8 c-1.3-0.3-2.7,0.5-3,1.9l-7.1,31.1l-59.9,51.5c-0.1,0-0.1,0.1-0.2,0.2c-2.3,2.1-2.4,5.7-0.2,7.9c2.1,2.3,5.7,2.4,7.9,0.2l42.5-40 l7.5-1.1c0.8-0.1,1.5-0.8,1.7-1.6c0.2-1.1-0.5-2.1-1.6-2.3l-1.9-0.3l10.6-10l45.2-36C217.9,268.9,218.1,267.4,217.3,266.3z", fill: "#AD6636" }),
				_react2.default.createElement("path", { className: "marshmallow", d: "M215,277.7l-5.3,4c-1.9,1.5-4.7,1.1-6.2-0.9l-4-5.3c-1.5-1.9-1.1-4.7,0.9-6.2l5.3-4 c1.9-1.5,4.7-1.1,6.2,0.9l4,5.3C217.4,273.5,217,276.2,215,277.7z", fill: "#3f392d" }),
				_react2.default.createElement("path", { className: "marshmallow", d: "M202.8,287l-5.3,4c-1.9,1.5-4.7,1.1-6.2-0.9l-4-5.3c-1.5-1.9-1.1-4.7,0.9-6.2l5.3-4 c1.9-1.5,4.7-1.1,6.2,0.9l4,5.3C205.1,282.8,204.7,285.5,202.8,287z", fill: "#3f392d" }),
				_react2.default.createElement("path", { className: "burn", d: "M215,277.7l-5.3,4c-1.9,1.5-4.7,1.1-6.2-0.9l-4-5.3c-0.7-1-1-2.1-0.8-3.3c0,0,3.3,4.3,8.6,5.5 C212.6,279,215,277.7,215,277.7z", fill: "#3f392d" }),
				_react2.default.createElement("path", { className: "burn", d: "M202.7,287l-5.3,4c-1.9,1.5-4.7,1.1-6.2-0.9l-4-5.3c-0.7-1-1-2.1-0.8-3.3c0,0,3.3,4.3,8.6,5.5 C200.3,288.2,202.7,287,202.7,287z", fill: "#3f392d" }),
				_react2.default.createElement("path", { className: "marshmallow", d: "M181.1,278l-1.1,6.5c-0.4,2.4-2.7,4-5.1,3.6l-6.5-1.1c-2.4-0.4-4-2.7-3.6-5.1l1.1-6.5 c0.4-2.4,2.7-4,5.1-3.6l6.5,1.1C179.9,273.3,181.5,275.6,181.1,278z", fill: "#3f392d" }),
				_react2.default.createElement("path", { className: "burn", d: "M180.4,282.2l-0.4,2.3c-0.4,2.4-2.6,4-5,3.6l-6.5-1c-1.2-0.2-2.2-0.9-2.9-1.8c0,0,7.4-0.5,10-1 C178.3,283.7,180.4,282.2,180.4,282.2z", fill: "#3f392d" }),
				_react2.default.createElement("path", { className: "fill", d: "M102.5,371.4c-3.5,0-7-1.3-9.7-3.9l-21.5-20.6c-5.6-5.4-5.7-14.2-0.4-19.8s14.2-5.7,19.8-0.4l21.5,20.6 c5.6,5.4,5.7,14.2,0.4,19.8C109.8,369.9,106.2,371.4,102.5,371.4z", fill: "#F1F1F1" })
			),
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M116.5,243.8c0-19.5-10.2-35.4-22.8-35.4s-22.8,15.8-22.8,35.4", fill: "#987FEF" }),
				_react2.default.createElement("path", { d: "M114.6,248.8H72.7c-2.3,0-4.2-1.9-4.2-4.2v-10.3c0-2.3,1.9-4.2,4.2-4.2h41.9c2.3,0,4.2,1.9,4.2,4.2v10.3 C118.8,246.9,116.9,248.8,114.6,248.8z", fill: "#836EEA" }),
				_react2.default.createElement("path", { d: "M95.2,195.1L95.2,195.1c1.8-1.2,4.2-0.2,4.6,1.9h0c0.2,1.2,1.2,2.1,2.3,2.3h0c2.1,0.4,3.1,2.8,1.9,4.6l0,0 c-0.7,1-0.7,2.3,0,3.3h0c1.2,1.8,0.2,4.2-1.9,4.6h0c-1.2,0.2-2.1,1.2-2.3,2.3l0,0c-0.4,2.1-2.8,3.1-4.6,1.9h0 c-1-0.7-2.3-0.7-3.3,0h0c-1.8,1.2-4.2,0.2-4.6-1.9l0,0c-0.2-1.2-1.2-2.1-2.3-2.3h0c-2.1-0.4-3.1-2.8-1.9-4.6h0 c0.7-1,0.7-2.3,0-3.3l0,0c-1.2-1.8-0.2-4.2,1.9-4.6h0c1.2-0.2,2.1-1.2,2.3-2.3h0c0.4-2.1,2.8-3.1,4.6-1.9h0 C92.8,195.8,94.2,195.8,95.2,195.1z", fill: "#EFEFEF" }),
				_react2.default.createElement("path", { d: "M99.9,206c0,1,2.5,1,2.5,0C102.3,204,99.9,204,99.9,206z", fill: "#987FEF" }),
				_react2.default.createElement("path", { d: "M91.7,207c0,1,2.1,1,2.1,0C93.8,205,91.7,205,91.7,207z", fill: "#836EEA" }),
				_react2.default.createElement("path", { d: "M84.9,204c0,1.2,1.6,1.2,1.6,0S84.9,202.8,84.9,204z", fill: "#987FEF" }),
				_react2.default.createElement("path", { d: "M91.9,197c0,1.2,1.6,1.2,1.6,0S91.9,195.8,91.9,197z", fill: "#836EEA" }),
				_react2.default.createElement("path", { d: "M84.9,209c0,1.2,1.6,1.2,1.6,0S84.9,207.8,84.9,209z", fill: "#836EEA" }),
				_react2.default.createElement("path", { d: "M89.9,210.9c-0.1,1.2,1.5,1.3,1.6,0.1C91.6,209.9,90,209.8,89.9,210.9z", fill: "#987FEF" }),
				_react2.default.createElement("path", { d: "M95.9,214c0,1.2,1.6,1.2,1.6,0S95.9,212.8,95.9,214z", fill: "#836EEA" }),
				_react2.default.createElement("path", { d: "M89.5,202c0,2,2.7,2,2.7,0C92.1,201,89.5,201,89.5,202z", fill: "#987FEF" }),
				_react2.default.createElement("path", { d: "M95.8,209c0,2,2.1,2,2.1,0C97.8,208,95.8,208,95.8,209z", fill: "#987FEF" }),
				_react2.default.createElement("path", { d: "M95.3,203c0,1,2.7,1,2.7,0C97.9,201,95.3,201,95.3,203z", fill: "#836EEA" })
			),
			_react2.default.createElement("path", { className: "fill--face", d: "M96.6,282.9h-2.6c-1.3,0-2.1,1.3-1.3,2.2l1.1,1.2l1.6,1.8c0.7,0.7,2,0.7,2.6,0l1.6-1.9l1-1.2c0.8-0.9,0-2.2-1.3-2.2H96.6z" }),
			_react2.default.createElement(
				"g",
				{ className: "kitten-eyes" },
				_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "76.3", cy: "271.6", rx: "5.9", ry: "5.3", transform: "matrix(0.1736 -0.9848 0.9848 0.1736 -204.4472 299.5506)" }),
				_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "115.7", cy: "271.6", rx: "5.3", ry: "5.9", transform: "matrix(0.9848 -0.1736 0.1736 0.9848 -45.4059 24.2093)" })
			),
			_react2.default.createElement(
				"g",
				{ className: "kitten-eyes--blink" },
				_react2.default.createElement("path", { className: "fill--face", d: "M80.3,275.3c-0.1,0-0.2,0-0.3,0l-8.6-1.7c-0.8-0.2-1.3-1-1.2-1.8c0.2-0.8,1-1.3,1.8-1.2l8.6,1.7c0.8,0.2,1.3,1,1.2,1.8 C81.6,274.8,81,275.3,80.3,275.3z" }),
				_react2.default.createElement("path", { className: "fill--face", d: "M111.6,275.3c-0.7,0-1.3-0.5-1.5-1.2c-0.2-0.8,0.4-1.6,1.2-1.8l8.6-1.7c0.8-0.2,1.6,0.4,1.8,1.2c0.2,0.8-0.4,1.6-1.2,1.8 l-8.6,1.7C111.8,275.2,111.7,275.3,111.6,275.3z" })
			)
		);
	}
	
	exports.default = Camper;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Chef() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				{ opacity: "0.3" },
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M168.59256,415.45813c1.28044,0,2.3214-0.88818,2.3214-1.97949s-1.04095-1.97949-2.3214-1.97949 s-2.32245,0.88818-2.32245,1.97949S167.31212,415.45813,168.59256,415.45813z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M285.48807,405.20129c-0.13446-0.5332-0.52628-0.99951-1.07352-1.27979 c-1.08929-0.55713-2.47583-0.27734-3.15753,0.63721c-0.32877,0.44238-0.43802,0.96777-0.30777,1.47998 c0.13446,0.53271,0.52625,0.99854,1.07352,1.27783c0.36975,0.18896,0.77939,0.27881,1.18591,0.27881 c0.7731,0,1.53253-0.32568,1.97055-0.91504C285.50803,406.2384,285.61832,405.71301,285.48807,405.20129z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M190.64584,415.77991c-1.07352-0.54883-2.48737-0.26367-3.15648,0.63623 c-0.32878,0.44189-0.43907,0.9668-0.30882,1.479c0.13446,0.5332,0.52626,0.99951,1.07352,1.2793 c0.3792,0.19385,0.79411,0.28662,1.20271,0.28662c0.76575,0,1.51048-0.32666,1.9548-0.92285v-0.00049 c0.32878-0.44238,0.43803-0.96777,0.30777-1.47998C191.5849,416.52502,191.1931,416.0592,190.64584,415.77991z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M243.6861,424.01624c-1.07457-0.54883-2.48842-0.2627-3.15648,0.63672 c-0.32877,0.44238-0.43802,0.96777-0.30777,1.47998c0.13446,0.53223,0.52626,0.99854,1.07352,1.27832 c0.36975,0.18896,0.7794,0.27881,1.18591,0.27881c0.7731,0,1.53255-0.32568,1.97057-0.91553 c0.32877-0.44238,0.43802-0.96826,0.30777-1.48047C244.62515,424.76135,244.23335,424.29553,243.6861,424.01624z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M231.45201,414.33264c-0.21323-0.10889-0.44116-0.17596-0.67279-0.22076 c-0.37393-0.66748-1.16699-1.13324-2.09082-1.13324c-1.28046,0-2.32245,0.88818-2.32245,1.97949 c0,0.93817,0.77205,1.72235,1.80144,1.92505c0.19537,0.3465,0.50157,0.6441,0.89285,0.84448 c0.36974,0.18896,0.7794,0.27881,1.1859,0.27881c0.77415,0,1.5336-0.32568,1.97162-0.91553 c0.32878-0.44238,0.43802-0.96826,0.30777-1.48047C232.39108,415.07776,231.99927,414.61194,231.45201,414.33264z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M241.39516,421.32385c0.32878-0.44238,0.43802-0.96777,0.30882-1.47998 c-0.1355-0.53223-0.52626-0.99805-1.07352-1.27832c-0.94116-0.48175-2.1465-0.31909-2.88022,0.33563 c0.13235-0.24854,0.21008-0.52216,0.21008-0.81219c0-1.0918-1.04201-1.97998-2.32245-1.97998s-2.3214,0.88818-2.3214,1.97998 c0,1.09131,1.04095,1.97949,2.3214,1.97949c0.67542,0,1.2794-0.25134,1.70377-0.6452 c-0.21638,0.39203-0.28572,0.82904-0.17647,1.25946c0.13445,0.53271,0.52625,0.99854,1.07352,1.27783 c0.36974,0.18896,0.77939,0.27881,1.1859,0.27881C240.19769,422.23938,240.95714,421.9137,241.39516,421.32385z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M256.62289,418.56555c-1.09032-0.55811-2.47685-0.27832-3.15752,0.63672 c-0.32878,0.44238-0.43802,0.96826-0.30777,1.48047c0.13445,0.53271,0.52625,0.99854,1.07352,1.27783 c0.36974,0.18896,0.7794,0.27881,1.1859,0.27881c0.7731,0,1.53256-0.32568,1.97058-0.91504c0-0.00049,0-0.00049,0-0.00049 c0.32877-0.44189,0.43906-0.9668,0.30881-1.47852C257.56195,419.31213,257.17017,418.84583,256.62289,418.56555z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M172.1608,420.06848c1.28044,0,2.32243-0.88818,2.32243-1.97949 c0-1.0918-1.04199-1.97998-2.32243-1.97998c-1.28046,0-2.32245,0.88818-2.32245,1.97998 c0,0.28888,0.07668,0.56158,0.20798,0.80927c-0.73213-0.65277-1.93484-0.81342-2.87706-0.3327 c-0.54727,0.27979-0.93907,0.74609-1.07352,1.27832c-0.13025,0.51221-0.02101,1.0376,0.30777,1.47998v0.00049 c0.44432,0.59619,1.18906,0.92236,1.95586,0.92236c0.40755,0,0.82246-0.09277,1.20166-0.28613 c0.54726-0.27979,0.93906-0.74609,1.07352-1.27881c0.10924-0.43005,0.03938-0.86633-0.177-1.25775 C170.88245,419.81744,171.48538,420.06848,172.1608,420.06848z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M209.57835,414.62952c-1.28044,0-2.3214,0.88818-2.3214,1.97949c0,1.0918,1.04095,1.97998,2.3214,1.97998 s2.32245-0.88818,2.32245-1.97998C211.9008,415.5177,210.8588,414.62952,209.57835,414.62952z" }),
				_react2.default.createElement("ellipse", { fill: "#FFFFFF", cx: "163.51408", cy: "408.36945", rx: "2.32245", ry: "1.97949" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M181.43272,414.95813c0-1.09131-1.04201-1.97949-2.32245-1.97949s-2.3214,0.88818-2.3214,1.97949 s1.04095,1.97949,2.3214,1.97949S181.43272,416.04944,181.43272,414.95813z" }),
				_react2.default.createElement("ellipse", { fill: "#FFFFFF", cx: "195.12477", cy: "424.63977", rx: "2.32245", ry: "1.97949" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M161.7187,415.62952c1.28044,0,2.3214-0.88818,2.3214-1.97949s-1.04095-1.97949-2.3214-1.97949 c-1.13916,0-2.08505,0.70447-2.28096,1.62823c-0.10818-1.00598-1.09294-1.79962-2.30092-1.79962 c-1.28044,0-2.3214,0.88818-2.3214,1.97949s1.04095,1.97949,2.3214,1.97949c1.13918,0,2.08507-0.70447,2.28096-1.62823 C159.52599,414.83588,160.51074,415.62952,161.7187,415.62952z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M180.80563,418.28381c-1.28044,0-2.32245,0.88818-2.32245,1.97949s1.04201,1.97949,2.32245,1.97949 s2.3214-0.88818,2.3214-1.97949S182.08607,418.28381,180.80563,418.28381z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M254.65128,407.59875c0.66229,0,1.25734-0.2406,1.68015-0.62128 c-0.00262,0.04089-0.01419,0.07977-0.01419,0.12128c0,1.09131,1.04199,1.97949,2.32245,1.97949 c1.28043,0,2.32245-0.88818,2.32245-1.97949s-1.04202-1.97949-2.32245-1.97949c-0.66281,0-1.25787,0.24091-1.6817,0.62189 c0.00314-0.04108,0.01471-0.08014,0.01471-0.12189c0-1.09131-1.04095-1.97949-2.32141-1.97949 c-1.28044,0-2.32243,0.88818-2.32243,1.97949c0,0.04175,0.01155,0.08081,0.01469,0.12189 c-0.42383-0.38098-1.01889-0.62189-1.6817-0.62189c-1.28044,0-2.32245,0.88818-2.32245,1.97949s1.04201,1.97949,2.32245,1.97949 c1.28046,0,2.32245-0.88818,2.32245-1.97949c0-0.04175-0.01155-0.08081-0.01469-0.12189 C253.39342,407.35785,253.98848,407.59875,254.65128,407.59875z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M221.14543,416.10901c-0.34033,0-0.66124,0.06622-0.95273,0.17877 c-0.71164-0.80457-2.00574-1.03735-3.03987-0.50787c-0.54726,0.27979-0.93906,0.74609-1.07352,1.2793 c-0.13025,0.51172-0.01996,1.03662,0.30882,1.47852c0.43802,0.58984,1.19746,0.91602,1.97057,0.91602 c0.31721,0,0.63077-0.07269,0.93118-0.18671c0.42384,0.48352,1.09453,0.80145,1.85555,0.80145 c1.28044,0,2.3214-0.88818,2.3214-1.97949C223.46683,416.99719,222.42587,416.10901,221.14543,416.10901z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M277.14362,413.41956c-0.49683,0.34229-0.79935,0.82959-0.85291,1.37305 c-0.05148,0.53174,0.14389,1.04785,0.55042,1.45264c0.46112,0.45996,1.10815,0.69678,1.76151,0.69678 c0.51367,0,1.03046-0.146,1.46426-0.44531c0.49686-0.34277,0.79938-0.83057,0.8519-1.37402 c0.05252-0.53223-0.14285-1.04785-0.54938-1.45264C279.54697,412.84924,278.12997,412.73938,277.14362,413.41956z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M264.86227,397.25989c-1.28043,0-2.32245,0.88818-2.32245,1.97949s1.04202,1.97949,2.32245,1.97949 c1.28046,0,2.32141-0.88818,2.32141-1.97949S266.14273,397.25989,264.86227,397.25989z" }),
				_react2.default.createElement("ellipse", { fill: "#FFFFFF", cx: "250.66183", cy: "413.47864", rx: "2.32245", ry: "1.97949" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M239.20717,415.45813c0.59505,0,1.13286-0.19733,1.54408-0.51215 c0.1581,0.1543,0.33508,0.29468,0.54411,0.40131c0.36975,0.18896,0.7794,0.27933,1.18591,0.27933 c0.7731,0,1.53255-0.3262,1.97057-0.91605c0.32877-0.44238,0.43802-0.96777,0.30777-1.47998 c-0.13446-0.53271-0.52626-0.99854-1.07352-1.27783c-0.88655-0.45294-1.9984-0.32983-2.73788,0.22998 c-0.42595-0.41541-1.04463-0.68359-1.74104-0.68359c-1.28046,0-2.32245,0.88818-2.32245,1.97949 S237.92671,415.45813,239.20717,415.45813z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M255.65967,413.26086c-0.54726,0.2793-0.93906,0.74512-1.07352,1.27783 c-0.13025,0.51221-0.021,1.0376,0.30777,1.47998v0.00049c0.44432,0.59619,1.18906,0.92285,1.95587,0.92285 c0.4086,0,0.82245-0.09277,1.20166-0.28613c0.54724-0.27979,0.93906-0.74609,1.07352-1.27881 c0.13025-0.51221,0.01996-1.0376-0.30884-1.47949C258.15018,412.99817,256.73529,412.71252,255.65967,413.26086z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M202.34631,416.39124c-0.54727,0.2793-0.93907,0.74512-1.07352,1.27783 c-0.12448,0.48877-0.02415,0.98798,0.26996,1.41718c-0.83665-0.05853-1.688,0.26288-2.16174,0.9007 c-0.32878,0.44189-0.43907,0.96729-0.30882,1.479c0.13446,0.5332,0.52626,0.99951,1.07352,1.27979 c0.3792,0.19385,0.79306,0.28613,1.20168,0.28613c0.76678,0,1.51152-0.32666,1.95584-0.92285v-0.00049 c0.32878-0.44238,0.43803-0.96777,0.30777-1.47998c-0.05199-0.20673-0.15335-0.39813-0.27678-0.5777 c0.06775,0.00513,0.13393,0.02155,0.20221,0.02155c0.40756,0,0.82246-0.09277,1.20166-0.28613 c0.54726-0.27979,0.93907-0.74609,1.07352-1.27881c0.13025-0.51221,0.01996-1.0376-0.30882-1.47949 C204.83472,416.12854,203.42088,415.84387,202.34631,416.39124z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M225.70839,425.49622c-0.54726,0.2793-0.93906,0.74512-1.07352,1.27783 c-0.13025,0.51221-0.021,1.0376,0.30777,1.47998v0.00049c0.44328,0.59619,1.18802,0.92236,1.9548,0.92236 c0.40862,0,0.82353-0.09229,1.20273-0.28613c0.54726-0.27979,0.93906-0.74609,1.0735-1.2793 c0.13026-0.51221,0.01996-1.03711-0.30881-1.47852C228.19786,425.23303,226.78191,424.94739,225.70839,425.49622z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M173.38977,420.46985c-0.54727,0.27979-0.93907,0.74609-1.07352,1.27832 c-0.13025,0.51221-0.02101,1.0376,0.30777,1.47998c0.43802,0.58984,1.19746,0.91553,1.9716,0.91553 c0.40651,0,0.81618-0.08984,1.18591-0.27881c0.54726-0.27979,0.93802-0.74561,1.07352-1.27783 c0.1292-0.51221,0.01996-1.03809-0.30882-1.47998C175.87817,420.20715,174.46432,419.922,173.38977,420.46985z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M151.17683,418.56555c-0.54727,0.27979-0.93907,0.74609-1.07352,1.27832 c-0.13025,0.51221-0.02101,1.0376,0.30777,1.47998c0.43802,0.58984,1.19746,0.91553,1.9716,0.91553 c0.40651,0,0.81616-0.08984,1.18591-0.27881c0.5462-0.27979,0.938-0.74512,1.07246-1.27783 c0.13025-0.51221,0.02101-1.03809-0.30777-1.48047C153.66524,418.30286,152.25034,418.01721,151.17683,418.56555z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M145.04561,408.81946c0.54726-0.27979,0.93906-0.74609,1.07352-1.27832 c0.13025-0.51221,0.02101-1.0376-0.30777-1.48047c-0.68066-0.91357-2.06825-1.1958-3.15753-0.63623 c-0.54726,0.2793-0.93906,0.74561-1.0735,1.27783c-0.13025,0.5127-0.02101,1.03809,0.30881,1.48047c0,0,0,0,0,0.00049 c0.43802,0.58887,1.19746,0.91504,1.97057,0.91455C144.2662,409.09778,144.67586,409.00793,145.04561,408.81946z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M162.32794,416.39124c-0.54727,0.2793-0.93907,0.74561-1.07352,1.27783 c-0.13025,0.5127-0.02101,1.03809,0.30882,1.48047c0,0,0,0,0,0.00049c0.43802,0.58887,1.19746,0.91504,1.97055,0.91455 c0.40651,0,0.81618-0.08936,1.18591-0.27832c0.54726-0.2793,0.93907-0.74512,1.07352-1.27783 c0.13025-0.51221,0.02101-1.03809-0.30777-1.48096C164.80374,416.11389,163.42036,415.83215,162.32794,416.39124z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M200.54277,416.60901c0-1.09131-1.04201-1.97949-2.32245-1.97949 c-1.28046,0-2.32245,0.88818-2.32245,1.97949c0,1.0918,1.04199,1.97998,2.32245,1.97998 C199.50076,418.58899,200.54277,417.70081,200.54277,416.60901z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M246.08102,414.62952c-1.09715,0-2.01363,0.65387-2.25523,1.52704 c-0.60451,0.10217-1.16174,0.39948-1.51152,0.8714c-0.32878,0.44238-0.43803,0.96826-0.30777,1.48047 c0.13445,0.53223,0.52625,0.99805,1.07246,1.27783c0.36974,0.18896,0.77939,0.27881,1.1859,0.27881 c0.77415,0,1.5336-0.32568,1.97162-0.91553c0.13866-0.18658,0.22899-0.38977,0.28833-0.59875 c1.06827-0.17725,1.87761-0.97949,1.87761-1.94177C248.40242,415.5177,247.36147,414.62952,246.08102,414.62952z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M246.08102,411.34973c1.28044,0,2.3214-0.88818,2.3214-1.97949s-1.04095-1.97949-2.3214-1.97949 c-1.28046,0-2.32245,0.88818-2.32245,1.97949S244.80057,411.34973,246.08102,411.34973z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M145.63383,413.15002c-1.28044,0-2.3214,0.88818-2.3214,1.97949s1.04095,1.97949,2.3214,1.97949 s2.32245-0.88818,2.32245-1.97949S146.91428,413.15002,145.63383,413.15002z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M214.16759,419.76331c-1.28046,0-2.32141,0.88818-2.32141,1.97949s1.04095,1.97949,2.32141,1.97949 c1.28044,0,2.32245-0.88818,2.32245-1.97949S215.44803,419.76331,214.16759,419.76331z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M263.94946,410.01917c-1.28043,0-2.32242,0.88818-2.32242,1.97998 c0,0.43378,0.16962,0.83203,0.44852,1.15857c-1.23843,0.04108-2.23212,0.90662-2.23212,1.9718 c0,1.09131,1.04095,1.97949,2.32138,1.97949c1.28046,0,2.32245-0.88818,2.32245-1.97949 c0-0.43378-0.16962-0.83203-0.44852-1.15857c1.23843-0.04108,2.23315-0.90662,2.23315-1.9718 C266.27191,410.90735,265.22992,410.01917,263.94946,410.01917z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M226.99409,418.28381c-1.28046,0-2.32245,0.88818-2.32245,1.97949s1.04199,1.97949,2.32245,1.97949 c1.28044,0,2.3214-0.88818,2.3214-1.97949S228.27454,418.28381,226.99409,418.28381z" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M186.6543,418.70813c-1.28044,0-2.32245,0.88818-2.32245,1.97998 c0,1.09131,1.04201,1.97949,2.32245,1.97949s2.3214-0.88818,2.3214-1.97949 C188.97569,419.59631,187.93474,418.70813,186.6543,418.70813z" }),
				_react2.default.createElement("ellipse", { fill: "#FFFFFF", cx: "252.44649", cy: "400.71887", rx: "2.32245", ry: "1.97949" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M273.05545,407.39075c-1.28046,0-2.32141,0.88818-2.32141,1.97949s1.04095,1.97949,2.32141,1.97949 s2.32245-0.88818,2.32245-1.97949S274.33591,407.39075,273.05545,407.39075z" }),
				_react2.default.createElement("ellipse", { fill: "#FFFFFF", cx: "158.16003", cy: "402.19836", rx: "2.32245", ry: "1.97949" }),
				_react2.default.createElement("path", { fill: "#FFFFFF", d: "M152.81383,408.09958c0,1.09131,1.04095,1.97949,2.3214,1.97949 c1.28046,0,2.32245-0.88818,2.32245-1.97949s-1.04199-1.97949-2.32245-1.97949 C153.85478,406.12009,152.81383,407.00827,152.81383,408.09958z" })
			),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M239.10045,414.34732c0.72272,0,1.22697-0.44565,1.22697-0.84549s-0.50426-0.84552-1.22697-0.84552 c-0.72379,0-1.22806,0.44568-1.22806,0.84552S238.37666,414.34732,239.10045,414.34732z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M245.9754,424.02914c0.25214,0,0.49557-0.05695,0.70641-0.16464 c0.27495-0.14053,0.46513-0.35779,0.5097-0.58121c0.03151-0.15723-0.00978-0.31445-0.1239-0.46671 c-0.21953-0.29587-0.63902-0.4791-1.09547-0.4791c-0.25212,0-0.49666,0.05695-0.70749,0.16403 c-0.27386,0.1405-0.46405,0.35776-0.50861,0.58121c-0.03152,0.15784,0.00978,0.31506,0.12389,0.46732 C245.09946,423.84531,245.51895,424.02914,245.9754,424.02914z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M218.24411,418.34583c0.25214,0,0.49666-0.05695,0.7075-0.16403 c0.27386-0.1405,0.46405-0.35776,0.50861-0.58121c0.03151-0.15784-0.00978-0.31503-0.12389-0.46732 c-0.21953-0.29523-0.64012-0.47906-1.09656-0.47906c-0.25105,0-0.49557,0.05695-0.70641,0.16464 c-0.27388,0.1405-0.46515,0.35776-0.5097,0.58121c-0.03043,0.15784,0.01086,0.31503,0.12389,0.46732 C217.36708,418.1626,217.78767,418.34583,218.24411,418.34583z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M206.3526,421.91724c0.25105,0,0.49557-0.05695,0.70532-0.16464 c0.27495-0.1405,0.46513-0.35776,0.5097-0.58121c0.03151-0.15723-0.00978-0.31442-0.1239-0.46671 c-0.21953-0.29587-0.63902-0.47906-1.09547-0.47906c-0.25212,0-0.49666,0.05695-0.70749,0.16403 c-0.27386,0.1405-0.46405,0.35776-0.50861,0.58118c-0.03152,0.15784,0.00978,0.31506,0.12389,0.46735 C205.47557,421.7334,205.89616,421.91724,206.3526,421.91724z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M168.25999,421.13239c0.25212,0,0.49556-0.05695,0.70639-0.16464 c0.27496-0.1405,0.46515-0.35776,0.5097-0.58121c0.03152-0.15723-0.00978-0.31442-0.12389-0.46671 c-0.21953-0.29584-0.64012-0.47968-1.09656-0.47968c-0.25214,0-0.49557,0.05695-0.70641,0.16464 c-0.27388,0.1405-0.46515,0.35776-0.5097,0.58121c-0.03043,0.15784,0.01086,0.31503,0.12389,0.46732 C167.38297,420.94855,167.80354,421.13239,168.25999,421.13239z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M163.4184,418.95798c0.25214,0,0.49557-0.05695,0.70641-0.16464 c0.27495-0.1405,0.46513-0.35776,0.5097-0.58121c0.03151-0.15723-0.00978-0.31442-0.1239-0.46671 c-0.21953-0.29587-0.64011-0.47968-1.09547-0.47968c-0.25212,0-0.49556,0.05695-0.70641,0.16464 c-0.27495,0.1405-0.46513,0.35776-0.50969,0.58121c-0.03152,0.1572,0.00978,0.31442,0.12389,0.46667 C162.54245,418.77414,162.96304,418.95798,163.4184,418.95798z" }),
			_react2.default.createElement("ellipse", { fill: "#FFFFFF", cx: "235.53148", cy: "418.11185", rx: "1.22806", ry: "0.8455" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M198.11375,417.47803c0.72379,0,1.22806-0.44565,1.22806-0.84549 c0-0.40048-0.50427-0.84613-1.22806-0.84613c-0.7238,0-1.22806,0.44565-1.22806,0.84613 C196.8857,417.03238,197.38995,417.47803,198.11375,417.47803z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M267.87335,407.09875c0.72382,0,1.22806-0.44568,1.22806-0.84552 c0-0.40045-0.50424-0.84613-1.22806-0.84613c-0.72269,0-1.22696,0.44568-1.22696,0.84613 C266.64639,406.65308,267.15067,407.09875,267.87335,407.09875z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M246.07996,410.23865c0.72379,0,1.22806-0.44565,1.22806-0.84549s-0.50427-0.84549-1.22806-0.84549 c-0.72272,0-1.22697,0.44565-1.22697,0.84549S245.35724,410.23865,246.07996,410.23865z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M228.58154,415.82727c0.72379,0,1.22806-0.44565,1.22806-0.84613 c0-0.39984-0.50427-0.84549-1.22806-0.84549c-0.7238,0-1.22806,0.44565-1.22806,0.84549 C227.35349,415.38162,227.85774,415.82727,228.58154,415.82727z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M212.56789,425.50845c0.7227,0,1.22696-0.44565,1.22696-0.84552c0-0.40045-0.50426-0.8461-1.22696-0.8461 c-0.7238,0-1.22806,0.44565-1.22806,0.8461C211.33983,425.06281,211.84409,425.50845,212.56789,425.50845z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M245.97324,414.51877c0.72379,0,1.22806-0.44565,1.22806-0.84549 c0-0.40045-0.50427-0.84613-1.22806-0.84613c-0.72272,0-1.22697,0.44568-1.22697,0.84613 C244.74626,414.07312,245.25052,414.51877,245.97324,414.51877z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M256.85498,415.80389c0.72382,0,1.22806-0.44565,1.22806-0.84552c0-0.40045-0.50424-0.8461-1.22806-0.8461 c-0.72269,0-1.22696,0.44565-1.22696,0.8461C255.62802,415.35825,256.13229,415.80389,256.85498,415.80389z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M271.27103,413.01636c0.72382,0,1.22806-0.44565,1.22806-0.84549 c0-0.40048-0.50424-0.84613-1.22806-0.84613c-0.72269,0-1.22696,0.44565-1.22696,0.84613 C270.04407,412.57071,270.54834,413.01636,271.27103,413.01636z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M226.88725,421.13177c0.7227,0,1.22697-0.44565,1.22697-0.84552 c0-0.39984-0.50427-0.84549-1.22697-0.84549c-0.72379,0-1.22806,0.44565-1.22806,0.84549 C225.65919,420.68613,226.16347,421.13177,226.88725,421.13177z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M258.53311,407.96768c0.72379,0,1.22806-0.44565,1.22806-0.8461 c0-0.39987-0.50427-0.84552-1.22806-0.84552s-1.22806,0.44565-1.22806,0.84552 C257.30505,407.52203,257.80933,407.96768,258.53311,407.96768z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M157.03032,414.34732c0.7238,0,1.22806-0.44565,1.22806-0.84549 c0-0.40048-0.50426-0.84613-1.22806-0.84613c-0.72379,0-1.22806,0.44565-1.22806,0.84613 C155.80226,413.90167,156.30653,414.34732,157.03032,414.34732z" }),
			_react2.default.createElement("ellipse", { fill: "#FFFFFF", cx: "168.48495", cy: "413.50183", rx: "1.22806", ry: "0.8455" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M189.34128,418.34583c0.45645,0,0.87595-0.18323,1.09547-0.47906 c0.11412-0.15228,0.15541-0.30951,0.1239-0.46671c-0.04456-0.22345-0.23474-0.4407-0.5097-0.58121 c-0.21083-0.1077-0.45427-0.16464-0.70641-0.16464c-0.45645,0-0.87595,0.18384-1.09547,0.47906 c-0.11411,0.15228-0.15541,0.30948-0.12389,0.46732c0.04456,0.22345,0.23474,0.4407,0.5097,0.58121 C188.84464,418.28949,189.08916,418.34583,189.34128,418.34583z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M204.14754,418.95798c0.45644,0,0.87703-0.18384,1.09656-0.47971 c0.11411-0.15225,0.15541-0.30948,0.12389-0.46667c-0.04456-0.22345-0.23474-0.4407-0.50969-0.58121 c-0.21085-0.1077-0.45428-0.16464-0.70641-0.16464c-0.45537,0-0.87595,0.18381-1.09547,0.47968 c-0.11412,0.15228-0.15541,0.30948-0.1239,0.46671c0.04457,0.22345,0.23476,0.4407,0.5097,0.58121 C203.65196,418.90103,203.89648,418.95798,204.14754,418.95798z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M180.78618,428.06229c0.45645,0,0.87595-0.18323,1.09547-0.47906 c0.11411-0.15228,0.15541-0.30948,0.12389-0.46671c-0.04456-0.22345-0.23474-0.4407-0.50969-0.58121 c-0.21085-0.1077-0.45537-0.16464-0.70641-0.16464c-0.45645,0-0.87595,0.1832-1.09547,0.47906 c-0.11412,0.15228-0.15541,0.31012-0.1239,0.46732c0.04457,0.22345,0.23476,0.44009,0.50862,0.5806 C180.2906,428.00534,180.53513,428.06229,180.78618,428.06229L180.78618,428.06229z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M233.10579,423.03632c0.45645,0,0.87595-0.18323,1.09547-0.47906 c0.11302-0.15228,0.15433-0.30948,0.1228-0.46671c-0.04456-0.22345-0.23474-0.4407-0.50861-0.58121 c-0.21083-0.1077-0.45537-0.16464-0.70749-0.16464c-0.45645,0-0.87595,0.1832-1.09547,0.47906 c-0.11412,0.15228-0.15541,0.31012-0.1239,0.46732c0.04457,0.22345,0.23476,0.44009,0.50862,0.5806 c0.21191,0.1077,0.45644,0.16464,0.70749,0.16464C233.10579,423.03632,233.10579,423.03632,233.10579,423.03632z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M239.32541,421.13239c0.45537,0,0.87595-0.18384,1.09547-0.47971 c0.11412-0.15225,0.15541-0.30948,0.1239-0.46667c-0.04456-0.22345-0.23476-0.4407-0.5097-0.58121 c-0.21083-0.1077-0.45427-0.16464-0.70641-0.16464c-0.45535,0-0.87595,0.18384-1.09547,0.47968 c-0.11411,0.15228-0.15541,0.30948-0.12389,0.46671c0.04456,0.22345,0.23474,0.4407,0.50969,0.58121 C238.82985,421.07544,239.07329,421.13239,239.32541,421.13239z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M255.31734,421.13239c0.45645,0,0.87703-0.18384,1.09657-0.47971 c0.11411-0.15225,0.1554-0.30948,0.12387-0.46667c-0.04456-0.22345-0.23474-0.4407-0.5097-0.58121 c-0.21082-0.1077-0.45425-0.16464-0.70639-0.16464c-0.45537,0-0.87595,0.18384-1.09547,0.47968 c-0.11411,0.15228-0.15541,0.30948-0.12389,0.46671c0.04456,0.22345,0.23474,0.4407,0.50969,0.58121 C254.82176,421.07544,255.0663,421.13239,255.31734,421.13239z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M244.16592,418.95798c0.45644,0,0.87703-0.18384,1.09656-0.47971 c0.11411-0.15225,0.15541-0.30948,0.12389-0.46667c-0.04456-0.22345-0.23474-0.4407-0.50969-0.58121 c-0.21085-0.1077-0.45428-0.16464-0.70641-0.16464c-0.45645,0-0.87595,0.18381-1.09547,0.47906 c-0.11412,0.15289-0.15541,0.31009-0.1239,0.46732c0.04457,0.22345,0.23476,0.4407,0.50862,0.58121 C243.67035,418.90103,243.91379,418.95798,244.16592,418.95798z" }),
			_react2.default.createElement("ellipse", { fill: "#FFFFFF", cx: "172.05392", cy: "418.11185", rx: "1.22806", ry: "0.8455" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M209.47165,417.47803c0.7238,0,1.22806-0.44565,1.22806-0.84549 c0-0.40048-0.50426-0.84613-1.22806-0.84613c-0.72379,0-1.22806,0.44565-1.22806,0.84613 C208.24359,417.03238,208.74786,417.47803,209.47165,417.47803z" }),
			_react2.default.createElement("ellipse", { fill: "#FFFFFF", cx: "163.51389", cy: "408.39236", rx: "1.22806", ry: "0.8455" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M179.00386,415.82727c0.7238,0,1.22806-0.44565,1.22806-0.84613 c0-0.39984-0.50426-0.84549-1.22806-0.84549c-0.72379,0-1.22806,0.44565-1.22806,0.84549 C177.7758,415.38162,178.28008,415.82727,179.00386,415.82727z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M262.05753,415.99872c0.72379,0,1.22806-0.44565,1.22806-0.84613 c0-0.39984-0.50427-0.84549-1.22806-0.84549c-0.72272,0-1.22696,0.44565-1.22696,0.84549 C260.83057,415.55307,261.33481,415.99872,262.05753,415.99872z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M193.52429,422.61169c0.72379,0,1.22806-0.44565,1.22806-0.8461 c0-0.39984-0.50427-0.84552-1.22806-0.84552c-0.7238,0-1.22806,0.44568-1.22806,0.84552 C192.29623,422.16605,192.80049,422.61169,193.52429,422.61169z" }),
			_react2.default.createElement("ellipse", { fill: "#FFFFFF", cx: "180.69815", cy: "420.28625", rx: "1.22806", ry: "0.8455" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M221.03822,421.55701c0.72379,0,1.22806-0.44565,1.22806-0.84613 c0-0.39984-0.50427-0.84549-1.22806-0.84549c-0.7238,0-1.22806,0.44565-1.22806,0.84549 C219.81017,421.11136,220.31442,421.55701,221.03822,421.55701z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M149.58688,411.21674c0.7238,0,1.22806-0.44565,1.22806-0.8461c0-0.39987-0.50426-0.84552-1.22806-0.84552 c-0.72379,0-1.22806,0.44565-1.22806,0.84552C148.35883,410.77109,148.8631,411.21674,149.58688,411.21674z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M155.13556,408.94534c0.7238,0,1.22806-0.44565,1.22806-0.8461c0-0.39987-0.50426-0.84552-1.22806-0.84552 c-0.72379,0-1.22806,0.44565-1.22806,0.84552C153.9075,408.49969,154.41177,408.94534,155.13556,408.94534z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M252.44594,401.58804c0.72379,0,1.22806-0.44565,1.22806-0.84549 c0-0.40048-0.50427-0.84613-1.22806-0.84613c-0.7227,0-1.22697,0.44565-1.22697,0.84613 C251.21896,401.1424,251.72324,401.58804,252.44594,401.58804z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M250.55508,407.96768c0.72379,0,1.22806-0.44565,1.22806-0.8461 c0-0.39987-0.50427-0.84552-1.22806-0.84552c-0.7238,0-1.22806,0.44565-1.22806,0.84552 C249.32703,407.52203,249.83128,407.96768,250.55508,407.96768z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M250.55508,414.34732c0.72379,0,1.22806-0.44565,1.22806-0.84549 c0-0.40048-0.50427-0.84613-1.22806-0.84613c-0.7238,0-1.22806,0.44565-1.22806,0.84613 C249.32703,413.90167,249.83128,414.34732,250.55508,414.34732z" }),
			_react2.default.createElement("ellipse", { transform: "matrix(0.1832 -0.98307 0.98307 0.1832 -180.07001 502.5116)", fill: "#F7A46B", cx: "212.37025", cy: "359.61969", rx: "7.32803", ry: "5.17683" }),
			_react2.default.createElement("polygon", { fill: "#F49453", points: "213.71278,352.41571 189.34343,345.5744 185.82994,364.42773 211.02773,366.8237 \t\t" }),
			_react2.default.createElement("circle", { fill: "#F49453", cx: "187.58669", cy: "355.00107", r: "9.58895" }),
			_react2.default.createElement("rect", { x: "211.34966", y: "349.57388", transform: "matrix(0.98307 0.1832 -0.1832 0.98307 72.5056 -43.49396)", fill: "#F7A46B", width: "120.60131", height: "42.18635" }),
			_react2.default.createElement("ellipse", { transform: "matrix(0.1832 -0.98307 0.98307 0.1832 -180.07001 502.5116)", fill: "#F7A46B", cx: "212.37025", cy: "359.61969", rx: "21.09318", ry: "14.90111" }),
			_react2.default.createElement("ellipse", { transform: "matrix(0.1832 -0.98307 0.98307 0.1832 -104.95139 637.11194)", fill: "#F49453", cx: "330.93036", cy: "381.71442", rx: "21.09318", ry: "14.90111" }),
			_react2.default.createElement("ellipse", { transform: "matrix(0.1832 -0.98307 0.98307 0.1832 -104.95139 637.11194)", fill: "#F7A46B", cx: "330.93036", cy: "381.71442", rx: "7.32803", ry: "5.17683" }),
			_react2.default.createElement("polygon", { fill: "#F7A46B", points: "332.27289,374.51041 357.47067,376.90637 353.95721,395.7597 329.58783,388.9184 \t\t" }),
			_react2.default.createElement("circle", { fill: "#F7A46B", cx: "355.71396", cy: "386.33304", r: "9.58895" }),
			_react2.default.createElement("path", { className: "fill", d: "M213.84863,336.42651c-0.87805-11.53931-5.77588-21.00269-15.54266-27.44092 c-8.6217-5.68335-19.59186,3.19629-29.53876,4.97827c-4.68256,0.83911-8.93488,1.55737-12.68988,2.53784 c-33.25574,3.20337-51.93219,28.73535-54.58264,51.46143c-0.81116,6.95508,0.16254,12.25122,2.3703,16.34497 c0.31641,1.6687,0.93042,3.30859,1.88794,4.83374c11.46973,18.26465,40.44336,18.79199,43.70898,18.79199 c7.73242,0,14-6.26807,14-14c0-0.69971-0.06818-1.38184-0.1673-2.0542c9.22772-4.87451,16.83722-5.16971,22.05951-13.99881 c2.75555-1.50488,4.75537-2.77686,5.33862-3.55103c2.68524-0.24976,5.35138-0.6228,7.80365-1.29907 C211.76929,369.37131,214.76953,348.53003,213.84863,336.42651z" }),
			_react2.default.createElement("path", { className: "fill", d: "M115.21727,394.09137l-0.28171-0.01083c-5.47805-0.20889-10.82626-0.50073-16.13197-0.61731 c-5.29791-0.13217-10.53992-0.12112-15.66969,0.12714c-5.1312,0.23889-10.13049,0.81519-14.90194,1.40393 c-4.80826,0.56528-9.26854,1.31055-13.92478,1.93365l-2.08387,0.27954c-3.29878,0.41885-6.60137-0.67361-8.73145-3.22238 c-3.45151-4.13-2.51728-10.51968,2.08682-14.27179c1.46571-1.19449,3.03398-2.39517,4.63434-3.38916 c0.80049-0.48639,1.61786-0.94766,2.43992-1.41214l1.24363-0.67554l1.24367-0.58102 c1.66588-0.74997,3.3716-1.52182,5.05476-2.05957l2.5505-0.84866c0.85586-0.27115,1.69188-0.4563,2.54164-0.68637 c6.80056-1.71347,13.49544-2.15085,19.96267-2.07553c6.47401,0.09439,12.75728,0.81207,18.82529,2.06784 c6.0599,1.27792,11.92459,3.06467,17.41988,5.6102c3.39565,1.57764,5.46075,5.12866,4.90821,9.16031 C125.67337,390.14978,120.66525,394.29907,115.21727,394.09137z" }),
			_react2.default.createElement(
				"g",
				{ className: "dough" },
				_react2.default.createElement("path", { fill: "#FFEAAE", d: "M247.80652,392.54141c0,18.00165-19.04999,19.78375-42.54935,19.78375s-42.54936-1.7821-42.54936-19.78375 s19.04999-32.59488,42.54936-32.59488S247.80652,374.53976,247.80652,392.54141z" }),
				_react2.default.createElement("path", { fill: "#ffe09c", d: "M177.7758,397.29471c0.03334,7.51855,3.98201,15.03049,27.48134,15.03049 c8.32269,0,14.24339-3.84189,17.68138-9.24832c8.97884-14.11969-2.60301-35.16263-24.05473-30.90573 C179.79106,375.9599,177.74176,389.61646,177.7758,397.29471z" })
			),
			_react2.default.createElement(
				"g",
				{ className: "kitten-arm--left" },
				_react2.default.createElement("path", { className: "fill", d: "M215.84386,381.81036c-5.99805,0-11.54492-3.88477-13.38574-9.91895l-13.25777-44.40613 c-2.25586-7.39551,1.91016-15.21924,9.30566-17.4751c7.39941-2.25732,14.12161-4.65121,16.37747,2.7438l14.35588,50.9675 c2.25586,7.396-1.91016,15.21973-9.30566,17.47559C218.57237,381.61261,217.1964,381.81036,215.84386,381.81036z" })
			),
			_react2.default.createElement(
				"g",
				{ className: "kitten-arm--right" },
				_react2.default.createElement("path", { className: "fill", d: "M181.92805,386.81436c-5.99805,0-11.54492-3.88477-13.38574-9.91895l-13.25777-44.40613 c-2.25586-7.39551,1.91016-15.21924,9.30566-17.4751c7.39941-2.25732,14.12161-4.65121,16.37747,2.7438l14.35588,50.9675 c2.25586,7.396-1.91016,15.21973-9.30566,17.47559C184.65657,386.61661,183.28059,386.81436,181.92805,386.81436z" })
			),
			_react2.default.createElement(
				"g",
				{ className: "dough" },
				_react2.default.createElement("path", { fill: "#FFEAAE", d: "M174.0172,388.81339c-8.58441,5.17294-6.95554,17.96249,2.6427,20.84781 c7.55293,2.27045,17.58525,2.664,28.59724,2.664c23.49939,0,42.54938-1.78198,42.54938-19.78369l-0.00011-0.07288 c-0.00679-4.61639-5.31567-11.93118-15.13997-13.66736c-9.07161-1.60318-20.383-2.16528-32.40894,0.2395 C190.12875,381.06619,181.08687,384.55322,174.0172,388.81339z" }),
				_react2.default.createElement("path", { fill: "none", d: "M247.80652,392.54141c0,18.00165-19.04999,19.78375-42.54935,19.78375s-42.54936-1.7821-42.54936-19.78375 s19.04999-32.59488,42.54936-32.59488S247.80652,374.53976,247.80652,392.54141z" })
			),
			_react2.default.createElement(
				"g",
				{ className: "kitten-head" },
				_react2.default.createElement("path", { className: "fill", d: "M189.4313,333.93323c-18.79309,1.53751-32.97781-1.31848-43.73412-9.17661l-3.9826,3.8768 c-0.49615,0.48303-1.12227,0.74969-1.76218,0.80206c-0.82265,0.06729-1.66739-0.21936-2.28763-0.85678 c-1.10359-1.13321-1.07919-2.94647,0.05469-4.0498l3.66106-3.56375c-1.16733-1.24124-2.21483-2.57709-3.13518-4.00803 l-5.83615,2.53781c-0.29688,0.12906-0.60316,0.20401-0.90857,0.22897c-1.18813,0.09723-2.35809-0.55945-2.86032-1.7132 c-0.63068-1.45068,0.03387-3.13794,1.48454-3.76862l5.54315-2.4104c-0.50726-1.34158-0.92216-2.74844-1.23903-4.22238 l-7.82204,0.15164c-1.58144,0.03085-2.88786-1.22641-2.91871-2.80783c-0.0302-1.58118,1.20969-2.89023,2.80814-2.91904 l7.12054-0.13809l0.00496-0.00095c-0.82832-15.70166,0.46381-40.43442,4.01807-51.57236 c0.94398-4.17145,5.91899-6.97575,9.63797-4.48718l0.00005,0.00003c7.00497,3.3206,15.75433,8.90036,22.80588,14.40845 c4.94336-1.86148,7.49019-2.87427,13.04655-3.32886c5.55637-0.45456,8.23395,0.13083,13.41412,1.16409 c6.06252-6.58098,13.78865-13.50861,20.16077-17.9236l0.00003-0.00005c3.26506-3.05994,8.6297-1.10153,10.23914,2.86102 c5.31729,10.41216,10.61217,34.60602,12.34691,50.23352l0.00505,0.00015l7.04831-1.02112 c1.58186-0.23138,3.01804,0.85873,3.24524,2.4238c0.22659,1.56543-0.85811,3.01831-2.42352,3.2449l-7.74269,1.12173 c-0.07309,1.50583-0.2538,2.96143-0.53627,4.36761l5.86121,1.47739c1.53389,0.38651,2.46384,1.94333,2.07735,3.47723 c-0.30803,1.22003-1.35571,2.05811-2.54384,2.15533c-0.30539,0.02496-0.6198,0.00079-0.93372-0.07828l-6.17102-1.55551 c-0.67552,1.56152-1.49199,3.04987-2.44205,4.46432l4.1916,2.92133c1.29813,0.90436,1.61693,2.68954,0.7122,3.98706 c-0.50841,0.72974-1.29532,1.1499-2.11797,1.21719c-0.63991,0.05234-1.30103-0.10901-1.86911-0.505l-4.55975-3.17792 C221.7563,327.27225,208.22438,332.39575,189.4313,333.93323z" }),
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("path", { fill: "#FFFFFF", d: "M204.87563,235.92473l-45.81551,3.74821l1.85568,22.68256 c0.07416,0.90646,0.77713,1.63498,1.68039,1.74139l1.71404,0.20193c13.79967,1.62576,27.78654,0.37134,41.07669-3.68399h0.00002 c0.85919-0.26218,1.41965-1.08755,1.34639-1.98285L204.87563,235.92473z" }),
					_react2.default.createElement("path", { fill: "#FFFFFF", d: "M217.19127,222.78279c0.99084,12.11137-14.41747,23.25587-34.41544,24.89192 c-19.99799,1.63606-37.01277-6.85587-38.00362-18.96725c-0.99084-12.11137,14.33586-24.25334,34.33385-25.88939 C199.10403,201.18201,216.20042,210.6714,217.19127,222.78279z" }),
					_react2.default.createElement("path", { fill: "#E5E5E5", d: "M198.26263,229.79456c-1.57149,4.02768,0.46944,10.95872,0.46944,10.95872 s6.19562-3.71739,7.76709-7.74507c1.57149-4.02769,0.1982-5.95303-2.07626-6.84047 C202.14844,225.28032,199.83411,225.76688,198.26263,229.79456z" }),
					_react2.default.createElement("path", { fill: "#E5E5E5", d: "M164.58882,232.54945c2.20522,3.7187,1.31796,10.8893,1.31796,10.8893s-6.71744-2.66096-8.92265-6.37967 s-1.16313-5.84166,0.93684-7.08696S162.38359,228.83073,164.58882,232.54945z" }),
					_react2.default.createElement("path", { fill: "#E5E5E5", d: "M184.2554,233.17397c-0.3597,3.7921,3.04221,9.17268,3.04221,9.17268s4.35287-4.645,4.71257-8.43712 c0.3597-3.7921-1.26857-5.09218-3.40999-5.29529C186.45877,228.41112,184.6151,229.38187,184.2554,233.17397z" }),
					_react2.default.createElement("path", { fill: "#E5E5E5", d: "M178.95906,233.60725c0.97125,3.68323-1.51088,9.5452-1.51088,9.5452s-5.04997-3.87576-6.02122-7.55898 c-0.97127-3.68321,0.42404-5.23065,2.50397-5.77913C176.01086,229.26587,177.98779,229.92404,178.95906,233.60725z" })
				),
				_react2.default.createElement("path", { className: "fill--face", d: "M193.62007,304.41449c1.35907-0.11426,2.25694,1.12692,1.54118,2.13052l-2.45822,3.38464 c-0.60493,0.82285-1.95737,0.9325-2.68521,0.21771l-2.96577-2.91257c-0.88388-0.86804-0.20796-2.25058,1.15637-2.3653 L193.62007,304.41449z" })
			),
			_react2.default.createElement(
				"g",
				{ className: "kitten-eyes--blink" },
				_react2.default.createElement(
					"g",
					{ className: "kitten-head" },
					_react2.default.createElement("path", { fill: "none", d: "M189.4313,333.93323c-18.79309,1.53751-32.97781-1.31848-43.73412-9.17661l-3.9826,3.8768 c-0.49615,0.48303-1.12227,0.74969-1.76218,0.80206c-0.82265,0.06729-1.66739-0.21936-2.28763-0.85678 c-1.10359-1.13321-1.07919-2.94647,0.05469-4.0498l3.66106-3.56375c-1.16733-1.24124-2.21483-2.57709-3.13518-4.00803 l-5.83615,2.53781c-0.29688,0.12906-0.60316,0.20401-0.90857,0.22897c-1.18813,0.09723-2.35809-0.55945-2.86032-1.7132 c-0.63068-1.45068,0.03387-3.13794,1.48454-3.76862l5.54315-2.4104c-0.50726-1.34158-0.92216-2.74844-1.23903-4.22238 l-7.82204,0.15164c-1.58144,0.03085-2.88786-1.22641-2.91871-2.80783c-0.0302-1.58118,1.20969-2.89023,2.80814-2.91904 l7.12054-0.13809l0.00496-0.00095c-0.82832-15.70166,0.46381-40.43442,4.01807-51.57236 c0.94398-4.17145,5.91899-6.97575,9.63797-4.48718l0.00005,0.00003c7.00497,3.3206,15.75433,8.90036,22.80588,14.40845 c4.94336-1.86148,7.49019-2.87427,13.04655-3.32886c5.55637-0.45456,8.23395,0.13083,13.41412,1.16409 c6.06252-6.58098,13.78865-13.50861,20.16077-17.9236l0.00003-0.00005c3.26506-3.05994,8.6297-1.10153,10.23914,2.86102 c5.31729,10.41216,10.61217,34.60602,12.34691,50.23352l0.00505,0.00015l7.04831-1.02112 c1.58186-0.23138,3.01804,0.85873,3.24524,2.4238c0.22659,1.56543-0.85811,3.01831-2.42352,3.2449l-7.74269,1.12173 c-0.07309,1.50583-0.2538,2.96143-0.53627,4.36761l5.86121,1.47739c1.53389,0.38651,2.46384,1.94333,2.07735,3.47723 c-0.30803,1.22003-1.35571,2.05811-2.54384,2.15533c-0.30539,0.02496-0.6198,0.00079-0.93372-0.07828l-6.17102-1.55551 c-0.67552,1.56152-1.49199,3.04987-2.44205,4.46432l4.1916,2.92133c1.29813,0.90436,1.61693,2.68954,0.7122,3.98706 c-0.50841,0.72974-1.29532,1.1499-2.11797,1.21719c-0.63991,0.05234-1.30103-0.10901-1.86911-0.505l-4.55975-3.17792 C221.7563,327.27225,208.22438,332.39575,189.4313,333.93323z" }),
					_react2.default.createElement("ellipse", { className: "fill--eyes", transform: "matrix(0.96737 -0.25337 0.25337 0.96737 -67.43803 62.48084)", cx: "208.85703", cy: "293.06229", rx: "5.28059", ry: "5.86732" }),
					_react2.default.createElement("ellipse", { className: "fill--eyes", transform: "matrix(0.09277 -0.99569 0.99569 0.09277 -140.90112 437.97821)", cx: "169.89064", cy: "296.30881", rx: "5.86732", ry: "5.28059" })
				)
			),
			_react2.default.createElement(
				"g",
				{ className: "kitten-eyes" },
				_react2.default.createElement(
					"g",
					{ className: "kitten-head" },
					_react2.default.createElement("path", { fill: "none", d: "M189.4313,333.93323c-18.79309,1.53751-32.97781-1.31848-43.73412-9.17661l-3.9826,3.8768 c-0.49615,0.48303-1.12227,0.74969-1.76218,0.80206c-0.82265,0.06729-1.66739-0.21936-2.28763-0.85678 c-1.10359-1.13321-1.07919-2.94647,0.05469-4.0498l3.66106-3.56375c-1.16733-1.24124-2.21483-2.57709-3.13518-4.00803 l-5.83615,2.53781c-0.29688,0.12906-0.60316,0.20401-0.90857,0.22897c-1.18813,0.09723-2.35809-0.55945-2.86032-1.7132 c-0.63068-1.45068,0.03387-3.13794,1.48454-3.76862l5.54315-2.4104c-0.50726-1.34158-0.92216-2.74844-1.23903-4.22238 l-7.82204,0.15164c-1.58144,0.03085-2.88786-1.22641-2.91871-2.80783c-0.0302-1.58118,1.20969-2.89023,2.80814-2.91904 l7.12054-0.13809l0.00496-0.00095c-0.82832-15.70166,0.46381-40.43442,4.01807-51.57236 c0.94398-4.17145,5.91899-6.97575,9.63797-4.48718l0.00005,0.00003c7.00497,3.3206,15.75433,8.90036,22.80588,14.40845 c4.94336-1.86148,7.49019-2.87427,13.04655-3.32886c5.55637-0.45456,8.23395,0.13083,13.41412,1.16409 c6.06252-6.58098,13.78865-13.50861,20.16077-17.9236l0.00003-0.00005c3.26506-3.05994,8.6297-1.10153,10.23914,2.86102 c5.31729,10.41216,10.61217,34.60602,12.34691,50.23352l0.00505,0.00015l7.04831-1.02112 c1.58186-0.23138,3.01804,0.85873,3.24524,2.4238c0.22659,1.56543-0.85811,3.01831-2.42352,3.2449l-7.74269,1.12173 c-0.07309,1.50583-0.2538,2.96143-0.53627,4.36761l5.86121,1.47739c1.53389,0.38651,2.46384,1.94333,2.07735,3.47723 c-0.30803,1.22003-1.35571,2.05811-2.54384,2.15533c-0.30539,0.02496-0.6198,0.00079-0.93372-0.07828l-6.17102-1.55551 c-0.67552,1.56152-1.49199,3.04987-2.44205,4.46432l4.1916,2.92133c1.29813,0.90436,1.61693,2.68954,0.7122,3.98706 c-0.50841,0.72974-1.29532,1.1499-2.11797,1.21719c-0.63991,0.05234-1.30103-0.10901-1.86911-0.505l-4.55975-3.17792 C221.7563,327.27225,208.22438,332.39575,189.4313,333.93323z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M175.69904,299.28027c-0.40286,0.0285-0.81665-0.08807-1.15768-0.35959c-0.65222-0.51895-2.01974-1.06155-3.90242-1.0274 c-1.88112,0.03766-3.22939,0.62659-3.86206,1.16946c-0.70114,0.60135-1.75476,0.5199-2.35503-0.17969 c-0.60092-0.69986-0.52054-1.75436,0.17932-2.35532c1.41084-1.21115,3.58115-1.93152,5.97667-1.97452 c2.38698-0.04333,4.59009,0.5961,6.04434,1.75427c0.72159,0.57458,0.84109,1.62543,0.26619,2.34702 C176.58501,299.0354,176.14941,299.24838,175.69904,299.28027z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M203.60025,296.91058c-0.44887,0.04871-0.91539-0.08344-1.28165-0.40433 c-0.69403-0.60788-0.76328-1.66321-0.15536-2.35693c1.22516-1.39828,3.27946-2.41928,5.63612-2.80103 c2.35846-0.38327,4.6288-0.06064,6.23251,0.88037c0.79556,0.46692,1.06216,1.49033,0.59525,2.28589 c-0.46753,0.79596-1.49077,1.06125-2.28554,0.59555c-0.71848-0.42178-2.14157-0.76285-4.00847-0.46411 c-1.85875,0.30115-3.108,1.07822-3.65756,1.7049C204.38823,296.67871,204.00177,296.867,203.60025,296.91058z" })
				)
			)
		);
	}
	
	exports.default = Chef;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Coffee() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				{ className: "kitten-tail" },
				_react2.default.createElement("path", { className: "fill", d: "M89.27252,355.06387l-1.14482-1.48544c-2.63973-3.42499-5.28518-6.62393-7.94964-10.20395 c-2.66584-3.53729-5.42716-7.26584-7.98398-11.28766c-2.56365-4.01544-4.99268-8.25293-7.33468-12.61462 c-2.35801-4.35956-4.59769-8.85022-6.96265-13.40027l-0.12282-0.24149c-1.68017-3.22345-5.18914-5.28107-9.03326-4.92944 c-5.07852,0.46463-8.81879,4.95819-8.35423,10.03668c0.53559,5.85507,1.83849,11.58978,3.63141,17.20157 c1.81411,5.6059,4.15076,11.08893,7.06559,16.38187c2.92678,5.27692,6.36161,10.4549,10.84886,15.01331 c0.57322,0.56082,1.10473,1.13531,1.71299,1.67831l1.84489,1.59579c1.20013,1.06537,2.59435,2.01968,3.95342,2.95392 l1.03104,0.68579l1.10526,0.63339c0.74477,0.40897,1.48478,0.81567,2.23682,1.19504 c1.52065,0.74634,3.18863,1.35239,4.8047,1.87903c2.91859,0.92813,6.28616,0.47668,8.89568-1.53455 C91.74554,365.36221,92.53153,359.29245,89.27252,355.06387z" })
			),
			_react2.default.createElement("path", { className: "fill", d: "M183.56053,318.54993c-5.87268-8.4939-15.88342-3.75516-25.77545-5.81998 c-5.18793-1.08289-10.25452-1.04285-15.01746-0.07214c-3.71997-3.21313-8.09076-5.31128-13.21973-5.61353 c-43.17676-2.54443-49.78925,31.2605-49.79333,55.59619c-0.00171,9.97925,3.81616,15.91833,9.33826,19.45349 c1.31616,1.28259,2.90582,2.32727,4.72888,3.0304l20.76172,8.00586c1.65625,0.63867,3.35938,0.94141,5.03418,0.94141 c4.92755,0,9.60938-2.62134,12.13342-7.01306c9.63361-0.42786,18.79071-2.48828,24.61755-6.80859 c1.94684,0.52356,3.89386,0.94495,5.79272,1.16235c13.67871,1.56653,21.63263-10.14514,25.30225-21.71594 C190.96196,348.66525,190.21324,328.17188,183.56053,318.54993z" }),
			_react2.default.createElement(
				"g",
				{ className: "kitten-head" },
				_react2.default.createElement("path", { className: "fill", d: "M165.0278,335.3399c-18.85588,0-32.7605-4.00308-42.84024-12.71207l-4.28545,3.53915 c-0.53389,0.44098-1.17966,0.6557-1.8217,0.6557c-0.82539,0-1.64395-0.35458-2.21017-1.04044 c-1.0075-1.21945-0.83533-3.02469,0.38473-4.03186l3.93945-3.25336c-1.06223-1.33231-1.99732-2.74911-2.79794-4.25034 l-6.02364,2.0535c-0.30641,0.1044-0.61781,0.15411-0.92422,0.15411c-1.19209,0-2.30463-0.74985-2.71111-1.9407 c-0.51028-1.49728,0.28963-3.12476,1.7869-3.63504l5.72123-1.95038c-0.39619-1.37848-0.69499-2.81448-0.89062-4.30936 l-7.80836-0.48666c-1.57868-0.09821-2.77824-1.45779-2.68004-3.03647c0.09882-1.5784,1.44133-2.78198,3.0368-2.68036 l7.10809,0.44299l0.00503-0.00055c0.45473-15.71692,3.75923-40.26196,8.20982-51.07301 c1.28097-4.08058,6.46807-6.46989,9.97176-3.68637l0.00003,0.00005c6.71091,3.88071,14.97617,10.15529,21.5551,16.22003 c5.07869-1.45221,7.69962-2.25397,13.27455-2.25397s8.19586,0.80176,13.27454,2.25397 c6.57893-6.06474,14.84421-12.33932,21.5551-16.22003l0.00005-0.00005c3.50368-2.78352,8.69078-0.39421,9.97176,3.68637 c4.45058,10.81105,7.7551,35.35609,8.20982,51.07301l0.00502,0.00055l7.10809-0.44299 c1.59546-0.10162,2.93797,1.10196,3.03679,2.68036c0.09821,1.57867-1.10135,2.93826-2.68004,3.03647l-7.80836,0.48666 c-0.19562,1.49487-0.49443,2.93088-0.89061,4.30936l5.72122,1.95038c1.49727,0.51028,2.29718,2.13776,1.78691,3.63504 c-0.40649,1.19086-1.51903,1.9407-2.71112,1.9407c-0.30641,0-0.6178-0.04971-0.92422-0.15411l-6.02364-2.0535 c-0.80061,1.50122-1.7357,2.91803-2.79793,4.25034l3.93945,3.25336c1.22006,1.00717,1.39223,2.81241,0.38472,4.03186 c-0.56621,0.68585-1.38477,1.04044-2.21016,1.04044c-0.64204,0-1.28781-0.21472-1.8217-0.6557l-4.28546-3.53915 C197.78828,331.33682,183.88367,335.3399,165.0278,335.3399z" })
			),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M190.24883,329.96841c-16.45052-5.85941-34.15047-5.85941-50.60098,0 c-2.96281,1.05511-4.67184,3.86008-4.67184,7.00513v23.51096v23.51071c0,3.14508,1.81615,5.95001,4.77896,7.00534l0,0 c16.45053,5.85922,34.12457,5.85922,50.5751,0l0,0c2.96281-1.05533,4.64594-3.86026,4.64594-7.00534V360.4845v-23.51096 C194.976,333.82849,193.21165,331.02353,190.24883,329.96841z" }),
			_react2.default.createElement("ellipse", { fill: "#E6E6E6", cx: "165.0278", cy: "335.26093", rx: "24.02005", ry: "2.79503" }),
			_react2.default.createElement("path", { fill: "#5E4C3E", d: "M146.49506,337.34152c12.16498,3.06766,24.9005,3.06766,37.06548,0 C171.39555,334.27386,158.66003,334.27386,146.49506,337.34152z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M198.87834,381.06885h-6.9707c-3.03711,0-5.5-2.4624-5.5-5.5s2.46289-5.5,5.5-5.5h6.9707 c2.99023,0,5.42285-2.43262,5.42285-5.42236v-7.4917c0-2.98975-2.43262-5.42236-5.42285-5.42236h-6.9707 c-3.03711,0-5.5-2.4624-5.5-5.5s2.46289-5.5,5.5-5.5h6.9707c9.05566,0,16.42285,7.36719,16.42285,16.42236v7.4917 C215.30119,373.70166,207.93401,381.06885,198.87834,381.06885z" }),
			_react2.default.createElement("path", { className: "fill", d: "M194.54387,346.48471h-0.43213c-7.73242,0-14,6.26758-14,14s6.26758,14,14,14h0.43213 c7.73242,0,11.9984-6.26758,11.9984-14S202.27629,346.48471,194.54387,346.48471z" }),
			_react2.default.createElement("path", { className: "fill", d: "M136.97562,374.48471h0.43213c7.73242,0,14-6.26758,14-14s-6.26758-14-14-14h-0.43213 c-7.73242,0-11.99841,6.26758-11.99841,14S129.24319,374.48471,136.97562,374.48471z" }),
			_react2.default.createElement(
				"g",
				{ className: "kitten-head" },
				_react2.default.createElement("path", { className: "kitten-tongue", fill: "#FC7E7E", d: "M165.02734,335.83331c-3.86621,0-7-3.13379-7-7v-6.33203c0-3.86621,3.13379-7,7-7s7,3.13379,7,7v6.33203 C172.02734,332.69952,168.89355,335.83331,165.02734,335.83331z" }),
				_react2.default.createElement("path", { className: "fill", d: "M164.07344,323.72589c0.55946-0.31567,1.23274-0.33337,1.80511-0.04175 c1.79506,0.91452,5.89143,2.68472,13.87825,2.686c10.76874,0.00174,0-18.0036,0-18.0036l0.35493-24.36826h-30.61328l0.658,24.36826 c0,0-10.4485,17.91531,0,18.0036C157.82808,326.435,162.40186,324.6691,164.07344,323.72589z" }),
				_react2.default.createElement("path", { className: "fill--face", d: "M165.01428,314.46347h2.6465c1.32248,0,2.0892,1.27225,1.31607,2.18381l-1.05519,1.24414l-1.59503,1.82654 c-0.65137,0.74591-1.96706,0.742-2.61226-0.00778l-1.60747-1.86804l-1.02158-1.18716 c-0.78352-0.91052-0.01808-2.1915,1.30951-2.1915H165.01428z" })
			),
			_react2.default.createElement("path", { fill: "#5E4C3E", d: "M146.49506,337.34152c12.16498,3.06766,24.9005,3.06766,37.06548,0l-10.49269-1.50119h-16.25586 L146.49506,337.34152z" }),
			_react2.default.createElement(
				"g",
				{ className: "kitten-head" },
				_react2.default.createElement("path", { fill: "#EFEFEF", d: "M143.39084,318.2966c-0.14497,0-0.28995-0.00104-0.437-0.00311 c-14.47986-0.18433-15.34039-10.88965-15.96896-18.70587c-0.07767-0.97131-0.1543-1.91678-0.25163-2.81665l2.10835-0.22781 c0.09941,0.91748,0.17708,1.88364,0.25681,2.87463c0.65654,8.15897,1.33481,16.59546,13.88237,16.75494 c4.9395,0.0849,8.44995-1.00757,10.71983-3.27023c3.51564-3.50732,3.45041-9.54242,3.39862-14.39081l0.96202-0.02173 l-0.88228-0.35934c1.12251-2.75867,4.07275-4.54184,7.51382-4.54184h0.67413c3.44109,0,6.39131,1.78317,7.51384,4.54184 l-0.91335,0.37177l0.99307,0.00931c-0.05385,5.01303-0.11494,10.69397,3.32718,14.19406 c2.26678,2.30304,5.80209,3.43799,10.81096,3.46698c0.05283,0,0.1077,0,0.16051,0c12.14888,0,12.88515-8.20557,13.59967-16.14294 c0.10977-1.22607,0.21436-2.38483,0.3614-3.51044l2.10213,0.27545c-0.14186,1.09039-0.24542,2.24399-0.35208,3.42554 c-0.72383,8.05542-1.62682,18.07211-15.70697,18.07315c-0.06006,0-0.11702,0-0.17708,0 c-5.6012-0.03314-9.62839-1.37415-12.31042-4.10071c-3.99301-4.06033-3.99197-10.33463-3.93916-15.44705 c-0.85535-1.85049-2.97612-3.03619-5.4697-3.03619h-0.67413c-2.49356,0-4.61433,1.1857-5.46968,3.03619 c0.05385,5.20148,0.05592,11.58658-4.02408,15.65829C152.57602,317.02081,148.70934,318.2966,143.39084,318.2966z" }),
				_react2.default.createElement("path", { fill: "#1C1C1C", d: "M158.17047,301.74493c-1.24254,0-2.32959-0.85056-2.62277-2.06607 c-0.0033-0.01318-0.8736-3.2605-3.63405-4.17496c-2.0687-0.56064-4.91151-1.00732-8.72476-1.01126l-8.64636,0.35904 c-0.0929,0.01382-0.1871,0.02307-0.28264,0.02768c-2.65636,0.11923-4.43913,2.69061-4.45691,2.71698 c-0.56659,0.83209-1.55022,1.2847-2.5582,1.16873c-1.00009-0.12054-1.85656-0.77939-2.21034-1.72281l-1.34927-3.59781 c-0.30372-0.80969-0.20094-1.71689,0.27737-2.43829c0.47765-0.72076,1.27284-1.1694,2.13721-1.20499l16.9218-0.70297 c0.03755-0.00198,0.07445-0.00262,0.112-0.00262c4.12289,0,7.3643,0.46512,9.88231,1.11539 c0.07379,0.0145,0.14824,0.03293,0.22202,0.05402c0.05403,0.01581,0.10674,0.03162,0.1601,0.04742 c5.07687,1.38879,7.0619,3.51218,7.35706,3.85739c0.5231,0.61008,0.7471,1.42108,0.61139,2.21298l-0.53563,3.12018 c-0.21675,1.26163-1.28996,2.19781-2.57005,2.24066C158.23042,301.74426,158.2001,301.74493,158.17047,301.74493z" }),
				_react2.default.createElement("path", { fill: "#EFEFEF", d: "M129.24756,294.28775h-2.02343c-0.58611,0-1.06039-0.47427-1.06039-1.06036 c0-0.58612,0.47427-1.06039,1.06039-1.06039h2.02343c0.58612,0,1.06039,0.47427,1.06039,1.06039 C130.30795,293.81348,129.83368,294.28775,129.24756,294.28775z" }),
				_react2.default.createElement("path", { fill: "#1C1C1C", d: "M171.8871,301.73373c-0.03755,0-0.07445-0.00067-0.112-0.00266 c-1.27086-0.0527-2.33485-0.9744-2.55029-2.22812l-0.53561-3.12018c-0.13573-0.7919,0.08827-1.60291,0.61139-2.21298 c0.29515-0.34521,2.28149-2.4686,7.35704-3.85739c0.05336-0.01581,0.10608-0.03162,0.1601-0.04742 c0.07379-0.02109,0.14824-0.03952,0.22202-0.05402c2.51802-0.65027,5.75941-1.11539,9.88231-1.11539 c0.03755,0,0.07445,0.00064,0.112,0.00262l16.92181,0.70297c0.86436,0.03558,1.65956,0.48422,2.13721,1.20499 c0.4783,0.72141,0.58109,1.6286,0.27736,2.43829l-1.34926,3.59781c-0.35643,0.95068-1.21619,1.62137-2.22549,1.73401 c-1.00865,0.11597-1.99623-0.34982-2.5549-1.19708c-0.00594-0.00922-1.78871-2.5806-4.44507-2.69983 c-0.09554-0.00461-0.18974-0.01385-0.28264-0.02768l-8.64636-0.35904c-3.82709,0.00461-6.68307,0.45786-8.75572,1.02182 c-2.73607,0.92828-3.59979,4.15189-3.60835,4.18549C174.19363,300.89505,173.11252,301.73373,171.8871,301.73373z" }),
				_react2.default.createElement("path", { fill: "#EFEFEF", d: "M202.83154,294.28775h-2.02344c-0.58611,0-1.06039-0.47427-1.06039-1.06036 c0-0.58612,0.47429-1.06039,1.06039-1.06039h2.02344c0.58611,0,1.06038,0.47427,1.06038,1.06039 C203.89192,293.81348,203.41765,294.28775,202.83154,294.28775z" })
			),
			_react2.default.createElement(
				"g",
				{ className: "kitten-eyes" },
				_react2.default.createElement(
					"g",
					{ className: "kitten-head" },
					_react2.default.createElement("ellipse", { className: "fill--eyes", transform: "matrix(0.98481 -0.17365 0.17365 0.98481 -49.84289 36.68232)", cx: "184.71899", cy: "303.19461", rx: "5.28059", ry: "5.86732" }),
					_react2.default.createElement("ellipse", { className: "fill--eyes", transform: "matrix(0.17365 -0.98481 0.98481 0.17365 -178.48923 393.67401)", cx: "145.33659", cy: "303.19461", rx: "5.86732", ry: "5.28059" })
				)
			),
			_react2.default.createElement(
				"g",
				{ className: "kitten-eyes--blink" },
				_react2.default.createElement(
					"g",
					{ className: "kitten-head" },
					_react2.default.createElement("path", { className: "fill--face", d: "M149.34225,306.96368c-0.09863,0-0.19824-0.00977-0.29883-0.03027l-8.625-1.74072 c-0.81152-0.16357-1.33691-0.95508-1.17383-1.76709c0.16406-0.8125,0.9541-1.33838,1.76758-1.17334l8.625,1.74072 c0.81152,0.16357,1.33691,0.95508,1.17383,1.76709C150.66745,306.47198,150.04147,306.96368,149.34225,306.96368z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M180.71335,306.96368c-0.69922,0-1.3252-0.4917-1.46875-1.20361c-0.16309-0.81201,0.3623-1.60352,1.17383-1.76709 l8.625-1.74072c0.81152-0.16455,1.60352,0.36084,1.76758,1.17334c0.16309,0.81201-0.3623,1.60352-1.17383,1.76709l-8.625,1.74072 C180.91159,306.95392,180.81198,306.96368,180.71335,306.96368z" })
				)
			)
		);
	}
	
	exports.default = Coffee;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Fan() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill", d: "M197.38,329.22c0-.89-.07-1.78-.13-2.66-.88-11.54-5.78-21-15.54-27.44-8.62-5.68-19.59-6.81-29.54-5a36.91,36.91,0,0,0-15.11,6.34c-12.19,1.12-25.94,8.09-37.11,20-12.2,13-18.35,28.67-17.57,41.6l-.82,0a171.23,171.23,0,0,0-18.21.4c-6.08.39-12.18,1-18.31,2-3.06.48-6.16,1.06-9.24,1.76-1.57.37-3.14.76-4.69,1.19s-3.21,1-4.78,1.54a9.16,9.16,0,0,0,2.92,17.81h.66l16.87.19q8.68.07,17.5,0c5.87-.05,11.75-.09,17.65-.51a107.59,107.59,0,0,0,14.82-2,35.8,35.8,0,0,0,14.1,3.43h4.88c15,0,20-5,21.28-12.23l.13-.06a14,14,0,0,0,27.84-2V363c1.65-.84,3.18-1.64,4.5-2.37v12.82a14,14,0,0,0,28,0V330.67A14.16,14.16,0,0,0,197.38,329.22Z", fill: "#f1f1f1" }),
			_react2.default.createElement(
				"g",
				{ className: "kitten-head" },
				_react2.default.createElement("path", { className: "fill", d: "M162.83,312.69c-18.86,0-32.76-4-42.84-12.71l-4.29,3.54a2.86,2.86,0,0,1-3.65-4.42l3.94-3.25a27.77,27.77,0,0,1-2.8-4.25l-6,2.05a2.86,2.86,0,1,1-1.85-5.42l5.72-2a29.38,29.38,0,0,1-.89-4.31l-7.81-.49a2.86,2.86,0,0,1,.36-5.72l7.11.44h0c.45-15.72,3.76-40.26,8.21-51.07,1.28-4.08,6.47-6.47,10-3.69h0a133.15,133.15,0,0,1,21.56,16.22c5.08-1.45,7.7-2.25,13.27-2.25s8.2.8,13.27,2.25a133.15,133.15,0,0,1,21.56-16.22h0c3.5-2.78,8.69-.39,10,3.69,4.45,10.81,7.76,35.36,8.21,51.07h0l7.11-.44a2.86,2.86,0,0,1,.36,5.72l-7.81.49a29.38,29.38,0,0,1-.89,4.31l5.72,2a2.86,2.86,0,1,1-1.85,5.42l-6-2.05a27.77,27.77,0,0,1-2.8,4.25l3.94,3.25a2.86,2.86,0,1,1-3.65,4.42L205.67,300C195.59,308.69,181.69,312.69,162.83,312.69Z", fill: "#f1f1f1" }),
				_react2.default.createElement("path", { d: "M104.83,263.12,103,256.2a219.2,219.2,0,0,1-4-41.36,65.34,65.34,0,0,1,3.55-21.55,2.8,2.8,0,0,0,.16-.94V125.74c0-7.76,5.64-17,12.67-20.31,17.62-8.2,34.92,4.54,34.92,21.24v13.91a.13.13,0,0,0,.13.13H156a23.2,23.2,0,0,1,13.43,4.23,2.76,2.76,0,0,0,2.39.39,23.37,23.37,0,0,1,6.85-1h1a23.32,23.32,0,0,1,15,5.52,2.65,2.65,0,0,0,2.32.56,23.28,23.28,0,0,1,5.33-.62h2.67a21.6,21.6,0,0,1,21.6,21.6v14.34a23.2,23.2,0,0,1-2.46,10.46,2.93,2.93,0,0,0-.21,2.16,64.29,64.29,0,0,1,2.67,18.39,187.39,187.39,0,0,1-4.12,39.81l-2,6.59s-11.81,3.66-55.8,3.66S104.83,263.12,104.83,263.12Z", fill: "#75c69f" }),
				_react2.default.createElement("path", { d: "M219.24,173.57A16.48,16.48,0,0,0,193.44,160,16.45,16.45,0,0,0,169,155.07a16.45,16.45,0,0,0-26-1.31V126.67a16.5,16.5,0,1,0-33,0v67.51a56.85,56.85,0,0,0-3.72,20.68A218.53,218.53,0,0,0,110,254.23a2,2,0,0,0,3.92-.81,213.94,213.94,0,0,1-3.68-38.56c0-9.37,2.35-31.92,24-38.82,7-2.1,12.48-2.13,16.13-.07,2.63,1.48,4.39,4,5.37,7.81,1.94,7.47-2.29,13.92-10.51,16.06l-5.46,1.39a2,2,0,0,0,1,3.88l5.47-1.39a19.9,19.9,0,0,0,9.81-5.67c3.66,1,8.06,2.9,10.36,6.65a2,2,0,0,0,3.41-2.09c-2.23-3.62-6.13-6.36-11.34-8a15.45,15.45,0,0,0,1-2.44,16.4,16.4,0,0,0,6.05-2.94,16.48,16.48,0,0,0,22.82,4.18,16.58,16.58,0,0,0,14.34,8.34,16.4,16.4,0,0,0,9.39-3,53.12,53.12,0,0,1,3.11,17.94,181.93,181.93,0,0,1-3.67,36.65,2,2,0,1,0,3.9.9,182.33,182.33,0,0,0,3.77-37.55,57.1,57.1,0,0,0-3.93-20.82,16.42,16.42,0,0,0,3.93-10.66Zm-86.1-1.35A35.13,35.13,0,0,0,114,186.49V126.67a12.5,12.5,0,1,1,25,0v44.19A45.55,45.55,0,0,0,133.14,172.22Zm19.27.27a17.85,17.85,0,0,0-9.42-2v-6a12.5,12.5,0,1,1,25,0v11.67a12.46,12.46,0,0,1-7.72,11.55,17.94,17.94,0,0,0-.58-4.94C158.44,178,156,174.5,152.41,172.48Zm16.06,13.86A16.46,16.46,0,0,0,172,176.17V164.5a16.39,16.39,0,0,0-1.08-5.82,12.38,12.38,0,0,1,8.2-3.08,12.52,12.52,0,0,1,12.5,12.5v11.67a12.5,12.5,0,0,1-23.13,6.58Zm23,4.31a16.41,16.41,0,0,0,4.13-10.89V168.1a16.42,16.42,0,0,0-.6-4.36,12.5,12.5,0,0,1,20.23,9.83v11.67a12.44,12.44,0,0,1-3.28,8.41,2,2,0,0,0-.74.75,12.47,12.47,0,0,1-19.74-3.73Z", fill: "#f2f2f2" }),
				_react2.default.createElement("path", { d: "M135.5,239.58v-4.47h5.14l1.17-5.06h-4.43v-4.52h5.31l1.8-8.11h5l-1.84,8.11h4.6l1.8-8.11h4.89L157,225.53h3.81V230h-4.6l-1.09,5.06h4.35v4.47H154l-1.51,6.94h-4.85l1.51-6.94H144.5L143,246.53h-4.89l1.46-6.94Zm10-4.43h4.73l1.17-5.06h-4.77Z", fill: "#f2f2f2" }),
				_react2.default.createElement("path", { d: "M166.79,246.53v-6.4h6.36V226.74h-6.36v-4.81a23,23,0,0,0,9.16-2.93q1.42-.79,2.59-1.59h2.8v22.71h6.11v6.4Z", fill: "#f2f2f2" }),
				_react2.default.createElement(
					"g",
					{ className: "kitten-eyes" },
					_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "182.52", cy: "276.55", rx: "5.28", ry: "5.87", transform: "translate(-45.25 35.9) rotate(-10)" }),
					_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "143.14", cy: "276.55", rx: "5.87", ry: "5.28", transform: "translate(-154.06 369.49) rotate(-80)" })
				),
				_react2.default.createElement(
					"g",
					{ className: "kitten-eyes--blink" },
					_react2.default.createElement("path", { className: "fill--face", d: "M147.15,280.09a1.49,1.49,0,0,1-.3,0l-8.62-1.74a1.5,1.5,0,1,1,.59-2.94l8.63,1.74a1.5,1.5,0,0,1-.29,3Z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M178.52,280.09a1.5,1.5,0,0,1-.29-3l8.63-1.74a1.5,1.5,0,1,1,.59,2.94l-8.62,1.74A1.49,1.49,0,0,1,178.52,280.09Z" })
				),
				_react2.default.createElement("path", { className: "fill--face", d: "M162.82,287.82h2.65c1.32,0,2.09,1.27,1.32,2.18l-1.06,1.24-1.6,1.83a1.8,1.8,0,0,1-2.61,0l-1.61-1.87-1-1.19c-.78-.91,0-2.19,1.31-2.19Z" })
			)
		);
	}
	
	exports.default = Fan;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Frisky() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { d: "M82.6,389.3c7.1,0.9,13-5.3,20.3-3.6c4.1,1,7.6,3.5,11.9,3.8c4.5,0.3,8.4-1.2,12-3.9 c2.9-2.1,5.6-3.7,9.2-4.1c4.3-0.5,8.7-0.1,13,0.4c8.7,1.1,17.1,3.5,25.1,7.2c3.2,1.5,1.7,6.9-1.5,5.4c-8-3.7-16.4-6.2-25.1-7.1 c-4-0.4-8.8-1.1-12.7-0.1c-3.9,1.1-6.8,4.6-10.5,6.1c-7.3,3-13.5,1-20.5-1.6c-7.5-2.9-13.7,4-21.3,3.1 C79,394.5,79.1,388.8,82.6,389.3z", fill: "#75C69F" }),
			_react2.default.createElement("path", { d: "M82.5,394.9c-0.7-0.1-1.3-0.4-1.7-0.9c0.3-0.3,0.6-0.6,1.1-0.7c2.5-0.9,4.4-2.6,6.2-4.5 c4.8-1.3,9.3-4.2,14.6-3.1c-0.2,0-0.5,0.1-0.7,0.1c-5,0.6-7.9,4.5-11.1,7.9C88.1,394.5,85.4,395.3,82.5,394.9z", fill: "#5994C9" }),
			_react2.default.createElement("path", { d: "M102.6,391.5c0.1,0,0.2,0,0.4,0c4.2,0,8.1,1.7,12.4,1c4.3-0.7,7.8-3.1,10.8-6.4c0.2-0.2,0.5-0.3,0.7-0.5 c2.9-2.1,5.6-3.7,9.2-4.1c4.3-0.5,8.7-0.1,13,0.4c1.3,0.2,2.5,0.4,3.8,0.6c-2,0.1-4,0.2-6,0.5c-4,0.5-8.8,0.9-12.4,2.9 c-1.9,1.1-3.4,2.7-4.9,4.4c-1.7,1.2-3.4,2.5-5.2,3.2c-7.3,3-13.5,1-20.5-1.6C103.4,391.7,103,391.6,102.6,391.5z", fill: "#5994C9" }),
			_react2.default.createElement(
				"g",
				{ className: "whole-kitten" },
				_react2.default.createElement("path", { className: "fill", d: "M169.8,338c-17.2,7.8-31.5,10-44.3,6.2l-2.4,5c-0.3,0.6-0.8,1.1-1.4,1.4c-0.8,0.3-1.6,0.4-2.4,0 c-1.4-0.7-2-2.4-1.3-3.8l2.2-4.6c-1.5-0.8-3-1.7-4.3-2.7l-4.6,4.4c-0.2,0.2-0.5,0.4-0.8,0.5c-1.1,0.5-2.4,0.3-3.3-0.6 c-1.1-1.2-1-3,0.1-4l4.4-4.1c-0.9-1.1-1.8-2.3-2.6-3.6l-7.3,2.8c-1.5,0.6-3.1-0.2-3.7-1.7c-0.6-1.5,0.2-3.1,1.7-3.7l6.7-2.5l0,0 c-6.1-14.5-13.3-38.2-13.7-49.9c-0.5-4.2,3.2-8.6,7.5-7.5l0,0c7.7,0.7,17.8,3,26.3,5.8c4-3.4,6.1-5.2,11.1-7.6s7.8-2.7,13-3.5 c3.5-8.2,8.4-17.4,12.9-23.7l0,0c2-4,7.7-4,10.6-0.8c8.5,8,21.7,28.9,28.7,43.1l0,0l6.3-3.4c1.4-0.8,3.1-0.2,3.9,1.2 c0.7,1.4,0.2,3.1-1.2,3.9l-6.9,3.7c0.4,1.4,0.8,2.9,1,4.3l6-0.6c1.6-0.2,3,1,3.1,2.6c0.1,1.3-0.6,2.4-1.7,2.9 c-0.3,0.1-0.6,0.2-0.9,0.2l-6.3,0.6c-0.1,1.7-0.4,3.4-0.8,5l4.9,1.3c1.5,0.4,2.4,2,2,3.5c-0.2,0.9-0.8,1.5-1.6,1.9 c-0.6,0.3-1.3,0.3-1.9,0.2l-5.4-1.4C197.9,320.8,186.9,330.2,169.8,338z" }),
				_react2.default.createElement("ellipse", { className: "fill", cx: "185.8", cy: "357.6", rx: "42.6", ry: "50.8", transform: "matrix(0.1171 -0.9931 0.9931 0.1171 -191.1207 500.2079)" }),
				_react2.default.createElement("ellipse", { className: "fill", cx: "180.8", cy: "355.6", rx: "42.6", ry: "50.8", transform: "matrix(0.3178 -0.9482 0.9482 0.3178 -213.8423 413.9724)" }),
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("path", { d: "M195.9,364.1c-12,2-26.3-6.7-27.5-25.5c-1.2-18.8,14.2-29.9,24-28.8c14.1-5.7,34.5,7.9,33.8,23.2 C228.8,349.5,215.8,366.1,195.9,364.1z", fill: "#5994C9" }),
					_react2.default.createElement(
						"g",
						null,
						_react2.default.createElement(
							"defs",
							null,
							_react2.default.createElement("path", { id: "SVGID_27_", d: "M195.9,364.1c-12,2-26.3-6.7-27.5-25.5c-1.2-18.8,14.2-29.9,24-28.8c14.1-5.7,34.5,7.9,33.8,23.2 C228.8,349.5,215.8,366.1,195.9,364.1z" })
						),
						_react2.default.createElement(
							"clippath",
							{ id: "SVGID_2_" },
							_react2.default.createElement("path", { d: "M195.9,364.1c-12,2-26.3-6.7-27.5-25.5c-1.2-18.8,14.2-29.9,24-28.8c14.1-5.7,34.5,7.9,33.8,23.2 C228.8,349.5,215.8,366.1,195.9,364.1z" })
						)
					)
				),
				_react2.default.createElement("path", { d: "M188.6,310c-2,0.3-4.1,1-6.1,2.1c-4.8,15.6-5.9,32-3.2,48c1.8,1.3,3.8,2.3,5.8,3 C181.4,345.5,182.6,327.1,188.6,310z", fill: "#75C69F" }),
				_react2.default.createElement("path", { d: "M192.4,330.7c0.1-0.9,0.2-1.8,0.3-2.6c0.2,0,0.4,0,0.7,0c10.8-1.3,21.7-2.4,32.3,0c-0.5-2-1.3-4-2.5-5.8 c-9.8-1.6-19.8-0.6-29.6,0.5c0.3-1.3,0.6-2.7,0.9-4c0,0,0,0,0,0c8.2-0.2,17.9-1.7,26.3,0.2c-2-2.3-4.3-4.3-7-6 c-6-0.2-12.1,0.3-17.9,0.6c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.1-0.5,0.1-0.7c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3,0.2-0.6,0.3-0.9 c0.4,0.2,0.9,0.4,1.5,0.3c3.2-0.3,6.3-0.5,9.5-0.7c-5.2-1.9-10.8-2.2-15.7-0.3c-0.2,0-0.4,0-0.6,0c-0.1,0.2-0.1,0.3-0.2,0.5 c-0.1,0.2-0.1,0.5-0.1,0.7c-0.2,0.2-0.4,0.5-0.5,0.9c-5.6,17-5.8,35.4-0.8,52.4c1.8,0.2,3.6,0.1,5.4-0.2c-1.1-3.6-2-7.2-2.6-10.9 c3.8,3.5,7.5,7,11.3,10.5c2-0.4,4-1,5.8-1.7c-5.4-5-10.8-10.1-16.2-15.1c-0.6-0.5-1.2-0.7-1.8-0.7c-0.1-1.5-0.2-2.9-0.3-4.4 c6.6,7.1,14.1,13.1,22.3,18c1.6-1,3-2.2,4.3-3.5c-9.3-5.4-17.7-12.2-24.9-20.3c-0.1-0.1-0.2-0.2-0.3-0.3c1.4-0.1,2.9-0.3,4.3-0.4 c7.6,6.3,13.9,14.3,22.5,19.2c1.1-1.3,2.1-2.8,3-4.3c-6.9-3.9-12.3-10-18.2-15.4c1.9-0.1,3.9-0.2,5.8-0.2 c4.2,4.7,8.8,8.9,13.9,12.5c0.7-1.7,1.2-3.5,1.5-5.3c-3-2.2-5.8-4.6-8.5-7.3c2.9,0,5.9,0.1,8.8,0.6c-0.1-0.7-0.1-1.4-0.2-2.2 c0-1,0-2-0.1-3c-2.5-0.3-5-0.4-7.4-0.5C209.9,329.2,201.1,329.9,192.4,330.7z", fill: "#75C69F" }),
				_react2.default.createElement("path", { className: "fill", d: "M222.3,375.1c0,0,1-0.1,2.8-0.2c0.4,0,0.9,0,1.5-0.1c0.5,0,1-0.1,1.6-0.1c1.1-0.1,2.3-0.2,3.8-0.3 c1.4-0.1,2.9-0.2,4.5-0.4c1.6-0.1,3.3-0.3,5-0.5c0.9-0.1,1.7-0.2,2.6-0.3c0.9-0.1,1.8-0.2,2.6-0.3c0.9-0.1,1.8-0.2,2.7-0.4 c0.9-0.1,1.8-0.3,2.7-0.4c0.9-0.1,1.8-0.3,2.6-0.5c0.9-0.2,1.7-0.3,2.6-0.5c1.7-0.4,3.3-0.7,4.8-1.1c0.8-0.2,1.6-0.3,2.3-0.5 c0.7-0.2,1.4-0.4,2.1-0.5c1.4-0.4,2.6-0.7,3.8-1c0.6-0.2,1.1-0.3,1.7-0.5c0.6-0.1,1-0.3,1.5-0.4c0.9-0.3,1.8-0.5,2.4-0.7 c0.6-0.2,1.2-0.3,1.6-0.4c0.4-0.1,0.6-0.1,0.6-0.1l2.4-0.4c5.3-0.8,10.3,2.8,11.1,8.1c0.4,2.8-0.4,5.5-2,7.5c0,0-0.2,0.3-0.6,0.7 c-0.4,0.5-1,1.1-1.8,1.9c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.5,0.4-0.7,0.6c-0.5,0.4-1.1,0.9-1.7,1.4c-1.2,1-2.7,1.8-4.3,2.8 c-0.8,0.5-1.6,0.9-2.5,1.4c-0.9,0.4-1.8,0.9-2.8,1.3c-1.9,0.8-3.9,1.6-6.1,2.1c-2.1,0.7-4.3,1.1-6.5,1.5c-2.2,0.4-4.5,0.8-6.7,0.9 c-2.3,0.3-4.5,0.4-6.7,0.4c-2.2,0-4.4,0-6.4,0c-2.1-0.1-4.1-0.2-6-0.4c-1.9-0.2-3.7-0.4-5.3-0.7c-1.6-0.2-3.2-0.6-4.5-0.9 c-0.7-0.2-1.3-0.3-1.9-0.4c-0.5-0.1-1-0.3-1.4-0.4c-1.7-0.5-2.7-0.8-2.7-0.8c-4.9-1.6-7.5-6.9-5.9-11.7 C215.5,377.8,218.7,375.4,222.3,375.1z" }),
				_react2.default.createElement("path", { d: "M180,313.6c-2.8,1.9-5.4,4.5-7.4,7.7c-1.9,8.6-2.7,17.4-2.5,26.2c1.4,3.9,3.4,7.2,5.9,9.7 C174.1,342.6,175.5,327.7,180,313.6z", fill: "#75C69F" }),
				_react2.default.createElement("path", { className: "fill", d: "M149.3,374.2c-3.9,0-7.7-1.6-10.5-4.7c-5.1-5.8-4.6-14.6,1.1-19.8l18.5-16.5c5.8-5.1,14.6-4.6,19.8,1.1 c5.1,5.8,4.6,14.6-1.1,19.8l-18.5,16.5C155.9,373,152.6,374.2,149.3,374.2z" }),
				_react2.default.createElement("path", { className: "fill", d: "M206.3,389.6c-4.5,0-8.9-2.2-11.6-6.1l-9.7-14.3c-4.3-6.4-2.7-15.1,3.7-19.4c6.4-4.3,15.1-2.7,19.4,3.7 l9.7,14.3c4.3,6.4,2.7,15.1-3.7,19.4C211.8,388.8,209,389.6,206.3,389.6z" }),
				_react2.default.createElement("path", { className: "fill", d: "M228.7,367.4c-4.5,0-8.9-2.2-11.6-6.1l-4.1-6.1c-4.3-6.4-2.7-15.1,3.7-19.4c6.4-4.3,15.1-2.7,19.4,3.7 l4.1,6.1c4.3,6.4,2.7,15.1-3.7,19.4C234.2,366.6,231.4,367.4,228.7,367.4z" }),
				_react2.default.createElement("path", { className: "fill--face", d: "M166.4,315.4l2.4-1.1c1.2-0.5,2.4,0.3,2.1,1.4l-0.4,1.6l-0.7,2.3c-0.3,0.9-1.5,1.5-2.4,1.1l-2.2-1l-1.4-0.7 c-1.1-0.5-0.9-2,0.3-2.5L166.4,315.4z" }),
				_react2.default.createElement(
					"g",
					{ className: "kitten-eyes" },
					_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "178.7", cy: "296.9", rx: "5.3", ry: "5.9", transform: "matrix(0.8239 -0.5667 0.5667 0.8239 -136.8163 153.5579)" }),
					_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "142.9", cy: "313.3", rx: "5.3", ry: "5.9", transform: "matrix(0.968 -0.2508 0.2508 0.968 -73.9952 45.8335)" })
				),
				_react2.default.createElement(
					"g",
					{ className: "kitten-eyes--blink" },
					_react2.default.createElement("path", { className: "fill--face", d: "M139.3,316.7c-0.7,0-1.3-0.5-1.5-1.1c-0.2-0.8,0.3-1.6,1.1-1.8l8-2c0.8-0.2,1.6,0.3,1.8,1.1c0.2,0.8-0.3,1.6-1.1,1.8l-8,2 C139.6,316.7,139.4,316.7,139.3,316.7z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M175.8,301.7c-0.4,0-0.8-0.2-1.1-0.5c-0.6-0.6-0.5-1.6,0.1-2.1l6-5.6c0.6-0.6,1.6-0.5,2.1,0.1c0.6,0.6,0.5,1.6-0.1,2.1 l-6,5.6C176.5,301.5,176.2,301.7,175.8,301.7z" })
				)
			)
		);
	}
	
	exports.default = Frisky;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Midi() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill", fill: "#F1F1F1", d: "M214.3422852,342.5367737c-0.9009399-11.5395508-6.9268188-21.0024414-16.9488525-27.440918 c-8.8469849-5.6831055-20.1038818-6.8115234-30.3106689-5.0297852c-5.9741211,1.043457-11.2683105,3.3261719-15.7426758,6.5092773 c-11.8011475,1.534668-24.8812256,8.4194336-35.59552,19.8276367 c-18.9624634,20.190918-25.3308716,46.8935547-11.7570801,59.6411133 c4.7337036,4.4458008,5.7537842,13.2822266,17.6411133,15.6806641c0,0,10.1521606,2,12.9020996,2 c15.4165649,0,17.6149292-7.9208984,16.5678711-14.8037109l9.3510132-11.0805664 c11.0854492-4.6196289,34.9232178-7.109375,37.1392822-7.7050781 C211.2086182,376.4762268,215.2872925,354.6402893,214.3422852,342.5367737z" }),
			_react2.default.createElement("path", { fill: "#5994C9", d: "M330.3323364,379.683136v40.2079773v0.0103149H150.3206787v-0.0103149V379.683136 c0-2.9573975,2.3974304-5.3547974,5.3547974-5.3547974h13.9203339c1.3096313,0,2.3657837,1.0667114,2.3657837,2.3657837v0.1268616 v6.7690735h136.7284088l-0.0019226-6.7690735c0.0350342,0,0.0634155-0.0284119,0.0634155-0.063446l0,0 c0-1.3360596,1.0931702-2.4291992,2.4292297-2.4291992h13.8074036 C327.934845,374.3283386,330.3323364,376.7258301,330.3323364,379.683136z" }),
			_react2.default.createElement("path", { fill: "#75C69F", d: "M164.0975342,400.2272644h-5.9127808c-0.9886932,0-1.7901917-0.8014832-1.7901917-1.7901917V380.633667 c0-0.9887085,0.8014984-1.7901917,1.7901917-1.7901917h5.9127808c0.988678,0,1.7901764,0.8014832,1.7901764,1.7901917v17.8034058 C165.8877106,399.4257812,165.0862122,400.2272644,164.0975342,400.2272644z" }),
			_react2.default.createElement("path", { fill: "#A2D8C0", d: "M161.9852142,390.4361877h-1.6881561c-0.9886932,0-1.7901764-0.8014832-1.7901764-1.7901917v-5.9000244 c0-0.988678,0.8014832-1.7901917,1.7901764-1.7901917h1.6881561c0.9886932,0,1.7901764,0.8015137,1.7901764,1.7901917v5.9000244 C163.7753906,389.6347046,162.9739075,390.4361877,161.9852142,390.4361877z" }),
			_react2.default.createElement("rect", { x: "190.4375", y: "395.4804688", fill: "#F2F2F2", width: "2.1132812", height: "18.1582031" }),
			_react2.default.createElement("rect", { x: "209.9697266", y: "395.4804688", fill: "#F2F2F2", width: "2.1132812", height: "18.1582031" }),
			_react2.default.createElement("rect", { x: "249.0341797", y: "395.4804688", fill: "#F2F2F2", width: "2.1132812", height: "18.1582031" }),
			_react2.default.createElement("rect", { x: "268.5664062", y: "395.4804688", fill: "#F2F2F2", width: "2.1132812", height: "18.1582031" }),
			_react2.default.createElement("rect", { x: "288.0996094", y: "395.4804688", fill: "#F2F2F2", width: "2.1132812", height: "18.1582031" }),
			_react2.default.createElement("path", { fill: "#FC5959", d: "M319.5102234,388.3366394h-0.0000305c-2.6105957,0-4.7465515-2.1359558-4.7465515-4.746582l0,0 c0-2.6106262,2.1359558-4.746582,4.7465515-4.746582h0.0000305c2.6105957,0,4.7465515,2.1359558,4.7465515,4.746582l0,0 C324.2567749,386.2006836,322.1208191,388.3366394,319.5102234,388.3366394z" }),
			_react2.default.createElement("path", { fill: "#F2F2F2", d: "M305.0097656,419.3462524h-129.369873c-2.0314636,0-3.678299-1.6468201-3.678299-3.6782837v-20.1872864 h136.7264862v20.1872864C308.6880798,417.6994324,307.0412598,419.3462524,305.0097656,419.3462524z" }),
			_react2.default.createElement("path", { fill: "#FC5959", d: "M319.5102234,400.2272644h-0.0000305c-2.6105957,0-4.7465515-2.1359558-4.7465515-4.7465515v-0.0000305 c0-2.6105957,2.1359558-4.7465515,4.7465515-4.7465515h0.0000305c2.6105957,0,4.7465515,2.1359558,4.7465515,4.7465515v0.0000305 C324.2567749,398.0913086,322.1208191,400.2272644,319.5102234,400.2272644z" }),
			_react2.default.createElement("path", { fill: "#FC7E7E", d: "M319.5102234,386.2243042L319.5102234,386.2243042c-1.4488525,0-2.6342773-1.1854248-2.6342773-2.6342468 l0,0c0-1.4488525,1.1854248-2.6342773,2.6342773-2.6342773l0,0c1.448822,0,2.6342468,1.1854248,2.6342468,2.6342773l0,0 C322.1444702,385.0388794,320.9590454,386.2243042,319.5102234,386.2243042z" }),
			_react2.default.createElement("path", { fill: "#FC7E7E", d: "M319.5102234,398.1149597L319.5102234,398.1149597c-1.4488525,0-2.6342773-1.1854248-2.6342773-2.6342773 l0,0c0-1.448822,1.1854248-2.6342468,2.6342773-2.6342468l0,0c1.448822,0,2.6342468,1.1854248,2.6342468,2.6342468l0,0 C322.1444702,396.9295349,320.9590454,398.1149597,319.5102234,398.1149597z" }),
			_react2.default.createElement("path", { className: "kitten-tail fill", fill: "#F1F1F1", d: "M113.8843384,381.3766174l-0.5292358-0.4204102 c-4.1571045-3.2998047-8.2711792-6.8632812-12.2469482-10.6503906c-3.9815063-3.7827148-7.836792-7.7592773-11.5076294-11.8530273 c-3.6759033-4.0898438-7.0936279-8.3579102-10.4239502-12.4951172c-3.3584595-4.125-6.4545288-8.2290039-9.4819336-11.956543 l-1.0297852-1.2700195c-2.0422974-2.5-5.289856-3.9213867-8.7276611-3.4804688 c-5.2977295,0.6801758-9.0412598,5.5258789-8.3613892,10.8237305c0.4868164,3.7929688,1.5101318,7.4238281,2.8720093,10.6591797 c0.3463745,0.8120117,0.680542,1.6352539,1.0462646,2.4433594c0.3775635,0.7880859,0.7632446,1.5507812,1.1687622,2.3164062 l1.2247925,2.2880859l1.3325806,2.1689453c3.6231079,5.7524414,8.0022583,10.7651367,12.6629639,15.4248047 c4.6776733,4.6469727,9.7294312,8.8852539,15.2125854,12.6264648c1.406189,0.9018555,2.7998047,1.8129883,4.2139893,2.6865234 c1.4455566,0.8540039,2.9313354,1.6552734,4.4030762,2.4526367c1.5062256,0.7753906,3.0577393,1.4985352,4.5999756,2.1938477 c1.5857544,0.6708984,3.2223511,1.2685547,4.8392334,1.8388672c3.5769653,1.2548828,7.7211914,0.1953125,10.2105103-2.940918 C118.5045166,390.2745667,117.8427124,384.518219,113.8843384,381.3766174z" }),
			_react2.default.createElement("rect", { x: "229.5019531", y: "374.331543", fill: "#F2F2F2", width: "2.1132812", height: "36.2994766" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M209.9699707,395.4811096v15.1499023h-17.4199829v-15.1499023h2.4899902 c1.25,0,2.2600098-1.0102539,2.2600098-2.2700195v-18.8798828h7.9199829v18.8798828 c0,1.2597656,1.0100098,2.2700195,2.2600098,2.2700195H209.9699707z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M249.0300293,395.4811096v15.1499023h-17.4100342v-36.2998047h12.6600342v18.8798828 c0,1.2597656,1.0199585,2.2700195,2.2699585,2.2700195H249.0300293z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M268.5700073,395.4811096v15.1499023h-17.4199829v-15.1499023h2.4799805 c1.2600098,0,2.2700195-1.0102539,2.2700195-2.2700195v-18.8798828h7.9099731v18.8798828 c0,1.2597656,1.0200195,2.2700195,2.2700195,2.2700195H268.5700073z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M288.0999756,395.4811096v15.1499023h-17.4199829v-15.1499023h2.4899902 c1.25,0,2.2600098-1.0102539,2.2600098-2.2700195v-18.8798828h7.9199829v18.8798828 c0,1.2597656,1.0100098,2.2700195,2.2600098,2.2700195H288.0999756z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M308.6900024,376.6910706v33.9399414H290.210022v-15.1499023h2.4899902 c1.25,0,2.2600098-1.0102539,2.2600098-2.2700195v-18.8798828h11.3699951 C307.6300049,374.3312073,308.6900024,375.3907776,308.6900024,376.6910706z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M229.5,374.3312073v36.2998047h-17.4199829v-15.1499023h2.4899902 c1.25,0,2.2700195-1.0102539,2.2700195-2.2700195v-18.8798828H229.5z" }),
			_react2.default.createElement("path", { fill: "#FFFFFF", d: "M190.4400024,395.4811096v15.1499023H171.960022v-33.9399414 c0-1.300293,1.0599976-2.3598633,2.3599854-2.3598633h11.3699951v18.8798828c0,1.2597656,1.0100098,2.2700195,2.2600098,2.2700195 H190.4400024z" }),
			_react2.default.createElement("rect", { className: "key-left", x: "171.960022", y: "398.4248657", fill: "#FFFFFF", width: "18.4799805", height: "12.2061424" }),
			_react2.default.createElement("rect", { className: "key-right", x: "212.0800171", y: "398.4249878", fill: "#FFFFFF", width: "17.4199829", height: "12.206027" }),
			_react2.default.createElement("path", { fill: "#4a88ba", d: "M315.0765991,410.62854h-1.8436279h-4.5448608v5.0394287 c0,2.0314941-1.6468506,3.6782227-3.6783447,3.6782227h-129.369873c-2.0314941,0-3.6782837-1.6467285-3.6782837-3.6782227 V410.62854h-4.5415649h-7.5650635h-9.5343018v13.4871826c0,0,0,0,0,0.0102539c0,1.3099365,0.5280762,2.513916,1.3942261,3.3693848 c0.8660889,0.8662109,2.0594482,1.404541,3.3796387,1.404541h170.4639282c2.6404419,0,4.7738647-2.1437988,4.7738647-4.7739258 c0-0.0102539,0-0.0102539,0-0.0102539V410.62854H315.0765991z" }),
			_react2.default.createElement("path", { fill: "#494949", d: "M195.0377502,395.4806824h-7.0875854c-1.2509613,0-2.2650757-1.0140991-2.2650757-2.2650757v-18.8872681 c0-1.2509766,2.0702667-4.8869019,3.3212433-4.8869019h4.9752655c1.2509613,0,3.321228,3.6359253,3.321228,4.8869019v18.8872681 C197.3028259,394.4665833,196.2887115,395.4806824,195.0377502,395.4806824z" }),
			_react2.default.createElement("path", { fill: "#494949", d: "M214.5701599,395.4806824h-7.0875854c-1.2509613,0-2.2650757-1.0140991-2.2650757-2.2650757v-18.8872681 c0-1.2509766,2.0702667-4.8869019,3.321228-4.8869019h4.9752808c1.2509613,0,3.321228,3.6359253,3.321228,4.8869019v18.8872681 C216.8352356,394.4665833,215.8211212,395.4806824,214.5701599,395.4806824z" }),
			_react2.default.createElement("path", { fill: "#494949", d: "M253.6348572,395.4806824h-7.0875854c-1.2509766,0-2.2650757-1.0140991-2.2650757-2.2650757v-18.8872681 c0-1.2509766,2.0702667-4.8869019,3.321228-4.8869019h4.9752655c1.2509766,0,3.321228,3.6359253,3.321228,4.8869019v18.8872681 C255.8999176,394.4665833,254.8858185,395.4806824,253.6348572,395.4806824z" }),
			_react2.default.createElement("path", { fill: "#494949", d: "M273.1672058,395.4806824h-7.0875854c-1.250946,0-2.2650757-1.0140991-2.2650757-2.2650757v-18.8872681 c0-1.2509766,2.070282-4.8869019,3.3212585-4.8869019h4.9752502c1.2509766,0,3.321228,3.6359253,3.321228,4.8869019v18.8872681 C275.4322815,394.4665833,274.4181824,395.4806824,273.1672058,395.4806824z" }),
			_react2.default.createElement("path", { fill: "#494949", d: "M292.699585,395.4806824h-7.0875854c-1.2509766,0-2.2650757-1.0140991-2.2650757-2.2650757v-18.8872681 c0-1.2509766,2.070282-4.8869019,3.321228-4.8869019h4.9752808c1.250946,0,3.321228,3.6359253,3.321228,4.8869019v18.8872681 C294.9646606,394.4665833,293.9505615,395.4806824,292.699585,395.4806824z" }),
			_react2.default.createElement("path", { className: "kitten-arm-right fill", fill: "#F1F1F1", d: "M228.6357422,379.5816956l-17.6953125-48.0351562 c-2.671875-7.2543945-10.7128906-10.9702148-17.9765625-8.2973633c-7.2548828,2.6728516-10.9697266,10.7207031-8.296875,17.9760742 l17.6953125,48.0351562c2.0849609,5.659668,7.4394531,9.1645508,13.1386719,9.1645508 c1.6064453,0,3.2412109-0.2792969,4.8378906-0.8671875C227.59375,394.8849182,231.3085938,386.8370667,228.6357422,379.5816956z" }),
			_react2.default.createElement("path", { className: "kitten-arm-left fill", fill: "#F1F1F1", d: "M175.6923828,335.546051c-2.671875-7.2539062-10.71875-10.9707031-17.9765625-8.296875 c-7.2548828,2.6728516-10.9697266,10.7211914-8.296875,17.9765625l17.6962891,48.0351562 c2.0849609,5.6591797,7.4394531,9.1640625,13.1386719,9.1640625c1.6064453,0,3.2421875-0.2792969,4.8378906-0.8671875 c7.2548828-2.6728516,10.9697266-10.7211914,8.296875-17.9765625L175.6923828,335.546051z" }),
			_react2.default.createElement(
				"g",
				{ className: "kitten-head" },
				_react2.default.createElement("path", { className: "fill", fill: "#F1F1F1", d: "M181.6304169,329.6701965c-18.8558655,0-32.7604828-4.0030823-42.8402252-12.7120667l-4.2854614,3.5391541 c-0.5338898,0.4409485-1.179657,0.6557007-1.821701,0.6557007c-0.8253937,0-1.6439514-0.3545837-2.2101593-1.0404358 c-1.0075073-1.2194519-0.8353424-3.0246887,0.3847198-4.0318604l3.9394531-3.2533875 c-1.0622253-1.3322754-1.9973297-2.7490845-2.7979279-4.2503357l-6.0236435,2.0534973 c-0.3064117,0.1044312-0.6178055,0.1541443-0.9242172,0.1541443c-1.1920929,0-2.3046341-0.7498779-2.711113-1.9407349 c-0.5102768-1.4972534,0.2896347-3.1247253,1.7868958-3.6350098l5.7212296-1.9504089 c-0.3961945-1.378479-0.6949921-2.8144836-0.8906097-4.3093262l-7.8083725-0.4866638 c-1.5786819-0.0982056-2.7782364-1.4577942-2.6800385-3.036499c0.0988235-1.5783691,1.44133-2.7819519,3.0367966-2.6803284 l7.1080933,0.4429932l0.0050201-0.0005493c0.4547272-15.7169189,3.7592316-40.2619629,8.2098236-51.0730133 c1.2809753-4.0805817,6.4680786-6.4698944,9.971756-3.6863708l0.0000458,0.0000305 c6.7108917,3.880722,14.9761658,10.155304,21.5550995,16.220047c5.0786743-1.4522095,7.6996002-2.2539825,13.2745361-2.2539825 s8.1958618,0.8017731,13.2745361,2.2539825c6.578949-6.064743,14.8442078-12.339325,21.5551147-16.220047l0.0000305-0.0000305 c3.5036774-2.7835236,8.6907806-0.3942108,9.971756,3.6863708c4.450592,10.8110504,7.7550964,35.3560944,8.2098236,51.0730133 l0.0050201,0.0005493l7.1080933-0.4429932c1.5954742-0.1016235,2.937973,1.1019592,3.0368042,2.6803284 c0.0981903,1.5787048-1.1013489,2.9382935-2.6800385,3.036499l-7.8083649,0.4866638 c-0.1956329,1.4948425-0.4944305,2.9308472-0.890625,4.3093262l5.7212372,1.9504089 c1.4972687,0.5102844,2.2971649,2.1377563,1.7868958,3.6350098c-0.4064789,1.1908569-1.5190277,1.9407349-2.7111206,1.9407349 c-0.3064117,0-0.6177979-0.0497131-0.9242096-0.1541443l-6.0236359-2.0534973 c-0.8006134,1.5012512-1.7357025,2.9180603-2.7979431,4.2503357l3.9394531,3.2533875 c1.2200623,1.0071716,1.3922272,2.8124084,0.3847351,4.0318604c-0.5662231,0.6858521-1.3847809,1.0404358-2.2101593,1.0404358 c-0.6420441,0-1.2878113-0.2147522-1.8217163-0.6557007l-4.2854462-3.5391541 C214.3909149,325.6671143,200.4862976,329.6701965,181.6304169,329.6701965z" }),
				_react2.default.createElement("path", { className: "fill--face", d: "M181.6169128,304.7905579h2.6464996c1.3224792,0,2.0891876,1.2722473,1.3160553,2.1838074l-1.055191,1.2441406 l-1.5950165,1.8265381c-0.6513824,0.7459106-1.9670715,0.7420044-2.6122742-0.007782l-1.6074524-1.868042l-1.0215912-1.1871643 c-0.7835083-0.910553-0.0180817-2.1914978,1.3095093-2.1914978H181.6169128z" }),
				_react2.default.createElement(
					"g",
					{ className: "kitten-eyes" },
					_react2.default.createElement("ellipse", { className: "fill--eyes", transform: "matrix(0.9848077 -0.1736482 0.1736482 0.9848077 -47.9109764 39.4183884)", cx: "201.3216248", cy: "293.5216675", rx: "5.2805867", ry: "5.8673186" }),
					_react2.default.createElement("ellipse", { className: "fill--eyes", transform: "matrix(0.1736482 -0.9848077 0.9848077 0.1736482 -155.2436676 402.031189)", cx: "161.9392242", cy: "293.5216675", rx: "5.8673186", ry: "5.2805867" })
				),
				_react2.default.createElement(
					"g",
					{ className: "kitten-eyes--blink" },
					_react2.default.createElement("path", { className: "fill--face", d: "M165.94487,296.8925476c-0.0986328,0-0.1982422-0.0097656-0.2988281-0.0302734l-8.625-1.7407227 c-0.8115234-0.1635742-1.3369141-0.9550781-1.1738281-1.7670898c0.1640625-0.8125,0.9541016-1.3383789,1.7675781-1.1733398 l8.625,1.7407227c0.8115234,0.1635742,1.3369141,0.9550781,1.1738281,1.7670898 C167.2700653,296.4008484,166.6440887,296.8925476,165.94487,296.8925476z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M197.3159637,296.8925476c-0.6992188,0-1.3251953-0.4916992-1.46875-1.2036133 c-0.1630859-0.8120117,0.3623047-1.6035156,1.1738281-1.7670898l8.625-1.7407227 c0.8115234-0.1645508,1.6035156,0.3608398,1.7675781,1.1733398c0.1630859,0.8120117-0.3623047,1.6035156-1.1738281,1.7670898 l-8.625,1.7407227C197.5142059,296.882782,197.4145966,296.8925476,197.3159637,296.8925476z" })
				),
				_react2.default.createElement(
					"g",
					{ opacity: "0.8" },
					_react2.default.createElement("polygon", { fill: "#222222", points: "144.7229614,286.5132141 146.9851685,299.3269348 152.8153229,305.5252075 162.4585571,306.7701721 170.0411072,304.3217163 174.1367188,297.9936523 174.9036407,288.9599304 170.8157806,283.7884216 157.1763916,282.7504578 145.5986633,282.7504578 \t\t\t" })
				),
				_react2.default.createElement(
					"g",
					{ opacity: "0.8" },
					_react2.default.createElement("polygon", { fill: "#222222", points: "218.568161,286.5132141 216.305954,299.3269348 210.4757996,305.5252075 200.8325653,306.7701721 193.2500153,304.3217163 189.1544189,297.9936523 188.3874969,288.9599304 192.4753571,283.7884216 206.1147461,282.7504578 217.6924591,282.7504578 \t\t\t" })
				),
				_react2.default.createElement(
					"g",
					{ opacity: "0.5" },
					_react2.default.createElement("rect", { x: "144.1429138", y: "288.0778503", transform: "matrix(0.7049354 -0.7092715 0.7092715 0.7049354 -160.2228546 196.3071899)", fill: "#FFFFFF", width: "23.3714027", height: "5.2926226" })
				),
				_react2.default.createElement(
					"g",
					{ opacity: "0.5" },
					_react2.default.createElement("rect", { x: "147.910614", y: "292.6906433", transform: "matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -160.3295441 200.9576721)", fill: "#FFFFFF", width: "29.0039806", height: "2.6461263" })
				),
				_react2.default.createElement(
					"g",
					{ opacity: "0.5" },
					_react2.default.createElement("rect", { x: "187.1458435", y: "287.8322449", transform: "matrix(0.7049354 -0.7092715 0.7092715 0.7049354 -147.3600159 226.7354736)", fill: "#FFFFFF", width: "23.3714027", height: "5.2926226" })
				),
				_react2.default.createElement(
					"g",
					{ opacity: "0.5" },
					_react2.default.createElement("rect", { x: "190.9135437", y: "292.4447937", transform: "matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -147.5604248 231.2933197)", fill: "#FFFFFF", width: "29.0039806", height: "2.6461263" })
				),
				_react2.default.createElement("path", { fill: "#1C1C1C", d: "M221.6259766,281.2511292c-0.4111328-0.6191406-1.0927734-1.0039062-1.8349609-1.034668 l-16.6894531-0.690918c-4.0898438,0-7.2802734,0.4667969-9.7382812,1.1123047 c-0.0185547,0.0048828-0.0380859,0.0097656-0.0576172,0.015625c-3.3853149,0.8974609-5.3640137,2.1318359-6.3822021,2.9423828 c-1.4330444-0.8100586-3.135437-1.2714844-4.9625244-1.2714844h-0.6611328c-1.8264771,0-3.5253296,0.4658203-4.958313,1.2753906 c-0.9885864-0.7866211-2.8880615-1.9750977-6.1207886-2.8666992c-0.0800781-0.0253906-0.1611328-0.050293-0.2431641-0.0737305 c-0.0839844-0.0239258-0.1669922-0.0429688-0.2509766-0.0576172c-2.4501953-0.6259766-5.6162109-1.0742188-9.6552734-1.0742188 c-0.0019531,0-0.0058594,0-0.0078125,0l-16.59375,0.6889648c-0.7421875,0.0307617-1.4238281,0.4155273-1.8339844,1.034668 c-0.4111328,0.6186523-0.4990234,1.3964844-0.2382812,2.0917969l1.3232422,3.5283203 c0.0264282,0.0708008,0.072998,0.1279297,0.1057739,0.1948242c0.0836792,0.809082,0.1530151,1.6513672,0.2233276,2.5185547 c0.6181641,7.6943359,1.5527344,19.3222656,16.9150391,19.519043c0.1484375,0.0014648,0.2958984,0.0024414,0.4433594,0.0024414 c5.5712891,0,9.6582031-1.3725586,12.4814453-4.1899414c4.2338257-4.2246094,4.3723755-10.496582,4.3267822-15.734375 l0.0518799-0.3022461c0.7223511-1.1806641,2.2419434-1.9243164,4.0314941-1.9243164h0.6611328 c1.7895508,0,3.3091431,0.7436523,4.0314941,1.9243164l0.0518799,0.3022461 c-0.0445557,5.1469727,0.0946045,11.309082,4.2349854,15.5185547c2.8798828,2.9287109,7.1240234,4.3686523,12.9736328,4.4033203 c0.0595703,0,0.1171875,0,0.1757812,0c14.9785156-0.0004883,16.0019531-11.3574219,16.6796875-18.8828125 c0.0991211-1.109375,0.1958008-2.1552734,0.321167-3.1459961c0.0344849-0.0693359,0.0828247-0.1293945,0.1104736-0.2036133 l1.3232422-3.5283203C222.1240234,282.6476135,222.0351562,281.8697815,221.6259766,281.2511292z M169.6191406,301.6378479 c-1.9423828,1.9375-5.1640625,2.8945312-9.5957031,2.8349609c-10.3671875-0.1328125-11.6240234-6.1279297-12.3574219-15.2587891 c-0.0722046-0.8989258-0.1453247-1.7709961-0.2322998-2.6103516c0.760376-0.8041992,2.1772461-1.9853516,4.0096436-2.0683594 c0.0898438-0.0039062,0.1787109-0.0126953,0.265625-0.0273438l8.4501953-0.3515625 c3.78125,0,6.609375,0.4394531,8.6748047,0.9951172c2.480835,0.7973633,3.4993896,3.359375,3.7523804,4.1220703 C172.6245117,293.8087463,172.5089722,298.7540588,169.6191406,301.6378479z M203.2802734,304.4728088 c-4.5546875-0.0273438-7.7275391-1.0146484-9.6992188-3.0195312c-2.8267212-2.8740234-2.9440918-7.7265625-2.9065552-12.1777344 c0.2640991-0.7949219,1.3172607-3.4243164,3.8919067-4.1660156l0.0009766-0.0004883 c2.0371094-0.5371094,4.7929688-0.9541016,8.4384766-0.9545898l8.5537109,0.3554688 c0.0849609,0.0126953,0.1708984,0.0214844,0.2578125,0.0253906c1.8310547,0.0830078,3.2476807,1.2631836,4.0062256,2.0639648 c-0.12854,1.0375977-0.227356,2.0922852-0.3275146,3.206543 C214.6699219,298.9708557,213.4853516,304.5177307,203.2802734,304.4728088z" })
			)
		);
	}
	
	exports.default = Midi;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Rocketship() {
		return _react2.default.createElement(
			"g",
			{ className: "kitty-fly" },
			_react2.default.createElement(
				"g",
				{ className: "kitty-wiggle" },
				_react2.default.createElement(
					"g",
					{ className: "flame" },
					_react2.default.createElement("path", { d: "M163.3,329.4c8.3,9,10.1,22.9,10.6,28c0.1,0.9-0.8,1.5-1.6,1.1l-5-2.4c-2.8-1.4-6.2-0.4-7.8,2.3l-3.4,5.5 c-0.4,0.6-1.2,0.7-1.7,0.3l-5.6-4.9c-2.3-2-5.7-2-8,0l-5.6,4.9c-0.5,0.5-1.4,0.3-1.7-0.3l-3.4-5.5c-1.6-2.7-5-3.6-7.8-2.3l-5,2.4 c-0.8,0.4-1.7-0.2-1.6-1.1c0.4-5.1,2.3-18.9,10.6-28H163.3z", fill: "#FCB47E" }),
					_react2.default.createElement("path", { d: "M144.7,332.4l9.4-1c4,4,6.7,11.5,7.8,14.5c0.2,0.6-0.3,1.2-0.9,1.1c-2.8-0.6-6.2,1.5-7.7,4.1 c-0.5,0.9-1.9,1-2.8,0.3c-1.4-1-2.7-2.6-5.8-2.6c-3.2,0-4.5,1.6-5.8,2.6c-0.9,0.6-2.3,0.6-2.8-0.3c-1.4-2.5-4.8-4.7-7.7-4.1 c-0.6,0.1-1.1-0.5-0.9-1.1c1.1-2.9,3.8-10.4,7.8-14.5C135.3,331.4,144.7,332.4,144.7,332.4z", fill: "#F2CC7B" })
				),
				_react2.default.createElement("path", { className: "fill tail", d: "M114.4,296.1c0,0-1-0.1-2.8-0.4c-0.4-0.1-0.9-0.2-1.5-0.2c-0.6-0.1-1.2-0.3-1.9-0.4 c-1.4-0.3-2.9-0.6-4.5-1.1c-1.6-0.4-3.3-0.9-5.1-1.6c-1.8-0.6-3.7-1.3-5.6-2.1c-1.9-0.8-3.9-1.7-5.9-2.6c-2-1-4-2-5.9-3.2 c-2-1.1-3.9-2.4-5.7-3.7c-1.8-1.3-3.7-2.6-5.3-4.1c-1.7-1.4-3.2-3-4.6-4.5c-0.7-0.7-1.3-1.6-2-2.3c-0.6-0.8-1.2-1.5-1.7-2.3 c-1-1.6-2-2.9-2.7-4.4c-0.4-0.7-0.7-1.3-1-1.9c-0.1-0.3-0.3-0.6-0.4-0.9c-0.1-0.3-0.2-0.6-0.3-0.8c-0.4-1.1-0.7-1.9-0.9-2.5 c-0.2-0.6-0.3-0.9-0.3-0.9c-1.3-5.2,1.9-10.5,7.1-11.7c2.7-0.7,5.5-0.1,7.6,1.3l2.1,1.4c0,0,0.2,0.1,0.5,0.4 c0.3,0.2,0.7,0.6,1.2,1c0.5,0.5,1.2,1,1.9,1.6c0.4,0.3,0.7,0.7,1.2,1c0.4,0.4,0.9,0.7,1.3,1.1c0.9,0.8,2,1.6,3.1,2.5 c0.6,0.4,1.2,0.9,1.7,1.4c0.6,0.5,1.2,0.9,1.8,1.4c1.2,1,2.6,2,3.9,3c0.7,0.5,1.4,1,2.1,1.5c0.7,0.5,1.4,1,2.2,1.5 c0.8,0.5,1.5,1,2.2,1.5c0.8,0.5,1.5,1,2.3,1.4c0.7,0.5,1.5,0.9,2.3,1.4c0.8,0.5,1.5,0.9,2.2,1.4c1.5,0.9,2.9,1.7,4.3,2.5 c1.4,0.8,2.7,1.5,4,2.2c1.2,0.7,2.3,1.3,3.3,1.8c0.5,0.3,0.9,0.5,1.4,0.8c0.5,0.2,0.9,0.5,1.3,0.7c1.6,0.8,2.5,1.4,2.5,1.4 c4.4,2.5,6,8.2,3.4,12.7C121.6,294.7,118,296.4,114.4,296.1z", fill: "#F1F1F1" }),
				_react2.default.createElement("path", { className: "fill", d: "M194,292.7c-2.5-2.7-5.9-4.2-9.3-4.4c1-3.9,1.6-8.3,1.6-13.1c0-28-19.1-51.7-42.7-51.7 c-23.6,0-42.6,23.7-42.6,51.8c0,4.1,0.4,7.8,1.2,11.2c-2.2,0.6-4.4,1.7-6.2,3.4c-5.7,5.3-6,14.1-0.7,19.8l5,5.4 c3.3,3.5,8,5,12.4,4.3c2.7-0.4,5.3-1.6,7.4-3.6c1.2-1.1,2.1-2.3,2.8-3.7c6.1,2.7,13.2,4,20.7,4c7.8,0,15.1-1.4,21.4-4.3 c0.6,1.9,1.6,3.6,3.1,5.2c5.3,5.7,14.1,6,19.8,0.7l5.4-5C199,307.2,199.3,298.3,194,292.7z", fill: "#F1F1F1" }),
				_react2.default.createElement(
					"g",
					{ className: "kitty-head" },
					_react2.default.createElement("path", { className: "fill", d: "M145.7,248.3c-18.7,2.3-33,0-44.1-7.4l-3.8,4c-0.5,0.5-1.1,0.8-1.7,0.9c-0.8,0.1-1.7-0.2-2.3-0.8 c-1.1-1.1-1.2-2.9-0.1-4l3.5-3.7c-1.2-1.2-2.3-2.5-3.3-3.9l-5.7,2.8c-0.3,0.1-0.6,0.2-0.9,0.3c-1.2,0.1-2.4-0.5-2.9-1.6 c-0.7-1.4-0.1-3.1,1.3-3.8l5.4-2.6c-0.6-1.3-1-2.7-1.4-4.2l-7.8,0.5c-1.6,0.1-2.9-1.1-3-2.7c-0.1-1.6,1.1-2.9,2.7-3l7.1-0.4l0,0 c-1.4-15.7-1.1-40.4,2-51.7c0.8-4.2,5.6-7.2,9.5-4.9l0,0c7.1,3,16.1,8.3,23.4,13.5c4.9-2.1,7.4-3.2,12.9-3.8 c5.5-0.7,8.2-0.2,13.4,0.6c5.8-6.8,13.2-14,19.4-18.7l0,0c3.1-3.2,8.6-1.4,10.3,2.5c5.7,10.2,12,34.2,14.3,49.7l0,0l7-1.3 c1.6-0.3,3,0.7,3.3,2.3c0.3,1.6-0.7,3-2.3,3.3l-7.7,1.4c0,1.5-0.1,3-0.4,4.4l5.9,1.2c1.5,0.3,2.5,1.8,2.2,3.4 c-0.3,1.2-1.3,2.1-2.5,2.3c-0.3,0-0.6,0-0.9,0l-6.2-1.3c-0.6,1.6-1.4,3.1-2.3,4.6l4.3,2.8c1.3,0.9,1.7,2.6,0.9,4 c-0.5,0.7-1.2,1.2-2.1,1.3c-0.6,0.1-1.3-0.1-1.9-0.4l-4.7-3C177.8,240.4,164.5,246.1,145.7,248.3z", fill: "#F1F1F1" }),
					_react2.default.createElement(
						"g",
						{ className: "kitten-eyes" },
						_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "161.2", cy: "212.5", rx: "5.3", ry: "5.9", transform: "matrix(0.9566 -0.2913 0.2913 0.9566 -54.8996 56.172)" }),
						_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "122.1", cy: "217.2", rx: "5.9", ry: "5.3", transform: "matrix(5.347026e-02 -0.9986 0.9986 5.347026e-02 -101.3304 327.555)" })
					),
					_react2.default.createElement(
						"g",
						{ className: "kitten-eyes--blink" },
						_react2.default.createElement("path", { className: "fill--face", d: "M126.5,220.1c-0.1,0-0.2,0-0.3,0l-8.8-0.7c-0.8-0.1-1.4-0.8-1.4-1.6c0.1-0.8,0.8-1.4,1.6-1.4l8.8,0.7 c0.8,0.1,1.4,0.8,1.4,1.6C127.7,219.5,127.1,220,126.5,220.1z" }),
						_react2.default.createElement("path", { className: "fill--face", d: "M157.6,216.3c-0.7,0.1-1.4-0.3-1.6-1c-0.3-0.8,0.2-1.6,0.9-1.9l8.3-2.8c0.8-0.3,1.6,0.2,1.9,0.9c0.3,0.8-0.2,1.6-0.9,1.9 l-8.3,2.8C157.8,216.2,157.7,216.3,157.6,216.3z" })
					),
					_react2.default.createElement("path", { className: "fill--face", d: "M143,226l2.6-0.3c1.3-0.2,2.2,1,1.6,2l-0.9,1.4l-1.4,2c-0.6,0.8-1.9,1-2.6,0.3l-1.8-1.7l-1.2-1.1c-0.9-0.8-0.3-2.2,1-2.3 L143,226z" })
				),
				_react2.default.createElement("path", { d: "M120,290.5c-17.6,0-25.1,16.4-15.8,41c0.5,1.2,2.2,1.2,2.7,0c2-5.6,8.3-13.1,16.1-13.1", fill: "#FC5959" }),
				_react2.default.createElement("path", { d: "M169.3,290.5c17.6,0,25.1,16.4,15.8,41c-0.5,1.2-2.2,1.2-2.7,0c-2-5.6-8.3-13.1-16.1-13.1", fill: "#FC5959" }),
				_react2.default.createElement("path", { d: "M163.3,329.4c22.8-58.7-14.8-88.4-18.7-89.7c-3.9,1.3-41.4,31-18.7,89.7h0 C138.1,333.4,151.2,333.4,163.3,329.4L163.3,329.4z", fill: "#FFFFFF" }),
				_react2.default.createElement("path", { d: "M163.1,260.5c-7-13.3-16.5-20.2-18.4-20.8c-1.9,0.6-11.4,7.5-18.4,20.8 C138.2,264.3,151.1,264.3,163.1,260.5z", fill: "#FC5959" }),
				_react2.default.createElement("circle", { cx: "144.7", cy: "279.9", fill: "#A5C6EF", r: "9.8" }),
				_react2.default.createElement("path", { d: "M140.7,279.9c-1.6,0-2.6-1.7-1.9-3.1c1.1-2.1,3.3-3.5,5.9-3.5c2.6,0,4.8,1.4,5.9,3.5 c0.8,1.4-0.3,3.1-1.9,3.1H140.7z", fill: "#FFFFFF", opacity: "0.4" }),
				_react2.default.createElement("path", { d: "M122.3,318.4c1,3.6,2.2,7.2,3.7,11h0c12.1,4,25.2,4,37.3,0h0c1.5-3.8,2.7-7.5,3.7-11c0,0-9.2,3-22.5,3 S122.3,318.4,122.3,318.4z", fill: "#F2F2F2" }),
				_react2.default.createElement("path", { d: "M149,302l-3,36c-0.1,0.8-0.8,1.4-1.6,1.4c-0.7-0.1-1.3-0.7-1.4-1.4l-3-36c-0.2-2.5,1.6-4.7,4.1-4.9 s4.7,1.6,4.9,4.1C149,301.5,149,301.8,149,302z", fill: "#FC5959" }),
				_react2.default.createElement("path", { className: "fill", d: "M108.5,252.2l16.1-3.6c7.5-1.7,15,3.1,16.7,10.7c1.7,7.6-3.1,15-10.7,16.7l-21.9,4.8L108.5,252.2z", fill: "#F1F1F1" }),
				_react2.default.createElement("path", { className: "fill", d: "M183.8,285.5l-26.5-1.3c-3.5-0.9-6.3-3-8.2-5.7c-2.2-3.2-3-7.3-2-11.3c1.9-7.5,9.5-12,17-10.1l9.9,1.5 L183.8,285.5z", fill: "#F1F1F1" })
			)
		);
	}
	
	exports.default = Rocketship;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Scuba() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill", d: "M156.6,392.6c19-20.2,23.3-46.9,9.8-59.6s-39.9-6.7-58.9,13.5s-23.3,46.9-9.8,59.6 c4.7,4.4,13.7,7.6,20.6,7.7c0,0,11.1,0,13.9,0c15.4,0,20.2-5.3,21.4-12.8L156.6,392.6z", fill: "#FFFFFF" }),
			_react2.default.createElement("path", { className: "fill", d: "M206.8,355.6c-0.9-11.5-5.8-21-15.5-27.4c-8.6-5.7-19.6-6.8-29.5-5c-15.4,2.8-26.2,14.2-29.7,28.1 c-0.5,0.9-1.1,2.4-1.3,2.6c-0.9,1.7-1.9,3.4-2.8,5.1c-1.9,3.8-3.6,7.7-5.1,11.7c-3,8.3-6.2,19.6-1.5,27.8c3.2,5.5,9.7,8.7,15.9,8.5 c5.1-0.2,9.8-2.7,14.4-4.5c7.7-3.1,29.8-13,32-15.9c2.7-0.2,5.4-0.6,7.8-1.3C204.7,381.6,207.7,367.7,206.8,355.6z", fill: "#FFFFFF" }),
			_react2.default.createElement("path", { className: "fill", d: "M174.6,343.5c-18.8-1.9-32.2-7.3-41.3-17l-4.6,3.1c-0.6,0.4-1.2,0.5-1.9,0.5c-0.8-0.1-1.6-0.5-2.1-1.3 c-0.9-1.3-0.5-3.1,0.8-4l4.3-2.8c-0.9-1.4-1.7-2.9-2.3-4.5l-6.2,1.4c-0.3,0.1-0.6,0.1-0.9,0.1c-1.2-0.1-2.2-1-2.5-2.2 c-0.4-1.5,0.6-3.1,2.2-3.4l5.9-1.4c-0.3-1.4-0.4-2.9-0.4-4.4l-7.7-1.3c-1.6-0.3-2.6-1.7-2.4-3.3c0.3-1.6,1.7-2.6,3.3-2.4l7,1.2h0 c2.1-15.6,7.9-39.7,13.4-50c1.7-3.9,7.1-5.8,10.3-2.6l0,0c6.3,4.5,13.9,11.6,19.8,18.3c5.2-0.9,7.9-1.5,13.4-0.9s8.1,1.6,13,3.6 c7.2-5.4,16-10.8,23.1-13.9l0,0c3.8-2.4,8.7,0.5,9.5,4.7c3.3,11.2,4.1,36,2.9,51.6l0,0l7.1,0.3c1.6,0.1,2.8,1.4,2.7,3 c-0.1,1.6-1.4,2.8-3,2.7l-7.8-0.3c-0.3,1.5-0.8,2.9-1.3,4.2l5.5,2.5c1.4,0.7,2.1,2.4,1.4,3.8c-0.5,1.1-1.7,1.8-2.9,1.7 c-0.3,0-0.6-0.1-0.9-0.2l-5.8-2.7c-1,1.4-2,2.7-3.2,3.9l3.6,3.6c1.1,1.1,1.1,2.9,0,4.1c-0.6,0.6-1.5,0.9-2.3,0.8 c-0.6-0.1-1.3-0.3-1.7-0.8l-3.9-4C207.6,342.9,193.4,345.4,174.6,343.5z", fill: "#FFFFFF" }),
			_react2.default.createElement("path", { className: "fill--face", d: "M185.1,319.6l2.6,0.3c1.3,0.1,1.9,1.5,1.1,2.3l-1.2,1.1l-1.8,1.7c-0.7,0.7-2,0.5-2.6-0.3l-1.4-2l-0.9-1.3 c-0.7-1,0.2-2.2,1.5-2L185.1,319.6z" }),
			_react2.default.createElement("path", { className: "fill", d: "M101,402.2c0,0-1,0.3-2.7,0.8c-0.4,0.1-0.9,0.3-1.4,0.4c-0.6,0.1-1.2,0.3-1.9,0.4c-1.4,0.3-2.9,0.6-4.5,0.9 c-1.6,0.3-3.4,0.5-5.3,0.7c-1.9,0.2-3.9,0.3-6,0.4c-2.1,0.1-4.2,0.1-6.4,0c-2.2-0.1-4.4-0.2-6.7-0.4c-2.2-0.2-4.5-0.6-6.7-0.9 c-2.2-0.5-4.4-0.9-6.5-1.5c-2.1-0.6-4.2-1.4-6.1-2.1c-1-0.4-1.9-0.9-2.8-1.3c-0.9-0.4-1.7-0.8-2.5-1.4c-1.6-1-3-1.8-4.3-2.8 c-0.6-0.5-1.2-0.9-1.7-1.4c-0.3-0.2-0.5-0.4-0.7-0.6c-0.2-0.2-0.4-0.4-0.6-0.6c-0.8-0.8-1.4-1.4-1.8-1.9c-0.4-0.4-0.6-0.7-0.6-0.7 c-3.3-4.2-2.6-10.3,1.6-13.6c2.2-1.7,4.9-2.4,7.5-2l2.5,0.4c0,0,0.2,0,0.6,0.1c0.4,0.1,0.9,0.2,1.6,0.4c0.6,0.2,1.5,0.4,2.4,0.7 c0.5,0.1,0.9,0.3,1.5,0.4c0.5,0.1,1.1,0.3,1.7,0.5c1.2,0.3,2.5,0.6,3.8,1c0.7,0.2,1.4,0.3,2.1,0.5c0.7,0.2,1.5,0.3,2.3,0.5 c1.5,0.4,3.2,0.7,4.8,1.1c0.9,0.2,1.7,0.3,2.6,0.5c0.9,0.2,1.7,0.3,2.6,0.5c0.9,0.1,1.8,0.3,2.7,0.4c0.9,0.1,1.8,0.2,2.7,0.4 c0.9,0.1,1.8,0.2,2.6,0.3c0.9,0.1,1.7,0.2,2.6,0.3c1.7,0.2,3.4,0.4,5,0.5c1.6,0.2,3.1,0.3,4.5,0.4c1.4,0.1,2.6,0.2,3.8,0.3 c0.6,0.1,1.1,0.1,1.6,0.1c0.5,0,1,0,1.5,0.1c1.8,0.1,2.8,0.2,2.8,0.2c5.1,0.5,8.9,5,8.4,10.1C107,398,104.4,401,101,402.2z", fill: "#FFFFFF" }),
			_react2.default.createElement(
				"g",
				{ className: "arm" },
				_react2.default.createElement("path", { className: "fill", d: "M202.3,407.6c-3.7-1.2-6.9-4-8.5-8l-15.2-37c-2.9-7.2,0.5-15.3,7.6-18.3c7.2-2.9,15.3,0.5,18.3,7.6 l15.2,37c2.9,7.2-0.5,15.3-7.6,18.3C208.8,408.6,205.3,408.6,202.3,407.6z", fill: "#FFFFFF" }),
				_react2.default.createElement("path", { d: "M219.2,387.6l-26,10.7l-0.1,0c-1.4,0.6-4.7,0-6.7-4.8c-2-4.8,0.4-7.9,0.4-7.9s-3.8-0.3-5.8-5.1 c-2-4.8,0.3-7.8,1.3-8.2l0.1,0c0,0,23.7-9.7,26-10.7c1.4-0.6,4.7,0,6.7,4.8c2,4.8-0.4,7.9-0.4,7.9s3.8,0.3,5.8,5.1 C222.5,384.1,220.2,387.1,219.2,387.6z", fill: "#F9914B" })
			),
			_react2.default.createElement(
				"g",
				{ className: "kitten-eyes" },
				_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "204.9", cy: "311.3", rx: "5.3", ry: "5.9", transform: "matrix(0.9974 -7.172883e-02 7.172883e-02 0.9974 -21.8003 15.4986)" }),
				_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "168.7", cy: "307.5", rx: "5.9", ry: "5.3", transform: "matrix(0.2737 -0.9618 0.9618 0.2737 -173.1807 385.5556)" })
			),
			_react2.default.createElement(
				"g",
				{ className: "kitten-eyes--blink" },
				_react2.default.createElement("path", { className: "fill--face", d: "M163.9,308.3c-0.6-0.3-0.9-1-0.7-1.7c0.2-0.8,1-1.3,1.8-1.1l8,2.1c0.8,0.2,1.3,1,1.1,1.8c-0.2,0.8-1,1.3-1.8,1.1l-8-2.1 C164.1,308.4,164,308.4,163.9,308.3z" }),
				_react2.default.createElement("path", { className: "fill--face", d: "M200,313.6c-0.3-0.2-0.5-0.6-0.6-1c-0.1-0.8,0.5-1.6,1.4-1.6l8.2-0.8c0.8-0.1,1.6,0.5,1.6,1.4c0.1,0.8-0.5,1.6-1.4,1.6 l-8.2,0.8C200.7,313.9,200.3,313.8,200,313.6z" })
			),
			_react2.default.createElement("rect", { height: "9", width: "6", fill: "#F9914B", transform: "matrix(0.1026 -0.9947 0.9947 0.1026 -140.3468 462.9121)", x: "183.4", y: "304.7" }),
			_react2.default.createElement("ellipse", { cx: "204.9", cy: "310.3", fill: "#FFFFFF", opacity: "0.4", rx: "11.6", ry: "14", transform: "matrix(0.1026 -0.9947 0.9947 0.1026 -124.7689 482.2753)" }),
			_react2.default.createElement("path", { d: "M153,307.9c1.4,0,2.7-1,2.9-2.4c0.3-1.6-0.7-3.2-2.4-3.5c-15.8-3.1-25-9.4-25.2-9.5 c-0.4-0.3-0.8-0.4-1.2-0.5c-0.4,2.1-0.8,4.2-1.1,6.2c3.1,1.9,12.3,7,26.2,9.7C152.6,307.9,152.8,307.9,153,307.9z", fill: "#F9914B" }),
			_react2.default.createElement("ellipse", { cx: "167.7", cy: "306.5", fill: "#FFFFFF", opacity: "0.4", rx: "11.6", ry: "14", transform: "matrix(0.1026 -0.9947 0.9947 0.1026 -154.3266 441.8453)" }),
			_react2.default.createElement("path", { d: "M231.6,303c-4.2,4.2-12.3,4.7-12.4,4.7c-1.7,0.1-2.9,1.5-2.8,3.1c0.1,1.6,1.4,2.8,3,2.8c0.1,0,0.1,0,0.2,0 c0.3,0,6.3-0.4,11.8-3.2C231.4,308.2,231.5,305.7,231.6,303z", fill: "#F9914B" }),
			_react2.default.createElement("path", { d: "M168.2,320.9c-0.7,0-1.3,0-2-0.1c-4.4-0.4-8.3-2.3-11.2-5.2c-3-3.1-4.4-6.9-4-10.8 c0.4-3.9,2.6-7.4,6.1-9.8c3.4-2.3,7.6-3.3,12-2.8c9.2,0.9,16,8.1,15.2,16C183.6,315.5,176.6,320.9,168.2,320.9z M167.2,297.5 c-2.5,0-5,0.7-6.9,2c-2.2,1.5-3.5,3.5-3.7,5.8c-0.2,2.3,0.6,4.5,2.5,6.4c2,2,4.7,3.3,7.8,3.6c6.2,0.6,11.6-2.8,12.1-7.7l0,0 c0.5-4.9-4.1-9.4-10.3-10C168.1,297.5,167.6,297.5,167.2,297.5z", fill: "#5994C9" }),
			_react2.default.createElement("path", { d: "M205.4,324.7c-0.7,0-1.3,0-2-0.1c-4.4-0.4-8.3-2.3-11.2-5.2c-3-3.1-4.4-6.9-4-10.8 c0.4-3.9,2.6-7.4,6.1-9.8c3.4-2.3,7.6-3.3,12-2.8c9.2,0.9,16,8.1,15.2,16v0C220.8,319.3,213.7,324.7,205.4,324.7z M204.3,301.4 c-2.5,0-5,0.7-6.9,2c-2.2,1.5-3.5,3.5-3.7,5.8c-0.2,2.3,0.6,4.5,2.5,6.4c2,2,4.7,3.3,7.8,3.6c6.2,0.6,11.6-2.8,12.1-7.7 c0.5-4.9-4.1-9.4-10.3-10C205.3,301.4,204.8,301.4,204.3,301.4z", fill: "#5994C9" }),
			_react2.default.createElement("path", { className: "fill", d: "M176.2,412.2c-6,0-11.5-3.9-13.4-9.9l-11.7-38.2c-2.3-7.4,1.9-15.2,9.3-17.5c7.4-2.3,15.2,1.9,17.5,9.3 l11.7,38.2c2.3,7.4-1.9,15.2-9.3,17.5C178.9,412,177.5,412.2,176.2,412.2z", fill: "#FFFFFF" }),
			_react2.default.createElement("path", { d: "M189.2,392.7l-26.9,8.2l-0.1,0c-1.4,0.4-4.7-0.4-6.2-5.4c-1.5-5,1.2-7.8,1.2-7.8s-3.7-0.7-5.3-5.7 c-1.5-5,1-7.8,2.1-8.1l0.1,0c0,0,24.5-7.5,26.9-8.2c1.4-0.4,4.7,0.4,6.2,5.4c1.5,5-1.2,7.8-1.2,7.8s3.7,0.7,5.3,5.7 S190.3,392.3,189.2,392.7z", fill: "#F9914B" }),
			_react2.default.createElement("path", { d: "M213.5,385c3.7,7.7,10,13.9,17.7,17.6c16,7.8,33.1,7.2,47.1-1.5 c13.6-8.5,21.6-22.9,21.6-38.9c0-6.9-1.6-13.7-4.4-19.8c-6-2.2-6.1-3.6-13-3.6c-7.1,0-7.1,4-14.3,4c-7.1,0-7.1-4-14.3-4 c-7.1,0-7.1,4-14.3,4c-7.1,0-7.1-4-14.3-4c-6.9,0-6.9,1.4-13,3.7C206.4,355.2,206.5,370.7,213.5,385z", fill: "#5994C9", opacity: "0.5" }),
			_react2.default.createElement("path", { d: "M271.3,368.9c0.6,0.7,0.6,1.7,0,2.4c-2.3,2.5-8.4,8.2-15.4,8.1c-9-0.1-16.2-9.7-16.2-9.7s7.4-9.4,16.4-9.3 C263.1,360.6,269,366.4,271.3,368.9z", fill: "#F9914B" }),
			_react2.default.createElement("path", { d: "M235.6,360.7l10,7.7c0.9,0.7,0.9,2.2,0,2.9l-10.2,7.4c-1.2,0.9-2.8,0-2.8-1.5l2.4-7.8l-2.2-7.4 C232.7,360.7,234.4,359.9,235.6,360.7z", fill: "#F9914B" }),
			_react2.default.createElement("circle", { cx: "258.9", cy: "369.7", fill: "#FFFFFF", r: "4.5" }),
			_react2.default.createElement("circle", { cx: "258.9", cy: "369.7", fill: "#555555", r: "1.9" }),
			_react2.default.createElement("path", { d: "M303.9,362.1c0-14-5.9-27.3-16.3-36.7l-0.6-0.4h-66.2l-0.6,0.4c-17,15.5-20.9,39.5-10.3,61.3 c3.7,7.6,10,13.8,17,18v3.3c0,3.3,3.1,6,7.1,6h39.8c4,0,7.1-2.7,7.1-6v-4l-0.1,0.1C295.3,394.8,303.9,379.2,303.9,362.1z M278.3,401.1c-14,8.7-31.1,9.2-47.1,1.4c-7.7-3.7-13.9-9.9-17.7-17.5c-9.7-19.9-6.2-42,8.9-56h63.1c9.2,8,14.4,20.6,14.4,33.2 C299.9,378.2,291.8,392.6,278.3,401.1z", fill: "#FFFFFF" }),
			_react2.default.createElement("circle", { cx: "267.2", cy: "355.1", fill: "#FFFFFF", opacity: "0.3", r: "2.8" }),
			_react2.default.createElement("circle", { cx: "275.9", cy: "350.9", fill: "#FFFFFF", opacity: "0.3", r: "3.6" }),
			_react2.default.createElement("circle", { cx: "273.6", cy: "360.9", fill: "#FFFFFF", opacity: "0.3", r: "1.9" })
		);
	}
	
	exports.default = Scuba;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Unicorn() {
		return _react2.default.createElement(
			"g",
			{ className: "unicorn-kitty" },
			_react2.default.createElement("path", { className: "fill", d: "M577.8,230.9c-7.5,0.6-14.5-0.7-15.5-1.4v20.2c0,7.7-6.3,14-14,14s-14-6.3-14-14v-42.8 c0-7.6,5.9-13.8,13.4-14c4.7-15.1,22.7-28.2,45.9-31.7c24.2-3.7,45.6,0.4,54.7,19.3c0.4-0.2,0.8-0.3,1.3-0.5c1.5-0.6,3-1.2,4.7-1.8 c0.8-0.3,1.6-0.7,2.4-1c0.8-0.3,1.7-0.7,2.5-1c0.8-0.4,1.6-0.7,2.5-1.1c0.8-0.4,1.6-0.8,2.4-1.1c0.8-0.4,1.6-0.8,2.4-1.2 c0.8-0.4,1.6-0.8,2.3-1.2c1.5-0.9,3-1.6,4.3-2.4c0.7-0.4,1.4-0.8,2-1.1c0.6-0.4,1.3-0.8,1.9-1.1c1.2-0.7,2.3-1.4,3.4-2 c0.5-0.3,1-0.6,1.5-0.9c0.5-0.3,0.9-0.6,1.3-0.8c0.8-0.5,1.6-0.9,2.1-1.3c0.6-0.4,1-0.7,1.4-0.9c0.3-0.2,0.5-0.3,0.5-0.3l2.2-1 c4.9-2.3,10.6-0.1,12.9,4.7c1.2,2.5,1.2,5.4,0.2,7.8c0,0-0.1,0.3-0.4,0.8c-0.3,0.5-0.7,1.3-1.2,2.3c-0.1,0.2-0.3,0.5-0.4,0.8 c-0.2,0.3-0.3,0.5-0.5,0.8c-0.4,0.6-0.8,1.1-1.2,1.8c-0.9,1.3-2,2.5-3.3,3.9c-0.6,0.7-1.3,1.3-2.1,2c-0.7,0.7-1.5,1.4-2.3,2 c-1.6,1.3-3.3,2.6-5.2,3.7c-1.9,1.2-3.8,2.2-5.9,3.3c-2,1-4.1,2-6.2,2.8c-2.1,0.9-4.2,1.6-6.3,2.3c-2.1,0.6-4.1,1.3-6.1,1.7 c-2,0.5-3.9,0.9-5.7,1.2c-0.9,0.2-2.3,0.3-2.3,0.4v37.7c0,7.7-6.3,14-14,14s-14-6.3-14-14v-12.1l-4,0.6v11.5c0,7.7-6.4,14-14.1,14 c-6.9,0-11.9-5-13.9-11.7v-16C593.3,226,585.3,230.2,577.8,230.9z", fill: "#F1F1F1" }),
			_react2.default.createElement(
				"g",
				{ className: "flap-down" },
				_react2.default.createElement("path", { d: "M602.4,170.1c0,0-1.5,29,20,42.5s41.5,8,41.5,8s5.7-10.8-5.1-14.1c0,0,6.3-10.9-5.2-14.3 c0,0,6.8-10.1-7.6-14.6c-13.6-4.3-41.3-19.5-41.3-19.5L602.4,170.1z", fill: "#EBEFFF" }),
				_react2.default.createElement("path", { d: "M540.9,170.1c0,0,1.5,29-20,42.5c-21.5,13.5-41.5,8-41.5,8s-5.7-10.8,5.1-14.1c0,0-6.3-10.9,5.2-14.3 c0,0-6.8-10.1,7.6-14.6c13.6-4.3,21.1-12.5,21.1-12.5L540.9,170.1z", fill: "#EBEFFF" })
			),
			_react2.default.createElement(
				"g",
				{ className: "flap-up" },
				_react2.default.createElement("path", { d: "M602.4,173.7c0,0-1.5-29,20-42.5s41.5-8,41.5-8s5.7,10.8-5.1,14.1c0,0,6.3,10.9-5.2,14.3 c0,0,6.8,10.1-7.6,14.6c-13.6,4.3-41.3,19.5-41.3,19.5L602.4,173.7z", fill: "#EBEFFF" }),
				_react2.default.createElement("path", { d: "M540.9,173.7c0,0,1.5-29-20-42.5c-21.5-13.5-41.5-8-41.5-8s-5.7,10.8,5.1,14.1c0,0-6.3,10.9,5.2,14.3 c0,0-6.8,10.1,7.6,14.6c13.6,4.3,21.1,12.5,21.1,12.5L540.9,173.7z", fill: "#EBEFFF" })
			),
			_react2.default.createElement("path", { className: "fill", d: "M556.5,208.9c18.9,0,32.8-4,42.8-12.7l4.3,3.5c0.5,0.4,1.2,0.7,1.8,0.7c0.8,0,1.6-0.4,2.2-1 c1-1.2,0.8-3-0.4-4l-3.9-3.3c1.1-1.3,2-2.7,2.8-4.3l6,2.1c0.3,0.1,0.6,0.2,0.9,0.2c1.2,0,2.3-0.7,2.7-1.9c0.5-1.5-0.3-3.1-1.8-3.6 l-5.7-2c0.4-1.4,0.7-2.8,0.9-4.3l7.8-0.5c1.6-0.1,2.8-1.5,2.7-3c-0.1-1.6-1.4-2.8-3-2.7l-7.1,0.4l0,0c-0.5-15.7-3.8-40.3-8.2-51.1 c-1.3-4.1-6.5-6.5-10-3.7v0c-6.7,3.9-15,10.2-21.6,16.2c-5.1-1.5-7.7-2.3-13.3-2.3c-5.6,0-8.2,0.8-13.3,2.3 c-6.6-6.1-14.8-12.3-21.6-16.2l0,0c-3.5-2.8-8.7-0.4-10,3.7c-4.5,10.8-7.8,35.4-8.2,51.1l0,0l-7.1-0.4c-1.6-0.1-2.9,1.1-3,2.7 c-0.1,1.6,1.1,2.9,2.7,3l7.8,0.5c0.2,1.5,0.5,2.9,0.9,4.3l-5.7,2c-1.5,0.5-2.3,2.1-1.8,3.6c0.4,1.2,1.5,1.9,2.7,1.9 c0.3,0,0.6,0,0.9-0.2l6-2.1c0.8,1.5,1.7,2.9,2.8,4.3l-3.9,3.3c-1.2,1-1.4,2.8-0.4,4c0.6,0.7,1.4,1,2.2,1c0.6,0,1.3-0.2,1.8-0.7 l4.3-3.5C523.8,204.9,537.7,208.9,556.5,208.9z", fill: "#F1F1F1" }),
			_react2.default.createElement("path", { d: "M545.6,139c-0.3-3.3,0-6.6,1-9.8l1.8-5.7L548,121c-0.5-3.6-0.1-7.3,1-10.8l1.5-4.7l0,0 c-0.8-4.4-0.4-8.8,1.1-13l0.6-1.7l0.3-2.4c0.2-1.9,1.1-8.6,3.8-8.6s3.6,6,4.1,8.7s0.9,8.4,0.9,8.4l1.2,3.4 c1.2,3.4,1.6,7.1,1.3,10.7l-0.4,3.6l1.7,5.2c1,3,1.4,6.2,1.1,9.3l-0.4,5.9c0,0,2.1,2.7,2,6.7c0,4-2.6,8.5-11.6,8.5 C544.6,150.2,545.6,139,545.6,139z", fill: "#FFFFFF" }),
			_react2.default.createElement("path", { d: "M565.8,135l0.1-1.2l-0.9,0.2c-4.9,1-9.2-0.6-12.7-4.7c-2.7-3.2-3.9-6.7-3.9-6.7l-0.2-0.5l0.2,1.4l-0.7,2.4 c2,3.8,6.5,10.4,14.6,10.4c1,0,2-0.1,3.1-0.3l0.7-0.1L565.8,135z", fill: "#EBEFFF" }),
			_react2.default.createElement("path", { d: "M563.1,115.5l0.5-0.1l-0.3-0.8l0.1-1.2l-0.8,0.2c-8.6,1.7-12-8-12.1-8.4l-0.3-0.8c0.1,0.4,0.1,0.7,0.2,1.1 l-0.8,2.5c1.6,2.9,5,7.7,11,7.7C561.4,115.7,562.2,115.7,563.1,115.5z", fill: "#EBEFFF" }),
			_react2.default.createElement("path", { d: "M561.6,97.8l-0.3-1c0,0,0-0.4-0.1-1c-6.1,0.4-8.5-6.5-8.6-6.8l-0.1-0.3l-0.2,2l-0.5,1.3 c1.6,2.8,4.5,5.8,8.9,5.8C560.9,97.9,561.3,97.8,561.6,97.8z", fill: "#EBEFFF" }),
			_react2.default.createElement("line", { fill: "#5994C9", x1: "578.4", x2: "586.5", y1: "256.8", y2: "256.6" }),
			_react2.default.createElement("line", { fill: "#5994C9", x1: "561.2", x2: "569.2", y1: "257.3", y2: "257.1" }),
			_react2.default.createElement("line", { fill: "#5994C9", x1: "543.9", x2: "552", y1: "257.8", y2: "257.6" }),
			_react2.default.createElement("ellipse", { className: "fill", cx: "561.6", cy: "192.2", fill: "#F1F1F1", rx: "7.2", ry: "5.8" }),
			_react2.default.createElement("ellipse", { className: "fill", cx: "551.5", cy: "192.2", fill: "#F1F1F1", rx: "7.2", ry: "5.8" }),
			_react2.default.createElement(
				"g",
				{ className: "arm" },
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("ellipse", { cx: "522.5", cy: "263.7", fill: "#FFEAAE", opacity: "0.2", rx: "59", ry: "59", transform: "matrix(0.286 -0.9582 0.9582 0.286 120.3343 688.9644)" }),
					_react2.default.createElement("polygon", { fill: "#75c69f", points: "537.6,264.1 534.8,264.7 532.9,254.9 544.4,252.6 \t\t\t" }),
					_react2.default.createElement("polygon", { fill: "#f9914b", points: "569.3,247.6 578.3,245.8 571.5,257.4 562.4,259.2 \t\t\t" }),
					_react2.default.createElement("polygon", { fill: "#987fef", points: "545.5,262.5 554.5,260.8 561.4,249.2 552.3,251 \t\t\t" }),
					_react2.default.createElement("polygon", { fill: "#5994c9", points: "545.5,262.5 552.3,251 544.4,252.6 537.6,264.1 \t\t\t" }),
					_react2.default.createElement("polygon", { fill: "#f79ac0", points: "561.4,249.2 554.5,260.8 562.4,259.2 569.3,247.6 \t\t\t" }),
					_react2.default.createElement("path", { d: "M594.6,242.6L594.6,242.6l-6.9,11.6l8.7-1.7c0,0,2.6-2.4,2-5.4S594.6,242.6,594.6,242.6z", fill: "#75c69f" }),
					_react2.default.createElement("path", { d: "M510.4,257.1l-0.7-12.3c-0.1-2.1,2.2-3.4,3.9-2.2l10.1,6.9l11.4-4.4c1.9-0.7,3.9,1,3.3,3l-3.4,11.8 l7.8,9.5c1.3,1.6,0.2,4-1.9,4.1l-12.3,0.4l-6.6,10.3c-1.1,1.7-3.7,1.4-4.4-0.5l-4.2-11.6l-11.9-3.1c-2-0.5-2.5-3.1-0.9-4.4 L510.4,257.1z", fill: "#FFEAAE" })
				),
				_react2.default.createElement("path", { d: "M519.6,265.5l-3.1-0.8c-0.8-0.2-1-1.3-0.4-1.8l2.6-2l-0.2-3.2c0-0.8,0.9-1.4,1.6-0.9l2.7,1.8l3-1.2 c0.8-0.3,1.6,0.4,1.4,1.2l-0.9,3.1l2.1,2.5c0.5,0.7,0.1,1.6-0.8,1.7l-3.2,0.1l-1.8,2.7c-0.5,0.7-1.5,0.6-1.8-0.2L519.6,265.5z", fill: "#FFFFFF" }),
				_react2.default.createElement("path", { className: "fill", d: "M567,219v30.7c0,7.7,6.3,14,14,14s14-6.3,14-14V219H567z", fill: "#F1F1F1" })
			),
			_react2.default.createElement("path", { className: "fill--face", d: "M556.6,184h-2.6c-1.3,0-2.1,1.3-1.3,2.2l1.1,1.2l1.6,1.8c0.7,0.7,2,0.7,2.6,0l1.6-1.9l1-1.2c0.8-0.9,0-2.2-1.3-2.2H556.6z" }),
			_react2.default.createElement(
				"g",
				{ className: "kitten-eyes" },
				_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "536.9", cy: "172.8", rx: "5.9", ry: "5.3", transform: "matrix(0.1736 -0.9848 0.9848 0.1736 273.4849 671.4612)" }),
				_react2.default.createElement("ellipse", { className: "fill--eyes", cx: "576.2", cy: "172.8", rx: "5.3", ry: "5.9", transform: "matrix(0.9848 -0.1736 0.1736 0.9848 -21.2465 102.6865)" })
			),
			_react2.default.createElement(
				"g",
				{ className: "kitten-eyes--blink" },
				_react2.default.createElement("path", { className: "fill--face", d: "M540.9,176.1c-0.1,0-0.2,0-0.3,0l-8.6-1.7c-0.8-0.2-1.3-1-1.2-1.8c0.2-0.8,1-1.3,1.8-1.2l8.6,1.7c0.8,0.2,1.3,1,1.2,1.8 C542.2,175.6,541.6,176.1,540.9,176.1z" }),
				_react2.default.createElement("path", { className: "fill--face", d: "M572.3,176.1c-0.7,0-1.3-0.5-1.5-1.2c-0.2-0.8,0.4-1.6,1.2-1.8l8.6-1.7c0.8-0.2,1.6,0.4,1.8,1.2c0.2,0.8-0.4,1.6-1.2,1.8 l-8.6,1.7C572.5,176.1,572.4,176.1,572.3,176.1z" })
			)
		);
	}
	
	exports.default = Unicorn;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC = __webpack_require__(13);
	
	var _PetHOC2 = _interopRequireDefault(_PetHOC);
	
	var _Frisky = __webpack_require__(521);
	
	var _Frisky2 = _interopRequireDefault(_Frisky);
	
	var _Bonsai = __webpack_require__(516);
	
	var _Bonsai2 = _interopRequireDefault(_Bonsai);
	
	var _Camper = __webpack_require__(517);
	
	var _Camper2 = _interopRequireDefault(_Camper);
	
	var _Fan = __webpack_require__(520);
	
	var _Fan2 = _interopRequireDefault(_Fan);
	
	var _Midi = __webpack_require__(522);
	
	var _Midi2 = _interopRequireDefault(_Midi);
	
	var _Rocketship = __webpack_require__(523);
	
	var _Rocketship2 = _interopRequireDefault(_Rocketship);
	
	var _Scuba = __webpack_require__(524);
	
	var _Scuba2 = _interopRequireDefault(_Scuba);
	
	var _Unicorn = __webpack_require__(525);
	
	var _Unicorn2 = _interopRequireDefault(_Unicorn);
	
	var _Athlete = __webpack_require__(514);
	
	var _Athlete2 = _interopRequireDefault(_Athlete);
	
	var _Coffee = __webpack_require__(519);
	
	var _Coffee2 = _interopRequireDefault(_Coffee);
	
	var _Chef = __webpack_require__(518);
	
	var _Chef2 = _interopRequireDefault(_Chef);
	
	var _Birthday = __webpack_require__(515);
	
	var _Birthday2 = _interopRequireDefault(_Birthday);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // To add a new kitten:
	//
	// 1. Add SVG component in this folder.
	// 	- Add .fill to all body elements.
	// 	- Add .fill--face to all face elements (blinking eyes and nose, NOT open eyes).
	// 	- Add .fill--eyes to open eyes (NOT blinking eyes).
	// 	- Add <g> .kitten-eyes around open eyes.
	// 	- Add <g> .kitten-eyes--blink around blinking eyes.
	// 2. Import the component here.
	// 3. Add it to `kittenOptions` here.
	// 4. Add a new story in `src/stories/kittens.js`
	// 5. Add goody rules to `utils/getKitten.js`
	// 6. Add styles to `scss/pet/kittens/_[kitten-name].scss`
	
	var kittenOptions = {
		Frisky: _Frisky2.default,
		Bonsai: _Bonsai2.default,
		Camper: _Camper2.default,
		Fan: _Fan2.default,
		Midi: _Midi2.default,
		Rocketship: _Rocketship2.default,
		Scuba: _Scuba2.default,
		Unicorn: _Unicorn2.default,
		Athlete: _Athlete2.default,
		Coffee: _Coffee2.default,
		Chef: _Chef2.default,
		Birthday: _Birthday2.default
	};
	
	var Kitten = function (_React$Component) {
		_inherits(Kitten, _React$Component);
	
		function Kitten(props) {
			_classCallCheck(this, Kitten);
	
			var _this = _possibleConstructorReturn(this, (Kitten.__proto__ || Object.getPrototypeOf(Kitten)).call(this, props));
	
			_this.state = {
				universalActions: {},
				actions: {
					idle: {}
				}
			};
	
			_this.staticClasses = ['pet', 'fill--kitten', _this.props.kitten];
	
			_this.actions = {
				idle: [{
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 3000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 199;
						}
					}
				}]
			};
	
			_this.loopAllActions = _PetHOC2.default.prototype.loopAllActions.bind(_this);
			_this.setAction = _PetHOC2.default.prototype.setAction.bind(_this);
			_this.loopAction = _PetHOC2.default.prototype.loopAction.bind(_this);
			_this.stopActions = _PetHOC2.default.prototype.stopActions.bind(_this);
			_this.getClassNames = _PetHOC2.default.prototype.getClassNames.bind(_this);
			return _this;
		}
	
		_createClass(Kitten, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.loopAllActions('idle');
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.kitten !== nextProps.kitten) {
					this.staticClasses = ['pet', 'fill--kitten', nextProps.kitten];
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.stopActions('idle');
			}
		}, {
			key: 'render',
			value: function render() {
				var ThisKitten = kittenOptions[this.props.kitten];
	
				if (!this.props.kitten || !ThisKitten) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'pet-kitten' },
					_react2.default.createElement(
						'svg',
						{ className: this.getClassNames(), version: '1.1', viewBox: '0 0 740 480', x: '0px', y: '0px', xmlSpace: 'preserve' },
						_react2.default.createElement(ThisKitten, null)
					)
				);
			}
		}]);
	
		return Kitten;
	}(_react2.default.Component);
	
	Kitten.propTypes = {
		kitten: _propTypes2.default.string
	};
	
	Kitten.defaultProps = {
		kitten: ''
	};
	
	exports.default = Kitten;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	var _Bodies = __webpack_require__(511);
	
	var _Bodies2 = _interopRequireDefault(_Bodies);
	
	var _Heads = __webpack_require__(513);
	
	var _Heads2 = _interopRequireDefault(_Heads);
	
	var _Eyes = __webpack_require__(512);
	
	var _Eyes2 = _interopRequireDefault(_Eyes);
	
	var _Toy = __webpack_require__(17);
	
	var _Toy2 = _interopRequireDefault(_Toy);
	
	var _Kitten = __webpack_require__(526);
	
	var _Kitten2 = _interopRequireDefault(_Kitten);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cat = function (_PetHOC) {
		_inherits(Cat, _PetHOC);
	
		function Cat(props) {
			_classCallCheck(this, Cat);
	
			var _this = _possibleConstructorReturn(this, (Cat.__proto__ || Object.getPrototypeOf(Cat)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(500, 4000);
						}
					}
				}, {
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 2500);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 199;
						}
					}
				}],
				pet: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(600, 1200);
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(Cat, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Bodies2.default, { body: this.props.body })
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Heads2.default, { getHatTargetCoords: this.getHatTargetCoords, head: this.props.head }),
									_react2.default.createElement(_Eyes2.default, { getGlassesTargetCoords: this.getGlassesTargetCoords }),
									this.shouldRenderHat(),
									this.shouldRenderGlasses()
								)
							)
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-toy', viewBox: '0 0 480 480' },
							_react2.default.createElement(_Toy2.default, { toy: this.props.toy, kitten: this.props.kitten })
						),
						_react2.default.createElement(_Kitten2.default, { kitten: this.props.kitten })
					)
				);
			}
		}]);
	
		return Cat;
	}(_PetHOC3.default);
	
	exports.default = Cat;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Bodies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function Bodies() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				{ className: "wing wing--left" },
				_react2.default.createElement("path", { className: "fill fill--dark", d: "M228.95879,243.4124c0,0,10.53212,61.71434-36.12633,61.71434 c-16.89166,0-30.58505-8.97876-30.58505-31.08014s13.69339-40.0181,30.58505-40.0181S228.95879,243.4124,228.95879,243.4124z" })
			),
			_react2.default.createElement("path", { className: "fill thigh thigh--right", d: "M314.60611,305.12671c-19.61865,39.74072-40.62469,51.84012-60.61441,32.22366 c-19.12944-19.12946,7.78482-42.00516,24.51871-51.11209C302.46719,273.20068,320.64883,289.06592,314.60611,305.12671z" }),
			_react2.default.createElement("path", { className: "fill thigh thigh--left", d: "M181.42679,305.12671c19.61865,39.74072,40.62471,51.84012,60.61444,32.22366 c19.12943-19.12946-7.78485-42.00516-24.51874-51.11209C193.5657,273.20068,175.38406,289.06592,181.42679,305.12671z" }),
			_react2.default.createElement(
				"g",
				{ className: "tail" },
				_react2.default.createElement("path", { className: "fill", d: "M328.97482,228.75055c-3.06363,6.14191-11.92139,7.94139-11.92139,7.94139 s-3.89059-8.15849-0.82697-14.3004c1.21512-2.43602,3.34171-4.18893,5.46558-5.41742 c3.41086-1.97285,7.82019,0.15784,8.31241,4.06728C330.31375,223.49765,330.20398,226.28639,328.97482,228.75055z" }),
				_react2.default.createElement("path", { className: "fill", d: "M331.09857,239.50623c-6.50931,2.17665-14.04514-2.81429-14.04514-2.81429 s3.01785-8.52,9.52716-10.69666c2.61157-0.87329,5.38834-0.59285,7.7774,0.05614c3.80252,1.03293,5.29712,5.69643,2.86761,8.79861 C335.7128,236.78172,333.6803,238.64291,331.09857,239.50623z" }),
				_react2.default.createElement("path", { className: "fill", d: "M319.86774,222.64682c2.17664,6.50931-2.8143,14.04512-2.8143,14.04512 s-8.51999-3.01785-10.69666-9.52716c-0.87329-2.61156-0.59283-5.38834,0.05612-7.7774 c1.03296-3.80251,5.69644-5.2971,8.79865-2.8676C317.14322,218.03258,319.00439,220.06508,319.86774,222.64682z" })
			),
			_react2.default.createElement("path", { className: "fill", d: "M302.43628,319.19c23.6463-23.26318,24.72998-80.66725,24.72998-80.66725 s-33.75958-27.60931-79.15903-27.60931" }),
			_react2.default.createElement("path", { className: "fill", d: "M248.00723,210.91344c40.49014,0,73.3139,23.73068,73.3139,64.22081 c0,43.41525-32.82376,62.26218-73.3139,62.26218s-73.31389-18.84692-73.31389-62.26218 C174.69334,234.64412,207.51709,210.91344,248.00723,210.91344z" })
		);
	}

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make group for face '.fill--face'
	// Make glasses target 'ref="glassesTarget"'
	// Make groups for each eye group
	// - '.fill-eyes eyes'
	// - '.fill-face eyes--blink'
	// - '.fill-face eyes--is-being-pet--likes'
	// - '.fill-eyes eyes--is-being-pet--hates'
	
	var Eyes = function (_React$Component) {
		_inherits(Eyes, _React$Component);
	
		function Eyes() {
			_classCallCheck(this, Eyes);
	
			return _possibleConstructorReturn(this, (Eyes.__proto__ || Object.getPrototypeOf(Eyes)).apply(this, arguments));
		}
	
		_createClass(Eyes, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getGlassesTargetCoords(this.refs.glassesTarget);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					{ className: "fill--face" },
					_react2.default.createElement("circle", { ref: "glassesTarget", cx: "238.22212", cy: "193.70601", r: "0" }),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes" },
						_react2.default.createElement("ellipse", { cx: "221.2341", cy: "193.70601", rx: "5.77192", ry: "6.25846" }),
						_react2.default.createElement("ellipse", { cx: "255.21025", cy: "193.70601", rx: "5.77192", ry: "6.25846" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--blink" },
						_react2.default.createElement("path", { d: "M249.35239,197.01091c-0.86926-0.06667-1.59607-0.74304-1.69537-1.64136c-0.11276-1.01572,0.61937-1.93073,1.63507-2.0435 l11.43094-1.26855c1.01566-0.11206,1.93109,0.61938,2.04309,1.63541c0.11279,1.0157-0.61935,1.93073-1.63507,2.04349 l-11.43091,1.26857C249.5824,197.01804,249.46628,197.01965,249.35239,197.01091z" }),
						_react2.default.createElement("path", { d: "M227.09703,197.00969c0.86963-0.06671,1.59674-0.74336,1.69608-1.64204c0.11282-1.01613-0.61961-1.93153-1.63574-2.04436 l-11.43568-1.26909c-1.01607-0.11209-1.93188,0.61966-2.04396,1.63609c-0.11281,1.01613,0.61963,1.93153,1.63576,2.04434 l11.43567,1.2691C226.86693,197.01682,226.98311,197.01843,227.09703,197.00969z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--is-being-pet--likes" },
						_react2.default.createElement("path", { d: "M215.68059,197.02895c-0.50008-0.0192-0.99028-0.23956-1.33998-0.65068c-0.66273-0.77884-0.56795-1.9473,0.21088-2.60965 c1.56964-1.33513,3.98746-2.12241,6.63342-2.15981c2.64819-0.03877,5.08557,0.68225,6.69193,1.97353 c0.79684,0.64069,0.92365,1.80606,0.28296,2.60292c-0.64143,0.79718-1.8064,0.92255-2.60258,0.28333 c-0.7196-0.57874-2.22496-1.18294-4.32043-1.15732c-2.08693,0.02954-3.58252,0.6796-4.28651,1.27789 C216.58217,196.90216,216.12793,197.04611,215.68059,197.02895z" }),
						_react2.default.createElement("path", { d: "M260.76324,197.02895c0.50009-0.0192,0.9903-0.23956,1.34-0.65068c0.66272-0.77884,0.56796-1.9473-0.21088-2.60965 c-1.56964-1.33513-3.98746-2.12241-6.63342-2.15981c-2.64819-0.03877-5.08557,0.68225-6.69193,1.97353 c-0.79684,0.64069-0.92365,1.80606-0.28296,2.60292c0.64143,0.79718,1.8064,0.92255,2.60258,0.28333 c0.7196-0.57874,2.22496-1.18294,4.32043-1.15732c2.08693,0.02954,3.5825,0.6796,4.28651,1.27789 C259.86169,196.90216,260.31592,197.04611,260.76324,197.02895z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes--is-being-pet--hates" },
						_react2.default.createElement("path", { d: "M260.98193,193.70601c0,3.91667-2.5842,6.25845-5.77193,6.25845c-3.18774,0-5.77193-2.34178-5.77193-6.25845 c0-2.40128,2.58418-2.40128,5.77193-2.40128C258.39774,191.30473,260.98193,191.30473,260.98193,193.70601z" }),
						_react2.default.createElement("path", { d: "M227.00577,193.70601c0,3.91667-2.58418,6.25845-5.77193,6.25845s-5.77191-2.34178-5.77191-6.25845 c0-2.40128,2.58417-2.40128,5.77191-2.40128S227.00577,191.30473,227.00577,193.70601z" })
					)
				);
			}
		}]);
	
		return Eyes;
	}(_react2.default.Component);
	
	exports.default = Eyes;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Feet;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function Feet() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				{ className: "foot foot--right" },
				_react2.default.createElement("path", { className: "fill fill--alt--dark", d: "M273.25558,365.79126c-1.5593,0.01904-3.07162-0.21463-4.56967-0.52628 c-1.49615-0.3205-2.97452-0.73831-4.43576-1.24731c-1.46121-0.50998-2.90976-1.08722-4.33511-1.78918 c-1.42856-0.68704-2.84091-1.45868-4.20819-2.47455c-1.21716-0.90424-1.47075-2.62372-0.56653-3.84073 c0.37801-0.50845,0.89948-0.849,1.466-1.00699c1.64053-0.45773,3.23602-0.67133,4.81564-0.80026 c1.58246-0.14386,3.14178-0.16306,4.68839-0.11499c1.5466,0.04913,3.07639,0.18942,4.58807,0.42688 c1.5101,0.24646,3.00562,0.57089,4.45416,1.14798c2.71997,1.08347,4.04663,4.16669,2.96307,6.88651 C277.29776,364.50565,275.33603,365.76349,273.25558,365.79126z" }),
				_react2.default.createElement("path", { className: "fill fill--alt", d: "M296.23853,358.96097c-1.80371-0.81091-3.61597-1.37393-5.43106-1.85098 c-1.81448-0.49194-3.63403-0.83789-5.45486-1.15305c-1.82083-0.30405-3.64578-0.48941-5.47357-0.59763 c-0.15839-0.00888-0.31708-0.0127-0.47546-0.02032v-14.25745c0-2.8717-2.32831-5.20001-5.19998-5.20001 s-5.20001,2.32831-5.20001,5.20001v15.89642c0,0.24786,0.03937,0.48495,0.073,0.72363 c-0.73123,0.48624-1.43393,1.00928-2.11819,1.55676c-1.27844,1.02673-2.50989,2.11505-3.66992,3.29761 c-1.15305,1.19177-2.28735,2.40799-3.33347,3.741c-1.0553,1.32062-2.05887,2.70981-2.91199,4.29703 c-0.29642,0.55289-0.40561,1.21399-0.25803,1.87448c0.32626,1.46091,1.77545,2.38101,3.23636,2.05441 c1.75861-0.39261,3.36743-0.98325,4.92419-1.64276c1.56564-0.64716,3.04306-1.41077,4.50208-2.19916 c1.05719-0.58051,2.06647-1.22415,3.05734-1.89191c0.69696,1.11115,1.42441,2.20483,2.22833,3.25601 c1.05023,1.35492,2.1268,2.69492,3.33127,3.96347c1.19113,1.27588,2.45749,2.50955,3.94031,3.62198 c0.51764,0.38657,1.17908,0.59286,1.87286,0.52686c1.48187-0.1409,2.56857-1.45645,2.42767-2.93832 c-0.17551-1.84558-0.56781-3.56927-1.035-5.2511c-0.45416-1.68912-1.03592-3.30713-1.64435-4.90961 c-0.10443-0.27008-0.22787-0.52905-0.33832-0.79599c0.57288-0.03397,1.14511-0.05966,1.71863-0.11584 c1.83765-0.19073,3.67654-0.41226,5.52054-0.78012c1.84335-0.35229,3.68958-0.79092,5.54437-1.47772 c0.6427-0.24026,1.20065-0.72998,1.50439-1.4054C298.17899,361.14139,297.58041,359.56464,296.23853,358.96097z" })
			),
			_react2.default.createElement(
				"g",
				{ className: "foot foot--left" },
				_react2.default.createElement("path", { className: "fill fill--alt--dark", d: "M220.86171,355.56583c1.44885-0.57709,2.94437-0.90152,4.45415-1.14798 c1.5117-0.23746,3.04149-0.37775,4.58809-0.42688c1.54692-0.04807,3.10623-0.02887,4.68871,0.11499 c1.57961,0.12894,3.17509,0.34253,4.81564,0.80026c1.46028,0.40753,2.31372,1.92169,1.90652,3.38205 c-0.17044,0.61008-0.53511,1.11511-1.00706,1.46567c-1.36728,1.01587-2.77995,1.78751-4.20818,2.47455 c-1.42537,0.70197-2.87422,1.27921-4.33513,1.78918c-1.46155,0.509-2.93961,0.92682-4.43607,1.24731 c-1.49773,0.31165-3.01006,0.54532-4.56935,0.52628c-2.92755-0.03561-5.27205-2.43781-5.23619-5.36526 C217.54982,358.21597,218.92981,356.3381,220.86171,355.56583z" }),
				_react2.default.createElement("path", { className: "fill fill--alt", d: "M238.97154,370.59399c-0.85344-1.58722-1.85669-2.97641-2.91199-4.29703 c-1.0461-1.33301-2.18074-2.54922-3.33379-3.741c-1.15971-1.18256-2.39148-2.27087-3.66959-3.29761 c-0.68459-0.54779-1.38759-1.07117-2.11916-1.5574c0.03363-0.23834,0.073-0.47543,0.073-0.72299v-15.89642 c0-2.8717-2.32832-5.20001-5.20001-5.20001c-2.87167,0-5.2,2.32831-5.2,5.20001v14.25745 c-0.15805,0.00763-0.31642,0.01144-0.47449,0.02032c-1.8278,0.10822-3.65276,0.29358-5.47389,0.59763 c-1.82051,0.31516-3.64008,0.6611-5.45486,1.15305c-1.81511,0.47705-3.62737,1.04007-5.43106,1.85098 c-0.62492,0.28375-1.14828,0.81027-1.40536,1.50473c-0.51099,1.37964,0.19328,2.91199,1.57295,3.42297 c1.85478,0.6868,3.701,1.12543,5.54436,1.47772c1.84367,0.36786,3.68259,0.58939,5.52055,0.78012 c0.5732,0.05618,1.14575,0.08188,1.71831,0.11584c-0.11044,0.26694-0.23358,0.52591-0.33832,0.79599 c-0.60843,1.60248-1.18988,3.22049-1.64404,4.90961c-0.46719,1.68182-0.85948,3.40552-1.03531,5.2511 c-0.05998,0.64301,0.10918,1.31525,0.52718,1.87256c0.89311,1.19083,2.58253,1.43204,3.77336,0.53891 c1.48282-1.11243,2.74918-2.3461,3.94031-3.62198c1.20447-1.26855,2.28134-2.60855,3.33157-3.96347 c0.8036-1.05118,1.53137-2.14487,2.22803-3.25601c0.99086,0.66809,2.00014,1.3114,3.05734,1.89191 c1.45901,0.78839,2.93643,1.552,4.5024,2.19916c1.55676,0.65952,3.16525,1.25015,4.92387,1.64276 c0.61255,0.13617,1.27873,0.06253,1.87447-0.25772C239.1861,373.55615,239.68025,371.91272,238.97154,370.59399z" })
			)
		);
	}

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make hatTarget 'ref="hatTarget"'
	// Add '.fill' to all body elements
	// Add '.fill--face' to nose
	
	var HeadHOC = function (_React$Component) {
		_inherits(HeadHOC, _React$Component);
	
		function HeadHOC() {
			_classCallCheck(this, HeadHOC);
	
			return _possibleConstructorReturn(this, (HeadHOC.__proto__ || Object.getPrototypeOf(HeadHOC)).apply(this, arguments));
		}
	
		_createClass(HeadHOC, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getHatTargetCoords(this.refs.hatTarget);
			}
		}]);
	
		return HeadHOC;
	}(_react2.default.Component);
	
	var Heads = function (_HeadHOC) {
		_inherits(Heads, _HeadHOC);
	
		function Heads() {
			_classCallCheck(this, Heads);
	
			return _possibleConstructorReturn(this, (Heads.__proto__ || Object.getPrototypeOf(Heads)).apply(this, arguments));
		}
	
		_createClass(Heads, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "237.22212", cy: "176.6104", r: "0" }),
					_react2.default.createElement("path", { className: "fill", d: "M280.66782,269.49115c18.62225,0-2.61652-63.45523-8.72714-79.30533 c-6.69879-17.37567-15.09631-33.71854-33.71855-33.71854s-27.01976,16.34286-33.71854,33.71854 c-6.11064,15.8501-27.3494,79.30533-8.72716,79.30533H280.66782z" }),
					_react2.default.createElement("path", { className: "fill chicken--comb", d: "M247.27718,231.18246c0,6.14453-4.05408,9.81833-9.05505,9.81833 c-5.00096,0-9.05505-3.6738-9.05505-9.81833c0-3.83281,3.5233-9.12279,6.17439-11.53731c1.63481-1.48892,4.12651-1.48892,5.76132,0 C243.75388,222.05968,247.27718,227.34966,247.27718,231.18246z" }),
					_react2.default.createElement("path", { className: "fill chicken--comb", d: "M229.31552,150.04858c0-6.04381,3.98763-9.65738,8.9066-9.65738 s8.9066,3.61357,8.9066,9.65738c0,3.76997-3.46553,17.05048-6.07317,19.4254c-1.608,1.46452-4.05885,1.46452-5.66687,0 C232.78105,167.09906,229.31552,153.81856,229.31552,150.04858z" })
				);
			}
		}]);
	
		return Heads;
	}(HeadHOC);
	
	exports.default = Heads;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Nose;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Nose() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill fill--alt--dark", d: "M245.56143,207.01997c0,3.7489-3.28592,6.78799-7.33931,6.78799s-7.33931-3.03909-7.33931-6.78799" }),
			_react2.default.createElement("path", { className: "fill fill--alt", d: "M230.88281,207.01997c0-6.18192,2.01007-9.74736,7.33931-9.74736s7.33931,3.56544,7.33931,9.74736 l-7.33931,1.44598L230.88281,207.01997z" })
		);
	}

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Wing;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Wing() {
		return _react2.default.createElement(
			"g",
			{ className: "wing wing--right" },
			_react2.default.createElement("path", { className: "fill fill--dark", d: "M327.16486,239.49071c4.52374,2.0405,6.43878,6.7592,6.4682,11.72177 c0.10825,18.27867-2.18121,53.91426-32.6398,53.91426c-16.89166,0-27.98297-8.97876-27.98297-31.08014 s13.69339-40.0181,30.58505-40.0181C312.96927,234.0285,321.46204,236.9184,327.16486,239.49071z" })
		);
	}

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	var _Bodies = __webpack_require__(528);
	
	var _Bodies2 = _interopRequireDefault(_Bodies);
	
	var _Wing = __webpack_require__(533);
	
	var _Wing2 = _interopRequireDefault(_Wing);
	
	var _Heads = __webpack_require__(531);
	
	var _Heads2 = _interopRequireDefault(_Heads);
	
	var _Eyes = __webpack_require__(529);
	
	var _Eyes2 = _interopRequireDefault(_Eyes);
	
	var _Nose = __webpack_require__(532);
	
	var _Nose2 = _interopRequireDefault(_Nose);
	
	var _Feet = __webpack_require__(530);
	
	var _Feet2 = _interopRequireDefault(_Feet);
	
	var _Toy = __webpack_require__(17);
	
	var _Toy2 = _interopRequireDefault(_Toy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Chicken = function (_PetHOC) {
		_inherits(Chicken, _PetHOC);
	
		function Chicken(props) {
			_classCallCheck(this, Chicken);
	
			var _this = _possibleConstructorReturn(this, (Chicken.__proto__ || Object.getPrototypeOf(Chicken)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 4000);
						}
					}
				}, {
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 2500);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}, {
					name: 'flap',
					actions: ['isFlapping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(2000, 8000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}, {
					name: 'ruffleTail',
					actions: ['isRufflingTail'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(2000, 10000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 300;
						}
					}
				}],
				pet: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(600, 1200);
						}
					}
				}, {
					name: 'flap',
					actions: ['isFlapping'],
					start: {
						timeout: null,
						interval: function interval() {
							return Math.random() > 0.5 ? 200 : 400;
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}, {
					name: 'stomp',
					actions: ['isStompingRight', 'isStompingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return 400;
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 400;
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(Chicken, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'svg',
								{ className: 'pet__body', viewBox: '0 0 480 480' },
								_react2.default.createElement(_Feet2.default, null)
							),
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Bodies2.default, { body: this.props.body })
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Heads2.default, { getHatTargetCoords: this.getHatTargetCoords, head: this.props.head }),
									_react2.default.createElement(_Eyes2.default, { getGlassesTargetCoords: this.getGlassesTargetCoords }),
									this.shouldRenderHat()
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Wing2.default, null)
								)
							)
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-toy', viewBox: '0 0 480 480' },
							_react2.default.createElement(_Toy2.default, { toy: this.props.toy })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									this.shouldRenderGlasses(),
									_react2.default.createElement(_Nose2.default, null)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Chicken;
	}(_PetHOC3.default);
	
	exports.default = Chicken;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Bodies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function Bodies() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				{ className: "tail" },
				_react2.default.createElement("path", { className: "fill", fill: "#F7EDE8", d: "M354.46661,313.76791c1.9939,1.15649,4.04602,2.1084,6.26581,2.77222 c2.23157,0.58716,4.65857,0.87744,7.29053,0.84155c2.6264-0.00708,5.47021-0.51001,8.39771-1.27612 c2.92963-0.77368,5.95776-1.8728,8.97736-3.3042c3.02319-1.41138,6.05469-3.07422,9.04443-4.94849 c2.98126-1.89453,5.92493-3.97925,8.80298-6.21875c2.87811-2.23926,5.69153-4.63452,8.41376-7.14526 c1.36627-1.25098,2.6958-2.54175,4.00366-3.84448c0.65265-0.65356,1.29272-1.30957,1.92371-1.96826l1.74194-1.85571 l0.55243-0.58862c3.77948-4.02637,10.10742-4.22656,14.13379-0.44702c3.55316,3.33545,4.12286,8.65771,1.61127,12.62915 l-0.96118,1.52222l-0.89838,1.38696c-0.59875,0.90723-1.20374,1.80469-1.81543,2.6897 c-1.22754,1.76758-2.47626,3.5127-3.77307,5.22241c-2.58417,3.42773-5.30975,6.7644-8.20764,10.00806 c-5.79279,6.48291-12.2511,12.63037-19.8476,18.04272c-3.77698,2.71875-7.89362,5.20801-12.36639,7.36523 c-4.47223,2.14331-9.28955,4.01978-14.55084,5.17578c-5.23425,1.17798-10.82239,1.75195-16.51678,1.47827 c-5.69073-0.34326-11.35718-1.52344-16.75049-3.35474l-0.86835-0.29468c-9.7807-3.32104-15.01733-13.94214-11.69635-23.7229 c3.32104-9.78076,13.94208-15.01733,23.72278-11.69629C352.25708,312.63071,353.44055,313.18173,354.46661,313.76791z" })
			),
			_react2.default.createElement("path", { className: "fill", fill: "#F7EDE8", d: "M224.85794,216.41782c-36.03488,0-57.54167,13.21263-61.81805,49.78073 c-4.30435,36.80725,19.65471,47.41922,57.5524,63.71628c12.89163,5.54373,130.49991,55.82355,132.25906-0.90277 C354.54349,274.44696,271.23871,233.87971,224.85794,216.41782z" }),
			_react2.default.createElement("path", { className: "fill", fill: "#F7EDE8", d: "M185.32265,252.65935c-11.18762-1.25537-21.27417,6.79588-22.52954,17.98338 l-9.42757,83.68814c-1.25531,11.1875,6.79596,19.27258,17.98358,20.52795c11.18756,1.25537,21.27411-4.79431,22.52948-15.98181 l9.42757-83.68814C204.56154,264.00113,196.51021,253.91472,185.32265,252.65935z" }),
			_react2.default.createElement("path", { className: "fill fill--alt", fill: "#B78A76", d: "M193.28119,362.48071c-1.39595,10.71671-10.06859,13.19708-22.48885,13.19708 c-12.42024,0-23.48965-1.38904-23.48965-12.19629c0-8.10541,6.22655-15.02548,14.57961-17.97891 c2.78435-0.9845,5.80499-1.52823,8.91005-1.52823c3.5649,0,7.05083,0.64352,10.1765,1.81403 C188.73314,348.69601,194.27446,354.85547,193.28119,362.48071z" }),
			_react2.default.createElement("path", { className: "fill", fill: "#F7EDE8", d: "M239.59492,252.65935c-11.18762-1.25537-21.27417,6.79588-22.52954,17.98338 l-9.42758,83.68814c-1.25531,11.1875,6.79596,19.27258,17.98358,20.52795c11.18756,1.25537,21.27411-4.79431,22.52948-15.98181 l9.42757-83.68814C258.8338,264.00113,250.78249,253.91472,239.59492,252.65935z" }),
			_react2.default.createElement("path", { className: "fill fill--alt", fill: "#B78A76", d: "M247.55345,362.48071c-1.39595,10.71671-10.06859,13.19708-22.48885,13.19708 c-12.42024,0-23.48964-1.38904-23.48964-12.19629c0-10.80722,11.0694-19.50714,23.48964-19.50714 C237.48486,343.97437,248.94659,351.78577,247.55345,362.48071z" }),
			_react2.default.createElement("path", { className: "fill fill--alt", fill: "#B78A76", d: "M336.13098,293.28613c-28.10754-16.89716-66.83844,6.17871-50.85712,51.55591 c-8.83398,2.02393-17.22394,4.2341-20.24677,13.79193c-1.15604,3.65549-0.79999,6.72189,0.216,9.20038 c1.98541,4.84323,6.89575,7.84344,12.13,7.84344h13.0043h0.48563h35.13348c20.9079,0,23.36536-21.37454,26.30151-41.50098 C354.28412,320.56305,350.79184,302.09967,336.13098,293.28613z" }),
			_react2.default.createElement("path", { className: "fill fill--alt", fill: "#B78A76", d: "M265.21698,279.28073c-0.91028-6.53882-6.68173-15.63458-15.25095-15.78094 c-8.5692-0.14633-18.46236,6.72153-19.83272,15.18173c-2.17659,13.43774,17.60139,25.49323,27.85793,21.59344 C266.0022,297.22897,266.23395,286.58603,265.21698,279.28073z" }),
			_react2.default.createElement("path", { className: "fill fill--alt", fill: "#B78A76", d: "M319.93579,269.12598c-13.36566-11.59082-29.43048-21.79028-45.53638-30.39966 c-6.25592,13.63672-5.10388,34.99976,8.3667,42.24243c11.1853,6.01416,28.18018,0.56934,35.73206-9.64087 C319.02637,270.61377,319.50195,269.8772,319.93579,269.12598z" })
		);
	}

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make group for face '.fill--face'
	// Make glasses target 'ref="glassesTarget"'
	// Make groups for each eye group
	// - '.fill-eyes eyes'
	// - '.fill-face eyes--blink'
	// - '.fill-face eyes--is-being-pet--likes'
	// - '.fill-eyes eyes--is-being-pet--hates'
	
	var Eyes = function (_React$Component) {
		_inherits(Eyes, _React$Component);
	
		function Eyes() {
			_classCallCheck(this, Eyes);
	
			return _possibleConstructorReturn(this, (Eyes.__proto__ || Object.getPrototypeOf(Eyes)).apply(this, arguments));
		}
	
		_createClass(Eyes, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getGlassesTargetCoords(this.refs.glassesTarget);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					{ className: "fill--face" },
					_react2.default.createElement("circle", { ref: "glassesTarget", cx: "206.796524", cy: "187.6204834", r: "0" }),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes" },
						_react2.default.createElement("ellipse", { cx: "180.0855865", cy: "187.6206055", rx: "7.8169193", ry: "8.6854658" }),
						_react2.default.createElement("ellipse", { cx: "233.1963654", cy: "187.6206055", rx: "7.8169193", ry: "8.6854658" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--blink" },
						_react2.default.createElement("path", { d: "M225.9395905,193.4739685c0.1542969,0,0.3105469-0.0141602,0.4677734-0.0439453l15.265625-2.8896484 c1.3564453-0.2568359,2.2480469-1.5649414,1.9912109-2.9213867c-0.2568359-1.3569336-1.5634766-2.2470703-2.9208984-1.9916992 l-15.265625,2.8896484c-1.3564453,0.2568359-2.2480469,1.5649414-1.9912109,2.9213867 C223.713028,192.638031,224.7618561,193.4739685,225.9395905,193.4739685z" }),
						_react2.default.createElement("path", { d: "M187.3423615,193.4739685c-0.1542969,0-0.3105469-0.0141602-0.4677734-0.0439453l-15.265625-2.8896484 c-1.3564453-0.2568359-2.2480469-1.5649414-1.9912109-2.9213867c0.2568359-1.3569336,1.5634766-2.2470703,2.9208984-1.9916992 l15.265625,2.8896484c1.3564453,0.2568359,2.2480469,1.5649414,1.9912109,2.9213867 C189.568924,192.638031,188.5200958,193.4739685,187.3423615,193.4739685z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--is-being-pet--likes" },
						_react2.default.createElement("path", { d: "M225.9411011,193.3410492c0.6044922,0,1.2099609-0.2177734,1.6904297-0.6591797 c0.9189453-0.84375,2.9033203-1.7983398,5.7177734-1.9462891c2.8125-0.1425781,4.8876953,0.5942383,5.8896484,1.3378906 c1.1103516,0.8237305,2.6748047,0.5908203,3.4970703-0.5170898c0.8232422-1.1083984,0.5917969-2.6743164-0.5166016-3.4975586 c-2.234375-1.6591797-5.5507812-2.5053711-9.1318359-2.3164062c-3.5683594,0.1875-6.7900391,1.375-8.8388672,3.2578125 c-1.0166016,0.934082-1.0839844,2.515625-0.1494141,3.5322266 C224.5924683,193.0690765,225.2653198,193.3410492,225.9411011,193.3410492z" }),
						_react2.default.createElement("path", { d: "M187.3408508,193.3410492c-0.6044922,0-1.2099609-0.2177734-1.6904297-0.6591797 c-0.9189453-0.84375-2.9033203-1.7983398-5.7177734-1.9462891c-2.8125-0.1425781-4.8876953,0.5942383-5.8896484,1.3378906 c-1.1103516,0.8237305-2.6748047,0.5908203-3.4970703-0.5170898c-0.8232422-1.1083984-0.5917969-2.6743164,0.5166016-3.4975586 c2.234375-1.6591797,5.5507812-2.5053711,9.1318359-2.3164062c3.5683594,0.1875,6.7900391,1.375,8.8388672,3.2578125 c1.0166016,0.934082,1.0839844,2.515625,0.1494141,3.5322266 C188.6894836,193.0690765,188.0166321,193.3410492,187.3408508,193.3410492z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes--is-being-pet--hates" },
						_react2.default.createElement("path", { d: "M187.9025116,187.6206055c0,4.7968445-3.4997559,8.6854706-7.816925,8.6854706 c-4.3171539,0-7.8169098-3.8886261-7.8169098-8.6854706c0-3.6821594,3.728363-3.6814728,7.8169098-3.6814728 S187.9025116,183.9147949,187.9025116,187.6206055z" }),
						_react2.default.createElement("path", { d: "M241.0075531,187.6206055c0,4.7968445-3.4997559,8.6854706-7.816925,8.6854706s-7.816925-3.8886261-7.816925-8.6854706 c0-3.6821594,3.7283783-3.6814728,7.816925-3.6814728S241.0075531,183.9147949,241.0075531,187.6206055z" })
					)
				);
			}
		}]);
	
		return Eyes;
	}(_react2.default.Component);
	
	exports.default = Eyes;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make hatTarget 'ref="hatTarget"'
	// Add '.fill' to all body elements
	// Add '.fill--face' to nose
	
	var HeadHOC = function (_React$Component) {
		_inherits(HeadHOC, _React$Component);
	
		function HeadHOC() {
			_classCallCheck(this, HeadHOC);
	
			return _possibleConstructorReturn(this, (HeadHOC.__proto__ || Object.getPrototypeOf(HeadHOC)).apply(this, arguments));
		}
	
		_createClass(HeadHOC, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getHatTargetCoords(this.refs.hatTarget);
			}
		}]);
	
		return HeadHOC;
	}(_react2.default.Component);
	
	var Heads = function (_HeadHOC) {
		_inherits(Heads, _HeadHOC);
	
		function Heads() {
			_classCallCheck(this, Heads);
	
			return _possibleConstructorReturn(this, (Heads.__proto__ || Object.getPrototypeOf(Heads)).apply(this, arguments));
		}
	
		_createClass(Heads, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "205.6381073", cy: "135.2619781", r: "0" }),
					_react2.default.createElement("path", { className: "fill", fill: "#F7EDE8", d: "M206.63898,245.34312c29.90564,0.99332,52.01013-20.01332,63.60568-77.88104 c0,0-7.60019-50.86475-63.60655-50.86475c-56.00569,0-63.60591,50.86475-63.60591,50.86475 c11.59558,57.86772,33.70006,78.87436,63.6057,77.88104H206.63898z" }),
					_react2.default.createElement(
						"g",
						{ className: "tongue" },
						_react2.default.createElement("path", { fill: "#B45A60", d: "M206.80154,204.31487c14.85411,0,21.00183-24.62981,21.00183-24.62981s-6.14772-4.39352-21.00182-4.39352 c-14.85411,0-21.00183,4.39352-21.00183,4.39352S191.94745,204.31487,206.80154,204.31487z" }),
						_react2.default.createElement("path", { fill: "#FC5959", d: "M206.80167,196.96463c0,0,6.00156-0.33357,7.61101,0.85893s2.73509,3.88394,3.64272,5.82573 c0.87399,1.94197,1.51778,3.88376,1.96617,5.82573c0.45567,1.94199,0.6993,3.88376,0.6731,5.82574 c-0.0392,1.94197-0.26118,3.88376-1.13927,5.82573c-1.16982,2.52538-4.06149,4.67981-8.00044,5.5312 c-1.20993,0.26147-3.54944,0.38599-4.7536,0.3862c-1.20416-0.00021-3.54367-0.12473-4.7536-0.3862 c-3.93895-0.85139-6.83063-3.00583-8.00046-5.5312c-0.87807-1.94197-1.10007-3.88376-1.13927-5.82573 c-0.0262-1.94199,0.21744-3.88376,0.67311-5.82574c0.44839-1.94197,1.09218-3.88376,1.96617-5.82573 c0.90762-1.94179,2.03326-4.63322,3.64272-5.82573S206.80103,196.96463,206.80167,196.96463z" })
					),
					_react2.default.createElement("path", { className: "fill", fill: "#F7EDE8", d: "M206.63844,147.29478c19.27068,0,41.6738,8.33925,37.88759,44.45351 c-3.08282,29.40503-17.98793,36.12108-37.72501,36.12108s-34.96736-6.71602-38.05019-36.12108 C164.96463,155.63403,187.36775,147.29478,206.63844,147.29478z" }),
					_react2.default.createElement("path", { className: "fill--face", fill: "#1A1A1A", d: "M206.63844,205.06024c-4.71431,0-8.01779,0.91878-9.51407,2.79565 c-1.49629,1.87688-2.09663,6.32716-0.16583,9.95689c1.68944,3.17599,5.01839,5.21803,8.28746,5.67894 c0.46701,0.06584,2.25238,0.0704,2.68637,0.01341c3.30052-0.43341,6.67953-2.48445,8.38596-5.69235 c1.9308-3.62973,1.33046-8.08002-0.16583-9.95689C214.65622,205.97902,211.35274,205.06024,206.63844,205.06024z" }),
					_react2.default.createElement("path", { className: "fill fill--alt", fill: "#B78A76", d: "M203.69295,151.64412c-1.9566-5.3313-6.77899-9.98999-14.5545-10.66772 c-27.58606-2.4043-41.44598,9.99805-46.05585,26.11914c-0.04382,0.24561-0.06439,0.38062-0.06439,0.38062 c3.73126,18.62085,8.55658,33.40552,14.37396,44.88794l0.46184,0.89058c2.42152,5.65628,21.52602,12.40727,37.50856-15.12544 C201.30428,187.89363,208.54878,164.87532,203.69295,151.64412z" }),
					_react2.default.createElement(
						"g",
						{ className: "ear ear--right" },
						_react2.default.createElement("path", { className: "fill fill--alt", fill: "#B78A76", d: "M239.64149,132.53613c19.77919,38.45963,13.67339,84.05106,26.67735,87.68307 c9.88467,2.7608,49.68677-58.26537,31.83566-76.82358c-3.88922-4.04327-32.38397-22.82735-38.86493-27.01538 C247.57631,108.81104,228.69728,111.25569,239.64149,132.53613z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "ear ear--left" },
						_react2.default.createElement("path", { className: "fill fill--alt", fill: "#B78A76", d: "M173.63474,132.53613c-19.77919,38.45963-13.6734,84.05106-26.67737,87.68307 c-9.88466,2.7608-49.68676-58.26537-31.83566-76.82358c3.88921-4.04327,32.38399-22.82735,38.86493-27.01538 C165.69991,108.81104,184.57893,111.25569,173.63474,132.53613z" })
					)
				);
			}
		}]);
	
		return Heads;
	}(HeadHOC);
	
	exports.default = Heads;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	var _Bodies = __webpack_require__(535);
	
	var _Bodies2 = _interopRequireDefault(_Bodies);
	
	var _Heads = __webpack_require__(537);
	
	var _Heads2 = _interopRequireDefault(_Heads);
	
	var _Eyes = __webpack_require__(536);
	
	var _Eyes2 = _interopRequireDefault(_Eyes);
	
	var _Toy = __webpack_require__(17);
	
	var _Toy2 = _interopRequireDefault(_Toy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassicDoggo = function (_PetHOC) {
		_inherits(ClassicDoggo, _PetHOC);
	
		function ClassicDoggo(props) {
			_classCallCheck(this, ClassicDoggo);
	
			var _this = _possibleConstructorReturn(this, (ClassicDoggo.__proto__ || Object.getPrototypeOf(ClassicDoggo)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(500, 4000);
						}
					}
				}, {
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 2500);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 199;
						}
					}
				}, {
					name: 'wag',
					actions: ['isWaggingUp', 'isWaggingDown'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}],
				pet: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(600, 1200);
						}
					}
				}, {
					name: 'wag',
					actions: ['isWaggingUp', 'isWaggingDown'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return 100;
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(ClassicDoggo, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Bodies2.default, { body: this.props.body })
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Heads2.default, { getHatTargetCoords: this.getHatTargetCoords, head: this.props.head }),
									_react2.default.createElement(_Eyes2.default, { getGlassesTargetCoords: this.getGlassesTargetCoords }),
									this.shouldRenderHat(),
									this.shouldRenderGlasses()
								)
							)
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-toy', viewBox: '0 0 480 480' },
							_react2.default.createElement(_Toy2.default, { toy: this.props.toy })
						)
					)
				);
			}
		}]);
	
		return ClassicDoggo;
	}(_PetHOC3.default);
	
	exports.default = ClassicDoggo;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComingSoon = function (_PetHOC) {
		_inherits(ComingSoon, _PetHOC);
	
		function ComingSoon(props) {
			_classCallCheck(this, ComingSoon);
	
			var _this = _possibleConstructorReturn(this, (ComingSoon.__proto__ || Object.getPrototypeOf(ComingSoon)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'shake',
					actions: ['isShaking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(1000, 3000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 999;
						}
					}
				}],
				pet: []
			};
			return _this;
		}
	
		_createClass(ComingSoon, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'svg',
								{ viewBox: '0 0 480 480' },
								_react2.default.createElement(
									'g',
									{ className: 'egg' },
									_react2.default.createElement('path', { className: 'fill', d: 'M254,369.9c40.4,0,73.2-25.3,73.2-72.1s-38.4-97.4-73.2-97.4s-73.2,50.6-73.2,97.4S213.6,369.9,254,369.9z' }),
									_react2.default.createElement('path', { className: 'fill--text', d: 'M222,298.3c-0.9,0.8-1.8,1.4-2.9,1.9c-1.1,0.5-2.3,0.7-3.7,0.7c-1.6,0-3.1-0.3-4.4-0.8 c-1.3-0.5-2.4-1.2-3.3-2.2c-0.9-0.9-1.6-2-2.1-3.2s-0.7-2.6-0.7-4c0-1.4,0.2-2.8,0.7-4c0.5-1.2,1.2-2.3,2.1-3.3 c0.9-0.9,2-1.7,3.3-2.2c1.3-0.5,2.7-0.8,4.3-0.8c1.5,0,2.8,0.2,3.9,0.7c1.1,0.4,2,1,2.8,1.7l-2.8,3.6c-0.4-0.3-0.9-0.7-1.5-1 c-0.6-0.3-1.4-0.5-2.3-0.5c-0.9,0-1.7,0.2-2.3,0.5s-1.3,0.7-1.7,1.2c-0.5,0.5-0.8,1.1-1.1,1.8s-0.4,1.5-0.4,2.3 c0,0.8,0.1,1.6,0.4,2.3c0.3,0.7,0.6,1.3,1.1,1.8s1.1,0.9,1.7,1.2c0.7,0.3,1.4,0.4,2.3,0.4c0.8,0,1.6-0.2,2.2-0.5 c0.6-0.3,1.1-0.6,1.6-1L222,298.3z' }),
									_react2.default.createElement('path', { className: 'fill--text', d: 'M222.8,292.9c0-1.1,0.2-2.1,0.6-3.1c0.4-1,0.9-1.8,1.7-2.5c0.7-0.7,1.6-1.3,2.5-1.7s2-0.6,3.2-0.6 c1.3,0,2.4,0.2,3.4,0.6c1,0.4,1.8,1,2.5,1.7c0.7,0.7,1.2,1.5,1.6,2.5c0.4,1,0.6,2,0.6,3.1c0,1.1-0.2,2.2-0.6,3.1 c-0.4,1-0.9,1.8-1.6,2.5c-0.7,0.7-1.6,1.3-2.5,1.7c-1,0.4-2.1,0.6-3.3,0.6c-1.2,0-2.3-0.2-3.3-0.6s-1.8-1-2.5-1.7 c-0.7-0.7-1.2-1.5-1.6-2.5C223,295,222.8,294,222.8,292.9z M227.4,292.8c0,0.5,0.1,1,0.3,1.5c0.2,0.5,0.4,0.9,0.7,1.2 c0.3,0.3,0.7,0.6,1.1,0.8c0.4,0.2,0.9,0.3,1.4,0.3c0.5,0,1-0.1,1.4-0.3c0.4-0.2,0.8-0.5,1.1-0.8c0.3-0.3,0.5-0.7,0.7-1.2 c0.2-0.5,0.2-1,0.2-1.5s-0.1-1-0.3-1.5c-0.2-0.5-0.4-0.9-0.7-1.2c-0.3-0.3-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.4-0.3 c-0.6,0-1,0.1-1.5,0.3c-0.4,0.2-0.8,0.5-1.1,0.8c-0.3,0.3-0.5,0.7-0.7,1.2C227.4,291.8,227.4,292.3,227.4,292.8z' }),
									_react2.default.createElement('path', { className: 'fill--text', d: 'M253.8,300.5h-4.6V291c0-0.6-0.1-1-0.4-1.3c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5 c-0.3,0.3-0.4,0.8-0.4,1.3v9.5h-4.6v-15.3h4.6v1c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.1,0.4-0.3,0.6-0.4c0.3-0.1,0.6-0.2,0.9-0.3 c0.4-0.1,0.8-0.1,1.3-0.1c0.9,0,1.6,0.1,2.1,0.4s1,0.6,1.4,1c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.2,0.5-0.3,0.8-0.5 c0.3-0.1,0.7-0.3,1-0.3c0.4-0.1,0.8-0.1,1.3-0.1c1,0,1.8,0.1,2.5,0.4s1.2,0.7,1.6,1.2s0.7,1.1,0.9,1.7c0.2,0.6,0.3,1.3,0.3,2.1v10.1 h-4.6V291c0-0.6-0.1-1-0.4-1.3c-0.3-0.3-0.7-0.5-1.2-0.5c-0.6,0-1,0.2-1.2,0.6c-0.3,0.4-0.4,0.8-0.4,1.3V300.5z' }),
									_react2.default.createElement('path', { className: 'fill--text', d: 'M266.7,284.6c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.4-0.5-0.6-0.8c-0.1-0.3-0.2-0.7-0.2-1 c0-0.4,0.1-0.7,0.2-1c0.1-0.3,0.3-0.6,0.6-0.8c0.2-0.2,0.5-0.4,0.8-0.6s0.7-0.2,1-0.2s0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.8,0.6 c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.7,0.2,1c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.2,0.2-0.5,0.4-0.8,0.6 C267.4,284.5,267.1,284.6,266.7,284.6z M269.1,300.5h-4.6v-15.3h4.6V300.5z' }),
									_react2.default.createElement('path', { className: 'fill--text', d: 'M279.8,291c0-0.6-0.1-1-0.4-1.3c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.8-0.4,1.3v9.5h-4.6 v-15.3h4.6v1c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.1,0.4-0.3,0.6-0.4s0.5-0.2,0.9-0.3c0.4-0.1,0.8-0.1,1.2-0.1c0.9,0,1.6,0.1,2.3,0.4 c0.6,0.3,1.1,0.7,1.5,1.2s0.6,1.1,0.8,1.7s0.2,1.3,0.2,2.1v10.1h-4.6V291z' }),
									_react2.default.createElement('path', { className: 'fill--text', d: 'M298.6,285.2h4.3v12.8c0,1.4-0.2,2.6-0.6,3.6c-0.4,1-1,1.8-1.7,2.4c-0.7,0.6-1.6,1.1-2.6,1.3 c-1,0.3-2.2,0.4-3.4,0.4c-1.1,0-2.2-0.1-3.1-0.4c-0.9-0.3-1.7-0.5-2.4-0.9l1.4-3.6c0.4,0.2,1,0.4,1.8,0.6c0.7,0.2,1.5,0.3,2.4,0.3 c1,0,1.9-0.2,2.6-0.6c0.7-0.4,1.1-0.9,1.1-1.7c-0.3,0.3-0.8,0.6-1.4,0.8c-0.6,0.2-1.3,0.4-2.3,0.4c-1.2,0-2.3-0.2-3.3-0.6 c-1-0.4-1.8-0.9-2.5-1.6c-0.7-0.7-1.2-1.5-1.6-2.5c-0.4-1-0.6-2-0.6-3.2c0-1.1,0.2-2.1,0.6-3.1s0.9-1.8,1.6-2.5 c0.7-0.7,1.5-1.3,2.5-1.7c1-0.4,2-0.6,3.2-0.6c1.7,0,3.1,0.4,4.1,1.2V285.2z M291.3,292.8c0,0.5,0.1,1,0.3,1.5 c0.2,0.5,0.4,0.9,0.7,1.2s0.7,0.6,1.1,0.8c0.4,0.2,0.9,0.3,1.5,0.3c0.6,0,1.1-0.1,1.5-0.3s0.8-0.5,1.1-0.8c0.3-0.3,0.5-0.7,0.7-1.2 c0.2-0.5,0.2-0.9,0.2-1.5c0-0.5-0.1-1-0.3-1.5c-0.2-0.5-0.4-0.9-0.7-1.2s-0.7-0.6-1.1-0.8s-0.9-0.3-1.5-0.3c-0.6,0-1.1,0.1-1.5,0.3 c-0.4,0.2-0.8,0.5-1.1,0.8c-0.3,0.3-0.5,0.7-0.7,1.2S291.3,292.3,291.3,292.8z' }),
									_react2.default.createElement('path', { className: 'fill--text', d: 'M226.7,314.5c0,0.4,0.1,0.8,0.4,1.1c0.3,0.3,0.7,0.6,1.4,0.8l2.5,1c1.3,0.5,2.3,1.2,3,2.1 c0.7,0.9,1.1,2.1,1.1,3.6c0,1-0.2,1.9-0.5,2.7c-0.3,0.8-0.8,1.4-1.4,2c-0.6,0.5-1.3,1-2.2,1.2s-1.8,0.4-2.7,0.4 c-1.4,0-2.6-0.2-3.4-0.6c-0.9-0.4-1.5-0.9-2-1.6c-0.5-0.6-0.8-1.4-0.9-2.1c-0.1-0.8-0.2-1.5-0.2-2.2h4.5c0,0.3,0,0.6,0.1,0.9 c0.1,0.3,0.2,0.5,0.3,0.8c0.2,0.2,0.4,0.4,0.6,0.5s0.6,0.2,1,0.2c0.6,0,1-0.1,1.4-0.4c0.4-0.3,0.5-0.7,0.5-1.3c0-0.5-0.2-1-0.6-1.3 c-0.4-0.3-0.9-0.6-1.5-0.8c-0.5-0.2-1-0.4-1.5-0.6c-0.5-0.2-1-0.4-1.6-0.7c-1-0.5-1.8-1.2-2.3-2.2c-0.5-0.9-0.8-2-0.8-3.2 c0-0.9,0.2-1.6,0.5-2.4c0.3-0.7,0.7-1.3,1.3-1.9c0.6-0.5,1.2-0.9,2-1.2c0.8-0.3,1.7-0.4,2.6-0.4c1.2,0,2.1,0.2,3,0.5 c0.8,0.3,1.5,0.7,1.9,1.3s0.8,1.2,1,2c0.2,0.8,0.3,1.6,0.2,2.4H230c0-0.6-0.1-1.1-0.4-1.5c-0.3-0.4-0.7-0.6-1.3-0.6 c-0.6,0-1,0.1-1.2,0.4C226.8,313.8,226.7,314.1,226.7,314.5z' }),
									_react2.default.createElement('path', { className: 'fill--text', d: 'M237.1,321.5c0-1.1,0.2-2.1,0.6-3.1c0.4-1,0.9-1.8,1.7-2.5c0.7-0.7,1.6-1.3,2.5-1.7s2-0.6,3.2-0.6 c1.3,0,2.4,0.2,3.4,0.6c1,0.4,1.8,1,2.5,1.7c0.7,0.7,1.2,1.5,1.6,2.5c0.4,1,0.6,2,0.6,3.1c0,1.1-0.2,2.2-0.6,3.1 c-0.4,1-0.9,1.8-1.6,2.5c-0.7,0.7-1.6,1.3-2.5,1.7c-1,0.4-2.1,0.6-3.3,0.6c-1.2,0-2.3-0.2-3.3-0.6s-1.8-1-2.5-1.7 c-0.7-0.7-1.2-1.5-1.6-2.5C237.3,323.6,237.1,322.6,237.1,321.5z M241.7,321.4c0,0.5,0.1,1,0.3,1.5c0.2,0.5,0.4,0.9,0.7,1.2 c0.3,0.3,0.7,0.6,1.1,0.8c0.4,0.2,0.9,0.3,1.4,0.3c0.5,0,1-0.1,1.4-0.3c0.4-0.2,0.8-0.5,1.1-0.8c0.3-0.3,0.5-0.7,0.7-1.2 c0.2-0.5,0.2-1,0.2-1.5s-0.1-1-0.3-1.5c-0.2-0.5-0.4-0.9-0.7-1.2c-0.3-0.3-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.4-0.3 c-0.6,0-1,0.1-1.5,0.3c-0.4,0.2-0.8,0.5-1.1,0.8c-0.3,0.3-0.5,0.7-0.7,1.2C241.8,320.4,241.7,320.9,241.7,321.4z' }),
									_react2.default.createElement('path', { className: 'fill--text', d: 'M255.1,321.5c0-1.1,0.2-2.1,0.6-3.1c0.4-1,0.9-1.8,1.7-2.5c0.7-0.7,1.6-1.3,2.5-1.7s2-0.6,3.2-0.6 c1.3,0,2.4,0.2,3.4,0.6c1,0.4,1.8,1,2.5,1.7c0.7,0.7,1.2,1.5,1.6,2.5c0.4,1,0.6,2,0.6,3.1c0,1.1-0.2,2.2-0.6,3.1 c-0.4,1-0.9,1.8-1.6,2.5c-0.7,0.7-1.6,1.3-2.5,1.7c-1,0.4-2.1,0.6-3.3,0.6c-1.2,0-2.3-0.2-3.3-0.6s-1.8-1-2.5-1.7 c-0.7-0.7-1.2-1.5-1.6-2.5C255.3,323.6,255.1,322.6,255.1,321.5z M259.7,321.4c0,0.5,0.1,1,0.3,1.5c0.2,0.5,0.4,0.9,0.7,1.2 c0.3,0.3,0.7,0.6,1.1,0.8c0.4,0.2,0.9,0.3,1.4,0.3c0.5,0,1-0.1,1.4-0.3c0.4-0.2,0.8-0.5,1.1-0.8c0.3-0.3,0.5-0.7,0.7-1.2 c0.2-0.5,0.2-1,0.2-1.5s-0.1-1-0.3-1.5c-0.2-0.5-0.4-0.9-0.7-1.2c-0.3-0.3-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.4-0.3 c-0.6,0-1,0.1-1.5,0.3c-0.4,0.2-0.8,0.5-1.1,0.8c-0.3,0.3-0.5,0.7-0.7,1.2C259.8,320.4,259.7,320.9,259.7,321.4z' }),
									_react2.default.createElement('path', { className: 'fill--text', d: 'M281.5,319.6c0-0.6-0.1-1-0.4-1.3c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.8-0.4,1.3v9.5h-4.6 v-15.3h4.6v1c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.1,0.4-0.3,0.6-0.4s0.5-0.2,0.9-0.3c0.4-0.1,0.8-0.1,1.2-0.1c0.9,0,1.6,0.1,2.3,0.4 c0.6,0.3,1.1,0.7,1.5,1.2s0.6,1.1,0.8,1.7s0.2,1.3,0.2,2.1v10.1h-4.6V319.6z' })
								)
							)
						)
					)
				);
			}
		}]);
	
		return ComingSoon;
	}(_PetHOC3.default);
	
	exports.default = ComingSoon;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Bodies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Add '.fill' to all body classes
	
	function Bodies() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill", d: "M380.0362549,321.7388c0.0998535-0.9068604,0.2870789-1.7940979,0.2870789-2.728241 c0-79.1560669-78.7913513-108.7231903-129.1038818-108.7231903c0,0-71.0446472-5.8880768-88.8769684,8.6281128 c-53.4115143,46.0286713-7.5922699,109.9627838,3.9866791,138.0825653 c1.3732758,3.335022,4.3396454,5.7366943,7.8925629,6.3570251c27.5469971,4.8096313,141.8412933,22.6150513,185.4226837-4.6194763 c5.1143188,10.6028442,1.2130432,23.7159729-14.3822937,27.381012 c-16.9381409,3.9802246-35.8396301,4.5001221-54.1889038,4.2585754 c-8.6318359-0.1136169-17.1412964-0.3956909-25.2669983-0.5654602 c-25.6242371-0.534729-25.6202698,39.2702942,0.0002747,39.8050232 c8.4207458,0.1755981,16.8451843,0.2015381,25.2648621,0.0500488c17.9183655-0.3226013,35.8163147-1.4490051,53.6173706-3.6454468 c20.0723877-2.4763489,37.7563782-9.6443481,48.7392883-27.6848145 C410.091217,370.9641113,401.3852539,340.5081482,380.0362549,321.7388z" }),
			_react2.default.createElement("path", { className: "fill fill--white", d: "M265.8063049,389.8097839 c-7.2068481-0.1504517-12.3864441,2.8900757-15.5391235,7.3504639c-0.3502655,0.4955444-0.6755829,1.0085449-0.9757843,1.5369263 c-6.6053009,11.6209717-1.0990143,30.5499878,16.5150909,30.9176025 c4.5776672,0.0953674,9.1563721,0.1422424,13.7348938,0.1446228c0.002655-0.0095215,0.0096741-0.0158997,0.0121155-0.0254211 c2.6511841-10.3779907,3.0579834-29.2466431,0.9423523-38.8176575c-0.0669556-0.3029785-0.2444763-0.5453186-0.4686584-0.7611694 c-4.8287964-0.1178589-9.5899963-0.2487183-14.2180481-0.3453674 C265.8083496,389.8097839,265.8070984,389.8097839,265.8063049,389.8097839z" }),
			_react2.default.createElement("path", { className: "fill fill--white leopard--foot leopard--foot--right", d: "M220.4105682,350.1894226 c-5.7938538,0.1106873-11.7185516,2.0271606-16.5286102,5.8106079c-4.157135,3.2698669-6.3834839,8.0459595-6.3535614,12.3847961 l0,0c-0.0002899,7.0748596,2.8796082,12.5444946,22.8821716,12.5444946s22.8824615-5.469635,22.8821716-12.5444946l0,0 c0.0299225-4.3388367-2.1964264-9.1149292-6.3535614-12.3847961 C232.1291199,352.2165833,226.204422,350.3001099,220.4105682,350.1894226z" }),
			_react2.default.createElement("path", { className: "fill fill--white leopard--foot leopard--foot--left", d: "M184.2732086,350.1894226 c-5.7938538,0.1106873-11.7185516,2.0271606-16.5286102,5.8106079c-4.157135,3.2698669-6.3834839,8.0459595-6.3535614,12.3847961 l0,0c-0.0002899,7.0748596,2.8796082,12.5444946,22.8821716,12.5444946s22.8824768-5.469635,22.8821716-12.5444946l0,0 c0.0299377-4.3388367-2.1964264-9.1149292-6.3535614-12.3847961 C195.9917603,352.2165833,190.0670776,350.3001099,184.2732086,350.1894226z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M223.4559326,338.7227173c8.9792175-6.3699646,1.6179199-17.3471985-7.8289032-10.6342468 C206.513916,334.56427,214.7143555,344.9240417,223.4559326,338.7227173z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M237.0736084,344.364502c6.3699951,8.9792175,17.347229,1.6179199,10.6342773-7.8289185 C241.2320862,327.4224854,230.8722839,335.6229248,237.0736084,344.364502z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M237.2693024,322.2219849c10.8535309,1.8449707,13.4103851-11.1223145,1.9837036-13.0554504 C228.2299805,307.3016663,226.7030945,320.4257507,237.2693024,322.2219849z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M312.8660583,397.5403442c7.792511-7.7768555,17.3717041,1.3295593,9.162323,9.509552 C314.1090088,414.940918,305.2798767,405.1114502,312.8660583,397.5403442z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M310.1375732,265.3736572c-0.4491882,0-0.9047241-0.0556335-1.3592224-0.172699 c-2.9006653-0.7484741-4.6455078-3.7063599-3.8975525-6.6070251c0.9672241-3.7508392,0.5455933-6.7161255-1.1272278-7.9312744 c-0.9524231-0.689682-2.2141724-0.7246399-3.2206116-0.0836945c-1.8486633,1.177536-2.4853821,4.2943268-1.701416,8.338089 c0.5689087,2.9409485-1.3528748,5.7870483-4.2937927,6.3564758c-2.9419861,0.5683899-5.7886353-1.3528748-6.3575439-4.2937927 c-1.6622009-8.5822906,0.7776184-15.8911743,6.526001-19.5514374c4.7895813-3.0484619,10.8409424-2.8699493,15.4218445,0.456604 c5.4136047,3.9314728,7.3798523,11.190567,5.2578735,19.4179535 C314.7545166,263.7495728,312.5519714,265.3736572,310.1375732,265.3736572z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M337.1419983,299.3717651c-1.8571472,0-3.6655579-0.95401-4.6773071-2.6691895 c-1.5223694-2.5802002-0.6642456-5.9057007,1.9154053-7.4275513c3.3360901-1.9683838,5.1349792-4.3631897,4.810791-6.4057312 c-0.1843262-1.1611023-1.0551758-2.0785522-2.2184143-2.3365173c-2.1410522-0.4751587-4.7927551,1.2797546-7.098053,4.6926575 c-1.6759949,2.4816895-5.0491638,3.1358643-7.5313416,1.4588013c-2.4822083-1.6770325-3.1358643-5.0486145-1.4588318-7.5308228 c4.8923645-7.2437134,11.7849121-10.6884155,18.4390869-9.2110596 c5.5407104,1.2294617,9.6946716,5.6365967,10.5813904,11.2271118 c1.0488281,6.6086121-2.6940918,13.1314087-10.0114441,17.4485168 C339.0277405,299.1286316,338.0785217,299.3717651,337.1419983,299.3717651z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M307.3337097,287.8204956c-7.7924805,7.776886-17.3717041-1.3295593-9.162323-9.509552 C306.0907593,270.4199219,314.9198914,280.2494202,307.3337097,287.8204956z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M283.5329895,225.267868c7.776886,7.792511-1.3295593,17.3717041-9.509552,9.162323 C266.1324158,226.5108185,275.9619141,217.6816864,283.5329895,225.267868z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M359.6795654,307.9844971c-7.7768555-7.792511,1.3295593-17.3717041,9.509552-9.162323 C377.0801392,306.7415466,367.2506714,315.5706787,359.6795654,307.9844971z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M361.909729,333.9134521c-7.776886-7.792511,1.3295593-17.3717041,9.509552-9.162323 C379.3103027,332.6705017,369.4808044,341.4996338,361.909729,333.9134521z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M181.2584381,338.7227173c-8.9792023-6.3699646-1.6179047-17.3471985,7.8289185-10.6342468 C198.2004547,334.56427,190.0000153,344.9240417,181.2584381,338.7227173z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M167.4450684,322.2219849c-10.8535156,1.8449707-13.4103699-11.1223145-1.9836884-13.0554504 C176.4844055,307.3016663,178.0112915,320.4257507,167.4450684,322.2219849z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M349.178894,316.257019c-0.0110474,11.0092163-13.2237854,11.3435059-13.2030029-0.2455139 C335.9959412,304.8318787,349.1895752,305.5392151,349.178894,316.257019z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M368.8470154,285.4622192c0.9312134,0.6287537,1.9863892,0.9296265,3.0309753,0.9296265 c1.0888672,0,2.1657104-0.3270874,3.0759888-0.951355c-3.0688477-8.9398499-7.344574-16.9749451-12.5326233-24.1638489 c-1.3328247,1.6299133-2.3044434,3.5794678-2.7848816,5.7459717 C358.159668,273.6757202,361.6027527,280.5687866,368.8470154,285.4622192z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M344.4169617,243.2880859c0.487793,0.1255493,0.9736633,0.1565247,1.4542542,0.147522 c-4.1380005-3.532608-8.5265503-6.7540131-13.0961914-9.6787872c-2.0081787,1.0178375-3.7327576,2.4469757-5.0671082,4.2839966 c-3.32547,4.580368-3.5045166,10.633316-0.456604,15.4213409c2.9038696,4.5602417,8.1023865,7.0376587,14.412262,7.0376587 c1.6452637,0,3.3657532-0.1684265,5.1402588-0.512207c2.940918-0.569458,4.8627014-3.4155579,4.2937927-6.3564758 c-0.5710144-2.9420013-3.4187317-4.8621826-6.3575439-4.293808c-4.0395203,0.7807922-7.160553,0.1472626-8.3375549-1.7019348 c-0.6398926-1.0048523-0.6070557-2.2687378,0.0836792-3.2200928 C337.7024231,242.7424927,340.6645508,242.3192596,344.4169617,243.2880859z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M295.1469116,219.662674c0.8867188,5.5910492,5.0406799,9.9981995,10.5813904,11.2276459 c1.0170593,0.2256622,2.037262,0.3363647,3.0574646,0.3363647c3.9181824,0,7.8013306-1.6402283,11.1965332-4.6878967 c-8.1107788-4.0183411-16.5476685-7.2363129-24.9825745-9.7124176 C294.9560242,217.7663269,294.9963379,218.7131805,295.1469116,219.662674z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M288.6619873,394.8660889c-0.020813,11.5891724,13.191925,11.2549133,13.2029724,0.2457886 c0.0019226-1.9376831-0.4319153-3.5429382-1.137146-4.815033c-3.6932983-0.0704651-7.3488159-0.1578674-10.9590149-0.2500305 C289.086853,391.2905579,288.6655579,392.8887024,288.6619873,394.8660889z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M157.0065002,336.535675c-0.1091919,0.153595-0.2009583,0.3048401-0.3008728,0.4573975 c2.0005646,4.0323792,3.9167023,7.809967,5.6102448,11.2705383c1.8300018-0.4179382,3.7230377-1.6410217,5.3249359-3.8991699 C173.8420715,335.6229858,163.4822845,327.4223328,157.0065002,336.535675z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M305.7422485,413.5602722c7.776886,7.7924805-1.3295593,17.3717041-9.509552,9.162323 C288.3416748,414.8032227,298.1711731,405.9740906,305.7422485,413.5602722z" })
		);
	}

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make group for face '.fill--face'
	// Make glasses target 'ref="glassesTarget"'
	// Make groups for each eye group
	// - '.fill-eyes eyes'
	// - '.fill-face eyes--blink'
	// - '.fill-face eyes--is-being-pet--likes'
	// - '.fill-eyes eyes--is-being-pet--hates'
	
	var Eyes = function (_React$Component) {
		_inherits(Eyes, _React$Component);
	
		function Eyes() {
			_classCallCheck(this, Eyes);
	
			return _possibleConstructorReturn(this, (Eyes.__proto__ || Object.getPrototypeOf(Eyes)).apply(this, arguments));
		}
	
		_createClass(Eyes, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getGlassesTargetCoords(this.refs.glassesTarget);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					{ className: "fill--face" },
					_react2.default.createElement("circle", { ref: "glassesTarget", cx: "201.2177277", cy: "193.0447998", r: "0" }),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes" },
						_react2.default.createElement("ellipse", { cx: "171.2177277", cy: "193.0447998", rx: "7.6592607", ry: "8.5102901" }),
						_react2.default.createElement("ellipse", { cx: "231.2177277", cy: "193.0447998", rx: "7.6592607", ry: "8.5102901" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--blink" },
						_react2.default.createElement("path", { d: "M178.8534698,199.0294952c-0.1542969,0-0.3105469-0.0141602-0.4677734-0.0439453l-15.265625-2.8896484 c-1.3564453-0.2568359-2.2480469-1.5649414-1.9912109-2.9213867c0.2568359-1.3569336,1.5634766-2.2470703,2.9208984-1.9916992 l15.265625,2.8896484c1.3564453,0.2568359,2.2480469,1.5649414,1.9912109,2.9213867 C181.0800323,198.1935577,180.0312042,199.0294952,178.8534698,199.0294952z" }),
						_react2.default.createElement("path", { d: "M223.5819855,199.0294952c0.1542969,0,0.3105469-0.0141602,0.4677734-0.0439453l15.265625-2.8896484 c1.3564453-0.2568359,2.2480469-1.5649414,1.9912109-2.9213867c-0.2568359-1.3569336-1.5634766-2.2470703-2.9208984-1.9916992 l-15.265625,2.8896484c-1.3564453,0.2568359-2.2480469,1.5649414-1.9912109,2.9213867 C221.355423,198.1935577,222.4042511,199.0294952,223.5819855,199.0294952z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--is-being-pet--likes" },
						_react2.default.createElement("path", { d: "M178.6112061,198.8965759c-0.6044922,0-1.2099609-0.2177734-1.6904297-0.6591797 c-0.9189453-0.84375-2.9033203-1.7983398-5.7177734-1.9462891c-2.8125-0.1425781-4.8876953,0.5942383-5.8896484,1.3378906 c-1.1103516,0.8237305-2.6748047,0.5908203-3.4970703-0.5170898c-0.8232422-1.1083984-0.5917969-2.6743164,0.5166016-3.4975586 c2.234375-1.6591797,5.5507812-2.5053711,9.1318359-2.3164062c3.5683594,0.1875,6.7900391,1.375,8.8388672,3.2578125 c1.0166016,0.934082,1.0839844,2.515625,0.1494141,3.5322266 C179.9598389,198.6246033,179.2869873,198.8965759,178.6112061,198.8965759z" }),
						_react2.default.createElement("path", { d: "M223.8242493,198.8965759c0.6044922,0,1.2099609-0.2177734,1.6904297-0.6591797 c0.9189453-0.84375,2.9033203-1.7983398,5.7177734-1.9462891c2.8125-0.1425781,4.8876953,0.5942383,5.8896484,1.3378906 c1.1103516,0.8237305,2.6748047,0.5908203,3.4970703-0.5170898c0.8232422-1.1083984,0.5917969-2.6743164-0.5166016-3.4975586 c-2.234375-1.6591797-5.5507812-2.5053711-9.1318359-2.3164062c-3.5683594,0.1875-6.7900391,1.375-8.8388672,3.2578125 c-1.0166016,0.934082-1.0839844,2.515625-0.1494141,3.5322266 C222.4756165,198.6246033,223.148468,198.8965759,223.8242493,198.8965759z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes--is-being-pet--hates" },
						_react2.default.createElement("path", { d: "M178.8769836,193.0447998c0,4.7001038-3.4291687,8.5102844-7.659256,8.5102844 c-4.2301025,0-7.6592712-3.8101807-7.6592712-8.5102844c0-3.0506287,3.4291687-3.0506287,7.6592712-3.0506287 C175.4478149,189.9941711,178.8769836,189.9941711,178.8769836,193.0447998z" }),
						_react2.default.createElement("path", { d: "M238.8769836,193.0447998c0,4.7001038-3.4291687,8.5102844-7.659256,8.5102844 c-4.2301025,0-7.6592712-3.8101807-7.6592712-8.5102844c0-3.0506287,3.4291687-3.0506287,7.6592712-3.0506287 C235.4478149,189.9941711,238.8769836,189.9941711,238.8769836,193.0447998z" })
					)
				);
			}
		}]);
	
		return Eyes;
	}(_react2.default.Component);
	
	exports.default = Eyes;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make hatTarget 'ref="hatTarget"'
	// Add '.fill' to all body elements
	// Add '.fill--face' to nose
	
	var HeadHOC = function (_React$Component) {
		_inherits(HeadHOC, _React$Component);
	
		function HeadHOC() {
			_classCallCheck(this, HeadHOC);
	
			return _possibleConstructorReturn(this, (HeadHOC.__proto__ || Object.getPrototypeOf(HeadHOC)).apply(this, arguments));
		}
	
		_createClass(HeadHOC, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getHatTargetCoords(this.refs.hatTarget);
			}
		}]);
	
		return HeadHOC;
	}(_react2.default.Component);
	
	var Heads = function (_HeadHOC) {
		_inherits(Heads, _HeadHOC);
	
		function Heads() {
			_classCallCheck(this, Heads);
	
			return _possibleConstructorReturn(this, (Heads.__proto__ || Object.getPrototypeOf(Heads)).apply(this, arguments));
		}
	
		_createClass(Heads, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "200.0660217", cy: "139.9579163", r: "0" }),
					_react2.default.createElement("path", { className: "fill ear ear--right", d: "M226.3887634,124.6551819 c-9.0610962,16.5014343-1.0314789,31.0526733,13.4719391,43.0548401 c23.9475861,19.8175812,36.1287994,7.9175873,45.1898956-8.583847s8.977356-42.769104-7.7424011-52.9901352 S235.4498596,108.1537399,226.3887634,124.6551819z" }),
					_react2.default.createElement("path", { className: "fill ear ear--left", d: "M176.3446198,124.6551819 c9.0610962,16.5014343,1.0314789,31.0526733-13.4719391,43.0548401 c-23.9475861,19.8175812-36.1288071,7.9175873-45.1898956-8.583847s-8.977356-42.769104,7.7424011-52.9901352 S167.2835236,108.1537399,176.3446198,124.6551819z" }),
					_react2.default.createElement("path", { className: "fill", d: "M258.3789673,192.372757c-2.2915039,0-4.3351135-1.6208954-4.7874908-3.9547882 c-0.5127563-2.6469421,1.2172699-5.2080688,3.8647308-5.7208252l27.4408875-5.3145294 c2.6517029-0.5101166,5.2080688,1.2183228,5.7208252,3.8647308c0.5127563,2.6469421-1.2172546,5.2080688-3.8647461,5.7208252 l-27.4408569,5.3145447C258.9987183,192.3430939,258.6861877,192.372757,258.3789673,192.372757z" }),
					_react2.default.createElement("path", { className: "fill", d: "M283.8249817,208.8217163c-0.2426147,0-0.4862671-0.0180054-0.7331238-0.0550842 l-25.4152832-3.8250122c-2.6654816-0.4009857-4.5014496-2.8874207-4.1009827-5.5539703 c0.4015198-2.6670685,2.8932495-4.5009003,5.5545044-4.1004486l25.4152832,3.8250122 c2.6654663,0.4009857,4.5014343,2.8874207,4.1009827,5.5539551 C288.2819214,207.0858765,286.1991272,208.8217163,283.8249817,208.8217163z" }),
					_react2.default.createElement("path", { className: "fill", d: "M272.620636,227.2549438c-0.7489929,0-1.508606-0.1732025-2.2215881-0.5381775 l-22.8748169-11.7186737c-2.3995667-1.2289276-3.3488007-4.1709137-2.1188202-6.5704803 c1.2289124-2.3995667,4.1698456-3.3482666,6.5704651-2.1188202l22.8748322,11.718689 c2.3995667,1.2289124,3.3487854,4.1708984,2.1188049,6.5704651 C276.1050415,226.2850647,274.394104,227.2549438,272.620636,227.2549438z" }),
					_react2.default.createElement("path", { className: "fill", d: "M143.2685699,192.372757c-0.3082886,0-0.619751-0.029129-0.9333344-0.0900421 l-27.4408875-5.3145447c-2.6474762-0.5127563-4.3774948-3.0738831-3.8647385-5.7208252 c0.5127563-2.6474762,3.0733566-4.3801422,5.7208252-3.8647308l27.4408798,5.3145294 c2.6474762,0.5127563,4.3774872,3.0738831,3.8647461,5.7208252 C147.6036835,190.7513275,145.5600739,192.372757,143.2685699,192.372757z" }),
					_react2.default.createElement("path", { className: "fill", d: "M117.8225632,208.8217163c-2.375206,0-4.4569473-1.7358398-4.8213882-4.1555481 c-0.4004593-2.6665344,1.4355011-5.1529694,4.1009827-5.5539551l25.4152985-3.8250122 c2.6750031-0.4031067,5.1529694,1.4344482,5.5544891,4.1004486c0.4004517,2.6665497-1.4355011,5.1529846-4.1009827,5.5539703 l-25.4152908,3.8250122C118.3088303,208.8037109,118.0641022,208.8217163,117.8225632,208.8217163z" }),
					_react2.default.createElement("path", { className: "fill", d: "M129.0269012,227.2549438c-1.7745132,0-3.4844055-0.9698792-4.3488846-2.6569977 c-1.2299805-2.3995667-0.2807465-5.3415527,2.1188202-6.5704651l22.8748245-11.718689 c2.3963776-1.2299805,5.3415527-0.2802124,6.5704651,2.1188202c1.2299805,2.3995667,0.2807465,5.3415527-2.1188202,6.5704803 l-22.8748169,11.7186737C130.5365601,227.0817413,129.7759094,227.2549438,129.0269012,227.2549438z" }),
					_react2.default.createElement("path", { className: "fill", d: "M129.7895966,200.7459259c0,0-6.3126526,41.8558044,71.5770874,41.8558044 s71.5771027-41.8558044,71.5771027-41.8558044c0-62.5276031-34.2851257-83.408287-71.5771027-83.408287 S129.7895966,138.2183228,129.7895966,200.7459259z" }),
					_react2.default.createElement("path", { className: "fill fill--white", d: "M201.2817688,246.1000366c-10.7256622,0-21.0442505-6.2400513-21.0442505-16.587677 c0-13.2633209,10.1630402-16.1316376,10.1630402-16.1316376l10.8478699,2.6056366c0,0,0.0755768,0,0.0755768,0h0.0755768 l10.8478699-2.6056366c0,0,10.1630402,2.8683167,10.1630402,16.1316376c0,10.3476257-10.3186035,16.587677-21.0442505,16.587677 H201.2817688z" }),
					_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M194.7651825,149.4967957c0.0110474,11.0092163,13.2237854,11.3435059,13.2030029-0.2455292 C207.9481506,138.0716248,194.7545013,138.7789764,194.7651825,149.4967957z" }),
					_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M178.746994,138.4436035c7.7924957,7.776886,17.3717041-1.3295593,9.162323-9.5095367 C179.9899445,121.0430374,171.1608124,130.8725281,178.746994,138.4436035z" }),
					_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M223.9863892,138.4436035c-7.792511,7.776886-17.3717041-1.3295593-9.162323-9.5095367 C222.7434387,121.0430374,231.5725708,130.8725281,223.9863892,138.4436035z" }),
					_react2.default.createElement("path", { className: "fill fill--dark leopard--spot", d: "M207.9681702,119.3722382c-0.0011902-0.6661072-0.0521088-1.2871857-0.1412964-1.8695984 c-2.1394196-0.1101837-4.2943268-0.1650085-6.4601593-0.1650085c-2.1484222,0-4.2861176,0.0540314-6.4085846,0.1626205 c-0.1220245,0.6571045-0.1936646,1.3594894-0.1929474,2.1175003 C194.7762451,130.6268921,207.9889679,130.9614105,207.9681702,119.3722382z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M201.3662415,222.3027802 c-0.6699371-0.010437-1.3378448-0.1875153-1.9539032-0.5304565l-8.9451294-4.9795227c0,0-0.9540253-0.3971558-0.9540253-2.0123138 c0-2.0688782,0.9606018-1.7815094,0.9629517-1.805191c0,0,7.5287628,1.2325897,10.8812103,1.2325897 s10.8901062-1.2325897,10.8901062-1.2325897c0.0023346,0.0236816,0.9629364-0.2636871,0.9629364,1.805191 c0,1.6151581-0.9540253,2.0123138-0.9540253,2.0123138l-8.9451141,4.9795227 c-0.6160583,0.3429413-1.2839661,0.5200195-1.9539032,0.5304565H201.3662415z" })
				);
			}
		}]);
	
		return Heads;
	}(HeadHOC);
	
	exports.default = Heads;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	var _Bodies = __webpack_require__(540);
	
	var _Bodies2 = _interopRequireDefault(_Bodies);
	
	var _Heads = __webpack_require__(542);
	
	var _Heads2 = _interopRequireDefault(_Heads);
	
	var _Eyes = __webpack_require__(541);
	
	var _Eyes2 = _interopRequireDefault(_Eyes);
	
	var _Toy = __webpack_require__(17);
	
	var _Toy2 = _interopRequireDefault(_Toy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Leopard = function (_PetHOC) {
		_inherits(Leopard, _PetHOC);
	
		function Leopard(props) {
			_classCallCheck(this, Leopard);
	
			var _this = _possibleConstructorReturn(this, (Leopard.__proto__ || Object.getPrototypeOf(Leopard)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(500, 4000);
						}
					}
				}, {
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 2500);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 199;
						}
					}
				}, {
					name: 'alert',
					actions: ['isAlert'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 4000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(1000, 2000);
						}
					}
				}],
				pet: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(600, 1200);
						}
					}
				}, {
					name: 'stomp',
					actions: ['isStompingRight', 'isStompingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return 400;
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 800;
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(Leopard, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Bodies2.default, { body: this.props.body })
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Heads2.default, { getHatTargetCoords: this.getHatTargetCoords, head: this.props.head }),
									_react2.default.createElement(_Eyes2.default, { getGlassesTargetCoords: this.getGlassesTargetCoords }),
									this.shouldRenderHat(),
									this.shouldRenderGlasses()
								)
							)
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-toy', viewBox: '0 0 480 480' },
							_react2.default.createElement(_Toy2.default, { toy: this.props.toy })
						)
					)
				);
			}
		}]);
	
		return Leopard;
	}(_PetHOC3.default);
	
	exports.default = Leopard;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Bodies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function Bodies() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				{ className: "tail" },
				_react2.default.createElement("path", { className: "fill", d: "M359.0834961,304.7711792c-0.6818848,4.6611328-2.1442871,8.7407227-3.7849121,12.6875 c-1.6953125,3.90625-3.6633301,7.6091309-5.8913574,11.1184082c-2.2246094,3.5117188-4.6977539,6.8381348-7.5297852,9.8974609 c-2.8408203,3.0524902-5.9128418,5.9328613-9.8122559,8.1967773c-7.3911133,4.2910156-16.8613281,1.777832-21.1523438-5.6132812 c-2.0727539-3.5705566-2.5490723-7.6625977-1.6633301-11.3852539c1.0534668-4.3842773,2.9345703-8.1518555,5.046875-11.7473145 c2.1210938-3.5888672,4.6008301-6.9104004,7.3293457-10.046875c2.7250977-3.138916,5.7102051-6.0839844,8.9680176-8.8259277 c3.3122559-2.7011719,6.8032227-5.2697754,11.0742188-7.2565918c6.1794434-2.8747559,13.5192871-0.1958008,16.394043,5.9836426 C359.1179199,300.0494995,359.4243164,302.46698,359.0834961,304.7711792z" })
			),
			_react2.default.createElement("path", { className: "fill", d: "M321.6542358,301.6124268c-13.0026245-16.9149475-54.2415771-28.4346924-63.8843994-32.4041748 c0,0-21.9933929-18.7685547-36.7140961-18.7685547c-26.2734375,0-47.5722656,21.2988281-47.5722656,47.5722656 s32.5313721,29.1589355,57.5722656,38.5722656c6.2717285,2.3574219,76.8852997,34.2780457,88.3958893,28.7803955 S345.5444641,332.6908264,321.6542358,301.6124268z" }),
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { className: "fill", d: "M195.0930176,286.253418c-10.3530273-1.7138672-20.1337891,5.2910156-21.8466797,15.6435547 l-7.3237305,44.2670898c-1.7128906,10.3525391,5.2910156,20.1333008,15.644043,21.8461914 c1.0498047,0.1738281,2.0932617,0.2578125,3.1240234,0.2578125c9.1289062,0,17.1831055-6.5991211,18.722168-15.9013672 l7.3237305-44.2670898C212.4494629,297.7470703,205.4455566,287.9663086,195.0930176,286.253418z" }),
				_react2.default.createElement("path", { className: "fill", d: "M243.4758301,286.253418c-10.3486328-1.7138672-20.1337891,5.2910156-21.8466797,15.6435547 l-7.3237305,44.2670898c-1.7128906,10.3525391,5.2910156,20.1333008,15.644043,21.8461914 c1.0498047,0.1738281,2.0932617,0.2578125,3.1240234,0.2578125c9.1289062,0,17.1831055-6.5991211,18.722168-15.9013672 l7.3237305-44.2670898C260.8322754,297.7470703,253.8283691,287.9663086,243.4758301,286.253418z" })
			),
			_react2.default.createElement("path", { className: "fill", d: "M230.3373413,368.2766418h-11.3812714c-4.7125854,0-9.133255-2.7010803-10.9207001-7.0615234 c-0.9146729-2.2313538-1.2354736-4.9921265-0.1945648-8.2832947c3.2383881-10.2391968,16.5957642-15.9115601,26.6977539-16.5403748 " }),
			_react2.default.createElement("path", { className: "fill", d: "M181.9546204,368.2766418H170.573349c-4.7125854,0-9.133255-2.7010803-10.9207001-7.0615234 c-0.9146729-2.2313538-1.2354736-4.9921265-0.1945648-8.2832947c3.2383881-10.2391968,16.5957642-15.9115601,26.6977539-16.5403748 " }),
			_react2.default.createElement("path", { className: "fill", d: "M284.1054382,368.2766418h-11.3812866c-4.7125854,0-9.1332397-2.7010803-10.9206848-7.0615234 c-0.9146729-2.2313538-1.2354736-4.9921265-0.1945801-8.2832947c3.2384033-10.2391968,16.5958252-15.9115601,26.6977539-16.5404663 c-0.8057861-23.3146973,34.8178101-23.4765625,41.2861023-6.5322876 c5.2611084,13.7819519,1.7027588,27.5638733-6.2441101,34.6651917c-2.7450562,2.4529724-6.3317261,3.7523804-10.0130615,3.7523804 h-23.9750977H284.1054382z" })
		);
	}

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make group for face '.fill--face'
	// Make glasses target 'ref="glassesTarget"'
	// Make groups for each eye group
	// - '.fill-eyes eyes'
	// - '.fill-face eyes--blink'
	// - '.fill-face eyes--is-being-pet--likes'
	// - '.fill-eyes eyes--is-being-pet--hates'
	
	var Eyes = function (_React$Component) {
		_inherits(Eyes, _React$Component);
	
		function Eyes() {
			_classCallCheck(this, Eyes);
	
			return _possibleConstructorReturn(this, (Eyes.__proto__ || Object.getPrototypeOf(Eyes)).apply(this, arguments));
		}
	
		_createClass(Eyes, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getGlassesTargetCoords(this.refs.glassesTarget);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					{ className: "fill--face" },
					_react2.default.createElement("circle", { ref: "glassesTarget", cx: "212.211853", cy: "213.2509918", r: "0" }),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes" },
						_react2.default.createElement("path", { d: "M192.6565552,213.1061401c0,5.1973877-3.4291687,8.3049011-7.659256,8.3049011 c-4.2301025,0-7.6592712-3.1075134-7.6592712-8.3049011c0-5.1973724,3.4291687-8.3048859,7.6592712-8.3048859 C189.2273865,204.8012543,192.6565552,207.9087677,192.6565552,213.1061401z" }),
						_react2.default.createElement("path", { d: "M246.3686981,213.1061401c0,5.1973877-3.4291687,8.3049011-7.6592712,8.3049011 c-4.2300873,0-7.659256-3.1075134-7.659256-8.3049011c0-5.1973724,3.4291687-8.3048859,7.659256-8.3048859 C242.9395294,204.8012543,246.3686981,207.9087677,246.3686981,213.1061401z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--blink" },
						_react2.default.createElement("path", { d: "M192.3922729,219.0513916c-0.1542969,0-0.3105469-0.0141602-0.4677734-0.0439453l-15.265625-2.8896484 c-1.3564453-0.2568359-2.2480469-1.5649414-1.9912109-2.9213867c0.2568359-1.3569336,1.5634766-2.2470703,2.9208984-1.9916992 l15.265625,2.8896484c1.3564453,0.2568359,2.2480469,1.5649414,1.9912109,2.9213867 C194.6188354,218.2154541,193.5700073,219.0513916,192.3922729,219.0513916z" }),
						_react2.default.createElement("path", { d: "M231.3144531,219.0513916c-1.1777344,0-2.2265625-0.8359375-2.453125-2.0356445 c-0.2568359-1.3564453,0.6347656-2.6645508,1.9912109-2.9213867l15.265625-2.8896484 c1.3564453-0.2558594,2.6650391,0.6347656,2.9208984,1.9916992c0.2568359,1.3564453-0.6347656,2.6645508-1.9912109,2.9213867 l-15.265625,2.8896484C231.625,219.0372314,231.46875,219.0513916,231.3144531,219.0513916z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--is-being-pet--likes" },
						_react2.default.createElement("path", { d: "M192.3907623,218.9184875c-0.6044922,0-1.2099609-0.2177734-1.6904297-0.6591797 c-0.9189453-0.84375-2.9033203-1.7983398-5.7177734-1.9462891c-2.8125-0.1425781-4.8876953,0.5942383-5.8896484,1.3378906 c-1.1103516,0.8237305-2.6748047,0.5908203-3.4970703-0.5170898c-0.8232422-1.1083984-0.5917969-2.6743164,0.5166016-3.4975586 c2.234375-1.6591797,5.5507812-2.5053711,9.1318359-2.3164062c3.5683594,0.1875,6.7900391,1.375,8.8388672,3.2578125 c1.0166016,0.934082,1.0839844,2.515625,0.1494141,3.5322266 C193.7393951,218.6465149,193.0665436,218.9184875,192.3907623,218.9184875z" }),
						_react2.default.createElement("path", { d: "M231.3159637,218.9185333c-0.6757812,0-1.3486328-0.2719727-1.8417969-0.8085938 c-0.9345703-1.0166016-0.8671875-2.5981445,0.1494141-3.5322266c2.0488281-1.8828125,5.2705078-3.0703125,8.8388672-3.2578125 c3.5712891-0.1894531,6.8974609,0.6572266,9.1318359,2.3164062c1.1083984,0.8232422,1.3398438,2.3891602,0.5166016,3.4975586 c-0.8242188,1.1088867-2.3896484,1.3383789-3.4970703,0.5170898c-1.0009766-0.7436523-3.0634766-1.480957-5.8896484-1.3378906 c-2.8144531,0.1479492-4.7988281,1.1025391-5.7177734,1.9462891 C232.5259247,218.7007599,231.9204559,218.9185333,231.3159637,218.9185333z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes--is-being-pet--hates" },
						_react2.default.createElement("path", { d: "M192.6565552,213.1061401c0,5.1973877-3.4291687,8.3049011-7.659256,8.3049011 c-4.2301025,0-7.6592712-3.1075134-7.6592712-8.3049011c0-4.3017273,3.4291687-4.3016815,7.6592712-4.3016815 C189.2273865,208.8044586,192.6565552,208.8044128,192.6565552,213.1061401z" }),
						_react2.default.createElement("path", { d: "M246.3686981,213.1061401c0,5.1973877-3.4291687,8.3049011-7.6592712,8.3049011 c-4.2300873,0-7.659256-3.1075134-7.659256-8.3049011c0-4.3605347,3.4291687-4.3016815,7.659256-4.3016815 C242.9395294,208.8044586,246.3686981,208.7456055,246.3686981,213.1061401z" })
					)
				);
			}
		}]);
	
		return Eyes;
	}(_react2.default.Component);
	
	exports.default = Eyes;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make hatTarget 'ref="hatTarget"'
	// Add '.fill' to all body elements
	// Add '.fill--face' to nose
	
	var HeadHOC = function (_React$Component) {
		_inherits(HeadHOC, _React$Component);
	
		function HeadHOC() {
			_classCallCheck(this, HeadHOC);
	
			return _possibleConstructorReturn(this, (HeadHOC.__proto__ || Object.getPrototypeOf(HeadHOC)).apply(this, arguments));
		}
	
		_createClass(HeadHOC, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getHatTargetCoords(this.refs.hatTarget);
			}
		}]);
	
		return HeadHOC;
	}(_react2.default.Component);
	
	var Heads = function (_HeadHOC) {
		_inherits(Heads, _HeadHOC);
	
		function Heads() {
			_classCallCheck(this, Heads);
	
			return _possibleConstructorReturn(this, (Heads.__proto__ || Object.getPrototypeOf(Heads)).apply(this, arguments));
		}
	
		_createClass(Heads, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "212.3859253", cy: "169.7848816", r: "0" }),
					_react2.default.createElement("path", { className: "fill ear ear--right", d: "M290.5451355,169.7881775c-2.3361206,21.0738831-22.9700623,56.9495697-35.4715271,55.5637512 s-24.7771606-40.9096527-22.4410706-61.9835358s22.9700623-56.9495697,35.4714966-55.5637512 C280.6054993,109.1904678,292.8811951,148.7142944,290.5451355,169.7881775z" }),
					_react2.default.createElement("path", { className: "fill ear ear--left", d: "M192.4631348,162.6876678c2.8315277,21.0130463-8.5103912,60.8148956-20.975769,62.4946136 s-33.9381104-33.7003326-36.7696533-54.7133789c-2.8315277-21.0130463,8.5104065-60.814888,20.975769-62.494606 C168.1588593,106.2945786,189.6315918,141.6746216,192.4631348,162.6876678z" }),
					_react2.default.createElement(
						"g",
						null,
						_react2.default.createElement("path", { className: "fill", d: "M286.1881409,219.7072754l-5.0021973-5.7351074 c-1.6922607-1.9401855-0.404541-4.9775391,2.166748-5.1101074c2.6696777-0.1376953,2.9260254-3.2661133,2.0230713-5.263916 s-6.1402588-12.1057129-6.1402588-12.1057129l-0.1136475,0.1938477 c-0.8995361-26.2602539-8.5140381-40.614502-67.1086426-40.6149902 c-58.5946045,0.0004883-66.2090454,14.3547363-67.1086426,40.6149902l-0.1137085-0.1938477 c0,0-5.2373657,10.1079102-6.1401978,12.1057129c-0.9028931,1.9978027-0.6466064,5.1262207,2.0230713,5.263916 c2.571228,0.1325684,3.8589478,3.1699219,2.166626,5.1101074l-5.0021362,5.7351074 c-1.748291,2.0043945-0.5544434,5.1481934,2.0835571,5.4870605l2.6535645,0.3405762 c2.2913208,0.2944336,3.4587402,2.9094238,2.1480103,4.8117676l-3.3581543,4.8737793 c-1.4106445,2.0471191,0.0548706,4.8366699,2.5410767,4.8366699h0.3496094c2.3875732,0,3.8707275,2.5952148,2.6588135,4.6523438 l-2.4741821,4.199707c-1.2119141,2.0571289,0.2712402,4.6523438,2.6587524,4.6523438h3.3988037 c2.0338135,0,3.5115967,1.9333496,2.9776611,3.895752l-1.2531738,4.6069336 c-0.5751953,2.114502,1.175293,4.1381836,3.350708,3.873291l3.6785889-0.447998 c2.1174316-0.2578125,3.8515625,1.6589355,3.3837891,3.7399902l-0.3695068,1.644043 c-0.4648438,2.0681152,1.2456055,3.9782715,3.3521729,3.7436523l25.7629395-3.2070312 c7.4315186-0.4523926,14.8527832-1.314209,20.6345215-1.314209c5.7801514,0,13.197998,0.8613281,20.6264648,1.3139648 l25.7658691,3.2072754c2.1064453,0.2346191,3.8168945-1.6755371,3.3520508-3.7436523l-0.3693848-1.644043 c-0.4677734-2.0810547,1.2663574-3.9978027,3.3837891-3.7399902l3.6784668,0.447998 c2.175415,0.2648926,3.9260254-1.7587891,3.3508301-3.873291l-1.2531738-4.6069336 c-0.5339355-1.9624023,0.9437256-3.895752,2.9776611-3.895752h3.3986816c2.3875732,0,3.8707275-2.5952148,2.6588135-4.6523438 l-2.4741211-4.199707c-1.2119141-2.0571289,0.2712402-4.6523438,2.6586914-4.6523438h0.3497314 c2.4862061,0,3.9516602-2.7895508,2.5411377-4.8366699l-3.3581543-4.8737793 c-1.310791-1.9023438-0.1434326-4.517334,2.1479492-4.8117676l2.6535645-0.3405762 C286.7425842,224.8554688,287.9364319,221.7116699,286.1881409,219.7072754z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "tongue" },
						_react2.default.createElement("path", { fill: "#B45A60", d: "M212.0106964,218.8930206c11.6897736,0,16.5278778-21.307312,16.5278778-21.307312 s-4.8381042-3.6527863-16.5278473-3.6527863c-11.6897736,0-16.5278625,3.6527863-16.5278625,3.6527863 S200.3209534,218.8930206,212.0106964,218.8930206z" }),
						_react2.default.createElement("path", { fill: "#FC5959", d: "M212.0108032,212.4672546c0,0,5.2467194-0.2916107,6.6537476,0.7509003 c1.4070129,1.042511,2.3910828,3.3954468,3.1845551,5.0930023c0.7640686,1.6977234,1.3268738,3.3952789,1.7188721,5.0930023 c0.3983612,1.6977234,0.6113434,3.3952789,0.5884399,5.0930023c-0.034256,1.6977234-0.2283325,3.3952942-0.9959717,5.0930023 c-1.0226898,2.2077484-3.5506744,4.0912323-6.9941864,4.8355255c-1.0577698,0.2285919-3.1030121,0.3374329-4.1557312,0.3376312 c-1.0527039-0.0001984-3.0979614-0.1090393-4.1557159-0.3376312c-3.4435272-0.7442932-5.9715118-2.6277771-6.9942017-4.8355255 c-0.7676392-1.6977081-0.9617004-3.3952789-0.9959717-5.0930023c-0.0229034-1.6977234,0.1900787-3.3952789,0.5884399-5.0930023 c0.3919983-1.6977234,0.9548035-3.3952789,1.7188873-5.0930023c0.793457-1.6975555,1.7775269-4.0504913,3.1845398-5.0930023 C206.7635345,212.1756439,212.0102539,212.4672546,212.0108032,212.4672546z" })
					),
					_react2.default.createElement("path", { className: "fill", d: "M246.249939,246.0572205c0,0-23.1636047,2.4571533-34.2392273,2.4571533 s-34.2392273-2.4571533-34.2392273-2.4571533v-73.4789276h68.4784546V246.0572205z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M208.1399689,231.7178345h7.7414856c4.3008881,0,6.9536896,4.355423,4.7336426,7.771759l-2.0294189,3.1229858 c-1.3891602,2.1376953-3.8838348,3.4446564-6.5750275,3.4446411l0,0c-2.6911316-0.0000305-5.1857605-1.3069763-6.5748749-3.4446259 l-2.0294342-3.1229858C201.1862793,236.0732727,203.8390808,231.7178345,208.1399689,231.7178345z" })
				);
			}
		}]);
	
		return Heads;
	}(HeadHOC);
	
	exports.default = Heads;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	var _Bodies = __webpack_require__(544);
	
	var _Bodies2 = _interopRequireDefault(_Bodies);
	
	var _Heads = __webpack_require__(546);
	
	var _Heads2 = _interopRequireDefault(_Heads);
	
	var _Eyes = __webpack_require__(545);
	
	var _Eyes2 = _interopRequireDefault(_Eyes);
	
	var _Toy = __webpack_require__(17);
	
	var _Toy2 = _interopRequireDefault(_Toy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LilDoggo = function (_PetHOC) {
		_inherits(LilDoggo, _PetHOC);
	
		function LilDoggo(props) {
			_classCallCheck(this, LilDoggo);
	
			var _this = _possibleConstructorReturn(this, (LilDoggo.__proto__ || Object.getPrototypeOf(LilDoggo)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(500, 4000);
						}
					}
				}, {
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 2500);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 199;
						}
					}
				}, {
					name: 'alert',
					actions: ['isAlert'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 4000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(1000, 2000);
						}
					}
				}, {
					name: 'wag',
					actions: ['isWaggingUp', 'isWaggingDown'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}],
				pet: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(600, 1200);
						}
					}
				}, {
					name: 'wag',
					actions: ['isWaggingUp', 'isWaggingDown'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return 100;
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(LilDoggo, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Bodies2.default, { body: this.props.body })
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Heads2.default, { getHatTargetCoords: this.getHatTargetCoords, head: this.props.head }),
									_react2.default.createElement(_Eyes2.default, { getGlassesTargetCoords: this.getGlassesTargetCoords }),
									this.shouldRenderHat(),
									this.shouldRenderGlasses()
								)
							)
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-toy', viewBox: '0 0 480 480' },
							_react2.default.createElement(_Toy2.default, { toy: this.props.toy })
						)
					)
				);
			}
		}]);
	
		return LilDoggo;
	}(_PetHOC3.default);
	
	exports.default = LilDoggo;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Bodies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function Bodies() {
		return _react2.default.createElement(
			"g",
			{ className: "pig-body" },
			_react2.default.createElement(
				"g",
				{ className: "tail" },
				_react2.default.createElement("path", { className: "fill", d: "M328.34531,230.82381c3.18512-0.00906,6.37933-0.46693,9.27466-1.50436 c2.89636-1.00417,5.49231-2.65872,7.08035-4.75273c0.79626-1.04272,1.32193-2.17517,1.55502-3.37589 c0.12851-0.59923,0.14691-1.2229,0.1217-1.85992c-0.00934-0.31902-0.05569-0.64256-0.10406-0.96915 c-0.0625-0.30313-0.10736-0.59947-0.19403-0.86557c-0.32053-1.08884-0.87064-1.84404-1.7095-2.36264 c-0.8439-0.50876-2.04034-0.73933-3.27759-0.5894c-1.2355,0.15498-2.46368,0.68491-3.38245,1.45599 c-0.92175,0.78217-1.47968,1.77878-1.67093,2.92885c-0.07861,0.5836-0.04861,1.20778,0.0542,1.86798 c0.14615,0.71489,0.34497,1.4061,0.62265,2.05496c0.56595,1.28967,1.43607,2.41354,2.59875,3.30885 c2.32608,1.82086,5.67651,2.60555,9.01334,2.63806c3.36151,0.04082,6.80441-0.64862,9.95804-1.91713l0.01764-0.00705 c0.97873-0.39386,2.091,0.08038,2.48486,1.0591c0.39059,0.97116-0.07458,2.07462-1.03793,2.47603 c-3.60242,1.50009-7.42484,2.37448-11.36945,2.535c-1.97253,0.05795-3.98038-0.06854-5.98166-0.51758 c-1.99576-0.43671-4.01065-1.17856-5.83554-2.39993c-0.90665-0.61435-1.76038-1.33882-2.51987-2.16837 c-0.74716-0.84062-1.38998-1.77676-1.91815-2.76883c-0.51532-0.99838-0.89731-2.04614-1.1846-3.10526 c-0.27289-1.12587-0.42737-2.3329-0.34698-3.57368c0.17035-2.49089,1.35419-4.95659,3.11835-6.65977 c1.76089-1.71529,3.9552-2.82932,6.31458-3.31264c2.35254-0.46265,4.97247-0.29735,7.3855,0.88121 c2.42664,1.16316,4.31076,3.45601,5.19928,5.80428c0.23987,0.58511,0.4057,1.18333,0.56067,1.76416 c0.13052,0.56924,0.24744,1.14403,0.31421,1.73645c0.1391,1.17754,0.17389,2.3954,0.01816,3.60242 c-0.28046,2.42085-1.19342,4.74846-2.48285,6.70187c-1.28613,1.96651-2.90793,3.59082-4.65167,4.9314 c-1.74628,1.34384-3.62006,2.42513-5.55585,3.28391c-3.87329,1.73216-7.96909,2.62772-12.07071,2.9601l-0.00955,0.00075 c-2.55869,0.20738-4.80115-1.6989-5.00851-4.25758c-0.20764-2.55893,1.69864-4.80138,4.25757-5.00876 C328.10089,230.82936,328.22888,230.82457,328.34531,230.82381z" })
			),
			_react2.default.createElement("path", { className: "fill", d: "M139.83638,284.31741c-0.00134,14.89529,5.00095,28.64374,18.18314,42.07855 c27.51324,23.86151,75.76874,29.80368,114.08922,29.81805c44.94568,0.01685,72.70572-28.40726,75.7645-67.00101 c2.89749-36.55836-16.22995-80.57831-89.18546-80.547c-36.70749,0.01575-67.23137,5.02946-88.63647,16.02713 C148.43494,235.79936,139.83841,261.91348,139.83638,284.31741z" })
		);
	}

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-string-refs */
	
	
	// Make group for face '.fill--face'
	// Make glasses target 'ref="glassesTarget"'
	// Make groups for each eye group
	// - '.fill-eyes eyes'
	// - '.fill-face eyes--blink'
	// - '.fill-face eyes--is-being-pet--likes'
	// - '.fill-eyes eyes--is-being-pet--hates'
	
	var Eyes = function (_React$Component) {
		_inherits(Eyes, _React$Component);
	
		function Eyes() {
			_classCallCheck(this, Eyes);
	
			return _possibleConstructorReturn(this, (Eyes.__proto__ || Object.getPrototypeOf(Eyes)).apply(this, arguments));
		}
	
		_createClass(Eyes, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getGlassesTargetCoords(this.refs.glassesTarget);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					{ className: "fill--face pig-face" },
					_react2.default.createElement("circle", { ref: "glassesTarget", cx: "187.35", cy: "271.18115", r: "0" }),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes" },
						_react2.default.createElement("ellipse", { cx: "157.60091", cy: "271.87469", rx: "6.93353", ry: "7.70392" }),
						_react2.default.createElement("ellipse", { cx: "217.51982", cy: "271.87469", rx: "6.92918", ry: "7.69909" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--blink" },
						_react2.default.createElement("path", { d: "M210.61174,276.63022c-0.94312-0.23715-1.61465-1.11777-1.55447-2.12411c0.06749-1.13791,1.04489-2.00589,2.18283-1.93839 l12.80632,0.76022c1.13774,0.0683,2.00629,1.04501,1.93791,2.18314c-0.0675,1.13794-1.04491,2.00589-2.18283,1.93839 l-12.80634-0.76022C210.86327,276.68143,210.73529,276.66132,210.61174,276.63022z" }),
						_react2.default.createElement("path", { d: "M164.50998,276.63022c0.9431-0.23715,1.61464-1.11777,1.55447-2.12411c-0.06749-1.13791-1.04489-2.00589-2.18283-1.93839 l-12.80632,0.76022c-1.13774,0.0683-2.00629,1.04501-1.93791,2.18314c0.06749,1.13794,1.04489,2.00589,2.18283,1.93839 l12.80632-0.76022C164.25845,276.68143,164.38641,276.66132,164.50998,276.63022z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--is-being-pet--likes" },
						_react2.default.createElement("path", { d: "M163.90364,276.09586c-0.49915,0-0.99908-0.17981-1.39581-0.54431c-0.75879-0.69669-2.39731-1.48489-4.72124-1.60706 c-2.32233-0.11774-4.03584,0.49066-4.86316,1.10471c-0.91684,0.68018-2.20863,0.48785-2.88759-0.42697 c-0.67976-0.91522-0.48865-2.20822,0.42657-2.88797c1.84494-1.37003,4.58334-2.06873,7.54027-1.91269 c2.94644,0.15482,5.60663,1.13535,7.29837,2.69c0.83942,0.7713,0.89507,2.07721,0.12338,2.91663 C165.01721,275.87128,164.46164,276.09586,163.90364,276.09586z" }),
						_react2.default.createElement("path", { d: "M211.2171,276.09589c-0.55801,0-1.11359-0.22455-1.5208-0.66766c-0.7717-0.83942-0.71605-2.14532,0.12337-2.9166 c1.69174-1.55466,4.35193-2.53519,7.29837-2.69003c2.94887-0.15643,5.69533,0.54269,7.54028,1.91269 c0.91521,0.67978,1.10632,1.97278,0.42656,2.888c-0.68057,0.91562-1.97316,1.1051-2.88757,0.42694 c-0.82652-0.61401-2.52956-1.22284-4.86316-1.10471c-2.32393,0.12216-3.96246,0.9104-4.72125,1.60709 C212.21617,275.91608,211.71623,276.09589,211.2171,276.09589z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes--is-being-pet--hates" },
						_react2.default.createElement("path", { d: "M164.53444,271.87946c0.00156,4.25476-3.10954,6.66882-6.93883,6.6662s-6.92668-2.42096-6.92824-6.67572 c-0.00137-3.79651,3.10954-3.56992,6.93883-3.56729C161.43549,268.3053,164.53304,268.07343,164.53444,271.87946z" }),
						_react2.default.createElement("path", { d: "M210.59064,271.87946c0.0013,4.25211,3.10759,6.664,6.93448,6.66138c3.82687-0.00262,6.92505-2.41879,6.92389-6.6709 c-0.00104-3.79651-3.10759-3.56509-6.93446-3.56244C213.68765,268.31012,210.58949,268.07343,210.59064,271.87946z" })
					)
				);
			}
		}]);
	
		return Eyes;
	}(_react2.default.Component);
	
	exports.default = Eyes;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Feet;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function Feet() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill fill--dark leg leg--rear-back", d: "M298.31717,324.67218l-14.13531,43.47711 c-1.35538,4.53668-4.99026,4.27213-10.46832,4.27213h4.5849c-9.28491,0.32147-14.5705,0.11435-16.24265-4.42099 c0,0-19.54538-44.77362-16.64923-79.81122L298.31717,324.67218z" }),
			_react2.default.createElement("path", { className: "fill leg leg--rear-front", d: "M288.43228,326.96466l12.98904,43.47711 c1.35538,4.53665,4.99026,4.27213,10.46835,4.27213h-4.58493c9.87527,0.00296,14.13843,0.46872,16.24265-4.42099 c0,0,19.66895-39.45258,22.12881-73.15683C345.8403,294.88788,288.43228,326.96466,288.43228,326.96466z" }),
			_react2.default.createElement("path", { className: "fill fill--dark leg leg--front-back", d: "M210.40121,324.41797l-8.40413,43.47711 c-1.35536,4.53668-8.42896,4.27213-13.90704,4.27213h4.58492c-5.54558,0-12.88132,0.27368-13.95016-4.42099 c0,0-19.54539-44.77362-16.64925-79.81122L210.40121,324.41797z" }),
			_react2.default.createElement("path", { className: "fill leg leg--front-front", d: "M206.90051,326.97482l11.84283,43.47711 c1.35536,4.53668,7.28271,4.27213,12.7608,4.27213h-3.43867c5.54558,0,12.88132,0.27365,13.95016-4.42099 c0,0,19.54539-44.77365,16.64925-79.81125L206.90051,326.97482z" })
		);
	}

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-string-refs */
	
	
	// Make hatTarget 'ref="hatTarget"'
	// Add '.fill' to all body elements
	// Add '.fill--face' to nose
	
	var HeadHOC = function (_React$Component) {
		_inherits(HeadHOC, _React$Component);
	
		function HeadHOC() {
			_classCallCheck(this, HeadHOC);
	
			return _possibleConstructorReturn(this, (HeadHOC.__proto__ || Object.getPrototypeOf(HeadHOC)).apply(this, arguments));
		}
	
		_createClass(HeadHOC, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getHatTargetCoords(this.refs.hatTarget);
			}
		}]);
	
		return HeadHOC;
	}(_react2.default.Component);
	
	var Heads = function (_HeadHOC) {
		_inherits(Heads, _HeadHOC);
	
		function Heads() {
			_classCallCheck(this, Heads);
	
			return _possibleConstructorReturn(this, (Heads.__proto__ || Object.getPrototypeOf(Heads)).apply(this, arguments));
		}
	
		_createClass(Heads, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "194.39067", cy: "225.5538", r: "0" }),
					_react2.default.createElement("path", { className: "fill fill--dark ear ear--right", d: "M268.11105,241.4136 c-10.19409,12.28036-28.41325,13.97163-40.69362,3.77756c-12.28036-10.19409-13.97163-28.41324-3.77756-40.6936 c20.32719-24.48729,66.76442-27.36226,60.11342-12.85396C279.64874,200.59717,278.30511,229.13324,268.11105,241.4136z" }),
					_react2.default.createElement("path", { className: "fill fill--dark ear ear--left", d: "M132.80215,241.4136 c10.19409,12.28036,28.41324,13.97163,40.6936,3.77756c12.28038-10.19409,13.97165-28.41324,3.77756-40.6936 c-20.32719-24.48729-66.7644-27.36226-60.1134-12.85396C121.26447,200.59717,122.60808,229.13324,132.80215,241.4136z" }),
					_react2.default.createElement("path", { className: "fill", d: "M198.46716,208.66602c48.53682,0,64.33514,38.47952,64.33514,74.6619 c0,21.03772-28.80383,54.99689-64.33514,54.99689c-44.23743,2.13107-62.49545-33.4259-62.49545-53.71524 C135.97171,235.59955,149.93033,208.66602,198.46716,208.66602z" })
				);
			}
		}]);
	
		return Heads;
	}(HeadHOC);
	
	exports.default = Heads;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Nose;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Nose() {
		return _react2.default.createElement(
			"g",
			{ className: "nose" },
			_react2.default.createElement(
				"g",
				{ className: "pig-face" },
				_react2.default.createElement("path", { className: "fill fill--dark snout", d: "M206.12941,290.30185c0,11.73746-8.31462,15.17841-18.57121,15.17841 c-10.25661,0-18.57123-3.44095-18.57123-15.17841c0-11.73743,11.73582-15.29324,18.57123-15.29324 S206.12941,278.56442,206.12941,290.30185z" }),
				_react2.default.createElement("path", { className: "fill fill--darker", d: "M195.78223,294.78986c-1.76523,0-3.38077-1.29709-4.1158-3.30472 c-0.98212-2.68362-0.03177-5.73251,2.11769-6.79666c0.4967-0.24606,1.02267-0.37106,1.56412-0.37106 c1.7648,0,3.38034,1.29758,4.11536,3.30521c0.9817,2.68314,0.03178,5.73203-2.11768,6.79663 C196.84962,294.66534,196.32324,294.78986,195.78223,294.78986L195.78223,294.78986z" }),
				_react2.default.createElement("path", { className: "fill fill--darker", d: "M179.33441,294.78986c-0.54102,0-1.06741-0.12451-1.56371-0.37061 c-2.14987-1.06509-3.09979-4.11398-2.11768-6.79617c0.7346-2.00809,2.35014-3.30566,4.11537-3.30566 c0.54102,0,1.06741,0.125,1.56369,0.37106c2.14946,1.06415,3.09981,4.11304,2.11769,6.79617 C182.71518,293.49277,181.09964,294.78986,179.33441,294.78986z" })
			)
		);
	}

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	var _Bodies = __webpack_require__(548);
	
	var _Bodies2 = _interopRequireDefault(_Bodies);
	
	var _Heads = __webpack_require__(551);
	
	var _Heads2 = _interopRequireDefault(_Heads);
	
	var _Eyes = __webpack_require__(549);
	
	var _Eyes2 = _interopRequireDefault(_Eyes);
	
	var _Nose = __webpack_require__(552);
	
	var _Nose2 = _interopRequireDefault(_Nose);
	
	var _Feet = __webpack_require__(550);
	
	var _Feet2 = _interopRequireDefault(_Feet);
	
	var _Toy = __webpack_require__(17);
	
	var _Toy2 = _interopRequireDefault(_Toy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pig = function (_PetHOC) {
		_inherits(Pig, _PetHOC);
	
		function Pig(props) {
			_classCallCheck(this, Pig);
	
			var _this = _possibleConstructorReturn(this, (Pig.__proto__ || Object.getPrototypeOf(Pig)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 4000);
						}
					}
				}, {
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 2500);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}, {
					name: 'ruffleTail',
					actions: ['isRufflingTail'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(2000, 10000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 600;
						}
					}
				}, {
					name: 'sniff',
					actions: ['isSniffing'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(150, 5000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 150;
						}
					}
				}, {
					name: 'alert',
					actions: ['isAlert'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 4000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(1000, 2000);
						}
					}
				}],
				pet: [{
					name: 'ruffleTail',
					actions: ['isRufflingTail'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(600, 1600);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 600;
						}
					}
				}, {
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(600, 1200);
						}
					}
				}, {
					name: 'stomp',
					actions: ['isStompingRight', 'isStompingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return 50;
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 100;
						}
					}
				}, {
					name: 'alert',
					actions: ['isAlert'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 1000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 1000);
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(Pig, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'svg',
								{ className: 'pet__body', viewBox: '0 0 480 480' },
								_react2.default.createElement(_Feet2.default, null)
							),
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Bodies2.default, { body: this.props.body })
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Heads2.default, { getHatTargetCoords: this.getHatTargetCoords, head: this.props.head }),
									_react2.default.createElement(_Eyes2.default, { getGlassesTargetCoords: this.getGlassesTargetCoords }),
									this.shouldRenderHat()
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									_react2.default.createElement(
										'g',
										{ className: 'pig-face' },
										this.shouldRenderGlasses()
									),
									_react2.default.createElement(_Nose2.default, null)
								)
							)
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-toy', viewBox: '0 0 480 480' },
							_react2.default.createElement(_Toy2.default, { toy: this.props.toy })
						)
					)
				);
			}
		}]);
	
		return Pig;
	}(_PetHOC3.default);
	
	exports.default = Pig;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = ArmsTail;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function ArmsTail() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "tail fill fill--half-dark", fill: "#EFEFEF", d: "M270.56531,352.11194c32.25662,8.18143,72.48856,5.18787,83.866,2.93784 c18.30356,10.43237,35.45758,12.53442,45.72504,5.33936c2.3783-1.66663,3.4346-4.72308,2.54022-7.48608 c-3.79947-11.73764-21.56873-13.83365-31.43423-12.61938c1.26636,0.7359,5.94025,4.44858,7.18442,5.03165 c8.57639,4.01923,18.32077,2.84076,24.7854,0.28055c3.87976-1.5365,5.48706-6.10516,3.44757-9.74576 c-5.28357-9.43155-23.45065-15.17996-38.34283-14.05978c-11.12177-23.13376-40.06839-46.85913-67.05008-59.97266 c-24.87335-12.08891-46.60361,5.99557-46.60361,5.99557L270.56531,352.11194z" }),
			_react2.default.createElement("path", { className: "arm arm--left fill", fill: "#FFFFFF", d: "M149.11337,324.72464c-43.52402,16.4971-53.71984,31.27542-47.36438,40.75754 c8.8624,13.22244,48.16917,13.58276,58.24539,5.94431c4.575-3.46817,25.01741-19.40732,21.66359-29.23431 C177.62517,330.3757,149.11337,324.72464,149.11337,324.72464z" }),
			_react2.default.createElement("path", { className: "arm arm--right fill", fill: "#FFFFFF", d: "M325.37051,324.72464c43.52405,16.4971,53.71985,31.27542,47.36438,40.75754 c-8.8624,13.22244-48.16916,13.58276-58.24539,5.94431c-4.57498-3.46817-25.0174-19.40732-21.66357-29.23431 C296.85873,330.3757,325.37051,324.72464,325.37051,324.72464z" })
		);
	}

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Bodies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function Bodies() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "body fill", fill: "#FFFFFF", d: "M237.90427,230.70677c59.72092,0,93.22128,47.7094,93.22128,89.57094 c0,25.87775-19.16122,65.4527-93.22128,65.4527s-93.22127-39.57495-93.22127-65.4527 C144.683,278.41617,178.18336,230.70677,237.90427,230.70677z" })
		);
	}

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make group for face '.fill--face'
	// Make glasses target 'ref="glassesTarget"'
	// Make groups for each eye group
	// - '.fill-eyes eyes'
	// - '.fill-face eyes--blink'
	// - '.fill-face eyes--is-being-pet--likes'
	// - '.fill-eyes eyes--is-being-pet--hates'
	
	var Eyes = function (_React$Component) {
		_inherits(Eyes, _React$Component);
	
		function Eyes() {
			_classCallCheck(this, Eyes);
	
			return _possibleConstructorReturn(this, (Eyes.__proto__ || Object.getPrototypeOf(Eyes)).apply(this, arguments));
		}
	
		_createClass(Eyes, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getGlassesTargetCoords(this.refs.glassesTarget);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					{ className: "fill--face" },
					_react2.default.createElement("circle", { ref: "glassesTarget", cx: "237.98854", cy: "316.28793" }),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes" },
						_react2.default.createElement("ellipse", { transform: "matrix(0.92835 -0.3717 0.3717 0.92835 -98.37289 122.22813)", cx: "267.86676", cy: "316.28809", rx: "7.27204", ry: "8.08004" }),
						_react2.default.createElement("ellipse", { transform: "matrix(0.3717 -0.92835 0.92835 0.3717 -162.97733 391.7662)", cx: "207.94176", cy: "316.28809", rx: "8.08004", ry: "7.27204" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--blink" },
						_react2.default.createElement("path", { d: "M215.76994,320.33267c-0.15819,0-0.31837-0.0145-0.47957-0.04504l-15.65034-2.96246 c-1.39062-0.26331-2.3047-1.6044-2.0414-2.99503c0.26331-1.39111,1.60287-2.30371,2.99451-2.0419l15.65036,2.96249 c1.39062,0.26331,2.3047,1.60437,2.0414,2.995C218.05263,319.47568,216.97736,320.33267,215.76994,320.33267z" }),
						_react2.default.createElement("path", { d: "M260.03857,320.33267c0.1582,0,0.31839-0.0145,0.47958-0.04504l15.65036-2.96246 c1.39062-0.26331,2.30469-1.6044,2.04138-2.99503c-0.26331-1.39111-1.60287-2.30371-2.99451-2.0419l-15.65036,2.96249 c-1.39062,0.26331-2.30469,1.60437-2.04138,2.995C257.75592,319.47568,258.83118,320.33267,260.03857,320.33267z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--is-being-pet--likes" },
						_react2.default.createElement("path", { d: "M215.52158,320.19641c-0.61974,0-1.24046-0.22327-1.73303-0.67578c-0.94211-0.86502-2.9765-1.84366-5.86188-1.99533 c-2.88338-0.14618-5.01088,0.60919-6.03809,1.37161c-1.13834,0.84448-2.74222,0.60568-3.58521-0.53012 c-0.84398-1.13635-0.6067-2.74173,0.52963-3.58572c2.29068-1.70099,5.69066-2.56851,9.36197-2.37479 c3.65829,0.19223,6.96117,1.40967,9.06163,3.33994c1.04222,0.95761,1.1113,2.57901,0.15318,3.62125 C216.90419,319.9176,216.21439,320.19641,215.52158,320.19641z" }),
						_react2.default.createElement("path", { d: "M260.28696,320.19641c0.61972,0,1.24045-0.22327,1.73303-0.67578c0.94211-0.86502,2.9765-1.84366,5.86188-1.99533 c2.88339-0.14618,5.01086,0.60919,6.03809,1.37161c1.13834,0.84448,2.74222,0.60568,3.58521-0.53012 c0.84399-1.13635,0.60672-2.74173-0.52963-3.58572c-2.29068-1.70099-5.69067-2.56851-9.36197-2.37479 c-3.65829,0.19223-6.96115,1.40967-9.06161,3.33994c-1.04224,0.95761-1.11133,2.57901-0.1532,3.62125 C258.90433,319.9176,259.59415,320.19641,260.28696,320.19641z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes--is-being-pet--hates" },
						_react2.default.createElement("path", { d: "M261.11575,318.99112c1.65872,4.14273,6.02591,6.29092,9.75439,4.79807c3.72849-1.49283,5.40884-6.06238,3.74762-10.20413 c-0.93921-2.34167-5.1908-1.94971-9.72952-0.901C261.39789,313.49054,259.45703,314.84836,261.11575,318.99112z" }),
						_react2.default.createElement("path", { d: "M214.69385,318.99112c-1.65872,4.14273-6.02591,6.29092-9.75439,4.79807 c-3.72847-1.49283-5.40884-6.06238-3.74763-10.20413c0.93921-2.34167,5.1908-1.94971,9.72954-0.901 C214.41173,313.49054,216.35255,314.84836,214.69385,318.99112z" })
					)
				);
			}
		}]);
	
		return Eyes;
	}(_react2.default.Component);
	
	exports.default = Eyes;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make hatTarget 'ref="hatTarget"'
	// Add '.fill' to all body elements
	// Add '.fill--face' to nose
	
	var HeadHOC = function (_React$Component) {
		_inherits(HeadHOC, _React$Component);
	
		function HeadHOC() {
			_classCallCheck(this, HeadHOC);
	
			return _possibleConstructorReturn(this, (HeadHOC.__proto__ || Object.getPrototypeOf(HeadHOC)).apply(this, arguments));
		}
	
		_createClass(HeadHOC, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getHatTargetCoords(this.refs.hatTarget);
			}
		}]);
	
		return HeadHOC;
	}(_react2.default.Component);
	
	var Heads = function (_HeadHOC) {
		_inherits(Heads, _HeadHOC);
	
		function Heads() {
			_classCallCheck(this, Heads);
	
			return _possibleConstructorReturn(this, (Heads.__proto__ || Object.getPrototypeOf(Heads)).apply(this, arguments));
		}
	
		_createClass(Heads, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "236.90427", cy: "250.6335" }),
					_react2.default.createElement(
						"g",
						{ className: "face" },
						_react2.default.createElement("path", { className: "tongue", fill: "#FC5959", d: "M230.61247,342.19141c0,3.33945,3.36089,6.04663,7.50673,6.04663 c4.14586,0,7.50674-2.70718,7.50674-6.04663v-9.25476h-15.01347V342.19141z" }),
						_react2.default.createElement("path", { className: "fill fill--dark", fill: "#EFEFEF", d: "M238.1192,318.85925c12.40154,0,22.14075,7.6553,22.45496,17.08688 c0.33173,9.95657-8.14845,18.2236-22.45496,12.98276c-14.30649,5.24084-22.78665-3.02618-22.45496-12.98276 C215.97847,326.51456,225.71768,318.85925,238.1192,318.85925z" }),
						_react2.default.createElement("path", { className: "fill--face", d: "M245.41101,329.70923c0-0.03384-0.00722-0.06638-0.00853-0.09988 c-0.00133-0.01633-0.00241-0.03241-0.00415-0.04874c-0.13356-2.31052-3.33676-4.16071-7.27913-4.16071 c-3.94753,0-7.15431,1.85498-7.27991,4.17007c-0.00168,0.01608-0.00288,0.03229-0.00414,0.04849 c-0.00108,0.03049-0.00775,0.06003-0.00775,0.09076h0.00691c-0.01532,0.48917,0.14485,0.99353,0.53345,1.4451l4.50221,4.2478 c1.10489,1.28397,3.35802,1.29068,4.47348,0.01321l4.53848-4.27423c0.38048-0.44855,0.53711-0.94766,0.52203-1.43188H245.41101z" }),
						_react2.default.createElement(
							"g",
							{ className: "eyebrow eyebrow--left" },
							_react2.default.createElement("ellipse", { className: "fill fill--dark", transform: "matrix(0.74435 -0.66779 0.66779 0.74435 -144.46913 216.79323)", fill: "#EFEFEF", cx: "210.91142", cy: "297.08267", rx: "7.12136", ry: "5.91489" })
						),
						_react2.default.createElement(
							"g",
							{ className: "eyebrow eyebrow--right" },
							_react2.default.createElement("ellipse", { className: "fill fill--dark", transform: "matrix(0.66779 -0.74435 0.74435 0.66779 -133.13193 295.87057)", fill: "#EFEFEF", cx: "264.89709", cy: "297.08267", rx: "5.91489", ry: "7.12136" })
						)
					)
				);
			}
		}]);
	
		return Heads;
	}(HeadHOC);
	
	exports.default = Heads;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	var _Bodies = __webpack_require__(555);
	
	var _Bodies2 = _interopRequireDefault(_Bodies);
	
	var _ArmsTail = __webpack_require__(554);
	
	var _ArmsTail2 = _interopRequireDefault(_ArmsTail);
	
	var _Heads = __webpack_require__(557);
	
	var _Heads2 = _interopRequireDefault(_Heads);
	
	var _Eyes = __webpack_require__(556);
	
	var _Eyes2 = _interopRequireDefault(_Eyes);
	
	var _Toy = __webpack_require__(17);
	
	var _Toy2 = _interopRequireDefault(_Toy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Seal = function (_PetHOC) {
		_inherits(Seal, _PetHOC);
	
		function Seal(props) {
			_classCallCheck(this, Seal);
	
			var _this = _possibleConstructorReturn(this, (Seal.__proto__ || Object.getPrototypeOf(Seal)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(500, 4000);
						}
					}
				}, {
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 3000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 199;
						}
					}
				}, {
					name: 'lick',
					actions: ['isLicking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(1000, 10000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 150;
						}
					}
				}, {
					name: 'sitting',
					actions: ['isSittingUp'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(2000, 5000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(2000, 5000);
						}
					}
				}, {
					name: 'slapTail',
					actions: ['isSlappingTail'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(2000, 5000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}],
				pet: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(2, 4) * 300;
						}
					}
				}, {
					name: 'sitting',
					actions: ['isSittingUp'],
					start: {
						timeout: null,
						interval: function interval() {
							return 300;
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 300;
						}
					}
				}, {
					name: 'slapTail',
					actions: ['isSlappingTail'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(2, 4) * 300;
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(Seal, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'svg',
								{ className: 'pet__body', viewBox: '0 0 480 480' },
								_react2.default.createElement(_ArmsTail2.default, null)
							),
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Bodies2.default, { body: this.props.body })
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Heads2.default, { getHatTargetCoords: this.getHatTargetCoords, head: this.props.head }),
									_react2.default.createElement(_Eyes2.default, { getGlassesTargetCoords: this.getGlassesTargetCoords }),
									this.shouldRenderHat(),
									this.shouldRenderGlasses()
								)
							)
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-toy', viewBox: '0 0 480 480' },
							_react2.default.createElement(_Toy2.default, { toy: this.props.toy })
						)
					)
				);
			}
		}]);
	
		return Seal;
	}(_PetHOC3.default);
	
	exports.default = Seal;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Bodies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function Bodies() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill", d: "M370.3789368,330.1865234c0.09198-0.8359375,0.2075195-1.6555176,0.2646484-2.5146484 c0.6781006-10.1938477,2.4981079-50.2312012-33.5246582-82.1538086 c-20.8181152-18.4482422-40.6291504-25.0561523-68.2229614-25.9599609 c-2.0594482-3.0327148-4.1710815-6.8408203-5.0863037-10.3713379 c-1.7336426-6.6853027-7.4257202-11.5270996-13.9144135-12.9746094c-3.559021-1.9194336-7.6882935-2.5905762-12.2849731-1.3273926 c-2.3348389,0.6416016-4.5438843,1.8522949-6.4852905,3.4433594c-6.6650391-5.0170898-14.1793213-6.8012695-21.4851074-6.0463867 h-0.0839233c-7.3057861-0.7548828-14.8200684,1.0292969-21.4850464,6.0463867 c-1.9414673-1.5910645-4.1505127-2.8017578-6.4853516-3.4433594c-10.2253418-2.8098145-18.1638184,3.8964844-22.567688,12.8134766 c-3.3810425,6.8459473-5.6296997,14.9482422-7.1389771,22.8117676 c-17.0921631,9.6184082-23.3041382,30.1486816-23.4277344,49.392334 c-0.1993408,31.0375977,13.0013428,54.9423828,36.0490112,77.6271973 c15.2424927,15.0026855,31.0118408,18.8955078,45.0977783,19.7714844 c12.8803101,0.8010254,24.3529663-0.9204102,32.7280884,1.0231934 c46.371933,10.7624512,87.3935394,3.5883789,109.2557831-14.0336914 c4.7143555,9.7734375,1.118103,21.861084-13.2575073,25.2392578c-22.9586792,5.3952637-49.8300171,3.8933105-73.2421265,3.404541 c-23.6204681-0.4929199-23.616806,36.1992188,0.000061,36.6921387c24.2808838,0.5068359,48.59375-0.3383789,72.7133789-3.314209 c18.5028076-2.282959,34.8039551-8.8903809,44.9277954-25.5197754 C398.0835266,375.5625,390.0585022,347.4882812,370.3789368,330.1865234z" }),
			_react2.default.createElement("path", { className: "fill", d: "M209.6398773,192.2816467c7.3058014-0.754715,14.8200989,1.0294952,21.4851074,6.0464935 c1.9414215-1.591095,4.1504517-2.8017273,6.485321-3.4434662c10.2253418-2.8096466,18.1638184,3.8966675,22.5676727,12.8136139 c3.3810425,6.8459015,5.6297302,14.9483185,7.1389465,22.8117828 c17.0922241,9.6183929,23.3041382,30.1487427,23.4277649,49.3922119 c0.1993408,31.0375977-13.0013123,54.9423218-36.0490265,77.6272888 c-15.2424622,15.0025635-31.0118256,18.8953857-45.0977325,19.7714233 c-14.0859222-0.8760376-29.8552704-4.7688599-45.0977325-19.7714233 c-23.0477295-22.684967-36.2483826-46.5896912-36.0490417-77.6272888 c0.1236267-19.2434692,6.3355408-39.773819,23.4277649-49.3922119c1.5092316-7.8634644,3.7579193-15.9658813,7.1389465-22.8117828 c4.4038696-8.9169464,12.3423309-15.6232605,22.567688-12.8136139c2.3348541,0.6417389,4.5438995,1.8523712,6.485321,3.4434662 c6.6650085-5.0169983,14.1792908-6.8012085,21.4851074-6.0464935H209.6398773z" }),
			_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M362.6140442,286.3100586c0.5838013-0.614502,1.1569824-1.2453613,1.7218018-1.8867188 c-2.1010742-5.5075684-4.8427734-11.2043457-8.4349365-16.9143066c-0.4255371,1.1452637-0.8977661,2.2836914-1.4273682,3.4125977 c-1.9071045,4.1455078-4.5782471,8.0788574-7.611084,11.9038086c-1.5101318,1.9238281-3.1030273,3.842041-4.7606201,5.7751465 c-0.8103027,0.9916992-1.6791992,1.9299316-2.5250244,2.9226074l-1.2923584,1.470459 c-0.4190674,0.4807129-0.8996582,1.005127-1.2392578,1.4555664l-0.3693848,0.4897461 c-0.5053711,0.6762695-0.7324219,1.5563965-0.5539551,2.4494629c0.333374,1.6687012,1.956665,2.7514648,3.6254883,2.4179688 c0.8549805-0.1708984,1.5430908-0.3164062,2.279541-0.5263672c0.730835-0.189209,1.4371338-0.4169922,2.1364746-0.6635742 c1.4196777-0.4628906,2.7556152-1.072998,4.1105957-1.6813965c2.6650391-1.2785645,5.2102051-2.8215332,7.6055908-4.6057129 C358.282135,290.5512695,360.5012512,288.5058594,362.6140442,286.3100586z" }),
			_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M337.657074,246.0148926c-0.1712036,0.9907227-0.3724365,1.9836426-0.6116333,2.9785156 c-0.4875488,2.2033691-1.1405029,4.4099121-1.9429932,6.604248c-1.5184326,4.4318848-3.7045898,8.7390137-6.0541992,13.0859375 c-1.1813965,2.1728516-2.4287109,4.3476562-3.7327881,6.5246582l-3.9942627,6.5l-0.1503906,0.2441406 c-0.5345459,0.8754883-0.6195068,1.998291-0.1264648,2.9831543c0.7606201,1.5192871,2.6088867,2.1342773,4.1281738,1.3735352 c1.3925781-0.6970215,2.5686035-1.3771973,3.7802734-2.1550293c1.2019043-0.7597656,2.3510742-1.579834,3.4770508-2.4367676 c2.2468262-1.7160645,4.3800049-3.590332,6.3852539-5.6140137c4.026123-4.0402832,7.4588623-8.7177734,10.4342041-13.8220215 c0.4501343-0.7895508,0.8812866-1.5964355,1.3026733-2.4111328 C346.9228821,255.1650391,342.6647034,250.5124512,337.657074,246.0148926z" }),
			_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M314.3443909,231.9353027c0.0343018,2.2504883-0.0732422,4.5461426-0.3597412,6.8588867 c-0.2490234,2.317627-0.598999,4.6662598-1.1077881,7.0119629c-0.5280762,2.3391113-1.1049805,4.7038574-1.7525635,7.0842285 c-0.6522217,2.3769531-1.3243408,4.7929688-2.069458,7.2175293c-0.72229,2.4069824-1.5427246,4.9328613-2.2406006,7.3215332 l-0.0927734,0.3166504c-0.2657471,0.9333496-0.0889893,1.9770508,0.5666504,2.7897949 c1.0720215,1.3288574,3.0183105,1.5371094,4.347168,0.4650879c1.2189941-0.9833984,2.2325439-1.902832,3.2425537-2.9355469 c1.0157471-1.0063477,1.9414062-2.074707,2.8601074-3.1599121c1.7961426-2.1916504,3.4631348-4.503418,4.9267578-6.9519043 c2.9534912-4.8881836,5.1743164-10.2563477,6.873291-15.9230957c0.2148438-0.7497559,0.4160767-1.5073242,0.6064453-2.2702637 c-5.2336426-4.012207-10.4672852-7.3134766-15.8400879-9.9992676 C314.3354797,230.4814453,314.3545227,231.2053223,314.3443909,231.9353027z" }),
			_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M128.4591522,281.0361328c0.0267944,6.4208984,0.6240845,12.5400391,1.7750244,18.4030762 c3.6367798,0.9655762,7.2761841,1.6340332,10.8950195,2.1357422c4.8012695,0.6398926,9.5201416,0.8447266,14.5183105-0.1245117 c1.0195312-0.2038574,1.9573975-0.8571777,2.4689941-1.8540039c0.8903809-1.7348633,0.2059326-3.8630371-1.5289307-4.753418 l-0.3105469-0.1594238c-1.9317627-0.9914551-4.0444336-1.8457031-6.0429688-2.6918945l-6.010498-2.4069824 c-3.9473877-1.6176758-7.746582-3.4562988-11.2163086-5.5334473 C131.4110565,283.0986328,129.8890228,282.0893555,128.4591522,281.0361328z" }),
			_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M163.3481903,342.0270996c0.9498291-0.4226074,1.7213135-1.2658691,2.0016479-2.3505859 c0.487793-1.8879395-0.6473389-3.8139648-2.5353394-4.302002l-0.3380127-0.0871582 c-2.1022949-0.543457-4.3510742-0.9128418-6.4865723-1.2995605l-6.392334-1.0283203 c-2.161499-0.3657227-4.2956543-0.7995605-6.3828735-1.3039551c2.8397217,4.5241699,6.0617676,8.9318848,9.6467285,13.2600098 C156.401535,344.4020996,159.8708954,343.5507812,163.3481903,342.0270996z" }),
			_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M158.5770721,315.6386719c-2.0535889-0.7055664-4.2667236-1.2490234-6.3656006-1.8010254l-6.2927246-1.5234375 c-4.1380615-1.0371094-8.1608887-2.3139648-11.8918457-3.8740234c-0.6045532-0.251709-1.1875-0.5241699-1.7756348-0.791748 c1.7249146,5.8413086,4.0177612,11.4401855,6.8480225,16.8530273c1.8327026,0.0849609,3.6584473,0.1323242,5.4700928,0.1220703 c4.8433838-0.0527344,9.5432129-0.5241699,14.3515625-2.1977539c0.9798584-0.347168,1.8146973-1.1279297,2.1787109-2.1875 c0.6334229-1.8442383-0.3481445-3.8527832-2.1923828-4.4863281L158.5770721,315.6386719z" }),
			_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M290.7469177,281.0361328c-0.0267944,6.4208984-0.6240845,12.5400391-1.7750244,18.4030762 c-3.6367798,0.9655762-7.2761841,1.6340332-10.8950195,2.1357422c-4.8012695,0.6398926-9.5201416,0.8447266-14.5183105-0.1245117 c-1.0195312-0.2038574-1.9573975-0.8571777-2.4689941-1.8540039c-0.8903809-1.7348633-0.2059326-3.8630371,1.5289307-4.753418 l0.3105469-0.1594238c1.9317627-0.9914551,4.0444336-1.8457031,6.0429688-2.6918945l6.010498-2.4069824 c3.9473877-1.6176758,7.746582-3.4562988,11.2163086-5.5334473 C287.7950134,283.0986328,289.3170471,282.0893555,290.7469177,281.0361328z" }),
			_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M255.8578796,342.0270996c-0.9498291-0.4226074-1.7213135-1.2658691-2.0016479-2.3505859 c-0.487793-1.8879395,0.6473389-3.8139648,2.5353394-4.302002l0.3380127-0.0871582 c2.1022949-0.543457,4.3510742-0.9128418,6.4865723-1.2995605l6.392334-1.0283203 c2.161499-0.3657227,4.2956543-0.7995605,6.3828735-1.3039551c-2.8397217,4.5241699-6.0617676,8.9318848-9.6467285,13.2600098 C262.8045349,344.4020996,259.3351746,343.5507812,255.8578796,342.0270996z" }),
			_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M260.6289978,315.6386719c2.0535889-0.7055664,4.2667236-1.2490234,6.3656006-1.8010254l6.2927246-1.5234375 c4.1380615-1.0371094,8.1608887-2.3139648,11.8918457-3.8740234c0.6045532-0.251709,1.1875-0.5241699,1.7756348-0.791748 c-1.7249146,5.8413086-4.0177612,11.4401855-6.8480225,16.8530273c-1.8327026,0.0849609-3.6584473,0.1323242-5.4700928,0.1220703 c-4.8433838-0.0527344-9.5432129-0.5241699-14.3515625-2.1977539c-0.9798584-0.347168-1.8146973-1.1279297-2.1787109-2.1875 c-0.6334229-1.8442383,0.3481445-3.8527832,2.1923828-4.4863281L260.6289978,315.6386719z" }),
			_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M314.8940735,394.5690918c1.4399414,1.8674316,2.6744385,4.1882324,3.5881348,6.7653809 c0.4726562,1.2841797,0.9106445,2.6181641,1.3508301,3.9890137l0.6461182,2.0810547 c0.2161865,0.6779785,0.4257812,1.4562988,0.6594238,2.0400391l0.237793,0.5939941 c0.3308105,0.814209,1.0080566,1.4802246,1.9111328,1.7663574c1.6107178,0.5100098,3.3297119-0.3823242,3.8397217-1.9929199 c0.5898438-1.862793,0.8530273-3.4975586,0.9998779-5.2792969c0.1477051-1.7529297,0.1030273-3.5251465-0.098999-5.3054199 c-0.3017578-2.4797363-0.8653564-5.0102539-1.788269-7.5087891c-4.2041626,0.5705566-8.4870605,0.9729004-12.8136597,1.2475586 C313.9323425,393.4560547,314.4264221,393.9775391,314.8940735,394.5690918z" }),
			_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M276.9212952,396.1882324c1.6069336,2.1081543,2.8874512,4.748291,3.9310303,7.5944824 c0.5252686,1.4245605,1.0140381,2.902832,1.4604492,4.4169922c0.4616699,1.4846191,0.8787842,3.1271973,1.2949219,4.543457 l0.1060791,0.362793c0.2999268,1.0114746,1.1171875,1.8391113,2.2171631,2.1015625 c1.6379395,0.390625,3.2825928-0.6206055,3.6732178-2.2585449c0.4736328-1.9858398,0.6654053-3.7443848,0.7592773-5.6403809 c0.0722656-1.8662109,0.008667-3.75-0.2235107-5.6418457c-0.229248-1.892334-0.6199951-3.791748-1.1743164-5.6923828 c-0.2468872-0.8395996-0.5255127-1.6826172-0.8359985-2.5231934c-4.791626-0.0649414-9.541687-0.1843262-14.1970215-0.3034668 C274.9946594,393.970459,275.9930725,394.9863281,276.9212952,396.1882324z" }),
			_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M293.9342957,393.4946289c0.7012939,0.6196289,1.3738403,1.3134766,1.9846802,2.1022949 c1.6247559,2.0314941,2.9620361,4.5620117,3.9766846,7.3527832c0.5093994,1.3933105,1.0075684,2.8361816,1.446167,4.324707 l1.2817383,4.4658203l0.1137695,0.3979492c0.2862549,0.9875488,1.0646973,1.8066406,2.1291504,2.0969238 c1.6258545,0.4433594,3.3033447-0.5153809,3.7467041-2.1411133c0.2872314-1.0537109,0.4648438-1.9060059,0.6114502-2.8596191 c0.1413574-0.9299316,0.2344971-1.8640137,0.2855225-2.8022461c0.0994873-1.8757324,0.036377-3.7741699-0.2178955-5.6743164 c-0.3309326-2.4846191-0.9332275-5.003418-1.8649902-7.4829102 C302.9393616,393.4465332,298.4293518,393.505127,293.9342957,393.4946289z" }),
			_react2.default.createElement("path", { className: "fill tiger--foot tiger--foot--left", d: "M192.9819794,384.7485352c0.000061,0,0.0001831,0,0.0002441,0s0.0001831,0,0.0002441,0 c0.008606,0,0.0169678,0,0.0255737,0c5.6281738,0,10.350647-0.1174316,13.9245605-1.3339844 c4.7711792-1.3154297,6.4085693-5.0478516,6.9196167-7.7648926c0.0877686-0.3686523,0.1815186-0.7282715,0.2488403-1.1276855 h-0.0838013c0.0406494-0.4194336,0.0579224-0.795166,0.0579224-1.0942383l-0.0002441-0.2429199 c0.0275879-3.9992676-2.0246582-8.4020996-5.8566895-11.4162598c-4.4338989-3.487793-9.8952637-5.2539062-15.2365112-5.3562012 c-5.3407593,0.1022949-10.802124,1.8684082-15.2360229,5.3562012c-3.8320312,3.0141602-5.8842773,7.4169922-5.8566895,11.4162598 l-0.0002441,0.2429199c0,0.2990723,0.0172729,0.6748047,0.0579224,1.0942383h-0.0838013 c0.0673218,0.3994141,0.1610718,0.7590332,0.2488403,1.1276855c0.5110474,2.717041,2.1484375,6.4494629,6.9196167,7.7648926 c3.5739136,1.2165527,8.2963867,1.3339844,13.9245605,1.3339844c0.008606,0,0.0169678,0,0.0255737,0 c0.000061,0,0.0001831,0,0.0002441,0S192.9819183,384.7485352,192.9819794,384.7485352z" }),
			_react2.default.createElement("path", { className: "fill tiger--foot tiger--foot--right", d: "M226.2389221,384.7485352c0.000061,0,0.0001831,0,0.0002441,0s0.0001831,0,0.0002441,0 c0.008606,0,0.0169678,0,0.0255737,0c5.6281738,0,10.350647-0.1174316,13.9245605-1.3339844 c4.7711792-1.3154297,6.4085693-5.0478516,6.9196167-7.7648926c0.0877686-0.3686523,0.1815186-0.7282715,0.2488403-1.1276855 h-0.0838013c0.0406494-0.4194336,0.0579224-0.795166,0.0579224-1.0942383l-0.0002441-0.2429199 c0.0275879-3.9992676-2.0246582-8.4020996-5.8566895-11.4162598c-4.4338989-3.487793-9.8952637-5.2539062-15.2365112-5.3562012 c-5.3407593,0.1022949-10.802124,1.8684082-15.2360229,5.3562012c-3.8320312,3.0141602-5.8842773,7.4169922-5.8566895,11.4162598 l-0.0002441,0.2429199c0,0.2990723,0.0172729,0.6748047,0.0579224,1.0942383h-0.0838013 c0.0673218,0.3994141,0.1610718,0.7590332,0.2488403,1.1276855c0.5110474,2.717041,2.1484375,6.4494629,6.9196167,7.7648926 c3.5739136,1.2165527,8.2963867,1.3339844,13.9245605,1.3339844c0.008606,0,0.0169678,0,0.0255737,0 c0.000061,0,0.0001831,0,0.0002441,0S226.2388611,384.7485352,226.2389221,384.7485352z" })
		);
	}

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Eyes = function (_React$Component) {
		_inherits(Eyes, _React$Component);
	
		function Eyes() {
			_classCallCheck(this, Eyes);
	
			return _possibleConstructorReturn(this, (Eyes.__proto__ || Object.getPrototypeOf(Eyes)).apply(this, arguments));
		}
	
		_createClass(Eyes, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getGlassesTargetCoords(this.refs.glassesTarget);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					{ className: "fill--face" },
					_react2.default.createElement("circle", { ref: "glassesTarget", cx: "205.6819763", cy: "192.5350647", r: "0" }),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes" },
						_react2.default.createElement("ellipse", { cx: "234.6811676", cy: "192.5350647", rx: "7.6592607", ry: "8.5102901" }),
						_react2.default.createElement("ellipse", { cx: "176.6827698", cy: "192.5350647", rx: "7.6592607", ry: "8.5102901" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--blink" },
						_react2.default.createElement("path", { d: "M227.2812347,198.5197601c0.1542969,0,0.3105469-0.0141602,0.4677734-0.0439453l15.265625-2.8896484 c1.3564453-0.2568359,2.2480469-1.5649414,1.9912109-2.9213867c-0.2568359-1.3569336-1.5634766-2.2470703-2.9208984-1.9916992 l-15.265625,2.8896484c-1.3564453,0.2568359-2.2480469,1.5649414-1.9912109,2.9213867 C225.0546722,197.6838226,226.1035004,198.5197601,227.2812347,198.5197601z" }),
						_react2.default.createElement("path", { d: "M184.0827026,198.5197601c-0.1542969,0-0.3105469-0.0141602-0.4677734-0.0439453l-15.265625-2.8896484 c-1.3564453-0.2568359-2.2480469-1.5649414-1.9912109-2.9213867c0.2568359-1.3569336,1.5634766-2.2470703,2.9208984-1.9916992 l15.265625,2.8896484c1.3564453,0.2568359,2.2480469,1.5649414,1.9912109,2.9213867 C186.3092651,197.6838226,185.260437,198.5197601,184.0827026,198.5197601z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--is-being-pet--likes" },
						_react2.default.createElement("path", { d: "M227.2850647,198.3868408c0.6044922,0,1.2099609-0.2177734,1.6904297-0.6591797 c0.9189453-0.84375,2.9033203-1.7983398,5.7177734-1.9462891c2.8125-0.1425781,4.8876953,0.5942383,5.8896484,1.3378906 c1.1103516,0.8237305,2.6748047,0.5908203,3.4970703-0.5170898c0.8232422-1.1083984,0.5917969-2.6743164-0.5166016-3.4975586 c-2.234375-1.6591797-5.5507812-2.5053711-9.1318359-2.3164062c-3.5683594,0.1875-6.7900391,1.375-8.8388672,3.2578125 c-1.0166016,0.934082-1.0839844,2.515625-0.1494141,3.5322266 C225.9364319,198.1148682,226.6092834,198.3868408,227.2850647,198.3868408z" }),
						_react2.default.createElement("path", { d: "M184.0788727,198.3868408c-0.6044922,0-1.2099609-0.2177734-1.6904297-0.6591797 c-0.9189453-0.84375-2.9033203-1.7983398-5.7177734-1.9462891c-2.8125-0.1425781-4.8876953,0.5942383-5.8896484,1.3378906 c-1.1103516,0.8237305-2.6748047,0.5908203-3.4970703-0.5170898c-0.8232422-1.1083984-0.5917969-2.6743164,0.5166016-3.4975586 c2.234375-1.6591797,5.5507812-2.5053711,9.1318359-2.3164062c3.5683594,0.1875,6.7900391,1.375,8.8388672,3.2578125 c1.0166016,0.934082,1.0839844,2.515625,0.1494141,3.5322266 C185.4275055,198.1148682,184.7546539,198.3868408,184.0788727,198.3868408z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes--is-being-pet--hates" },
						_react2.default.createElement("path", { d: "M184.3420258,192.5350647c0,4.7001038-3.4291687,8.5102844-7.659256,8.5102844s-7.659256-3.8101807-7.659256-8.5102844 c0-3.0506439,3.4291687-3.0506439,7.659256-3.0506439S184.3420258,189.4844208,184.3420258,192.5350647z" }),
						_react2.default.createElement("path", { d: "M242.3404236,192.5350647c0,4.7001038-3.4291687,8.5102844-7.659256,8.5102844s-7.659256-3.8101807-7.659256-8.5102844 c0-3.0506439,3.4291687-3.0506439,7.659256-3.0506439S242.3404236,189.4844208,242.3404236,192.5350647z" })
					)
				);
			}
		}]);
	
		return Eyes;
	}(_react2.default.Component);
	
	exports.default = Eyes;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make hatTarget 'ref="hatTarget"'
	// Add '.fill' to all body elements
	// Add '.fill--face' to nose
	
	var HeadHOC = function (_React$Component) {
		_inherits(HeadHOC, _React$Component);
	
		function HeadHOC() {
			_classCallCheck(this, HeadHOC);
	
			return _possibleConstructorReturn(this, (HeadHOC.__proto__ || Object.getPrototypeOf(HeadHOC)).apply(this, arguments));
		}
	
		_createClass(HeadHOC, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getHatTargetCoords(this.refs.hatTarget);
			}
		}]);
	
		return HeadHOC;
	}(_react2.default.Component);
	
	var Heads = function (_HeadHOC) {
		_inherits(Heads, _HeadHOC);
	
		function Heads() {
			_classCallCheck(this, Heads);
	
			return _possibleConstructorReturn(this, (Heads.__proto__ || Object.getPrototypeOf(Heads)).apply(this, arguments));
		}
	
		_createClass(Heads, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "203.6819763", cy: "135.206604", r: "0" }),
					_react2.default.createElement("path", { className: "fill tiger--beard", d: "M140.2312469,202.203125c-0.0170898,0-0.0336914,0-0.050293-0.0004883l-24.8710938-0.2734375 c-2.4853516-0.0273438-4.4775391-2.0639648-4.4501953-4.5488281c0.0268555-2.4682617,2.0366211-4.4506836,4.4985352-4.4506836 c0.0170898,0,0.0336914,0,0.050293,0.0004883l24.8710938,0.2734375c2.4853516,0.0273438,4.4775391,2.0639648,4.4501953,4.5488281 C144.7029266,200.2207031,142.693161,202.203125,140.2312469,202.203125z" }),
					_react2.default.createElement("path", { className: "fill tiger--beard", d: "M120.5876923,220.6645508c-1.8706055,0-3.6176758-1.1757812-4.2573242-3.0449219 c-0.8041992-2.3510742,0.449707-4.909668,2.8007812-5.7143555l21.640625-7.4042969 c2.3515625-0.8046875,4.909668,0.4492188,5.7143555,2.8012695c0.8041992,2.3510742-0.449707,4.909668-2.8007812,5.7143555 l-21.640625,7.4042969C121.5623016,220.5859375,121.0706024,220.6645508,120.5876923,220.6645508z" }),
					_react2.default.createElement("path", { className: "fill tiger--beard", d: "M133.3332977,235.0136719c-1.3525391,0-2.6894531-0.6069336-3.5756836-1.7631836 c-1.5112305-1.9731445-1.137207-4.7973633,0.8354492-6.309082l18.1557617-13.9091797 c1.9731445-1.5117188,4.7973633-1.1367188,6.309082,0.8354492c1.5112305,1.9731445,1.137207,4.7973633-0.8354492,6.309082 l-18.1557617,13.9091797C135.2502899,234.7114258,134.2878876,235.0136719,133.3332977,235.0136719z" }),
					_react2.default.createElement("path", { className: "fill tiger--beard", d: "M271.1999817,202.203125c-2.4619141,0-4.4716797-1.9824219-4.4990234-4.4506836 c-0.0273438-2.4848633,1.9658203-4.5214844,4.4501953-4.5488281l24.8710938-0.2734375 c0.0175781-0.0004883,0.0341797-0.0004883,0.0507812-0.0004883c2.4619141,0,4.4716797,1.9824219,4.4990234,4.4506836 c0.0273438,2.4848633-1.9658203,4.5214844-4.4501953,4.5488281l-24.8710938,0.2734375 C271.2331848,202.203125,271.2165833,202.203125,271.1999817,202.203125z" }),
					_react2.default.createElement("path", { className: "fill tiger--beard", d: "M290.8425598,220.6645508c-0.4824219,0-0.9746094-0.0786133-1.4570312-0.2436523l-21.6396484-7.4042969 c-2.3515625-0.8046875-3.6054688-3.3632812-2.8007812-5.7148438c0.8037109-2.3505859,3.359375-3.6069336,5.7148438-2.8007812 l21.6396484,7.4042969c2.3515625,0.8046875,3.6054688,3.3632812,2.8007812,5.7148438 C294.4607239,219.4887695,292.7136536,220.6645508,290.8425598,220.6645508z" }),
					_react2.default.createElement("path", { className: "fill tiger--beard", d: "M278.0984192,235.0136719c-0.9550781,0-1.9169922-0.3022461-2.7333984-0.9277344l-18.1552734-13.9091797 c-1.9736176-1.5117188-2.347641-4.3359375-0.8359375-6.309082c1.5117188-1.9736328,4.3369141-2.3457031,6.3085938-0.8354492 l18.1552734,13.9091797c1.9736328,1.5117188,2.3476562,4.3359375,0.8359375,6.309082 C280.7878723,234.4067383,279.4499817,235.0136719,278.0984192,235.0136719z" }),
					_react2.default.createElement("path", { className: "fill tiger--beard", d: "M205.6817474,245.945694c-31.3823242,0-54.2333984-7.0707092-67.9179688-21.0153809 c-11.7744141-11.9983978-12.4467773-24.9530487-12.4223633-28.1155548 c0.0073242-29.6554565,7.3608398-53.1912384,21.8569336-69.9509811c0,0,34.4370117,33.3290329,58.4833984,33.3290329 s58.483902-33.3290329,58.483902-33.3290329c14.4960938,16.7597427,21.8496094,40.2955246,21.8569336,69.9514542 c0.0244141,3.1620331-0.6479492,16.116684-12.4223633,28.1150818 C259.9151611,238.8749847,237.0640717,245.945694,205.6817474,245.945694z" }),
					_react2.default.createElement("path", { className: "fill", d: "M272.0224609,196.8571777c0,0,1.6698914,35.4611511-66.3404846,35.4611511 s-66.3405151-35.4611511-66.3405151-35.4611511c0-54.5967407,27.397583-81.4861908,66.3405151-81.4861908 S272.0224609,142.260437,272.0224609,196.8571777z" }),
					_react2.default.createElement("path", { className: "fill tiger--beard", d: "M231.6236267,230.9999542c0,11.2899323-12.7199249,20.4422302-25.9416504,20.4422302 c-13.2217407,0-25.9416656-9.152298-25.9416656-20.4422302c0-8.1218719,2.0016022-18.4352112,15.5841217-18.4352112 l10.3986359,3.6956329l10.4022369-3.6602478C229.6220245,212.6001282,231.6236267,222.9070282,231.6236267,230.9999542z" }),
					_react2.default.createElement("path", { className: "fill--face", d: "M218.0469971,214.813385c0-0.0452728-0.0101013-0.0887756-0.0119476-0.1335602 c-0.0018616-0.0218201-0.0033722-1.0441437-0.0058136-1.0659637c-0.1872406-3.0891876-6.7759857,0.4418793-12.3023376,0.4418793 c-5.5335846,0-12.1273956-3.5246429-12.3034363-0.4293671c-0.0023499,0.0215149-0.0040436,1.0439911-0.0057983,1.0656586 c-0.0015259,0.0407715-0.0108643,0.0802612-0.0108643,0.1213531h0.0096741 c-0.0214539,0.6539917,0.203064,1.3283691,0.7477875,1.9321136l11.5154572,5.2780304l11.6256409-5.2957001 c0.5333557-0.5997314,0.7529144-1.2670288,0.731781-1.914444H218.0469971z" }),
					_react2.default.createElement("path", { className: "fill ear--left", d: "M223.3407898,139.54776c-5.1493378,2.5046387,26.8779449-23.9955444,40.5081482-31.8774567v-0.0000763 c16.0650024-10.5836639,28.5853271-5.9729385,34.7830811,20.5489502 c1.0477295,4.483551,1.6903992,9.4104004,2.0221558,14.5631104c1.7918091,27.8277435-32.381897,42.409256-51.0904999,21.7312012 L223.3407898,139.54776z" }),
					_react2.default.createElement("path", { className: "fill ear--right", d: "M188.0231628,139.54776c5.1493225,2.5046387-26.8779602-23.9955444-40.5081482-31.8774567v-0.0000763 c-16.0650177-10.5836639-28.5853424-5.9729385-34.7830887,20.5489502 c-1.0477371,4.483551-1.6903992,9.4104004-2.0221786,14.5631104 c-1.7917938,27.8277435,32.381897,42.409256,51.0905151,21.7312012L188.0231628,139.54776z" }),
					_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M220.4785614,124.921875c-0.3826904,2.609375-0.6716309,5.1757812-0.887207,7.7275391 c-0.2141113,2.5595703-0.364502,5.0688477-0.4591064,7.6435547l-0.0075684,0.1904297 c-0.0335693,0.9555664,0.4766846,1.8891602,1.3846436,2.3520508c1.2487793,0.6362305,2.7769775,0.1396484,3.413208-1.109375 c1.0681152-2.0966797,2.2202148-4.2275391,3.394165-6.2890625c1.1793213-2.0678711,2.4082031-4.0898438,3.6749268-6.0395508 c1.2672119-1.9501953,2.6153564-3.7998047,3.9802246-5.4462891c0.3468018-0.3925781,0.6850586-0.8105469,1.0288086-1.1743164 l0.4675903-0.4643555c-0.0079956-0.0075684-0.0164795-0.0141602-0.0244751-0.0217285 c-4.4805298-2.291748-9.3001099-4.0124512-14.4146729-5.1618652 C221.3186493,119.8271484,220.8326874,122.3945312,220.4785614,124.921875z" }),
					_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M174.3826141,125.0756836c1.5419922,1.4194336,3.1098633,3.1083984,4.6060791,4.9228516 c1.4885254,1.8168945,2.9493408,3.7290039,4.3651123,5.6987305c1.4105225,1.9638672,2.8033447,4.0078125,4.1157227,6.0288086 l0.1813965,0.2802734c0.5148926,0.7900391,1.4542236,1.2573242,2.4508057,1.1220703 c1.3789062-0.1870117,2.3450928-1.456543,2.1580811-2.8354492c-0.3388672-2.4990234-0.7299805-4.9213867-1.1806641-7.3833008 c-0.4521484-2.4536133-0.9729004-4.909668-1.5775146-7.3867188c-0.595459-2.4804688-1.3172607-4.9760742-2.2467041-7.5512695 c-0.039856-0.1027832-0.0780029-0.2045898-0.1170044-0.3071289c-5.1937256,1.3571777-10.0706787,3.3154297-14.5715332,5.8918457 c-0.0125732,0.0126953-0.0267944,0.0231934-0.0393066,0.0358887l0.7070923,0.4980469 C173.6119843,124.3828125,173.9941864,124.7446289,174.3826141,125.0756836z" }),
					_react2.default.createElement("path", { className: "fill tiger--stripe", d: "M208.6764374,141.0141602c0.3034668-2.1401367,0.6413574-4.2802734,1.0458984-6.4204102 c0.3830566-2.140625,0.7834473-4.2807617,1.2277832-6.4204102c0.8725586-4.1132812,1.6585693-8.2268066,3.1968384-12.3391113 c-2.7566528-0.2966309-5.574646-0.4631348-8.4649658-0.4631348c-2.8650513,0-5.6589966,0.1635742-8.3927612,0.454834 c1.5213013,4.1115723,2.2938843,8.2209473,3.15271,12.3312988c0.4377441,2.1411133,0.831665,4.2827148,1.2081299,6.4238281 c0.3980713,2.1416016,0.7293701,4.2827148,1.0263672,6.4238281c0.1816406,1.3046875,1.2061768,2.3891602,2.5753174,2.5834961 C206.9082489,143.8232422,208.441452,142.6708984,208.6764374,141.0141602z" })
				);
			}
		}]);
	
		return Heads;
	}(HeadHOC);
	
	exports.default = Heads;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	var _Bodies = __webpack_require__(559);
	
	var _Bodies2 = _interopRequireDefault(_Bodies);
	
	var _Heads = __webpack_require__(561);
	
	var _Heads2 = _interopRequireDefault(_Heads);
	
	var _Eyes = __webpack_require__(560);
	
	var _Eyes2 = _interopRequireDefault(_Eyes);
	
	var _Toy = __webpack_require__(17);
	
	var _Toy2 = _interopRequireDefault(_Toy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // TODO ACTIONS
	
	var Tiger = function (_PetHOC) {
		_inherits(Tiger, _PetHOC);
	
		function Tiger(props) {
			_classCallCheck(this, Tiger);
	
			var _this = _possibleConstructorReturn(this, (Tiger.__proto__ || Object.getPrototypeOf(Tiger)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 4000);
						}
					}
				}, {
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 2500);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 199;
						}
					}
				}],
				pet: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(600, 1200);
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(Tiger, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Bodies2.default, { body: this.props.body })
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Heads2.default, { getHatTargetCoords: this.getHatTargetCoords, head: this.props.head }),
									_react2.default.createElement(_Eyes2.default, { getGlassesTargetCoords: this.getGlassesTargetCoords }),
									this.shouldRenderHat(),
									this.shouldRenderGlasses()
								)
							)
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-toy', viewBox: '0 0 480 480' },
							_react2.default.createElement(_Toy2.default, { toy: this.props.toy, kitten: this.props.kitten })
						)
					)
				);
			}
		}]);
	
		return Tiger;
	}(_PetHOC3.default);
	
	exports.default = Tiger;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make group for face '.fill--face'
	// Make glasses target 'ref="glassesTarget"'
	// Make groups for each eye group
	// - '.fill-eyes eyes'
	// - '.fill-face eyes--blink'
	// - '.fill-face eyes--is-being-pet--likes'
	// - '.fill-eyes eyes--is-being-pet--hates'
	
	var Eyes = function (_React$Component) {
		_inherits(Eyes, _React$Component);
	
		function Eyes() {
			_classCallCheck(this, Eyes);
	
			return _possibleConstructorReturn(this, (Eyes.__proto__ || Object.getPrototypeOf(Eyes)).apply(this, arguments));
		}
	
		_createClass(Eyes, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getGlassesTargetCoords(this.refs.glassesTarget);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					{ className: "fill--face" },
					_react2.default.createElement("circle", { ref: "glassesTarget", cx: "105.9212341", cy: "291.245575", r: "0" }),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes" },
						_react2.default.createElement("path", { d: "M97.9024353,291.245575c0,3.4293823-2.2626648,5.4797974-5.0537949,5.4797974s-5.0537872-2.050415-5.0537872-5.4797974 c0-3.4293518,2.2626572-5.4797974,5.0537872-5.4797974S97.9024353,287.8162231,97.9024353,291.245575z" }),
						_react2.default.createElement("path", { d: "M124.037941,291.245575c0,3.4293823-2.2626648,5.4797974-5.0537949,5.4797974s-5.0537872-2.050415-5.0537872-5.4797974 c0-3.4293518,2.2626572-5.4797974,5.0537872-5.4797974S124.037941,287.8162231,124.037941,291.245575z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--blink" },
						_react2.default.createElement("path", { d: "M114.067009,294.1382141c-0.7614365-0.0583801-1.3980713-0.6508484-1.485054-1.4377136 c-0.0987854-0.8897095,0.5425262-1.6912231,1.4322357-1.7900085l10.0128632-1.1112061 c0.8896637-0.0981445,1.6915283,0.542572,1.7896576,1.4325256c0.0987854,0.8897095-0.5425262,1.6912231-1.4322357,1.7900085 l-10.0128632,1.1112061C114.268486,294.1444702,114.1667633,294.145874,114.067009,294.1382141z" }),
						_react2.default.createElement("path", { d: "M97.7736435,294.1382141c0.7614365-0.0583801,1.3980713-0.6508484,1.485054-1.4377136 c0.0987854-0.8897095-0.5425262-1.6912231-1.4322357-1.7900085l-10.0128632-1.1112061 c-0.8896637-0.0981445-1.6915283,0.542572-1.7896576,1.4325256c-0.0987854,0.8897095,0.5425262,1.6912231,1.4322357,1.7900085 l10.0128632,1.1112061C97.5721664,294.1444702,97.6738892,294.145874,97.7736435,294.1382141z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--is-being-pet--likes" },
						_react2.default.createElement("path", { d: "M114.1315002,294.1550903c-0.4378662-0.0168152-0.8670731-0.2097473-1.1732712-0.5697327 c-0.5802765-0.6819153-0.4972839-1.7050171,0.1846466-2.2849731c1.3743439-1.1690063,3.4913406-1.8583069,5.8081055-1.8910828 c2.3187027-0.0339355,4.4528275,0.5973816,5.8593216,1.7279968c0.6977081,0.5609741,0.8087311,1.5813599,0.2477493,2.2790833 c-0.5616226,0.697998-1.5816345,0.8077698-2.2787628,0.2480774c-0.6300812-0.5067444-1.9481354-1.0357666-3.7828979-1.0133362 c-1.8272858,0.0258789-3.1367874,0.5950317-3.7531967,1.1188965 C114.9209061,294.0440674,114.5231781,294.1701355,114.1315002,294.1550903z" }),
						_react2.default.createElement("path", { d: "M97.7091522,294.1550903c0.4378662-0.0168152,0.8670731-0.2097473,1.1732712-0.5697327 c0.5802689-0.6819153,0.4972839-1.7050171-0.1846466-2.2849731c-1.3743439-1.1690063-3.4913406-1.8583069-5.8081055-1.8910828 c-2.3187103-0.0339355-4.4528275,0.5973816-5.8593216,1.7279968c-0.6977081,0.5609741-0.8087311,1.5813599-0.2477493,2.2790833 c0.5616226,0.697998,1.5816345,0.8077698,2.2787628,0.2480774c0.6300812-0.5067444,1.9481354-1.0357666,3.7828979-1.0133362 c1.8272858,0.0258789,3.1367874,0.5950317,3.7531967,1.1188965 C96.9197464,294.0440674,97.3174744,294.1701355,97.7091522,294.1550903z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes--is-being-pet--hates" },
						_react2.default.createElement("path", { d: "M124.0476151,291.245575c0,3.4293823-2.2626572,5.4797974-5.0537872,5.4797974s-5.0537872-2.050415-5.0537872-5.4797974 c0-1.8418579,2.2626572-1.8375549,5.0537872-1.8375549S124.0476151,289.403717,124.0476151,291.245575z" }),
						_react2.default.createElement("path", { d: "M87.7930374,291.245575c0,3.4293823,2.2626572,5.4797974,5.0537872,5.4797974s5.0537872-2.050415,5.0537872-5.4797974 c0-1.8418579-2.2626572-1.8375549-5.0537872-1.8375549S87.7930374,289.403717,87.7930374,291.245575z" })
					)
				);
			}
		}]);
	
		return Eyes;
	}(_react2.default.Component);
	
	exports.default = Eyes;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = FeetBack;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function FeetBack() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill fill--alt foot foot--back foot--inside", d: "M263.3526917,282.6105042 c-2.2128906,21.534668-2.7739258,44.2214355-2.078125,67.7861328l-0.0047607,0.0203857 c0,9.9409485,9.1487732,14.3233032,27.0380859,14.3233032c17.8892822,0,27.0429077-4.3823547,27.0429077-14.3233032v-0.0204468 c0-41.6942749,0-67.7859192-40.3345642-67.7859192L263.3526917,282.6105042z" }),
			_react2.default.createElement("path", { className: "fill fill--alt foot foot--front foot--outside", d: "M179.2938995,282.6105042 c2.2128906,21.534668,2.7739258,44.2214355,2.078125,67.7861328l0.004776,0.0203857 c0,9.9409485-9.1487885,14.3233032-27.0380859,14.3233032s-27.0429077-4.3823547-27.0429077-14.3233032v-0.0204468 c0-41.6942749,0-67.7859192,40.334549-67.7859192L179.2938995,282.6105042z" })
		);
	}

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = FeetFront;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function FeetFront() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill fill--alt foot foot--back foot--outside", d: "M330.2015686,292.6184998 c-2.2128906,21.534668-2.7739258,44.2214355-2.078125,67.7861328l-0.0047913,0.0203857 c0,9.9409485,9.1488037,14.3233032,27.0380859,14.3233032c17.8893127,0,27.0429077-4.3823547,27.0429077-14.3233032v-0.0204468 c0-41.6942749,0-67.7858887-40.3345337-67.7858887L330.2015686,292.6184998z" }),
			_react2.default.createElement("path", { className: "fill fill--alt foot foot--front foot--inside", d: "M246.1427612,292.6184998 c2.2128906,21.534668,2.7739258,44.2214355,2.078125,67.7861328l0.004776,0.0203857 c0,9.9409485-9.1487732,14.3233032-27.0380859,14.3233032s-27.0429077-4.3823547-27.0429077-14.3233032v-0.0204468 c0-41.6942749,0-67.7858887,40.334549-67.7858887L246.1427612,292.6184998z" })
		);
	}

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make hatTarget 'ref="hatTarget"'
	// Add '.fill' to all body elements
	// Add '.fill--face' to nose
	
	var HeadHOC = function (_React$Component) {
		_inherits(HeadHOC, _React$Component);
	
		function HeadHOC() {
			_classCallCheck(this, HeadHOC);
	
			return _possibleConstructorReturn(this, (HeadHOC.__proto__ || Object.getPrototypeOf(HeadHOC)).apply(this, arguments));
		}
	
		_createClass(HeadHOC, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getHatTargetCoords(this.refs.hatTarget);
			}
		}]);
	
		return HeadHOC;
	}(_react2.default.Component);
	
	var Heads = function (_HeadHOC) {
		_inherits(Heads, _HeadHOC);
	
		function Heads() {
			_classCallCheck(this, Heads);
	
			return _possibleConstructorReturn(this, (Heads.__proto__ || Object.getPrototypeOf(Heads)).apply(this, arguments));
		}
	
		_createClass(Heads, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "108.0065765", cy: "275.2041931", r: "0" }),
					_react2.default.createElement("path", { className: "fill fill--alt", d: "M78.6175537,306.1664124 c-0.5605316-1.4047852-0.8212814-2.9166565-0.7986603-4.4289551c0.2975159-19.8843689,5.7018585-38.9046021,27.4036102-38.9046021 c44.112793-1.5108948,81.3959351,16.9168701,94.1513672,30.3713379 C177.0821838,321.5604248,90.1616211,335.0974426,78.6175537,306.1664124z" })
				);
			}
		}]);
	
		return Heads;
	}(HeadHOC);
	
	exports.default = Heads;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = ShellBack;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function ShellBack() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill fill--light", d: "M371.3501587,308.4816589c0,13.9603271-39.2392578,41.219696-115.9666901,41.219696 s-115.9873657-27.2593689-115.9873657-41.219696v-0.0930786c0-69.8253937,51.9200592-115.9381866,115.9666901-115.9381866 s115.9666748,46.112793,115.9666748,115.9381866L371.3501587,308.4816589z" }),
			_react2.default.createElement("path", { className: "fill", d: "M255.3505249,323.1589355 c-46.9255219,0-48.3117218-42.3075562-87.5112-42.3075562c-17.7304077,0-32.4064789,28.4089966-34.0817871,27.1079102 c-3.4686584-2.6938782-5.2108002-5.7794189-5.2107697-9.2827759 c-0.0001678-68.089447,56.7945862-120.3929138,126.8263702-120.3929138s126.8265076,52.3034668,126.826355,120.3929138 c0.0001526,17.3858948-42.9061584,24.4824219-126.8037567,24.4824219H255.3505249z" })
		);
	}

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = ShellFront;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function ShellFront() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill", d: "M255.3731384,178.2835999 c70.0317688,0,126.8265076,52.3034668,126.826355,120.3929138c0.0001526,17.3858948-42.9061584,24.4824219-126.8037567,24.4824219 h-0.0452118c-30.0759888,0-41.4447937-17.3795776-56.0522461-29.8605652 c-8.1835632-6.992218-29.9604187-30.4655151-44.0357666-30.4655151" }),
			_react2.default.createElement("ellipse", { className: "fill fill--dark", transform: "matrix(0.945053 -0.326917 0.326917 0.945053 -75.3242264 134.9950256)", cx: "363.9267578", cy: "291.5751648", rx: "7.0994086", ry: "7.0994086" }),
			_react2.default.createElement("ellipse", { className: "fill fill--dark", transform: "matrix(0.945053 -0.326917 0.326917 0.945053 -72.5145645 130.2639923)", cx: "351.2575378", cy: "280.8513794", rx: "4.4301147", ry: "4.4301147" }),
			_react2.default.createElement("ellipse", { className: "fill fill--dark", transform: "matrix(0.945053 -0.326917 0.326917 0.945053 -77.9462967 129.430191)", cx: "346.0612488", cy: "296.5930176", rx: "5.6807146", ry: "5.6807146" }),
			_react2.default.createElement("ellipse", { className: "fill fill--dark", transform: "matrix(0.3609667 -0.9325787 0.9325787 0.3609667 -0.4517455 409.1203613)", cx: "298.3007812", cy: "204.8898163", rx: "7.0994086", ry: "7.0994086" }),
			_react2.default.createElement("ellipse", { className: "fill fill--dark", transform: "matrix(0.3609667 -0.9325787 0.9325787 0.3609667 -13.965313 422.139679)", cx: "301.0439148", cy: "221.2600403", rx: "4.4301147", ry: "4.4301147" }),
			_react2.default.createElement("ellipse", { className: "fill fill--dark", transform: "matrix(0.3609667 -0.9325787 0.9325787 0.3609667 3.1432755 429.7888184)", cx: "315.1796265", cy: "212.6008301", rx: "5.6807146", ry: "5.6807146" })
		);
	}

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	var _FeetBack = __webpack_require__(564);
	
	var _FeetBack2 = _interopRequireDefault(_FeetBack);
	
	var _FeetFront = __webpack_require__(565);
	
	var _FeetFront2 = _interopRequireDefault(_FeetFront);
	
	var _ShellBack = __webpack_require__(567);
	
	var _ShellBack2 = _interopRequireDefault(_ShellBack);
	
	var _ShellFront = __webpack_require__(568);
	
	var _ShellFront2 = _interopRequireDefault(_ShellFront);
	
	var _Heads = __webpack_require__(566);
	
	var _Heads2 = _interopRequireDefault(_Heads);
	
	var _Eyes = __webpack_require__(563);
	
	var _Eyes2 = _interopRequireDefault(_Eyes);
	
	var _Toy = __webpack_require__(17);
	
	var _Toy2 = _interopRequireDefault(_Toy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tortoise = function (_PetHOC) {
		_inherits(Tortoise, _PetHOC);
	
		function Tortoise(props) {
			_classCallCheck(this, Tortoise);
	
			var _this = _possibleConstructorReturn(this, (Tortoise.__proto__ || Object.getPrototypeOf(Tortoise)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 2500);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 199;
						}
					}
				}, {
					name: 'sitting',
					actions: ['isSittingDown', 'isSittingUp'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(1000, 4000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(1000, 2000);
						}
					}
				}, {
					name: 'bobHead',
					actions: ['isBobbingHeadDown', 'isBobbingHeadUp'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(700, 3000);
						}
					}
				}],
				pet: [{
					name: 'bobHead',
					actions: ['isBobbingHeadDown', 'isBobbingHeadUp'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}, {
					name: 'sitting',
					actions: ['isSittingUp'],
					start: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(Tortoise, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body pet__feet', viewBox: '0 0 480 480' },
									_react2.default.createElement(_FeetBack2.default, null)
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body pet__in-shell', viewBox: '0 0 480 480' },
									_react2.default.createElement(_ShellBack2.default, null)
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body pet__feet', viewBox: '0 0 480 480' },
									_react2.default.createElement(_FeetFront2.default, null)
								),
								_react2.default.createElement(
									'div',
									{ className: 'pet__in-shell', viewBox: '0 0 480 480' },
									_react2.default.createElement(
										'svg',
										{ className: 'pet__head', viewBox: '0 0 480 480' },
										_react2.default.createElement(_Heads2.default, { getHatTargetCoords: this.getHatTargetCoords, head: this.props.head }),
										_react2.default.createElement(_Eyes2.default, { getGlassesTargetCoords: this.getGlassesTargetCoords })
									)
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body pet__in-shell', viewBox: '0 0 480 480' },
									_react2.default.createElement(_ShellFront2.default, null)
								),
								_react2.default.createElement(
									'div',
									{ className: 'pet__in-shell', viewBox: '0 0 480 480' },
									_react2.default.createElement(
										'svg',
										{ className: 'pet__head', viewBox: '0 0 480 480' },
										this.shouldRenderHat(),
										this.shouldRenderGlasses()
									)
								)
							)
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-toy', viewBox: '0 0 480 480' },
							_react2.default.createElement(_Toy2.default, { toy: this.props.toy })
						)
					)
				);
			}
		}]);
	
		return Tortoise;
	}(_PetHOC3.default);
	
	exports.default = Tortoise;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Bodies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function Bodies() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill fill--black penguin--wing penguin--wing--left", d: "M196.9253082,188.8121033c-17.03125,18.3716278-28.6724396,54.885498-28.6724396,86.0325012 c0,11.4630737,2.3295746,24.9998474,6.5444946,38.0345764c0.791626,2.6525879,3.5147247,8.256897,10.5464478,6.9443665 c5.3550262-0.9995728,7.6847992-10.9397583,8.2038574-33.4861755l0.0105438-0.1288757 c0.2108459-2.336853,0.5123444-4.798645,0.9224243-7.5255432c1.464798-9.7567749,4.3986206-18.9042969,9.2310333-28.7869568 c2.1811218-4.4510651,16.1586456-29.1740417,16.7521667-30.2242279c0.3673859-0.6596375,0.6236115-1.4688873,0.9666901-2.0692596 C238.9804993,186.8903656,211.5692139,173.0157013,196.9253082,188.8121033z" }),
			_react2.default.createElement("path", { className: "fill fill--black penguin--wing penguin--wing--right", d: "M311.074707,188.8121033c17.03125,18.3716278,28.6724243,54.885498,28.6724243,86.0325012 c0,11.4630737-2.3295593,24.9998474-6.5444946,38.0345764c-0.791626,2.6525879-3.51474,8.256897-10.5464478,6.9443665 c-5.3550415-0.9995728-7.6848145-10.9397583-8.2038574-33.4861755l-0.0105591-0.1288757 c-0.2108154-2.336853-0.5123291-4.798645-0.9223938-7.5255432c-1.4648132-9.7567749-4.3986206-18.9042969-9.2310486-28.7869568 c-2.1811218-4.4510651-16.1586609-29.1740417-16.7521667-30.2242279 c-0.3673706-0.6596375-0.6236267-1.4688873-0.9666748-2.0692596 C269.0195007,186.8903656,296.4307861,173.0157013,311.074707,188.8121033z" }),
			_react2.default.createElement(
				"g",
				{ className: "body" },
				_react2.default.createElement("path", { className: "fill fill--white", d: "M254,198.9755096c18.0625305,0,35.7052612-11.6563416,47.2984314,2.2769928 c14.9534912,17.9719543,25.3825989,53.8635864,25.3825989,82.3667603c0,75.8895874-48.9959717,78.9524841-48.9959717,78.9524841 c-6.8857117,2.1470032-40.3427277,2.1683044-47.1703033,0.0619812c0,0-49.1957855-3.1248779-49.1957855-79.0144653 c0-28.5031738,10.4290924-64.3948059,25.3825836-82.3667603C219.4226074,185.963623,235.9374695,198.9755096,254,198.9755096z" })
			)
		);
	}

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make group for face '.fill--face'
	// Make glasses target 'ref="glassesTarget"'
	// Make groups for each eye group
	// - '.fill-eyes eyes'
	// - '.fill-face eyes--blink'
	// - '.fill-face eyes--is-being-pet--likes'
	// - '.fill-eyes eyes--is-being-pet--hates'
	
	var Eyes = function (_React$Component) {
		_inherits(Eyes, _React$Component);
	
		function Eyes() {
			_classCallCheck(this, Eyes);
	
			return _possibleConstructorReturn(this, (Eyes.__proto__ || Object.getPrototypeOf(Eyes)).apply(this, arguments));
		}
	
		_createClass(Eyes, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getGlassesTargetCoords(this.refs.glassesTarget);
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					{ className: "fill--face" },
					_react2.default.createElement("circle", { ref: "glassesTarget", cx: "254.2126312", cy: "150.9294281", r: "0" }),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes" },
						_react2.default.createElement("ellipse", { cx: "229.9018097", cy: "150.9295654", rx: "7.4444652", ry: "8.2716284" }),
						_react2.default.createElement("ellipse", { cx: "278.0979919", cy: "150.9295654", rx: "7.4444652", ry: "8.2716284" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--blink" },
						_react2.default.createElement("path", { d: "M270.8044434,155.956665c0.1473694,0,0.2966309-0.0135345,0.4468079-0.0419769l14.5814819-2.7601471 c1.2956543-0.2453308,2.1473083-1.494812,1.9019775-2.7904663c-0.2453308-1.2961273-1.4934082-2.1463623-2.7900085-1.9024353 l-14.5814819,2.7601471c-1.2956543,0.2453156-2.1473083,1.494812-1.9019775,2.7904663 C268.6776428,155.1581879,269.6794739,155.956665,270.8044434,155.956665z" }),
						_react2.default.createElement("path", { d: "M237.195343,155.956665c-0.1473694,0-0.2966309-0.0135345-0.4468079-0.0419769l-14.5814819-2.7601471 c-1.2956543-0.2453308-2.1473083-1.494812-1.9019775-2.7904663c0.2453308-1.2961273,1.4934082-2.1463623,2.7899933-1.9024353 l14.5814972,2.7601471c1.2956543,0.2453156,2.1472931,1.494812,1.9019623,2.7904663 C239.3221283,155.1581879,238.3202972,155.956665,237.195343,155.956665z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--face eyes--is-being-pet--likes" },
						_react2.default.createElement("path", { d: "M237.1350403,155.9220886c-0.5759277,0-1.152771-0.2074738-1.6105194-0.6280212 c-0.8755035-0.8038483-2.7660675-1.7133179-5.447464-1.8542633c-2.6795349-0.135849-4.6566162,0.5661316-5.6112061,1.2746277 c-1.0578613,0.78479-2.5483398,0.5628967-3.3317413-0.4926453c-0.784317-1.0559845-0.5638123-2.5478821,0.4921875-3.3321991 c2.1287384-1.5807343,5.2883606-2.3869324,8.700119-2.2068939c3.3996582,0.1786346,6.4690247,1.3099976,8.42099,3.1037903 c0.9685364,0.8899231,1.0327454,2.396698,0.1423492,3.3652344 C238.4199066,155.6629791,237.7788696,155.9220886,237.1350403,155.9220886z" }),
						_react2.default.createElement("path", { d: "M270.8019409,155.9220886c0.5758972,0,1.1527405-0.2074738,1.6105042-0.6280212 c0.8754883-0.8038483,2.7660522-1.7133179,5.4474487-1.8542633c2.6795349-0.135849,4.6566467,0.5661316,5.6112061,1.2746277 c1.0578613,0.78479,2.5483704,0.5628967,3.3317566-0.4926453c0.7843323-1.0559845,0.5638123-2.5478821-0.4921875-3.3321991 c-2.1287231-1.5807343-5.2883606-2.3869324-8.7001038-2.2068939c-3.3996582,0.1786346-6.4690247,1.3099976-8.42099,3.1037903 c-0.9685669,0.8899231-1.0327454,2.396698-0.1423645,3.3652344 C269.5170593,155.6629791,270.1581116,155.9220886,270.8019409,155.9220886z" })
					),
					_react2.default.createElement(
						"g",
						{ className: "fill--eyes eyes--is-being-pet--hates" },
						_react2.default.createElement("path", { d: "M237.3462677,150.9295654c0,4.5682831-3.3329926,8.2716217-7.444458,8.2716217s-7.4444733-3.7033386-7.4444733-8.2716217 c0-3.2873535,3.3330078-3.0427094,7.4444733-3.0427094S237.3462677,147.6422119,237.3462677,150.9295654z" }),
						_react2.default.createElement("path", { d: "M285.54245,150.9295654c0,4.5682831-3.3330078,8.2716217-7.444458,8.2716217 c-4.1114807,0-7.4444885-3.7033386-7.4444885-8.2716217c0-3.2873535,3.3330078-3.0427094,7.4444885-3.0427094 C282.2094421,147.8868561,285.54245,147.6422119,285.54245,150.9295654z" })
					)
				);
			}
		}]);
	
		return Eyes;
	}(_react2.default.Component);
	
	exports.default = Eyes;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Feet;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// - Add '.fill' to all body classes.
	// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>
	
	function Feet() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill penguin--foot penguin--foot--left", d: "M250.2910461,368.0740967c0,6.978302-10.0612946,6.6719666-22.4725189,6.6719666 s-22.4725037,0.3063354-22.4725037-6.6719666s10.0612793-17.3981323,22.4725037-17.3981323 S250.2910461,361.0957947,250.2910461,368.0740967z" }),
			_react2.default.createElement("path", { className: "fill penguin--foot penguin--foot--right", d: "M302.7102356,368.0657349c0,6.9870605-10.0739136,6.6803284-22.5007324,6.6803284 s-22.5007324,0.3067322-22.5007324-6.6803284c0-6.9870911,10.0739136-17.4199829,22.5007324-17.4199829 S302.7102356,361.0786438,302.7102356,368.0657349z" })
		);
	}

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Make hatTarget 'ref="hatTarget"'
	// Add '.fill' to all body elements
	// Add '.fill--face' to nose
	
	var HeadHOC = function (_React$Component) {
		_inherits(HeadHOC, _React$Component);
	
		function HeadHOC() {
			_classCallCheck(this, HeadHOC);
	
			return _possibleConstructorReturn(this, (HeadHOC.__proto__ || Object.getPrototypeOf(HeadHOC)).apply(this, arguments));
		}
	
		_createClass(HeadHOC, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				this.props.getHatTargetCoords(this.refs.hatTarget);
			}
		}]);
	
		return HeadHOC;
	}(_react2.default.Component);
	
	var Heads = function (_HeadHOC) {
		_inherits(Heads, _HeadHOC);
	
		function Heads() {
			_classCallCheck(this, Heads);
	
			return _possibleConstructorReturn(this, (Heads.__proto__ || Object.getPrototypeOf(Heads)).apply(this, arguments));
		}
	
		_createClass(Heads, [{
			key: "render",
			value: function render() {
				return _react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("circle", { ref: "hatTarget", cx: "252.4510956", cy: "124.5629578", r: "0" }),
					_react2.default.createElement("path", { className: "fill fill--black", d: "M254.0057983,105.8250732c2.690979-0.0144806,5.4129944,0.1755829,8.1493835,0.5838623 c24.6368713,3.6759644,42.9733887,23.1970367,46.4758301,46.6557922 c7.4205933,49.7020416-20.6480103,71.907074-54.625351,71.907074s-61.7118988-22.7582092-54.6253204-71.907074 c3.3849182-23.4759979,21.8389435-42.9798279,46.4758453-46.6557922 C248.5925598,106.0006561,251.3145752,105.8105927,254.0057983,105.8250732z" })
				);
			}
		}]);
	
		return Heads;
	}(HeadHOC);
	
	exports.default = Heads;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = Nose;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Nose() {
		return _react2.default.createElement(
			"g",
			null,
			_react2.default.createElement("path", { className: "fill penguin--beak", d: "M254.1199036,154.3847809c-3.2996826,0-10.0014038,8.9412842-10.0014038,10.495163l9.9182434,1.9044342 l10.0838013-1.9044342C264.1205444,163.144165,257.4195862,154.3847809,254.1199036,154.3847809z" }),
			_react2.default.createElement("path", { className: "fill fill--dark penguin--beak", d: "M254.0367432,166.7843781l-9.9182434-1.9044342c0,1.554184,3.8116302,5.4132996,3.8116302,5.4132996 c3.4180756,3.4185333,8.9602509,3.4185333,12.3785553,0c0,0,3.8118591-3.6772003,3.8118591-5.4132996L254.0367432,166.7843781z" })
		);
	}

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PetHOC2 = __webpack_require__(13);
	
	var _PetHOC3 = _interopRequireDefault(_PetHOC2);
	
	var _Bodies = __webpack_require__(570);
	
	var _Bodies2 = _interopRequireDefault(_Bodies);
	
	var _Heads = __webpack_require__(573);
	
	var _Heads2 = _interopRequireDefault(_Heads);
	
	var _Eyes = __webpack_require__(571);
	
	var _Eyes2 = _interopRequireDefault(_Eyes);
	
	var _Nose = __webpack_require__(574);
	
	var _Nose2 = _interopRequireDefault(_Nose);
	
	var _Feet = __webpack_require__(572);
	
	var _Feet2 = _interopRequireDefault(_Feet);
	
	var _Toy = __webpack_require__(17);
	
	var _Toy2 = _interopRequireDefault(_Toy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TuxedoBird = function (_PetHOC) {
		_inherits(TuxedoBird, _PetHOC);
	
		function TuxedoBird(props) {
			_classCallCheck(this, TuxedoBird);
	
			var _this = _possibleConstructorReturn(this, (TuxedoBird.__proto__ || Object.getPrototypeOf(TuxedoBird)).call(this, props));
	
			_this.actions = {
				idle: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 4000);
						}
					}
				}, {
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					}
				}, {
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(200, 2500);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}, {
					name: 'flap',
					actions: ['isFlapping'],
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(5000, 10000);
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}],
				pet: [{
					name: 'tilt',
					actions: ['isTiltingRight', 'isTiltingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return _lodash2.default.random(600, 1200);
						}
					}
				}, {
					name: 'flap',
					actions: ['isFlapping'],
					start: {
						timeout: null,
						interval: function interval() {
							return Math.random() > 0.5 ? 200 : 400;
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 200;
						}
					}
				}, {
					name: 'stomp',
					actions: ['isStompingRight', 'isStompingLeft'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: function interval() {
							return 400;
						}
					},
					stop: {
						timeout: null,
						interval: function interval() {
							return 400;
						}
					}
				}]
			};
			return _this;
		}
	
		_createClass(TuxedoBird, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'pet-wrapper' },
					_react2.default.createElement(
						'div',
						{
							className: this.getClassNames(),
							onMouseEnter: this.startBeingPet,
							onMouseLeave: this.stopBeingPet },
						_react2.default.createElement('img', { className: 'pet-frame', src: this.getFrameImagePathname(), alt: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'pet-name' },
							this.getName()
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-shadow', viewBox: '0 0 480 480' },
							_react2.default.createElement('ellipse', { cx: '254', cy: '366', rx: '167', ry: '33' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'special-pet-transform-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'pet-body-and-head' },
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Heads2.default, { getHatTargetCoords: this.getHatTargetCoords, head: this.props.head }),
									_react2.default.createElement(_Eyes2.default, { getGlassesTargetCoords: this.getGlassesTargetCoords }),
									this.shouldRenderHat()
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__body', viewBox: '0 0 480 480' },
									_react2.default.createElement(_Bodies2.default, { body: this.props.body })
								),
								_react2.default.createElement(
									'svg',
									{ className: 'pet__head', viewBox: '0 0 480 480' },
									this.shouldRenderGlasses(),
									_react2.default.createElement(_Nose2.default, null)
								)
							),
							_react2.default.createElement(
								'svg',
								{ className: 'pet__body', viewBox: '0 0 480 480' },
								_react2.default.createElement(_Feet2.default, null)
							)
						),
						_react2.default.createElement(
							'svg',
							{ className: 'pet-toy', viewBox: '0 0 480 480' },
							_react2.default.createElement(_Toy2.default, { toy: this.props.toy })
						)
					)
				);
			}
		}]);
	
		return TuxedoBird;
	}(_PetHOC3.default);
	
	exports.default = TuxedoBird;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = CatSnapshotFooter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Navigation = __webpack_require__(23);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CatSnapshotFooter() {
		return _react2.default.createElement(
			'div',
			{ className: 'server-footer alt-color--shadow' },
			_react2.default.createElement(
				'div',
				{ className: 'server-footer__contents' },
				_react2.default.createElement(_Navigation2.default, null),
				_react2.default.createElement(
					'div',
					{ className: 'server-footer__credits alt-color--lighter' },
					'Made by ',
					_react2.default.createElement(
						'a',
						{ className: 'site-link', href: 'https://twitter.com/lslez', target: '_blank', rel: 'noopener noreferrer' },
						'@lslez'
					)
				)
			)
		);
	}

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KittenInTab = __webpack_require__(253);
	
	var _KittenInTab2 = _interopRequireDefault(_KittenInTab);
	
	var _Arrow = __webpack_require__(251);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HeroIllustration(_ref) {
		var buttonHover = _ref.buttonHover;
	
		return _react2.default.createElement(
			'div',
			{ className: 'hero--illustration' },
			_react2.default.createElement(
				'div',
				{ className: 'toolbar' },
				_react2.default.createElement('div', { className: 'dot' }),
				_react2.default.createElement('div', { className: 'dot' }),
				_react2.default.createElement('div', { className: 'dot' })
			),
			_react2.default.createElement(
				'div',
				{ className: 'hero--cats' },
				_react2.default.createElement(_KittenInTab2.default, { beingPet: buttonHover, color: 'gray' }),
				_react2.default.createElement(_KittenInTab2.default, { beingPet: buttonHover, color: 'white' }),
				_react2.default.createElement(_KittenInTab2.default, { beingPet: buttonHover, color: 'orange' }),
				_react2.default.createElement(_KittenInTab2.default, { beingPet: buttonHover, color: 'black' })
			),
			_react2.default.createElement(
				'div',
				{ className: 'window' },
				_react2.default.createElement(_Arrow2.default, null)
			)
		);
	}
	
	HeroIllustration.propTypes = {
		buttonHover: _propTypes2.default.bool
	};
	
	HeroIllustration.defaultProps = {
		buttonHover: false
	};
	
	exports.default = HeroIllustration;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactWaypoint = __webpack_require__(58);
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _Pet = __webpack_require__(54);
	
	var _Pet2 = _interopRequireDefault(_Pet);
	
	var _SnapshotInSection = __webpack_require__(581);
	
	var _SnapshotInSection2 = _interopRequireDefault(_SnapshotInSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var classnames = __webpack_require__(12);
	
	var Section = function (_React$Component) {
		_inherits(Section, _React$Component);
	
		function Section() {
			_classCallCheck(this, Section);
	
			var _this = _possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).call(this));
	
			_this.state = {
				textIsHidden: true
			};
	
			_this.wayPointEntered = _this.wayPointEntered.bind(_this);
			return _this;
		}
	
		_createClass(Section, [{
			key: 'getClassNames',
			value: function getClassNames() {
				var classes = ['contents--left'];
	
				if (this.state.textIsHidden) {
					classes.push('is-hidden');
				}
	
				return classnames(classes);
			}
		}, {
			key: 'wayPointEntered',
			value: function wayPointEntered() {
				this.setState({ textIsHidden: false });
			}
		}, {
			key: 'render',
			value: function render() {
				var Media = this.props.contents.pet ? _Pet2.default : _SnapshotInSection2.default;
	
				return _react2.default.createElement(
					'div',
					{ className: 'bg--' + this.props.contents.bgColor + ' section' },
					_react2.default.createElement(
						'div',
						{ className: 'section__contents' },
						_react2.default.createElement(
							'div',
							{ className: this.getClassNames() },
							_react2.default.createElement(
								'h2',
								null,
								this.props.contents.title
							),
							_react2.default.createElement(
								'p',
								null,
								this.props.contents.desc
							),
							_react2.default.createElement(_reactWaypoint2.default, { onEnter: this.wayPointEntered })
						),
						_react2.default.createElement(
							'div',
							{ className: 'contents--right' },
							_react2.default.createElement(Media, this.props.contents.pet)
						)
					)
				);
			}
		}]);
	
		return Section;
	}(_react2.default.Component);
	
	exports.default = Section;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactWaypoint = __webpack_require__(58);
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _BaseSectionBookend2 = __webpack_require__(252);
	
	var _BaseSectionBookend3 = _interopRequireDefault(_BaseSectionBookend2);
	
	var _Navigation = __webpack_require__(23);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _HeroIllustration = __webpack_require__(577);
	
	var _HeroIllustration2 = _interopRequireDefault(_HeroIllustration);
	
	var _InstallButton = __webpack_require__(85);
	
	var _InstallButton2 = _interopRequireDefault(_InstallButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hero = function (_BaseSectionBookend) {
		_inherits(Hero, _BaseSectionBookend);
	
		function Hero() {
			_classCallCheck(this, Hero);
	
			return _possibleConstructorReturn(this, (Hero.__proto__ || Object.getPrototypeOf(Hero)).apply(this, arguments));
		}
	
		_createClass(Hero, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'section section--centered section--full-height bg--light-blue' },
					_react2.default.createElement(_Navigation2.default, null),
					_react2.default.createElement(
						'div',
						{ className: this.getClassNames() },
						_react2.default.createElement(
							'h1',
							null,
							'Tabby Cat'
						),
						_react2.default.createElement(
							'p',
							null,
							'A new friend in every tab.'
						),
						_react2.default.createElement(_InstallButton2.default, { classNames: 'install-button install-button--light-blue', hoverOnButton: this.hoverOnButton, hoverOffButton: this.hoverOffButton }),
						_react2.default.createElement(_reactWaypoint2.default, { onEnter: this.wayPointEntered })
					),
					_react2.default.createElement(_HeroIllustration2.default, { buttonHover: this.state.buttonHover })
				);
			}
		}]);
	
		return Hero;
	}(_BaseSectionBookend3.default);
	
	exports.default = Hero;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactWaypoint = __webpack_require__(58);
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _BaseSectionBookend2 = __webpack_require__(252);
	
	var _BaseSectionBookend3 = _interopRequireDefault(_BaseSectionBookend2);
	
	var _Navigation = __webpack_require__(23);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _KittenInTab = __webpack_require__(253);
	
	var _KittenInTab2 = _interopRequireDefault(_KittenInTab);
	
	var _InstallButton = __webpack_require__(85);
	
	var _InstallButton2 = _interopRequireDefault(_InstallButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LastSection = function (_BaseSectionBookend) {
		_inherits(LastSection, _BaseSectionBookend);
	
		function LastSection() {
			_classCallCheck(this, LastSection);
	
			return _possibleConstructorReturn(this, (LastSection.__proto__ || Object.getPrototypeOf(LastSection)).apply(this, arguments));
		}
	
		_createClass(LastSection, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'section section--centered section--full-height section--last bg--purple' },
					_react2.default.createElement(_Navigation2.default, null),
					_react2.default.createElement(
						'div',
						{ className: this.getClassNames() },
						_react2.default.createElement(
							'h2',
							null,
							'Get Tabbies in your Tabs.'
						),
						_react2.default.createElement(
							'p',
							null,
							'Available for Google Chrome and Firefox.'
						),
						_react2.default.createElement(_InstallButton2.default, { classNames: 'install-button install-button--purple', hoverOnButton: this.hoverOnButton, hoverOffButton: this.hoverOffButton }),
						_react2.default.createElement(_reactWaypoint2.default, { onEnter: this.wayPointEntered })
					),
					_react2.default.createElement(
						'div',
						{ className: 'hero--illustration' },
						_react2.default.createElement(
							'div',
							{ className: 'hero--cats' },
							_react2.default.createElement(_KittenInTab2.default, { beingPet: this.state.buttonHover, color: 'orange' })
						)
					)
				);
			}
		}]);
	
		return LastSection;
	}(_BaseSectionBookend3.default);
	
	exports.default = LastSection;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactWaypoint = __webpack_require__(58);
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SnapshotInSection = function (_React$Component) {
		_inherits(SnapshotInSection, _React$Component);
	
		function SnapshotInSection() {
			_classCallCheck(this, SnapshotInSection);
	
			var _this = _possibleConstructorReturn(this, (SnapshotInSection.__proto__ || Object.getPrototypeOf(SnapshotInSection)).call(this));
	
			_this.state = {
				isFlashing: false
			};
	
			_this.flashTimeout = null;
			_this.flashDelayTimeout = null;
	
			_this.getClassNames = _this.getClassNames.bind(_this);
			_this.flash = _this.flash.bind(_this);
			_this.flashDelay = _this.flashDelay.bind(_this);
			return _this;
		}
	
		_createClass(SnapshotInSection, [{
			key: 'getClassNames',
			value: function getClassNames() {
				return (0, _classnames2.default)('contents__snapshot__flash', {
					'contents__snapshot__flash--is-flashing': this.state.isFlashing
				});
			}
		}, {
			key: 'flash',
			value: function flash() {
				var _this2 = this;
	
				clearInterval(this.flashTimeout);
	
				this.setState({ isFlashing: true });
	
				this.flashTimeout = setTimeout(function () {
					_this2.setState({ isFlashing: false });
				}, 100);
			}
		}, {
			key: 'flashDelay',
			value: function flashDelay() {
				var _this3 = this;
	
				clearInterval(this.flashDelayTimeout);
	
				this.flashDelayTimeout = setTimeout(function () {
					_this3.flash();
				}, 600);
			}
		}, {
			key: 'render',
			value: function render() {
				var style = {
					st6: {
						fill: '#F2CC7B'
					},
					st8: {
						fill: '#5994C9'
					},
					st10: {
						fill: '#B3B3B3'
					},
					st69: {
						fill: '#64a9dd'
					},
					st96: {
						fill: '#F2F2F2'
					},
					st97: {
						fill: '#CCCCCC'
					},
					st98: {
						fill: '#E6E6E6'
					},
					st99: {
						fill: '#FFF1B8'
					}
				};
	
				return _react2.default.createElement(
					'div',
					{ className: 'contents__snapshot--wrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'contents__snapshot', onMouseDown: this.flash },
						_react2.default.createElement('img', { src: 'extension-assets/frame.png', alt: '' }),
						_react2.default.createElement(
							'svg',
							{ version: '1.1', viewBox: '0 0 113.2 89.9' },
							_react2.default.createElement('path', { style: style.st10, d: 'M106.6,50.6v25.6c0,4.6-3.8,8.4-8.4,8.4H15c-4.6,0-8.4-3.8-8.4-8.4V50.6H106.6z' }),
							_react2.default.createElement('path', { style: style.st96, d: 'M6.6,50.6V25.3c0-4.6,3.8-8.4,8.4-8.4h83.2c4.6,0,8.4,3.8,8.4,8.4v25.3H6.6z' }),
							_react2.default.createElement('path', { style: style.st10, d: 'M73.9,50.6C73.9,65.7,61.7,78,46.6,78S19.3,65.7,19.3,50.6H73.9z' }),
							_react2.default.createElement('path', { style: style.st97, d: 'M19.3,50.6c0-15.1,12.2-27.3,27.3-27.3s27.3,12.2,27.3,27.3H19.3z' }),
							_react2.default.createElement('circle', { style: style.st96, cx: '46.6', cy: '50.6', r: '21.9' }),
							_react2.default.createElement('path', { style: style.st98, d: 'M89.4,39.5L89.4,39.5c-4.1,0-7.5-3.4-7.5-7.5v0c0-4.1,3.4-7.5,7.5-7.5h0c4.1,0,7.5,3.4,7.5,7.5v0 C96.9,36.1,93.6,39.5,89.4,39.5z' }),
							_react2.default.createElement('path', { style: style.st96, d: 'M77.9,19.9L66.5,7c-1-1.1-2.4-1.8-3.9-1.8H46.8H31c-1.5,0-2.9,0.6-3.9,1.8L15.6,19.9H77.9z' }),
							_react2.default.createElement('circle', { style: style.st8, cx: '46.6', cy: '50.6', r: '16' }),
							_react2.default.createElement('path', { style: style.st69, d: 'M38,50.6c-1.2,0-2-1.1-1.8-2.3c1-4.8,5.3-8.4,10.4-8.4c5.1,0,9.4,3.6,10.4,8.5c0.2,1.1-0.7,2.1-1.8,2.1H38z'
							}),
							_react2.default.createElement('path', { style: style.st98, d: 'M52,10.1H41.2c-2.5,0-4.5,2-4.5,4.5v0c0,2.5,2,4.5,4.5,4.5H52c2.5,0,4.5-2,4.5-4.5v0 C56.5,12.1,54.5,10.1,52,10.1z' })
						),
						_react2.default.createElement(
							'svg',
							{ className: this.getClassNames(), version: '1.1', viewBox: '0 0 113.2 89.9' },
							_react2.default.createElement('polygon', { style: style.st6, points: '83.7,18.7 95,9.2 99.8,23.1 112.4,30.9 100.6,39.8 97.2,54.1 85,45.7 70.3,46.8 74.6,32.7 69,19 ' }),
							_react2.default.createElement('polygon', { style: style.st99, points: '87.2,38.1 80.6,38.6 82.5,32.3 80,26.2 86.6,26 91.6,21.8 93.8,28 99.4,31.5 94.2,35.5 92.6,41.9 ' })
						),
						_react2.default.createElement(_reactWaypoint2.default, { onEnter: this.flashDelay })
					)
				);
			}
		}]);
	
		return SnapshotInSection;
	}(_react2.default.Component);
	
	exports.default = SnapshotInSection;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shopify = __webpack_require__(258);
	
	var _shopify2 = _interopRequireDefault(_shopify);
	
	var _CartItem = __webpack_require__(583);
	
	var _CartItem2 = _interopRequireDefault(_CartItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cart = function (_React$Component) {
		_inherits(Cart, _React$Component);
	
		function Cart() {
			_classCallCheck(this, Cart);
	
			var _this = _possibleConstructorReturn(this, (Cart.__proto__ || Object.getPrototypeOf(Cart)).call(this));
	
			_this.state = {
				isClosed: true,
				isEmpty: true,
				subtotal: null
			};
	
			_this.clearCart = _this.clearCart.bind(_this);
			_this.checkout = _this.checkout.bind(_this);
			_this.toggleCart = _this.toggleCart.bind(_this);
			_this.closeCart = _this.closeCart.bind(_this);
			return _this;
		}
	
		_createClass(Cart, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!nextProps.cart) {
					return null;
				}
	
				this.setState({
					isEmpty: !Boolean(nextProps.cart.lineItemCount)
				});
	
				this.setState({
					subtotal: "$" + Math.round(Number(nextProps.cart.subtotal))
				});
			}
		}, {
			key: 'clearCart',
			value: function clearCart() {
				var _this2 = this;
	
				this.props.cart.clearLineItems().then(function (newCart) {
					_this2.props.updateCart(newCart);
				}).catch(function (err) {
					_this2.error = "Sorry, there was a problem clearing your cart. Try again?";
					console.error('There was a problem clearing the cart. ' + err);
				});
			}
		}, {
			key: 'checkout',
			value: function checkout() {
				_shopify2.default.clearLocalCart();
				window.location.href = this.props.cart.checkoutUrl;
			}
		}, {
			key: 'getClassNames',
			value: function getClassNames() {
				var classes = ['cart-wrapper'];
	
				if (this.state.isEmpty) {
					classes.push('cart-wrapper--is-empty');
				}
	
				if (this.state.isClosed) {
					classes.push('cart-wrapper--is-closed');
				}
	
				return (0, _classnames2.default)(classes);
			}
		}, {
			key: 'toggleCart',
			value: function toggleCart() {
				this.setState({ isClosed: !this.state.isClosed });
			}
		}, {
			key: 'closeCart',
			value: function closeCart() {
				this.setState({ isClosed: true });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var cartHeading = "Where'd the pets go?";
				var cartToggle = void 0;
	
				if (!this.props.cart) {
					return null;
				}
	
				if (this.props.cart.lineItemCount > 0) {
					if (this.state.isClosed) {
						cartHeading = this.props.cart.lineItemCount > 1 ? this.props.cart.lineItemCount + ' pets are in your cart' : this.props.cart.lineItemCount + ' pet is in your cart';
					} else {
						cartHeading = "Your Cart";
					}
				}
	
				cartToggle = this.state.isClosed ? "View" : "Close";
	
				return _react2.default.createElement(
					'div',
					{ className: this.getClassNames() },
					_react2.default.createElement('div', { className: 'cart-overlay', onClick: this.closeCart }),
					_react2.default.createElement(
						'div',
						{ className: 'cart' },
						_react2.default.createElement(
							'div',
							{ className: 'cart__heading', onClick: this.toggleCart },
							_react2.default.createElement(
								'span',
								{ className: 'cart__heading__text' },
								cartHeading
							),
							_react2.default.createElement(
								'a',
								{ className: 'cart__link cart__link--toggle-cart' },
								cartToggle
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'cart__items' },
							this.props.cart.lineItems.map(function (item) {
								return _react2.default.createElement(_CartItem2.default, { key: item.id, cart: _this3.props.cart, item: item, updateCart: _this3.props.updateCart });
							}),
							_react2.default.createElement(
								'div',
								{ className: 'cart__items__empty-message' },
								'Your cart is empty.',
								_react2.default.createElement('br', null),
								_react2.default.createElement('br', null),
								'\uD83D\uDC7B'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'cart__checkout' },
							_react2.default.createElement(
								'div',
								{ className: 'cart__checkout__subtotal cart__checkout-flex-wrapper' },
								_react2.default.createElement(
									'b',
									null,
									'Subtotal:'
								),
								_react2.default.createElement(
									'span',
									null,
									this.state.subtotal
								)
							),
							_react2.default.createElement(
								'a',
								{ className: 'button button--checkout alt-color--dark', onClick: this.checkout },
								'Checkout'
							),
							_react2.default.createElement(
								'div',
								{ className: 'cart__checkout__disclaimer' },
								'Shipping and promotions are added at checkout.'
							)
						)
					)
				);
			}
		}]);
	
		return Cart;
	}(_react2.default.Component);
	
	exports.default = Cart;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartItem = function (_React$Component) {
		_inherits(CartItem, _React$Component);
	
		function CartItem() {
			_classCallCheck(this, CartItem);
	
			var _this = _possibleConstructorReturn(this, (CartItem.__proto__ || Object.getPrototypeOf(CartItem)).call(this));
	
			_this.state = {
				price: null
			};
	
			_this.increment = _this.increment.bind(_this);
			_this.decrement = _this.decrement.bind(_this);
			_this.removeFromCart = _this.removeFromCart.bind(_this);
			return _this;
		}
	
		_createClass(CartItem, [{
			key: "removeFromCart",
			value: function removeFromCart() {
				var _this2 = this;
	
				this.props.cart.removeLineItem(this.props.item.id).then(function (newCart) {
					_this2.props.updateCart(newCart);
				}).catch(function (err) {
					// TODO - display error
					_this2.error = "Sorry, there was a problem removing this item from your cart. Try again?";
					console.error("There was a problem removing this item from the cart. " + err);
				});
			}
		}, {
			key: "increment",
			value: function increment() {
				var newQuantity = ++this.props.item.quantity;
				this.updateQuantity(newQuantity);
			}
		}, {
			key: "decrement",
			value: function decrement() {
				var newQuantity = --this.props.item.quantity;
				this.updateQuantity(newQuantity);
			}
		}, {
			key: "updateQuantity",
			value: function updateQuantity(quantity) {
				var _this3 = this;
	
				this.props.cart.updateLineItem(this.props.item.id, quantity).then(function (newCart) {
					_this3.props.updateCart(newCart);
				}).catch(function (err) {
					_this3.error = "Sorry, there was a problem updating the quantity. Try again?";
					console.error("There was a problem updating the quantity for this item. " + err);
				});
			}
		}, {
			key: "componentWillReceiveProps",
			value: function componentWillReceiveProps() {
				if (!this.props.item) {
					return null;
				}
	
				var price = "$" + Math.round(Number(this.props.item.line_price));
	
				this.setState({
					price: price
				});
			}
		}, {
			key: "render",
			value: function render() {
				var item = this.props.item;
	
				return _react2.default.createElement(
					"div",
					{ className: "cart__item" },
					_react2.default.createElement(
						"div",
						{ className: "item__image" },
						_react2.default.createElement("img", { src: item.image.src, alt: item.title })
					),
					_react2.default.createElement(
						"div",
						{ className: "item__details" },
						_react2.default.createElement(
							"div",
							{ className: "item__details__title-and-price" },
							_react2.default.createElement(
								"span",
								{ className: "title" },
								item.title
							),
							this.state.price
						),
						_react2.default.createElement(
							"div",
							{ className: "item__details__quantity" },
							_react2.default.createElement(
								"a",
								{ className: "cart__link cart__link--qty", onClick: this.decrement },
								"\u2013"
							),
							_react2.default.createElement(
								"div",
								{ className: "qty" },
								item.quantity
							),
							_react2.default.createElement(
								"a",
								{ className: "cart__link cart__link--qty", onClick: this.increment },
								"+"
							),
							_react2.default.createElement(
								"a",
								{ className: "cart__link cart__link--remove-from-cart", onClick: this.removeFromCart },
								"Remove"
							)
						)
					)
				);
			}
		}]);
	
		return CartItem;
	}(_react2.default.Component);
	
	exports.default = CartItem;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Product = __webpack_require__(586);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Gallery(_ref) {
		var products = _ref.products,
		    cart = _ref.cart,
		    updateCart = _ref.updateCart,
		    shopClosedUntilDate = _ref.shopClosedUntilDate;
	
		return _react2.default.createElement(
			'div',
			{ className: 'shop__collection' },
			_react2.default.createElement(
				'div',
				{ className: 'collection__products' },
				products.map(function (product) {
					return _react2.default.createElement(_Product2.default, { shopClosedUntilDate: shopClosedUntilDate, key: product.id, item: product, cart: cart, updateCart: updateCart });
				})
			)
		);
	}
	
	Gallery.defaultProps = {
		products: []
	};
	
	exports.default = Gallery;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageWithLoader = function (_React$PureComponent) {
		_inherits(ImageWithLoader, _React$PureComponent);
	
		function ImageWithLoader() {
			_classCallCheck(this, ImageWithLoader);
	
			var _this = _possibleConstructorReturn(this, (ImageWithLoader.__proto__ || Object.getPrototypeOf(ImageWithLoader)).call(this));
	
			_this.state = {
				loading: true,
				initialLoading: true,
				oldSrc: ''
			};
			_this.displayImage = _this.displayImage.bind(_this);
			_this.getClassNames = _this.getClassNames.bind(_this);
			return _this;
		}
	
		_createClass(ImageWithLoader, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.fetchImage();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.src !== nextProps.src) {
					this.fetchImage();
				}
			}
		}, {
			key: 'fetchImage',
			value: function fetchImage() {
				var _this2 = this;
	
				if (this.props.src) {
					this.setState(function () {
						return {
							loading: true,
							oldSrc: _this2.props.src
						};
					}, function () {
						var img = new window.Image();
						img.onload = function () {
							_this2.displayImage();
						};
						img.src = _this2.props.src;
					});
				}
			}
		}, {
			key: 'displayImage',
			value: function displayImage() {
				this.setState(function () {
					return {
						loading: false,
						initialLoading: false
					};
				});
			}
		}, {
			key: 'getClassNames',
			value: function getClassNames() {
				return (0, _classnames2.default)('product__image', {
					'product__image--is-loading': this.state.loading,
					'product__image--initial': this.state.initialLoading
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: this.getClassNames() },
					_react2.default.createElement('img', {
						src: this.state.loading ? this.state.oldSrc : this.props.src,
						alt: this.props.alt
					}),
					_react2.default.createElement('div', { className: 'spinner' })
				);
			}
		}]);
	
		return ImageWithLoader;
	}(_react2.default.PureComponent);
	
	ImageWithLoader.propTypes = {
		src: _propTypes2.default.string.isRequired,
		alt: _propTypes2.default.string.isRequired
	};
	
	exports.default = ImageWithLoader;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Icons = __webpack_require__(44);
	
	var _ImageWithLoader = __webpack_require__(585);
	
	var _ImageWithLoader2 = _interopRequireDefault(_ImageWithLoader);
	
	var _getRoundedPrice = __webpack_require__(614);
	
	var _getRoundedPrice2 = _interopRequireDefault(_getRoundedPrice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	var Product = function (_React$Component) {
		_inherits(Product, _React$Component);
	
		function Product() {
			_classCallCheck(this, Product);
	
			var _this = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this));
	
			_this.state = {
				currentImage: 1,
				error: false
			};
	
			_this.addToCart = _this.addToCart.bind(_this);
			_this.nextImage = _this.nextImage.bind(_this);
			_this.prevImage = _this.prevImage.bind(_this);
			_this.shouldShowError = _this.shouldShowError.bind(_this);
			_this.getTags = _this.getTags.bind(_this);
			_this.getBadges = _this.getBadges.bind(_this);
			return _this;
		}
	
		_createClass(Product, [{
			key: 'getTags',
			value: function getTags() {
				return _lodash2.default.filter(_lodash2.default.split(this.props.item.attrs.tags, ', '), function (tag) {
					return !!tag;
				});
			}
		}, {
			key: 'getBadges',
			value: function getBadges() {
				var badgesMap = {
					'limited edition': _react2.default.createElement(
						'span',
						{ key: 'limited', className: 'details__badge details__badge--limited' },
						'LIMITED EDITION'
					),
					'almost gone': _react2.default.createElement(
						'span',
						{ key: 'almost-gone', className: 'details__badge details__badge--almost-gone' },
						'ALMOST GONE'
					),
					'back in stock': _react2.default.createElement(
						'span',
						{ key: 'back-in-stock', className: 'details__badge details__badge--back-in-stock' },
						'BACK IN STOCK'
					)
				};
				var badges = _lodash2.default.map(this.getTags(), function (tag) {
					return badgesMap[tag];
				});
	
				return !_lodash2.default.isEmpty(badges) ? _react2.default.createElement(
					'div',
					{ className: 'details__badges' },
					badges
				) : null;
			}
		}, {
			key: 'getCurrentImage',
			value: function getCurrentImage() {
				if (this.props.item.images[this.state.currentImage - 1]) {
					return this.props.item.images[this.state.currentImage - 1].src;
				}
				return null;
			}
		}, {
			key: 'shouldShowError',
			value: function shouldShowError() {
				if (this.state.error) {
					return _react2.default.createElement(
						'div',
						{ className: 'details__error-message' },
						'Sorry, there was a problem adding this to your cart. Try again?'
					);
				}
				return null;
			}
		}, {
			key: 'nextImage',
			value: function nextImage() {
				if (this.state.currentImage === this.props.item.images.length) {
					this.setState({ currentImage: 1 });
				} else {
					this.setState({ currentImage: this.state.currentImage + 1 });
				}
			}
		}, {
			key: 'prevImage',
			value: function prevImage() {
				if (this.state.currentImage === 1) {
					this.setState({ currentImage: this.props.item.images.length });
				} else {
					this.setState({ currentImage: this.state.currentImage - 1 });
				}
			}
		}, {
			key: 'addToCart',
			value: function addToCart() {
				var _this2 = this;
	
				this.setState({ error: false });
				this.props.cart.createLineItemsFromVariants({ variant: this.props.item.selectedVariant, quantity: 1 }).then(function (newCart) {
					_this2.props.updateCart(newCart);
				}).catch(function (err) {
					_this2.setState({ error: true });
					console.error('There was a problem updating the cart. ' + err);
				});
			}
		}, {
			key: 'buyButton',
			value: function buyButton() {
				if (this.props.shopClosedUntilDate) {
					return _react2.default.createElement(
						'div',
						{ className: 'unavailable-message' },
						'Available ',
						this.props.shopClosedUntilDate
					);
				}
	
				return _react2.default.createElement(
					'button',
					{ className: 'button button--add-to-cart', onClick: this.addToCart },
					'Add to Cart'
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var item = this.props.item;
				var badges = this.getBadges();
				var isSoldOut = !item.selectedVariant.available;
				var classes = (0, _classnames2.default)('product', item.attrs.handle);
				var description = {
					__html: item.description
				};
	
				var price = void 0;
	
				if (item.selectedVariant.available) {
					price = (0, _getRoundedPrice2.default)(item.selectedVariant.price);
				} else {
					price = 'Sold out';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: classes },
					_react2.default.createElement(
						'div',
						{ className: 'product__contents' },
						_react2.default.createElement(
							'div',
							{ className: 'product__image__container' },
							_react2.default.createElement(_ImageWithLoader2.default, { src: this.getCurrentImage(), alt: item.title }),
							this.props.item.images.length > 1 && _react2.default.createElement(
								'div',
								{ className: 'product__image__navigation' },
								_react2.default.createElement(
									'svg',
									{ onClick: this.prevImage, viewBox: '0 0 40 40', title: 'Previous' },
									_react2.default.createElement('polygon', { points: '32.0214844,19.1591797 23,28.1799316 23,0 17,0 17,28.1796875 7.9794922,19.1591797 3.7363281,23.4013672 20,39.6660156 36.2636719,23.4013672 ' })
								),
								_react2.default.createElement(
									'svg',
									{ onClick: this.nextImage, viewBox: '0 0 40 40', title: 'Next' },
									_react2.default.createElement('polygon', { points: '32.0214844,19.1591797 23,28.1799316 23,0 17,0 17,28.1796875 7.9794922,19.1591797 3.7363281,23.4013672 20,39.6660156 36.2636719,23.4013672 ' })
								)
							),
							item.attrs.handle === 'mystery-kitty-sticker-packs' && _react2.default.createElement(
								'div',
								{ className: 'product__image__badge product__image__badge--mystery-kitties' },
								_react2.default.createElement(_Icons.Badge, null),
								_react2.default.createElement(
									'div',
									{ className: 'badge__text' },
									'3-Pack'
								)
							),
							_lodash2.default.includes(this.getTags(), 'new') && _react2.default.createElement(
								'div',
								{ className: 'product__image__badge' },
								_react2.default.createElement(_Icons.Badge, null),
								_react2.default.createElement(
									'div',
									{ className: 'badge__text' },
									'New'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'product__details' },
							_react2.default.createElement(
								'div',
								{ className: 'details__badges' },
								badges
							),
							_react2.default.createElement(
								'h3',
								{ className: 'details__title' },
								item.title
							),
							_react2.default.createElement(
								'div',
								{ className: 'details__price' },
								price
							),
							_react2.default.createElement('div', { className: 'details__description', dangerouslySetInnerHTML: description }),
							!isSoldOut && this.buyButton(),
							this.shouldShowError(),
							isSoldOut && _react2.default.createElement(
								'div',
								{ className: 'unavailable-message' },
								_react2.default.createElement(
									'p',
									null,
									'Tell us if you want more!',
									_react2.default.createElement('br', null),
									'Email ',
									_react2.default.createElement(
										'a',
										{ className: 'site-link', href: 'mailto:meow@tabbycats.club' },
										'meow@tabbycats.club'
									),
									'.'
								)
							)
						)
					)
				);
			}
		}]);
	
		return Product;
	}(_react2.default.Component);
	
	exports.default = Product;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(256);
	
	__webpack_require__(608);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(218);
	
	var _redux = __webpack_require__(90);
	
	var _reactRedux = __webpack_require__(22);
	
	var _reduxThunk = __webpack_require__(650);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxLogger = __webpack_require__(648);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _reduxSubscriber = __webpack_require__(649);
	
	var _reduxSubscriber2 = _interopRequireDefault(_reduxSubscriber);
	
	var _reducers = __webpack_require__(592);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _saveToStorage = __webpack_require__(257);
	
	var _saveToStorage2 = _interopRequireDefault(_saveToStorage);
	
	var _App = __webpack_require__(422);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// DEVELOPMENT ONLY
	
	var myStore = (0, _redux.createStore)(_reducers2.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), (0, _redux.applyMiddleware)(_reduxThunk2.default), (0, _redux.applyMiddleware)(_reduxLogger2.default)); // DEVELOPMENT ONLY
	
	
	var subscribe = (0, _reduxSubscriber2.default)(myStore);
	
	subscribe('lastVerification', _saveToStorage2.default.lastVerification);
	subscribe('allPets', _saveToStorage2.default.allPets);
	subscribe('activePet.shuffle', _saveToStorage2.default.activePet);
	subscribe('activePet.active.petType', _saveToStorage2.default.activePet);
	subscribe('collectedGoodies', _saveToStorage2.default.collectedGoodies);
	subscribe('activeGoodies', _saveToStorage2.default.activeGoodies);
	
	(0, _reactDom.render)(_react2.default.createElement(
		_reactRedux.Provider,
		{ store: myStore },
		_react2.default.createElement(_App2.default, null)
	), document.getElementById('root'));

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _constants = __webpack_require__(4);
	
	var _initialize = __webpack_require__(34);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = (0, _initialize.setActiveGoodies)();
	
	var activeGoodies = function activeGoodies() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
			case _constants.SET_ACTIVE_GOODY:
				return Object.assign({}, state, {
					active: Object.assign({}, state.active, _defineProperty({}, action.payload.type, action.payload.id))
				});
			case _constants.SET_ACTIVE_GOODIES_WITH_SHUFFLE:
				return Object.assign({}, state, {
					shuffle: action.payload.shuffle,
					active: action.payload.activeGoodies
				});
			case _constants.SET_SHUFFLE_GOODIES:
				return Object.assign({}, state, {
					shuffle: action.payload.shuffle
				});
			default:
				return state;
		}
	};
	
	exports.default = activeGoodies;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _initialize = __webpack_require__(34);
	
	var _constants = __webpack_require__(4);
	
	var initialState = (0, _initialize.setActivePet)();
	
	var activePet = function activePet() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
			case _constants.SET_ACTIVE_PET:
				return Object.assign({}, state, {
					active: Object.assign({}, state.active, action.payload.pet)
				});
			case _constants.SET_ACTIVE_PET_TYPE:
				return Object.assign({}, state, {
					active: Object.assign({}, state.active, {
						petType: action.payload.petType
					})
				});
			case _constants.SET_KITTEN:
				return Object.assign({}, state, {
					active: Object.assign({}, state.active, {
						kitten: action.payload.kitten
					})
				});
			case _constants.SET_SHUFFLE_PETS:
				return Object.assign({}, state, {
					shuffle: action.payload.isShuffle
				});
			default:
				return state;
		}
	};
	
	exports.default = activePet;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _initialize = __webpack_require__(34);
	
	var _constants = __webpack_require__(4);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = (0, _initialize.setAllPets)();
	
	var allPets = function allPets() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_ALL_PETS:
	      return [].concat(_toConsumableArray(action.payload.allPets));
	    default:
	      return state;
	  }
	};
	
	exports.default = allPets;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _initialize = __webpack_require__(34);
	
	var _constants = __webpack_require__(4);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = (0, _initialize.setCollectedGoodies)();
	
	var collectedGoodies = function collectedGoodies() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_NEW_GOODY:
	      return Object.assign({}, state, {
	        list: [].concat(_toConsumableArray(state.list), [action.payload.id]),
	        newItems: [].concat(_toConsumableArray(state.newItems), [action.payload.id])
	      });
	    case _constants.SET_COLLECTED_GOODIES:
	      return Object.assign({}, state, {
	        list: action.payload.collectedGoodies
	      });
	    case _constants.SET_COLLECTED_NEW_GOODIES:
	      return Object.assign({}, state, {
	        newItems: action.payload.collectedNewGoodies
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = collectedGoodies;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(90);
	
	var _visits = __webpack_require__(595);
	
	var _visits2 = _interopRequireDefault(_visits);
	
	var _lastVerification = __webpack_require__(593);
	
	var _lastVerification2 = _interopRequireDefault(_lastVerification);
	
	var _allPets = __webpack_require__(590);
	
	var _allPets2 = _interopRequireDefault(_allPets);
	
	var _activePet = __webpack_require__(589);
	
	var _activePet2 = _interopRequireDefault(_activePet);
	
	var _purchases = __webpack_require__(594);
	
	var _purchases2 = _interopRequireDefault(_purchases);
	
	var _collectedGoodies = __webpack_require__(591);
	
	var _collectedGoodies2 = _interopRequireDefault(_collectedGoodies);
	
	var _activeGoodies = __webpack_require__(588);
	
	var _activeGoodies2 = _interopRequireDefault(_activeGoodies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  visits: _visits2.default,
	  lastVerification: _lastVerification2.default,
	
	  allPets: _allPets2.default,
	  activePet: _activePet2.default,
	  purchases: _purchases2.default,
	
	  collectedGoodies: _collectedGoodies2.default,
	  activeGoodies: _activeGoodies2.default
	});

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _initialize = __webpack_require__(34);
	
	var _constants = __webpack_require__(4);
	
	var initialState = (0, _initialize.setLastVerification)();
	
	var lastVerification = function lastVerification() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_LAST_VERIFICATION_DATE:
	      return {
	        date: action.payload.date,
	        error: undefined
	      };
	    case _constants.SET_VERIFICATION_ERROR:
	      return Object.assign({}, state, {
	        error: action.payload.error
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = lastVerification;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _constants = __webpack_require__(4);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {};
	
	var purchases = function purchases() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
	
		switch (action.type) {
			case _constants.SET_PURCHASE_LOADING:
				return Object.assign({}, state, _defineProperty({}, action.payload.sku, {
					isLoading: action.payload.isLoading
				}));
			case _constants.SET_PURCHASE_SUCCESS:
				return Object.assign({}, state, _defineProperty({}, action.payload.sku, {
					success: true
				}));
			case _constants.SET_PURCHASE_FAIL:
				return Object.assign({}, state, _defineProperty({}, action.payload.sku, {}));
			case _constants.CLEAR_PURCHASES:
				return initialState;
			default:
				return state;
		}
	};
	
	exports.default = purchases;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _initialize = __webpack_require__(34);
	
	var _constants = __webpack_require__(4);
	
	var initialState = (0, _initialize.setVisits)();
	
	var visits = function visits() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_VISITS:
	      return action.payload.visits;
	    default:
	      return state;
	  }
	};
	
	exports.default = visits;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(22);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Pet = __webpack_require__(54);
	
	var _Pet2 = _interopRequireDefault(_Pet);
	
	var _GoodyBag = __webpack_require__(426);
	
	var _GoodyBag2 = _interopRequireDefault(_GoodyBag);
	
	var _PetPicker = __webpack_require__(433);
	
	var _PetPicker2 = _interopRequireDefault(_PetPicker);
	
	var _Snapshot = __webpack_require__(435);
	
	var _Snapshot2 = _interopRequireDefault(_Snapshot);
	
	var _ShopBox = __webpack_require__(434);
	
	var _ShopBox2 = _interopRequireDefault(_ShopBox);
	
	var _Background = __webpack_require__(249);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _getKitten = __webpack_require__(611);
	
	var _getKitten2 = _interopRequireDefault(_getKitten);
	
	var _activePet = __webpack_require__(52);
	
	var _googleApi = __webpack_require__(247);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Extension = function (_React$Component) {
		_inherits(Extension, _React$Component);
	
		function Extension() {
			_classCallCheck(this, Extension);
	
			return _possibleConstructorReturn(this, (Extension.__proto__ || Object.getPrototypeOf(Extension)).apply(this, arguments));
		}
	
		_createClass(Extension, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.shouldSetKitten();
				this.shouldCheckGooglePayments();
			}
		}, {
			key: 'shouldCheckGooglePayments',
			value: function shouldCheckGooglePayments() {
				this.props.updateInAppPurchaseData();
	
				// Local storage contains a verification timestamp that we
				// used to check google if the extension was loaded after
				// MINS_TO_VERIFY_GOOGLE (2) minutes. This is to prevent
				// people from cheating by "buying" pets using localstorage.
				// We are no longer using the timestamp.
	
				// const now = moment();
				// const then = moment(this.props.lastVerification.date);
				// const minsSinceLastCheck = now.diff(then, 'minutes');
	
				// if (
				// 	!this.props.lastVerification.date || // If there's no verification date
				// 	minsSinceLastCheck > MINS_TO_VERIFY_GOOGLE || // or we've surpassed the time to check again
				// 	minsSinceLastCheck < 0 || // or if it's in the future
				// 	this.props.allPets.length <= 1 || // or if the allPets store doesn't have more than the cat
				// 	this.props.lastVerification.error // or there was an API error.
				// ) {
				// 	this.props.updateInAppPurchaseData();
				// }
			}
		}, {
			key: 'shouldSetKitten',
			value: function shouldSetKitten() {
				var thisKitten = (0, _getKitten2.default)(this.props.pet);
				if (thisKitten) {
					this.props.setKitten(thisKitten);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_Background2.default,
					this.props.pet,
					_react2.default.createElement(_Pet2.default, this.props.pet),
					_react2.default.createElement(_ShopBox2.default, null),
					_react2.default.createElement(_GoodyBag2.default, null),
					_react2.default.createElement(_Snapshot2.default, null),
					_react2.default.createElement(_PetPicker2.default, null)
				);
			}
		}]);
	
		return Extension;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
		return {
			lastVerification: state.lastVerification,
			allPets: state.allPets,
			pet: Object.assign({}, state.activePet.active, {
				glasses: state.activeGoodies.active.glasses,
				hat: state.activeGoodies.active.hat,
				toy: state.activeGoodies.active.toy
			})
		};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			setKitten: function setKitten(kitten) {
				dispatch((0, _activePet.setKitten)(kitten));
			},
			updateInAppPurchaseData: function updateInAppPurchaseData() {
				dispatch((0, _googleApi.updateInAppPurchaseData)());
			}
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Extension);

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _reactScroll = __webpack_require__(625);
	
	var _reactScroll2 = _interopRequireDefault(_reactScroll);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _BasePage2 = __webpack_require__(25);
	
	var _BasePage3 = _interopRequireDefault(_BasePage2);
	
	var _Pet = __webpack_require__(54);
	
	var _Pet2 = _interopRequireDefault(_Pet);
	
	var _Background = __webpack_require__(249);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _Arrow = __webpack_require__(251);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _CatSnapshotFooter = __webpack_require__(576);
	
	var _CatSnapshotFooter2 = _interopRequireDefault(_CatSnapshotFooter);
	
	var _translateLegacyCat = __webpack_require__(620);
	
	var _getRandom = __webpack_require__(33);
	
	var _getRandom2 = _interopRequireDefault(_getRandom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // TODO hook this up to more pets
	
	var scroll = _reactScroll2.default.animateScroll;
	
	var CatSnapshot = function (_BasePage) {
		_inherits(CatSnapshot, _BasePage);
	
		function CatSnapshot() {
			_classCallCheck(this, CatSnapshot);
	
			return _possibleConstructorReturn(this, (CatSnapshot.__proto__ || Object.getPrototypeOf(CatSnapshot)).apply(this, arguments));
		}
	
		_createClass(CatSnapshot, [{
			key: 'animateScroll',
			value: function animateScroll() {
				scroll.scrollToBottom();
			}
		}, {
			key: 'getClassNames',
			value: function getClassNames() {
				var classes = ['cat-snapshot', 'bg--' + this.props.bgColor, this.props.name.special];
	
				return (0, _classnames2.default)(classes, {
					'cat-snapshot--screenshot': _lodash2.default.get(this.props, 'location.pathname', '').indexOf('screenshot') > -1
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: this.getClassNames() },
					_react2.default.createElement(
						_Background2.default,
						this.props,
						_react2.default.createElement(_Pet2.default, this.props),
						_react2.default.createElement(
							'div',
							{ className: 'server-footer-nudge alt-color--lighter' },
							_react2.default.createElement(
								'div',
								{ className: 'server-footer-nudge__headline' },
								'Found with ',
								_react2.default.createElement(
									_reactRouterDom.Link,
									{ className: 'site-link', to: '/' },
									'Tabby Cat'
								),
								_react2.default.createElement(
									'span',
									{ onClick: this.animateScroll },
									_react2.default.createElement(_Arrow2.default, null)
								)
							)
						)
					),
					_react2.default.createElement(_CatSnapshotFooter2.default, null)
				);
			}
		}]);
	
		return CatSnapshot;
	}(_BasePage3.default);
	
	if (window.snapshotCat) {
		CatSnapshot.defaultProps = (0, _translateLegacyCat.translateLegacyCat)(window.snapshotCat);
	} else {
		CatSnapshot.defaultProps = _getRandom2.default.cat();
	}
	
	exports.default = CatSnapshot;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _BasePage2 = __webpack_require__(25);
	
	var _BasePage3 = _interopRequireDefault(_BasePage2);
	
	var _SectionFirst = __webpack_require__(579);
	
	var _SectionFirst2 = _interopRequireDefault(_SectionFirst);
	
	var _Section = __webpack_require__(578);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _SectionLast = __webpack_require__(580);
	
	var _SectionLast2 = _interopRequireDefault(_SectionLast);
	
	var _Footer = __webpack_require__(84);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _getRandom = __webpack_require__(33);
	
	var _getRandom2 = _interopRequireDefault(_getRandom);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var petTypeForSection = _constants.PETS[_lodash2.default.random(1, _constants.PETS.length - 1)];
	
	var Site = function (_BasePage) {
		_inherits(Site, _BasePage);
	
		function Site() {
			_classCallCheck(this, Site);
	
			var _this = _possibleConstructorReturn(this, (Site.__proto__ || Object.getPrototypeOf(Site)).call(this));
	
			_this.state = {
				meet: {
					title: 'Meet your first Tabby.',
					desc: 'Tabby Cat is a browser extension that gives you a new cat with a special name in every new tab.',
					bgColor: 'mauve',
					pet: {
						petType: {
							sku: 'cat_tabbycat',
							type: 'cat',
							name: 'Cat'
						},
						name: _getRandom2.default.name(),
						color: 'white',
						body: _getRandom2.default.body(),
						head: _getRandom2.default.head()
					}
				},
	
				pet: {
					title: 'You can pet the cats.',
					desc: 'Some cats love pets and others don’t. See what Professor Burp thinks.',
					bgColor: 'red',
					pet: {
						petType: {
							sku: 'cat_tabbycat',
							type: 'cat',
							name: 'Cat'
						},
						name: {
							full: 'Professor Burp'
						},
						color: 'black',
						body: _getRandom2.default.body(),
						head: _getRandom2.default.head(),
						likesPets: 'likes'
					}
				},
	
				goodies: {
					title: 'Collect cool goodies.',
					desc: 'Over time, your Tabby Cats will bring goodies that you can use to dress them up, and more...',
					bgColor: 'teal',
					pet: {
						petType: {
							sku: 'cat_tabbycat',
							type: 'cat',
							name: 'Cat'
						},
						name: _getRandom2.default.name(),
						color: 'gray',
						body: 3,
						head: 1,
						likesPets: _getRandom2.default.likesPets(),
						hat: 'hat-PartyHat',
						toy: 'toy-Pizza'
					}
				},
	
				kittens: {
					title: 'Find little kittens.',
					desc: 'Some combinations of goodies lure out special little baby cats. Find them all!',
					bgColor: 'yellow',
					pet: {
						petType: {
							sku: 'cat_tabbycat',
							type: 'cat',
							name: 'Cat'
						},
						name: _getRandom2.default.name(),
						color: 'white',
						body: _getRandom2.default.body(),
						head: _getRandom2.default.head(),
						likesPets: _getRandom2.default.likesPets(),
						toy: 'Yarn',
						kitten: 'Frisky'
					}
				},
	
				pets: {
					title: 'Get new pets!',
					desc: 'Now all furry friends like Dogs, Birds, Turtles, and more are FREE.',
					bgColor: 'purple',
					pet: Object.assign({
						petType: petTypeForSection
					}, _getRandom2.default.petOfTypeForInitialize(petTypeForSection.type), {
						name: petTypeForSection.displayName,
						likesPets: 'likes'
					})
				},
	
				snapshots: {
					title: 'Take snapshots.',
					desc: 'Share your favorite cats and save them forever and ever.',
					bgColor: 'teal'
				},
	
				work: {
					title: 'Bring cats to work, finally.',
					desc: 'Guaranteed to increase productivity by no percent at all.',
					bgColor: 'light-purple',
					pet: {
						petType: {
							sku: 'cat_tabbycat',
							type: 'cat',
							name: 'Cat'
						},
						name: _getRandom2.default.name(),
						color: 'gray',
						body: _getRandom2.default.body(),
						head: _getRandom2.default.head(),
						likesPets: _getRandom2.default.likesPets(),
						toy: 'toy-Coffee',
						glasses: 'glasses-Raybans'
					}
				}
			};
			return _this;
		}
	
		_createClass(Site, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'page--home' },
					_react2.default.createElement(_SectionFirst2.default, null),
					_react2.default.createElement(_Section2.default, { contents: this.state.meet }),
					_react2.default.createElement(_Section2.default, { contents: this.state.pet }),
					_react2.default.createElement(_Section2.default, { contents: this.state.goodies }),
					_react2.default.createElement(_Section2.default, { contents: this.state.kittens }),
					_react2.default.createElement(_Section2.default, { contents: this.state.pets }),
					_react2.default.createElement(_Section2.default, { contents: this.state.snapshots }),
					_react2.default.createElement(_Section2.default, { contents: this.state.work }),
					_react2.default.createElement(_SectionLast2.default, null),
					_react2.default.createElement(_Footer2.default, { bgColor: 'bg--purple' })
				);
			}
		}]);
	
		return Site;
	}(_BasePage3.default);
	
	exports.default = Site;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _BasePage2 = __webpack_require__(25);
	
	var _BasePage3 = _interopRequireDefault(_BasePage2);
	
	var _Navigation = __webpack_require__(23);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Footer = __webpack_require__(84);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotFound = function (_BasePage) {
		_inherits(NotFound, _BasePage);
	
		function NotFound() {
			_classCallCheck(this, NotFound);
	
			return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
		}
	
		_createClass(NotFound, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'section section--centered section--full-height bg--purple' },
						_react2.default.createElement(_Navigation2.default, null),
						_react2.default.createElement(
							'h1',
							null,
							'Oops.'
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'p',
							null,
							'We can\u2019t find that page,',
							_react2.default.createElement('br', null),
							'at least not right meow.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								_reactRouterDom.Link,
								{ className: 'site-link', to: '/' },
								'Go to Tabby Home'
							)
						)
					),
					_react2.default.createElement(_Footer2.default, { bgColor: 'bg--purple' })
				);
			}
		}]);
	
		return NotFound;
	}(_BasePage3.default);
	
	exports.default = NotFound;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BasePage2 = __webpack_require__(25);
	
	var _BasePage3 = _interopRequireDefault(_BasePage2);
	
	var _Navigation = __webpack_require__(23);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _ShopFooter = __webpack_require__(55);
	
	var _ShopFooter2 = _interopRequireDefault(_ShopFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShopTOS = function (_BasePage) {
		_inherits(ShopTOS, _BasePage);
	
		function ShopTOS() {
			_classCallCheck(this, ShopTOS);
	
			return _possibleConstructorReturn(this, (ShopTOS.__proto__ || Object.getPrototypeOf(ShopTOS)).apply(this, arguments));
		}
	
		_createClass(ShopTOS, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'section section--operations section--operations--faq' },
					_react2.default.createElement(_Navigation2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'section__intro' },
						_react2.default.createElement(
							'h2',
							null,
							'Frequently Asked Questions'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'section__contents' },
						_react2.default.createElement(
							'h3',
							null,
							'What are pets?'
						),
						_react2.default.createElement(
							'p',
							null,
							'Tabby Cat made some friends! Now you can purchase other animals to keep alongside the original Tabby Cat. Every pet you buy is yours to keep, dress up, pet, and love forever. When you have more than one pet, you can shuffle them so that each new tab is a surprise. Just like the original Tabby Cats, each pet has lots of different names, colors, and behaviors. Some even unlock new goodies...!'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Will Tabby Cat always be free?'
						),
						_react2.default.createElement(
							'p',
							null,
							'Yes! The original Tabby Cat will be free forever and you will continue to receive new goodies over time.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'How do payments work?'
						),
						_react2.default.createElement(
							'p',
							null,
							'Payments are handled through Google Wallet and managed through Google\u2019s In-App Payments platform, so your data is secure. Tabby Cat only sees what you\u2019ve purchased. When you\u2019re logged into Google Chrome your pets will sync across all of your computers. If you\u2019re not sure how to log into Google Chrome, follow ',
							_react2.default.createElement(
								'a',
								{ className: 'external-link', href: 'https://support.google.com/chrome/answer/185277?co=GENIE.Platform%3DDesktop&hl=en', target: '_blank', rel: 'noopener noreferrer' },
								'these instructions on Google\u2019s Help Center'
							),
							'.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Where does my money go?'
						),
						_react2.default.createElement(
							'p',
							null,
							'Every purchase you make goes towards the creation of more pets and goodies. New pets will be released regularly, and if you have ideas for pets you\u2019d like to see you can send them to ',
							_react2.default.createElement(
								'a',
								{ className: 'external-link', href: 'mailto:meow@tabbycats.club' },
								'meow@tabbycats.club'
							),
							'!'
						)
					),
					_react2.default.createElement(_ShopFooter2.default, null)
				);
			}
		}]);
	
		return ShopTOS;
	}(_BasePage3.default);
	
	exports.default = ShopTOS;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BasePage2 = __webpack_require__(25);
	
	var _BasePage3 = _interopRequireDefault(_BasePage2);
	
	var _Navigation = __webpack_require__(23);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Footer = __webpack_require__(84);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrivacyPolicy = function (_BasePage) {
		_inherits(PrivacyPolicy, _BasePage);
	
		function PrivacyPolicy() {
			_classCallCheck(this, PrivacyPolicy);
	
			return _possibleConstructorReturn(this, (PrivacyPolicy.__proto__ || Object.getPrototypeOf(PrivacyPolicy)).apply(this, arguments));
		}
	
		_createClass(PrivacyPolicy, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'section section--operations' },
					_react2.default.createElement(_Navigation2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'section__intro' },
						_react2.default.createElement(
							'h2',
							null,
							'Tabby Cat Extension',
							_react2.default.createElement('br', null),
							'Terms of Use & Privacy Policy'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'section__contents' },
						_react2.default.createElement(
							'h3',
							null,
							'Overview'
						),
						_react2.default.createElement(
							'p',
							null,
							'The Tabby Cat chrome extension is operated by Tabby Cat. Throughout this site, the terms \u201Cwe\u201D, \u201Cus\u201D and \u201Cour\u201D refer to Tabby Cat. Tabby Cat offers the Chrome extension and this website, including all information, tools and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							'By visiting our extension and/ or purchasing something from us, you engage in our \u201CService\u201D and agree to be bound by the following terms and conditions (\u201CTerms of Service\u201D, \u201CTerms\u201D), including those additional terms and conditions and policies referenced herein. These Terms of Service apply  to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/ or contributors of content.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							'Please read these Terms of Service carefully before accessing or using our extension. By accessing or using any part of the extension, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the extension or use any services. If these Terms of Service are considered an offer, acceptance is expressly limited to these Terms of Service.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							'Any new features or tools which are added to the current store shall also be subject to the Terms of Service. You can review the most current version of the Terms of Service at any time on this page. We reserve the right to update, change or replace any part of these Terms of Service by posting updates and/or changes to our website. It is your responsibility to check this page periodically for changes. Your continued use of or access to the website following the posting of any changes constitutes acceptance of those changes.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							'Our extension store is hosted by Google. They provide us with the online e-commerce platform that allows us to sell our products and services to you.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 1 - Online Store Terms'
						),
						_react2.default.createElement(
							'p',
							null,
							'By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site. You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws). You must not transmit any worms or viruses or any code of a destructive nature. A breach or violation of any of the Terms will result in an immediate termination of your Services.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 2 - General Conditions'
						),
						_react2.default.createElement(
							'p',
							null,
							'We reserve the right to refuse service to anyone for any reason at any time. You understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks. You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us. The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 3 - Accuracy, Completeness and Timeliness of Information'
						),
						_react2.default.createElement(
							'p',
							null,
							'We are not responsible if information made available on this site is not accurate, complete or current. The material on this site is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on this site is at your own risk. This site may contain certain historical information. Historical information, necessarily, is not current and is provided for your reference only. We reserve the right to modify the contents of this site at any time, but we have no obligation to update any information on our site. You agree that it is your responsibility to monitor changes to our site.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 4 - Modifications to the Service and Prices'
						),
						_react2.default.createElement(
							'p',
							null,
							'Prices for our products are subject to change without notice. We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time. We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance of the Service.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 5 - Products or Services'
						),
						_react2.default.createElement(
							'p',
							null,
							'Certain products or services may be available exclusively online through the extension. These products or services may have limited quantities and are subject to return or exchange only according to our Return Policy. We have made every effort to display as accurately as possible the colors and images of our products that appear at the store. We cannot guarantee that your computer monitor\u2019s display of any color will be accurate. We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region or jurisdiction. We may exercise this right on a case-by-case basis. We reserve the right to limit the quantities of any products or services that we offer. All descriptions of products or product pricing are subject to change at any time without notice, at the sole discretion of us. We reserve the right to discontinue any product at any time. Any offer for any product or service made on this site is void where prohibited. We do not warrant that the quality of any products, services, information, or other material purchased or obtained by you will meet your expectations, or that any errors in the Service will be corrected.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 6 - Billing and Account Information'
						),
						_react2.default.createElement(
							'p',
							null,
							'We do not store any billing or account information for purchases made inside of the extension. These are handled through Google\u2019s In-App Payments using a Payments Merchant Account. By purchasing items through Google\u2019s In-App Payments mechanism you agree to Google\u2019s privacy policy.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 7 - Optional Tools'
						),
						_react2.default.createElement(
							'p',
							null,
							'We may provide you with access to third-party tools over which we neither monitor nor have any control nor input. You acknowledge and agree that we provide access to such tools \u201Das is\u201D and \u201Cas available\u201D without any warranties, representations or conditions of any kind and without any endorsement. We shall have no liability whatsoever arising from or relating to your use of optional third-party tools. Any use by you of optional tools offered through the site is entirely at your own risk and discretion and you should ensure that you are familiar with and approve of the terms on which tools are provided by the relevant third-party provider(s). We may also, in the future, offer new services and/or features through the website (including, the release of new tools and resources). Such new features and/or services shall also be subject to these Terms of Service.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 8 - Third-Party Links'
						),
						_react2.default.createElement(
							'p',
							null,
							'Certain content, products and services available via our Service may include materials from third-parties. Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third-parties. We are not liable for any harm or damages related to the purchase or use of goods, services, resources, content, or any other transactions made in connection with any third-party websites. Please review carefully the third-party\u2019s policies and practices and make sure you understand them before you engage in any transaction. Complaints, claims, concerns, or questions regarding third-party products should be directed to the third-party.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 9 - User Comments, Feedback and Other Submissions'
						),
						_react2.default.createElement(
							'p',
							null,
							'If, at our request, you send certain specific submissions (for example contest entries) or without a request from us you send creative ideas, suggestions, proposals, plans, or other materials, whether online, by email, by postal mail, or otherwise (collectively, \u2018comments\u2019), you agree that we may, at any time, without restriction, edit, copy, publish, distribute, translate and otherwise use in any medium any comments that you forward to us. We are and shall be under no obligation (1) to maintain any comments in confidence; (2) to pay compensation for any comments; or (3) to respond to any comments. We may, but have no obligation to, monitor, edit or remove content that we determine in our sole discretion are unlawful, offensive, threatening, libelous, defamatory, pornographic, obscene or otherwise objectionable or violates any party\u2019s intellectual property or these Terms of Service. You agree that your comments will not violate any right of any third-party, including copyright, trademark, privacy, personality or other personal or proprietary right. You further agree that your comments will not contain libelous or otherwise unlawful, abusive or obscene material, or contain any computer virus or other malware that could in any way affect the operation of the Service or any related website. You may not use a false e-mail address, pretend to be someone other than yourself, or otherwise mislead us or third-parties as to the origin of any comments. You are solely responsible for any comments you make and their accuracy. We take no responsibility and assume no liability for any comments posted by you or any third-party.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 10 - Errors, Inaccuracies and Omissions'
						),
						_react2.default.createElement(
							'p',
							null,
							'Occasionally there may be information on our site or in the Service that contains typographical errors, inaccuracies or omissions that may relate to product descriptions, pricing, promotions, offers, product shipping charges, transit times and availability. We reserve the right to correct any errors, inaccuracies or omissions, and to change or update information or cancel orders if any information in the Service or on any related website is inaccurate at any time without prior notice (including after you have submitted your order). We undertake no obligation to update, amend or clarify information in the Service or on any related website, including without limitation, pricing information, except as required by law. No specified update or refresh date applied in the Service or on any related website, should be taken to indicate that all information in the Service or on any related website has been modified or updated.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 11 - Prohibited Uses'
						),
						_react2.default.createElement(
							'p',
							null,
							'In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the site or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Service or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 12 - Disclaimer of Warranties; Limitation of Liability'
						),
						_react2.default.createElement(
							'p',
							null,
							'We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure or error-free. We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable. You agree that from time to time we may remove the service for indefinite periods of time or cancel the service at any time, without notice to you. You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are (except as expressly stated by us) provided \u2018as is\u2019 and \u2018as available\u2019 for your use, without any representation, warranties or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement. In no case shall Tabby Cat, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or the limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 13 - Indemnification'
						),
						_react2.default.createElement(
							'p',
							null,
							'You agree to indemnify, defend and hold harmless Tabby Cat and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns and employees, harmless from any claim or demand, including reasonable attorneys\u2019 fees, made by any third-party due to or arising out of your breach of these Terms of Service or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 14 - Severability'
						),
						_react2.default.createElement(
							'p',
							null,
							'In the event that any provision of these Terms of Service is determined to be unlawful, void or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of any other remaining provisions.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 15 - Termination'
						),
						_react2.default.createElement(
							'p',
							null,
							'The obligations and liabilities of the parties incurred prior to the termination date shall survive the termination of this agreement for all purposes. These Terms of Service are effective unless and until terminated by either you or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or when you cease using our site. If in our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time without notice and you will remain liable for all amounts due up to and including the date of termination; and/or accordingly may deny you access to our Services (or any part thereof).'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 16 - Entire Agreement'
						),
						_react2.default.createElement(
							'p',
							null,
							'The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision. These Terms of Service and any policies or operating rules posted by us on this site or in respect to The Service constitutes the entire agreement and understanding between you and us and govern your use of the Service, superseding any prior or contemporaneous agreements, communications and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service). Any ambiguities in the interpretation of these Terms of Service shall not be construed against the drafting party.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 17 - Governing Law'
						),
						_react2.default.createElement(
							'p',
							null,
							'These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of 1159 Glen Ave Berkeley California US 94708.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 18 - Changes to Terms of Service'
						),
						_react2.default.createElement(
							'p',
							null,
							'You can review the most current version of the Terms of Service at any time at this page. We reserve the right, at our sole discretion, to update, change or replace any part of these Terms of Service by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to our website or the Service following the posting of any changes to these Terms of Service constitutes acceptance of those changes.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 19 - Contact Information'
						),
						_react2.default.createElement(
							'p',
							null,
							'Questions about the Terms of Service should be sent to us at ',
							_react2.default.createElement(
								'a',
								{ href: 'mailto:meow@tabbycats.club', className: 'site-link' },
								'meow@tabbycats.club'
							),
							'.'
						)
					),
					_react2.default.createElement(_Footer2.default, { bgColor: 'bg--purple' })
				);
			}
		}]);
	
		return PrivacyPolicy;
	}(_BasePage3.default);
	
	exports.default = PrivacyPolicy;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BasePage2 = __webpack_require__(25);
	
	var _BasePage3 = _interopRequireDefault(_BasePage2);
	
	var _Navigation = __webpack_require__(23);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _ShopFooter = __webpack_require__(55);
	
	var _ShopFooter2 = _interopRequireDefault(_ShopFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShopPrivacyPolicy = function (_BasePage) {
		_inherits(ShopPrivacyPolicy, _BasePage);
	
		function ShopPrivacyPolicy() {
			_classCallCheck(this, ShopPrivacyPolicy);
	
			return _possibleConstructorReturn(this, (ShopPrivacyPolicy.__proto__ || Object.getPrototypeOf(ShopPrivacyPolicy)).apply(this, arguments));
		}
	
		_createClass(ShopPrivacyPolicy, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'section section--operations section--operations--shop' },
					_react2.default.createElement(_Navigation2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'section__intro' },
						_react2.default.createElement(
							'h2',
							null,
							'Tabby Cat Shop',
							_react2.default.createElement('br', null),
							'Privacy Statement'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'section__contents' },
						_react2.default.createElement(
							'h3',
							null,
							'Section 1 - What do we do with your information?'
						),
						_react2.default.createElement(
							'p',
							null,
							'When you purchase something from our store, as part of the buying and selling process, we collect the personal information you give us such as your name, address and email address. When you browse our store, we also automatically receive your computer\u2019s internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system. With your permission, we may send you emails about our store, new products and other updates.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 2 - Consent'
						),
						_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement(
								'b',
								null,
								'How do you get my consent?'
							),
							_react2.default.createElement('br', null),
							'When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only. If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'b',
								null,
								'How do I withdraw my consent?'
							),
							_react2.default.createElement('br', null),
							'If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at anytime, by contacting us at ',
							_react2.default.createElement(
								'a',
								{ href: 'mailto:meow@tabbycats.club', className: 'site-link' },
								'meow@tabbycats.club'
							),
							'.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 3 - Disclosure'
						),
						_react2.default.createElement(
							'p',
							null,
							'We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 4 - Shopify'
						),
						_react2.default.createElement(
							'p',
							null,
							'Our store is hosted on Shopify Inc. They provide us with the online e-commerce platform that allows us to sell our products and services to you. Your data is stored through Shopify\u2019s data storage, databases and the general Shopify application. They store your data on a secure server behind a firewall.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'b',
								null,
								'Payment:'
							),
							_react2.default.createElement('br', null),
							'If you choose a direct payment gateway to complete your purchase, then Shopify stores your credit card data. It is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS). Your purchase transaction data is stored only as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is deleted. All direct payment gateways adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers. For more insight, you may also want to read Shopify\u2019s ',
							_react2.default.createElement(
								'a',
								{ className: 'site-link', href: 'https://www.shopify.com/legal/terms' },
								'Terms of Service'
							),
							' or ',
							_react2.default.createElement(
								'a',
								{ className: 'site-link', href: 'https://www.shopify.com/legal/privacy' },
								'Privacy Statement'
							),
							'.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 5 - Third-Party Services'
						),
						_react2.default.createElement(
							'p',
							null,
							'In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us. However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions. For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers. In particular, remember that certain providers may be located in or have facilities that are located a different jurisdiction than either you or us. So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located. As an example, if you are located in Canada and your transaction is processed by a payment gateway located in the United States, then your personal information used in completing that transaction may be subject to disclosure under United States legislation, including the Patriot Act. Once you leave our store\u2019s website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website\u2019s Terms of Service.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'b',
								null,
								'Links:'
							),
							_react2.default.createElement('br', null),
							'When you click on links on our store, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 6 - Security'
						),
						_react2.default.createElement(
							'p',
							null,
							'To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed. If you provide us with your credit card information, the information is encrypted using secure socket layer technology (SSL) and stored with a AES-256 encryption.  Although no method of transmission over the Internet or electronic storage is 100% secure, we follow all PCI-DSS requirements and implement additional generally accepted industry standards.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 7 - Cookies'
						),
						_react2.default.createElement(
							'p',
							null,
							'Here is a list of cookies that we use. We\u2019ve listed them here so you that you can choose if you want to opt-out of cookies or not.'
						),
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								null,
								'_session_id, unique token, sessional, Allows Shopify to store information about your session (referrer, landing page, etc).'
							),
							_react2.default.createElement(
								'li',
								null,
								'_shopify_visit, no data held, Persistent for 30 minutes from the last visit, Used by our website provider\u2019s internal stats tracker to record the number of visits.'
							),
							_react2.default.createElement(
								'li',
								null,
								'_shopify_uniq, no data held, expires midnight (relative to the visitor) of the next day, Counts the number of visits to a store by a single customer.'
							),
							_react2.default.createElement(
								'li',
								null,
								'cart, unique token, persistent for 2 weeks, Stores information about the contents of your cart.'
							),
							_react2.default.createElement(
								'li',
								null,
								'_secure_session_id, unique token, sessional.'
							),
							_react2.default.createElement(
								'li',
								null,
								'storefront_digest, unique token, indefinite If the shop has a password, this is used to determine if the current visitor has access.'
							)
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 8 - Age of Consent'
						),
						_react2.default.createElement(
							'p',
							null,
							'By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 9 - Changes to this Privacy Policy'
						),
						_react2.default.createElement(
							'p',
							null,
							'We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it. If our store is acquired or merged with another company, your information may be transferred to the new owners so that we may continue to sell products to you.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Questions and Contact Information'
						),
						_react2.default.createElement(
							'p',
							null,
							'If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at ',
							_react2.default.createElement(
								'a',
								{ href: 'mailto:meow@tabbycats.club', className: 'site-link' },
								'meow@tabbycats.club'
							),
							'.'
						)
					),
					_react2.default.createElement(_ShopFooter2.default, null)
				);
			}
		}]);
	
		return ShopPrivacyPolicy;
	}(_BasePage3.default);
	
	exports.default = ShopPrivacyPolicy;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BasePage2 = __webpack_require__(25);
	
	var _BasePage3 = _interopRequireDefault(_BasePage2);
	
	var _Navigation = __webpack_require__(23);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _ShopFooter = __webpack_require__(55);
	
	var _ShopFooter2 = _interopRequireDefault(_ShopFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShopTOS = function (_BasePage) {
		_inherits(ShopTOS, _BasePage);
	
		function ShopTOS() {
			_classCallCheck(this, ShopTOS);
	
			return _possibleConstructorReturn(this, (ShopTOS.__proto__ || Object.getPrototypeOf(ShopTOS)).apply(this, arguments));
		}
	
		_createClass(ShopTOS, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'section section--operations section--operations--shop' },
					_react2.default.createElement(_Navigation2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'section__intro' },
						_react2.default.createElement(
							'h2',
							null,
							'Tabby Cat Shop',
							_react2.default.createElement('br', null),
							'Terms of Service'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'section__contents' },
						_react2.default.createElement(
							'h3',
							null,
							'Overview'
						),
						_react2.default.createElement(
							'p',
							null,
							'This website is operated by Tabby Cat. Throughout the site, the terms \u201Cwe\u201D, \u201Cus\u201D and \u201Cour\u201D refer to Tabby Cat. Tabby Cat offers this website, including all information, tools and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							'By visiting our site and/ or purchasing something from us, you engage in our \u201CService\u201D and agree to be bound by the following terms and conditions (\u201CTerms of Service\u201D, \u201CTerms\u201D), including those additional terms and conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply  to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/ or contributors of content.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							'Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any services. If these Terms of Service are considered an offer, acceptance is expressly limited to these Terms of Service.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							'Any new features or tools which are added to the current store shall also be subject to the Terms of Service. You can review the most current version of the Terms of Service at any time on this page. We reserve the right to update, change or replace any part of these Terms of Service by posting updates and/or changes to our website. It is your responsibility to check this page periodically for changes. Your continued use of or access to the website following the posting of any changes constitutes acceptance of those changes.',
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							'Our store is hosted on Shopify Inc. They provide us with the online e-commerce platform that allows us to sell our products and services to you.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 1 - Online Store Terms'
						),
						_react2.default.createElement(
							'p',
							null,
							'By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site. You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws). You must not transmit any worms or viruses or any code of a destructive nature. A breach or violation of any of the Terms will result in an immediate termination of your Services.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 2 - General Conditions'
						),
						_react2.default.createElement(
							'p',
							null,
							'We reserve the right to refuse service to anyone for any reason at any time. You understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks. You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us. The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 3 - Accuracy, Completeness and Timeliness of Information'
						),
						_react2.default.createElement(
							'p',
							null,
							'We are not responsible if information made available on this site is not accurate, complete or current. The material on this site is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on this site is at your own risk. This site may contain certain historical information. Historical information, necessarily, is not current and is provided for your reference only. We reserve the right to modify the contents of this site at any time, but we have no obligation to update any information on our site. You agree that it is your responsibility to monitor changes to our site.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 4 - Modifications to the Service and Prices'
						),
						_react2.default.createElement(
							'p',
							null,
							'Prices for our products are subject to change without notice. We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time. We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance of the Service.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 5 - Products or Services'
						),
						_react2.default.createElement(
							'p',
							null,
							'Certain products or services may be available exclusively online through the website. These products or services may have limited quantities and are subject to return or exchange only according to our Return Policy. We have made every effort to display as accurately as possible the colors and images of our products that appear at the store. We cannot guarantee that your computer monitor\u2019s display of any color will be accurate. We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region or jurisdiction. We may exercise this right on a case-by-case basis. We reserve the right to limit the quantities of any products or services that we offer. All descriptions of products or product pricing are subject to change at anytime without notice, at the sole discretion of us. We reserve the right to discontinue any product at any time. Any offer for any product or service made on this site is void where prohibited. We do not warrant that the quality of any products, services, information, or other material purchased or obtained by you will meet your expectations, or that any errors in the Service will be corrected.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 6 - Accuracy of Billing and Account Information'
						),
						_react2.default.createElement(
							'p',
							null,
							'We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event that we make a change to or cancel an order, we may attempt to notify you by contacting the e-mail and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers or distributors. You agree to provide current, complete and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed. For more detail, please review our Returns Policy.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 7 - Optional Tools'
						),
						_react2.default.createElement(
							'p',
							null,
							'We may provide you with access to third-party tools over which we neither monitor nor have any control nor input. You acknowledge and agree that we provide access to such tools \u201Das is\u201D and \u201Cas available\u201D without any warranties, representations or conditions of any kind and without any endorsement. We shall have no liability whatsoever arising from or relating to your use of optional third-party tools. Any use by you of optional tools offered through the site is entirely at your own risk and discretion and you should ensure that you are familiar with and approve of the terms on which tools are provided by the relevant third-party provider(s). We may also, in the future, offer new services and/or features through the website (including, the release of new tools and resources). Such new features and/or services shall also be subject to these Terms of Service.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 8 - Third-Party Links'
						),
						_react2.default.createElement(
							'p',
							null,
							'Certain content, products and services available via our Service may include materials from third-parties. Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third-parties. We are not liable for any harm or damages related to the purchase or use of goods, services, resources, content, or any other transactions made in connection with any third-party websites. Please review carefully the third-party\u2019s policies and practices and make sure you understand them before you engage in any transaction. Complaints, claims, concerns, or questions regarding third-party products should be directed to the third-party.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 9 - User Comments, Feedback and Other Submissions'
						),
						_react2.default.createElement(
							'p',
							null,
							'If, at our request, you send certain specific submissions (for example contest entries) or without a request from us you send creative ideas, suggestions, proposals, plans, or other materials, whether online, by email, by postal mail, or otherwise (collectively, \u2018comments\u2019), you agree that we may, at any time, without restriction, edit, copy, publish, distribute, translate and otherwise use in any medium any comments that you forward to us. We are and shall be under no obligation (1) to maintain any comments in confidence; (2) to pay compensation for any comments; or (3) to respond to any comments. We may, but have no obligation to, monitor, edit or remove content that we determine in our sole discretion are unlawful, offensive, threatening, libelous, defamatory, pornographic, obscene or otherwise objectionable or violates any party\u2019s intellectual property or these Terms of Service. You agree that your comments will not violate any right of any third-party, including copyright, trademark, privacy, personality or other personal or proprietary right. You further agree that your comments will not contain libelous or otherwise unlawful, abusive or obscene material, or contain any computer virus or other malware that could in any way affect the operation of the Service or any related website. You may not use a false e-mail address, pretend to be someone other than yourself, or otherwise mislead us or third-parties as to the origin of any comments. You are solely responsible for any comments you make and their accuracy. We take no responsibility and assume no liability for any comments posted by you or any third-party.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 10 - Personal Information'
						),
						_react2.default.createElement(
							'p',
							null,
							'Your submission of personal information through the store is governed by our Privacy Policy. To view our Privacy Policy.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 11 - Errors, Inaccuracies and Omissions'
						),
						_react2.default.createElement(
							'p',
							null,
							'Occasionally there may be information on our site or in the Service that contains typographical errors, inaccuracies or omissions that may relate to product descriptions, pricing, promotions, offers, product shipping charges, transit times and availability. We reserve the right to correct any errors, inaccuracies or omissions, and to change or update information or cancel orders if any information in the Service or on any related website is inaccurate at any time without prior notice (including after you have submitted your order). We undertake no obligation to update, amend or clarify information in the Service or on any related website, including without limitation, pricing information, except as required by law. No specified update or refresh date applied in the Service or on any related website, should be taken to indicate that all information in the Service or on any related website has been modified or updated.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 12 - Prohibited Uses'
						),
						_react2.default.createElement(
							'p',
							null,
							'In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the site or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Service or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 13 - Disclaimer of Warranties; Limitation of Liability'
						),
						_react2.default.createElement(
							'p',
							null,
							'We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure or error-free. We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable. You agree that from time to time we may remove the service for indefinite periods of time or cancel the service at any time, without notice to you. You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are (except as expressly stated by us) provided \u2018as is\u2019 and \u2018as available\u2019 for your use, without any representation, warranties or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement. In no case shall Tabby Cat, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or the limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 14 - Indemnification'
						),
						_react2.default.createElement(
							'p',
							null,
							'You agree to indemnify, defend and hold harmless Tabby Cat and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns and employees, harmless from any claim or demand, including reasonable attorneys\u2019 fees, made by any third-party due to or arising out of your breach of these Terms of Service or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 15 - Severability'
						),
						_react2.default.createElement(
							'p',
							null,
							'In the event that any provision of these Terms of Service is determined to be unlawful, void or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of any other remaining provisions.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 16 - Termination'
						),
						_react2.default.createElement(
							'p',
							null,
							'The obligations and liabilities of the parties incurred prior to the termination date shall survive the termination of this agreement for all purposes. These Terms of Service are effective unless and until terminated by either you or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or when you cease using our site. If in our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time without notice and you will remain liable for all amounts due up to and including the date of termination; and/or accordingly may deny you access to our Services (or any part thereof).'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 17 - Entire Agreement'
						),
						_react2.default.createElement(
							'p',
							null,
							'The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision. These Terms of Service and any policies or operating rules posted by us on this site or in respect to The Service constitutes the entire agreement and understanding between you and us and govern your use of the Service, superseding any prior or contemporaneous agreements, communications and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service). Any ambiguities in the interpretation of these Terms of Service shall not be construed against the drafting party.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 18 - Governing Law'
						),
						_react2.default.createElement(
							'p',
							null,
							'These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of 1159 Glen Ave Berkeley California US 94708.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 19 - Changes to Terms of Service'
						),
						_react2.default.createElement(
							'p',
							null,
							'You can review the most current version of the Terms of Service at any time at this page. We reserve the right, at our sole discretion, to update, change or replace any part of these Terms of Service by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to our website or the Service following the posting of any changes to these Terms of Service constitutes acceptance of those changes.'
						),
						_react2.default.createElement(
							'h3',
							null,
							'Section 20 - Contact Information'
						),
						_react2.default.createElement(
							'p',
							null,
							'Questions about the Terms of Service should be sent to us at ',
							_react2.default.createElement(
								'a',
								{ href: 'mailto:meow@tabbycats.club', className: 'site-link' },
								'meow@tabbycats.club'
							),
							'.'
						)
					),
					_react2.default.createElement(_ShopFooter2.default, null)
				);
			}
		}]);
	
		return ShopTOS;
	}(_BasePage3.default);
	
	exports.default = ShopTOS;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shopify = __webpack_require__(258);
	
	var _shopify2 = _interopRequireDefault(_shopify);
	
	var _BasePage2 = __webpack_require__(25);
	
	var _BasePage3 = _interopRequireDefault(_BasePage2);
	
	var _Navigation = __webpack_require__(23);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _ShopFooter = __webpack_require__(55);
	
	var _ShopFooter2 = _interopRequireDefault(_ShopFooter);
	
	var _Cart = __webpack_require__(582);
	
	var _Cart2 = _interopRequireDefault(_Cart);
	
	var _Gallery = __webpack_require__(584);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Shop = function (_BasePage) {
		_inherits(Shop, _BasePage);
	
		function Shop() {
			_classCallCheck(this, Shop);
	
			var _this = _possibleConstructorReturn(this, (Shop.__proto__ || Object.getPrototypeOf(Shop)).call(this));
	
			_this.state = {
				featuredStickers: [],
				catStickers: [],
				petStickers: [],
				stickers: [],
				cart: null
			};
	
			_this.activePromo = false;
	
			_this.shopClosedUntilDate = null;
			_this.shopClosedMessage = _react2.default.createElement(
				'div',
				null,
				'We\u2019ll be back on ',
				_this.shopClosedUntilDate,
				'.',
				_react2.default.createElement('br', null),
				'Thanks for your support!'
			);
	
			_this.updateCart = _this.updateCart.bind(_this);
			return _this;
		}
	
		_createClass(Shop, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				_shopify2.default.getCurrentStock.then(function (stickersFromShopify) {
					_this2.setState({ stickers: stickersFromShopify });
				});
	
				_shopify2.default.getCart.then(function (cartFromShopify) {
					_this2.setState({ cart: cartFromShopify });
				});
	
				window.scrollTo(0, 0);
			}
		}, {
			key: 'updateCart',
			value: function updateCart(cartObject) {
				this.setState({ cart: cartObject });
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'section section--centered section--shop bg--orange' },
					_react2.default.createElement(
						'div',
						{ className: 'shop__intro' },
						_react2.default.createElement(_Navigation2.default, null),
						_react2.default.createElement(
							'div',
							{ className: 'intro__header' },
							_react2.default.createElement(
								'h1',
								null,
								'Tabby Cat Shop'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'intro__disclaimer' },
							!this.shopClosedUntilDate && ''
						)
					),
					this.shopClosedUntilDate && _react2.default.createElement(
						'div',
						{ className: 'closed-banner' },
						_react2.default.createElement(
							'div',
							{ className: 'closed-banner__inner' },
							_react2.default.createElement(
								'svg',
								{ width: '60', height: '60', viewBox: '0 0 60 60' },
								_react2.default.createElement('polygon', { points: '42.7232857,18.2530651 40.279438,18.2530651 42.7232857,14.747694 42.7232857,12.8526745 36.9850044,12.8526745 36.9850044,15.1754284 39.317524,15.1754284 36.958149,18.6837292 36.958149,20.575819 42.7232857,20.575819 ' }),
								_react2.default.createElement('polygon', { points: '34.9098091,24.1495495 32.4659615,24.1495495 34.9098091,20.6441784 34.9098091,18.7491589 29.1715279,18.7491589 29.1715279,21.0719128 31.5040474,21.0719128 29.1446724,24.5802135 29.1446724,26.4723034 34.9098091,26.4723034 ' }),
								_react2.default.createElement('circle', { cx: '30.0000191', cy: '39.8555412', r: '2.7578125' }),
								_react2.default.createElement('path', { d: 'M44.4181099,32.2667351c-1.019043,1.2397461-2.5219727,1.9506836-4.1245117,1.9506836 s-3.105957-0.7109375-4.1245117-1.9511719l-2.3183594,1.9042969c1.5908203,1.9365234,3.9389648,3.046875,6.4428711,3.046875 c2.503418,0,4.8515625-1.1103516,6.4418945-3.0463867L44.4181099,32.2667351z' }),
								_react2.default.createElement('path', { d: 'M19.7066841,34.2174187c-1.6025391,0-3.105957-0.7109375-4.1245127-1.9511719l-2.3183594,1.9042969 c1.5908203,1.9365234,3.9389658,3.046875,6.442872,3.046875c2.503418,0,4.8520508-1.1103516,6.4423828-3.0463867 l-2.3173828-1.9042969C22.8126411,33.5064812,21.3092232,34.2174187,19.7066841,34.2174187z' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'closed-banner__header' },
								'The shop is taking a little break.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'closed-banner__desc' },
								this.shopClosedMessage
							)
						)
					),
					this.activePromo && _react2.default.createElement(
						'div',
						{ className: 'promo-banner' },
						_react2.default.createElement(
							'div',
							{ className: 'promo-banner__inner' },
							_react2.default.createElement(
								'div',
								{ className: 'promo-banner__header' },
								'Free shipping on orders over $15!'
							),
							_react2.default.createElement(
								'div',
								{ className: 'promo-banner__desc' },
								'Valid on US orders with code: ',
								_react2.default.createElement(
									'div',
									{ className: 'promo-banner__code' },
									'SHIPPY-CAT'
								)
							)
						)
					),
					_react2.default.createElement(_Gallery2.default, { shopClosedUntilDate: this.shopClosedUntilDate, products: this.state.stickers, cart: this.state.cart, updateCart: this.updateCart }),
					_react2.default.createElement(_ShopFooter2.default, null),
					!this.shopClosedUntilDate && _react2.default.createElement(_Cart2.default, { cart: this.state.cart, updateCart: this.updateCart })
				);
			}
		}]);
	
		return Shop;
	}(_BasePage3.default);
	
	exports.default = Shop;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getAvailablePets;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getAvailablePets(pets) {
		// filter down to the available pets and key them by ID
		// so we can easily grab them.
		var petsById = _lodash2.default.keyBy(_lodash2.default.filter(pets, function (pet) {
			return !pet.isComingSoon;
		}), 'sku');
		// Return an array of available pets sorted by the
		// order in the PETS array.
		return _lodash2.default.reduce(_constants.PETS, function (newPetsArray, pet) {
			if (petsById[pet.sku]) newPetsArray.push(petsById[pet.sku]);
			return newPetsArray;
		}, []);
	}

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getComingSoonPets;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComingSoonPets(pets) {
		return _lodash2.default.filter(pets, 'isComingSoon');
	}

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getGoodiesInCodebase;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getGoodiesInCodebase(goodies) {
		return _lodash2.default.chain(goodies).map(function (goody) {
			return _constants.GOODIES[goody];
		}).filter(function (goody) {
			return !!goody;
		}).value();
	}

/***/ },
/* 608 */
/***/ function(module, exports) {

	"use strict";
	
	function set(data, callback) {
		setTimeout(function () {
			return callback();
		}, 20);
	}
	
	function get(data, callback) {
		setTimeout(function () {
			return callback({});
		}, 20);
	}
	
	var storage = {
		sync: {
			set: set,
			get: get
		}
	};
	
	if (window.chrome) {
		// The browser has a chrome object.
		window.chrome.storage = storage;
	} else {
		// Browsers other than chrome need this defined.
		window.chrome = {
			storage: storage
		};
	}

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClassNames(state, staticClasses) {
	
		var currentActions = [];
	
		// Get the list of base classes from state.universalActions key names.
		var universalActions = _lodash2.default.chain(state.universalActions).map(function (value, key) {
			return value ? key : undefined;
		}).filter(function (action) {
			return !!action;
		}).value();
	
		if (state.universalActions.isBeingPet) {
			// Get the values of each pet action that doesn't have null actions.
			currentActions = _lodash2.default.filter(state.actions.pet, function (action) {
				return !!action;
			});
		} else if (state.actions.idle.sleep) {
			// It's sleeping so only return the sleep action.
			currentActions = state.actions.idle.sleep;
		} else {
			// Get the values of each pet action that doesn't have null actions.
			currentActions = _lodash2.default.filter(state.actions.idle, function (action) {
				return !!action;
			});
		}
	
		var classes = (0, _classnames2.default)(staticClasses, universalActions, currentActions);
	
		return classes;
	}
	
	module.exports = getClassNames;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getGoodiesOfType(collectedGoodies, type) {
		return _lodash2.default.chain(collectedGoodies).filter(function (goody) {
			return _lodash2.default.get(_constants.GOODIES[goody], 'type') === type;
		}).value();
	}
	
	exports.default = getGoodiesOfType;

/***/ },
/* 611 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	function getKitten(props) {
		var shouldGetKitten = Math.random() < 0.3;
		var thisKitten = void 0;
	
		if (!shouldGetKitten) {
			return null;
		}
	
		if (props.toy === 'toy-Yarn') {
			thisKitten = 'Frisky';
		} else if (props.toy === 'toy-Fishbowl' && props.glasses === 'glasses-Scuba') {
			thisKitten = 'Scuba';
		} else if (props.toy === 'toy-MagicWand' && props.hat === 'hat-Unicorn') {
			thisKitten = 'Unicorn';
		} else if (props.toy === 'toy-Campfire' && props.hat === 'hat-Beanie') {
			thisKitten = 'Camper';
		} else if (props.toy === 'toy-Rocketship') {
			thisKitten = 'Rocketship';
		} else if (props.toy === 'toy-FoamFinger' && props.hat === 'hat-Baseball') {
			thisKitten = 'Fan';
		} else if (props.toy === 'toy-BonsaiTree' && props.glasses === 'glasses-OldMan') {
			thisKitten = 'Bonsai';
		} else if (props.toy === 'toy-Synth' && props.glasses === 'glasses-Sunglasses') {
			thisKitten = 'Midi';
		} else if (props.toy === 'toy-SoccerBall' && props.hat === 'hat-Sweatband') {
			thisKitten = 'Athlete';
		} else if (props.toy === 'toy-Coffee' && props.glasses === 'glasses-Raybans') {
			thisKitten = 'Coffee';
		} else if (props.toy === 'toy-Dough' && props.hat === 'hat-Chef') {
			thisKitten = 'Chef';
		} else if (props.toy === 'toy-Cake' && props.hat === 'hat-PartyHat') {
			thisKitten = 'Birthday';
		}
	
		return thisKitten;
	}
	
	exports.default = getKitten;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getNewGoody(collectedPets, collectedGoodies) {
		// Get the types of collected pets.
		var typesOfPets = _lodash2.default.chain(collectedPets).map('type').uniq().value();
	
		// Get array of all new goodies that we can get with these types of pets.
		var newGoodiesForTypesOfPets = _lodash2.default.filter(_constants.GOODIES, function (goody) {
			var isForThesePetTypes = _lodash2.default.isUndefined(goody.forPetType) || _lodash2.default.includes(typesOfPets, goody.forPetType);
			var isNotCollected = !_lodash2.default.includes(collectedGoodies, goody.id);
	
			return isForThesePetTypes && isNotCollected;
		});
	
		// Return a random new goody.
		return newGoodiesForTypesOfPets[_lodash2.default.random(newGoodiesForTypesOfPets.length - 1)];
	}
	
	exports.default = getNewGoody;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _log = __webpack_require__(56);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getNewGoodyOfPetType(collectedGoodies, petType) {
	
		// Get array of all new goodies that we can get for this pet type
		var newGoodiesForPetType = _lodash2.default.filter(_constants.GOODIES, function (goody) {
			var isForThisPetType = goody.forPetType === petType;
			var isNotCollected = !_lodash2.default.includes(collectedGoodies, goody.id);
	
			return isForThisPetType && isNotCollected;
		});
	
		(0, _log2.default)('getNewGoodyOfPetType -> newGoodiesForPetType: ', newGoodiesForPetType);
	
		// Return a random new goody.
		return newGoodiesForPetType[_lodash2.default.random(newGoodiesForPetType.length - 1)];
	}
	
	exports.default = getNewGoodyOfPetType;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(3);
	
	module.exports = function (number) {
		var price = void 0;
	
		// sanity check
		if (!number) {
			return null;
		}
	
		price = "$" + Math.round(Number(number));
	
		return price;
	};

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function currentUser() {
		var currentUserState = {};
	
		try {
			currentUserState.visits = _lodash2.default.isUndefined(window.localStorage.visits) ? _constants.INITIAL_STATE.visits : JSON.parse(window.localStorage.visits);
			currentUserState.lastVerification = _lodash2.default.isUndefined(window.localStorage.lastVerification) ? _constants.INITIAL_STATE.lastVerification : JSON.parse(window.localStorage.lastVerification);
	
			currentUserState.activePet = _lodash2.default.isUndefined(window.localStorage.activePet) ? _constants.INITIAL_STATE.activePet : JSON.parse(window.localStorage.activePet);
			currentUserState.allPets = _lodash2.default.isUndefined(window.localStorage.allPets) ? _constants.INITIAL_STATE.allPets : JSON.parse(window.localStorage.allPets);
	
			currentUserState.activeGoodies = _lodash2.default.isUndefined(window.localStorage.activeGoodies) ? _constants.INITIAL_STATE.activeGoodies : JSON.parse(window.localStorage.activeGoodies);
			currentUserState.collectedGoodies = _lodash2.default.isUndefined(window.localStorage.collectedGoodies) ? _constants.INITIAL_STATE.collectedGoodies : JSON.parse(window.localStorage.collectedGoodies);
		} catch (err) {
			currentUserState = Object.assign({}, _constants.INITIAL_STATE);
		}
	
		return currentUserState;
	}
	
	exports.default = currentUser;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _currentUser = __webpack_require__(615);
	
	var _currentUser2 = _interopRequireDefault(_currentUser);
	
	var _legacyUser = __webpack_require__(617);
	
	var _legacyUser2 = _interopRequireDefault(_legacyUser);
	
	var _newUser = __webpack_require__(618);
	
	var _newUser2 = _interopRequireDefault(_newUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStorage() {
	
		if (window.localStorage.tabbyCatVersion1) {
			// CURRENT USER - Get their storage from the new place - chrome.storage.
			return (0, _currentUser2.default)();
		} else if (window.localStorage.goodies) {
			// LEGACY USER - Get their storage from the old place - localStorage.
			return (0, _legacyUser2.default)();
		}
	
		// NEW USER - Initialize state.
		return (0, _newUser2.default)();
	} // Get this user's storage.
	
	exports.default = getStorage;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function legacyUser() {
		var legacyUserState = {};
		var parsedGoodies = void 0;
		var parsedVisits = void 0;
		var parseWorked = void 0;
	
		try {
			parsedGoodies = JSON.parse(window.localStorage.goodies);
			parsedVisits = JSON.parse(window.localStorage.visits);
			parseWorked = true;
		} catch (err) {
			console.error('Parsing window.localStorage.goodies failed with error: ', err);
			window.localStorage.setItem('failedStorageGoodies', window.localStorage.goodies);
			window.localStorage.setItem('failedStorageVisits', window.localStorage.visits);
		}
	
		if (parseWorked) {
			var _parsedGoodies = parsedGoodies,
			    collected = _parsedGoodies.collected,
			    unseen = _parsedGoodies.unseen,
			    shuffle = _parsedGoodies.shuffle,
			    active = _parsedGoodies.active;
	
	
			var collectedGoodies = _lodash2.default.map(collected, function (goody) {
				return _constants.LEGACY_GOODY_MAP[goody];
			});
	
			var newCollectedGoodies = _lodash2.default.map(unseen, function (goody) {
				return _constants.LEGACY_GOODY_MAP[goody];
			});
	
			var activeGoodies = {
				hat: _constants.LEGACY_GOODY_MAP[active.hat],
				glasses: _constants.LEGACY_GOODY_MAP[active.glasses],
				toy: _constants.LEGACY_GOODY_MAP[active.toy]
			};
	
			var activeGoodiesShuffle = shuffle;
	
			legacyUserState = Object.assign({}, _constants.INITIAL_STATE, {
				visits: parsedVisits,
				activeGoodies: {
					shuffle: activeGoodiesShuffle,
					active: activeGoodies
				},
				collectedGoodies: {
					newItems: newCollectedGoodies,
					list: collectedGoodies
				}
			});
		} else {
			legacyUserState = Object.assign({}, _constants.INITIAL_STATE);
		}
	
		window.localStorage.setItem('tabbyCatVersion1', true);
		window.localStorage.removeItem('goodies');
		window.localStorage.removeItem('visits');
	
		return legacyUserState;
	}
	
	exports.default = legacyUser;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _constants = __webpack_require__(4);
	
	function newUser() {
		var newUserState = Object.assign({}, _constants.INITIAL_STATE);
	
		window.localStorage.setItem('tabbyCatVersion1', true);
		return newUserState;
	}
	
	exports.default = newUser;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.setPetAction = exports.setIdleAction = exports.setAction = undefined;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setAction(action, state, type) {
		var nextState = _lodash2.default.assign({}, state);
		var nextAction = void 0;
	
		// ACTIONS THAT ARE TOGGLED BACK AND FORTH (like stomping)
		if (action.toggleBetween) {
			// Remove the last action from the ones that can be chosen this time.
			// This creates the "back and forth" effect
			var availableActions = _lodash2.default.without(action.actions, state.lastActions[action.name]);
			// Set the next action.
			nextAction = availableActions[_lodash2.default.random(0, availableActions.length - 1)];
			// Save the next action to the lastActions object.
			nextState.lastActions[action.name] = nextAction;
	
			// ALL OTHER ACTIONS
		} else {
			// Get a new random action
			nextAction = action.actions[_lodash2.default.random(0, action.actions.length - 1)];
			// If it's the same as last time, reset this action.
			if (nextAction === state.actions[type][action.name]) nextAction = undefined;
		}
	
		// Set the state with our new action
		nextState.actions[type][action.name] = nextAction;
	
		// Return the new state.
		return nextState;
	}
	
	function setIdleAction(action, state) {
		return setAction(action, state, 'idle');
	}
	
	function setPetAction(action, state) {
		return setAction(action, state, 'pet');
	}
	
	exports.setAction = setAction;
	exports.setIdleAction = setIdleAction;
	exports.setPetAction = setPetAction;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable */
	
	var _ = __webpack_require__(3);
	var changeCase = __webpack_require__(277);
	
	var backgroundColorMap = {
		'#c9d2fc': 'light-purple',
		'#A2D8C0': 'teal',
		'#F2CC7B': 'yellow',
		'#FC7E7E': 'red',
		'#D7EDAF': 'green',
		'#A5C6EF': 'blue',
		'#C8B8F2': 'purple',
		'#bad5dd': 'light-blue'
	};
	
	var catColorMap = {
		'#FCB47E': 'orange',
		'#5E5E5E': 'black',
		'#B3B3B3': 'gray',
		'#FCDAC9': 'white'
	};
	
	var getOld = {
		_id: function _id(cat) {
			return cat._id;
		},
		name: function name(cat) {
			return cat.name;
		},
		body: function body(cat) {
			return cat.body;
		},
		head: function head(cat) {
			return cat.head;
		},
		color: function color(cat) {
			return cat.color.cat;
		},
		bgColor: function bgColor(cat) {
			return cat.color.background;
		},
		likesPets: function likesPets(cat) {
			return cat.likesPets;
		},
		kitten: function kitten(cat) {
			return cat.kitty;
		},
		glasses: function glasses(cat) {
			return _.get(cat, ['activeGoodies', 'glasses'], null);
		},
		hat: function hat(cat) {
			return _.get(cat, ['activeGoodies', 'hat'], null);
		},
		toy: function toy(cat) {
			return _.get(cat, ['activeGoodies', 'toy'], null);
		}
	};
	
	var makeNew = {
		_id: function _id(id) {
			// id is the same
			return id;
		},
		name: function name(oldName) {
			// name is the same
			return oldName;
		},
		body: function body(oldBody) {
			// old body is a string
			// new body is a number
			return Number(oldBody);
		},
		head: function head(oldHead) {
			// old head was a string
			// new head is a number
			return Number(oldHead);
		},
		color: function color(oldColor) {
			// old color was the classname for cat color, 'cat-[color]',
			// new color is just the string of cat color, without class prefix, '[color]'.
			// If it was an old hex code, convert it using the table above.
			if (oldColor.indexOf('#') === 0) return catColorMap[oldColor] || 'orange';
			return oldColor.replace('cat-', '').replace('grey', 'gray');
		},
		bgColor: function bgColor(oldBgColor) {
			// old bgColor was the classname for bg color, 'bg-[color]',
			// new bgColor is just the string of bg color, without class prefix, '[color]'.
			// If it was an old hex code, convert it using the table above.
			if (oldBgColor.indexOf('#') === 0) return backgroundColorMap[oldBgColor] || 'light-purple';
			return oldBgColor.replace('bg-', '');
		},
		likesPets: function likesPets(oldLikesPets) {
			// old likesPets was Boolean, but is sometimes interpreted as string
			// new is string for class.
			if (typeof oldLikesPets === 'boolean') {
				return oldLikesPets ? 'likes' : 'hates';
			} else {
				return oldLikesPets === 'true' ? 'likes' : 'hates';
			}
		},
		kitten: function kitten(oldKitten) {
			// old kitten was kitty id (lowercase) or 'no-kitty'.
			// new kitten is kitty id (capitalized) or the prop doesn't exist.
			var hasKitten = !_.isUndefined(oldKitten) && oldKitten !== 'no-kitty';
	
			if (!hasKitten) {
				return undefined;
			} else {
				// given 'poop-kitten' should return 'PoopKitten'.
				return changeCase.pascalCase(oldKitten);
			}
		},
		glasses: function glasses(oldGlasses) {
			// old goodies were 'goodytype-n'
			// new goodies are 'GoodyName';
			var newGlasses = void 0;
			var glassesMap = {
				"glasses-1": "glasses-Raybans",
				"glasses-2": "glasses-CatEye",
				"glasses-3": "glasses-ThreeD",
				"glasses-4": "glasses-OldMan",
				"glasses-5": "glasses-Scuba",
				"glasses-6": "glasses-Kerry",
				"glasses-7": "glasses-Blue",
				"glasses-8": "glasses-Sunglasses"
			};
	
			if (!_.isUndefined(oldGlasses)) {
				newGlasses = glassesMap[oldGlasses];
			}
	
			return newGlasses || null;
		},
		hat: function hat(oldHat) {
			// old goodies were 'goodytype-n'
			// new goodies are 'GoodyName';
			var newHat = void 0;
			var hatMap = {
				"hat-1": "hat-PartyHat",
				"hat-2": "hat-Fedora",
				"hat-3": "hat-Fez",
				"hat-4": "hat-Chef",
				"hat-5": "hat-Baseball",
				"hat-6": "hat-Beanie",
				"hat-7": "hat-Princess",
				"hat-8": "hat-King",
				"hat-9": "hat-Unicorn",
				"hat-10": "hat-Sweatband",
				"hat-11": "hat-Spinner",
				"hat-12": "hat-Bow"
			};
	
			if (!_.isUndefined(oldHat)) {
				newHat = hatMap[oldHat];
			}
	
			return newHat || null;
		},
		toy: function toy(oldToy) {
			// old goodies were 'goodytype-n'
			// new goodies are 'GoodyName';
			var newToy = void 0;
			var toyMap = {
				"toy-1": "toy-Yarn",
				"toy-2": "toy-Mouse",
				"toy-3": "toy-Pizza",
				"toy-4": "toy-Fishbones",
				"toy-5": "toy-SoccerBall",
				"toy-6": "toy-Donut",
				"toy-7": "toy-Fishbowl",
				"toy-8": "toy-Campfire",
				"toy-9": "toy-MagicWand",
				"toy-10": "toy-IceCream",
				"toy-11": "toy-Coffee",
				"toy-12": "toy-MiniGolf",
				"toy-13": "toy-Flamingo",
				"toy-14": "toy-Rocketship",
				"toy-15": "toy-FoamFinger",
				"toy-16": "toy-BonsaiTree",
				"toy-17": "toy-Wine",
				"toy-18": "toy-Synth",
				"toy-19": "toy-Martini"
			};
	
			if (!_.isUndefined(oldToy)) {
				newToy = toyMap[oldToy];
			}
	
			return newToy || null;
		}
	};
	
	function translateLegacyCat(cat) {
		var newCat = {};
	
		if (cat.petType) {
			// This is a new cat with a petType defined.
			return cat;
		}
	
		if (!cat) {
			console.error('Your cat was undefined.');
			return newCat;
		}
	
		_.forOwn(getOld, function (value, key) {
			newCat[key] = makeNew[key](value(cat));
		});
	
		return newCat;
	}
	
	module.exports = {
		makeNew: makeNew,
		getOld: getOld,
		translateLegacyCat: translateLegacyCat
	};

/***/ },
/* 621 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var Helpers = __webpack_require__(57);
	
	var Button = function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
	  }
	
	  _createClass(Button, [{
	    key: 'render',
	    value: function render() {
	      return React.createElement(
	        'input',
	        this.props,
	        this.props.children
	      );
	    }
	  }]);
	
	  return Button;
	}(React.Component);
	
	;
	
	module.exports = Helpers.Scroll(Button);

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var Helpers = __webpack_require__(57);
	
	var Element = function (_React$Component) {
	  _inherits(Element, _React$Component);
	
	  function Element() {
	    _classCallCheck(this, Element);
	
	    return _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).apply(this, arguments));
	  }
	
	  _createClass(Element, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // Remove `parentBindings` from props
	      var newProps = Object.assign({}, this.props);
	      if (newProps.parentBindings) {
	        delete newProps.parentBindings;
	      }
	
	      return React.createElement(
	        'div',
	        _extends({}, newProps, { ref: function ref(el) {
	            _this2.props.parentBindings.domNode = el;
	          } }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Element;
	}(React.Component);
	
	;
	
	module.exports = Helpers.Element(Element);

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var Helpers = __webpack_require__(57);
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	  }
	
	  _createClass(Link, [{
	    key: 'render',
	    value: function render() {
	      return React.createElement(
	        'a',
	        this.props,
	        this.props.children
	      );
	    }
	  }]);
	
	  return Link;
	}(React.Component);
	
	;
	
	module.exports = Helpers.Scroll(Link);

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.Link = __webpack_require__(624);
	exports.Button = __webpack_require__(622);
	exports.Element = __webpack_require__(623);
	exports.Helpers = __webpack_require__(57);
	exports.scroller = __webpack_require__(263);
	exports.Events = __webpack_require__(89);
	exports.scrollSpy = __webpack_require__(262);
	exports.animateScroll = __webpack_require__(88);

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var addPassiveEventListener = __webpack_require__(261);
	
	var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];
	
	module.exports = {
		register: function register(cancelEvent) {
			if (typeof document === 'undefined') {
				return;
			}
	
			for (var i = 0; i < events.length; i = i + 1) {
				addPassiveEventListener(document, events[i], cancelEvent);
			}
		}
	};

/***/ },
/* 627 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  /*
	   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
	   */
	  defaultEasing: function defaultEasing(x) {
	    if (x < 0.5) {
	      return Math.pow(x * 2, 2) / 2;
	    }
	    return 1 - Math.pow((1 - x) * 2, 2) / 2;
	  },
	  /*
	   * https://gist.github.com/gre/1650294
	   */
	  // no easing, no acceleration
	  linear: function linear(x) {
	    return x;
	  },
	  // accelerating from zero velocity
	  easeInQuad: function easeInQuad(x) {
	    return x * x;
	  },
	  // decelerating to zero velocity
	  easeOutQuad: function easeOutQuad(x) {
	    return x * (2 - x);
	  },
	  // acceleration until halfway, then deceleration
	  easeInOutQuad: function easeInOutQuad(x) {
	    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
	  },
	  // accelerating from zero velocity 
	  easeInCubic: function easeInCubic(x) {
	    return x * x * x;
	  },
	  // decelerating to zero velocity π
	  easeOutCubic: function easeOutCubic(x) {
	    return --x * x * x + 1;
	  },
	  // acceleration until halfway, then deceleration 
	  easeInOutCubic: function easeInOutCubic(x) {
	    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
	  },
	  // accelerating from zero velocity 
	  easeInQuart: function easeInQuart(x) {
	    return x * x * x * x;
	  },
	  // decelerating to zero velocity 
	  easeOutQuart: function easeOutQuart(x) {
	    return 1 - --x * x * x * x;
	  },
	  // acceleration until halfway, then deceleration
	  easeInOutQuart: function easeInOutQuart(x) {
	    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
	  },
	  // accelerating from zero velocity
	  easeInQuint: function easeInQuint(x) {
	    return x * x * x * x * x;
	  },
	  // decelerating to zero velocity
	  easeOutQuint: function easeOutQuint(x) {
	    return 1 + --x * x * x * x * x;
	  },
	  // acceleration until halfway, then deceleration 
	  easeInOutQuint: function easeInOutQuint(x) {
	    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
	  }
	};

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = computeOffsetPixels;
	
	var _parseOffsetAsPercentage = __webpack_require__(633);
	
	var _parseOffsetAsPercentage2 = _interopRequireDefault(_parseOffsetAsPercentage);
	
	var _parseOffsetAsPixels = __webpack_require__(634);
	
	var _parseOffsetAsPixels2 = _interopRequireDefault(_parseOffsetAsPixels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @param {string|number} offset
	 * @param {number} contextHeight
	 * @return {number} A number representing `offset` converted into pixels.
	 */
	function computeOffsetPixels(offset, contextHeight) {
	  var pixelOffset = (0, _parseOffsetAsPixels2.default)(offset);
	
	  if (typeof pixelOffset === 'number') {
	    return pixelOffset;
	  }
	
	  var percentOffset = (0, _parseOffsetAsPercentage2.default)(offset);
	  if (typeof percentOffset === 'number') {
	    return percentOffset * contextHeight;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debugLog;
	function debugLog() {
	  if (false) {
	    console.log(arguments); // eslint-disable-line no-console
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ensureChildrenIsSingleDOMElement;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isDOMElement = __webpack_require__(632);
	
	var _isDOMElement2 = _interopRequireDefault(_isDOMElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Raise an error if "children" isn't a single DOM Element
	 *
	 * @param {React.element|null} children
	 * @return {undefined}
	 */
	function ensureChildrenIsSingleDOMElement(children) {
	  if (children) {
	    _react2.default.Children.only(children);
	
	    if (!(0, _isDOMElement2.default)(children)) {
	      throw new Error('You must wrap any Component Elements passed to Waypoint in a DOM Element (eg; a <div>).');
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getCurrentPosition;
	
	var _constants = __webpack_require__(264);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @param {object} bounds An object with bounds data for the waypoint and
	 *   scrollable parent
	 * @return {string} The current position of the waypoint in relation to the
	 *   visible portion of the scrollable parent. One of `constants.above`,
	 *   `constants.below`, or `constants.inside`.
	 */
	function getCurrentPosition(bounds) {
	  if (bounds.viewportBottom - bounds.viewportTop === 0) {
	    return _constants2.default.invisible;
	  }
	
	  // top is within the viewport
	  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
	    return _constants2.default.inside;
	  }
	
	  // bottom is within the viewport
	  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
	    return _constants2.default.inside;
	  }
	
	  // top is above the viewport and bottom is below the viewport
	  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
	    return _constants2.default.inside;
	  }
	
	  if (bounds.viewportBottom < bounds.waypointTop) {
	    return _constants2.default.below;
	  }
	
	  if (bounds.waypointTop < bounds.viewportTop) {
	    return _constants2.default.above;
	  }
	
	  return _constants2.default.invisible;
	}
	module.exports = exports['default'];

/***/ },
/* 632 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDOMElement;
	/**
	 * When an element's type is a string, it represents a DOM node with that tag name
	 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
	 *
	 * @param {React.element} Component
	 * @return {bool} Whether the component is a DOM Element
	 */
	function isDOMElement(Component) {
	  return typeof Component.type === 'string';
	}
	module.exports = exports['default'];

/***/ },
/* 633 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseOffsetAsPercentage;
	/**
	 * Attempts to parse the offset provided as a prop as a percentage. For
	 * instance, if the component has been provided with the string "20%" as
	 * a value of one of the offset props. If the value matches, then it returns
	 * a numeric version of the prop. For instance, "20%" would become `0.2`.
	 * If `str` isn't a percentage, then `undefined` will be returned.
	 *
	 * @param {string} str The value of an offset prop to be converted to a
	 *   number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was not a percentage.
	 */
	function parseOffsetAsPercentage(str) {
	  if (str.slice(-1) === '%') {
	    return parseFloat(str.slice(0, -1)) / 100;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 634 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseOffsetAsPixels;
	/**
	 * Attempts to parse the offset provided as a prop as a pixel value. If
	 * parsing fails, then `undefined` is returned. Three examples of values that
	 * will be successfully parsed are:
	 * `20`
	 * "20px"
	 * "20"
	 *
	 * @param {string|number} str A string of the form "{number}" or "{number}px",
	 *   or just a number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was neither a number nor string ending in "px".
	 */
	function parseOffsetAsPixels(str) {
	  if (!isNaN(parseFloat(str)) && isFinite(str)) {
	    return parseFloat(str);
	  } else if (str.slice(-2) === 'px') {
	    return parseFloat(str.slice(0, -2));
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 635 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = resolveScrollableAncestorProp;
	function resolveScrollableAncestorProp(scrollableAncestor) {
	  // When Waypoint is rendered on the server, `window` is not available.
	  // To make Waypoint easier to work with, we allow this to be specified in
	  // string form and safely convert to `window` here.
	  if (scrollableAncestor === 'window') {
	    return global.window;
	  }
	
	  return scrollableAncestor;
	}
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 636 */
67,
/* 637 */
[665, 45],
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(637);
	var ReactElement = __webpack_require__(36);
	
	var emptyFunction = __webpack_require__(15);
	var traverseAllChildren = __webpack_require__(647);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(36);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(36),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(216);
	
	module.exports = factory(isValidElement);

/***/ },
/* 641 */
370,
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(265),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(36),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(268);
	var factory = __webpack_require__(285);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 643 */
389,
/* 644 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var ReactElement = __webpack_require__(36);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(45);
	
	var ReactCurrentOwner = __webpack_require__(24);
	var REACT_ELEMENT_TYPE = __webpack_require__(267);
	
	var getIteratorFn = __webpack_require__(643);
	var invariant = __webpack_require__(5);
	var KeyEscapeUtils = __webpack_require__(636);
	var warning = __webpack_require__(7);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.subscribe = subscribe;
	
	exports.default = function (store) {
	    var prevState = store.getState();
	
	    store.subscribe(function () {
	        var newState = store.getState();
	
	        Object.keys(subscribers).forEach(function (key) {
	            if ((0, _objectPath.get)(prevState, key) !== (0, _objectPath.get)(newState, key)) {
	                subscribers[key].forEach(function (cb) {
	                    return cb(newState);
	                });
	            }
	        });
	
	        prevState = newState;
	    });
	
	    return subscribe;
	};
	
	var _objectPath = __webpack_require__(320);
	
	var subscribers = {};
	
	function subscribe(key, cb) {
	    if (subscribers.hasOwnProperty(key)) {
	        subscribers[key].push(cb);
	    } else {
	        subscribers[key] = [cb];
	    }
	
	    // return "unsubscribe" function
	    return function () {
	        subscribers[key] = subscribers[key].filter(function (s) {
	            return s !== cb;
	        });
	    };
	}

/***/ },
/* 650 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(270);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 652 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(271);
	
	var _isPlainObject = __webpack_require__(62);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(272);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 654 */
/***/ function(module, exports) {

	'use strict';
	
	var isAbsolute = function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	};
	
	// About 1.5x faster than the two-arg version of Array#splice()
	var spliceOne = function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }list.pop();
	};
	
	// This implementation is based heavily on node's url.parse
	var resolvePathname = function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	};
	
	module.exports = resolvePathname;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(20)
	var upperCaseFirst = __webpack_require__(91)
	
	/**
	 * Sentence case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return upperCaseFirst(noCase(value, locale), locale)
	}


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(global, Buffer) {'use strict';
	
	/* eslint no-undefined: 0 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var assign = void 0;
	
	if (typeof Object.assign === 'function') {
	  assign = Object.assign;
	} else {
	  assign = function assign(target) {
	    if (target === undefined || target === null) {
	      throw new TypeError('Cannot convert undefined or null to object');
	    }
	
	    var output = Object(target);
	
	    var propertyObjects = [].slice.call(arguments, 1);
	
	    if (propertyObjects.length > 0) {
	      propertyObjects.forEach(function (source) {
	        if (source !== undefined && source !== null) {
	          var nextKey = void 0;
	
	          for (nextKey in source) {
	            if (source.hasOwnProperty(nextKey)) {
	              output[nextKey] = source[nextKey];
	            }
	          }
	        }
	      });
	    }
	
	    return output;
	  };
	}
	
	var assign$1 = assign;
	
	var includes = void 0;
	
	if (!Array.prototype.includes) {
	  includes = function includes(array, searchElement) {
	    var ObjectifiedArray = Object(array);
	    var length = parseInt(ObjectifiedArray.length, 10) || 0;
	
	    if (length === 0) {
	      return false;
	    }
	
	    var startIndex = parseInt(arguments[2], 10) || 0;
	    var index = void 0;
	
	    if (startIndex >= 0) {
	      index = startIndex;
	    } else {
	      index = length + startIndex;
	
	      if (index < 0) {
	        index = 0;
	      }
	    }
	
	    while (index < length) {
	      var currentElement = ObjectifiedArray[index];
	
	      /* eslint no-self-compare:0 */
	      if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) {
	        // NaN !== NaN
	        return true;
	      }
	      index++;
	    }
	
	    return false;
	  };
	} else {
	  includes = function includes(array) {
	    var args = [].slice.call(arguments, 1);
	
	    return Array.prototype.includes.apply(array, args);
	  };
	}
	
	var includes$1 = includes;
	
	function wrap(func, superFunc) {
	  function superWrapper() {
	    var originalSuper = this['super'];
	
	    this['super'] = function () {
	      return superFunc.apply(this, arguments);
	    };
	
	    var ret = func.apply(this, arguments);
	
	    this['super'] = originalSuper;
	
	    return ret;
	  }
	
	  superWrapper.wrappedFunction = func;
	
	  return superWrapper;
	}
	
	function defineProperties(names, proto, destination) {
	  var parentProto = Object.getPrototypeOf(destination);
	
	  names.forEach(function (name) {
	    var descriptor = Object.getOwnPropertyDescriptor(proto, name);
	    var parentDescriptor = parentProto.hasOwnProperty(name) && Object.getOwnPropertyDescriptor(parentProto, name);
	
	    if (typeof parentDescriptor.value === 'function' && typeof descriptor.value === 'function') {
	      var wrappedFunction = wrap(descriptor.value, parentDescriptor.value);
	
	      Object.defineProperty(destination, name, { value: wrappedFunction });
	    } else {
	      Object.defineProperty(destination, name, descriptor);
	    }
	  });
	}
	
	function createClass(props) {
	  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object;
	
	  var Constructor = wrap(props.constructor, parent);
	  var instancePropertyNames = Object.getOwnPropertyNames(props).filter(function (key) {
	    return !includes$1(['constructor', 'static'], key);
	  });
	
	  assign$1(Constructor, parent);
	
	  Constructor.prototype = Object.create(parent.prototype);
	  defineProperties(instancePropertyNames, props, Constructor.prototype);
	  Constructor.prototype.constructor = Constructor;
	
	  var staticProps = props['static'];
	
	  if (staticProps) {
	    var staticPropertyNames = Object.getOwnPropertyNames(staticProps);
	
	    defineProperties(staticPropertyNames, staticProps, Constructor);
	  }
	
	  return Constructor;
	}
	
	var CoreObject = createClass({
	  constructor: function constructor() {},
	
	
	  'static': {
	    extend: function extend(subClassProps) {
	      return createClass(subClassProps, this);
	    }
	  }
	});
	
	function wrapConsole(logCommand) {
	  var logMethod = function logMethod() {
	    var log = void 0;
	
	    /* eslint-disable no-console */
	    if (console[logCommand]) {
	      log = Function.prototype.bind.call(console[logCommand], console);
	    } else {
	      log = Function.prototype.bind.call(console.log, console);
	    }
	    log.apply(undefined, arguments);
	    /* eslint-enable no-console */
	  };
	
	  return function () {
	    var args = [].concat(Array.prototype.slice.call(arguments));
	
	    args.unshift('[JS-BUY-SDK]: ');
	    logMethod.apply(undefined, _toConsumableArray(args));
	  };
	}
	
	var Logger = CoreObject.extend({
	  /**
	   * Wrapper around the console log so in the future we can have better dev output.
	   * Also allows us to disable output in production.
	   * @private
	   * @class Logger
	   * @constructor
	   */
	  constructor: function constructor() {},
	
	  debug: wrapConsole('debug'),
	  info: wrapConsole('info'),
	  warn: wrapConsole('warn'),
	  error: wrapConsole('error')
	});
	
	var logger = new Logger();
	
	var Config = CoreObject.extend({
	  constructor: function constructor(attrs) {
	    var _this = this;
	
	    Object.keys(this.deprecatedProperties).forEach(function (key) {
	      if (attrs.hasOwnProperty(key)) {
	        var transformName = _this.deprecatedProperties[key];
	        var transform = _this[transformName];
	
	        transform(attrs[key], attrs);
	      }
	    });
	    this.requiredProperties.forEach(function (key) {
	      if (!attrs.hasOwnProperty(key)) {
	        throw new Error('new Config() requires the option \'' + key + '\'');
	      } else {
	        _this[key] = attrs[key];
	      }
	    });
	    this.optionalProperties.forEach(function (key) {
	      if (attrs.hasOwnProperty(key)) {
	        _this[key] = attrs[key];
	      }
	    });
	  },
	
	
	  /**
	   * An object with keys for deprecated properties and values as functions that
	   * will transform the value into a usable value. A depracation transform should
	   * have the value signature function(deprecated_value, config_to_be_transformed)
	   * @attribute deprecatedProperties
	   * @default { apiKey: this.transformApiKey, myShopifyDomain: this.transformMyShopifyDomain }
	   * @type Object
	   * @private
	   */
	  deprecatedProperties: {
	    apiKey: 'transformApiKey',
	    myShopifyDomain: 'transformMyShopifyDomain'
	  },
	
	  /**
	   * Transform the myShopifyDomain config to a domain config.
	   * @method transformMyShopifyDomain
	   * @static
	   * @private
	   * @param {String} subdomain The original subdomain on myshopify.com
	   * @param {Object} attrs. The config attributes to be transformed to a
	   * non-deprecated state.
	   * @return {Object} the transformed config attributes.
	   */
	  transformMyShopifyDomain: function transformMyShopifyDomain(subdomain, attrs) {
	    logger.warn('Config - ', 'myShopifyDomain is deprecated, please use domain and provide the full shop domain.');
	    attrs.domain = subdomain + '.myshopify.com';
	  },
	
	
	  /**
	   * Transform the apiKey config to an accessToken config.
	   * @method transformApiKey
	   * @static
	   * @private
	   * @param {String} apiKey The original api key
	   * @param {Object} attrs. The config attributes to be transformed to a
	   * non-deprecated state.
	   * @return {Object} the transformed config attributes.
	   */
	  transformApiKey: function transformApiKey(apiKey, attrs) {
	    logger.warn('Config - ', 'apiKey is deprecated, please use accessToken instead.');
	    attrs.accessToken = apiKey;
	  },
	
	
	  /**
	   * Properties that must be set on initializations
	   * @attribute requiredProperties
	   * @default ['accessToken', 'appId', 'myShopifyDomain']
	   * @type Array
	   * @private
	   */
	  requiredProperties: ['accessToken', 'appId', 'domain'],
	
	  /**
	   * Properties that may be set on initializations
	   * @attribute optionalProperties
	   * @default ['ajaxHeaders']
	   * @type Array
	   * @private
	   */
	  optionalProperties: ['ajaxHeaders'],
	
	  /**
	   * The accessToken for authenticating against shopify. This is your api client's
	   * storefront access token. Not the shared secret. Set during initialization.
	   * @attribute accessToken
	   * @default ''
	   * @type String
	   * @private
	   */
	  accessToken: '',
	
	  /**
	   * The apiKey for authenticating against shopify. This is your api client's
	   * public api token. Not the shared secret. Set during initialization.
	   * @attribute apiKey
	   * @default ''
	   * @type String
	   * @private
	   * @deprecated Use `config.accessToken` instead.
	   */
	  apiKey: '',
	
	  /**
	   * @attribute appId
	   * @default ''
	   * @type String
	   * @private
	   */
	  appId: '',
	
	  /**
	   * The domain that all the api requests will go to
	   * @attribute domain
	   * @default ''
	   * @type String
	   * @private
	   */
	  domain: '',
	
	  /**
	   * The subdomain of myshopify.io that all the api requests will go to
	   * @attribute myShopifyDomain
	   * @default ''
	   * @type String
	   * @private
	   * @deprecated Use `config.domain` instead.
	   */
	  myShopifyDomain: '',
	
	  /**
	   * @attribute ajaxHeaders
	   * @default {}
	   * @type Object
	   * @private
	   */
	  ajaxHeaders: {}
	});
	
	var version = 'v0.7.1-66ba4e4'; // eslint-disable-line
	
	var BaseModel = CoreObject.extend({
	  constructor: function constructor() {
	    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var metaAttrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    this.attrs = attrs;
	
	    assign$1(this, metaAttrs);
	  },
	
	  attrs: null,
	  serializer: null,
	  adapter: null,
	  shopClient: null
	});
	
	/**
	  * Class for product option
	  * @class ProductOptionModel
	  * @constructor
	*/
	var ProductOptionModel = BaseModel.extend(Object.defineProperties({
	  constructor: function constructor() {
	    this['super'].apply(this, arguments);
	
	    this.selected = this.values[0];
	  }
	}, {
	  name: {
	
	    /**
	      * name of option. Example values: `"Size"`, `"Color"`, etc.
	      * @property name
	      * @readOnly
	      * @type String
	    */
	    get: function get() {
	      return this.attrs.name;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  values: {
	
	    /**
	      * an Array possible values for option. For instance if this option is a "Size" option an example value
	      * for values could be: `["Large", "Medium", "Small"]`
	      *
	      * @property values
	      * @readOnly
	      * @type Array
	    */
	    get: function get() {
	      return this.attrs.values;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  selected: {
	
	    /**
	      * get/set the currently selected option value with one of the values from the
	      * {{#crossLink "ProductOptionModel/values"}}ProductOptionModel.values{{/crossLink}} array. For
	      * instance if the option values array had the following `["Large", "Medium", "Small"]` setting `selected` to be
	      * `"Large"`, `"Medium"`, or `"Small"` would be valid any other value would throw an `Error`.
	      *
	      * @property selected
	      * @type String
	    */
	    get: function get() {
	      return this._selected;
	    },
	    set: function set(value) {
	      if (includes$1(this.values, value)) {
	        this._selected = value;
	      } else {
	        throw new Error('Invalid option selection for ' + this.name + '.');
	      }
	
	      return value;
	    },
	    configurable: true,
	    enumerable: true
	  }
	}));
	
	var variants = [{ name: 'pico', dimension: '16x16' }, { name: 'icon', dimension: '32x32' }, { name: 'thumb', dimension: '50x50' }, { name: 'small', dimension: '100x100' }, { name: 'compact', dimension: '160x160' }, { name: 'medium', dimension: '240x240' }, { name: 'large', dimension: '480x480' }, { name: 'grande', dimension: '600x600' }, { name: '1024x1024', dimension: '1024x1024' }, { name: '2048x2048', dimension: '2048x2048' }];
	
	/**
	* Class for image model
	* @class ImageModel
	*/
	var ImageModel = CoreObject.extend(Object.defineProperties({
	  constructor: function constructor(attrs) {
	    var _this2 = this;
	
	    Object.keys(attrs).forEach(function (key) {
	      _this2[key] = attrs[key];
	    });
	  }
	}, {
	  variants: {
	
	    /**
	      * Image variants available for an image. An example value of `imageVariant`:
	      * ```
	      * [
	      *   {
	      *     "name": "pico",
	      *     "dimensions": "16x16",
	      *     "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/alien_146ef7c1-26e9-4e96-96e6-9d37128d0005_pico.jpg?v=1469046423"
	      *   },
	      *   {
	      *     "name": "compact",
	      *     "dimensions": "160x160",
	      *     "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/alien_146ef7c1-26e9-4e96-96e6-9d37128d0005_compact.jpg?v=1469046423"
	      *   }
	      * ]
	      * ```
	      *
	      * @attribute variants
	      * @type {Array}
	    */
	    get: function get() {
	      var src = this.src;
	      var extensionIndex = src.lastIndexOf('.');
	      var pathAndBasename = src.slice(0, extensionIndex);
	      var extension = src.slice(extensionIndex);
	
	      variants.forEach(function (variant) {
	        variant.src = pathAndBasename + '_' + variant.name + extension;
	      });
	
	      return variants;
	    },
	    configurable: true,
	    enumerable: true
	  }
	}));
	
	/**
	  * Model for product variant
	  * @class ProductVariantModel
	  * @constructor
	*/
	var ProductVariantModel = BaseModel.extend(Object.defineProperties({
	  constructor: function constructor() {
	    this['super'].apply(this, arguments);
	  },
	
	
	  /**
	    * Get a checkout url for a specific product variant. You can
	    * optionally pass a quantity. If no quantity is passed then quantity
	    * will default to 1. The example below will grab a checkout url for
	    * 3 copies of the first variant:
	    * ```
	    * const checkoutURL = product.variants[ 0 ].checkoutUrl(3);
	    * ```
	    *
	    * @method checkoutUrl
	    * @param {Number} [quantity = 1] quantity of variants
	    * @public
	    * @return {String} Checkout URL
	  */
	  checkoutUrl: function checkoutUrl() {
	    var quantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	    var config = this.config;
	    var baseUrl = 'https://' + config.domain + '/cart';
	
	    var variantPath = this.id + ':' + parseInt(quantity, 10);
	
	    var query = 'access_token=' + config.accessToken + '&_fd=0';
	
	    return baseUrl + '/' + variantPath + '?' + query;
	  }
	}, {
	  id: {
	
	    /**
	      * Variant unique ID
	      * @property id
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs.variant.id;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  productId: {
	
	    /**
	      * ID of product variant belongs to
	      * @property productId
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs.product.id;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  title: {
	
	    /**
	      * Title of variant
	      * @property title
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs.variant.title;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  productTitle: {
	
	    /**
	      * Title of product variant belongs to
	      * @property productTitle
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs.product.title;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  compareAtPrice: {
	
	    /**
	      * Compare at price for variant. The `compareAtPrice` would be
	      * the price of the product previously before the product went on sale. For more info
	      * go <a href="https://docs.shopify.com/manual/products/promoting-marketing/sales" target="_blank">here</a>.
	      *
	      * If no `compareAtPrice` is set then this value will be `null`. An example value: `"5.00"`
	      * @property compareAtPrice
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs.variant.compare_at_price;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  price: {
	
	    /**
	      * Price of the variant. The price will be in the following form: `"10.00"`
	      *
	      * @property price
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs.variant.price;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  formattedPrice: {
	
	    /**
	      * Price of variant, formatted according to shop currency format string.
	      * For instance `"$10.00"`
	      *
	      * @property formattedPrice
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs.variant.formatted_price;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  grams: {
	
	    /**
	      * Variant weight in grams. If no weight is defined grams will be `0`.
	      * @property grams
	      * @type {Number}
	    */
	    get: function get() {
	      return this.attrs.variant.grams;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  optionValues: {
	
	    /**
	      * Option values associated with this variant. Example `optionValues`:
	      * ```
	      * [
	      *   {
	      *     "name": "Size",
	      *     "option_id": 9165336518,
	      *     "value": "small"
	      *   },
	      *   {
	      *     "name": "Color",
	      *     "option_id": 9640532358,
	      *     "value": "blue"
	      *   }
	      * ]
	      * ````
	      *
	      * @property optionValues
	      * @type {Array|Object}
	    */
	    get: function get() {
	      return this.attrs.variant.option_values;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  available: {
	
	    /**
	      * Variant in stock. Always `true` if inventory tracking is disabled.
	      * @property available
	      * @type {Boolean}
	    */
	    get: function get() {
	      return this.attrs.variant.available;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  image: {
	
	    /**
	      * Image for variant. An example image `Object`:
	      * ```
	      * {
	      *   created_at: "2016-08-29T12:35:09-04:00",
	      *   id: 17690553350,
	      *   position: 1,
	      *   product_id: 8291029446,
	      *   src: "https://cdn.shopify.com/s/files/1/1019/0495/products/i11_c3334325-2d67-4623-8cd4-0a6b08aa1b83.jpg?v=1472488509",
	      *   updated_at: "2016-08-29T12:35:09-04:00",
	      *   variant_ids: [ 27690103238 ]
	      * }
	      * ```
	      *
	      * @property image
	      * @type {Object}
	    */
	    get: function get() {
	      var id = this.id;
	      var images = this.attrs.product.images;
	
	      var primaryImage = images[0];
	      var variantImage = images.filter(function (image) {
	        return image.variant_ids.indexOf(id) !== -1;
	      })[0];
	
	      var image = variantImage || primaryImage;
	
	      if (!image) {
	        return null;
	      }
	
	      return new ImageModel(image);
	    },
	    configurable: true,
	    enumerable: true
	  },
	  imageVariants: {
	
	    /**
	      * Image variants available for a variant. An example value of `imageVariant`:
	      * ```
	      * [
	      *   {
	      *     "name": "pico",
	      *     "dimensions": "16x16",
	      *     "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/alien_146ef7c1-26e9-4e96-96e6-9d37128d0005_pico.jpg?v=1469046423"
	      *   },
	      *   {
	      *     "name": "compact",
	      *     "dimensions": "160x160",
	      *     "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/alien_146ef7c1-26e9-4e96-96e6-9d37128d0005_compact.jpg?v=1469046423"
	      *   }
	      * ]
	      * ```
	      *
	      * @property imageVariant
	      * @type {Array}
	    */
	    get: function get() {
	      if (!this.image) {
	        return [];
	      }
	
	      return this.image.variants;
	    },
	    configurable: true,
	    enumerable: true
	  }
	}));
	
	var uniq = function uniq(array) {
	  return array.reduce(function (uniqueArray, item) {
	    if (uniqueArray.indexOf(item) < 0) {
	      uniqueArray.push(item);
	    }
	
	    return uniqueArray;
	  }, []);
	};
	
	var NO_IMAGE_URI = 'https://widgets.shopifyapps.com/assets/no-image.svg';
	
	/**
	   * Class for products returned by fetch('product')
	   * @class ProductModel
	   * @constructor
	 */
	var ProductModel = BaseModel.extend(Object.defineProperties({
	  constructor: function constructor() {
	    this['super'].apply(this, arguments);
	  }
	}, {
	  id: {
	
	    /**
	      * Product unique ID
	      *
	      * @property id
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs.product_id;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  title: {
	
	    /**
	      * The product title
	      * @property title
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs.title;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  description: {
	
	    /**
	      * A product description.
	      * @property description
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs.body_html;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  images: {
	
	    /**
	      * An `Array` of `Objects` that contain meta data about an image including `src` of the images.
	      *
	      * An example image `Object`:
	      * ```
	      * {
	      *   created_at: "2016-08-29T12:35:09-04:00",
	      *   id: 17690553350,
	      *   position: 1,
	      *   product_id: 8291029446,
	      *   src: "https://cdn.shopify.com/s/files/1/1019/0495/products/i11_c3334325-2d67-4623-8cd4-0a6b08aa1b83.jpg?v=1472488509",
	      *   updated_at: "2016-08-29T12:35:09-04:00",
	      *   variant_ids: [ 27690103238 ]
	      * }
	      * ```
	      * @property images
	      * @type {Array} array of image objects.
	    */
	    get: function get() {
	      return this.attrs.images.map(function (image) {
	        return new ImageModel(image);
	      });
	    },
	    configurable: true,
	    enumerable: true
	  },
	  memoized: {
	    get: function get() {
	      this._memoized = this._memoized || {};
	
	      return this._memoized;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  options: {
	
	    /**
	     *  Get an array of {{#crossLink "ProductOptionModel"}}ProductOptionModels{{/crossLink}}.
	     *  {{#crossLink "ProductOptionModel"}}ProductOptionModels{{/crossLink}} can be used to
	     *  define the currently `selectedVariant` from which you can get a checkout url
	     *  ({{#crossLink "ProductVariantModel/checkoutUrl"}}ProductVariantModel.checkoutUrl{{/crossLink}}) or can
	     *  be added to a cart ({{#crossLink "CartModel/createLineItemsFromVariants"}}CartModel.createLineItemsFromVariants{{/crossLink}}).
	     *
	     *  Below is an example on how to create html for option selections:
	     * ```javascript
	     *  // the following will create an Array of HTML to create multiple select inputs
	     *  // global callbacks are also created which will set the option as selected
	     *  var elements = product.options.map(function(option) {
	     *    // we'll create a callback in global scope
	     *    // which will be called when the select's value changes
	     *    var callBackName = option.name + 'onChange';
	     *    window[ callBackName ] = function(select) {
	     *      // set the products option to be selected
	     *      option.selected = select.value;
	     *    };
	     *
	     *    // return a string which will be HTML for the select
	     *    return '<select name="' + option.name + '" onchange="'callBackName'(this)">' + option.values.map(function(value) {
	     *      return '<option value="' + value + '">' + value + '</option>';
	     *    }) + '</select>';
	     *  });
	     * ```
	     *
	     * @property options
	     * @type {Array|ProductOptionModel}
	     */
	    get: function get() {
	      if (this.memoized.options) {
	        return this.memoized.options;
	      }
	
	      var baseOptions = this.attrs.options;
	      var variants$$1 = this.variants;
	
	      this.memoized.options = baseOptions.map(function (option) {
	        var name = option.name;
	
	        var dupedValues = variants$$1.reduce(function (valueList, variant) {
	          var optionValueForOption = variant.optionValues.filter(function (optionValue) {
	            return optionValue.name === option.name;
	          })[0];
	
	          valueList.push(optionValueForOption.value);
	
	          return valueList;
	        }, []);
	
	        var values = uniq(dupedValues);
	
	        return new ProductOptionModel({ name: name, values: values });
	      });
	
	      return this.memoized.options;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  variants: {
	
	    /**
	      * An `Array` of {{#crossLink "ProductVariantModel"}}ProductVariantModel's{{/crossLink}}
	      * @property variants
	      * @type {Array|ProductVariantModel} array of ProductVariantModel instances.
	    */
	    get: function get() {
	      var _this3 = this;
	
	      return this.attrs.variants.map(function (variant) {
	        return new ProductVariantModel({ variant: variant, product: _this3 }, { config: _this3.config });
	      });
	    },
	    configurable: true,
	    enumerable: true
	  },
	  selections: {
	
	    /**
	      * A read only `Array` of Strings represented currently selected option values. eg. `["Large", "Red"]`
	      * @property selections
	      * @type {Array | String}
	    */
	    get: function get() {
	      return this.options.map(function (option) {
	        return option.selected;
	      });
	    },
	    configurable: true,
	    enumerable: true
	  },
	  selectedVariant: {
	
	    /**
	      * Retrieve variant for currently selected options. By default the first value in each
	      * option is selected which means `selectedVariant` will never be `null`.
	      *
	      * With a `selectedVariant` you can create checkout url
	      * ({{#crossLink "ProductVariantModel/checkoutUrl"}}ProductVariantModel.checkoutUrl{{/crossLink}}) or it can
	      * be added to a cart ({{#crossLink "CartModel/createLineItemsFromVariants"}}CartModel.createLineItemsFromVariants{{/crossLink}}).
	      *
	      * @property selectedVariant
	      * @type {ProductVariantModel}
	    */
	    get: function get() {
	      var variantTitle = this.selections.join(' / ');
	
	      return this.variants.filter(function (variant) {
	        return variant.title === variantTitle;
	      })[0] || null;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  selectedVariantImage: {
	
	    /**
	      * Retrieve image for currently selected variantImage. An example image Object would look like this:
	      * ```
	      * {
	      *   created_at: "2016-08-29T12:35:09-04:00",
	      *   id: 17690553350,
	      *   position: 1,
	      *   product_id: 8291029446,
	      *   src: "https://cdn.shopify.com/s/files/1/1019/0495/products/i11_c3334325-2d67-4623-8cd4-0a6b08aa1b83.jpg?v=1472488509",
	      *   updated_at: "2016-08-29T12:35:09-04:00",
	      *   variant_ids: [ 27690103238 ]
	      * }
	      * ```
	      *
	      * @property selectedVariantImage
	      * @type {Object}
	    */
	    get: function get() {
	      if (!this.selectedVariant) {
	        return null;
	      }
	
	      return this.selectedVariant.image;
	    },
	    configurable: true,
	    enumerable: true
	  }
	}));
	
	var ListingsSerializer = CoreObject.extend({
	  constructor: function constructor(config) {
	    this.config = config;
	  },
	  rootKeyForType: function rootKeyForType(type) {
	    return type.slice(0, -1) + '_listing';
	  },
	
	
	  models: {
	    collections: BaseModel,
	    products: ProductModel
	  },
	
	  modelForType: function modelForType(type) {
	    return this.models[type];
	  },
	  deserializeSingle: function deserializeSingle(type) {
	    var singlePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var metaAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var modelAttrs = singlePayload[this.rootKeyForType(type)];
	    var model = this.modelFromAttrs(type, modelAttrs, metaAttrs);
	
	    return model;
	  },
	  deserializeMultiple: function deserializeMultiple(type) {
	    var _this4 = this;
	
	    var collectionPayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var metaAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var models = collectionPayload[this.rootKeyForType(type) + 's'];
	
	    return models.map(function (attrs) {
	      var model = _this4.modelFromAttrs(type, attrs, metaAttrs);
	
	      return model;
	    });
	  },
	  modelFromAttrs: function modelFromAttrs(type, attrs, metaAttrs) {
	    var Model = this.modelForType(type);
	
	    metaAttrs.config = this.config;
	
	    return new Model(attrs, metaAttrs);
	  }
	});
	
	function authToUrl(url, opts) {
	  var authorization = void 0;
	
	  if (opts.headers) {
	    Object.keys(opts.headers).forEach(function (key) {
	      if (key.toLowerCase() === 'authorization') {
	        authorization = opts.headers[key];
	      }
	    });
	  }
	
	  if (authorization) {
	    var hashedKey = authorization.split(' ').slice(-1)[0];
	
	    try {
	      var plainKey = atob(hashedKey);
	
	      var newUrl = void 0;
	
	      if (url.indexOf('?') > -1) {
	        newUrl = url + '&_x_http_authorization=' + plainKey;
	      } else {
	        newUrl = url + '?_x_http_authorization=' + plainKey;
	      }
	
	      return newUrl;
	    } catch (e) {
	      // atob choked on non-encoded data. Therefore, not a form of auth we
	      // support.
	      //
	      // NOOP
	      //
	    }
	  }
	
	  /* eslint newline-before-return: 0 */
	  return url;
	}
	
	function ie9Ajax(method, url, opts) {
	  return new Promise(function (resolve, reject) {
	    var xdr = new XDomainRequest();
	
	    xdr.onload = function () {
	      try {
	        var json = JSON.parse(xdr.responseText);
	
	        resolve({ json: json, originalResponse: xdr, isJSON: true });
	      } catch (e) {
	        resolve({ text: xdr.responseText, originalResponse: xdr, isText: true });
	      }
	    };
	
	    function handleError() {
	      reject(new Error('There was an error with the XDR'));
	    }
	
	    xdr.onerror = handleError;
	    xdr.ontimeout = handleError;
	
	    xdr.open(method, authToUrl(url, opts));
	    xdr.send(opts.data);
	  });
	}
	
	function isNodeLikeEnvironment() {
	  var windowAbsent = typeof window === 'undefined';
	  var requirePresent = "function" === 'function';
	
	  return windowAbsent && requirePresent;
	}
	
	function checkStatus(response) {
	  if (response.status >= 200 && response.status < 300) {
	    return response;
	  }
	
	  var error = new Error(response.statusText);
	
	  error.status = response.status;
	  error.response = response;
	  throw error;
	}
	
	function parseResponse(response) {
	  return response.json().then(function (json) {
	    return { json: json, originalResponse: response, isJSON: true };
	  })['catch'](function () {
	    var responseClone = response.clone();
	
	    return responseClone.text().then(function (text) {
	      return { text: text, originalResponse: responseClone, isText: true };
	    });
	  });
	}
	
	function ajax(method, url) {
	  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  // we need to check that we're not running in Node
	  // before we should check if this is ie9
	  if (!isNodeLikeEnvironment()) {
	    var xhr = new XMLHttpRequest();
	
	    if (!('withCredentials' in xhr)) {
	      return ie9Ajax.apply(undefined, arguments);
	    }
	  }
	
	  opts.method = method;
	  opts.mode = 'cors';
	
	  return fetch(url, opts).then(checkStatus).then(parseResponse);
	}
	
	var ListingsAdapter = CoreObject.extend(Object.defineProperties({
	  ajax: ajax,
	
	  constructor: function constructor(config) {
	    this.config = config;
	  },
	  pathForType: function pathForType(type) {
	    return '/' + type.slice(0, -1) + '_listings';
	  },
	  buildUrl: function buildUrl(singleOrMultiple, type, idOrQuery) {
	    switch (singleOrMultiple) {
	      case 'multiple':
	        return this.buildMultipleUrl(type, idOrQuery);
	      case 'single':
	        return this.buildSingleUrl(type, idOrQuery);
	      default:
	        return '';
	    }
	  },
	  buildMultipleUrl: function buildMultipleUrl(type) {
	    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var url = '' + this.baseUrl + this.pathForType(type);
	    var paramNames = Object.keys(query);
	
	    if (paramNames.length > 0) {
	      var queryString = paramNames.map(function (key) {
	        var value = void 0;
	
	        if (Array.isArray(query[key])) {
	          value = query[key].join(',');
	        } else {
	          value = query[key];
	        }
	
	        return key + '=' + encodeURIComponent(value);
	      }).join('&');
	
	      return url + '?' + queryString;
	    }
	
	    return url;
	  },
	  buildSingleUrl: function buildSingleUrl(type, id) {
	    return '' + this.baseUrl + this.pathForType(type) + '/' + id;
	  },
	  fetchMultiple: function fetchMultiple() /* type, [query] */{
	    var url = this.buildUrl.apply(this, ['multiple'].concat(Array.prototype.slice.call(arguments)));
	
	    return this.ajax('GET', url, { headers: this.headers }).then(function (response) {
	      return response.json;
	    });
	  },
	  fetchSingle: function fetchSingle() /* type, id */{
	    var url = this.buildUrl.apply(this, ['single'].concat(Array.prototype.slice.call(arguments)));
	
	    return this.ajax('GET', url, { headers: this.headers }).then(function (response) {
	      return response.json;
	    });
	  }
	}, {
	  base64AccessToken: {
	    get: function get() {
	      return btoa(this.config.accessToken);
	    },
	    configurable: true,
	    enumerable: true
	  },
	  baseUrl: {
	    get: function get() {
	      var _config = this.config,
	          domain = _config.domain,
	          appId = _config.appId;
	
	
	      return 'https://' + domain + '/api/apps/' + appId;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  headers: {
	    get: function get() {
	      return assign$1({}, {
	        Authorization: 'Basic ' + this.base64AccessToken,
	        'Content-Type': 'application/json',
	        'X-SDK-Variant': 'javascript',
	        'X-SDK-Version': version
	
	      }, this.config.ajaxHeaders);
	    },
	    configurable: true,
	    enumerable: true
	  }
	}));
	
	var GUID_KEY = 'shopify-buy-uuid';
	
	/**
	 * A cart stores an Array of `CartLineItemModel`'s in it's `lineItems` property.
	 * @class CartLineItemModel
	 * @constructor
	 */
	var CartLineItemModel = BaseModel.extend(Object.defineProperties({
	  constructor: function constructor() {
	    this['super'].apply(this, arguments);
	  }
	}, {
	  id: {
	
	    /**
	     * A line item ID.
	     * @property id
	     * @readOnly
	     * @type {String}
	     */
	    get: function get() {
	      return this.attrs[GUID_KEY];
	    },
	    configurable: true,
	    enumerable: true
	  },
	  variant_id: {
	
	    /**
	     * ID of line item variant.
	     * @property variant_id
	     * @readOnly
	     * @type {String}
	     */
	    get: function get() {
	      return this.attrs.variant_id;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  product_id: {
	
	    /**
	     * ID of variant's product.
	     * @property product_id
	     * @readOnly
	     * @type {String}
	     */
	    get: function get() {
	      return this.attrs.product_id;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  image: {
	
	    /**
	     * Variant's image.
	     * Example `Object` returned:
	     * ```
	     * {
	     *    "id": 18723183238,
	     *    "created_at": "2016-09-14T17:12:12-04:00",
	     *    "position": 1,
	     *    "updated_at": "2016-09-14T17:12:12-04:00",
	     *    "product_id": 8569911558,
	     *    "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/Mop__three_different_mop_handles.jpg?v=1473887532",
	     *    "variant_ids": []
	     *  }
	     * ```
	     * @property image
	     * @readOnly
	     * @type {Object}
	     */
	    get: function get() {
	      if (!this.attrs.image) {
	        return null;
	      }
	
	      return new ImageModel(this.attrs.image);
	    },
	    configurable: true,
	    enumerable: true
	  },
	  imageVariants: {
	
	    /**
	      * Image variants available for a variant. An example value of `imageVariant`:
	      * ```
	      * [
	      *   {
	      *     "name": "pico",
	      *     "dimensions": "16x16",
	      *     "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/alien_146ef7c1-26e9-4e96-96e6-9d37128d0005_pico.jpg?v=1469046423"
	      *   },
	      *   {
	      *     "name": "compact",
	      *     "dimensions": "160x160",
	      *     "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/alien_146ef7c1-26e9-4e96-96e6-9d37128d0005_compact.jpg?v=1469046423"
	      *   }
	      * ]
	      * ```
	      *
	      * @property imageVariant
	      * @type {Array}
	    */
	    get: function get() {
	      if (!this.image) {
	        return [];
	      }
	
	      return this.image.variants;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  title: {
	
	    /**
	     * Product title of variant's parent product.
	     * @property title
	     * @readOnly
	     * @type {String}
	     */
	    get: function get() {
	      return this.attrs.title;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  quantity: {
	
	    /**
	     * Count of variants to order.
	     * @property quantity
	     * @type {Number}
	     */
	    get: function get() {
	      return this.attrs.quantity;
	    },
	    set: function set(value) {
	      var parsedValue = parseInt(value, 10);
	
	      if (parsedValue < 0) {
	        throw new Error('Quantities must be positive');
	      } else if (parsedValue !== parseFloat(value)) {
	        /* incidentally, this covers all NaN values, because NaN !== Nan */
	        throw new Error('Quantities must be whole numbers');
	      }
	
	      this.attrs.quantity = parsedValue;
	
	      return this.attrs.quantity;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  properties: {
	
	    /**
	     * Customization information for a product.
	     * <a href="https://help.shopify.com/themes/customization/products/get-customization-information-for-products" target="_blank">
	     * See here for more info
	     * </a>.
	     * @property properties
	     * @type {Object}
	     * @private
	     */
	    get: function get() {
	      return this.attrs.properties || {};
	    },
	    set: function set(value) {
	      this.attrs.properties = value || {};
	
	      return value;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  variant_title: {
	
	    /**
	     * Title of variant.
	     * @property variant_title
	     * @readOnly
	     * @type {String}
	     */
	    get: function get() {
	      return this.attrs.variant_title;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  price: {
	
	    /**
	     * Price of the variant. For example: `"5.00"`.
	     * @property price
	     * @readOnly
	     * @type {String}
	     */
	    get: function get() {
	      return this.attrs.price;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  compare_at_price: {
	
	    /**
	      * Compare at price for variant. The `compareAtPrice` would be
	      * the price of the product previously before the product went on sale. For more info
	      * go <a href="https://docs.shopify.com/manual/products/promoting-marketing/sales" target="_blank">here</a>.
	      *
	      * If no `compareAtPrice` is set then this value will be `null`. An example value: `"5.00"`.
	      * @property compareAtPrice
	      * @readOnly
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs.compare_at_price;
	    },
	    configurable: true,
	    enumerable: true
	  },
	  line_price: {
	
	    /**
	     * The total price for this line item. For instance if the variant costs `1.50` and you have a quantity
	     * of 2 then `line_price` will be `3.00`.
	     * @property line_price
	     * @readOnly
	     * @type {String}
	     */
	    get: function get() {
	      return (this.quantity * parseFloat(this.price)).toFixed(2);
	    },
	    configurable: true,
	    enumerable: true
	  },
	  grams: {
	
	    /**
	     * Variant's weight in grams. If no weight is set then `0` is returned.
	     * @property grams
	     * @readOnly
	     * @type {Number}
	     */
	    get: function get() {
	      return this.attrs.grams;
	    },
	    configurable: true,
	    enumerable: true
	  }
	}));
	
	/* eslint no-undefined: 0 complexity: 0 */
	var GUID_PREFIX = 'shopify-buy.' + Date.now();
	
	var GUID_DESC = {
	  writable: true,
	  configurable: true,
	  enumerable: true,
	  value: null
	};
	
	var uuidSeed = 0;
	
	function uuid() {
	  return ++uuidSeed;
	}
	
	var numberCache = {};
	var stringCache = {};
	
	function setGuidFor(obj) {
	  if (obj && obj[GUID_KEY]) {
	    return obj[GUID_KEY];
	  }
	
	  if (obj === undefined) {
	    return '(undefined)';
	  }
	
	  if (obj === null) {
	    return '(null)';
	  }
	
	  var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
	  var id = void 0;
	
	  switch (type) {
	    case 'number':
	      id = numberCache[obj];
	
	      if (!id) {
	        id = numberCache[obj] = 'nu' + obj;
	      }
	
	      break;
	
	    case 'string':
	      id = stringCache[obj];
	
	      if (!id) {
	        id = stringCache[obj] = 'st' + uuid();
	      }
	
	      break;
	
	    case 'boolean':
	      if (obj) {
	        id = '(true)';
	      } else {
	        id = '(false)';
	      }
	
	      break;
	
	    default:
	      if (obj === Object) {
	        id = '(Object)';
	        break;
	      }
	
	      if (obj === Array) {
	        id = '(Array)';
	        break;
	      }
	
	      id = GUID_PREFIX + '.' + uuid();
	
	      if (obj[GUID_KEY] === null) {
	        obj[GUID_KEY] = id;
	      } else {
	        GUID_DESC.value = id;
	        Object.defineProperty(obj, GUID_KEY, GUID_DESC);
	      }
	  }
	
	  return id;
	}
	
	/* global global */
	
	var globalNamespace = void 0;
	
	if (typeof global === 'undefined') {
	  globalNamespace = window;
	} else {
	  globalNamespace = global;
	}
	
	function set(key, value) {
	  if (!globalNamespace[key]) {
	    globalNamespace[key] = value;
	  }
	}
	
	function get(key) {
	  return globalNamespace[key];
	}
	
	var globalVars = { set: set, get: get };
	
	function objectsEqual(one, two) {
	  if (one === two) {
	    return true;
	  }
	
	  return Object.keys(one).every(function (key) {
	    if (one[key] instanceof Date) {
	      return one[key].toString() === two[key].toString();
	    } else if (_typeof(one[key]) === 'object') {
	      return objectsEqual(one[key], two[key]);
	    }
	
	    return one[key] === two[key];
	  });
	}
	
	/**
	* Class for cart model
	* @class CartModel
	*/
	var CartModel = BaseModel.extend(Object.defineProperties({
	  constructor: function constructor() {
	    this['super'].apply(this, arguments);
	  },
	
	
	  /**
	    * Add items to the cart. Updates cart's `lineItems` based on variants passed in.
	    * ```javascript
	    * cart.addVariants({variant: variantObject, quantity: 1}).then(cart => {
	    *   // the cart has created line items
	    * });
	    * ```
	    * @deprecated `createLineItemsFromVariants` will be used in the future as it's more descriptive
	    * @method addVariants
	    * @param {Object} item - One or more variants
	    * @param {ProductVariantModel} item.variant - variant object
	    * @param {Number} item.quantity - quantity
	    * @param {Object} [moreItems...] - further objects defining `variant` and `quantity` maybe passed in
	    * @private
	    * @return {Promise|CartModel} - the cart instance.
	  */
	  addVariants: function addVariants() {
	    logger.warn('CartModel - ', 'addVariants is deprecated, please use createLineItemsFromVariants instead');
	
	    return this.createLineItemsFromVariants.apply(this, arguments);
	  },
	
	
	  /**
	    * Add items to the cart. Updates cart's `lineItems` based on variants passed in.
	    * ```javascript
	    * cart.createLineItemsFromVariants({variant: variantObject, quantity: 1}).then(cart => {
	    *   // the cart has created line items
	    * });
	    * ```
	    * @method createLineItemsFromVariants
	    * @param {Object} item - One or more variants
	    * @param {ProductVariantModel} item.variant - variant object
	    * @param {Number} item.quantity - quantity
	    * @param {Object} [moreItems...] - further objects defining `variant` and `quantity` maybe passed in
	    * @public
	    * @return {Promise|CartModel} - the cart instance.
	  */
	  createLineItemsFromVariants: function createLineItemsFromVariants() {
	    var newLineItems = [].concat(Array.prototype.slice.call(arguments)).map(function (item) {
	      var lineItem = {
	        image: item.variant.image,
	        image_variants: item.variant.imageVariants,
	        variant_id: item.variant.id,
	        product_id: item.variant.productId,
	        title: item.variant.productTitle,
	        quantity: parseInt(item.quantity, 10),
	        properties: item.properties || {},
	        variant_title: item.variant.title,
	        price: item.variant.price,
	        compare_at_price: item.variant.compareAtPrice,
	        grams: item.variant.grams
	      };
	
	      setGuidFor(lineItem);
	
	      return lineItem;
	    });
	    var existingLineItems = this.attrs.line_items;
	
	    existingLineItems.push.apply(existingLineItems, _toConsumableArray(newLineItems));
	
	    var dedupedLineItems = existingLineItems.reduce(function (itemAcc, item) {
	      var matchingItem = itemAcc.filter(function (existingItem) {
	        return existingItem.variant_id === item.variant_id && objectsEqual(existingItem.properties, item.properties);
	      })[0];
	
	      if (matchingItem) {
	        matchingItem.quantity = matchingItem.quantity + item.quantity;
	      } else {
	        itemAcc.push(item);
	      }
	
	      return itemAcc;
	    }, []);
	
	    // Users may pass negative numbers and remove items. This ensures there's no
	    // item with a quantity of zero or less.
	    this.attrs.line_items = dedupedLineItems.reduce(function (itemAcc, item) {
	      if (item.quantity >= 1) {
	        itemAcc.push(item);
	      }
	
	      return itemAcc;
	    }, []);
	
	    return this.updateModel();
	  },
	
	
	  /**
	    * Update a line item quantity based on line item id
	    * ```javascript
	    * // This example changes the quantity for the first line item to 2
	    * const firstLineItemId = cart.lineItems[0].id;
	    *
	    * cart.updateLineItem(firstLineItemId, 2).then(cart => {
	    *   // the cart has updated the line item
	    * });
	    * ```
	    * @method updateLineItem
	    * @param {String} id - line item ID
	    * @param {Number} quantity - new quantity for line item
	    * @throws {Error} if line item with ID is not in cart.
	    * @public
	    * @return {Promise|CartModel} - the cart instance
	  */
	  updateLineItem: function updateLineItem(id, quantity) {
	    if (quantity < 1) {
	      return this.removeLineItem(id);
	    }
	
	    var lineItem = this.lineItems.filter(function (item) {
	      return item.id === id;
	    })[0];
	
	    if (lineItem) {
	      lineItem.quantity = quantity;
	
	      return this.updateModel();
	    }
	
	    return new Promise(function (resolve, reject) {
	      reject(new Error('line item with id: ' + id + ' not found in cart#' + this.id));
	    });
	  },
	
	
	  /**
	    * Remove a line item from cart based on line item id
	    * ```javascript
	    * // This example removes the first line item
	    * const firstLineItemId = cart.lineItems[0].id;
	    *
	    * cart.removeLineItem(firstLineItemId).then(cart => {
	    *   // the cart has removed the line item
	    * });
	    * ```
	    *
	    * @method removeLineItem
	    * @param {String} id - line item ID
	    * @throws {Error} if line item with ID is not in cart.
	    * @public
	    * @return {Promise|CartModel} - the cart instance
	  */
	  removeLineItem: function removeLineItem(id) {
	    var oldLength = this.lineItems.length;
	    var newLineItems = this.lineItems.filter(function (item) {
	      return item.id !== id;
	    });
	    var newLength = newLineItems.length;
	
	    if (newLength < oldLength) {
	      this.attrs.line_items = newLineItems.map(function (item) {
	        return item.attrs;
	      });
	
	      return this.updateModel();
	    }
	
	    return new Promise(function (resolve, reject) {
	      reject(new Error('line item with id: ' + id + ' not found in cart#' + this.id));
	    });
	  },
	
	
	  /**
	    * Remove all line items from cart
	    * ```javascript
	    * // This example removes all line items from the cart
	    * cart.clearLineItems().then(cart => {
	    *   // the cart has removed all line items
	    * });
	    * @method clearLineItems
	    * @public
	    * @return {Promise|CartModel} - the cart instance
	  */
	  clearLineItems: function clearLineItems() {
	    this.attrs.line_items = [];
	
	    return this.updateModel();
	  },
	
	
	  /**
	    * Force update of cart model on server. This function will only be used in advanced situations and does not need to be called
	    * explicitly to update line items. It is automatically called after
	    * {{#crossLink "CartModel/createLineItemsFromVariants"}}{{/crossLink}},
	    * {{#crossLink "CartModel/updateLineItem"}}{{/crossLink}},
	    * {{#crossLink "CartModel/removeLineItem"}}{{/crossLink}},
	    * and {{#crossLink "CartModel/removeLineItem"}}{{/crossLink}}
	    *
	    * @method updateModel
	    * @public
	    * @return {Promise|CartModel} - the cart instance
	  */
	  updateModel: function updateModel() {
	    var _this5 = this;
	
	    return this.shopClient.update('carts', this).then(function (updateCart) {
	      assign$1(_this5.attrs, updateCart.attrs);
	
	      return _this5;
	    });
	  }
	}, {
	  id: {
	
	    /**
	      * get ID for current cart
	      * @property id
	      * @readOnly
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs[GUID_KEY];
	    },
	    configurable: true,
	    enumerable: true
	  },
	  lineItems: {
	
	    /**
	      * Get an `Array` of {{#crossLink "CartLineItemModel"}}CartLineItemModel's{{/crossLink}}
	      * @property lineItems
	      * @readOnly
	      * @type {Array}
	    */
	    get: function get() {
	      return (this.attrs.line_items || []).map(function (item) {
	        return new CartLineItemModel(item);
	      });
	    },
	    configurable: true,
	    enumerable: true
	  },
	  lineItemCount: {
	
	    /**
	      * Gets the total quantity of all line items. Example: you've added two variants with quantities 3 and 2. `lineItemCount` will be 5.
	      * @property lineItemCount
	      * @readOnly
	      * @type {Number}
	    */
	    get: function get() {
	      return this.lineItems.reduce(function (total, item) {
	        return total + item.quantity;
	      }, 0);
	    },
	    configurable: true,
	    enumerable: true
	  },
	  subtotal: {
	
	    /**
	      * Get current subtotal price for all line items. Example: two items have been added to the cart that cost $1.25
	      * then the subtotal will be `2.50`
	      *
	      * @property subtotal
	      * @readOnly
	      * @type {String}
	    */
	    get: function get() {
	      var subtotal = this.lineItems.reduce(function (runningTotal, lineItem) {
	        return runningTotal + parseFloat(lineItem.line_price);
	      }, 0);
	
	      return subtotal.toFixed(2);
	    },
	    configurable: true,
	    enumerable: true
	  },
	  checkoutUrl: {
	
	    /**
	      * Get checkout URL for current cart
	      * @property checkoutUrl
	      * @readOnly
	      * @type {String}
	    */
	    get: function get() {
	      var config = this.config;
	      var baseUrl = 'https://' + config.domain + '/cart';
	      var ga = globalVars.get('ga');
	
	      var variantPath = this.lineItems.map(function (item) {
	        return item.variant_id + ':' + item.quantity;
	      });
	
	      var query = 'access_token=' + config.accessToken + '&_fd=0';
	
	      if (typeof ga === 'function') {
	        var linkerParam = void 0;
	
	        ga(function (tracker) {
	          linkerParam = tracker.get('linkerParam');
	        });
	
	        if (linkerParam) {
	          query += '&' + linkerParam;
	        }
	      }
	
	      return baseUrl + '/' + variantPath + '?' + query;
	    },
	    configurable: true,
	    enumerable: true
	  }
	}));
	
	var CartSerializer = CoreObject.extend({
	  constructor: function constructor(config) {
	    this.config = config;
	  },
	  rootKeyForType: function rootKeyForType(type) {
	    return type.slice(0, -1);
	  },
	  modelForType: function modelForType() /* type */{
	    return CartModel;
	  },
	  deserializeSingle: function deserializeSingle(type) {
	    var singlePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var metaAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var modelAttrs = singlePayload[this.rootKeyForType(type)];
	    var model = this.modelFromAttrs(type, modelAttrs, metaAttrs);
	
	    return model;
	  },
	  modelFromAttrs: function modelFromAttrs(type, attrs, metaAttrs) {
	    var Model = this.modelForType(type);
	
	    metaAttrs.config = this.config;
	
	    return new Model(attrs, metaAttrs);
	  },
	  serialize: function serialize(type, model) {
	    var root = this.rootKeyForType(type);
	    var payload = {};
	    var attrs = assign$1({}, model.attrs);
	
	    payload[root] = attrs;
	
	    delete attrs.attributes;
	
	    Object.keys(attrs).forEach(function (key) {
	      var value = attrs[key];
	
	      if (value === null || typeof value === 'string' && value.length === 0) {
	        delete attrs[key];
	      }
	    });
	
	    return payload;
	  }
	});
	
	var ReferenceModel = BaseModel.extend(Object.defineProperties({
	
	  /**
	    * Class for reference model
	    * @private
	    * @class ReferenceModel
	    * @constructor
	  */
	  constructor: function constructor(attrs) {
	    if (Object.keys(attrs).indexOf('referenceId') < 0) {
	      throw new Error('Missing key referenceId of reference. References to null are not allowed');
	    }
	
	    this['super'].apply(this, arguments);
	  }
	}, {
	  id: {
	
	    /**
	      * get the ID for current reference (not what it refers to, but its own unique identifier)
	      * @property id
	      * @type {String}
	    */
	    get: function get() {
	      return this.attrs[GUID_KEY];
	    },
	    configurable: true,
	    enumerable: true
	  },
	  referenceId: {
	    get: function get() {
	      return this.attrs.referenceId;
	    },
	    set: function set(value) {
	      this.attrs.referenceId = value;
	
	      return value;
	    },
	    configurable: true,
	    enumerable: true
	  }
	}));
	
	var ReferenceSerializer = CoreObject.extend({
	  constructor: function constructor(config) {
	    this.config = config;
	  },
	  modelForType: function modelForType() /* type */{
	    return ReferenceModel;
	  },
	  deserializeSingle: function deserializeSingle(type) {
	    var singlePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var metaAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var Model = this.modelForType(type);
	
	    return new Model(singlePayload, metaAttrs);
	  },
	  serialize: function serialize(type, model) {
	    var attrs = assign$1({}, model.attrs);
	
	    return attrs;
	  }
	});
	
	var Store = CoreObject.extend({
	  constructor: function constructor() {
	    this.localStorageAvailable = this.storageAvailable('localStorage');
	    this.cache = {};
	  },
	  setItem: function setItem(key, value) {
	    if (this.localStorageAvailable) {
	      localStorage.setItem(key, JSON.stringify(value));
	    } else {
	      this.cache[key] = value;
	    }
	
	    return value;
	  },
	  getItem: function getItem(key) {
	    if (this.localStorageAvailable) {
	      var stringValue = localStorage.getItem(key);
	
	      try {
	        return JSON.parse(stringValue);
	      } catch (e) {
	        return null;
	      }
	    } else {
	      return this.cache[key] || null;
	    }
	  },
	  storageAvailable: function storageAvailable(type) {
	    try {
	      var storage = globalVars.get(type);
	      var x = '__storage_test__';
	
	      storage.setItem(x, x);
	      storage.removeItem(x);
	
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});
	
	var LocalStorageAdapter = CoreObject.extend({
	  constructor: function constructor() {
	    this.store = new Store();
	  },
	  idKeyForType: function idKeyForType() /* type */{
	    return GUID_KEY;
	  },
	  fetchSingle: function fetchSingle(type, id) {
	    var _this6 = this;
	
	    return new Promise(function (resolve, reject) {
	      var value = _this6.store.getItem(_this6.storageKey(type, id));
	
	      if (value === null) {
	        reject(new Error(type + '#' + id + ' not found'));
	
	        return;
	      }
	
	      resolve(value);
	    });
	  },
	  create: function create(type, payload) {
	    var _this7 = this;
	
	    return new Promise(function (resolve) {
	      var id = _this7.identify(payload);
	
	      _this7.store.setItem(_this7.storageKey(type, id), payload);
	      resolve(payload);
	    });
	  },
	  update: function update(type, id, payload) {
	    var _this8 = this;
	
	    return new Promise(function (resolve) {
	      _this8.store.setItem(_this8.storageKey(type, id), payload);
	      resolve(payload);
	    });
	  },
	  storageKey: function storageKey(type, id) {
	    return type + '.' + id;
	  },
	  identify: function identify(payload) {
	    var keys = Object.keys(payload);
	
	    if (keys.length === 1 && _typeof(payload[keys[0]]) === 'object') {
	      return setGuidFor(payload[keys[0]]);
	    }
	
	    return setGuidFor(payload);
	  }
	});
	
	/**
	 * @module shopify-buy
	 * @submodule shop-client
	 */
	
	function fetchFactory(fetchType, type) {
	  var func = void 0;
	
	  switch (fetchType) {
	    case 'all':
	      func = function func() {
	        return this.fetchAll(type);
	      };
	      break;
	    case 'one':
	      func = function func() {
	        return this.fetch.apply(this, [type].concat(Array.prototype.slice.call(arguments)));
	      };
	      break;
	    case 'query':
	      func = function func() {
	        return this.fetchQuery.apply(this, [type].concat(Array.prototype.slice.call(arguments)));
	      };
	      break;
	  }
	
	  return func;
	}
	
	var ShopClient = CoreObject.extend(Object.defineProperties({
	  /**
	   * @class ShopClient
	   * @constructor
	   */
	  constructor: function constructor(config) {
	    this.config = config;
	
	    this.serializers = {
	      products: ListingsSerializer,
	      collections: ListingsSerializer,
	      carts: CartSerializer,
	      references: ReferenceSerializer
	    };
	
	    this.adapters = {
	      products: ListingsAdapter,
	      collections: ListingsAdapter,
	      carts: LocalStorageAdapter,
	      references: LocalStorageAdapter
	    };
	  },
	
	
	  config: null,
	
	  /**
	   * Fetch all of a `type`, returning a promise.
	   *
	   * ```javascript
	   * client.fetchAll('products').then(products => {
	   *   // do things with products
	   * });
	   * ```
	   *
	   * @method fetchAll
	   * @private
	   * @param {String} type The pluralized name of the type, in lower case.
	   * @return {Promise|Array} a promise resolving with an array of `type`
	   */
	  fetchAll: function fetchAll(type) {
	    var _this9 = this;
	
	    var adapter = new this.adapters[type](this.config);
	
	    return adapter.fetchMultiple(type).then(function (payload) {
	      return _this9.deserialize(type, payload, adapter, null, { multiple: true });
	    });
	  },
	
	
	  /**
	   * Fetch one of a `type`, returning a promise.
	   *
	   * ```javascript
	   * client.fetch('products', 123).then(product => {
	   *   // do things with the product
	   * });
	   * ```
	   *
	   * @method fetch
	   * @private
	   * @param {String} type The pluralized name of the type, in lower case.
	   * @param {String|Number} id a unique identifier
	   * @return {Promise|BaseModel} a promise resolving with a single instance of
	   * `type` expressed as a `BaseModel`.
	   */
	  fetch: function fetch(type, id) {
	    var _this10 = this;
	
	    var adapter = new this.adapters[type](this.config);
	
	    return adapter.fetchSingle(type, id).then(function (payload) {
	      return _this10.deserialize(type, payload, adapter, null, { single: true });
	    });
	  },
	
	
	  /**
	   * Fetch many of a `type`, that match `query`
	   *
	   * ```javascript
	   * client.fetchQuery('products', { collection_id: 456 }).then(products => {
	   *   // do things with the products
	   * });
	   * ```
	   *
	   * @method fetchQuery
	   * @private
	   * @param {String} type The pluralized name of the type, in lower case.
	   * @param {Object} query a query sent to the api server.
	   * @return {Promise|Array} a promise resolving with an array of `type`.
	   */
	  fetchQuery: function fetchQuery(type, query) {
	    var _this11 = this;
	
	    var adapter = new this.adapters[type](this.config);
	
	    return adapter.fetchMultiple(type, query).then(function (payload) {
	      return _this11.deserialize(type, payload, adapter, null, { multiple: true });
	    });
	  },
	
	
	  /**
	   * Create an instance of `type`, optionally including `modelAttrs`.
	   *
	   * ```javascript
	   * client.create('carts', { line_items: [ ... ] }).then(cart => {
	   *   // do things with the cart.
	   * });
	   * ```
	   *
	   * @method create
	   * @private
	   * @param {String} type The pluralized name of the type, in lower case.
	   * @param {Object} [modelAttrs={}] attributes representing the internal state
	   * of the model to be persisted.
	   * @return {Promise|CartModel} a promise resolving with a single instance of
	   * `type`
	   */
	  create: function create(type) {
	    var _this12 = this;
	
	    var modelAttrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var adapter = new this.adapters[type](this.config);
	    var serializer = new this.serializers[type](this.config);
	    var Model = serializer.modelForType(type);
	    var model = new Model(modelAttrs, { shopClient: this });
	    var attrs = serializer.serialize(type, model);
	
	    return adapter.create(type, attrs).then(function (payload) {
	      return _this12.deserialize(type, payload, adapter, serializer, { single: true });
	    });
	  },
	
	
	  /**
	   * Create an instance of `type`, optionally including `attrs`.
	   *
	   * ```javascript
	   * client.create('carts', { line_items: [ ... ] }).then(cart => {
	   *   // do things with the cart.
	   * });
	   * ```
	   *
	   * @method update
	   * @private
	   * @param {String} type The pluralized name of the type, in lower case.
	   * @param {BaseModel} updatedModel The model that represents new state to
	   * to persist.
	   * @return {Promise|CartModel} a promise resolving with a single instance of
	   * `type`
	   */
	  update: function update(type, updatedModel) {
	    var _this13 = this;
	
	    var adapter = updatedModel.adapter;
	    var serializer = updatedModel.serializer;
	    var serializedModel = serializer.serialize(type, updatedModel);
	    var id = updatedModel.attrs[adapter.idKeyForType(type)];
	
	    return adapter.update(type, id, serializedModel).then(function (payload) {
	      return _this13.deserialize(type, payload, adapter, serializer, { single: true });
	    });
	  },
	
	
	  /**
	   * Proxy to serializer's deserialize.
	   *
	   * @method deserialize
	   * @private
	   * @param {String} type The pluralized name of the type, in lower case.
	   * @param {Object} payload The raw payload returned by the adapter.
	   * @param {BaseAdapter} adapter The adapter that yielded the payload.
	   * @param {BaseSerializer} existingSerializer The serializer to attach. If
	   * none is passed, then `this.deserialize` will create one for the type.
	   * @param {Object} opts Options that determine which deserialization method to
	   * use.
	   * @param {Boolean} opts.multiple true when the payload represents multiple
	   * models
	   * @param {Boolean} opts.single true when the payload represents one model.
	   * @return {BaseModel} an instance of `type` reified into a model.
	   */
	  deserialize: function deserialize(type, payload, adapter, existingSerializer) {
	    var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	    var serializer = existingSerializer || new this.serializers[type](this.config);
	    var meta = { shopClient: this, adapter: adapter, serializer: serializer, type: type };
	    var serializedPayload = void 0;
	
	    if (opts.multiple) {
	      serializedPayload = serializer.deserializeMultiple(type, payload, meta);
	    } else {
	      serializedPayload = serializer.deserializeSingle(type, payload, meta);
	    }
	
	    return serializedPayload;
	  },
	
	
	  /**
	    * Creates a {{#crossLink "CartModel"}}CartModel{{/crossLink}} instance.
	    *
	    * ```javascript
	    * client.createCart().then(cart => {
	    *   // do something with cart
	    * });
	    * ```
	    *
	    * @method createCart
	    * @public
	    * @return {Promise|CartModel} - new cart instance.
	  */
	  createCart: function createCart() {
	    var userAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var baseAttrs = {
	      line_items: []
	    };
	    var attrs = {};
	
	    assign$1(attrs, baseAttrs);
	    assign$1(attrs, userAttrs);
	
	    return this.create('carts', attrs);
	  },
	
	
	  /**
	    * Updates an existing {{#crossLink "CartModel"}}CartModel{{/crossLink}} instance and persists it to localStorage.
	    *
	    * ```javascript
	    * client.createCart().then(cart => {
	    *   cart.lineItems = [
	    *     // ...
	    *   ];
	    *   client.updateCart(cart);
	    * });
	    * ```
	    *
	    * @param {CartModel} updatedCart an updated CartModel
	    * @method updateCart
	    * @private
	    * @return {Promise|CartModel} - updated cart instance.
	  */
	  updateCart: function updateCart(updatedCart) {
	    return this.update('carts', updatedCart);
	  },
	
	
	  /**
	   * Retrieve a previously created cart by its key.
	   *
	   * ```javascript
	   * client.fetchCart('shopify-buy.1459804699118.2').then(cart => {
	   *   console.log(cart); // The retrieved cart
	   * });
	   *
	   * @method fetchCart
	   * @public
	   * @param {String} id The cart's unique identifier
	   * @return {Promise|CartModel} The cart model.
	   *
	   */
	  fetchCart: fetchFactory('one', 'carts'),
	
	  /**
	   * This function will return an `Array` of products from your store
	   * ```
	   * client.fetchAllProducts()
	   * .then(function(products) {
	   *   // all products in store
	   * });
	   * ```
	   *
	   * @method fetchAllProducts
	   * @public
	   * @return {Promise|Array} The product models.
	   */
	  fetchAllProducts: fetchFactory('all', 'products'),
	
	  /**
	   * This function will return an `Array` of collections from your store
	   * ```
	   * client.fetchAllCollections()
	   * .then(function(collections) {
	   *
	   * });
	   * ```
	   *
	   * @method fetchAllCollections
	   * @public
	   * @return {Promise|Array} The collection models.
	   */
	  fetchAllCollections: fetchFactory('all', 'collections'),
	
	  /**
	   * Fetch one product by its ID.
	   *
	   * ```javascript
	   * client.fetchProduct('8569911558').then(product => {
	   *   console.log(product); // The product with an ID of '8569911558'
	   * });
	   * ```
	   *
	   * @method fetchProduct
	   * @public
	   * @param {String|Number} id a unique identifier
	   * @return {Promise|BaseModel} The product model with the specified ID.
	   */
	  fetchProduct: fetchFactory('one', 'products'),
	
	  /**
	   * Fetch one collection by its ID.
	   *
	   * ```javascript
	   * client.fetchCollection('336903494').then(collection => {
	   *   console.log(collection); // The collection with an ID of '336903494'
	   * });
	   * ```
	   *
	   * @method fetchCollection
	   * @public
	   * @param {String|Number} id a unique identifier
	   * @return {Promise|BaseModel} The collection model with the specified ID.
	   */
	  fetchCollection: fetchFactory('one', 'collections'),
	
	  /**
	   * Fetches a list of products matching a specified query.
	   *
	   * ```javascript
	   * client.fetchQueryProducts({ collection_id: '336903494', tag: ['hats'] }).then(products => {
	   *   console.log(products); // An array of products in collection '336903494' having the tag 'hats'
	   * });
	   * ```
	   * @method fetchQueryProducts
	   * @public
	   * @param {Object} query A query sent to the api server containing one or more of:
	   *   @param {String|Number} [query.collection_id] The ID of a collection to retrieve products from
	   *   @param {Array} [query.tag] A list of tags to filter the products by. Accepts up to 10 tags.
	   *   @param {Array} [query.product_ids] A list of product IDs to retrieve
	   *   @param {String|Number} [query.page=1] The page offset number of the current lookup (based on the `limit`)
	   *   @param {String|Number} [query.limit=50] The number of products to retrieve per page
	   *   @param {String} [query.handle] The handle of the product to look up
	   *   @param {String} [query.updated_at_min] Products updated since the supplied timestamp (format: 2008-12-31 03:00)
	   *   @param {String} [query.sort_by] Will modify how products are ordered. Possible values are:
	   *                                   `"updated_at"`, `"best-selling"`, `"title-ascending"`, `"title-descending"`,
	   *                                   `"price-descending"`, `"price-ascending"`, `"created-descending"`, `"created-ascending"`,
	   *                                   or `"collection-default"`. Using `"collection-default"` means that products will be ordered
	   *                                   the using the custom ordering defined in your Shopify Admin. Default value `"collection-default"`.
	   * @return {Promise|Array} The product models.
	   */
	  fetchQueryProducts: fetchFactory('query', 'products'),
	
	  /**
	   * Fetches a list of collections matching a specified query.
	   *
	   * ```javascript
	   * client.fetchQueryCollections({page: 2, limit: 20}).then(collections => {
	   *   console.log(collections); // An array of collection resources
	   * });
	   * ```
	   *
	   * @method fetchQueryCollections
	   * @public
	   * @param {Object} query a query sent to the api server.
	   *   @param {String|Number} [query.page=1] the page offset number of the current lookup (based on the `limit`)
	   *   @param {String|Number} [query.limit=50] the number of collections to retrieve per page
	   * @return {Promise|Array} The collection models.
	   */
	  fetchQueryCollections: fetchFactory('query', 'collections'),
	
	  /**
	   * This method looks up a reference in localStorage to the most recent cart.
	   * If one is not found, creates one. If the cart the reference points to
	   * doesn't exist, create one and store the new reference.
	   *
	   * ```javascript
	   * client.fetchRecentCart().then(cart => {
	   *  // do stuff with the cart
	   * });
	   * ```
	   *
	   * @method fetchRecentCart
	   * @public
	   * @return {Promise|CartModel} The cart.
	   */
	  fetchRecentCart: function fetchRecentCart() {
	    var _this14 = this;
	
	    return this.fetch('references', this.config.domain + '.recent-cart').then(function (reference) {
	      var cartId = reference.referenceId;
	
	      return _this14.fetchCart(cartId);
	    })['catch'](function () {
	      return _this14.createCart().then(function (cart) {
	        var refAttrs = {
	          referenceId: cart.id
	        };
	
	        refAttrs[GUID_KEY] = _this14.config.domain + '.recent-cart';
	
	        _this14.create('references', refAttrs);
	
	        return cart;
	      });
	    });
	  }
	}, {
	  serializers: {
	    /**
	     * @attribute
	     * @default {
	     *  products: ListingsAdapter,
	     *  collections: ListingsAdapter,
	     *  carts: CartAdapter
	     * }
	     * @type Object
	     * @protected
	     */
	    // Prevent leaky state
	    get: function get() {
	      return assign$1({}, this.shadowedSerializers);
	    },
	    set: function set(values) {
	      this.shadowedSerializers = assign$1({}, values);
	    },
	    configurable: true,
	    enumerable: true
	  },
	  adapters: {
	    get: function get() {
	      return assign$1({}, this.shadowedAdapters);
	    },
	    set: function set(values) {
	      this.shadowedAdapters = assign$1({}, values);
	    },
	    configurable: true,
	    enumerable: true
	  }
	}));
	
	/* globals require */
	
	if (isNodeLikeEnvironment()) {
	  /* this indirection is needed because babel throws errors when
	   * transpiling require('node-fetch') using `amd` plugin with babel6
	   */
	  var localRequire = require;
	  var _fetch = __webpack_require__(664);
	
	  globalVars.set('fetch', _fetch);
	  globalVars.set('Response', _fetch.Response);
	}
	
	/* global Buffer */
	
	if (isNodeLikeEnvironment()) {
	  globalVars.set('btoa', function (string) {
	    return new Buffer(string).toString('base64');
	  });
	}
	
	/**
	 * @module shopify-buy
	 * @submodule shopify
	 */
	
	/**
	 * `ShopifyBuy` only defines one function {{#crossLink "ShopifyBuy/buildClient"}}{{/crossLink}} which can
	 * be used to build a {{#crossLink "ShopClient"}}{{/crossLink}} to query your store using the
	 * provided
	 * {{#crossLink "ShopifyBuy/buildClient/configAttrs:accessToken"}}`accessToken`{{/crossLink}},
	 * {{#crossLink "ShopifyBuy/buildClient/configAttrs:appId"}}`appId`{{/crossLink}},
	 * and {{#crossLink "ShopifyBuy/buildClient/configAttrs:domain"}}`domain`{{/crossLink}}.
	 * @class ShopifyBuy
	 * @static
	 */
	var Shopify = {
	  ShopClient: ShopClient,
	  Config: Config,
	  version: version,
	  NO_IMAGE_URI: NO_IMAGE_URI,
	
	  /**
	   * Create a ShopClient. This is the main entry point to the SDK.
	   *
	   * ```javascript
	   * const client = ShopifyBuy.buildClient({
	   *   accessToken: 'bf081e860bc9dc1ce0654fdfbc20892d',
	   *   appId: 6,
	   *   myShopifyDomain: 'your-shop-subdomain.myshopify.com', //Deprecated. Use `domain` instead
	   *   domain: 'embeds.myshopify.com'
	   * });
	   * ```
	   *
	   * @method buildClient
	   * @for ShopifyBuy
	   * @static
	   * @public
	   * @param {Object} configAttrs An object of required config data such as: `accessToken`, `appId`, `domain`
	   * @param {String} configAttrs.accessToken An access token for your store. Documentation how to get a token:
	   *   https://help.shopify.com/api/sdks/custom-storefront/js-buy-sdk/getting-started#generate-javascript-buy-sdk-credentials
	   * @param {String} configAttrs.appId Typically will be 6 which is the Buy Button App Id. For more info on App Id see:
	   *   https://help.shopify.com/api/sdks/js-buy-sdk/getting-started#app-id
	   * @param {String} configAttrs.domain Your shop's full `myshopify.com` domain. For example: `embeds.myshopify.com`
	   * @param {String} configAttrs.myShopifyDomain You shop's `myshopify.com` domain. [deprecated Use configAttrs.domain]
	   * @return {ShopClient} a client for the shop using your api credentials which you can use to query your store.
	   */
	  buildClient: function buildClient() {
	    var configAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var config = new this.Config(configAttrs);
	
	    return new this.ShopClient(config);
	  }
	};
	
	module.exports = Shopify;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(276).Buffer))

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(26)
	var lowerCase = __webpack_require__(39)
	
	/**
	 * Swap the case of a string. Manually iterate over every character and check
	 * instead of replacing certain characters for better unicode support.
	 *
	 * @param  {String} str
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  var result = ''
	
	  for (var i = 0; i < str.length; i++) {
	    var c = str[i]
	    var u = upperCase(c, locale)
	
	    result += u === c ? lowerCase(c, locale) : u
	  }
	
	  return result
	}


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(659);


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(660);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(87)(module)))

/***/ },
/* 660 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(20)
	var upperCase = __webpack_require__(26)
	
	/**
	 * Title case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale).replace(/^.| ./g, function (m) {
	    return upperCase(m, locale)
	  })
	}


/***/ },
/* 662 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var valueEqual = function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	    return valueEqual(item, b[index]);
	  });
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	};
	
	exports.default = valueEqual;

/***/ },
/* 663 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 664 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.770c0fb0.js